(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire21c7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire21c7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iouPm", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $d642618b37f17542$export$2191b9da168c6cf0);
$parcel$export(module.exports, "invalidateTokenCache", () => $d642618b37f17542$export$a046837327246960);
$parcel$export(module.exports, "getHeadersWithToken", () => $d642618b37f17542$export$eaa8d33244153939);
$parcel$export(module.exports, "projectBoardsCreate", () => $d642618b37f17542$export$6f6f11b768b77c63);
$parcel$export(module.exports, "projectBoardsList", () => $d642618b37f17542$export$a727b8d6d1ae0f28);
$parcel$export(module.exports, "projectBoardsClone", () => $d642618b37f17542$export$25fce77ab4089d87);
$parcel$export(module.exports, "projectBoardsDelete", () => $d642618b37f17542$export$3c1dac990bf3d1b3);
$parcel$export(module.exports, "segmentTypesList", () => $d642618b37f17542$export$d97e7786e3e057dd);
$parcel$export(module.exports, "occupationTypesList", () => $d642618b37f17542$export$e8e159821d037f49);
$parcel$export(module.exports, "projectBoardsGet", () => $d642618b37f17542$export$9be692c47ebaf764);
$parcel$export(module.exports, "projectBoardsGetShared", () => $d642618b37f17542$export$7a1cd4b6b22559d6);
$parcel$export(module.exports, "projectBoardsGenerateSharedUrl", () => $d642618b37f17542$export$a2839ba17760ae08);
$parcel$export(module.exports, "projectBoardsGetUploadSettings", () => $d642618b37f17542$export$70ca0f4e51dde2fc);
$parcel$export(module.exports, "projectBoardsUpdate", () => $d642618b37f17542$export$b3c1229c726864bd);
$parcel$export(module.exports, "projectBoardItemsGet", () => $d642618b37f17542$export$1c0d9939834e1bf1);
$parcel$export(module.exports, "projectBoardItemsGetShared", () => $d642618b37f17542$export$28bd6c367b926b19);
$parcel$export(module.exports, "projectBoardItemDelete", () => $d642618b37f17542$export$a2aa9f511462d1f3);
$parcel$export(module.exports, "projectBoardItemGet", () => $d642618b37f17542$export$bed2db7cc24296ad);
$parcel$export(module.exports, "projectBoardItemUpdate", () => $d642618b37f17542$export$9e10a1d47c968321);
$parcel$export(module.exports, "projectBoardSetCoverImage", () => $d642618b37f17542$export$8b0f297674f9daa7);
$parcel$export(module.exports, "projectBoardItemsAdd", () => $d642618b37f17542$export$f12b76b009aef111);
$parcel$export(module.exports, "navigationGetHeader", () => $d642618b37f17542$export$5b0bbb8016a29396);
$parcel$export(module.exports, "newsletterSubscribe", () => $d642618b37f17542$export$ddf8948e85fb9c5);
$parcel$export(module.exports, "forgotPassword", () => $d642618b37f17542$export$66791fb2cfeec3e);
let $d642618b37f17542$var$tokenCache = {
    token: null,
    expiresAt: null
};
function $d642618b37f17542$export$2191b9da168c6cf0(errors) {
    this.errors = errors;
    return this;
}
function $d642618b37f17542$export$f2e832acab1bdd79(response) {
    this.response = response;
    return this;
}
async function $d642618b37f17542$var$handleResponse(response, returnAsJson = true) {
    if (response.ok) {
        const contentLength = response.headers.get('content-length');
        if (contentLength && contentLength === '0') return null;
        return returnAsJson ? await response.json() : await response.text();
    } else if (response.status === 400) {
        const result = await response.json();
        throw new $d642618b37f17542$export$2191b9da168c6cf0(result.errors);
    } else throw new $d642618b37f17542$export$f2e832acab1bdd79(response);
}
async function $d642618b37f17542$export$257b2d10b709d8ef() {
    if ($d642618b37f17542$var$tokenCache.token && $d642618b37f17542$var$tokenCache.expiresAt && Date.now() < $d642618b37f17542$var$tokenCache.expiresAt) return $d642618b37f17542$var$tokenCache.token;
    try {
        const response = await fetch('/api/Security/token');
        if (!response.ok) {
            console.error('error getting xsrf token', response.status, response.statusText);
            return 'ERROR_GETTING_XSRF_TOKEN_CHECK_LOGS';
        }
        const data = await response.json();
        const token = data.token;
        $d642618b37f17542$var$tokenCache.expiresAt = Date.now() + 3300000; // expire in 55 minutes, the token itself is valid for 60 
        $d642618b37f17542$var$tokenCache.token = token;
        return token;
    } catch (e) {
        console.error('error getting xsrf token:', e);
        return 'ERROR_GETTING_XSRF_TOKEN_CHECK_LOGS';
    }
}
function $d642618b37f17542$export$a046837327246960() {
    $d642618b37f17542$var$tokenCache.token = null;
    $d642618b37f17542$var$tokenCache.expiresAt = null;
}
async function $d642618b37f17542$export$eaa8d33244153939(headers = {}) {
    const token = await $d642618b37f17542$export$257b2d10b709d8ef();
    return {
        ...headers,
        'X-XSRF-TOKEN': token
    };
}
async function $d642618b37f17542$export$6f6f11b768b77c63({ name: name, segmentTypeIds: segmentTypeIds, notes: notes }) {
    const payload = {
        name: name,
        segmentTypeIds: segmentTypeIds,
        notes: notes
    };
    const response = await fetch('/api/ProjectBoards', {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        })
    });
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$a727b8d6d1ae0f28() {
    const url = new URL('/api/ProjectBoards', window.location.origin);
    url.searchParams.set('pageSize', 1000);
    const response = await fetch(url.toString());
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$25fce77ab4089d87(id) {
    const response = await fetch(`/api/ProjectBoards/${id}/clone`, {
        method: 'POST',
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        })
    });
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$3c1dac990bf3d1b3(id) {
    const response = await fetch(`/api/ProjectBoards/${id}`, {
        method: 'DELETE',
        headers: await $d642618b37f17542$export$eaa8d33244153939()
    });
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$d97e7786e3e057dd() {
    const response = await fetch('/api/Segments');
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$e8e159821d037f49() {
    const response = await fetch('/api/Occupations');
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$9be692c47ebaf764(id) {
    const response = await fetch(`/api/ProjectBoards/${id}`);
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$7a1cd4b6b22559d6(id, sharedInfo) {
    const response = await fetch(`/api/ProjectBoards/${id}/shared/${sharedInfo}`);
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$a2839ba17760ae08(id) {
    const response = await fetch(`/api/ProjectBoards/${id}/share`);
    return await $d642618b37f17542$var$handleResponse(response, false);
}
async function $d642618b37f17542$export$70ca0f4e51dde2fc() {
    const response = await fetch('/api/ProjectBoards/items/upload-settings');
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$b3c1229c726864bd({ id: id, name: name, segmentTypeIds: segmentTypeIds, notes: notes }) {
    const payload = {
        name: name,
        segmentTypeIds: segmentTypeIds,
        notes: notes
    };
    const response = await fetch(`/api/ProjectBoards/${id}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        })
    });
    return await $d642618b37f17542$var$handleResponse(response);
}
async function $d642618b37f17542$export$1c0d9939834e1bf1(boardId) {
    const res = await fetch(`/api/ProjectBoards/${boardId}/items`);
    if (!res.ok) throw new Error("Failed to fetch project board items");
    return await res.json();
}
async function $d642618b37f17542$export$28bd6c367b926b19(boardId, sharedInfo) {
    const res = await fetch(`/api/ProjectBoards/${boardId}/shared/${sharedInfo}/items`);
    if (!res.ok) throw new Error("Failed to fetch project board items");
    return await res.json();
}
async function $d642618b37f17542$export$a2aa9f511462d1f3(boardId, itemId) {
    const res = await fetch(`/api/ProjectBoards/${boardId}/items/${itemId}`, {
        method: "DELETE",
        headers: await $d642618b37f17542$export$eaa8d33244153939()
    });
    if (!res.ok) throw new Error("Failed to delete project board item");
    return true;
}
async function $d642618b37f17542$export$bed2db7cc24296ad(boardId, itemId, sharedInfo = null) {
    const basePath = sharedInfo ? `/api/ProjectBoards/${boardId}/shared/${sharedInfo}/items/${itemId}` : `/api/ProjectBoards/${boardId}/items/${itemId}`;
    const res = await fetch(basePath);
    if (!res.ok) throw new Error("Failed to fetch project board item");
    return await res.json();
}
async function $d642618b37f17542$export$9e10a1d47c968321(boardId, itemId, { notes: notes }) {
    const response = await fetch(`/api/ProjectBoards/${boardId}/items/${itemId}`, {
        method: 'PUT',
        body: JSON.stringify({
            notes: notes
        }),
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        })
    });
    return await $d642618b37f17542$var$handleResponse(response, false);
}
async function $d642618b37f17542$export$8b0f297674f9daa7(boardId, itemId) {
    const response = await fetch(`/api/ProjectBoards/${boardId}/coverImage/${itemId}`, {
        method: 'POST',
        headers: await $d642618b37f17542$export$eaa8d33244153939()
    });
    return await $d642618b37f17542$var$handleResponse(response, false);
}
async function $d642618b37f17542$export$f12b76b009aef111(boardIds, assetInfo) {
    const results = [];
    for (const boardId of boardIds)try {
        const res = await fetch(`/api/ProjectBoards/${boardId}/items`, {
            method: "POST",
            headers: await $d642618b37f17542$export$eaa8d33244153939({
                "Content-Type": "application/json"
            }),
            body: JSON.stringify({
                assetInfo: assetInfo
            })
        });
        if (!res.ok) {
            const text = await res.text();
            results.push({
                boardId: boardId,
                success: false,
                error: text
            });
        } else results.push({
            boardId: boardId,
            success: true
        });
    } catch (err) {
        results.push({
            boardId: boardId,
            success: false,
            error: err.message
        });
    }
    return results;
}
async function $d642618b37f17542$export$5b0bbb8016a29396(currentPage = null) {
    const res = await fetch('/api/Navigation/Header?currentPage=' + currentPage);
    return await $d642618b37f17542$var$handleResponse(res, false);
}
async function $d642618b37f17542$export$ddf8948e85fb9c5(email) {
    const res = await fetch('/api/Newsletter', {
        method: 'POST',
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify(email)
    });
    return await $d642618b37f17542$var$handleResponse(res);
}
async function $d642618b37f17542$export$66791fb2cfeec3e(email) {
    const res = await fetch('/api/Accounts/ForgotPassword', {
        method: 'POST',
        headers: await $d642618b37f17542$export$eaa8d33244153939({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            username: email
        })
    });
    return await $d642618b37f17542$var$handleResponse(res);
}

});

parcelRegister("fWVzk", function(module, exports) {

$parcel$export(module.exports, "BREAKPOINTS", () => $b9c8edc8343467fe$export$426e07cd0772984d);
/**
 * Breakpoint constants matching SCSS variables in _variables.scss
 * Keep these in sync with $breakpoint-* variables
 */ const $b9c8edc8343467fe$export$426e07cd0772984d = {
    SMALL: 375,
    MEDIUM: 768,
    LARGE: 1024,
    LARGER: 1200,
    XLARGE: 1440
};

});

parcelRegister("8cF6f", function(module, exports) {

$parcel$export(module.exports, "showToast", () => $5f8f5348f8c207a6$export$f6cef6fcf9ca4e17);
/**
 * Toast notification system for displaying temporary messages to users.
 * Requires toast containers in the DOM (typically in the header).
 */ // Track active messages to prevent duplicates
const $5f8f5348f8c207a6$var$activeMessages = new Set();
function $5f8f5348f8c207a6$export$f6cef6fcf9ca4e17(message, type) {
    const toastContainers = document.querySelectorAll('.toast-container');
    if (toastContainers.length === 0) {
        console.warn('Toast container not found, message not displayed:', message);
        return;
    }
    // Prevent duplicate messages
    const key = `${type}:${message}`;
    if ($5f8f5348f8c207a6$var$activeMessages.has(key)) return;
    $5f8f5348f8c207a6$var$activeMessages.add(key);
    const messageElements = [];
    // Add message to all toast containers (desktop + mobile)
    toastContainers.forEach((container)=>{
        const messageEl = document.createElement('div');
        messageEl.className = `toast-message toast-message--${type} toast-message--entering`;
        messageEl.textContent = message;
        container.appendChild(messageEl);
        messageElements.push(messageEl);
    });
    // Trigger slide-in animation by removing entering class
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            messageElements.forEach((el)=>el.classList.remove('toast-message--entering'));
        });
    });
    // Auto-dismiss after 8 seconds with fade-out
    setTimeout(()=>{
        messageElements.forEach((el)=>el.classList.add('toast-message--fade-out'));
        setTimeout(()=>{
            messageElements.forEach((el)=>el.remove());
            $5f8f5348f8c207a6$var$activeMessages.delete(key);
        }, 300);
    }, 8000);
}
if (typeof window !== 'undefined') {
    window.mannington = window.mannington || {};
    window.mannington.showToast = $5f8f5348f8c207a6$export$f6cef6fcf9ca4e17;
}

});

parcelRegister("9zaOw", function(module, exports) {

$parcel$export(module.exports, "FlyoutManager", () => $6f6fc55923f3e16b$export$66a6c60ee9680564);
$parcel$export(module.exports, "initFlyoutManager", () => $6f6fc55923f3e16b$export$2928aaa11b7167c1);
const $6f6fc55923f3e16b$export$66a6c60ee9680564 = (()=>{
    let openFlyout = null;
    let overlay = null;
    let focusOrigin = null;
    let managedBackgroundElements = [];
    const focusableSelector = [
        'button:not([disabled])',
        '[href]',
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        '[tabindex]:not([tabindex="-1"])'
    ].join(", ");
    const preferredFocusSelector = [
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])'
    ].join(", ");
    function open(id, trigger = null) {
        const flyout = document.querySelector(`[data-flyout="${id}"]`);
        if (!flyout) return;
        const nextFocusOrigin = resolveFocusOrigin(trigger);
        if (!(openFlyout && nextFocusOrigin && openFlyout.contains(nextFocusOrigin))) focusOrigin = nextFocusOrigin;
        closeAll(false);
        flyout.classList.replace("closed", "open");
        document.body.classList.add("flyout-open");
        overlay?.classList.add("active");
        openFlyout = flyout;
        applyDialogAttributes(flyout);
        setBackgroundInert(flyout);
        focusFlyout(flyout);
        document.addEventListener("keydown", handleKeydown, true);
    }
    function emitClosedEvent(target) {
        if (!target) return;
        const flyoutId = target.getAttribute("data-flyout");
        if (!flyoutId) return;
        document.dispatchEvent(new CustomEvent("flyout:closed", {
            detail: {
                id: flyoutId
            }
        }));
    }
    function subscribeToClosedEvent(callback) {
        document.addEventListener("flyout:closed", callback);
    }
    function unsubscribeToClosedEvent(callback) {
        document.removeEventListener("flyout:closed", callback);
    }
    function close(id = null) {
        const flyout = id ? document.querySelector(`[data-flyout="${id}"]`) : openFlyout;
        if (flyout) {
            flyout.classList.replace("open", "closed");
            emitClosedEvent(flyout);
        }
        if (!document.querySelector('[data-flyout].open')) cleanupFlyoutState(true);
    }
    function closeAll(shouldRestoreFocus = true) {
        document.querySelectorAll('[data-flyout].open').forEach((el)=>{
            el.classList.replace("open", "closed");
            emitClosedEvent(el);
        });
        cleanupFlyoutState(shouldRestoreFocus);
    }
    function handleKeydown(e) {
        if (!openFlyout) return;
        if (e.key === "Escape") {
            close();
            return;
        }
        if (e.key !== "Tab") return;
        const focusableElements = getFocusableElements(openFlyout);
        if (focusableElements.length === 0) {
            e.preventDefault();
            openFlyout.focus();
            return;
        }
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        const activeElement = document.activeElement;
        if (!openFlyout.contains(activeElement)) {
            e.preventDefault();
            (e.shiftKey ? lastElement : firstElement).focus();
            return;
        }
        if (!e.shiftKey && activeElement === lastElement) {
            e.preventDefault();
            firstElement.focus();
        }
        if (e.shiftKey && activeElement === firstElement) {
            e.preventDefault();
            lastElement.focus();
        }
    }
    function initTriggers() {
        overlay = document.getElementById("flyout-overlay");
        document.querySelectorAll('[data-flyout-trigger]').forEach((trigger)=>{
            trigger.addEventListener("click", (e)=>{
                e.preventDefault();
                open(trigger.getAttribute("data-flyout-trigger"), trigger);
            });
        });
        document.querySelectorAll('[data-flyout-close]').forEach((btn)=>{
            btn.addEventListener("click", ()=>close());
        });
        overlay?.addEventListener("click", ()=>close());
    }
    function getFlyoutContentContainer(flyoutId) {
        return document.querySelector(`#flyout-${flyoutId} .flyout-container__content`);
    }
    function resolveFocusOrigin(trigger) {
        if (trigger instanceof HTMLElement) return trigger;
        if (document.activeElement instanceof HTMLElement && document.activeElement !== document.body) return document.activeElement;
        return null;
    }
    function applyDialogAttributes(flyout) {
        if (!flyout.hasAttribute("role")) flyout.setAttribute("role", "dialog");
        if (!flyout.hasAttribute("aria-modal")) flyout.setAttribute("aria-modal", "true");
        if (!flyout.hasAttribute("tabindex")) flyout.setAttribute("tabindex", "-1");
        if (!flyout.hasAttribute("aria-labelledby") && !flyout.hasAttribute("aria-label")) {
            const heading = flyout.querySelector("h1, h2, h3, h4, h5, h6");
            if (!heading) return;
            if (!heading.id) {
                const flyoutName = flyout.getAttribute("data-flyout") || flyout.id || "flyout";
                heading.id = `${flyoutName}-title`;
            }
            flyout.setAttribute("aria-labelledby", heading.id);
        }
    }
    function focusFlyout(flyout) {
        const preferredElement = flyout.querySelector(preferredFocusSelector);
        if (preferredElement instanceof HTMLElement) {
            preferredElement.focus();
            return;
        }
        const focusableElements = getFocusableElements(flyout);
        if (focusableElements.length > 0) {
            focusableElements[0].focus();
            return;
        }
        flyout.focus();
    }
    function getFocusableElements(flyout) {
        return Array.from(flyout.querySelectorAll(focusableSelector)).filter(isFocusable);
    }
    function isFocusable(element) {
        if (!(element instanceof HTMLElement)) return false;
        if (element.hasAttribute("disabled")) return false;
        if (element.getAttribute("aria-hidden") === "true") return false;
        if (element.closest("[hidden]")) return false;
        return true;
    }
    function setBackgroundInert(activeFlyout) {
        clearBackgroundInert();
        managedBackgroundElements = Array.from(document.body.children).filter((element)=>element !== activeFlyout && element !== overlay).map((element)=>{
            const previousAriaHidden = element.getAttribute("aria-hidden");
            const hadInert = element.hasAttribute("inert");
            element.setAttribute("inert", "");
            element.setAttribute("aria-hidden", "true");
            return {
                element: element,
                hadInert: hadInert,
                previousAriaHidden: previousAriaHidden
            };
        });
    }
    function clearBackgroundInert() {
        managedBackgroundElements.forEach(({ element: element, hadInert: hadInert, previousAriaHidden: previousAriaHidden })=>{
            if (!hadInert) element.removeAttribute("inert");
            if (previousAriaHidden === null) element.removeAttribute("aria-hidden");
            else element.setAttribute("aria-hidden", previousAriaHidden);
        });
        managedBackgroundElements = [];
    }
    function cleanupFlyoutState(shouldRestoreFocus) {
        document.body.classList.remove("flyout-open");
        overlay?.classList.remove("active");
        document.removeEventListener("keydown", handleKeydown, true);
        clearBackgroundInert();
        const elementToRestore = shouldRestoreFocus ? focusOrigin : null;
        openFlyout = null;
        if (shouldRestoreFocus) focusOrigin = null;
        if (elementToRestore instanceof HTMLElement && elementToRestore.isConnected && !elementToRestore.hasAttribute("disabled") && !elementToRestore.closest("[inert]")) elementToRestore.focus();
    }
    return {
        initTriggers: initTriggers,
        open: open,
        close: close,
        closeAll: closeAll,
        getFlyoutContentContainer: getFlyoutContentContainer,
        subscribeToClosedEvent: subscribeToClosedEvent,
        unsubscribeToClosedEvent: unsubscribeToClosedEvent
    };
})();
function $6f6fc55923f3e16b$export$2928aaa11b7167c1() {
    document.addEventListener("DOMContentLoaded", ()=>{
        $6f6fc55923f3e16b$export$66a6c60ee9680564.initTriggers();
    });
}

});

parcelRegister("41yrs", function(module, exports) {

module.exports = (parcelRequire("24zrG"))($parcel$resolve("kr1xC")).then(()=>parcelRequire('fO75v'));

});
parcelRegister("24zrG", function(module, exports) {
"use strict";

var $kpxvq = parcelRequire("kpxvq");
module.exports = $kpxvq(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("kpxvq", function(module, exports) {
"use strict";
var $edc022003ab01d6d$var$cachedBundles = {};
var $edc022003ab01d6d$var$cachedPreloads = {};
var $edc022003ab01d6d$var$cachedPrefetches = {};
function $edc022003ab01d6d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $edc022003ab01d6d$var$cachedPreloads;
        case 'prefetch':
            return $edc022003ab01d6d$var$cachedPrefetches;
        default:
            return $edc022003ab01d6d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $edc022003ab01d6d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("1nFdx", function(module, exports) {

module.exports = (parcelRequire("24zrG"))($parcel$resolve("9rZS7")).then(()=>parcelRequire('iY8KQ'));

});

parcelRegister("dF3Ou", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", () => $9f220ff36a1e4eac$export$4d99f7c30e854ff, (v) => $9f220ff36a1e4eac$export$4d99f7c30e854ff = v);
$parcel$export(module.exports, "SourceMapConsumer", () => $9f220ff36a1e4eac$export$194e92554d04abdd, (v) => $9f220ff36a1e4eac$export$194e92554d04abdd = v);
$parcel$export(module.exports, "SourceNode", () => $9f220ff36a1e4eac$export$7e987e8f375d24c2, (v) => $9f220ff36a1e4eac$export$7e987e8f375d24c2 = v);
/*
 * Copyright 2009-2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE.txt or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $9f220ff36a1e4eac$export$4d99f7c30e854ff;
var $9f220ff36a1e4eac$export$194e92554d04abdd;
var $9f220ff36a1e4eac$export$7e987e8f375d24c2;

$9f220ff36a1e4eac$export$4d99f7c30e854ff = (parcelRequire("4p4SG")).SourceMapGenerator;

$9f220ff36a1e4eac$export$194e92554d04abdd = (parcelRequire("cUj0p")).SourceMapConsumer;

$9f220ff36a1e4eac$export$7e987e8f375d24c2 = (parcelRequire("2EjYD")).SourceNode;

});
parcelRegister("4p4SG", function(module, exports) {

$parcel$export(module.exports, "SourceMapGenerator", () => $334d48776617e29b$export$4d99f7c30e854ff, (v) => $334d48776617e29b$export$4d99f7c30e854ff = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $334d48776617e29b$export$4d99f7c30e854ff;

var $832FF = parcelRequire("832FF");

var $jPinH = parcelRequire("jPinH");

var $8czLv = parcelRequire("8czLv");
var $334d48776617e29b$require$ArraySet = $8czLv.ArraySet;

var $1I6ue = parcelRequire("1I6ue");
var $334d48776617e29b$require$MappingList = $1I6ue.MappingList;
/**
 * An instance of the SourceMapGenerator represents a source map which is
 * being built incrementally. You may pass an object with the following
 * properties:
 *
 *   - file: The filename of the generated source.
 *   - sourceRoot: A root for all relative URLs in this source map.
 */ function $334d48776617e29b$var$SourceMapGenerator(aArgs) {
    if (!aArgs) aArgs = {};
    this._file = $jPinH.getArg(aArgs, 'file', null);
    this._sourceRoot = $jPinH.getArg(aArgs, 'sourceRoot', null);
    this._skipValidation = $jPinH.getArg(aArgs, 'skipValidation', false);
    this._sources = new $334d48776617e29b$require$ArraySet();
    this._names = new $334d48776617e29b$require$ArraySet();
    this._mappings = new $334d48776617e29b$require$MappingList();
    this._sourcesContents = null;
}
$334d48776617e29b$var$SourceMapGenerator.prototype._version = 3;
/**
 * Creates a new SourceMapGenerator based on a SourceMapConsumer
 *
 * @param aSourceMapConsumer The SourceMap.
 */ $334d48776617e29b$var$SourceMapGenerator.fromSourceMap = function SourceMapGenerator_fromSourceMap(aSourceMapConsumer) {
    var sourceRoot = aSourceMapConsumer.sourceRoot;
    var generator = new $334d48776617e29b$var$SourceMapGenerator({
        file: aSourceMapConsumer.file,
        sourceRoot: sourceRoot
    });
    aSourceMapConsumer.eachMapping(function(mapping) {
        var newMapping = {
            generated: {
                line: mapping.generatedLine,
                column: mapping.generatedColumn
            }
        };
        if (mapping.source != null) {
            newMapping.source = mapping.source;
            if (sourceRoot != null) newMapping.source = $jPinH.relative(sourceRoot, newMapping.source);
            newMapping.original = {
                line: mapping.originalLine,
                column: mapping.originalColumn
            };
            if (mapping.name != null) newMapping.name = mapping.name;
        }
        generator.addMapping(newMapping);
    });
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var sourceRelative = sourceFile;
        if (sourceRoot !== null) sourceRelative = $jPinH.relative(sourceRoot, sourceFile);
        if (!generator._sources.has(sourceRelative)) generator._sources.add(sourceRelative);
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) generator.setSourceContent(sourceFile, content);
    });
    return generator;
};
/**
 * Add a single mapping from original source line and column to the generated
 * source's line and column for this source map being created. The mapping
 * object should have the following properties:
 *
 *   - generated: An object with the generated line and column positions.
 *   - original: An object with the original line and column positions.
 *   - source: The original source file (relative to the sourceRoot).
 *   - name: An optional original token name for this mapping.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype.addMapping = function SourceMapGenerator_addMapping(aArgs) {
    var generated = $jPinH.getArg(aArgs, 'generated');
    var original = $jPinH.getArg(aArgs, 'original', null);
    var source = $jPinH.getArg(aArgs, 'source', null);
    var name = $jPinH.getArg(aArgs, 'name', null);
    if (!this._skipValidation) this._validateMapping(generated, original, source, name);
    if (source != null) {
        source = String(source);
        if (!this._sources.has(source)) this._sources.add(source);
    }
    if (name != null) {
        name = String(name);
        if (!this._names.has(name)) this._names.add(name);
    }
    this._mappings.add({
        generatedLine: generated.line,
        generatedColumn: generated.column,
        originalLine: original != null && original.line,
        originalColumn: original != null && original.column,
        source: source,
        name: name
    });
};
/**
 * Set the source content for a source file.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype.setSourceContent = function SourceMapGenerator_setSourceContent(aSourceFile, aSourceContent) {
    var source = aSourceFile;
    if (this._sourceRoot != null) source = $jPinH.relative(this._sourceRoot, source);
    if (aSourceContent != null) {
        // Add the source content to the _sourcesContents map.
        // Create a new _sourcesContents map if the property is null.
        if (!this._sourcesContents) this._sourcesContents = Object.create(null);
        this._sourcesContents[$jPinH.toSetString(source)] = aSourceContent;
    } else if (this._sourcesContents) {
        // Remove the source file from the _sourcesContents map.
        // If the _sourcesContents map is empty, set the property to null.
        delete this._sourcesContents[$jPinH.toSetString(source)];
        if (Object.keys(this._sourcesContents).length === 0) this._sourcesContents = null;
    }
};
/**
 * Applies the mappings of a sub-source-map for a specific source file to the
 * source map being generated. Each mapping to the supplied source file is
 * rewritten using the supplied source map. Note: The resolution for the
 * resulting mappings is the minimium of this map and the supplied map.
 *
 * @param aSourceMapConsumer The source map to be applied.
 * @param aSourceFile Optional. The filename of the source file.
 *        If omitted, SourceMapConsumer's file property will be used.
 * @param aSourceMapPath Optional. The dirname of the path to the source map
 *        to be applied. If relative, it is relative to the SourceMapConsumer.
 *        This parameter is needed when the two source maps aren't in the same
 *        directory, and the source map to be applied contains relative source
 *        paths. If so, those relative source paths need to be rewritten
 *        relative to the SourceMapGenerator.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype.applySourceMap = function SourceMapGenerator_applySourceMap(aSourceMapConsumer, aSourceFile, aSourceMapPath) {
    var sourceFile = aSourceFile;
    // If aSourceFile is omitted, we will use the file property of the SourceMap
    if (aSourceFile == null) {
        if (aSourceMapConsumer.file == null) throw new Error('SourceMapGenerator.prototype.applySourceMap requires either an explicit source file, or the source map\'s "file" property. Both were omitted.');
        sourceFile = aSourceMapConsumer.file;
    }
    var sourceRoot = this._sourceRoot;
    // Make "sourceFile" relative if an absolute Url is passed.
    if (sourceRoot != null) sourceFile = $jPinH.relative(sourceRoot, sourceFile);
    // Applying the SourceMap can add and remove items from the sources and
    // the names array.
    var newSources = new $334d48776617e29b$require$ArraySet();
    var newNames = new $334d48776617e29b$require$ArraySet();
    // Find mappings for the "sourceFile"
    this._mappings.unsortedForEach(function(mapping) {
        if (mapping.source === sourceFile && mapping.originalLine != null) {
            // Check if it can be mapped by the source map, then update the mapping.
            var original = aSourceMapConsumer.originalPositionFor({
                line: mapping.originalLine,
                column: mapping.originalColumn
            });
            if (original.source != null) {
                // Copy mapping
                mapping.source = original.source;
                if (aSourceMapPath != null) mapping.source = $jPinH.join(aSourceMapPath, mapping.source);
                if (sourceRoot != null) mapping.source = $jPinH.relative(sourceRoot, mapping.source);
                mapping.originalLine = original.line;
                mapping.originalColumn = original.column;
                if (original.name != null) mapping.name = original.name;
            }
        }
        var source = mapping.source;
        if (source != null && !newSources.has(source)) newSources.add(source);
        var name = mapping.name;
        if (name != null && !newNames.has(name)) newNames.add(name);
    }, this);
    this._sources = newSources;
    this._names = newNames;
    // Copy sourcesContents of applied map.
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aSourceMapPath != null) sourceFile = $jPinH.join(aSourceMapPath, sourceFile);
            if (sourceRoot != null) sourceFile = $jPinH.relative(sourceRoot, sourceFile);
            this.setSourceContent(sourceFile, content);
        }
    }, this);
};
/**
 * A mapping can have one of the three levels of data:
 *
 *   1. Just the generated position.
 *   2. The Generated position, original position, and original source.
 *   3. Generated and original position, original source, as well as a name
 *      token.
 *
 * To maintain consistency, we validate that any new mapping being added falls
 * in to one of these categories.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype._validateMapping = function SourceMapGenerator_validateMapping(aGenerated, aOriginal, aSource, aName) {
    // When aOriginal is truthy but has empty values for .line and .column,
    // it is most likely a programmer error. In this case we throw a very
    // specific error message to try to guide them the right way.
    // For example: https://github.com/Polymer/polymer-bundler/pull/519
    if (aOriginal && typeof aOriginal.line !== 'number' && typeof aOriginal.column !== 'number') throw new Error("original.line and original.column are not numbers -- you probably meant to omit the original mapping entirely and only map the generated position. If so, pass null for the original mapping instead of an object with empty or null values.");
    if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aGenerated.line > 0 && aGenerated.column >= 0 && !aOriginal && !aSource && !aName) // Case 1.
    return;
    else if (aGenerated && 'line' in aGenerated && 'column' in aGenerated && aOriginal && 'line' in aOriginal && 'column' in aOriginal && aGenerated.line > 0 && aGenerated.column >= 0 && aOriginal.line > 0 && aOriginal.column >= 0 && aSource) // Cases 2 and 3.
    return;
    else throw new Error('Invalid mapping: ' + JSON.stringify({
        generated: aGenerated,
        source: aSource,
        original: aOriginal,
        name: aName
    }));
};
/**
 * Serialize the accumulated mappings in to the stream of base 64 VLQs
 * specified by the source map format.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype._serializeMappings = function SourceMapGenerator_serializeMappings() {
    var previousGeneratedColumn = 0;
    var previousGeneratedLine = 1;
    var previousOriginalColumn = 0;
    var previousOriginalLine = 0;
    var previousName = 0;
    var previousSource = 0;
    var result = '';
    var next;
    var mapping;
    var nameIdx;
    var sourceIdx;
    var mappings = this._mappings.toArray();
    for(var i = 0, len = mappings.length; i < len; i++){
        mapping = mappings[i];
        next = '';
        if (mapping.generatedLine !== previousGeneratedLine) {
            previousGeneratedColumn = 0;
            while(mapping.generatedLine !== previousGeneratedLine){
                next += ';';
                previousGeneratedLine++;
            }
        } else if (i > 0) {
            if (!$jPinH.compareByGeneratedPositionsInflated(mapping, mappings[i - 1])) continue;
            next += ',';
        }
        next += $832FF.encode(mapping.generatedColumn - previousGeneratedColumn);
        previousGeneratedColumn = mapping.generatedColumn;
        if (mapping.source != null) {
            sourceIdx = this._sources.indexOf(mapping.source);
            next += $832FF.encode(sourceIdx - previousSource);
            previousSource = sourceIdx;
            // lines are stored 0-based in SourceMap spec version 3
            next += $832FF.encode(mapping.originalLine - 1 - previousOriginalLine);
            previousOriginalLine = mapping.originalLine - 1;
            next += $832FF.encode(mapping.originalColumn - previousOriginalColumn);
            previousOriginalColumn = mapping.originalColumn;
            if (mapping.name != null) {
                nameIdx = this._names.indexOf(mapping.name);
                next += $832FF.encode(nameIdx - previousName);
                previousName = nameIdx;
            }
        }
        result += next;
    }
    return result;
};
$334d48776617e29b$var$SourceMapGenerator.prototype._generateSourcesContent = function SourceMapGenerator_generateSourcesContent(aSources, aSourceRoot) {
    return aSources.map(function(source) {
        if (!this._sourcesContents) return null;
        if (aSourceRoot != null) source = $jPinH.relative(aSourceRoot, source);
        var key = $jPinH.toSetString(source);
        return Object.prototype.hasOwnProperty.call(this._sourcesContents, key) ? this._sourcesContents[key] : null;
    }, this);
};
/**
 * Externalize the source map.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype.toJSON = function SourceMapGenerator_toJSON() {
    var map = {
        version: this._version,
        sources: this._sources.toArray(),
        names: this._names.toArray(),
        mappings: this._serializeMappings()
    };
    if (this._file != null) map.file = this._file;
    if (this._sourceRoot != null) map.sourceRoot = this._sourceRoot;
    if (this._sourcesContents) map.sourcesContent = this._generateSourcesContent(map.sources, map.sourceRoot);
    return map;
};
/**
 * Render the source map being generated to a string.
 */ $334d48776617e29b$var$SourceMapGenerator.prototype.toString = function SourceMapGenerator_toString() {
    return JSON.stringify(this.toJSON());
};
$334d48776617e29b$export$4d99f7c30e854ff = $334d48776617e29b$var$SourceMapGenerator;

});
parcelRegister("832FF", function(module, exports) {

$parcel$export(module.exports, "encode", () => $5dc0acf94fda5ae0$export$c564cdbbe6da493, (v) => $5dc0acf94fda5ae0$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $5dc0acf94fda5ae0$export$2f872c0f2117be69, (v) => $5dc0acf94fda5ae0$export$2f872c0f2117be69 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 *
 * Based on the Base 64 VLQ implementation in Closure Compiler:
 * https://code.google.com/p/closure-compiler/source/browse/trunk/src/com/google/debugging/sourcemap/Base64VLQ.java
 *
 * Copyright 2011 The Closure Compiler Authors. All rights reserved.
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *  * Redistributions of source code must retain the above copyright
 *    notice, this list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above
 *    copyright notice, this list of conditions and the following
 *    disclaimer in the documentation and/or other materials provided
 *    with the distribution.
 *  * Neither the name of Google Inc. nor the names of its
 *    contributors may be used to endorse or promote products derived
 *    from this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ /**
 * Returns the base 64 VLQ encoded value.
 */ var $5dc0acf94fda5ae0$export$c564cdbbe6da493;
/**
 * Decodes the next base 64 VLQ value from the given string and returns the
 * value and the rest of the string via the out parameter.
 */ var $5dc0acf94fda5ae0$export$2f872c0f2117be69;

var $3taSp = parcelRequire("3taSp");
// A single base 64 digit can contain 6 bits of data. For the base 64 variable
// length quantities we use in the source map spec, the first bit is the sign,
// the next four bits are the actual value, and the 6th bit is the
// continuation bit. The continuation bit tells us whether there are more
// digits in this value following this digit.
//
//   Continuation
//   |    Sign
//   |    |
//   V    V
//   101011
var $5dc0acf94fda5ae0$var$VLQ_BASE_SHIFT = 5;
// binary: 100000
var $5dc0acf94fda5ae0$var$VLQ_BASE = 1 << $5dc0acf94fda5ae0$var$VLQ_BASE_SHIFT;
// binary: 011111
var $5dc0acf94fda5ae0$var$VLQ_BASE_MASK = $5dc0acf94fda5ae0$var$VLQ_BASE - 1;
// binary: 100000
var $5dc0acf94fda5ae0$var$VLQ_CONTINUATION_BIT = $5dc0acf94fda5ae0$var$VLQ_BASE;
/**
 * Converts from a two-complement value to a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   1 becomes 2 (10 binary), -1 becomes 3 (11 binary)
 *   2 becomes 4 (100 binary), -2 becomes 5 (101 binary)
 */ function $5dc0acf94fda5ae0$var$toVLQSigned(aValue) {
    return aValue < 0 ? (-aValue << 1) + 1 : (aValue << 1) + 0;
}
/**
 * Converts to a two-complement value from a value where the sign bit is
 * placed in the least significant bit.  For example, as decimals:
 *   2 (10 binary) becomes 1, 3 (11 binary) becomes -1
 *   4 (100 binary) becomes 2, 5 (101 binary) becomes -2
 */ function $5dc0acf94fda5ae0$var$fromVLQSigned(aValue) {
    var isNegative = (aValue & 1) === 1;
    var shifted = aValue >> 1;
    return isNegative ? -shifted : shifted;
}
$5dc0acf94fda5ae0$export$c564cdbbe6da493 = function base64VLQ_encode(aValue) {
    var encoded = "";
    var digit;
    var vlq = $5dc0acf94fda5ae0$var$toVLQSigned(aValue);
    do {
        digit = vlq & $5dc0acf94fda5ae0$var$VLQ_BASE_MASK;
        vlq >>>= $5dc0acf94fda5ae0$var$VLQ_BASE_SHIFT;
        if (vlq > 0) // There are still more digits in this value, so we must make sure the
        // continuation bit is marked.
        digit |= $5dc0acf94fda5ae0$var$VLQ_CONTINUATION_BIT;
        encoded += $3taSp.encode(digit);
    }while (vlq > 0);
    return encoded;
};
$5dc0acf94fda5ae0$export$2f872c0f2117be69 = function base64VLQ_decode(aStr, aIndex, aOutParam) {
    var strLen = aStr.length;
    var result = 0;
    var shift = 0;
    var continuation, digit;
    do {
        if (aIndex >= strLen) throw new Error("Expected more digits in base 64 VLQ value.");
        digit = $3taSp.decode(aStr.charCodeAt(aIndex++));
        if (digit === -1) throw new Error("Invalid base64 digit: " + aStr.charAt(aIndex - 1));
        continuation = !!(digit & $5dc0acf94fda5ae0$var$VLQ_CONTINUATION_BIT);
        digit &= $5dc0acf94fda5ae0$var$VLQ_BASE_MASK;
        result = result + (digit << shift);
        shift += $5dc0acf94fda5ae0$var$VLQ_BASE_SHIFT;
    }while (continuation);
    aOutParam.value = $5dc0acf94fda5ae0$var$fromVLQSigned(result);
    aOutParam.rest = aIndex;
};

});
parcelRegister("3taSp", function(module, exports) {

$parcel$export(module.exports, "encode", () => $286c8469b834d11e$export$c564cdbbe6da493, (v) => $286c8469b834d11e$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $286c8469b834d11e$export$2f872c0f2117be69, (v) => $286c8469b834d11e$export$2f872c0f2117be69 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * Encode an integer in the range of 0 to 63 to a single base 64 digit.
 */ var $286c8469b834d11e$export$c564cdbbe6da493;
/**
 * Decode a single base 64 character code digit to an integer. Returns -1 on
 * failure.
 */ var $286c8469b834d11e$export$2f872c0f2117be69;
var $286c8469b834d11e$var$intToCharMap = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
$286c8469b834d11e$export$c564cdbbe6da493 = function(number) {
    if (0 <= number && number < $286c8469b834d11e$var$intToCharMap.length) return $286c8469b834d11e$var$intToCharMap[number];
    throw new TypeError("Must be between 0 and 63: " + number);
};
$286c8469b834d11e$export$2f872c0f2117be69 = function(charCode) {
    var bigA = 65; // 'A'
    var bigZ = 90; // 'Z'
    var littleA = 97; // 'a'
    var littleZ = 122; // 'z'
    var zero = 48; // '0'
    var nine = 57; // '9'
    var plus = 43; // '+'
    var slash = 47; // '/'
    var littleOffset = 26;
    var numberOffset = 52;
    // 0 - 25: ABCDEFGHIJKLMNOPQRSTUVWXYZ
    if (bigA <= charCode && charCode <= bigZ) return charCode - bigA;
    // 26 - 51: abcdefghijklmnopqrstuvwxyz
    if (littleA <= charCode && charCode <= littleZ) return charCode - littleA + littleOffset;
    // 52 - 61: 0123456789
    if (zero <= charCode && charCode <= nine) return charCode - zero + numberOffset;
    // 62: +
    if (charCode == plus) return 62;
    // 63: /
    if (charCode == slash) return 63;
    // Invalid base64 digit.
    return -1;
};

});


parcelRegister("jPinH", function(module, exports) {

$parcel$export(module.exports, "getArg", () => $e6f109dccd89c275$export$6e45e70adce70bb2, (v) => $e6f109dccd89c275$export$6e45e70adce70bb2 = v);
$parcel$export(module.exports, "urlParse", () => $e6f109dccd89c275$export$d6e833647f7f5f17, (v) => $e6f109dccd89c275$export$d6e833647f7f5f17 = v);
$parcel$export(module.exports, "isAbsolute", () => $e6f109dccd89c275$export$e434c7255acda994, (v) => $e6f109dccd89c275$export$e434c7255acda994 = v);
$parcel$export(module.exports, "normalize", () => $e6f109dccd89c275$export$a3295358bff77e, (v) => $e6f109dccd89c275$export$a3295358bff77e = v);
$parcel$export(module.exports, "join", () => $e6f109dccd89c275$export$f7e2c8231c57a8bd, (v) => $e6f109dccd89c275$export$f7e2c8231c57a8bd = v);
$parcel$export(module.exports, "relative", () => $e6f109dccd89c275$export$f0e7d1106eeabbe6, (v) => $e6f109dccd89c275$export$f0e7d1106eeabbe6 = v);
$parcel$export(module.exports, "toSetString", () => $e6f109dccd89c275$export$be0fa1163fa7a4c, (v) => $e6f109dccd89c275$export$be0fa1163fa7a4c = v);
$parcel$export(module.exports, "fromSetString", () => $e6f109dccd89c275$export$1fc47c3d4c3302a1, (v) => $e6f109dccd89c275$export$1fc47c3d4c3302a1 = v);
$parcel$export(module.exports, "compareByOriginalPositions", () => $e6f109dccd89c275$export$273077902de92ff2, (v) => $e6f109dccd89c275$export$273077902de92ff2 = v);
$parcel$export(module.exports, "compareByGeneratedPositionsDeflated", () => $e6f109dccd89c275$export$b7acf533941302f6, (v) => $e6f109dccd89c275$export$b7acf533941302f6 = v);
$parcel$export(module.exports, "compareByGeneratedPositionsInflated", () => $e6f109dccd89c275$export$f9c43907549d61f1, (v) => $e6f109dccd89c275$export$f9c43907549d61f1 = v);
$parcel$export(module.exports, "parseSourceMapInput", () => $e6f109dccd89c275$export$b49e2de2ad542732, (v) => $e6f109dccd89c275$export$b49e2de2ad542732 = v);
$parcel$export(module.exports, "computeSourceURL", () => $e6f109dccd89c275$export$659a1aa8f1cdc036, (v) => $e6f109dccd89c275$export$659a1aa8f1cdc036 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ /**
 * This is a helper function for getting values from parameter/options
 * objects.
 *
 * @param args The object we are extracting values from
 * @param name The name of the property we are getting.
 * @param defaultValue An optional value to return if the property is missing
 * from the object. If this is not specified and the property is missing, an
 * error will be thrown.
 */ var $e6f109dccd89c275$export$6e45e70adce70bb2;
var $e6f109dccd89c275$export$d6e833647f7f5f17;
var $e6f109dccd89c275$export$2ec9abc2d2cac192;
var $e6f109dccd89c275$export$a3295358bff77e;
var $e6f109dccd89c275$export$f7e2c8231c57a8bd;
var $e6f109dccd89c275$export$e434c7255acda994;
var $e6f109dccd89c275$export$f0e7d1106eeabbe6;
var $e6f109dccd89c275$export$be0fa1163fa7a4c;
var $e6f109dccd89c275$export$1fc47c3d4c3302a1;
var $e6f109dccd89c275$export$273077902de92ff2;
var $e6f109dccd89c275$export$b7acf533941302f6;
var $e6f109dccd89c275$export$f9c43907549d61f1;
var $e6f109dccd89c275$export$b49e2de2ad542732;
var $e6f109dccd89c275$export$659a1aa8f1cdc036;
function $e6f109dccd89c275$var$getArg(aArgs, aName, aDefaultValue) {
    if (aName in aArgs) return aArgs[aName];
    else if (arguments.length === 3) return aDefaultValue;
    else throw new Error('"' + aName + '" is a required argument.');
}
$e6f109dccd89c275$export$6e45e70adce70bb2 = $e6f109dccd89c275$var$getArg;
var $e6f109dccd89c275$var$urlRegexp = /^(?:([\w+\-.]+):)?\/\/(?:(\w+:\w+)@)?([\w.-]*)(?::(\d+))?(.*)$/;
var $e6f109dccd89c275$var$dataUrlRegexp = /^data:.+\,.+$/;
function $e6f109dccd89c275$var$urlParse(aUrl) {
    var match = aUrl.match($e6f109dccd89c275$var$urlRegexp);
    if (!match) return null;
    return {
        scheme: match[1],
        auth: match[2],
        host: match[3],
        port: match[4],
        path: match[5]
    };
}
$e6f109dccd89c275$export$d6e833647f7f5f17 = $e6f109dccd89c275$var$urlParse;
function $e6f109dccd89c275$var$urlGenerate(aParsedUrl) {
    var url = '';
    if (aParsedUrl.scheme) url += aParsedUrl.scheme + ':';
    url += '//';
    if (aParsedUrl.auth) url += aParsedUrl.auth + '@';
    if (aParsedUrl.host) url += aParsedUrl.host;
    if (aParsedUrl.port) url += ":" + aParsedUrl.port;
    if (aParsedUrl.path) url += aParsedUrl.path;
    return url;
}
$e6f109dccd89c275$export$2ec9abc2d2cac192 = $e6f109dccd89c275$var$urlGenerate;
/**
 * Normalizes a path, or the path portion of a URL:
 *
 * - Replaces consecutive slashes with one slash.
 * - Removes unnecessary '.' parts.
 * - Removes unnecessary '<dir>/..' parts.
 *
 * Based on code in the Node.js 'path' core module.
 *
 * @param aPath The path or url to normalize.
 */ function $e6f109dccd89c275$var$normalize(aPath) {
    var path = aPath;
    var url = $e6f109dccd89c275$var$urlParse(aPath);
    if (url) {
        if (!url.path) return aPath;
        path = url.path;
    }
    var isAbsolute = $e6f109dccd89c275$export$e434c7255acda994(path);
    var parts = path.split(/\/+/);
    for(var part, up = 0, i = parts.length - 1; i >= 0; i--){
        part = parts[i];
        if (part === '.') parts.splice(i, 1);
        else if (part === '..') up++;
        else if (up > 0) {
            if (part === '') {
                // The first part is blank if the path is absolute. Trying to go
                // above the root is a no-op. Therefore we can remove all '..' parts
                // directly after the root.
                parts.splice(i + 1, up);
                up = 0;
            } else {
                parts.splice(i, 2);
                up--;
            }
        }
    }
    path = parts.join('/');
    if (path === '') path = isAbsolute ? '/' : '.';
    if (url) {
        url.path = path;
        return $e6f109dccd89c275$var$urlGenerate(url);
    }
    return path;
}
$e6f109dccd89c275$export$a3295358bff77e = $e6f109dccd89c275$var$normalize;
/**
 * Joins two paths/URLs.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be joined with the root.
 *
 * - If aPath is a URL or a data URI, aPath is returned, unless aPath is a
 *   scheme-relative URL: Then the scheme of aRoot, if any, is prepended
 *   first.
 * - Otherwise aPath is a path. If aRoot is a URL, then its path portion
 *   is updated with the result and aRoot is returned. Otherwise the result
 *   is returned.
 *   - If aPath is absolute, the result is aPath.
 *   - Otherwise the two paths are joined with a slash.
 * - Joining for example 'http://' and 'www.example.com' is also supported.
 */ function $e6f109dccd89c275$var$join(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    if (aPath === "") aPath = ".";
    var aPathUrl = $e6f109dccd89c275$var$urlParse(aPath);
    var aRootUrl = $e6f109dccd89c275$var$urlParse(aRoot);
    if (aRootUrl) aRoot = aRootUrl.path || '/';
    // `join(foo, '//www.example.org')`
    if (aPathUrl && !aPathUrl.scheme) {
        if (aRootUrl) aPathUrl.scheme = aRootUrl.scheme;
        return $e6f109dccd89c275$var$urlGenerate(aPathUrl);
    }
    if (aPathUrl || aPath.match($e6f109dccd89c275$var$dataUrlRegexp)) return aPath;
    // `join('http://', 'www.example.com')`
    if (aRootUrl && !aRootUrl.host && !aRootUrl.path) {
        aRootUrl.host = aPath;
        return $e6f109dccd89c275$var$urlGenerate(aRootUrl);
    }
    var joined = aPath.charAt(0) === '/' ? aPath : $e6f109dccd89c275$var$normalize(aRoot.replace(/\/+$/, '') + '/' + aPath);
    if (aRootUrl) {
        aRootUrl.path = joined;
        return $e6f109dccd89c275$var$urlGenerate(aRootUrl);
    }
    return joined;
}
$e6f109dccd89c275$export$f7e2c8231c57a8bd = $e6f109dccd89c275$var$join;
$e6f109dccd89c275$export$e434c7255acda994 = function(aPath) {
    return aPath.charAt(0) === '/' || $e6f109dccd89c275$var$urlRegexp.test(aPath);
};
/**
 * Make a path relative to a URL or another path.
 *
 * @param aRoot The root path or URL.
 * @param aPath The path or URL to be made relative to aRoot.
 */ function $e6f109dccd89c275$var$relative(aRoot, aPath) {
    if (aRoot === "") aRoot = ".";
    aRoot = aRoot.replace(/\/$/, '');
    // It is possible for the path to be above the root. In this case, simply
    // checking whether the root is a prefix of the path won't work. Instead, we
    // need to remove components from the root one by one, until either we find
    // a prefix that fits, or we run out of components to remove.
    var level = 0;
    while(aPath.indexOf(aRoot + '/') !== 0){
        var index = aRoot.lastIndexOf("/");
        if (index < 0) return aPath;
        // If the only part of the root that is left is the scheme (i.e. http://,
        // file:///, etc.), one or more slashes (/), or simply nothing at all, we
        // have exhausted all components, so the path is not relative to the root.
        aRoot = aRoot.slice(0, index);
        if (aRoot.match(/^([^\/]+:\/)?\/*$/)) return aPath;
        ++level;
    }
    // Make sure we add a "../" for each component we removed from the root.
    return Array(level + 1).join("../") + aPath.substr(aRoot.length + 1);
}
$e6f109dccd89c275$export$f0e7d1106eeabbe6 = $e6f109dccd89c275$var$relative;
var $e6f109dccd89c275$var$supportsNullProto = function() {
    var obj = Object.create(null);
    return !('__proto__' in obj);
}();
function $e6f109dccd89c275$var$identity(s) {
    return s;
}
/**
 * Because behavior goes wacky when you set `__proto__` on objects, we
 * have to prefix all the strings in our set with an arbitrary character.
 *
 * See https://github.com/mozilla/source-map/pull/31 and
 * https://github.com/mozilla/source-map/issues/30
 *
 * @param String aStr
 */ function $e6f109dccd89c275$var$toSetString(aStr) {
    if ($e6f109dccd89c275$var$isProtoString(aStr)) return '$' + aStr;
    return aStr;
}
$e6f109dccd89c275$export$be0fa1163fa7a4c = $e6f109dccd89c275$var$supportsNullProto ? $e6f109dccd89c275$var$identity : $e6f109dccd89c275$var$toSetString;
function $e6f109dccd89c275$var$fromSetString(aStr) {
    if ($e6f109dccd89c275$var$isProtoString(aStr)) return aStr.slice(1);
    return aStr;
}
$e6f109dccd89c275$export$1fc47c3d4c3302a1 = $e6f109dccd89c275$var$supportsNullProto ? $e6f109dccd89c275$var$identity : $e6f109dccd89c275$var$fromSetString;
function $e6f109dccd89c275$var$isProtoString(s) {
    if (!s) return false;
    var length = s.length;
    if (length < 9 /* "__proto__".length */ ) return false;
    if (s.charCodeAt(length - 1) !== 95 /* '_' */  || s.charCodeAt(length - 2) !== 95 /* '_' */  || s.charCodeAt(length - 3) !== 111 /* 'o' */  || s.charCodeAt(length - 4) !== 116 /* 't' */  || s.charCodeAt(length - 5) !== 111 /* 'o' */  || s.charCodeAt(length - 6) !== 114 /* 'r' */  || s.charCodeAt(length - 7) !== 112 /* 'p' */  || s.charCodeAt(length - 8) !== 95 /* '_' */  || s.charCodeAt(length - 9) !== 95 /* '_' */ ) return false;
    for(var i = length - 10; i >= 0; i--){
        if (s.charCodeAt(i) !== 36 /* '$' */ ) return false;
    }
    return true;
}
/**
 * Comparator between two mappings where the original positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same original source/line/column, but different generated
 * line and column the same. Useful when searching for a mapping with a
 * stubbed out mapping.
 */ function $e6f109dccd89c275$var$compareByOriginalPositions(mappingA, mappingB, onlyCompareOriginal) {
    var cmp = $e6f109dccd89c275$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0 || onlyCompareOriginal) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    return $e6f109dccd89c275$var$strcmp(mappingA.name, mappingB.name);
}
$e6f109dccd89c275$export$273077902de92ff2 = $e6f109dccd89c275$var$compareByOriginalPositions;
/**
 * Comparator between two mappings with deflated source and name indices where
 * the generated positions are compared.
 *
 * Optionally pass in `true` as `onlyCompareGenerated` to consider two
 * mappings with the same generated line and column, but different
 * source/name/original line and column the same. Useful when searching for a
 * mapping with a stubbed out mapping.
 */ function $e6f109dccd89c275$var$compareByGeneratedPositionsDeflated(mappingA, mappingB, onlyCompareGenerated) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0 || onlyCompareGenerated) return cmp;
    cmp = $e6f109dccd89c275$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $e6f109dccd89c275$var$strcmp(mappingA.name, mappingB.name);
}
$e6f109dccd89c275$export$b7acf533941302f6 = $e6f109dccd89c275$var$compareByGeneratedPositionsDeflated;
function $e6f109dccd89c275$var$strcmp(aStr1, aStr2) {
    if (aStr1 === aStr2) return 0;
    if (aStr1 === null) return 1; // aStr2 !== null
    if (aStr2 === null) return -1; // aStr1 !== null
    if (aStr1 > aStr2) return 1;
    return -1;
}
/**
 * Comparator between two mappings with inflated source and name strings where
 * the generated positions are compared.
 */ function $e6f109dccd89c275$var$compareByGeneratedPositionsInflated(mappingA, mappingB) {
    var cmp = mappingA.generatedLine - mappingB.generatedLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.generatedColumn - mappingB.generatedColumn;
    if (cmp !== 0) return cmp;
    cmp = $e6f109dccd89c275$var$strcmp(mappingA.source, mappingB.source);
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalLine - mappingB.originalLine;
    if (cmp !== 0) return cmp;
    cmp = mappingA.originalColumn - mappingB.originalColumn;
    if (cmp !== 0) return cmp;
    return $e6f109dccd89c275$var$strcmp(mappingA.name, mappingB.name);
}
$e6f109dccd89c275$export$f9c43907549d61f1 = $e6f109dccd89c275$var$compareByGeneratedPositionsInflated;
/**
 * Strip any JSON XSSI avoidance prefix from the string (as documented
 * in the source maps specification), and then parse the string as
 * JSON.
 */ function $e6f109dccd89c275$var$parseSourceMapInput(str) {
    return JSON.parse(str.replace(/^\)]}'[^\n]*\n/, ''));
}
$e6f109dccd89c275$export$b49e2de2ad542732 = $e6f109dccd89c275$var$parseSourceMapInput;
/**
 * Compute the URL of a source given the the source root, the source's
 * URL, and the source map's URL.
 */ function $e6f109dccd89c275$var$computeSourceURL(sourceRoot, sourceURL, sourceMapURL) {
    sourceURL = sourceURL || '';
    if (sourceRoot) {
        // This follows what Chrome does.
        if (sourceRoot[sourceRoot.length - 1] !== '/' && sourceURL[0] !== '/') sourceRoot += '/';
        // The spec says:
        //   Line 4: An optional source root, useful for relocating source
        //   files on a server or removing repeated values in the
        //   “sources” entry.  This value is prepended to the individual
        //   entries in the “source” field.
        sourceURL = sourceRoot + sourceURL;
    }
    // Historically, SourceMapConsumer did not take the sourceMapURL as
    // a parameter.  This mode is still somewhat supported, which is why
    // this code block is conditional.  However, it's preferable to pass
    // the source map URL to SourceMapConsumer, so that this function
    // can implement the source URL resolution algorithm as outlined in
    // the spec.  This block is basically the equivalent of:
    //    new URL(sourceURL, sourceMapURL).toString()
    // ... except it avoids using URL, which wasn't available in the
    // older releases of node still supported by this library.
    //
    // The spec says:
    //   If the sources are not absolute URLs after prepending of the
    //   “sourceRoot”, the sources are resolved relative to the
    //   SourceMap (like resolving script src in a html document).
    if (sourceMapURL) {
        var parsed = $e6f109dccd89c275$var$urlParse(sourceMapURL);
        if (!parsed) throw new Error("sourceMapURL could not be parsed");
        if (parsed.path) {
            // Strip the last path component, but keep the "/".
            var index = parsed.path.lastIndexOf('/');
            if (index >= 0) parsed.path = parsed.path.substring(0, index + 1);
        }
        sourceURL = $e6f109dccd89c275$var$join($e6f109dccd89c275$var$urlGenerate(parsed), sourceURL);
    }
    return $e6f109dccd89c275$var$normalize(sourceURL);
}
$e6f109dccd89c275$export$659a1aa8f1cdc036 = $e6f109dccd89c275$var$computeSourceURL;

});

parcelRegister("8czLv", function(module, exports) {

$parcel$export(module.exports, "ArraySet", () => $5f8b2ff847399f22$export$605bbf5ea7b60ba3, (v) => $5f8b2ff847399f22$export$605bbf5ea7b60ba3 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $5f8b2ff847399f22$export$605bbf5ea7b60ba3;

var $jPinH = parcelRequire("jPinH");
var $5f8b2ff847399f22$var$has = Object.prototype.hasOwnProperty;
var $5f8b2ff847399f22$var$hasNativeMap = typeof Map !== "undefined";
/**
 * A data structure which is a combination of an array and a set. Adding a new
 * member is O(1), testing for membership is O(1), and finding the index of an
 * element is O(1). Removing elements from the set is not supported. Only
 * strings are supported for membership.
 */ function $5f8b2ff847399f22$var$ArraySet() {
    this._array = [];
    this._set = $5f8b2ff847399f22$var$hasNativeMap ? new Map() : Object.create(null);
}
/**
 * Static method for creating ArraySet instances from an existing array.
 */ $5f8b2ff847399f22$var$ArraySet.fromArray = function ArraySet_fromArray(aArray, aAllowDuplicates) {
    var set = new $5f8b2ff847399f22$var$ArraySet();
    for(var i = 0, len = aArray.length; i < len; i++)set.add(aArray[i], aAllowDuplicates);
    return set;
};
/**
 * Return how many unique items are in this ArraySet. If duplicates have been
 * added, than those do not count towards the size.
 *
 * @returns Number
 */ $5f8b2ff847399f22$var$ArraySet.prototype.size = function ArraySet_size() {
    return $5f8b2ff847399f22$var$hasNativeMap ? this._set.size : Object.getOwnPropertyNames(this._set).length;
};
/**
 * Add the given string to this set.
 *
 * @param String aStr
 */ $5f8b2ff847399f22$var$ArraySet.prototype.add = function ArraySet_add(aStr, aAllowDuplicates) {
    var sStr = $5f8b2ff847399f22$var$hasNativeMap ? aStr : $jPinH.toSetString(aStr);
    var isDuplicate = $5f8b2ff847399f22$var$hasNativeMap ? this.has(aStr) : $5f8b2ff847399f22$var$has.call(this._set, sStr);
    var idx = this._array.length;
    if (!isDuplicate || aAllowDuplicates) this._array.push(aStr);
    if (!isDuplicate) {
        if ($5f8b2ff847399f22$var$hasNativeMap) this._set.set(aStr, idx);
        else this._set[sStr] = idx;
    }
};
/**
 * Is the given string a member of this set?
 *
 * @param String aStr
 */ $5f8b2ff847399f22$var$ArraySet.prototype.has = function ArraySet_has(aStr) {
    if ($5f8b2ff847399f22$var$hasNativeMap) return this._set.has(aStr);
    else {
        var sStr = $jPinH.toSetString(aStr);
        return $5f8b2ff847399f22$var$has.call(this._set, sStr);
    }
};
/**
 * What is the index of the given string in the array?
 *
 * @param String aStr
 */ $5f8b2ff847399f22$var$ArraySet.prototype.indexOf = function ArraySet_indexOf(aStr) {
    if ($5f8b2ff847399f22$var$hasNativeMap) {
        var idx = this._set.get(aStr);
        if (idx >= 0) return idx;
    } else {
        var sStr = $jPinH.toSetString(aStr);
        if ($5f8b2ff847399f22$var$has.call(this._set, sStr)) return this._set[sStr];
    }
    throw new Error('"' + aStr + '" is not in the set.');
};
/**
 * What is the element at the given index?
 *
 * @param Number aIdx
 */ $5f8b2ff847399f22$var$ArraySet.prototype.at = function ArraySet_at(aIdx) {
    if (aIdx >= 0 && aIdx < this._array.length) return this._array[aIdx];
    throw new Error('No element indexed by ' + aIdx);
};
/**
 * Returns the array representation of this set (which has the proper indices
 * indicated by indexOf). Note that this is a copy of the internal array used
 * for storing the members so that no one can mess with internal state.
 */ $5f8b2ff847399f22$var$ArraySet.prototype.toArray = function ArraySet_toArray() {
    return this._array.slice();
};
$5f8b2ff847399f22$export$605bbf5ea7b60ba3 = $5f8b2ff847399f22$var$ArraySet;

});

parcelRegister("1I6ue", function(module, exports) {

$parcel$export(module.exports, "MappingList", () => $13eeee9b9903b533$export$e82e0908843dd951, (v) => $13eeee9b9903b533$export$e82e0908843dd951 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2014 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $13eeee9b9903b533$export$e82e0908843dd951;

var $jPinH = parcelRequire("jPinH");
/**
 * Determine whether mappingB is after mappingA with respect to generated
 * position.
 */ function $13eeee9b9903b533$var$generatedPositionAfter(mappingA, mappingB) {
    // Optimized for most common case
    var lineA = mappingA.generatedLine;
    var lineB = mappingB.generatedLine;
    var columnA = mappingA.generatedColumn;
    var columnB = mappingB.generatedColumn;
    return lineB > lineA || lineB == lineA && columnB >= columnA || $jPinH.compareByGeneratedPositionsInflated(mappingA, mappingB) <= 0;
}
/**
 * A data structure to provide a sorted view of accumulated mappings in a
 * performance conscious manner. It trades a neglibable overhead in general
 * case for a large speedup in case of mappings being added in order.
 */ function $13eeee9b9903b533$var$MappingList() {
    this._array = [];
    this._sorted = true;
    // Serves as infimum
    this._last = {
        generatedLine: -1,
        generatedColumn: 0
    };
}
/**
 * Iterate through internal items. This method takes the same arguments that
 * `Array.prototype.forEach` takes.
 *
 * NOTE: The order of the mappings is NOT guaranteed.
 */ $13eeee9b9903b533$var$MappingList.prototype.unsortedForEach = function MappingList_forEach(aCallback, aThisArg) {
    this._array.forEach(aCallback, aThisArg);
};
/**
 * Add the given source mapping.
 *
 * @param Object aMapping
 */ $13eeee9b9903b533$var$MappingList.prototype.add = function MappingList_add(aMapping) {
    if ($13eeee9b9903b533$var$generatedPositionAfter(this._last, aMapping)) {
        this._last = aMapping;
        this._array.push(aMapping);
    } else {
        this._sorted = false;
        this._array.push(aMapping);
    }
};
/**
 * Returns the flat, sorted array of mappings. The mappings are sorted by
 * generated position.
 *
 * WARNING: This method returns internal data without copying, for
 * performance. The return value must NOT be mutated, and should be treated as
 * an immutable borrow. If you want to take ownership, you must make your own
 * copy.
 */ $13eeee9b9903b533$var$MappingList.prototype.toArray = function MappingList_toArray() {
    if (!this._sorted) {
        this._array.sort($jPinH.compareByGeneratedPositionsInflated);
        this._sorted = true;
    }
    return this._array;
};
$13eeee9b9903b533$export$e82e0908843dd951 = $13eeee9b9903b533$var$MappingList;

});


parcelRegister("cUj0p", function(module, exports) {

$parcel$export(module.exports, "SourceMapConsumer", () => $9659751726d9a0d3$export$194e92554d04abdd, (v) => $9659751726d9a0d3$export$194e92554d04abdd = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $9659751726d9a0d3$export$194e92554d04abdd;
var $9659751726d9a0d3$export$bef6691594139a79;
var $9659751726d9a0d3$export$823525094e5b803c;

var $jPinH = parcelRequire("jPinH");

var $4cMCc = parcelRequire("4cMCc");

var $8czLv = parcelRequire("8czLv");
var $9659751726d9a0d3$require$ArraySet = $8czLv.ArraySet;

var $832FF = parcelRequire("832FF");

var $kCbM6 = parcelRequire("kCbM6");
var $9659751726d9a0d3$require$quickSort = $kCbM6.quickSort;
function $9659751726d9a0d3$var$SourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === 'string') sourceMap = $jPinH.parseSourceMapInput(aSourceMap);
    return sourceMap.sections != null ? new $9659751726d9a0d3$var$IndexedSourceMapConsumer(sourceMap, aSourceMapURL) : new $9659751726d9a0d3$var$BasicSourceMapConsumer(sourceMap, aSourceMapURL);
}
$9659751726d9a0d3$var$SourceMapConsumer.fromSourceMap = function(aSourceMap, aSourceMapURL) {
    return $9659751726d9a0d3$var$BasicSourceMapConsumer.fromSourceMap(aSourceMap, aSourceMapURL);
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $9659751726d9a0d3$var$SourceMapConsumer.prototype._version = 3;
// `__generatedMappings` and `__originalMappings` are arrays that hold the
// parsed mapping coordinates from the source map's "mappings" attribute. They
// are lazily instantiated, accessed via the `_generatedMappings` and
// `_originalMappings` getters respectively, and we only parse the mappings
// and create these arrays once queried for a source location. We jump through
// these hoops because there can be many thousands of mappings, and parsing
// them is expensive, so we only want to do it if we must.
//
// Each object in the arrays is of the form:
//
//     {
//       generatedLine: The line number in the generated code,
//       generatedColumn: The column number in the generated code,
//       source: The path to the original source file that generated this
//               chunk of code,
//       originalLine: The line number in the original source that
//                     corresponds to this chunk of generated code,
//       originalColumn: The column number in the original source that
//                       corresponds to this chunk of generated code,
//       name: The name of the original symbol which generated this chunk of
//             code.
//     }
//
// All properties except for `generatedLine` and `generatedColumn` can be
// `null`.
//
// `_generatedMappings` is ordered by the generated positions.
//
// `_originalMappings` is ordered by the original positions.
$9659751726d9a0d3$var$SourceMapConsumer.prototype.__generatedMappings = null;
Object.defineProperty($9659751726d9a0d3$var$SourceMapConsumer.prototype, '_generatedMappings', {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__generatedMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__generatedMappings;
    }
});
$9659751726d9a0d3$var$SourceMapConsumer.prototype.__originalMappings = null;
Object.defineProperty($9659751726d9a0d3$var$SourceMapConsumer.prototype, '_originalMappings', {
    configurable: true,
    enumerable: true,
    get: function() {
        if (!this.__originalMappings) this._parseMappings(this._mappings, this.sourceRoot);
        return this.__originalMappings;
    }
});
$9659751726d9a0d3$var$SourceMapConsumer.prototype._charIsMappingSeparator = function SourceMapConsumer_charIsMappingSeparator(aStr, index) {
    var c = aStr.charAt(index);
    return c === ";" || c === ",";
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $9659751726d9a0d3$var$SourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    throw new Error("Subclasses must implement _parseMappings");
};
$9659751726d9a0d3$var$SourceMapConsumer.GENERATED_ORDER = 1;
$9659751726d9a0d3$var$SourceMapConsumer.ORIGINAL_ORDER = 2;
$9659751726d9a0d3$var$SourceMapConsumer.GREATEST_LOWER_BOUND = 1;
$9659751726d9a0d3$var$SourceMapConsumer.LEAST_UPPER_BOUND = 2;
/**
 * Iterate over each mapping between an original source/line/column and a
 * generated line/column in this source map.
 *
 * @param Function aCallback
 *        The function that is called with each mapping.
 * @param Object aContext
 *        Optional. If specified, this object will be the value of `this` every
 *        time that `aCallback` is called.
 * @param aOrder
 *        Either `SourceMapConsumer.GENERATED_ORDER` or
 *        `SourceMapConsumer.ORIGINAL_ORDER`. Specifies whether you want to
 *        iterate over the mappings sorted by the generated file's line/column
 *        order or the original's source/line/column order, respectively. Defaults to
 *        `SourceMapConsumer.GENERATED_ORDER`.
 */ $9659751726d9a0d3$var$SourceMapConsumer.prototype.eachMapping = function SourceMapConsumer_eachMapping(aCallback, aContext, aOrder) {
    var context = aContext || null;
    var order = aOrder || $9659751726d9a0d3$var$SourceMapConsumer.GENERATED_ORDER;
    var mappings;
    switch(order){
        case $9659751726d9a0d3$var$SourceMapConsumer.GENERATED_ORDER:
            mappings = this._generatedMappings;
            break;
        case $9659751726d9a0d3$var$SourceMapConsumer.ORIGINAL_ORDER:
            mappings = this._originalMappings;
            break;
        default:
            throw new Error("Unknown order of iteration.");
    }
    var sourceRoot = this.sourceRoot;
    mappings.map(function(mapping) {
        var source = mapping.source === null ? null : this._sources.at(mapping.source);
        source = $jPinH.computeSourceURL(sourceRoot, source, this._sourceMapURL);
        return {
            source: source,
            generatedLine: mapping.generatedLine,
            generatedColumn: mapping.generatedColumn,
            originalLine: mapping.originalLine,
            originalColumn: mapping.originalColumn,
            name: mapping.name === null ? null : this._names.at(mapping.name)
        };
    }, this).forEach(aCallback, context);
};
/**
 * Returns all generated line and column information for the original source,
 * line, and column provided. If no column is provided, returns all mappings
 * corresponding to a either the line we are searching for or the next
 * closest line that has any mappings. Otherwise, returns all mappings
 * corresponding to the given line and either the column we are searching for
 * or the next closest column that has any offsets.
 *
 * The only argument is an object with the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number is 1-based.
 *   - column: Optional. the column number in the original source.
 *    The column number is 0-based.
 *
 * and an array of objects is returned, each with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *    line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *    The column number is 0-based.
 */ $9659751726d9a0d3$var$SourceMapConsumer.prototype.allGeneratedPositionsFor = function SourceMapConsumer_allGeneratedPositionsFor(aArgs) {
    var line = $jPinH.getArg(aArgs, 'line');
    // When there is no exact match, BasicSourceMapConsumer.prototype._findMapping
    // returns the index of the closest mapping less than the needle. By
    // setting needle.originalColumn to 0, we thus find the last mapping for
    // the given line, provided such a mapping exists.
    var needle = {
        source: $jPinH.getArg(aArgs, 'source'),
        originalLine: line,
        originalColumn: $jPinH.getArg(aArgs, 'column', 0)
    };
    needle.source = this._findSourceIndex(needle.source);
    if (needle.source < 0) return [];
    var mappings = [];
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jPinH.compareByOriginalPositions, $4cMCc.LEAST_UPPER_BOUND);
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (aArgs.column === undefined) {
            var originalLine = mapping.originalLine;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we found. Since
            // mappings are sorted, this is guaranteed to find all mappings for
            // the line we found.
            while(mapping && mapping.originalLine === originalLine){
                mappings.push({
                    line: $jPinH.getArg(mapping, 'generatedLine', null),
                    column: $jPinH.getArg(mapping, 'generatedColumn', null),
                    lastColumn: $jPinH.getArg(mapping, 'lastGeneratedColumn', null)
                });
                mapping = this._originalMappings[++index];
            }
        } else {
            var originalColumn = mapping.originalColumn;
            // Iterate until either we run out of mappings, or we run into
            // a mapping for a different line than the one we were searching for.
            // Since mappings are sorted, this is guaranteed to find all mappings for
            // the line we are searching for.
            while(mapping && mapping.originalLine === line && mapping.originalColumn == originalColumn){
                mappings.push({
                    line: $jPinH.getArg(mapping, 'generatedLine', null),
                    column: $jPinH.getArg(mapping, 'generatedColumn', null),
                    lastColumn: $jPinH.getArg(mapping, 'lastGeneratedColumn', null)
                });
                mapping = this._originalMappings[++index];
            }
        }
    }
    return mappings;
};
$9659751726d9a0d3$export$194e92554d04abdd = $9659751726d9a0d3$var$SourceMapConsumer;
/**
 * A BasicSourceMapConsumer instance represents a parsed source map which we can
 * query for information about the original file positions by giving it a file
 * position in the generated source.
 *
 * The first parameter is the raw source map (either as a JSON string, or
 * already parsed to an object). According to the spec, source maps have the
 * following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - sources: An array of URLs to the original source files.
 *   - names: An array of identifiers which can be referrenced by individual mappings.
 *   - sourceRoot: Optional. The URL root from which all sources are relative.
 *   - sourcesContent: Optional. An array of contents of the original source files.
 *   - mappings: A string of base64 VLQs which contain the actual mappings.
 *   - file: Optional. The generated file this source map is associated with.
 *
 * Here is an example source map, taken from the source map spec[0]:
 *
 *     {
 *       version : 3,
 *       file: "out.js",
 *       sourceRoot : "",
 *       sources: ["foo.js", "bar.js"],
 *       names: ["src", "maps", "are", "fun"],
 *       mappings: "AA,AB;;ABCDE;"
 *     }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit?pli=1#
 */ function $9659751726d9a0d3$var$BasicSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === 'string') sourceMap = $jPinH.parseSourceMapInput(aSourceMap);
    var version = $jPinH.getArg(sourceMap, 'version');
    var sources = $jPinH.getArg(sourceMap, 'sources');
    // Sass 3.3 leaves out the 'names' array, so we deviate from the spec (which
    // requires the array) to play nice here.
    var names = $jPinH.getArg(sourceMap, 'names', []);
    var sourceRoot = $jPinH.getArg(sourceMap, 'sourceRoot', null);
    var sourcesContent = $jPinH.getArg(sourceMap, 'sourcesContent', null);
    var mappings = $jPinH.getArg(sourceMap, 'mappings');
    var file = $jPinH.getArg(sourceMap, 'file', null);
    // Once again, Sass deviates from the spec and supplies the version as a
    // string rather than a number, so we use loose equality checking here.
    if (version != this._version) throw new Error('Unsupported version: ' + version);
    if (sourceRoot) sourceRoot = $jPinH.normalize(sourceRoot);
    sources = sources.map(String)// Some source maps produce relative source paths like "./foo.js" instead of
    // "foo.js".  Normalize these first so that future comparisons will succeed.
    // See bugzil.la/1090768.
    .map($jPinH.normalize)// Always ensure that absolute sources are internally stored relative to
    // the source root, if the source root is absolute. Not doing this would
    // be particularly problematic when the source root is a prefix of the
    // source (valid, but why??). See github issue #199 and bugzil.la/1188982.
    .map(function(source) {
        return sourceRoot && $jPinH.isAbsolute(sourceRoot) && $jPinH.isAbsolute(source) ? $jPinH.relative(sourceRoot, source) : source;
    });
    // Pass `true` below to allow duplicate names and sources. While source maps
    // are intended to be compressed and deduplicated, the TypeScript compiler
    // sometimes generates source maps with duplicates in them. See Github issue
    // #72 and bugzil.la/889492.
    this._names = $9659751726d9a0d3$require$ArraySet.fromArray(names.map(String), true);
    this._sources = $9659751726d9a0d3$require$ArraySet.fromArray(sources, true);
    this._absoluteSources = this._sources.toArray().map(function(s) {
        return $jPinH.computeSourceURL(sourceRoot, s, aSourceMapURL);
    });
    this.sourceRoot = sourceRoot;
    this.sourcesContent = sourcesContent;
    this._mappings = mappings;
    this._sourceMapURL = aSourceMapURL;
    this.file = file;
}
$9659751726d9a0d3$var$BasicSourceMapConsumer.prototype = Object.create($9659751726d9a0d3$var$SourceMapConsumer.prototype);
$9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.consumer = $9659751726d9a0d3$var$SourceMapConsumer;
/**
 * Utility function to find the index of a source.  Returns -1 if not
 * found.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype._findSourceIndex = function(aSource) {
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $jPinH.relative(this.sourceRoot, relativeSource);
    if (this._sources.has(relativeSource)) return this._sources.indexOf(relativeSource);
    // Maybe aSource is an absolute URL as returned by |sources|.  In
    // this case we can't simply undo the transform.
    var i;
    for(i = 0; i < this._absoluteSources.length; ++i){
        if (this._absoluteSources[i] == aSource) return i;
    }
    return -1;
};
/**
 * Create a BasicSourceMapConsumer from a SourceMapGenerator.
 *
 * @param SourceMapGenerator aSourceMap
 *        The source map that will be consumed.
 * @param String aSourceMapURL
 *        The URL at which the source map can be found (optional)
 * @returns BasicSourceMapConsumer
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.fromSourceMap = function SourceMapConsumer_fromSourceMap(aSourceMap, aSourceMapURL) {
    var smc = Object.create($9659751726d9a0d3$var$BasicSourceMapConsumer.prototype);
    var names = smc._names = $9659751726d9a0d3$require$ArraySet.fromArray(aSourceMap._names.toArray(), true);
    var sources = smc._sources = $9659751726d9a0d3$require$ArraySet.fromArray(aSourceMap._sources.toArray(), true);
    smc.sourceRoot = aSourceMap._sourceRoot;
    smc.sourcesContent = aSourceMap._generateSourcesContent(smc._sources.toArray(), smc.sourceRoot);
    smc.file = aSourceMap._file;
    smc._sourceMapURL = aSourceMapURL;
    smc._absoluteSources = smc._sources.toArray().map(function(s) {
        return $jPinH.computeSourceURL(smc.sourceRoot, s, aSourceMapURL);
    });
    // Because we are modifying the entries (by converting string sources and
    // names to indices into the sources and names ArraySets), we have to make
    // a copy of the entry or else bad things happen. Shared mutable state
    // strikes again! See github issue #191.
    var generatedMappings = aSourceMap._mappings.toArray().slice();
    var destGeneratedMappings = smc.__generatedMappings = [];
    var destOriginalMappings = smc.__originalMappings = [];
    for(var i = 0, length = generatedMappings.length; i < length; i++){
        var srcMapping = generatedMappings[i];
        var destMapping = new $9659751726d9a0d3$var$Mapping;
        destMapping.generatedLine = srcMapping.generatedLine;
        destMapping.generatedColumn = srcMapping.generatedColumn;
        if (srcMapping.source) {
            destMapping.source = sources.indexOf(srcMapping.source);
            destMapping.originalLine = srcMapping.originalLine;
            destMapping.originalColumn = srcMapping.originalColumn;
            if (srcMapping.name) destMapping.name = names.indexOf(srcMapping.name);
            destOriginalMappings.push(destMapping);
        }
        destGeneratedMappings.push(destMapping);
    }
    $9659751726d9a0d3$require$quickSort(smc.__originalMappings, $jPinH.compareByOriginalPositions);
    return smc;
};
/**
 * The version of the source mapping spec that we are consuming.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($9659751726d9a0d3$var$BasicSourceMapConsumer.prototype, 'sources', {
    get: function() {
        return this._absoluteSources.slice();
    }
});
/**
 * Provide the JIT with a nice shape / hidden class.
 */ function $9659751726d9a0d3$var$Mapping() {
    this.generatedLine = 0;
    this.generatedColumn = 0;
    this.source = null;
    this.originalLine = null;
    this.originalColumn = null;
    this.name = null;
}
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype._parseMappings = function SourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    var generatedLine = 1;
    var previousGeneratedColumn = 0;
    var previousOriginalLine = 0;
    var previousOriginalColumn = 0;
    var previousSource = 0;
    var previousName = 0;
    var length = aStr.length;
    var index = 0;
    var cachedSegments = {};
    var temp = {};
    var originalMappings = [];
    var generatedMappings = [];
    var mapping, str, segment, end, value;
    while(index < length){
        if (aStr.charAt(index) === ';') {
            generatedLine++;
            index++;
            previousGeneratedColumn = 0;
        } else if (aStr.charAt(index) === ',') index++;
        else {
            mapping = new $9659751726d9a0d3$var$Mapping();
            mapping.generatedLine = generatedLine;
            // Because each offset is encoded relative to the previous one,
            // many segments often have the same encoding. We can exploit this
            // fact by caching the parsed variable length fields of each segment,
            // allowing us to avoid a second parse if we encounter the same
            // segment again.
            for(end = index; end < length; end++){
                if (this._charIsMappingSeparator(aStr, end)) break;
            }
            str = aStr.slice(index, end);
            segment = cachedSegments[str];
            if (segment) index += str.length;
            else {
                segment = [];
                while(index < end){
                    $832FF.decode(aStr, index, temp);
                    value = temp.value;
                    index = temp.rest;
                    segment.push(value);
                }
                if (segment.length === 2) throw new Error('Found a source, but no line and column');
                if (segment.length === 3) throw new Error('Found a source and line, but no column');
                cachedSegments[str] = segment;
            }
            // Generated column.
            mapping.generatedColumn = previousGeneratedColumn + segment[0];
            previousGeneratedColumn = mapping.generatedColumn;
            if (segment.length > 1) {
                // Original source.
                mapping.source = previousSource + segment[1];
                previousSource += segment[1];
                // Original line.
                mapping.originalLine = previousOriginalLine + segment[2];
                previousOriginalLine = mapping.originalLine;
                // Lines are stored 0-based
                mapping.originalLine += 1;
                // Original column.
                mapping.originalColumn = previousOriginalColumn + segment[3];
                previousOriginalColumn = mapping.originalColumn;
                if (segment.length > 4) {
                    // Original name.
                    mapping.name = previousName + segment[4];
                    previousName += segment[4];
                }
            }
            generatedMappings.push(mapping);
            if (typeof mapping.originalLine === 'number') originalMappings.push(mapping);
        }
    }
    $9659751726d9a0d3$require$quickSort(generatedMappings, $jPinH.compareByGeneratedPositionsDeflated);
    this.__generatedMappings = generatedMappings;
    $9659751726d9a0d3$require$quickSort(originalMappings, $jPinH.compareByOriginalPositions);
    this.__originalMappings = originalMappings;
};
/**
 * Find the mapping that best matches the hypothetical "needle" mapping that
 * we are searching for in the given "haystack" of mappings.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype._findMapping = function SourceMapConsumer_findMapping(aNeedle, aMappings, aLineName, aColumnName, aComparator, aBias) {
    // To return the position we are searching for, we must first find the
    // mapping for the given position and then return the opposite position it
    // points to. Because the mappings are sorted, we can use binary search to
    // find the best mapping.
    if (aNeedle[aLineName] <= 0) throw new TypeError('Line must be greater than or equal to 1, got ' + aNeedle[aLineName]);
    if (aNeedle[aColumnName] < 0) throw new TypeError('Column must be greater than or equal to 0, got ' + aNeedle[aColumnName]);
    return $4cMCc.search(aNeedle, aMappings, aComparator, aBias);
};
/**
 * Compute the last column for each generated mapping. The last column is
 * inclusive.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.computeColumnSpans = function SourceMapConsumer_computeColumnSpans() {
    for(var index = 0; index < this._generatedMappings.length; ++index){
        var mapping = this._generatedMappings[index];
        // Mappings do not contain a field for the last generated columnt. We
        // can come up with an optimistic estimate, however, by assuming that
        // mappings are contiguous (i.e. given two consecutive mappings, the
        // first mapping ends where the second one starts).
        if (index + 1 < this._generatedMappings.length) {
            var nextMapping = this._generatedMappings[index + 1];
            if (mapping.generatedLine === nextMapping.generatedLine) {
                mapping.lastGeneratedColumn = nextMapping.generatedColumn - 1;
                continue;
            }
        }
        // The last mapping for each line spans the entire line.
        mapping.lastGeneratedColumn = Infinity;
    }
};
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.originalPositionFor = function SourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jPinH.getArg(aArgs, 'line'),
        generatedColumn: $jPinH.getArg(aArgs, 'column')
    };
    var index = this._findMapping(needle, this._generatedMappings, "generatedLine", "generatedColumn", $jPinH.compareByGeneratedPositionsDeflated, $jPinH.getArg(aArgs, 'bias', $9659751726d9a0d3$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._generatedMappings[index];
        if (mapping.generatedLine === needle.generatedLine) {
            var source = $jPinH.getArg(mapping, 'source', null);
            if (source !== null) {
                source = this._sources.at(source);
                source = $jPinH.computeSourceURL(this.sourceRoot, source, this._sourceMapURL);
            }
            var name = $jPinH.getArg(mapping, 'name', null);
            if (name !== null) name = this._names.at(name);
            return {
                source: source,
                line: $jPinH.getArg(mapping, 'originalLine', null),
                column: $jPinH.getArg(mapping, 'originalColumn', null),
                name: name
            };
        }
    }
    return {
        source: null,
        line: null,
        column: null,
        name: null
    };
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.hasContentsOfAllSources = function BasicSourceMapConsumer_hasContentsOfAllSources() {
    if (!this.sourcesContent) return false;
    return this.sourcesContent.length >= this._sources.size() && !this.sourcesContent.some(function(sc) {
        return sc == null;
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.sourceContentFor = function SourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    if (!this.sourcesContent) return null;
    var index = this._findSourceIndex(aSource);
    if (index >= 0) return this.sourcesContent[index];
    var relativeSource = aSource;
    if (this.sourceRoot != null) relativeSource = $jPinH.relative(this.sourceRoot, relativeSource);
    var url;
    if (this.sourceRoot != null && (url = $jPinH.urlParse(this.sourceRoot))) {
        // XXX: file:// URIs and absolute paths lead to unexpected behavior for
        // many users. We can help them out when they expect file:// URIs to
        // behave like it would if they were running a local HTTP server. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=885597.
        var fileUriAbsPath = relativeSource.replace(/^file:\/\//, "");
        if (url.scheme == "file" && this._sources.has(fileUriAbsPath)) return this.sourcesContent[this._sources.indexOf(fileUriAbsPath)];
        if ((!url.path || url.path == "/") && this._sources.has("/" + relativeSource)) return this.sourcesContent[this._sources.indexOf("/" + relativeSource)];
    }
    // This function is used recursively from
    // IndexedSourceMapConsumer.prototype.sourceContentFor. In that case, we
    // don't want to throw if we can't find the source - we just want to
    // return null, so we provide a flag to exit gracefully.
    if (nullOnMissing) return null;
    else throw new Error('"' + relativeSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *   - bias: Either 'SourceMapConsumer.GREATEST_LOWER_BOUND' or
 *     'SourceMapConsumer.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'SourceMapConsumer.GREATEST_LOWER_BOUND'.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $9659751726d9a0d3$var$BasicSourceMapConsumer.prototype.generatedPositionFor = function SourceMapConsumer_generatedPositionFor(aArgs) {
    var source = $jPinH.getArg(aArgs, 'source');
    source = this._findSourceIndex(source);
    if (source < 0) return {
        line: null,
        column: null,
        lastColumn: null
    };
    var needle = {
        source: source,
        originalLine: $jPinH.getArg(aArgs, 'line'),
        originalColumn: $jPinH.getArg(aArgs, 'column')
    };
    var index = this._findMapping(needle, this._originalMappings, "originalLine", "originalColumn", $jPinH.compareByOriginalPositions, $jPinH.getArg(aArgs, 'bias', $9659751726d9a0d3$var$SourceMapConsumer.GREATEST_LOWER_BOUND));
    if (index >= 0) {
        var mapping = this._originalMappings[index];
        if (mapping.source === needle.source) return {
            line: $jPinH.getArg(mapping, 'generatedLine', null),
            column: $jPinH.getArg(mapping, 'generatedColumn', null),
            lastColumn: $jPinH.getArg(mapping, 'lastGeneratedColumn', null)
        };
    }
    return {
        line: null,
        column: null,
        lastColumn: null
    };
};
$9659751726d9a0d3$export$bef6691594139a79 = $9659751726d9a0d3$var$BasicSourceMapConsumer;
/**
 * An IndexedSourceMapConsumer instance represents a parsed source map which
 * we can query for information. It differs from BasicSourceMapConsumer in
 * that it takes "indexed" source maps (i.e. ones with a "sections" field) as
 * input.
 *
 * The first parameter is a raw source map (either as a JSON string, or already
 * parsed to an object). According to the spec for indexed source maps, they
 * have the following attributes:
 *
 *   - version: Which version of the source map spec this map is following.
 *   - file: Optional. The generated file this source map is associated with.
 *   - sections: A list of section definitions.
 *
 * Each value under the "sections" field has two fields:
 *   - offset: The offset into the original specified at which this section
 *       begins to apply, defined as an object with a "line" and "column"
 *       field.
 *   - map: A source map definition. This source map could also be indexed,
 *       but doesn't have to be.
 *
 * Instead of the "map" field, it's also possible to have a "url" field
 * specifying a URL to retrieve a source map from, but that's currently
 * unsupported.
 *
 * Here's an example source map, taken from the source map spec[0], but
 * modified to omit a section which uses the "url" field.
 *
 *  {
 *    version : 3,
 *    file: "app.js",
 *    sections: [{
 *      offset: {line:100, column:10},
 *      map: {
 *        version : 3,
 *        file: "section.js",
 *        sources: ["foo.js", "bar.js"],
 *        names: ["src", "maps", "are", "fun"],
 *        mappings: "AAAA,E;;ABCDE;"
 *      }
 *    }],
 *  }
 *
 * The second parameter, if given, is a string whose value is the URL
 * at which the source map was found.  This URL is used to compute the
 * sources array.
 *
 * [0]: https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit#heading=h.535es3xeprgt
 */ function $9659751726d9a0d3$var$IndexedSourceMapConsumer(aSourceMap, aSourceMapURL) {
    var sourceMap = aSourceMap;
    if (typeof aSourceMap === 'string') sourceMap = $jPinH.parseSourceMapInput(aSourceMap);
    var version = $jPinH.getArg(sourceMap, 'version');
    var sections = $jPinH.getArg(sourceMap, 'sections');
    if (version != this._version) throw new Error('Unsupported version: ' + version);
    this._sources = new $9659751726d9a0d3$require$ArraySet();
    this._names = new $9659751726d9a0d3$require$ArraySet();
    var lastOffset = {
        line: -1,
        column: 0
    };
    this._sections = sections.map(function(s) {
        if (s.url) // The url field will require support for asynchronicity.
        // See https://github.com/mozilla/source-map/issues/16
        throw new Error('Support for url field in sections not implemented.');
        var offset = $jPinH.getArg(s, 'offset');
        var offsetLine = $jPinH.getArg(offset, 'line');
        var offsetColumn = $jPinH.getArg(offset, 'column');
        if (offsetLine < lastOffset.line || offsetLine === lastOffset.line && offsetColumn < lastOffset.column) throw new Error('Section offsets must be ordered and non-overlapping.');
        lastOffset = offset;
        return {
            generatedOffset: {
                // The offset fields are 0-based, but we use 1-based indices when
                // encoding/decoding from VLQ.
                generatedLine: offsetLine + 1,
                generatedColumn: offsetColumn + 1
            },
            consumer: new $9659751726d9a0d3$var$SourceMapConsumer($jPinH.getArg(s, 'map'), aSourceMapURL)
        };
    });
}
$9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype = Object.create($9659751726d9a0d3$var$SourceMapConsumer.prototype);
$9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype.constructor = $9659751726d9a0d3$var$SourceMapConsumer;
/**
 * The version of the source mapping spec that we are consuming.
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype._version = 3;
/**
 * The list of original sources.
 */ Object.defineProperty($9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype, 'sources', {
    get: function() {
        var sources = [];
        for(var i = 0; i < this._sections.length; i++)for(var j = 0; j < this._sections[i].consumer.sources.length; j++)sources.push(this._sections[i].consumer.sources[j]);
        return sources;
    }
});
/**
 * Returns the original source, line, and column information for the generated
 * source's line and column positions provided. The only argument is an object
 * with the following properties:
 *
 *   - line: The line number in the generated source.  The line number
 *     is 1-based.
 *   - column: The column number in the generated source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - source: The original source file, or null.
 *   - line: The line number in the original source, or null.  The
 *     line number is 1-based.
 *   - column: The column number in the original source, or null.  The
 *     column number is 0-based.
 *   - name: The original identifier, or null.
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype.originalPositionFor = function IndexedSourceMapConsumer_originalPositionFor(aArgs) {
    var needle = {
        generatedLine: $jPinH.getArg(aArgs, 'line'),
        generatedColumn: $jPinH.getArg(aArgs, 'column')
    };
    // Find the section containing the generated position we're trying to map
    // to an original position.
    var sectionIndex = $4cMCc.search(needle, this._sections, function(needle, section) {
        var cmp = needle.generatedLine - section.generatedOffset.generatedLine;
        if (cmp) return cmp;
        return needle.generatedColumn - section.generatedOffset.generatedColumn;
    });
    var section = this._sections[sectionIndex];
    if (!section) return {
        source: null,
        line: null,
        column: null,
        name: null
    };
    return section.consumer.originalPositionFor({
        line: needle.generatedLine - (section.generatedOffset.generatedLine - 1),
        column: needle.generatedColumn - (section.generatedOffset.generatedLine === needle.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
        bias: aArgs.bias
    });
};
/**
 * Return true if we have the source content for every source in the source
 * map, false otherwise.
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype.hasContentsOfAllSources = function IndexedSourceMapConsumer_hasContentsOfAllSources() {
    return this._sections.every(function(s) {
        return s.consumer.hasContentsOfAllSources();
    });
};
/**
 * Returns the original source content. The only argument is the url of the
 * original source file. Returns null if no original source content is
 * available.
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype.sourceContentFor = function IndexedSourceMapConsumer_sourceContentFor(aSource, nullOnMissing) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var content = section.consumer.sourceContentFor(aSource, true);
        if (content) return content;
    }
    if (nullOnMissing) return null;
    else throw new Error('"' + aSource + '" is not in the SourceMap.');
};
/**
 * Returns the generated line and column information for the original source,
 * line, and column positions provided. The only argument is an object with
 * the following properties:
 *
 *   - source: The filename of the original source.
 *   - line: The line number in the original source.  The line number
 *     is 1-based.
 *   - column: The column number in the original source.  The column
 *     number is 0-based.
 *
 * and an object is returned with the following properties:
 *
 *   - line: The line number in the generated source, or null.  The
 *     line number is 1-based. 
 *   - column: The column number in the generated source, or null.
 *     The column number is 0-based.
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype.generatedPositionFor = function IndexedSourceMapConsumer_generatedPositionFor(aArgs) {
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        // Only consider this section if the requested source is in the list of
        // sources of the consumer.
        if (section.consumer._findSourceIndex($jPinH.getArg(aArgs, 'source')) === -1) continue;
        var generatedPosition = section.consumer.generatedPositionFor(aArgs);
        if (generatedPosition) {
            var ret = {
                line: generatedPosition.line + (section.generatedOffset.generatedLine - 1),
                column: generatedPosition.column + (section.generatedOffset.generatedLine === generatedPosition.line ? section.generatedOffset.generatedColumn - 1 : 0)
            };
            return ret;
        }
    }
    return {
        line: null,
        column: null
    };
};
/**
 * Parse the mappings in a string in to a data structure which we can easily
 * query (the ordered arrays in the `this.__generatedMappings` and
 * `this.__originalMappings` properties).
 */ $9659751726d9a0d3$var$IndexedSourceMapConsumer.prototype._parseMappings = function IndexedSourceMapConsumer_parseMappings(aStr, aSourceRoot) {
    this.__generatedMappings = [];
    this.__originalMappings = [];
    for(var i = 0; i < this._sections.length; i++){
        var section = this._sections[i];
        var sectionMappings = section.consumer._generatedMappings;
        for(var j = 0; j < sectionMappings.length; j++){
            var mapping = sectionMappings[j];
            var source = section.consumer._sources.at(mapping.source);
            source = $jPinH.computeSourceURL(section.consumer.sourceRoot, source, this._sourceMapURL);
            this._sources.add(source);
            source = this._sources.indexOf(source);
            var name = null;
            if (mapping.name) {
                name = section.consumer._names.at(mapping.name);
                this._names.add(name);
                name = this._names.indexOf(name);
            }
            // The mappings coming from the consumer for the section have
            // generated positions relative to the start of the section, so we
            // need to offset them to be relative to the start of the concatenated
            // generated file.
            var adjustedMapping = {
                source: source,
                generatedLine: mapping.generatedLine + (section.generatedOffset.generatedLine - 1),
                generatedColumn: mapping.generatedColumn + (section.generatedOffset.generatedLine === mapping.generatedLine ? section.generatedOffset.generatedColumn - 1 : 0),
                originalLine: mapping.originalLine,
                originalColumn: mapping.originalColumn,
                name: name
            };
            this.__generatedMappings.push(adjustedMapping);
            if (typeof adjustedMapping.originalLine === 'number') this.__originalMappings.push(adjustedMapping);
        }
    }
    $9659751726d9a0d3$require$quickSort(this.__generatedMappings, $jPinH.compareByGeneratedPositionsDeflated);
    $9659751726d9a0d3$require$quickSort(this.__originalMappings, $jPinH.compareByOriginalPositions);
};
$9659751726d9a0d3$export$823525094e5b803c = $9659751726d9a0d3$var$IndexedSourceMapConsumer;

});
parcelRegister("4cMCc", function(module, exports) {

$parcel$export(module.exports, "GREATEST_LOWER_BOUND", () => $30fdfe62207e9899$export$4ecd616dce182dff, (v) => $30fdfe62207e9899$export$4ecd616dce182dff = v);
$parcel$export(module.exports, "LEAST_UPPER_BOUND", () => $30fdfe62207e9899$export$b99fbecff261243, (v) => $30fdfe62207e9899$export$b99fbecff261243 = v);
$parcel$export(module.exports, "search", () => $30fdfe62207e9899$export$d76128d007d19019, (v) => $30fdfe62207e9899$export$d76128d007d19019 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $30fdfe62207e9899$export$4ecd616dce182dff;
var $30fdfe62207e9899$export$b99fbecff261243;
/**
 * This is an implementation of binary search which will always try and return
 * the index of the closest element if there is no exact hit. This is because
 * mappings between original and generated line/col pairs are single points,
 * and there is an implicit region between each of them, so a miss just means
 * that you aren't on the very start of a region.
 *
 * @param aNeedle The element you are looking for.
 * @param aHaystack The array that is being searched.
 * @param aCompare A function which takes the needle and an element in the
 *     array and returns -1, 0, or 1 depending on whether the needle is less
 *     than, equal to, or greater than the element, respectively.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 *     Defaults to 'binarySearch.GREATEST_LOWER_BOUND'.
 */ var $30fdfe62207e9899$export$d76128d007d19019;
$30fdfe62207e9899$export$4ecd616dce182dff = 1;
$30fdfe62207e9899$export$b99fbecff261243 = 2;
/**
 * Recursive implementation of binary search.
 *
 * @param aLow Indices here and lower do not contain the needle.
 * @param aHigh Indices here and higher do not contain the needle.
 * @param aNeedle The element being searched for.
 * @param aHaystack The non-empty array being searched.
 * @param aCompare Function which takes two elements and returns -1, 0, or 1.
 * @param aBias Either 'binarySearch.GREATEST_LOWER_BOUND' or
 *     'binarySearch.LEAST_UPPER_BOUND'. Specifies whether to return the
 *     closest element that is smaller than or greater than the one we are
 *     searching for, respectively, if the exact element cannot be found.
 */ function $30fdfe62207e9899$var$recursiveSearch(aLow, aHigh, aNeedle, aHaystack, aCompare, aBias) {
    // This function terminates when one of the following is true:
    //
    //   1. We find the exact element we are looking for.
    //
    //   2. We did not find the exact element, but we can return the index of
    //      the next-closest element.
    //
    //   3. We did not find the exact element, and there is no next-closest
    //      element than the one we are searching for, so we return -1.
    var mid = Math.floor((aHigh - aLow) / 2) + aLow;
    var cmp = aCompare(aNeedle, aHaystack[mid], true);
    if (cmp === 0) // Found the element we are looking for.
    return mid;
    else if (cmp > 0) {
        // Our needle is greater than aHaystack[mid].
        if (aHigh - mid > 1) // The element is in the upper half.
        return $30fdfe62207e9899$var$recursiveSearch(mid, aHigh, aNeedle, aHaystack, aCompare, aBias);
        // The exact needle element was not found in this haystack. Determine if
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $30fdfe62207e9899$export$b99fbecff261243) return aHigh < aHaystack.length ? aHigh : -1;
        else return mid;
    } else {
        // Our needle is less than aHaystack[mid].
        if (mid - aLow > 1) // The element is in the lower half.
        return $30fdfe62207e9899$var$recursiveSearch(aLow, mid, aNeedle, aHaystack, aCompare, aBias);
        // we are in termination case (3) or (2) and return the appropriate thing.
        if (aBias == $30fdfe62207e9899$export$b99fbecff261243) return mid;
        else return aLow < 0 ? -1 : aLow;
    }
}
$30fdfe62207e9899$export$d76128d007d19019 = function search(aNeedle, aHaystack, aCompare, aBias) {
    if (aHaystack.length === 0) return -1;
    var index = $30fdfe62207e9899$var$recursiveSearch(-1, aHaystack.length, aNeedle, aHaystack, aCompare, aBias || $30fdfe62207e9899$export$4ecd616dce182dff);
    if (index < 0) return -1;
    // We have found either the exact element, or the next-closest element than
    // the one we are searching for. However, there may be more than one such
    // element. Make sure we always return the smallest of these.
    while(index - 1 >= 0){
        if (aCompare(aHaystack[index], aHaystack[index - 1], true) !== 0) break;
        --index;
    }
    return index;
};

});

parcelRegister("kCbM6", function(module, exports) {

$parcel$export(module.exports, "quickSort", () => $f0207d82356636ba$export$866270269b9544a5, (v) => $f0207d82356636ba$export$866270269b9544a5 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ // It turns out that some (most?) JavaScript engines don't self-host
// `Array.prototype.sort`. This makes sense because C++ will likely remain
// faster than JS when doing raw CPU-intensive sorting. However, when using a
// custom comparator function, calling back and forth between the VM's C++ and
// JIT'd JS is rather slow *and* loses JIT type information, resulting in
// worse generated code for the comparator function than would be optimal. In
// fact, when sorting with a comparator, these costs outweigh the benefits of
// sorting in C++. By using our own JS-implemented Quick Sort (below), we get
// a ~3500ms mean speed-up in `bench/bench.html`.
/**
 * Swap the elements indexed by `x` and `y` in the array `ary`.
 *
 * @param {Array} ary
 *        The array.
 * @param {Number} x
 *        The index of the first item.
 * @param {Number} y
 *        The index of the second item.
 */ /**
 * Sort the given array in-place with the given comparator function.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 */ var $f0207d82356636ba$export$866270269b9544a5;
function $f0207d82356636ba$var$swap(ary, x, y) {
    var temp = ary[x];
    ary[x] = ary[y];
    ary[y] = temp;
}
/**
 * Returns a random integer within the range `low .. high` inclusive.
 *
 * @param {Number} low
 *        The lower bound on the range.
 * @param {Number} high
 *        The upper bound on the range.
 */ function $f0207d82356636ba$var$randomIntInRange(low, high) {
    return Math.round(low + Math.random() * (high - low));
}
/**
 * The Quick Sort algorithm.
 *
 * @param {Array} ary
 *        An array to sort.
 * @param {function} comparator
 *        Function to use to compare two items.
 * @param {Number} p
 *        Start index of the array
 * @param {Number} r
 *        End index of the array
 */ function $f0207d82356636ba$var$doQuickSort(ary, comparator, p, r) {
    // If our lower bound is less than our upper bound, we (1) partition the
    // array into two pieces and (2) recurse on each half. If it is not, this is
    // the empty array and our base case.
    if (p < r) {
        // (1) Partitioning.
        //
        // The partitioning chooses a pivot between `p` and `r` and moves all
        // elements that are less than or equal to the pivot to the before it, and
        // all the elements that are greater than it after it. The effect is that
        // once partition is done, the pivot is in the exact place it will be when
        // the array is put in sorted order, and it will not need to be moved
        // again. This runs in O(n) time.
        // Always choose a random pivot so that an input array which is reverse
        // sorted does not cause O(n^2) running time.
        var pivotIndex = $f0207d82356636ba$var$randomIntInRange(p, r);
        var i = p - 1;
        $f0207d82356636ba$var$swap(ary, pivotIndex, r);
        var pivot = ary[r];
        // Immediately after `j` is incremented in this loop, the following hold
        // true:
        //
        //   * Every element in `ary[p .. i]` is less than or equal to the pivot.
        //
        //   * Every element in `ary[i+1 .. j-1]` is greater than the pivot.
        for(var j = p; j < r; j++)if (comparator(ary[j], pivot) <= 0) {
            i += 1;
            $f0207d82356636ba$var$swap(ary, i, j);
        }
        $f0207d82356636ba$var$swap(ary, i + 1, j);
        var q = i + 1;
        // (2) Recurse on each half.
        $f0207d82356636ba$var$doQuickSort(ary, comparator, p, q - 1);
        $f0207d82356636ba$var$doQuickSort(ary, comparator, q + 1, r);
    }
}
$f0207d82356636ba$export$866270269b9544a5 = function(ary, comparator) {
    $f0207d82356636ba$var$doQuickSort(ary, comparator, 0, ary.length - 1);
};

});


parcelRegister("2EjYD", function(module, exports) {

$parcel$export(module.exports, "SourceNode", () => $1eded031447e5869$export$7e987e8f375d24c2, (v) => $1eded031447e5869$export$7e987e8f375d24c2 = v);
/* -*- Mode: js; js-indent-level: 2; -*- */ /*
 * Copyright 2011 Mozilla Foundation and contributors
 * Licensed under the New BSD license. See LICENSE or:
 * http://opensource.org/licenses/BSD-3-Clause
 */ var $1eded031447e5869$export$7e987e8f375d24c2;

var $4p4SG = parcelRequire("4p4SG");
var $1eded031447e5869$require$SourceMapGenerator = $4p4SG.SourceMapGenerator;

var $jPinH = parcelRequire("jPinH");
// Matches a Windows-style `\r\n` newline or a `\n` newline used by all other
// operating systems these days (capturing the result).
var $1eded031447e5869$var$REGEX_NEWLINE = /(\r?\n)/;
// Newline character code for charCodeAt() comparisons
var $1eded031447e5869$var$NEWLINE_CODE = 10;
// Private symbol for identifying `SourceNode`s when multiple versions of
// the source-map library are loaded. This MUST NOT CHANGE across
// versions!
var $1eded031447e5869$var$isSourceNode = "$$$isSourceNode$$$";
/**
 * SourceNodes provide a way to abstract over interpolating/concatenating
 * snippets of generated JavaScript source code while maintaining the line and
 * column information associated with the original source code.
 *
 * @param aLine The original line number.
 * @param aColumn The original column number.
 * @param aSource The original source's filename.
 * @param aChunks Optional. An array of strings which are snippets of
 *        generated JS, or other SourceNodes.
 * @param aName The original identifier.
 */ function $1eded031447e5869$var$SourceNode(aLine, aColumn, aSource, aChunks, aName) {
    this.children = [];
    this.sourceContents = {};
    this.line = aLine == null ? null : aLine;
    this.column = aColumn == null ? null : aColumn;
    this.source = aSource == null ? null : aSource;
    this.name = aName == null ? null : aName;
    this[$1eded031447e5869$var$isSourceNode] = true;
    if (aChunks != null) this.add(aChunks);
}
/**
 * Creates a SourceNode from generated code and a SourceMapConsumer.
 *
 * @param aGeneratedCode The generated code
 * @param aSourceMapConsumer The SourceMap for the generated code
 * @param aRelativePath Optional. The path that relative sources in the
 *        SourceMapConsumer should be relative to.
 */ $1eded031447e5869$var$SourceNode.fromStringWithSourceMap = function SourceNode_fromStringWithSourceMap(aGeneratedCode, aSourceMapConsumer, aRelativePath) {
    // The SourceNode we want to fill with the generated code
    // and the SourceMap
    var node = new $1eded031447e5869$var$SourceNode();
    // All even indices of this array are one line of the generated code,
    // while all odd indices are the newlines between two adjacent lines
    // (since `REGEX_NEWLINE` captures its match).
    // Processed fragments are accessed by calling `shiftNextLine`.
    var remainingLines = aGeneratedCode.split($1eded031447e5869$var$REGEX_NEWLINE);
    var remainingLinesIndex = 0;
    var shiftNextLine = function() {
        var lineContents = getNextLine();
        // The last line of a file might not have a newline.
        var newLine = getNextLine() || "";
        return lineContents + newLine;
        function getNextLine() {
            return remainingLinesIndex < remainingLines.length ? remainingLines[remainingLinesIndex++] : undefined;
        }
    };
    // We need to remember the position of "remainingLines"
    var lastGeneratedLine = 1, lastGeneratedColumn = 0;
    // The generate SourceNodes we need a code range.
    // To extract it current and last mapping is used.
    // Here we store the last mapping.
    var lastMapping = null;
    aSourceMapConsumer.eachMapping(function(mapping) {
        if (lastMapping !== null) {
            // We add the code from "lastMapping" to "mapping":
            // First check if there is a new line in between.
            if (lastGeneratedLine < mapping.generatedLine) {
                // Associate first line with "lastMapping"
                addMappingWithCode(lastMapping, shiftNextLine());
                lastGeneratedLine++;
                lastGeneratedColumn = 0;
            // The remaining code is added without mapping
            } else {
                // There is no new line in between.
                // Associate the code between "lastGeneratedColumn" and
                // "mapping.generatedColumn" with "lastMapping"
                var nextLine = remainingLines[remainingLinesIndex] || '';
                var code = nextLine.substr(0, mapping.generatedColumn - lastGeneratedColumn);
                remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn - lastGeneratedColumn);
                lastGeneratedColumn = mapping.generatedColumn;
                addMappingWithCode(lastMapping, code);
                // No more remaining code, continue
                lastMapping = mapping;
                return;
            }
        }
        // We add the generated code until the first mapping
        // to the SourceNode without any mapping.
        // Each line is added as separate string.
        while(lastGeneratedLine < mapping.generatedLine){
            node.add(shiftNextLine());
            lastGeneratedLine++;
        }
        if (lastGeneratedColumn < mapping.generatedColumn) {
            var nextLine = remainingLines[remainingLinesIndex] || '';
            node.add(nextLine.substr(0, mapping.generatedColumn));
            remainingLines[remainingLinesIndex] = nextLine.substr(mapping.generatedColumn);
            lastGeneratedColumn = mapping.generatedColumn;
        }
        lastMapping = mapping;
    }, this);
    // We have processed all mappings.
    if (remainingLinesIndex < remainingLines.length) {
        if (lastMapping) // Associate the remaining code in the current line with "lastMapping"
        addMappingWithCode(lastMapping, shiftNextLine());
        // and add the remaining lines without any mapping
        node.add(remainingLines.splice(remainingLinesIndex).join(""));
    }
    // Copy sourcesContent into SourceNode
    aSourceMapConsumer.sources.forEach(function(sourceFile) {
        var content = aSourceMapConsumer.sourceContentFor(sourceFile);
        if (content != null) {
            if (aRelativePath != null) sourceFile = $jPinH.join(aRelativePath, sourceFile);
            node.setSourceContent(sourceFile, content);
        }
    });
    return node;
    function addMappingWithCode(mapping, code) {
        if (mapping === null || mapping.source === undefined) node.add(code);
        else {
            var source = aRelativePath ? $jPinH.join(aRelativePath, mapping.source) : mapping.source;
            node.add(new $1eded031447e5869$var$SourceNode(mapping.originalLine, mapping.originalColumn, source, code, mapping.name));
        }
    }
};
/**
 * Add a chunk of generated JS to this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $1eded031447e5869$var$SourceNode.prototype.add = function SourceNode_add(aChunk) {
    if (Array.isArray(aChunk)) aChunk.forEach(function(chunk) {
        this.add(chunk);
    }, this);
    else if (aChunk[$1eded031447e5869$var$isSourceNode] || typeof aChunk === "string") {
        if (aChunk) this.children.push(aChunk);
    } else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Add a chunk of generated JS to the beginning of this source node.
 *
 * @param aChunk A string snippet of generated JS code, another instance of
 *        SourceNode, or an array where each member is one of those things.
 */ $1eded031447e5869$var$SourceNode.prototype.prepend = function SourceNode_prepend(aChunk) {
    if (Array.isArray(aChunk)) for(var i = aChunk.length - 1; i >= 0; i--)this.prepend(aChunk[i]);
    else if (aChunk[$1eded031447e5869$var$isSourceNode] || typeof aChunk === "string") this.children.unshift(aChunk);
    else throw new TypeError("Expected a SourceNode, string, or an array of SourceNodes and strings. Got " + aChunk);
    return this;
};
/**
 * Walk over the tree of JS snippets in this node and its children. The
 * walking function is called once for each snippet of JS and is passed that
 * snippet and the its original associated source's line/column location.
 *
 * @param aFn The traversal function.
 */ $1eded031447e5869$var$SourceNode.prototype.walk = function SourceNode_walk(aFn) {
    var chunk;
    for(var i = 0, len = this.children.length; i < len; i++){
        chunk = this.children[i];
        if (chunk[$1eded031447e5869$var$isSourceNode]) chunk.walk(aFn);
        else if (chunk !== '') aFn(chunk, {
            source: this.source,
            line: this.line,
            column: this.column,
            name: this.name
        });
    }
};
/**
 * Like `String.prototype.join` except for SourceNodes. Inserts `aStr` between
 * each of `this.children`.
 *
 * @param aSep The separator.
 */ $1eded031447e5869$var$SourceNode.prototype.join = function SourceNode_join(aSep) {
    var newChildren;
    var i;
    var len = this.children.length;
    if (len > 0) {
        newChildren = [];
        for(i = 0; i < len - 1; i++){
            newChildren.push(this.children[i]);
            newChildren.push(aSep);
        }
        newChildren.push(this.children[i]);
        this.children = newChildren;
    }
    return this;
};
/**
 * Call String.prototype.replace on the very right-most source snippet. Useful
 * for trimming whitespace from the end of a source node, etc.
 *
 * @param aPattern The pattern to replace.
 * @param aReplacement The thing to replace the pattern with.
 */ $1eded031447e5869$var$SourceNode.prototype.replaceRight = function SourceNode_replaceRight(aPattern, aReplacement) {
    var lastChild = this.children[this.children.length - 1];
    if (lastChild[$1eded031447e5869$var$isSourceNode]) lastChild.replaceRight(aPattern, aReplacement);
    else if (typeof lastChild === 'string') this.children[this.children.length - 1] = lastChild.replace(aPattern, aReplacement);
    else this.children.push(''.replace(aPattern, aReplacement));
    return this;
};
/**
 * Set the source content for a source file. This will be added to the SourceMapGenerator
 * in the sourcesContent field.
 *
 * @param aSourceFile The filename of the source file
 * @param aSourceContent The content of the source file
 */ $1eded031447e5869$var$SourceNode.prototype.setSourceContent = function SourceNode_setSourceContent(aSourceFile, aSourceContent) {
    this.sourceContents[$jPinH.toSetString(aSourceFile)] = aSourceContent;
};
/**
 * Walk over the tree of SourceNodes. The walking function is called for each
 * source file content and is passed the filename and source content.
 *
 * @param aFn The traversal function.
 */ $1eded031447e5869$var$SourceNode.prototype.walkSourceContents = function SourceNode_walkSourceContents(aFn) {
    for(var i = 0, len = this.children.length; i < len; i++)if (this.children[i][$1eded031447e5869$var$isSourceNode]) this.children[i].walkSourceContents(aFn);
    var sources = Object.keys(this.sourceContents);
    for(var i = 0, len = sources.length; i < len; i++)aFn($jPinH.fromSetString(sources[i]), this.sourceContents[sources[i]]);
};
/**
 * Return the string representation of this source node. Walks over the tree
 * and concatenates all the various snippets together to one string.
 */ $1eded031447e5869$var$SourceNode.prototype.toString = function SourceNode_toString() {
    var str = "";
    this.walk(function(chunk) {
        str += chunk;
    });
    return str;
};
/**
 * Returns the string representation of this source node along with a source
 * map.
 */ $1eded031447e5869$var$SourceNode.prototype.toStringWithSourceMap = function SourceNode_toStringWithSourceMap(aArgs) {
    var generated = {
        code: "",
        line: 1,
        column: 0
    };
    var map = new $1eded031447e5869$require$SourceMapGenerator(aArgs);
    var sourceMappingActive = false;
    var lastOriginalSource = null;
    var lastOriginalLine = null;
    var lastOriginalColumn = null;
    var lastOriginalName = null;
    this.walk(function(chunk, original) {
        generated.code += chunk;
        if (original.source !== null && original.line !== null && original.column !== null) {
            if (lastOriginalSource !== original.source || lastOriginalLine !== original.line || lastOriginalColumn !== original.column || lastOriginalName !== original.name) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
            lastOriginalSource = original.source;
            lastOriginalLine = original.line;
            lastOriginalColumn = original.column;
            lastOriginalName = original.name;
            sourceMappingActive = true;
        } else if (sourceMappingActive) {
            map.addMapping({
                generated: {
                    line: generated.line,
                    column: generated.column
                }
            });
            lastOriginalSource = null;
            sourceMappingActive = false;
        }
        for(var idx = 0, length = chunk.length; idx < length; idx++)if (chunk.charCodeAt(idx) === $1eded031447e5869$var$NEWLINE_CODE) {
            generated.line++;
            generated.column = 0;
            // Mappings end at eol
            if (idx + 1 === length) {
                lastOriginalSource = null;
                sourceMappingActive = false;
            } else if (sourceMappingActive) map.addMapping({
                source: original.source,
                original: {
                    line: original.line,
                    column: original.column
                },
                generated: {
                    line: generated.line,
                    column: generated.column
                },
                name: original.name
            });
        } else generated.column++;
    });
    this.walkSourceContents(function(sourceFile, sourceContent) {
        map.setSourceContent(sourceFile, sourceContent);
    });
    return {
        code: generated.code,
        map: map
    };
};
$1eded031447e5869$export$7e987e8f375d24c2 = $1eded031447e5869$var$SourceNode;

});


parcelRegister("5Q3m3", function(module, exports) {

$parcel$export(module.exports, "initSignin", () => $4404694602f4231f$export$8576e273b960e4f);
$parcel$export(module.exports, "showSignInFlyout", () => $4404694602f4231f$export$a6a16dcf7d3647e8);

var $iouPm = parcelRequire("iouPm");

var $9zaOw = parcelRequire("9zaOw");

var $bWUN0 = parcelRequire("bWUN0");

var $8cF6f = parcelRequire("8cF6f");
function $4404694602f4231f$export$8576e273b960e4f() {
    const flyout = document.querySelector('[data-flyout="SignInForm"]');
    if (!flyout) return;
    const emailInput = flyout.querySelector("#signin-email");
    const passwordInput = flyout.querySelector("#signin-password");
    const eyeIcon = flyout.querySelector(".signin-flyout__eye-icon");
    const submitButton = flyout.querySelector('button[type="submit"]');
    eyeIcon?.addEventListener("click", ()=>{
        const isPassword = passwordInput.type === "password";
        passwordInput.type = isPassword ? "text" : "password";
        eyeIcon.alt = isPassword ? "Hide password" : "Show password";
        eyeIcon.src = isPassword ? "/images/eye-icon-hide.svg" : "/images/eye-icon.svg";
    });
    const toggleSubmitState = ()=>{
        const emailFilled = emailInput?.value.trim().length > 0;
        const passwordFilled = passwordInput?.value.trim().length > 0;
        submitButton.disabled = !(emailFilled && passwordFilled);
    };
    emailInput?.addEventListener("input", ()=>{
        clearError(emailInput);
        toggleSubmitState();
    });
    passwordInput?.addEventListener("input", ()=>{
        clearError(passwordInput);
        toggleSubmitState();
    });
    function showError(field, message) {
        if (!field) return;
        field.classList.add("error");
        const errorEl = flyout.querySelector(`.error-message[data-error-for="${field.id}"]`);
        if (errorEl) {
            errorEl.textContent = message;
            errorEl.classList.add("visible");
        }
    }
    function clearError(field) {
        if (!field) return;
        field.classList.remove("error");
        const errorEl = flyout.querySelector(`.error-message[data-error-for="${field.id}"]`);
        if (errorEl) {
            errorEl.textContent = "";
            errorEl.classList.remove("visible");
        }
    }
    flyout.querySelector("form")?.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const email = emailInput?.value.trim();
        const password = passwordInput?.value.trim();
        clearError(emailInput);
        clearError(passwordInput);
        let valid = true;
        if (!email) {
            showError(emailInput, "Email is required.");
            valid = false;
        } else {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                showError(emailInput, "Please enter a valid email address.");
                valid = false;
            }
        }
        if (!password) {
            showError(passwordInput, "Password is required.");
            valid = false;
        }
        if (!valid) return;
        submitButton.disabled = true;
        submitButton.textContent = "Signing In...";
        try {
            const payload = {
                username: email,
                password: password
            };
            const response = await fetch("/api/Accounts/SignIn", {
                method: "POST",
                credentials: "include",
                headers: await (0, $iouPm.getHeadersWithToken)({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                // GTM: Track successful login
                (0, $bWUN0.pushEvent)({
                    'event': 'formSubmission',
                    'formID': 'login'
                });
                (0, $9zaOw.FlyoutManager).close("SignInForm");
                // notify other components that the user signed in so that they can react,
                // the header specifically uses this
                (0, $iouPm.invalidateTokenCache)(); // the xsrf token needs to be refreshed after sign in/out
                document.dispatchEvent(new Event('mm.signedIn'));
            } else {
                const rawText = await response.text();
                console.warn("Raw error response text:", rawText);
                try {
                    const result = JSON.parse(rawText);
                    console.warn("Parsed sign-in error response:", result);
                    if (result.errors) {
                        if (result.errors.username) showError(emailInput, result.errors.username.join(" "));
                        if (result.errors.password) showError(passwordInput, result.errors.password.join(" "));
                        if (!result.errors.username && !result.errors.password && result.message) (0, $8cF6f.showToast)(result.message, 'error');
                    } else if (result.message) (0, $8cF6f.showToast)(result.message, 'error');
                    else (0, $8cF6f.showToast)("Invalid email or password. Please try again.", 'error');
                } catch (jsonErr) {
                    console.error("Could not parse error response as JSON:", jsonErr);
                    (0, $8cF6f.showToast)("An unexpected error occurred. Please try again.", 'error');
                }
            }
        } catch (err) {
            console.error("Sign-in error:", err);
            (0, $8cF6f.showToast)("Something went wrong. Please try again.", 'error');
        } finally{
            submitButton.disabled = false;
            submitButton.textContent = "Sign In";
        }
    });
}
function $4404694602f4231f$export$a6a16dcf7d3647e8() {
    (0, $9zaOw.FlyoutManager).open("SignInForm");
}

});
parcelRegister("bWUN0", function(module, exports) {

$parcel$export(module.exports, "pushEvent", () => $8b3129b0e2adbfa4$export$8a2526708127299c);
function $8b3129b0e2adbfa4$export$8a2526708127299c(event) {
    console.debug('pushEvent', event);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
}
if (typeof window !== 'undefined') {
    window.mannington = window.mannington || {};
    window.mannington.pushEvent = $8b3129b0e2adbfa4$export$8a2526708127299c;
}

});


parcelRegister("1srIE", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6gD8s"));

});
parcelRegister("6gD8s", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $4902982a9feaa9a9$export$ffb0004e005737fa, (v) => $4902982a9feaa9a9$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $4902982a9feaa9a9$export$34b9dba7ce09269b, (v) => $4902982a9feaa9a9$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $4902982a9feaa9a9$export$25062201e9e25d76, (v) => $4902982a9feaa9a9$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4902982a9feaa9a9$export$ffb0004e005737fa;
var $4902982a9feaa9a9$export$34b9dba7ce09269b;
var $4902982a9feaa9a9$export$25062201e9e25d76;
"use strict";
var $4902982a9feaa9a9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $4902982a9feaa9a9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $4902982a9feaa9a9$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $4902982a9feaa9a9$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$4902982a9feaa9a9$export$ffb0004e005737fa = $4902982a9feaa9a9$var$REACT_FRAGMENT_TYPE;
$4902982a9feaa9a9$export$34b9dba7ce09269b = $4902982a9feaa9a9$var$jsxProd;
$4902982a9feaa9a9$export$25062201e9e25d76 = $4902982a9feaa9a9$var$jsxProd;

});


parcelRegister("6PIFj", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hKPLf"));

});
parcelRegister("hKPLf", function(module, exports) {

$parcel$export(module.exports, "Children", () => $cecee23ae7875ab3$export$dca3b0875bd9a954, (v) => $cecee23ae7875ab3$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $cecee23ae7875ab3$export$16fa2f45be04daa8, (v) => $cecee23ae7875ab3$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $cecee23ae7875ab3$export$ffb0004e005737fa, (v) => $cecee23ae7875ab3$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $cecee23ae7875ab3$export$e2c29f18771995cb, (v) => $cecee23ae7875ab3$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $cecee23ae7875ab3$export$221d75b3f55bb0bd, (v) => $cecee23ae7875ab3$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $cecee23ae7875ab3$export$5f8d39834fd61797, (v) => $cecee23ae7875ab3$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $cecee23ae7875ab3$export$74bf444e3cd11ea5, (v) => $cecee23ae7875ab3$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $cecee23ae7875ab3$export$1ced07cd6b1985ce, (v) => $cecee23ae7875ab3$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $cecee23ae7875ab3$export$abd8e32b826d7ea7, (v) => $cecee23ae7875ab3$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $cecee23ae7875ab3$export$69a3209f1a06c04d, (v) => $cecee23ae7875ab3$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $cecee23ae7875ab3$export$e530037191fcd5d7, (v) => $cecee23ae7875ab3$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $cecee23ae7875ab3$export$fd42f52fd3ae1109, (v) => $cecee23ae7875ab3$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $cecee23ae7875ab3$export$c8a8987d4410bf2d, (v) => $cecee23ae7875ab3$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $cecee23ae7875ab3$export$7d1e3a5e95ceca43, (v) => $cecee23ae7875ab3$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $cecee23ae7875ab3$export$257a8862b851cb5b, (v) => $cecee23ae7875ab3$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $cecee23ae7875ab3$export$a8257692ac88316c, (v) => $cecee23ae7875ab3$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $cecee23ae7875ab3$export$488013bae63b21da, (v) => $cecee23ae7875ab3$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $cecee23ae7875ab3$export$7c73462e0d25e514, (v) => $cecee23ae7875ab3$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $cecee23ae7875ab3$export$7568632d0d33d16d, (v) => $cecee23ae7875ab3$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $cecee23ae7875ab3$export$f93f40ac0ca7e3a8, (v) => $cecee23ae7875ab3$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $cecee23ae7875ab3$export$1f96ae73734a86cc, (v) => $cecee23ae7875ab3$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $cecee23ae7875ab3$export$9a47ced3238df325, (v) => $cecee23ae7875ab3$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $cecee23ae7875ab3$export$35808ee640e87ca7, (v) => $cecee23ae7875ab3$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $cecee23ae7875ab3$export$fae74005e78b1a27, (v) => $cecee23ae7875ab3$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $cecee23ae7875ab3$export$dc8fbce3eb94dc1e, (v) => $cecee23ae7875ab3$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $cecee23ae7875ab3$export$6a7bc4e911dc01cf, (v) => $cecee23ae7875ab3$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $cecee23ae7875ab3$export$6d9c69b0de29b591, (v) => $cecee23ae7875ab3$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $cecee23ae7875ab3$export$f680877a34711e37, (v) => $cecee23ae7875ab3$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $cecee23ae7875ab3$export$d5a552a76deda3c2, (v) => $cecee23ae7875ab3$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $cecee23ae7875ab3$export$aaabe4eda9ed9969, (v) => $cecee23ae7875ab3$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $cecee23ae7875ab3$export$e5c5a5f917a5871c, (v) => $cecee23ae7875ab3$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $cecee23ae7875ab3$export$1538c33de8887b59, (v) => $cecee23ae7875ab3$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $cecee23ae7875ab3$export$fca7f784ae7a249a, (v) => $cecee23ae7875ab3$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $cecee23ae7875ab3$export$13e3392192263954, (v) => $cecee23ae7875ab3$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $cecee23ae7875ab3$export$b8f5890fc79d6aca, (v) => $cecee23ae7875ab3$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $cecee23ae7875ab3$export$60241385465d0a34, (v) => $cecee23ae7875ab3$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $cecee23ae7875ab3$export$306c0aa65ff9ec16, (v) => $cecee23ae7875ab3$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $cecee23ae7875ab3$export$7b286972b8d8ccbf, (v) => $cecee23ae7875ab3$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $cecee23ae7875ab3$export$83d89fbfd8236492, (v) => $cecee23ae7875ab3$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cecee23ae7875ab3$export$dca3b0875bd9a954;
var $cecee23ae7875ab3$export$16fa2f45be04daa8;
var $cecee23ae7875ab3$export$ffb0004e005737fa;
var $cecee23ae7875ab3$export$e2c29f18771995cb;
var $cecee23ae7875ab3$export$221d75b3f55bb0bd;
var $cecee23ae7875ab3$export$5f8d39834fd61797;
var $cecee23ae7875ab3$export$74bf444e3cd11ea5;
var $cecee23ae7875ab3$export$1ced07cd6b1985ce;
var $cecee23ae7875ab3$export$abd8e32b826d7ea7;
var $cecee23ae7875ab3$export$69a3209f1a06c04d;
var $cecee23ae7875ab3$export$e530037191fcd5d7;
var $cecee23ae7875ab3$export$fd42f52fd3ae1109;
var $cecee23ae7875ab3$export$c8a8987d4410bf2d;
var $cecee23ae7875ab3$export$7d1e3a5e95ceca43;
var $cecee23ae7875ab3$export$257a8862b851cb5b;
var $cecee23ae7875ab3$export$a8257692ac88316c;
var $cecee23ae7875ab3$export$488013bae63b21da;
var $cecee23ae7875ab3$export$7c73462e0d25e514;
var $cecee23ae7875ab3$export$7568632d0d33d16d;
var $cecee23ae7875ab3$export$f93f40ac0ca7e3a8;
var $cecee23ae7875ab3$export$1f96ae73734a86cc;
var $cecee23ae7875ab3$export$9a47ced3238df325;
var $cecee23ae7875ab3$export$35808ee640e87ca7;
var $cecee23ae7875ab3$export$fae74005e78b1a27;
var $cecee23ae7875ab3$export$dc8fbce3eb94dc1e;
var $cecee23ae7875ab3$export$6a7bc4e911dc01cf;
var $cecee23ae7875ab3$export$6d9c69b0de29b591;
var $cecee23ae7875ab3$export$f680877a34711e37;
var $cecee23ae7875ab3$export$d5a552a76deda3c2;
var $cecee23ae7875ab3$export$aaabe4eda9ed9969;
var $cecee23ae7875ab3$export$e5c5a5f917a5871c;
var $cecee23ae7875ab3$export$1538c33de8887b59;
var $cecee23ae7875ab3$export$fca7f784ae7a249a;
var $cecee23ae7875ab3$export$13e3392192263954;
var $cecee23ae7875ab3$export$b8f5890fc79d6aca;
var $cecee23ae7875ab3$export$60241385465d0a34;
var $cecee23ae7875ab3$export$306c0aa65ff9ec16;
var $cecee23ae7875ab3$export$7b286972b8d8ccbf;
var $cecee23ae7875ab3$export$83d89fbfd8236492;
"use strict";
var $cecee23ae7875ab3$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $cecee23ae7875ab3$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $cecee23ae7875ab3$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $cecee23ae7875ab3$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $cecee23ae7875ab3$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $cecee23ae7875ab3$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $cecee23ae7875ab3$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $cecee23ae7875ab3$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $cecee23ae7875ab3$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $cecee23ae7875ab3$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $cecee23ae7875ab3$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $cecee23ae7875ab3$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $cecee23ae7875ab3$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $cecee23ae7875ab3$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$cecee23ae7875ab3$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $cecee23ae7875ab3$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $cecee23ae7875ab3$var$assign = Object.assign, $cecee23ae7875ab3$var$emptyObject = {};
function $cecee23ae7875ab3$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $cecee23ae7875ab3$var$emptyObject;
    this.updater = updater || $cecee23ae7875ab3$var$ReactNoopUpdateQueue;
}
$cecee23ae7875ab3$var$Component.prototype.isReactComponent = {};
$cecee23ae7875ab3$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$cecee23ae7875ab3$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $cecee23ae7875ab3$var$ComponentDummy() {}
$cecee23ae7875ab3$var$ComponentDummy.prototype = $cecee23ae7875ab3$var$Component.prototype;
function $cecee23ae7875ab3$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $cecee23ae7875ab3$var$emptyObject;
    this.updater = updater || $cecee23ae7875ab3$var$ReactNoopUpdateQueue;
}
var $cecee23ae7875ab3$var$pureComponentPrototype = $cecee23ae7875ab3$var$PureComponent.prototype = new $cecee23ae7875ab3$var$ComponentDummy();
$cecee23ae7875ab3$var$pureComponentPrototype.constructor = $cecee23ae7875ab3$var$PureComponent;
$cecee23ae7875ab3$var$assign($cecee23ae7875ab3$var$pureComponentPrototype, $cecee23ae7875ab3$var$Component.prototype);
$cecee23ae7875ab3$var$pureComponentPrototype.isPureReactComponent = !0;
var $cecee23ae7875ab3$var$isArrayImpl = Array.isArray, $cecee23ae7875ab3$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $cecee23ae7875ab3$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $cecee23ae7875ab3$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $cecee23ae7875ab3$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $cecee23ae7875ab3$var$cloneAndReplaceKey(oldElement, newKey) {
    return $cecee23ae7875ab3$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $cecee23ae7875ab3$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $cecee23ae7875ab3$var$REACT_ELEMENT_TYPE;
}
function $cecee23ae7875ab3$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $cecee23ae7875ab3$var$userProvidedKeyEscapeRegex = /\/+/g;
function $cecee23ae7875ab3$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $cecee23ae7875ab3$var$escape("" + element.key) : index.toString(36);
}
function $cecee23ae7875ab3$var$noop$1() {}
function $cecee23ae7875ab3$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($cecee23ae7875ab3$var$noop$1, $cecee23ae7875ab3$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $cecee23ae7875ab3$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $cecee23ae7875ab3$var$REACT_ELEMENT_TYPE:
                case $cecee23ae7875ab3$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $cecee23ae7875ab3$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $cecee23ae7875ab3$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $cecee23ae7875ab3$var$getElementKey(children, 0) : nameSoFar, $cecee23ae7875ab3$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($cecee23ae7875ab3$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $cecee23ae7875ab3$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($cecee23ae7875ab3$var$isValidElement(callback) && (callback = $cecee23ae7875ab3$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($cecee23ae7875ab3$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($cecee23ae7875ab3$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $cecee23ae7875ab3$var$getElementKey(nameSoFar, i), invokeCallback += $cecee23ae7875ab3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $cecee23ae7875ab3$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $cecee23ae7875ab3$var$getElementKey(nameSoFar, i++), invokeCallback += $cecee23ae7875ab3$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $cecee23ae7875ab3$var$mapIntoArray($cecee23ae7875ab3$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $cecee23ae7875ab3$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $cecee23ae7875ab3$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $cecee23ae7875ab3$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $cecee23ae7875ab3$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $cecee23ae7875ab3$var$noop() {}
$cecee23ae7875ab3$export$dca3b0875bd9a954 = {
    map: $cecee23ae7875ab3$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $cecee23ae7875ab3$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $cecee23ae7875ab3$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $cecee23ae7875ab3$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$cecee23ae7875ab3$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$cecee23ae7875ab3$export$16fa2f45be04daa8 = $cecee23ae7875ab3$var$Component;
$cecee23ae7875ab3$export$ffb0004e005737fa = $cecee23ae7875ab3$var$REACT_FRAGMENT_TYPE;
$cecee23ae7875ab3$export$e2c29f18771995cb = $cecee23ae7875ab3$var$REACT_PROFILER_TYPE;
$cecee23ae7875ab3$export$221d75b3f55bb0bd = $cecee23ae7875ab3$var$PureComponent;
$cecee23ae7875ab3$export$5f8d39834fd61797 = $cecee23ae7875ab3$var$REACT_STRICT_MODE_TYPE;
$cecee23ae7875ab3$export$74bf444e3cd11ea5 = $cecee23ae7875ab3$var$REACT_SUSPENSE_TYPE;
$cecee23ae7875ab3$export$1ced07cd6b1985ce = $cecee23ae7875ab3$var$ReactSharedInternals;
$cecee23ae7875ab3$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $cecee23ae7875ab3$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$cecee23ae7875ab3$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$cecee23ae7875ab3$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $cecee23ae7875ab3$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$cecee23ae7875ab3$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $cecee23ae7875ab3$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$cecee23ae7875ab3$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $cecee23ae7875ab3$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $cecee23ae7875ab3$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$cecee23ae7875ab3$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$cecee23ae7875ab3$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $cecee23ae7875ab3$var$ReactElement(type, key, void 0, void 0, null, props);
};
$cecee23ae7875ab3$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$cecee23ae7875ab3$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $cecee23ae7875ab3$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$cecee23ae7875ab3$export$a8257692ac88316c = $cecee23ae7875ab3$var$isValidElement;
$cecee23ae7875ab3$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $cecee23ae7875ab3$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $cecee23ae7875ab3$var$lazyInitializer
    };
};
$cecee23ae7875ab3$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $cecee23ae7875ab3$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$cecee23ae7875ab3$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $cecee23ae7875ab3$var$ReactSharedInternals.T, currentTransition = {};
    $cecee23ae7875ab3$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $cecee23ae7875ab3$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($cecee23ae7875ab3$var$noop, $cecee23ae7875ab3$var$reportGlobalError);
    } catch (error) {
        $cecee23ae7875ab3$var$reportGlobalError(error);
    } finally{
        $cecee23ae7875ab3$var$ReactSharedInternals.T = prevTransition;
    }
};
$cecee23ae7875ab3$export$f93f40ac0ca7e3a8 = function() {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useCacheRefresh();
};
$cecee23ae7875ab3$export$1f96ae73734a86cc = function(usable) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.use(usable);
};
$cecee23ae7875ab3$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$cecee23ae7875ab3$export$35808ee640e87ca7 = function(callback, deps) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$cecee23ae7875ab3$export$fae74005e78b1a27 = function(Context) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useContext(Context);
};
$cecee23ae7875ab3$export$dc8fbce3eb94dc1e = function() {};
$cecee23ae7875ab3$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$cecee23ae7875ab3$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $cecee23ae7875ab3$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$cecee23ae7875ab3$export$f680877a34711e37 = function() {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useId();
};
$cecee23ae7875ab3$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$cecee23ae7875ab3$export$aaabe4eda9ed9969 = function(create, deps) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$cecee23ae7875ab3$export$e5c5a5f917a5871c = function(create, deps) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$cecee23ae7875ab3$export$1538c33de8887b59 = function(create, deps) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useMemo(create, deps);
};
$cecee23ae7875ab3$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$cecee23ae7875ab3$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$cecee23ae7875ab3$export$b8f5890fc79d6aca = function(initialValue) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useRef(initialValue);
};
$cecee23ae7875ab3$export$60241385465d0a34 = function(initialState) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useState(initialState);
};
$cecee23ae7875ab3$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$cecee23ae7875ab3$export$7b286972b8d8ccbf = function() {
    return $cecee23ae7875ab3$var$ReactSharedInternals.H.useTransition();
};
$cecee23ae7875ab3$export$83d89fbfd8236492 = "19.1.1";

});


parcelRegister("2kmti", function(module, exports) {
'use strict';
function $1b1ee16680c08e64$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($1b1ee16680c08e64$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$1b1ee16680c08e64$var$checkDCE();

module.exports = (parcelRequire("iiKN9"));

});
parcelRegister("iiKN9", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $d52e344c7cd7d393$export$882461b6382ed46c, (v) => $d52e344c7cd7d393$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $d52e344c7cd7d393$export$757ceba2d55c277e, (v) => $d52e344c7cd7d393$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $d52e344c7cd7d393$export$83d89fbfd8236492, (v) => $d52e344c7cd7d393$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $d52e344c7cd7d393$export$882461b6382ed46c;
var $d52e344c7cd7d393$export$757ceba2d55c277e;
var $d52e344c7cd7d393$export$83d89fbfd8236492;
"use strict";

var $aXDU1 = parcelRequire("aXDU1");

var $6PIFj = parcelRequire("6PIFj");

var $8GGcu = parcelRequire("8GGcu");
function $d52e344c7cd7d393$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $d52e344c7cd7d393$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $d52e344c7cd7d393$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $d52e344c7cd7d393$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $d52e344c7cd7d393$var$assertIsMounted(fiber) {
    if ($d52e344c7cd7d393$var$getNearestMountedFiber(fiber) !== fiber) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(188));
}
function $d52e344c7cd7d393$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $d52e344c7cd7d393$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $d52e344c7cd7d393$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $d52e344c7cd7d393$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $d52e344c7cd7d393$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $d52e344c7cd7d393$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $d52e344c7cd7d393$var$assign = Object.assign, $d52e344c7cd7d393$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $d52e344c7cd7d393$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d52e344c7cd7d393$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d52e344c7cd7d393$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d52e344c7cd7d393$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d52e344c7cd7d393$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $d52e344c7cd7d393$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d52e344c7cd7d393$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d52e344c7cd7d393$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d52e344c7cd7d393$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d52e344c7cd7d393$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d52e344c7cd7d393$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $d52e344c7cd7d393$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $d52e344c7cd7d393$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $d52e344c7cd7d393$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $d52e344c7cd7d393$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $d52e344c7cd7d393$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$d52e344c7cd7d393$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $d52e344c7cd7d393$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d52e344c7cd7d393$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $d52e344c7cd7d393$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $d52e344c7cd7d393$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $d52e344c7cd7d393$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $d52e344c7cd7d393$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $d52e344c7cd7d393$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $d52e344c7cd7d393$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $d52e344c7cd7d393$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $d52e344c7cd7d393$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $d52e344c7cd7d393$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $d52e344c7cd7d393$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $d52e344c7cd7d393$var$getComponentNameFromType(type.type) || "Memo";
        case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $d52e344c7cd7d393$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $d52e344c7cd7d393$var$isArrayImpl = Array.isArray, $d52e344c7cd7d393$var$ReactSharedInternals = $6PIFj.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d52e344c7cd7d393$var$ReactDOMSharedInternals = $8GGcu.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $d52e344c7cd7d393$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $d52e344c7cd7d393$var$valueStack = [], $d52e344c7cd7d393$var$index = -1;
function $d52e344c7cd7d393$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $d52e344c7cd7d393$var$pop(cursor) {
    0 > $d52e344c7cd7d393$var$index || (cursor.current = $d52e344c7cd7d393$var$valueStack[$d52e344c7cd7d393$var$index], $d52e344c7cd7d393$var$valueStack[$d52e344c7cd7d393$var$index] = null, $d52e344c7cd7d393$var$index--);
}
function $d52e344c7cd7d393$var$push(cursor, value) {
    $d52e344c7cd7d393$var$index++;
    $d52e344c7cd7d393$var$valueStack[$d52e344c7cd7d393$var$index] = cursor.current;
    cursor.current = value;
}
var $d52e344c7cd7d393$var$contextStackCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$contextFiberStackCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$rootInstanceStackCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$hostTransitionProviderCursor = $d52e344c7cd7d393$var$createCursor(null);
function $d52e344c7cd7d393$var$pushHostContainer(fiber, nextRootInstance) {
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$rootInstanceStackCursor, nextRootInstance);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$contextFiberStackCursor, fiber);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $d52e344c7cd7d393$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $d52e344c7cd7d393$var$getOwnHostContext(nextRootInstance), fiber = $d52e344c7cd7d393$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$contextStackCursor);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$contextStackCursor, fiber);
}
function $d52e344c7cd7d393$var$popHostContainer() {
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$contextStackCursor);
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$contextFiberStackCursor);
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$rootInstanceStackCursor);
}
function $d52e344c7cd7d393$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$hostTransitionProviderCursor, fiber);
    var context = $d52e344c7cd7d393$var$contextStackCursor.current;
    var JSCompiler_inline_result = $d52e344c7cd7d393$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$contextFiberStackCursor, fiber), $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$contextStackCursor, JSCompiler_inline_result));
}
function $d52e344c7cd7d393$var$popHostContext(fiber) {
    $d52e344c7cd7d393$var$contextFiberStackCursor.current === fiber && ($d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$contextStackCursor), $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$contextFiberStackCursor));
    $d52e344c7cd7d393$var$hostTransitionProviderCursor.current === fiber && ($d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$hostTransitionProviderCursor), $d52e344c7cd7d393$var$HostTransitionContext._currentValue = $d52e344c7cd7d393$var$sharedNotPendingObject);
}
var $d52e344c7cd7d393$var$hasOwnProperty = Object.prototype.hasOwnProperty, $d52e344c7cd7d393$var$scheduleCallback$3 = $aXDU1.unstable_scheduleCallback, $d52e344c7cd7d393$var$cancelCallback$1 = $aXDU1.unstable_cancelCallback, $d52e344c7cd7d393$var$shouldYield = $aXDU1.unstable_shouldYield, $d52e344c7cd7d393$var$requestPaint = $aXDU1.unstable_requestPaint, $d52e344c7cd7d393$var$now = $aXDU1.unstable_now, $d52e344c7cd7d393$var$getCurrentPriorityLevel = $aXDU1.unstable_getCurrentPriorityLevel, $d52e344c7cd7d393$var$ImmediatePriority = $aXDU1.unstable_ImmediatePriority, $d52e344c7cd7d393$var$UserBlockingPriority = $aXDU1.unstable_UserBlockingPriority, $d52e344c7cd7d393$var$NormalPriority$1 = $aXDU1.unstable_NormalPriority, $d52e344c7cd7d393$var$LowPriority = $aXDU1.unstable_LowPriority, $d52e344c7cd7d393$var$IdlePriority = $aXDU1.unstable_IdlePriority, $d52e344c7cd7d393$var$log$1 = $aXDU1.log, $d52e344c7cd7d393$var$unstable_setDisableYieldValue = $aXDU1.unstable_setDisableYieldValue, $d52e344c7cd7d393$var$rendererID = null, $d52e344c7cd7d393$var$injectedHook = null;
function $d52e344c7cd7d393$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $d52e344c7cd7d393$var$log$1 && $d52e344c7cd7d393$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($d52e344c7cd7d393$var$injectedHook && "function" === typeof $d52e344c7cd7d393$var$injectedHook.setStrictMode) try {
        $d52e344c7cd7d393$var$injectedHook.setStrictMode($d52e344c7cd7d393$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $d52e344c7cd7d393$var$clz32 = Math.clz32 ? Math.clz32 : $d52e344c7cd7d393$var$clz32Fallback, $d52e344c7cd7d393$var$log = Math.log, $d52e344c7cd7d393$var$LN2 = Math.LN2;
function $d52e344c7cd7d393$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($d52e344c7cd7d393$var$log(x) / $d52e344c7cd7d393$var$LN2 | 0) | 0;
}
var $d52e344c7cd7d393$var$nextTransitionLane = 256, $d52e344c7cd7d393$var$nextRetryLane = 4194304;
function $d52e344c7cd7d393$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $d52e344c7cd7d393$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $d52e344c7cd7d393$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $d52e344c7cd7d393$var$claimNextTransitionLane() {
    var lane = $d52e344c7cd7d393$var$nextTransitionLane;
    $d52e344c7cd7d393$var$nextTransitionLane <<= 1;
    0 === ($d52e344c7cd7d393$var$nextTransitionLane & 4194048) && ($d52e344c7cd7d393$var$nextTransitionLane = 256);
    return lane;
}
function $d52e344c7cd7d393$var$claimNextRetryLane() {
    var lane = $d52e344c7cd7d393$var$nextRetryLane;
    $d52e344c7cd7d393$var$nextRetryLane <<= 1;
    0 === ($d52e344c7cd7d393$var$nextRetryLane & 62914560) && ($d52e344c7cd7d393$var$nextRetryLane = 4194304);
    return lane;
}
function $d52e344c7cd7d393$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $d52e344c7cd7d393$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $d52e344c7cd7d393$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $d52e344c7cd7d393$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $d52e344c7cd7d393$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $d52e344c7cd7d393$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $d52e344c7cd7d393$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $d52e344c7cd7d393$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $d52e344c7cd7d393$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $d52e344c7cd7d393$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $d52e344c7cd7d393$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $d52e344c7cd7d393$var$resolveUpdatePriority() {
    var updatePriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $d52e344c7cd7d393$var$getEventPriority(updatePriority.type);
}
function $d52e344c7cd7d393$var$runWithPriority(priority, fn) {
    var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    try {
        return $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $d52e344c7cd7d393$var$randomKey = Math.random().toString(36).slice(2), $d52e344c7cd7d393$var$internalInstanceKey = "__reactFiber$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalPropsKey = "__reactProps$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalContainerInstanceKey = "__reactContainer$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalEventHandlersKey = "__reactEvents$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalEventHandlerListenersKey = "__reactListeners$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalEventHandlesSetKey = "__reactHandles$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalRootNodeResourcesKey = "__reactResources$" + $d52e344c7cd7d393$var$randomKey, $d52e344c7cd7d393$var$internalHoistableMarker = "__reactMarker$" + $d52e344c7cd7d393$var$randomKey;
function $d52e344c7cd7d393$var$detachDeletedInstance(node) {
    delete node[$d52e344c7cd7d393$var$internalInstanceKey];
    delete node[$d52e344c7cd7d393$var$internalPropsKey];
    delete node[$d52e344c7cd7d393$var$internalEventHandlersKey];
    delete node[$d52e344c7cd7d393$var$internalEventHandlerListenersKey];
    delete node[$d52e344c7cd7d393$var$internalEventHandlesSetKey];
}
function $d52e344c7cd7d393$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$d52e344c7cd7d393$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$d52e344c7cd7d393$var$internalContainerInstanceKey] || parentNode[$d52e344c7cd7d393$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $d52e344c7cd7d393$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$d52e344c7cd7d393$var$internalInstanceKey]) return parentNode;
                targetNode = $d52e344c7cd7d393$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $d52e344c7cd7d393$var$getInstanceFromNode(node) {
    if (node = node[$d52e344c7cd7d393$var$internalInstanceKey] || node[$d52e344c7cd7d393$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $d52e344c7cd7d393$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(33));
}
function $d52e344c7cd7d393$var$getResourcesFromRoot(root) {
    var resources = root[$d52e344c7cd7d393$var$internalRootNodeResourcesKey];
    resources || (resources = root[$d52e344c7cd7d393$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $d52e344c7cd7d393$var$markNodeAsHoistable(node) {
    node[$d52e344c7cd7d393$var$internalHoistableMarker] = !0;
}
var $d52e344c7cd7d393$var$allNativeEvents = new Set(), $d52e344c7cd7d393$var$registrationNameDependencies = {};
function $d52e344c7cd7d393$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $d52e344c7cd7d393$var$registerDirectEvent(registrationName, dependencies);
    $d52e344c7cd7d393$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $d52e344c7cd7d393$var$registerDirectEvent(registrationName, dependencies) {
    $d52e344c7cd7d393$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$d52e344c7cd7d393$var$allNativeEvents.add(dependencies[registrationName]);
}
var $d52e344c7cd7d393$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $d52e344c7cd7d393$var$illegalAttributeNameCache = {}, $d52e344c7cd7d393$var$validatedAttributeNameCache = {};
function $d52e344c7cd7d393$var$isAttributeNameSafe(attributeName) {
    if ($d52e344c7cd7d393$var$hasOwnProperty.call($d52e344c7cd7d393$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($d52e344c7cd7d393$var$hasOwnProperty.call($d52e344c7cd7d393$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($d52e344c7cd7d393$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $d52e344c7cd7d393$var$validatedAttributeNameCache[attributeName] = !0;
    $d52e344c7cd7d393$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $d52e344c7cd7d393$var$setValueForAttribute(node, name, value) {
    if ($d52e344c7cd7d393$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $d52e344c7cd7d393$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $d52e344c7cd7d393$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $d52e344c7cd7d393$var$prefix, $d52e344c7cd7d393$var$suffix;
function $d52e344c7cd7d393$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $d52e344c7cd7d393$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $d52e344c7cd7d393$var$prefix = match && match[1] || "";
        $d52e344c7cd7d393$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $d52e344c7cd7d393$var$prefix + name + $d52e344c7cd7d393$var$suffix;
}
var $d52e344c7cd7d393$var$reentry = !1;
function $d52e344c7cd7d393$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $d52e344c7cd7d393$var$reentry) return "";
    $d52e344c7cd7d393$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $d52e344c7cd7d393$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $d52e344c7cd7d393$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $d52e344c7cd7d393$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $d52e344c7cd7d393$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $d52e344c7cd7d393$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $d52e344c7cd7d393$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $d52e344c7cd7d393$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $d52e344c7cd7d393$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $d52e344c7cd7d393$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $d52e344c7cd7d393$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $d52e344c7cd7d393$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $d52e344c7cd7d393$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $d52e344c7cd7d393$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $d52e344c7cd7d393$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $d52e344c7cd7d393$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $d52e344c7cd7d393$var$trackValueOnNode(node) {
    var valueField = $d52e344c7cd7d393$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $d52e344c7cd7d393$var$track(node) {
    node._valueTracker || (node._valueTracker = $d52e344c7cd7d393$var$trackValueOnNode(node));
}
function $d52e344c7cd7d393$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $d52e344c7cd7d393$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $d52e344c7cd7d393$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $d52e344c7cd7d393$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $d52e344c7cd7d393$var$getToStringValue(value);
        } else element.value !== "" + $d52e344c7cd7d393$var$getToStringValue(value) && (element.value = "" + $d52e344c7cd7d393$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $d52e344c7cd7d393$var$setDefaultValue(element, type, $d52e344c7cd7d393$var$getToStringValue(value)) : null != defaultValue ? $d52e344c7cd7d393$var$setDefaultValue(element, type, $d52e344c7cd7d393$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $d52e344c7cd7d393$var$getToStringValue(name) : element.removeAttribute("name");
}
function $d52e344c7cd7d393$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $d52e344c7cd7d393$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $d52e344c7cd7d393$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $d52e344c7cd7d393$var$setDefaultValue(node, type, value) {
    "number" === type && $d52e344c7cd7d393$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $d52e344c7cd7d393$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $d52e344c7cd7d393$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $d52e344c7cd7d393$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $d52e344c7cd7d393$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $d52e344c7cd7d393$var$getToStringValue(defaultValue) : "";
}
function $d52e344c7cd7d393$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(92));
            if ($d52e344c7cd7d393$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $d52e344c7cd7d393$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $d52e344c7cd7d393$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $d52e344c7cd7d393$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $d52e344c7cd7d393$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $d52e344c7cd7d393$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $d52e344c7cd7d393$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $d52e344c7cd7d393$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $d52e344c7cd7d393$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $d52e344c7cd7d393$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $d52e344c7cd7d393$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $d52e344c7cd7d393$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $d52e344c7cd7d393$var$sanitizeURL(url) {
    return $d52e344c7cd7d393$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $d52e344c7cd7d393$var$currentReplayingEvent = null;
function $d52e344c7cd7d393$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $d52e344c7cd7d393$var$restoreTarget = null, $d52e344c7cd7d393$var$restoreQueue = null;
function $d52e344c7cd7d393$var$restoreStateOfTarget(target) {
    var internalInstance = $d52e344c7cd7d393$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$d52e344c7cd7d393$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $d52e344c7cd7d393$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$d52e344c7cd7d393$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(90));
                            $d52e344c7cd7d393$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $d52e344c7cd7d393$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $d52e344c7cd7d393$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $d52e344c7cd7d393$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $d52e344c7cd7d393$var$isInsideEventHandler = !1;
function $d52e344c7cd7d393$var$batchedUpdates$1(fn, a, b) {
    if ($d52e344c7cd7d393$var$isInsideEventHandler) return fn(a, b);
    $d52e344c7cd7d393$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($d52e344c7cd7d393$var$isInsideEventHandler = !1, null !== $d52e344c7cd7d393$var$restoreTarget || null !== $d52e344c7cd7d393$var$restoreQueue) {
            if ($d52e344c7cd7d393$var$flushSyncWork$1(), $d52e344c7cd7d393$var$restoreTarget && (a = $d52e344c7cd7d393$var$restoreTarget, fn = $d52e344c7cd7d393$var$restoreQueue, $d52e344c7cd7d393$var$restoreQueue = $d52e344c7cd7d393$var$restoreTarget = null, $d52e344c7cd7d393$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$d52e344c7cd7d393$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $d52e344c7cd7d393$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$d52e344c7cd7d393$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $d52e344c7cd7d393$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $d52e344c7cd7d393$var$passiveBrowserEventsSupported = !1;
if ($d52e344c7cd7d393$var$canUseDOM) try {
    var $d52e344c7cd7d393$var$options = {};
    Object.defineProperty($d52e344c7cd7d393$var$options, "passive", {
        get: function() {
            $d52e344c7cd7d393$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $d52e344c7cd7d393$var$options, $d52e344c7cd7d393$var$options);
    window.removeEventListener("test", $d52e344c7cd7d393$var$options, $d52e344c7cd7d393$var$options);
} catch (e) {
    $d52e344c7cd7d393$var$passiveBrowserEventsSupported = !1;
}
var $d52e344c7cd7d393$var$root = null, $d52e344c7cd7d393$var$startText = null, $d52e344c7cd7d393$var$fallbackText = null;
function $d52e344c7cd7d393$var$getData() {
    if ($d52e344c7cd7d393$var$fallbackText) return $d52e344c7cd7d393$var$fallbackText;
    var start, startValue = $d52e344c7cd7d393$var$startText, startLength = startValue.length, end, endValue = "value" in $d52e344c7cd7d393$var$root ? $d52e344c7cd7d393$var$root.value : $d52e344c7cd7d393$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $d52e344c7cd7d393$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $d52e344c7cd7d393$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $d52e344c7cd7d393$var$functionThatReturnsTrue() {
    return !0;
}
function $d52e344c7cd7d393$var$functionThatReturnsFalse() {
    return !1;
}
function $d52e344c7cd7d393$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $d52e344c7cd7d393$var$functionThatReturnsTrue : $d52e344c7cd7d393$var$functionThatReturnsFalse;
        this.isPropagationStopped = $d52e344c7cd7d393$var$functionThatReturnsFalse;
        return this;
    }
    $d52e344c7cd7d393$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $d52e344c7cd7d393$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $d52e344c7cd7d393$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $d52e344c7cd7d393$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $d52e344c7cd7d393$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $d52e344c7cd7d393$var$SyntheticEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$EventInterface), $d52e344c7cd7d393$var$UIEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    view: 0,
    detail: 0
}), $d52e344c7cd7d393$var$SyntheticUIEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$UIEventInterface), $d52e344c7cd7d393$var$lastMovementX, $d52e344c7cd7d393$var$lastMovementY, $d52e344c7cd7d393$var$lastMouseEvent, $d52e344c7cd7d393$var$MouseEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $d52e344c7cd7d393$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $d52e344c7cd7d393$var$lastMouseEvent && ($d52e344c7cd7d393$var$lastMouseEvent && "mousemove" === event.type ? ($d52e344c7cd7d393$var$lastMovementX = event.screenX - $d52e344c7cd7d393$var$lastMouseEvent.screenX, $d52e344c7cd7d393$var$lastMovementY = event.screenY - $d52e344c7cd7d393$var$lastMouseEvent.screenY) : $d52e344c7cd7d393$var$lastMovementY = $d52e344c7cd7d393$var$lastMovementX = 0, $d52e344c7cd7d393$var$lastMouseEvent = event);
        return $d52e344c7cd7d393$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $d52e344c7cd7d393$var$lastMovementY;
    }
}), $d52e344c7cd7d393$var$SyntheticMouseEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$MouseEventInterface), $d52e344c7cd7d393$var$DragEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$MouseEventInterface, {
    dataTransfer: 0
}), $d52e344c7cd7d393$var$SyntheticDragEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$DragEventInterface), $d52e344c7cd7d393$var$FocusEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$UIEventInterface, {
    relatedTarget: 0
}), $d52e344c7cd7d393$var$SyntheticFocusEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$FocusEventInterface), $d52e344c7cd7d393$var$AnimationEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d52e344c7cd7d393$var$SyntheticAnimationEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$AnimationEventInterface), $d52e344c7cd7d393$var$ClipboardEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $d52e344c7cd7d393$var$SyntheticClipboardEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$ClipboardEventInterface), $d52e344c7cd7d393$var$CompositionEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    data: 0
}), $d52e344c7cd7d393$var$SyntheticCompositionEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$CompositionEventInterface), $d52e344c7cd7d393$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $d52e344c7cd7d393$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $d52e344c7cd7d393$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $d52e344c7cd7d393$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $d52e344c7cd7d393$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $d52e344c7cd7d393$var$getEventModifierState() {
    return $d52e344c7cd7d393$var$modifierStateGetter;
}
var $d52e344c7cd7d393$var$KeyboardEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $d52e344c7cd7d393$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $d52e344c7cd7d393$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $d52e344c7cd7d393$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $d52e344c7cd7d393$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $d52e344c7cd7d393$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $d52e344c7cd7d393$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $d52e344c7cd7d393$var$SyntheticKeyboardEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$KeyboardEventInterface), $d52e344c7cd7d393$var$PointerEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $d52e344c7cd7d393$var$SyntheticPointerEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$PointerEventInterface), $d52e344c7cd7d393$var$TouchEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $d52e344c7cd7d393$var$getEventModifierState
}), $d52e344c7cd7d393$var$SyntheticTouchEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$TouchEventInterface), $d52e344c7cd7d393$var$TransitionEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $d52e344c7cd7d393$var$SyntheticTransitionEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$TransitionEventInterface), $d52e344c7cd7d393$var$WheelEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $d52e344c7cd7d393$var$SyntheticWheelEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$WheelEventInterface), $d52e344c7cd7d393$var$ToggleEventInterface = $d52e344c7cd7d393$var$assign({}, $d52e344c7cd7d393$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $d52e344c7cd7d393$var$SyntheticToggleEvent = $d52e344c7cd7d393$var$createSyntheticEvent($d52e344c7cd7d393$var$ToggleEventInterface), $d52e344c7cd7d393$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $d52e344c7cd7d393$var$canUseCompositionEvent = $d52e344c7cd7d393$var$canUseDOM && "CompositionEvent" in window, $d52e344c7cd7d393$var$documentMode = null;
$d52e344c7cd7d393$var$canUseDOM && "documentMode" in document && ($d52e344c7cd7d393$var$documentMode = document.documentMode);
var $d52e344c7cd7d393$var$canUseTextInputEvent = $d52e344c7cd7d393$var$canUseDOM && "TextEvent" in window && !$d52e344c7cd7d393$var$documentMode, $d52e344c7cd7d393$var$useFallbackCompositionData = $d52e344c7cd7d393$var$canUseDOM && (!$d52e344c7cd7d393$var$canUseCompositionEvent || $d52e344c7cd7d393$var$documentMode && 8 < $d52e344c7cd7d393$var$documentMode && 11 >= $d52e344c7cd7d393$var$documentMode), $d52e344c7cd7d393$var$SPACEBAR_CHAR = String.fromCharCode(32), $d52e344c7cd7d393$var$hasSpaceKeypress = !1;
function $d52e344c7cd7d393$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $d52e344c7cd7d393$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $d52e344c7cd7d393$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $d52e344c7cd7d393$var$isComposing = !1;
function $d52e344c7cd7d393$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $d52e344c7cd7d393$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $d52e344c7cd7d393$var$hasSpaceKeypress = !0;
            return $d52e344c7cd7d393$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $d52e344c7cd7d393$var$SPACEBAR_CHAR && $d52e344c7cd7d393$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $d52e344c7cd7d393$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($d52e344c7cd7d393$var$isComposing) return "compositionend" === domEventName || !$d52e344c7cd7d393$var$canUseCompositionEvent && $d52e344c7cd7d393$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $d52e344c7cd7d393$var$getData(), $d52e344c7cd7d393$var$fallbackText = $d52e344c7cd7d393$var$startText = $d52e344c7cd7d393$var$root = null, $d52e344c7cd7d393$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $d52e344c7cd7d393$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $d52e344c7cd7d393$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $d52e344c7cd7d393$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$d52e344c7cd7d393$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $d52e344c7cd7d393$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $d52e344c7cd7d393$var$restoreTarget ? $d52e344c7cd7d393$var$restoreQueue ? $d52e344c7cd7d393$var$restoreQueue.push(target) : $d52e344c7cd7d393$var$restoreQueue = [
        target
    ] : $d52e344c7cd7d393$var$restoreTarget = target;
    inst = $d52e344c7cd7d393$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $d52e344c7cd7d393$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $d52e344c7cd7d393$var$activeElement$1 = null, $d52e344c7cd7d393$var$activeElementInst$1 = null;
function $d52e344c7cd7d393$var$runEventInBatch(dispatchQueue) {
    $d52e344c7cd7d393$var$processDispatchQueue(dispatchQueue, 0);
}
function $d52e344c7cd7d393$var$getInstIfValueChanged(targetInst) {
    var targetNode = $d52e344c7cd7d393$var$getNodeFromInstance(targetInst);
    if ($d52e344c7cd7d393$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $d52e344c7cd7d393$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $d52e344c7cd7d393$var$isInputEventSupported = !1;
if ($d52e344c7cd7d393$var$canUseDOM) {
    var $d52e344c7cd7d393$var$JSCompiler_inline_result$jscomp$282;
    if ($d52e344c7cd7d393$var$canUseDOM) {
        var $d52e344c7cd7d393$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$d52e344c7cd7d393$var$isSupported$jscomp$inline_417) {
            var $d52e344c7cd7d393$var$element$jscomp$inline_418 = document.createElement("div");
            $d52e344c7cd7d393$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $d52e344c7cd7d393$var$isSupported$jscomp$inline_417 = "function" === typeof $d52e344c7cd7d393$var$element$jscomp$inline_418.oninput;
        }
        $d52e344c7cd7d393$var$JSCompiler_inline_result$jscomp$282 = $d52e344c7cd7d393$var$isSupported$jscomp$inline_417;
    } else $d52e344c7cd7d393$var$JSCompiler_inline_result$jscomp$282 = !1;
    $d52e344c7cd7d393$var$isInputEventSupported = $d52e344c7cd7d393$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $d52e344c7cd7d393$var$stopWatchingForValueChange() {
    $d52e344c7cd7d393$var$activeElement$1 && ($d52e344c7cd7d393$var$activeElement$1.detachEvent("onpropertychange", $d52e344c7cd7d393$var$handlePropertyChange), $d52e344c7cd7d393$var$activeElementInst$1 = $d52e344c7cd7d393$var$activeElement$1 = null);
}
function $d52e344c7cd7d393$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $d52e344c7cd7d393$var$getInstIfValueChanged($d52e344c7cd7d393$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $d52e344c7cd7d393$var$createAndAccumulateChangeEvent(dispatchQueue, $d52e344c7cd7d393$var$activeElementInst$1, nativeEvent, $d52e344c7cd7d393$var$getEventTarget(nativeEvent));
        $d52e344c7cd7d393$var$batchedUpdates$1($d52e344c7cd7d393$var$runEventInBatch, dispatchQueue);
    }
}
function $d52e344c7cd7d393$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($d52e344c7cd7d393$var$stopWatchingForValueChange(), $d52e344c7cd7d393$var$activeElement$1 = target, $d52e344c7cd7d393$var$activeElementInst$1 = targetInst, $d52e344c7cd7d393$var$activeElement$1.attachEvent("onpropertychange", $d52e344c7cd7d393$var$handlePropertyChange)) : "focusout" === domEventName && $d52e344c7cd7d393$var$stopWatchingForValueChange();
}
function $d52e344c7cd7d393$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $d52e344c7cd7d393$var$getInstIfValueChanged($d52e344c7cd7d393$var$activeElementInst$1);
}
function $d52e344c7cd7d393$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $d52e344c7cd7d393$var$getInstIfValueChanged(targetInst);
}
function $d52e344c7cd7d393$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $d52e344c7cd7d393$var$getInstIfValueChanged(targetInst);
}
function $d52e344c7cd7d393$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d52e344c7cd7d393$var$objectIs = "function" === typeof Object.is ? Object.is : $d52e344c7cd7d393$var$is;
function $d52e344c7cd7d393$var$shallowEqual(objA, objB) {
    if ($d52e344c7cd7d393$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$d52e344c7cd7d393$var$hasOwnProperty.call(objB, currentKey) || !$d52e344c7cd7d393$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $d52e344c7cd7d393$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $d52e344c7cd7d393$var$getNodeForCharacterOffset(root, offset) {
    var node = $d52e344c7cd7d393$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $d52e344c7cd7d393$var$getLeafNode(node);
    }
}
function $d52e344c7cd7d393$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $d52e344c7cd7d393$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $d52e344c7cd7d393$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $d52e344c7cd7d393$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $d52e344c7cd7d393$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $d52e344c7cd7d393$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $d52e344c7cd7d393$var$skipSelectionChangeEvent = $d52e344c7cd7d393$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $d52e344c7cd7d393$var$activeElement = null, $d52e344c7cd7d393$var$activeElementInst = null, $d52e344c7cd7d393$var$lastSelection = null, $d52e344c7cd7d393$var$mouseDown = !1;
function $d52e344c7cd7d393$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $d52e344c7cd7d393$var$mouseDown || null == $d52e344c7cd7d393$var$activeElement || $d52e344c7cd7d393$var$activeElement !== $d52e344c7cd7d393$var$getActiveElement(doc) || (doc = $d52e344c7cd7d393$var$activeElement, "selectionStart" in doc && $d52e344c7cd7d393$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $d52e344c7cd7d393$var$lastSelection && $d52e344c7cd7d393$var$shallowEqual($d52e344c7cd7d393$var$lastSelection, doc) || ($d52e344c7cd7d393$var$lastSelection = doc, doc = $d52e344c7cd7d393$var$accumulateTwoPhaseListeners($d52e344c7cd7d393$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $d52e344c7cd7d393$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $d52e344c7cd7d393$var$activeElement)));
}
function $d52e344c7cd7d393$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $d52e344c7cd7d393$var$vendorPrefixes = {
    animationend: $d52e344c7cd7d393$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $d52e344c7cd7d393$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $d52e344c7cd7d393$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $d52e344c7cd7d393$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $d52e344c7cd7d393$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $d52e344c7cd7d393$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $d52e344c7cd7d393$var$makePrefixMap("Transition", "TransitionEnd")
}, $d52e344c7cd7d393$var$prefixedEventNames = {}, $d52e344c7cd7d393$var$style = {};
$d52e344c7cd7d393$var$canUseDOM && ($d52e344c7cd7d393$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $d52e344c7cd7d393$var$vendorPrefixes.animationend.animation, delete $d52e344c7cd7d393$var$vendorPrefixes.animationiteration.animation, delete $d52e344c7cd7d393$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $d52e344c7cd7d393$var$vendorPrefixes.transitionend.transition);
function $d52e344c7cd7d393$var$getVendorPrefixedEventName(eventName) {
    if ($d52e344c7cd7d393$var$prefixedEventNames[eventName]) return $d52e344c7cd7d393$var$prefixedEventNames[eventName];
    if (!$d52e344c7cd7d393$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $d52e344c7cd7d393$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $d52e344c7cd7d393$var$style) return $d52e344c7cd7d393$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $d52e344c7cd7d393$var$ANIMATION_END = $d52e344c7cd7d393$var$getVendorPrefixedEventName("animationend"), $d52e344c7cd7d393$var$ANIMATION_ITERATION = $d52e344c7cd7d393$var$getVendorPrefixedEventName("animationiteration"), $d52e344c7cd7d393$var$ANIMATION_START = $d52e344c7cd7d393$var$getVendorPrefixedEventName("animationstart"), $d52e344c7cd7d393$var$TRANSITION_RUN = $d52e344c7cd7d393$var$getVendorPrefixedEventName("transitionrun"), $d52e344c7cd7d393$var$TRANSITION_START = $d52e344c7cd7d393$var$getVendorPrefixedEventName("transitionstart"), $d52e344c7cd7d393$var$TRANSITION_CANCEL = $d52e344c7cd7d393$var$getVendorPrefixedEventName("transitioncancel"), $d52e344c7cd7d393$var$TRANSITION_END = $d52e344c7cd7d393$var$getVendorPrefixedEventName("transitionend"), $d52e344c7cd7d393$var$topLevelEventsToReactNames = new Map(), $d52e344c7cd7d393$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$d52e344c7cd7d393$var$simpleEventPluginEvents.push("scrollEnd");
function $d52e344c7cd7d393$var$registerSimpleEvent(domEventName, reactName) {
    $d52e344c7cd7d393$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $d52e344c7cd7d393$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $d52e344c7cd7d393$var$CapturedStacks = new WeakMap();
function $d52e344c7cd7d393$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $d52e344c7cd7d393$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $d52e344c7cd7d393$var$getStackByFiberInDevAndProd(source)
        };
        $d52e344c7cd7d393$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $d52e344c7cd7d393$var$getStackByFiberInDevAndProd(source)
    };
}
var $d52e344c7cd7d393$var$concurrentQueues = [], $d52e344c7cd7d393$var$concurrentQueuesIndex = 0, $d52e344c7cd7d393$var$concurrentlyUpdatedLanes = 0;
function $d52e344c7cd7d393$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $d52e344c7cd7d393$var$concurrentQueuesIndex, i = $d52e344c7cd7d393$var$concurrentlyUpdatedLanes = $d52e344c7cd7d393$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $d52e344c7cd7d393$var$concurrentQueues[i];
        $d52e344c7cd7d393$var$concurrentQueues[i++] = null;
        var queue = $d52e344c7cd7d393$var$concurrentQueues[i];
        $d52e344c7cd7d393$var$concurrentQueues[i++] = null;
        var update = $d52e344c7cd7d393$var$concurrentQueues[i];
        $d52e344c7cd7d393$var$concurrentQueues[i++] = null;
        var lane = $d52e344c7cd7d393$var$concurrentQueues[i];
        $d52e344c7cd7d393$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $d52e344c7cd7d393$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $d52e344c7cd7d393$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $d52e344c7cd7d393$var$concurrentQueues[$d52e344c7cd7d393$var$concurrentQueuesIndex++] = fiber;
    $d52e344c7cd7d393$var$concurrentQueues[$d52e344c7cd7d393$var$concurrentQueuesIndex++] = queue;
    $d52e344c7cd7d393$var$concurrentQueues[$d52e344c7cd7d393$var$concurrentQueuesIndex++] = update;
    $d52e344c7cd7d393$var$concurrentQueues[$d52e344c7cd7d393$var$concurrentQueuesIndex++] = lane;
    $d52e344c7cd7d393$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $d52e344c7cd7d393$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $d52e344c7cd7d393$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $d52e344c7cd7d393$var$getRootForUpdatedFiber(fiber);
}
function $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $d52e344c7cd7d393$var$enqueueUpdate$1(fiber, null, null, lane);
    return $d52e344c7cd7d393$var$getRootForUpdatedFiber(fiber);
}
function $d52e344c7cd7d393$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $d52e344c7cd7d393$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $d52e344c7cd7d393$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $d52e344c7cd7d393$var$nestedUpdateCount) throw $d52e344c7cd7d393$var$nestedUpdateCount = 0, $d52e344c7cd7d393$var$rootWithNestedUpdates = null, Error($d52e344c7cd7d393$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $d52e344c7cd7d393$var$emptyContextObject = {};
function $d52e344c7cd7d393$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $d52e344c7cd7d393$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $d52e344c7cd7d393$var$FiberNode(tag, pendingProps, key, mode);
}
function $d52e344c7cd7d393$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $d52e344c7cd7d393$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $d52e344c7cd7d393$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $d52e344c7cd7d393$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $d52e344c7cd7d393$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $d52e344c7cd7d393$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $d52e344c7cd7d393$var$isHostHoistableType(type, pendingProps, $d52e344c7cd7d393$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $d52e344c7cd7d393$var$REACT_ACTIVITY_TYPE:
            return type = $d52e344c7cd7d393$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $d52e344c7cd7d393$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE:
            return $d52e344c7cd7d393$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $d52e344c7cd7d393$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $d52e344c7cd7d393$var$REACT_PROFILER_TYPE:
            return type = $d52e344c7cd7d393$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $d52e344c7cd7d393$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $d52e344c7cd7d393$var$REACT_SUSPENSE_TYPE:
            return type = $d52e344c7cd7d393$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $d52e344c7cd7d393$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $d52e344c7cd7d393$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $d52e344c7cd7d393$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $d52e344c7cd7d393$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $d52e344c7cd7d393$var$REACT_PROVIDER_TYPE:
                case $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $d52e344c7cd7d393$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $d52e344c7cd7d393$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $d52e344c7cd7d393$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($d52e344c7cd7d393$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $d52e344c7cd7d393$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $d52e344c7cd7d393$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $d52e344c7cd7d393$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $d52e344c7cd7d393$var$createFiberFromText(content, mode, lanes) {
    content = $d52e344c7cd7d393$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $d52e344c7cd7d393$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $d52e344c7cd7d393$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $d52e344c7cd7d393$var$forkStack = [], $d52e344c7cd7d393$var$forkStackIndex = 0, $d52e344c7cd7d393$var$treeForkProvider = null, $d52e344c7cd7d393$var$treeForkCount = 0, $d52e344c7cd7d393$var$idStack = [], $d52e344c7cd7d393$var$idStackIndex = 0, $d52e344c7cd7d393$var$treeContextProvider = null, $d52e344c7cd7d393$var$treeContextId = 1, $d52e344c7cd7d393$var$treeContextOverflow = "";
function $d52e344c7cd7d393$var$pushTreeFork(workInProgress, totalChildren) {
    $d52e344c7cd7d393$var$forkStack[$d52e344c7cd7d393$var$forkStackIndex++] = $d52e344c7cd7d393$var$treeForkCount;
    $d52e344c7cd7d393$var$forkStack[$d52e344c7cd7d393$var$forkStackIndex++] = $d52e344c7cd7d393$var$treeForkProvider;
    $d52e344c7cd7d393$var$treeForkProvider = workInProgress;
    $d52e344c7cd7d393$var$treeForkCount = totalChildren;
}
function $d52e344c7cd7d393$var$pushTreeId(workInProgress, totalChildren, index) {
    $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextId;
    $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextOverflow;
    $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextProvider;
    $d52e344c7cd7d393$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $d52e344c7cd7d393$var$treeContextId;
    workInProgress = $d52e344c7cd7d393$var$treeContextOverflow;
    var baseLength = 32 - $d52e344c7cd7d393$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $d52e344c7cd7d393$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $d52e344c7cd7d393$var$treeContextId = 1 << 32 - $d52e344c7cd7d393$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $d52e344c7cd7d393$var$treeContextOverflow = length + workInProgress;
    } else $d52e344c7cd7d393$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $d52e344c7cd7d393$var$treeContextOverflow = workInProgress;
}
function $d52e344c7cd7d393$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($d52e344c7cd7d393$var$pushTreeFork(workInProgress, 1), $d52e344c7cd7d393$var$pushTreeId(workInProgress, 1, 0));
}
function $d52e344c7cd7d393$var$popTreeContext(workInProgress) {
    for(; workInProgress === $d52e344c7cd7d393$var$treeForkProvider;)$d52e344c7cd7d393$var$treeForkProvider = $d52e344c7cd7d393$var$forkStack[--$d52e344c7cd7d393$var$forkStackIndex], $d52e344c7cd7d393$var$forkStack[$d52e344c7cd7d393$var$forkStackIndex] = null, $d52e344c7cd7d393$var$treeForkCount = $d52e344c7cd7d393$var$forkStack[--$d52e344c7cd7d393$var$forkStackIndex], $d52e344c7cd7d393$var$forkStack[$d52e344c7cd7d393$var$forkStackIndex] = null;
    for(; workInProgress === $d52e344c7cd7d393$var$treeContextProvider;)$d52e344c7cd7d393$var$treeContextProvider = $d52e344c7cd7d393$var$idStack[--$d52e344c7cd7d393$var$idStackIndex], $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex] = null, $d52e344c7cd7d393$var$treeContextOverflow = $d52e344c7cd7d393$var$idStack[--$d52e344c7cd7d393$var$idStackIndex], $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex] = null, $d52e344c7cd7d393$var$treeContextId = $d52e344c7cd7d393$var$idStack[--$d52e344c7cd7d393$var$idStackIndex], $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex] = null;
}
var $d52e344c7cd7d393$var$hydrationParentFiber = null, $d52e344c7cd7d393$var$nextHydratableInstance = null, $d52e344c7cd7d393$var$isHydrating = !1, $d52e344c7cd7d393$var$hydrationErrors = null, $d52e344c7cd7d393$var$rootOrSingletonContext = !1, $d52e344c7cd7d393$var$HydrationMismatchException = Error($d52e344c7cd7d393$var$formatProdErrorMessage(519));
function $d52e344c7cd7d393$var$throwOnHydrationMismatch(fiber) {
    var error = Error($d52e344c7cd7d393$var$formatProdErrorMessage(418, ""));
    $d52e344c7cd7d393$var$queueHydrationError($d52e344c7cd7d393$var$createCapturedValueAtFiber(error, fiber));
    throw $d52e344c7cd7d393$var$HydrationMismatchException;
}
function $d52e344c7cd7d393$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$d52e344c7cd7d393$var$internalInstanceKey] = fiber;
    instance[$d52e344c7cd7d393$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("cancel", instance);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $d52e344c7cd7d393$var$mediaEventTypes.length; type++)$d52e344c7cd7d393$var$listenToNonDelegatedEvent($d52e344c7cd7d393$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("error", instance);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", instance);
            $d52e344c7cd7d393$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $d52e344c7cd7d393$var$track(instance);
            break;
        case "select":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", instance), $d52e344c7cd7d393$var$initTextarea(instance, props.value, props.defaultValue, props.children), $d52e344c7cd7d393$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $d52e344c7cd7d393$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($d52e344c7cd7d393$var$listenToNonDelegatedEvent("beforetoggle", instance), $d52e344c7cd7d393$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $d52e344c7cd7d393$var$noop$1), instance = !0) : instance = !1;
    instance || $d52e344c7cd7d393$var$throwOnHydrationMismatch(fiber);
}
function $d52e344c7cd7d393$var$popToNextHostParent(fiber) {
    for($d52e344c7cd7d393$var$hydrationParentFiber = fiber.return; $d52e344c7cd7d393$var$hydrationParentFiber;)switch($d52e344c7cd7d393$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $d52e344c7cd7d393$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $d52e344c7cd7d393$var$rootOrSingletonContext = !0;
            return;
        default:
            $d52e344c7cd7d393$var$hydrationParentFiber = $d52e344c7cd7d393$var$hydrationParentFiber.return;
    }
}
function $d52e344c7cd7d393$var$popHydrationState(fiber) {
    if (fiber !== $d52e344c7cd7d393$var$hydrationParentFiber) return !1;
    if (!$d52e344c7cd7d393$var$isHydrating) return $d52e344c7cd7d393$var$popToNextHostParent(fiber), $d52e344c7cd7d393$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $d52e344c7cd7d393$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $d52e344c7cd7d393$var$nextHydratableInstance && $d52e344c7cd7d393$var$throwOnHydrationMismatch(fiber);
    $d52e344c7cd7d393$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $d52e344c7cd7d393$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $d52e344c7cd7d393$var$nextHydratableInstance, $d52e344c7cd7d393$var$isSingletonScope(fiber.type) ? (fiber = $d52e344c7cd7d393$var$previousHydratableOnEnteringScopedSingleton, $d52e344c7cd7d393$var$previousHydratableOnEnteringScopedSingleton = null, $d52e344c7cd7d393$var$nextHydratableInstance = fiber) : $d52e344c7cd7d393$var$nextHydratableInstance = tag) : $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$hydrationParentFiber ? $d52e344c7cd7d393$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $d52e344c7cd7d393$var$resetHydrationState() {
    $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$hydrationParentFiber = null;
    $d52e344c7cd7d393$var$isHydrating = !1;
}
function $d52e344c7cd7d393$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $d52e344c7cd7d393$var$hydrationErrors;
    null !== queuedErrors && (null === $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors ? $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = queuedErrors : $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors.push.apply($d52e344c7cd7d393$var$workInProgressRootRecoverableErrors, queuedErrors), $d52e344c7cd7d393$var$hydrationErrors = null);
    return queuedErrors;
}
function $d52e344c7cd7d393$var$queueHydrationError(error) {
    null === $d52e344c7cd7d393$var$hydrationErrors ? $d52e344c7cd7d393$var$hydrationErrors = [
        error
    ] : $d52e344c7cd7d393$var$hydrationErrors.push(error);
}
var $d52e344c7cd7d393$var$valueCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = null, $d52e344c7cd7d393$var$lastContextDependency = null;
function $d52e344c7cd7d393$var$pushProvider(providerFiber, context, nextValue) {
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $d52e344c7cd7d393$var$popProvider(context) {
    context._currentValue = $d52e344c7cd7d393$var$valueCursor.current;
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$valueCursor);
}
function $d52e344c7cd7d393$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $d52e344c7cd7d393$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $d52e344c7cd7d393$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $d52e344c7cd7d393$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $d52e344c7cd7d393$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $d52e344c7cd7d393$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $d52e344c7cd7d393$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($d52e344c7cd7d393$var$HostTransitionContext) : current = [
                $d52e344c7cd7d393$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $d52e344c7cd7d393$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $d52e344c7cd7d393$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$d52e344c7cd7d393$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $d52e344c7cd7d393$var$prepareToReadContext(workInProgress) {
    $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = workInProgress;
    $d52e344c7cd7d393$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $d52e344c7cd7d393$var$readContext(context) {
    return $d52e344c7cd7d393$var$readContextForConsumer($d52e344c7cd7d393$var$currentlyRenderingFiber$1, context);
}
function $d52e344c7cd7d393$var$readContextDuringReconciliation(consumer, context) {
    null === $d52e344c7cd7d393$var$currentlyRenderingFiber$1 && $d52e344c7cd7d393$var$prepareToReadContext(consumer);
    return $d52e344c7cd7d393$var$readContextForConsumer(consumer, context);
}
function $d52e344c7cd7d393$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $d52e344c7cd7d393$var$lastContextDependency) {
        if (null === consumer) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(308));
        $d52e344c7cd7d393$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $d52e344c7cd7d393$var$lastContextDependency = $d52e344c7cd7d393$var$lastContextDependency.next = context;
    return value;
}
var $d52e344c7cd7d393$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $d52e344c7cd7d393$var$scheduleCallback$2 = $aXDU1.unstable_scheduleCallback, $d52e344c7cd7d393$var$NormalPriority = $aXDU1.unstable_NormalPriority, $d52e344c7cd7d393$var$CacheContext = {
    $$typeof: $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $d52e344c7cd7d393$var$createCache() {
    return {
        controller: new $d52e344c7cd7d393$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $d52e344c7cd7d393$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $d52e344c7cd7d393$var$scheduleCallback$2($d52e344c7cd7d393$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $d52e344c7cd7d393$var$currentEntangledListeners = null, $d52e344c7cd7d393$var$currentEntangledPendingCount = 0, $d52e344c7cd7d393$var$currentEntangledLane = 0, $d52e344c7cd7d393$var$currentEntangledActionThenable = null;
function $d52e344c7cd7d393$var$entangleAsyncAction(transition, thenable) {
    if (null === $d52e344c7cd7d393$var$currentEntangledListeners) {
        var entangledListeners = $d52e344c7cd7d393$var$currentEntangledListeners = [];
        $d52e344c7cd7d393$var$currentEntangledPendingCount = 0;
        $d52e344c7cd7d393$var$currentEntangledLane = $d52e344c7cd7d393$var$requestTransitionLane();
        $d52e344c7cd7d393$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $d52e344c7cd7d393$var$currentEntangledPendingCount++;
    thenable.then($d52e344c7cd7d393$var$pingEngtangledActionScope, $d52e344c7cd7d393$var$pingEngtangledActionScope);
    return thenable;
}
function $d52e344c7cd7d393$var$pingEngtangledActionScope() {
    if (0 === --$d52e344c7cd7d393$var$currentEntangledPendingCount && null !== $d52e344c7cd7d393$var$currentEntangledListeners) {
        null !== $d52e344c7cd7d393$var$currentEntangledActionThenable && ($d52e344c7cd7d393$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $d52e344c7cd7d393$var$currentEntangledListeners;
        $d52e344c7cd7d393$var$currentEntangledListeners = null;
        $d52e344c7cd7d393$var$currentEntangledLane = 0;
        $d52e344c7cd7d393$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $d52e344c7cd7d393$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $d52e344c7cd7d393$var$prevOnStartTransitionFinish = $d52e344c7cd7d393$var$ReactSharedInternals.S;
$d52e344c7cd7d393$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $d52e344c7cd7d393$var$entangleAsyncAction(transition, returnValue);
    null !== $d52e344c7cd7d393$var$prevOnStartTransitionFinish && $d52e344c7cd7d393$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $d52e344c7cd7d393$var$resumedCache = $d52e344c7cd7d393$var$createCursor(null);
function $d52e344c7cd7d393$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $d52e344c7cd7d393$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $d52e344c7cd7d393$var$workInProgressRoot.pooledCache;
}
function $d52e344c7cd7d393$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$resumedCache, $d52e344c7cd7d393$var$resumedCache.current) : $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$resumedCache, prevCachePool.pool);
}
function $d52e344c7cd7d393$var$getSuspendedCache() {
    var cacheFromPool = $d52e344c7cd7d393$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $d52e344c7cd7d393$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $d52e344c7cd7d393$var$SuspenseException = Error($d52e344c7cd7d393$var$formatProdErrorMessage(460)), $d52e344c7cd7d393$var$SuspenseyCommitException = Error($d52e344c7cd7d393$var$formatProdErrorMessage(474)), $d52e344c7cd7d393$var$SuspenseActionException = Error($d52e344c7cd7d393$var$formatProdErrorMessage(542)), $d52e344c7cd7d393$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $d52e344c7cd7d393$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $d52e344c7cd7d393$var$noop$3() {}
function $d52e344c7cd7d393$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($d52e344c7cd7d393$var$noop$3, $d52e344c7cd7d393$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $d52e344c7cd7d393$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($d52e344c7cd7d393$var$noop$3, $d52e344c7cd7d393$var$noop$3);
            else {
                thenableState = $d52e344c7cd7d393$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $d52e344c7cd7d393$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $d52e344c7cd7d393$var$suspendedThenable = thenable;
            throw $d52e344c7cd7d393$var$SuspenseException;
    }
}
var $d52e344c7cd7d393$var$suspendedThenable = null;
function $d52e344c7cd7d393$var$getSuspendedThenable() {
    if (null === $d52e344c7cd7d393$var$suspendedThenable) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(459));
    var thenable = $d52e344c7cd7d393$var$suspendedThenable;
    $d52e344c7cd7d393$var$suspendedThenable = null;
    return thenable;
}
function $d52e344c7cd7d393$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $d52e344c7cd7d393$var$SuspenseException || rejectedReason === $d52e344c7cd7d393$var$SuspenseActionException) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(483));
}
var $d52e344c7cd7d393$var$hasForceUpdate = !1;
function $d52e344c7cd7d393$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $d52e344c7cd7d393$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $d52e344c7cd7d393$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $d52e344c7cd7d393$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($d52e344c7cd7d393$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $d52e344c7cd7d393$var$getRootForUpdatedFiber(fiber);
        $d52e344c7cd7d393$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $d52e344c7cd7d393$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $d52e344c7cd7d393$var$getRootForUpdatedFiber(fiber);
}
function $d52e344c7cd7d393$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $d52e344c7cd7d393$var$markRootEntangled(root, lane);
    }
}
function $d52e344c7cd7d393$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $d52e344c7cd7d393$var$didReadFromEntangledAsyncAction = !1;
function $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($d52e344c7cd7d393$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $d52e344c7cd7d393$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $d52e344c7cd7d393$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $d52e344c7cd7d393$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $d52e344c7cd7d393$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $d52e344c7cd7d393$var$currentEntangledLane && ($d52e344c7cd7d393$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $d52e344c7cd7d393$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $d52e344c7cd7d393$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $d52e344c7cd7d393$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $d52e344c7cd7d393$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$d52e344c7cd7d393$var$callCallback(callbacks[updateQueue], context);
}
var $d52e344c7cd7d393$var$currentTreeHiddenStackCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$prevEntangledRenderLanesCursor = $d52e344c7cd7d393$var$createCursor(0);
function $d52e344c7cd7d393$var$pushHiddenContext(fiber, context) {
    fiber = $d52e344c7cd7d393$var$entangledRenderLanes;
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$prevEntangledRenderLanesCursor, fiber);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$currentTreeHiddenStackCursor, context);
    $d52e344c7cd7d393$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $d52e344c7cd7d393$var$reuseHiddenContextOnStack() {
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$prevEntangledRenderLanesCursor, $d52e344c7cd7d393$var$entangledRenderLanes);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$currentTreeHiddenStackCursor, $d52e344c7cd7d393$var$currentTreeHiddenStackCursor.current);
}
function $d52e344c7cd7d393$var$popHiddenContext() {
    $d52e344c7cd7d393$var$entangledRenderLanes = $d52e344c7cd7d393$var$prevEntangledRenderLanesCursor.current;
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$currentTreeHiddenStackCursor);
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$prevEntangledRenderLanesCursor);
}
var $d52e344c7cd7d393$var$renderLanes = 0, $d52e344c7cd7d393$var$currentlyRenderingFiber = null, $d52e344c7cd7d393$var$currentHook = null, $d52e344c7cd7d393$var$workInProgressHook = null, $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdate = !1, $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $d52e344c7cd7d393$var$localIdCounter = 0, $d52e344c7cd7d393$var$thenableIndexCounter$1 = 0, $d52e344c7cd7d393$var$thenableState$1 = null, $d52e344c7cd7d393$var$globalClientIdCounter = 0;
function $d52e344c7cd7d393$var$throwInvalidHookError() {
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(321));
}
function $d52e344c7cd7d393$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$d52e344c7cd7d393$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $d52e344c7cd7d393$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $d52e344c7cd7d393$var$renderLanes = nextRenderLanes;
    $d52e344c7cd7d393$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $d52e344c7cd7d393$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $d52e344c7cd7d393$var$HooksDispatcherOnMount : $d52e344c7cd7d393$var$HooksDispatcherOnUpdate;
    $d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $d52e344c7cd7d393$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $d52e344c7cd7d393$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $d52e344c7cd7d393$var$finishRenderingHooks(current) {
    $d52e344c7cd7d393$var$ReactSharedInternals.H = $d52e344c7cd7d393$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $d52e344c7cd7d393$var$currentHook && null !== $d52e344c7cd7d393$var$currentHook.next;
    $d52e344c7cd7d393$var$renderLanes = 0;
    $d52e344c7cd7d393$var$workInProgressHook = $d52e344c7cd7d393$var$currentHook = $d52e344c7cd7d393$var$currentlyRenderingFiber = null;
    $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdate = !1;
    $d52e344c7cd7d393$var$thenableIndexCounter$1 = 0;
    $d52e344c7cd7d393$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(300));
    null === current || $d52e344c7cd7d393$var$didReceiveUpdate || (current = current.dependencies, null !== current && $d52e344c7cd7d393$var$checkIfContextChanged(current) && ($d52e344c7cd7d393$var$didReceiveUpdate = !0));
}
function $d52e344c7cd7d393$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $d52e344c7cd7d393$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass && ($d52e344c7cd7d393$var$thenableState$1 = null);
        $d52e344c7cd7d393$var$thenableIndexCounter$1 = 0;
        $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $d52e344c7cd7d393$var$workInProgressHook = $d52e344c7cd7d393$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $d52e344c7cd7d393$var$ReactSharedInternals.H = $d52e344c7cd7d393$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $d52e344c7cd7d393$var$TransitionAwareHostComponent() {
    var dispatcher = $d52e344c7cd7d393$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $d52e344c7cd7d393$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $d52e344c7cd7d393$var$currentHook ? $d52e344c7cd7d393$var$currentHook.memoizedState : null) !== dispatcher && ($d52e344c7cd7d393$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $d52e344c7cd7d393$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $d52e344c7cd7d393$var$localIdCounter;
    $d52e344c7cd7d393$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $d52e344c7cd7d393$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $d52e344c7cd7d393$var$resetHooksOnUnwind(workInProgress) {
    if ($d52e344c7cd7d393$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdate = !1;
    }
    $d52e344c7cd7d393$var$renderLanes = 0;
    $d52e344c7cd7d393$var$workInProgressHook = $d52e344c7cd7d393$var$currentHook = $d52e344c7cd7d393$var$currentlyRenderingFiber = null;
    $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $d52e344c7cd7d393$var$thenableIndexCounter$1 = $d52e344c7cd7d393$var$localIdCounter = 0;
    $d52e344c7cd7d393$var$thenableState$1 = null;
}
function $d52e344c7cd7d393$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $d52e344c7cd7d393$var$workInProgressHook ? $d52e344c7cd7d393$var$currentlyRenderingFiber.memoizedState = $d52e344c7cd7d393$var$workInProgressHook = hook : $d52e344c7cd7d393$var$workInProgressHook = $d52e344c7cd7d393$var$workInProgressHook.next = hook;
    return $d52e344c7cd7d393$var$workInProgressHook;
}
function $d52e344c7cd7d393$var$updateWorkInProgressHook() {
    if (null === $d52e344c7cd7d393$var$currentHook) {
        var nextCurrentHook = $d52e344c7cd7d393$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $d52e344c7cd7d393$var$currentHook.next;
    var nextWorkInProgressHook = null === $d52e344c7cd7d393$var$workInProgressHook ? $d52e344c7cd7d393$var$currentlyRenderingFiber.memoizedState : $d52e344c7cd7d393$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $d52e344c7cd7d393$var$workInProgressHook = nextWorkInProgressHook, $d52e344c7cd7d393$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $d52e344c7cd7d393$var$currentlyRenderingFiber.alternate) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(467));
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(310));
        }
        $d52e344c7cd7d393$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $d52e344c7cd7d393$var$currentHook.memoizedState,
            baseState: $d52e344c7cd7d393$var$currentHook.baseState,
            baseQueue: $d52e344c7cd7d393$var$currentHook.baseQueue,
            queue: $d52e344c7cd7d393$var$currentHook.queue,
            next: null
        };
        null === $d52e344c7cd7d393$var$workInProgressHook ? $d52e344c7cd7d393$var$currentlyRenderingFiber.memoizedState = $d52e344c7cd7d393$var$workInProgressHook = nextCurrentHook : $d52e344c7cd7d393$var$workInProgressHook = $d52e344c7cd7d393$var$workInProgressHook.next = nextCurrentHook;
    }
    return $d52e344c7cd7d393$var$workInProgressHook;
}
function $d52e344c7cd7d393$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $d52e344c7cd7d393$var$useThenable(thenable) {
    var index = $d52e344c7cd7d393$var$thenableIndexCounter$1;
    $d52e344c7cd7d393$var$thenableIndexCounter$1 += 1;
    null === $d52e344c7cd7d393$var$thenableState$1 && ($d52e344c7cd7d393$var$thenableState$1 = []);
    thenable = $d52e344c7cd7d393$var$trackUsedThenable($d52e344c7cd7d393$var$thenableState$1, thenable, index);
    index = $d52e344c7cd7d393$var$currentlyRenderingFiber;
    null === (null === $d52e344c7cd7d393$var$workInProgressHook ? index.memoizedState : $d52e344c7cd7d393$var$workInProgressHook.next) && (index = index.alternate, $d52e344c7cd7d393$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $d52e344c7cd7d393$var$HooksDispatcherOnMount : $d52e344c7cd7d393$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $d52e344c7cd7d393$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $d52e344c7cd7d393$var$useThenable(usable);
        if (usable.$$typeof === $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE) return $d52e344c7cd7d393$var$readContext(usable);
    }
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(438, String(usable)));
}
function $d52e344c7cd7d393$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $d52e344c7cd7d393$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $d52e344c7cd7d393$var$createFunctionComponentUpdateQueue(), $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $d52e344c7cd7d393$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $d52e344c7cd7d393$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $d52e344c7cd7d393$var$updateReducer(reducer) {
    var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    return $d52e344c7cd7d393$var$updateReducerImpl(hook, $d52e344c7cd7d393$var$currentHook, reducer);
}
function $d52e344c7cd7d393$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($d52e344c7cd7d393$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $d52e344c7cd7d393$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($d52e344c7cd7d393$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $d52e344c7cd7d393$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $d52e344c7cd7d393$var$currentlyRenderingFiber.lanes |= revertLane, $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $d52e344c7cd7d393$var$currentlyRenderingFiber.lanes |= updateLane, $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$d52e344c7cd7d393$var$objectIs(pendingQueue, hook.memoizedState) && ($d52e344c7cd7d393$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $d52e344c7cd7d393$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $d52e344c7cd7d393$var$rerenderReducer(reducer) {
    var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $d52e344c7cd7d393$var$objectIs(newState, hook.memoizedState) || ($d52e344c7cd7d393$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $d52e344c7cd7d393$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $d52e344c7cd7d393$var$currentlyRenderingFiber, hook = $d52e344c7cd7d393$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $d52e344c7cd7d393$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$d52e344c7cd7d393$var$objectIs(($d52e344c7cd7d393$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $d52e344c7cd7d393$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $d52e344c7cd7d393$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $d52e344c7cd7d393$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $d52e344c7cd7d393$var$workInProgressHook && $d52e344c7cd7d393$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $d52e344c7cd7d393$var$pushSimpleEffect(9, $d52e344c7cd7d393$var$createEffectInstance(), $d52e344c7cd7d393$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $d52e344c7cd7d393$var$workInProgressRoot) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($d52e344c7cd7d393$var$renderLanes & 124) || $d52e344c7cd7d393$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $d52e344c7cd7d393$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $d52e344c7cd7d393$var$createFunctionComponentUpdateQueue(), $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $d52e344c7cd7d393$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $d52e344c7cd7d393$var$checkIfSnapshotChanged(inst) && $d52e344c7cd7d393$var$forceStoreRerender(fiber);
}
function $d52e344c7cd7d393$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $d52e344c7cd7d393$var$checkIfSnapshotChanged(inst) && $d52e344c7cd7d393$var$forceStoreRerender(fiber);
    });
}
function $d52e344c7cd7d393$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$d52e344c7cd7d393$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $d52e344c7cd7d393$var$forceStoreRerender(fiber) {
    var root = $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $d52e344c7cd7d393$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $d52e344c7cd7d393$var$mountStateImpl(initialState) {
    var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d52e344c7cd7d393$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $d52e344c7cd7d393$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $d52e344c7cd7d393$var$updateReducerImpl(hook, $d52e344c7cd7d393$var$currentHook, "function" === typeof reducer ? reducer : $d52e344c7cd7d393$var$basicStateReducer);
}
function $d52e344c7cd7d393$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($d52e344c7cd7d393$var$isRenderPhaseUpdate(fiber)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $d52e344c7cd7d393$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $d52e344c7cd7d393$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $d52e344c7cd7d393$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $d52e344c7cd7d393$var$ReactSharedInternals.T, currentTransition = {};
        $d52e344c7cd7d393$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $d52e344c7cd7d393$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $d52e344c7cd7d393$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $d52e344c7cd7d393$var$onActionError(actionQueue, node, error);
        } finally{
            $d52e344c7cd7d393$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $d52e344c7cd7d393$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $d52e344c7cd7d393$var$onActionError(actionQueue, node, error$38);
    }
}
function $d52e344c7cd7d393$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $d52e344c7cd7d393$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $d52e344c7cd7d393$var$onActionError(actionQueue, node, error);
    }) : $d52e344c7cd7d393$var$onActionSuccess(actionQueue, node, returnValue);
}
function $d52e344c7cd7d393$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $d52e344c7cd7d393$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $d52e344c7cd7d393$var$runActionStateAction(actionQueue, nextState)));
}
function $d52e344c7cd7d393$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $d52e344c7cd7d393$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $d52e344c7cd7d393$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $d52e344c7cd7d393$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $d52e344c7cd7d393$var$mountActionState(action, initialStateProp) {
    if ($d52e344c7cd7d393$var$isHydrating) {
        var ssrFormState = $d52e344c7cd7d393$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $d52e344c7cd7d393$var$currentlyRenderingFiber;
                if ($d52e344c7cd7d393$var$isHydrating) {
                    if ($d52e344c7cd7d393$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $d52e344c7cd7d393$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $d52e344c7cd7d393$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $d52e344c7cd7d393$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $d52e344c7cd7d393$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $d52e344c7cd7d393$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $d52e344c7cd7d393$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $d52e344c7cd7d393$var$dispatchSetState.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $d52e344c7cd7d393$var$mountStateImpl(!1);
    inRootOrSingleton = $d52e344c7cd7d393$var$dispatchOptimisticSetState.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $d52e344c7cd7d393$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $d52e344c7cd7d393$var$dispatchActionState.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $d52e344c7cd7d393$var$updateActionState(action) {
    var stateHook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    return $d52e344c7cd7d393$var$updateActionStateImpl(stateHook, $d52e344c7cd7d393$var$currentHook, action);
}
function $d52e344c7cd7d393$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $d52e344c7cd7d393$var$updateReducerImpl(stateHook, currentStateHook, $d52e344c7cd7d393$var$actionStateReducer)[0];
    stateHook = $d52e344c7cd7d393$var$updateReducer($d52e344c7cd7d393$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $d52e344c7cd7d393$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $d52e344c7cd7d393$var$SuspenseException) throw $d52e344c7cd7d393$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($d52e344c7cd7d393$var$currentlyRenderingFiber.flags |= 2048, $d52e344c7cd7d393$var$pushSimpleEffect(9, $d52e344c7cd7d393$var$createEffectInstance(), $d52e344c7cd7d393$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $d52e344c7cd7d393$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $d52e344c7cd7d393$var$rerenderActionState(action) {
    var stateHook = $d52e344c7cd7d393$var$updateWorkInProgressHook(), currentStateHook = $d52e344c7cd7d393$var$currentHook;
    if (null !== currentStateHook) return $d52e344c7cd7d393$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $d52e344c7cd7d393$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $d52e344c7cd7d393$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $d52e344c7cd7d393$var$createFunctionComponentUpdateQueue(), $d52e344c7cd7d393$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $d52e344c7cd7d393$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $d52e344c7cd7d393$var$updateRef() {
    return $d52e344c7cd7d393$var$updateWorkInProgressHook().memoizedState;
}
function $d52e344c7cd7d393$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $d52e344c7cd7d393$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $d52e344c7cd7d393$var$pushSimpleEffect(1 | hookFlags, $d52e344c7cd7d393$var$createEffectInstance(), create, createDeps);
}
function $d52e344c7cd7d393$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $d52e344c7cd7d393$var$currentHook && null !== deps && $d52e344c7cd7d393$var$areHookInputsEqual(deps, $d52e344c7cd7d393$var$currentHook.memoizedState.deps) ? hook.memoizedState = $d52e344c7cd7d393$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($d52e344c7cd7d393$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $d52e344c7cd7d393$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $d52e344c7cd7d393$var$mountEffect(create, createDeps) {
    $d52e344c7cd7d393$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $d52e344c7cd7d393$var$updateEffect(create, createDeps) {
    $d52e344c7cd7d393$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $d52e344c7cd7d393$var$updateInsertionEffect(create, deps) {
    return $d52e344c7cd7d393$var$updateEffectImpl(4, 2, create, deps);
}
function $d52e344c7cd7d393$var$updateLayoutEffect(create, deps) {
    return $d52e344c7cd7d393$var$updateEffectImpl(4, 4, create, deps);
}
function $d52e344c7cd7d393$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $d52e344c7cd7d393$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $d52e344c7cd7d393$var$updateEffectImpl(4, 4, $d52e344c7cd7d393$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $d52e344c7cd7d393$var$mountDebugValue() {}
function $d52e344c7cd7d393$var$updateCallback(callback, deps) {
    var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d52e344c7cd7d393$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $d52e344c7cd7d393$var$updateMemo(nextCreate, deps) {
    var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $d52e344c7cd7d393$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $d52e344c7cd7d393$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($d52e344c7cd7d393$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $d52e344c7cd7d393$var$requestDeferredLane();
    $d52e344c7cd7d393$var$currentlyRenderingFiber.lanes |= hook;
    $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $d52e344c7cd7d393$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($d52e344c7cd7d393$var$objectIs(value, prevValue)) return value;
    if (null !== $d52e344c7cd7d393$var$currentTreeHiddenStackCursor.current) return hook = $d52e344c7cd7d393$var$mountDeferredValueImpl(hook, value, initialValue), $d52e344c7cd7d393$var$objectIs(hook, prevValue) || ($d52e344c7cd7d393$var$didReceiveUpdate = !0), hook;
    if (0 === ($d52e344c7cd7d393$var$renderLanes & 42)) return $d52e344c7cd7d393$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $d52e344c7cd7d393$var$requestDeferredLane();
    $d52e344c7cd7d393$var$currentlyRenderingFiber.lanes |= hook;
    $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $d52e344c7cd7d393$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $d52e344c7cd7d393$var$ReactSharedInternals.T, currentTransition = {};
    $d52e344c7cd7d393$var$ReactSharedInternals.T = currentTransition;
    $d52e344c7cd7d393$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $d52e344c7cd7d393$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $d52e344c7cd7d393$var$chainThenableValue(returnValue, finishedState);
            $d52e344c7cd7d393$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $d52e344c7cd7d393$var$requestUpdateLane(fiber));
        } else $d52e344c7cd7d393$var$dispatchSetStateInternal(fiber, queue, finishedState, $d52e344c7cd7d393$var$requestUpdateLane(fiber));
    } catch (error) {
        $d52e344c7cd7d393$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $d52e344c7cd7d393$var$requestUpdateLane());
    } finally{
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d52e344c7cd7d393$var$noop$2() {}
function $d52e344c7cd7d393$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(476));
    var queue = $d52e344c7cd7d393$var$ensureFormComponentIsStateful(formFiber).queue;
    $d52e344c7cd7d393$var$startTransition(formFiber, queue, pendingState, $d52e344c7cd7d393$var$sharedNotPendingObject, null === action ? $d52e344c7cd7d393$var$noop$2 : function() {
        $d52e344c7cd7d393$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $d52e344c7cd7d393$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $d52e344c7cd7d393$var$sharedNotPendingObject,
        baseState: $d52e344c7cd7d393$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d52e344c7cd7d393$var$basicStateReducer,
            lastRenderedState: $d52e344c7cd7d393$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $d52e344c7cd7d393$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $d52e344c7cd7d393$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $d52e344c7cd7d393$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $d52e344c7cd7d393$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $d52e344c7cd7d393$var$requestUpdateLane());
}
function $d52e344c7cd7d393$var$useHostTransitionStatus() {
    return $d52e344c7cd7d393$var$readContext($d52e344c7cd7d393$var$HostTransitionContext);
}
function $d52e344c7cd7d393$var$updateId() {
    return $d52e344c7cd7d393$var$updateWorkInProgressHook().memoizedState;
}
function $d52e344c7cd7d393$var$updateRefresh() {
    return $d52e344c7cd7d393$var$updateWorkInProgressHook().memoizedState;
}
function $d52e344c7cd7d393$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $d52e344c7cd7d393$var$requestUpdateLane();
                fiber = $d52e344c7cd7d393$var$createUpdate(lane);
                var root$41 = $d52e344c7cd7d393$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(root$41, provider, lane), $d52e344c7cd7d393$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $d52e344c7cd7d393$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $d52e344c7cd7d393$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $d52e344c7cd7d393$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $d52e344c7cd7d393$var$isRenderPhaseUpdate(fiber) ? $d52e344c7cd7d393$var$enqueueRenderPhaseUpdate(queue, action) : (action = $d52e344c7cd7d393$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(action, fiber, lane), $d52e344c7cd7d393$var$entangleTransitionUpdate(action, queue, lane)));
}
function $d52e344c7cd7d393$var$dispatchSetState(fiber, queue, action) {
    var lane = $d52e344c7cd7d393$var$requestUpdateLane();
    $d52e344c7cd7d393$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $d52e344c7cd7d393$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d52e344c7cd7d393$var$isRenderPhaseUpdate(fiber)) $d52e344c7cd7d393$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($d52e344c7cd7d393$var$objectIs(eagerState, currentState)) return $d52e344c7cd7d393$var$enqueueUpdate$1(fiber, queue, update, 0), null === $d52e344c7cd7d393$var$workInProgressRoot && $d52e344c7cd7d393$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $d52e344c7cd7d393$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $d52e344c7cd7d393$var$scheduleUpdateOnFiber(action, fiber, lane), $d52e344c7cd7d393$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $d52e344c7cd7d393$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $d52e344c7cd7d393$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($d52e344c7cd7d393$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $d52e344c7cd7d393$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $d52e344c7cd7d393$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $d52e344c7cd7d393$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $d52e344c7cd7d393$var$currentlyRenderingFiber || null !== alternate && alternate === $d52e344c7cd7d393$var$currentlyRenderingFiber;
}
function $d52e344c7cd7d393$var$enqueueRenderPhaseUpdate(queue, update) {
    $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdateDuringThisPass = $d52e344c7cd7d393$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $d52e344c7cd7d393$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $d52e344c7cd7d393$var$markRootEntangled(root, lane);
    }
}
var $d52e344c7cd7d393$var$ContextOnlyDispatcher = {
    readContext: $d52e344c7cd7d393$var$readContext,
    use: $d52e344c7cd7d393$var$use,
    useCallback: $d52e344c7cd7d393$var$throwInvalidHookError,
    useContext: $d52e344c7cd7d393$var$throwInvalidHookError,
    useEffect: $d52e344c7cd7d393$var$throwInvalidHookError,
    useImperativeHandle: $d52e344c7cd7d393$var$throwInvalidHookError,
    useLayoutEffect: $d52e344c7cd7d393$var$throwInvalidHookError,
    useInsertionEffect: $d52e344c7cd7d393$var$throwInvalidHookError,
    useMemo: $d52e344c7cd7d393$var$throwInvalidHookError,
    useReducer: $d52e344c7cd7d393$var$throwInvalidHookError,
    useRef: $d52e344c7cd7d393$var$throwInvalidHookError,
    useState: $d52e344c7cd7d393$var$throwInvalidHookError,
    useDebugValue: $d52e344c7cd7d393$var$throwInvalidHookError,
    useDeferredValue: $d52e344c7cd7d393$var$throwInvalidHookError,
    useTransition: $d52e344c7cd7d393$var$throwInvalidHookError,
    useSyncExternalStore: $d52e344c7cd7d393$var$throwInvalidHookError,
    useId: $d52e344c7cd7d393$var$throwInvalidHookError,
    useHostTransitionStatus: $d52e344c7cd7d393$var$throwInvalidHookError,
    useFormState: $d52e344c7cd7d393$var$throwInvalidHookError,
    useActionState: $d52e344c7cd7d393$var$throwInvalidHookError,
    useOptimistic: $d52e344c7cd7d393$var$throwInvalidHookError,
    useMemoCache: $d52e344c7cd7d393$var$throwInvalidHookError,
    useCacheRefresh: $d52e344c7cd7d393$var$throwInvalidHookError
}, $d52e344c7cd7d393$var$HooksDispatcherOnMount = {
    readContext: $d52e344c7cd7d393$var$readContext,
    use: $d52e344c7cd7d393$var$use,
    useCallback: function(callback, deps) {
        $d52e344c7cd7d393$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $d52e344c7cd7d393$var$readContext,
    useEffect: $d52e344c7cd7d393$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $d52e344c7cd7d393$var$mountEffectImpl(4194308, 4, $d52e344c7cd7d393$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $d52e344c7cd7d393$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $d52e344c7cd7d393$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($d52e344c7cd7d393$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $d52e344c7cd7d393$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $d52e344c7cd7d393$var$dispatchReducerAction.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $d52e344c7cd7d393$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $d52e344c7cd7d393$var$dispatchSetState.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $d52e344c7cd7d393$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        return $d52e344c7cd7d393$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $d52e344c7cd7d393$var$mountStateImpl(!1);
        stateHook = $d52e344c7cd7d393$var$startTransition.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $d52e344c7cd7d393$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $d52e344c7cd7d393$var$currentlyRenderingFiber, hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        if ($d52e344c7cd7d393$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $d52e344c7cd7d393$var$workInProgressRoot) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(349));
            0 !== ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 124) || $d52e344c7cd7d393$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $d52e344c7cd7d393$var$mountEffect($d52e344c7cd7d393$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $d52e344c7cd7d393$var$pushSimpleEffect(9, $d52e344c7cd7d393$var$createEffectInstance(), $d52e344c7cd7d393$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook(), identifierPrefix = $d52e344c7cd7d393$var$workInProgressRoot.identifierPrefix;
        if ($d52e344c7cd7d393$var$isHydrating) {
            var JSCompiler_inline_result = $d52e344c7cd7d393$var$treeContextOverflow;
            var idWithLeadingBit = $d52e344c7cd7d393$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $d52e344c7cd7d393$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $d52e344c7cd7d393$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $d52e344c7cd7d393$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $d52e344c7cd7d393$var$useHostTransitionStatus,
    useFormState: $d52e344c7cd7d393$var$mountActionState,
    useActionState: $d52e344c7cd7d393$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $d52e344c7cd7d393$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $d52e344c7cd7d393$var$dispatchOptimisticSetState.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $d52e344c7cd7d393$var$useMemoCache,
    useCacheRefresh: function() {
        return $d52e344c7cd7d393$var$mountWorkInProgressHook().memoizedState = $d52e344c7cd7d393$var$refreshCache.bind(null, $d52e344c7cd7d393$var$currentlyRenderingFiber);
    }
}, $d52e344c7cd7d393$var$HooksDispatcherOnUpdate = {
    readContext: $d52e344c7cd7d393$var$readContext,
    use: $d52e344c7cd7d393$var$use,
    useCallback: $d52e344c7cd7d393$var$updateCallback,
    useContext: $d52e344c7cd7d393$var$readContext,
    useEffect: $d52e344c7cd7d393$var$updateEffect,
    useImperativeHandle: $d52e344c7cd7d393$var$updateImperativeHandle,
    useInsertionEffect: $d52e344c7cd7d393$var$updateInsertionEffect,
    useLayoutEffect: $d52e344c7cd7d393$var$updateLayoutEffect,
    useMemo: $d52e344c7cd7d393$var$updateMemo,
    useReducer: $d52e344c7cd7d393$var$updateReducer,
    useRef: $d52e344c7cd7d393$var$updateRef,
    useState: function() {
        return $d52e344c7cd7d393$var$updateReducer($d52e344c7cd7d393$var$basicStateReducer);
    },
    useDebugValue: $d52e344c7cd7d393$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
        return $d52e344c7cd7d393$var$updateDeferredValueImpl(hook, $d52e344c7cd7d393$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d52e344c7cd7d393$var$updateReducer($d52e344c7cd7d393$var$basicStateReducer)[0], start = $d52e344c7cd7d393$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d52e344c7cd7d393$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d52e344c7cd7d393$var$updateSyncExternalStore,
    useId: $d52e344c7cd7d393$var$updateId,
    useHostTransitionStatus: $d52e344c7cd7d393$var$useHostTransitionStatus,
    useFormState: $d52e344c7cd7d393$var$updateActionState,
    useActionState: $d52e344c7cd7d393$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
        return $d52e344c7cd7d393$var$updateOptimisticImpl(hook, $d52e344c7cd7d393$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $d52e344c7cd7d393$var$useMemoCache,
    useCacheRefresh: $d52e344c7cd7d393$var$updateRefresh
}, $d52e344c7cd7d393$var$HooksDispatcherOnRerender = {
    readContext: $d52e344c7cd7d393$var$readContext,
    use: $d52e344c7cd7d393$var$use,
    useCallback: $d52e344c7cd7d393$var$updateCallback,
    useContext: $d52e344c7cd7d393$var$readContext,
    useEffect: $d52e344c7cd7d393$var$updateEffect,
    useImperativeHandle: $d52e344c7cd7d393$var$updateImperativeHandle,
    useInsertionEffect: $d52e344c7cd7d393$var$updateInsertionEffect,
    useLayoutEffect: $d52e344c7cd7d393$var$updateLayoutEffect,
    useMemo: $d52e344c7cd7d393$var$updateMemo,
    useReducer: $d52e344c7cd7d393$var$rerenderReducer,
    useRef: $d52e344c7cd7d393$var$updateRef,
    useState: function() {
        return $d52e344c7cd7d393$var$rerenderReducer($d52e344c7cd7d393$var$basicStateReducer);
    },
    useDebugValue: $d52e344c7cd7d393$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
        return null === $d52e344c7cd7d393$var$currentHook ? $d52e344c7cd7d393$var$mountDeferredValueImpl(hook, value, initialValue) : $d52e344c7cd7d393$var$updateDeferredValueImpl(hook, $d52e344c7cd7d393$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $d52e344c7cd7d393$var$rerenderReducer($d52e344c7cd7d393$var$basicStateReducer)[0], start = $d52e344c7cd7d393$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $d52e344c7cd7d393$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $d52e344c7cd7d393$var$updateSyncExternalStore,
    useId: $d52e344c7cd7d393$var$updateId,
    useHostTransitionStatus: $d52e344c7cd7d393$var$useHostTransitionStatus,
    useFormState: $d52e344c7cd7d393$var$rerenderActionState,
    useActionState: $d52e344c7cd7d393$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $d52e344c7cd7d393$var$updateWorkInProgressHook();
        if (null !== $d52e344c7cd7d393$var$currentHook) return $d52e344c7cd7d393$var$updateOptimisticImpl(hook, $d52e344c7cd7d393$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $d52e344c7cd7d393$var$useMemoCache,
    useCacheRefresh: $d52e344c7cd7d393$var$updateRefresh
}, $d52e344c7cd7d393$var$thenableState = null, $d52e344c7cd7d393$var$thenableIndexCounter = 0;
function $d52e344c7cd7d393$var$unwrapThenable(thenable) {
    var index = $d52e344c7cd7d393$var$thenableIndexCounter;
    $d52e344c7cd7d393$var$thenableIndexCounter += 1;
    null === $d52e344c7cd7d393$var$thenableState && ($d52e344c7cd7d393$var$thenableState = []);
    return $d52e344c7cd7d393$var$trackUsedThenable($d52e344c7cd7d393$var$thenableState, thenable, index);
}
function $d52e344c7cd7d393$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $d52e344c7cd7d393$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $d52e344c7cd7d393$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $d52e344c7cd7d393$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $d52e344c7cd7d393$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $d52e344c7cd7d393$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $d52e344c7cd7d393$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $d52e344c7cd7d393$var$REACT_LAZY_TYPE && $d52e344c7cd7d393$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $d52e344c7cd7d393$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $d52e344c7cd7d393$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $d52e344c7cd7d393$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $d52e344c7cd7d393$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $d52e344c7cd7d393$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $d52e344c7cd7d393$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d52e344c7cd7d393$var$REACT_ELEMENT_TYPE:
                    return lanes = $d52e344c7cd7d393$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d52e344c7cd7d393$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $d52e344c7cd7d393$var$REACT_PORTAL_TYPE:
                    return newChild = $d52e344c7cd7d393$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($d52e344c7cd7d393$var$isArrayImpl(newChild) || $d52e344c7cd7d393$var$getIteratorFn(newChild)) return newChild = $d52e344c7cd7d393$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $d52e344c7cd7d393$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $d52e344c7cd7d393$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d52e344c7cd7d393$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d52e344c7cd7d393$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $d52e344c7cd7d393$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($d52e344c7cd7d393$var$isArrayImpl(newChild) || $d52e344c7cd7d393$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $d52e344c7cd7d393$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $d52e344c7cd7d393$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d52e344c7cd7d393$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d52e344c7cd7d393$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $d52e344c7cd7d393$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($d52e344c7cd7d393$var$isArrayImpl(newChild) || $d52e344c7cd7d393$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $d52e344c7cd7d393$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $d52e344c7cd7d393$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d52e344c7cd7d393$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $d52e344c7cd7d393$var$isHydrating && $d52e344c7cd7d393$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $d52e344c7cd7d393$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $d52e344c7cd7d393$var$REACT_LAZY_TYPE && $d52e344c7cd7d393$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $d52e344c7cd7d393$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $d52e344c7cd7d393$var$REACT_FRAGMENT_TYPE ? (lanes = $d52e344c7cd7d393$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $d52e344c7cd7d393$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $d52e344c7cd7d393$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $d52e344c7cd7d393$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $d52e344c7cd7d393$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $d52e344c7cd7d393$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($d52e344c7cd7d393$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($d52e344c7cd7d393$var$getIteratorFn(newChild)) {
                key = $d52e344c7cd7d393$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d52e344c7cd7d393$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $d52e344c7cd7d393$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $d52e344c7cd7d393$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $d52e344c7cd7d393$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $d52e344c7cd7d393$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $d52e344c7cd7d393$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $d52e344c7cd7d393$var$SuspenseException || x === $d52e344c7cd7d393$var$SuspenseActionException) throw x;
            var fiber = $d52e344c7cd7d393$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $d52e344c7cd7d393$var$reconcileChildFibers = $d52e344c7cd7d393$var$createChildReconciler(!0), $d52e344c7cd7d393$var$mountChildFibers = $d52e344c7cd7d393$var$createChildReconciler(!1), $d52e344c7cd7d393$var$suspenseHandlerStackCursor = $d52e344c7cd7d393$var$createCursor(null), $d52e344c7cd7d393$var$shellBoundary = null;
function $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, $d52e344c7cd7d393$var$suspenseStackCursor.current & 1);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseHandlerStackCursor, handler);
    null === $d52e344c7cd7d393$var$shellBoundary && (null === current || null !== $d52e344c7cd7d393$var$currentTreeHiddenStackCursor.current ? $d52e344c7cd7d393$var$shellBoundary = handler : null !== current.memoizedState && ($d52e344c7cd7d393$var$shellBoundary = handler));
}
function $d52e344c7cd7d393$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, $d52e344c7cd7d393$var$suspenseStackCursor.current), $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseHandlerStackCursor, fiber), null === $d52e344c7cd7d393$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($d52e344c7cd7d393$var$shellBoundary = fiber);
        }
    } else $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(fiber);
}
function $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack() {
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, $d52e344c7cd7d393$var$suspenseStackCursor.current);
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseHandlerStackCursor, $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current);
}
function $d52e344c7cd7d393$var$popSuspenseHandler(fiber) {
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$suspenseHandlerStackCursor);
    $d52e344c7cd7d393$var$shellBoundary === fiber && ($d52e344c7cd7d393$var$shellBoundary = null);
    $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$suspenseStackCursor);
}
var $d52e344c7cd7d393$var$suspenseStackCursor = $d52e344c7cd7d393$var$createCursor(0);
function $d52e344c7cd7d393$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $d52e344c7cd7d393$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $d52e344c7cd7d393$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $d52e344c7cd7d393$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $d52e344c7cd7d393$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d52e344c7cd7d393$var$requestUpdateLane(), update = $d52e344c7cd7d393$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d52e344c7cd7d393$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(payload, inst, lane), $d52e344c7cd7d393$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $d52e344c7cd7d393$var$requestUpdateLane(), update = $d52e344c7cd7d393$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $d52e344c7cd7d393$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(payload, inst, lane), $d52e344c7cd7d393$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $d52e344c7cd7d393$var$requestUpdateLane(), update = $d52e344c7cd7d393$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $d52e344c7cd7d393$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(callback, inst, lane), $d52e344c7cd7d393$var$entangleTransitions(callback, inst, lane));
    }
};
function $d52e344c7cd7d393$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$d52e344c7cd7d393$var$shallowEqual(oldProps, newProps) || !$d52e344c7cd7d393$var$shallowEqual(oldState, newState) : !0;
}
function $d52e344c7cd7d393$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $d52e344c7cd7d393$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $d52e344c7cd7d393$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $d52e344c7cd7d393$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $d52e344c7cd7d393$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $d52e344c7cd7d393$var$defaultOnUncaughtError(error) {
    $d52e344c7cd7d393$var$reportGlobalError(error);
}
function $d52e344c7cd7d393$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $d52e344c7cd7d393$var$defaultOnRecoverableError(error) {
    $d52e344c7cd7d393$var$reportGlobalError(error);
}
function $d52e344c7cd7d393$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $d52e344c7cd7d393$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $d52e344c7cd7d393$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $d52e344c7cd7d393$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $d52e344c7cd7d393$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $d52e344c7cd7d393$var$createClassErrorUpdate(lane) {
    lane = $d52e344c7cd7d393$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $d52e344c7cd7d393$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $d52e344c7cd7d393$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $d52e344c7cd7d393$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed ? $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $d52e344c7cd7d393$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $d52e344c7cd7d393$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $d52e344c7cd7d393$var$shellBoundary ? $d52e344c7cd7d393$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $d52e344c7cd7d393$var$workInProgressRootExitStatus && ($d52e344c7cd7d393$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $d52e344c7cd7d393$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $d52e344c7cd7d393$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $d52e344c7cd7d393$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $d52e344c7cd7d393$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $d52e344c7cd7d393$var$attachPingListener(root, value, rootRenderLanes);
        $d52e344c7cd7d393$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($d52e344c7cd7d393$var$isHydrating) return returnFiber = $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $d52e344c7cd7d393$var$HydrationMismatchException && (root = Error($d52e344c7cd7d393$var$formatProdErrorMessage(422), {
        cause: value
    }), $d52e344c7cd7d393$var$queueHydrationError($d52e344c7cd7d393$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $d52e344c7cd7d393$var$HydrationMismatchException && (returnFiber = Error($d52e344c7cd7d393$var$formatProdErrorMessage(423), {
        cause: value
    }), $d52e344c7cd7d393$var$queueHydrationError($d52e344c7cd7d393$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $d52e344c7cd7d393$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $d52e344c7cd7d393$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $d52e344c7cd7d393$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $d52e344c7cd7d393$var$workInProgressRootExitStatus && ($d52e344c7cd7d393$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($d52e344c7cd7d393$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $d52e344c7cd7d393$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors ? $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $d52e344c7cd7d393$var$workInProgressRootExitStatus && ($d52e344c7cd7d393$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $d52e344c7cd7d393$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $d52e344c7cd7d393$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $d52e344c7cd7d393$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed || !$d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $d52e344c7cd7d393$var$createClassErrorUpdate(rootRenderLanes), $d52e344c7cd7d393$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $d52e344c7cd7d393$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $d52e344c7cd7d393$var$SelectiveHydrationException = Error($d52e344c7cd7d393$var$formatProdErrorMessage(461)), $d52e344c7cd7d393$var$didReceiveUpdate = !1;
function $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $d52e344c7cd7d393$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $d52e344c7cd7d393$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $d52e344c7cd7d393$var$prepareToReadContext(workInProgress);
    nextProps = $d52e344c7cd7d393$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $d52e344c7cd7d393$var$checkDidRenderIdHook();
    if (null !== current && !$d52e344c7cd7d393$var$didReceiveUpdate) return $d52e344c7cd7d393$var$bailoutHooks(current, workInProgress, renderLanes), $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d52e344c7cd7d393$var$isHydrating && key && $d52e344c7cd7d393$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$d52e344c7cd7d393$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $d52e344c7cd7d393$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $d52e344c7cd7d393$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$d52e344c7cd7d393$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $d52e344c7cd7d393$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $d52e344c7cd7d393$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $d52e344c7cd7d393$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($d52e344c7cd7d393$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($d52e344c7cd7d393$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $d52e344c7cd7d393$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($d52e344c7cd7d393$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $d52e344c7cd7d393$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $d52e344c7cd7d393$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $d52e344c7cd7d393$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $d52e344c7cd7d393$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $d52e344c7cd7d393$var$pushHiddenContext(workInProgress, prevState) : $d52e344c7cd7d393$var$reuseHiddenContextOnStack(), $d52e344c7cd7d393$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $d52e344c7cd7d393$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($d52e344c7cd7d393$var$pushTransition(workInProgress, prevState.cachePool), $d52e344c7cd7d393$var$pushHiddenContext(workInProgress, prevState), $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $d52e344c7cd7d393$var$pushTransition(workInProgress, null), $d52e344c7cd7d393$var$reuseHiddenContextOnStack(), $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress));
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $d52e344c7cd7d393$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $d52e344c7cd7d393$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $d52e344c7cd7d393$var$pushTransition(workInProgress, null);
    $d52e344c7cd7d393$var$reuseHiddenContextOnStack();
    $d52e344c7cd7d393$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $d52e344c7cd7d393$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $d52e344c7cd7d393$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $d52e344c7cd7d393$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d52e344c7cd7d393$var$prepareToReadContext(workInProgress);
    Component = $d52e344c7cd7d393$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $d52e344c7cd7d393$var$checkDidRenderIdHook();
    if (null !== current && !$d52e344c7cd7d393$var$didReceiveUpdate) return $d52e344c7cd7d393$var$bailoutHooks(current, workInProgress, renderLanes), $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d52e344c7cd7d393$var$isHydrating && nextProps && $d52e344c7cd7d393$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $d52e344c7cd7d393$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $d52e344c7cd7d393$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $d52e344c7cd7d393$var$finishRenderingHooks(current);
    Component = $d52e344c7cd7d393$var$checkDidRenderIdHook();
    if (null !== current && !$d52e344c7cd7d393$var$didReceiveUpdate) return $d52e344c7cd7d393$var$bailoutHooks(current, workInProgress, renderLanes), $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $d52e344c7cd7d393$var$isHydrating && Component && $d52e344c7cd7d393$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $d52e344c7cd7d393$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $d52e344c7cd7d393$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $d52e344c7cd7d393$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $d52e344c7cd7d393$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $d52e344c7cd7d393$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $d52e344c7cd7d393$var$readContext(contextType) : $d52e344c7cd7d393$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($d52e344c7cd7d393$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $d52e344c7cd7d393$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $d52e344c7cd7d393$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $d52e344c7cd7d393$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $d52e344c7cd7d393$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $d52e344c7cd7d393$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $d52e344c7cd7d393$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $d52e344c7cd7d393$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d52e344c7cd7d393$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $d52e344c7cd7d393$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($d52e344c7cd7d393$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $d52e344c7cd7d393$var$hasForceUpdate || $d52e344c7cd7d393$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $d52e344c7cd7d393$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $d52e344c7cd7d393$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $d52e344c7cd7d393$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $d52e344c7cd7d393$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $d52e344c7cd7d393$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $d52e344c7cd7d393$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $d52e344c7cd7d393$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $d52e344c7cd7d393$var$hasForceUpdate || null !== current && null !== current.dependencies && $d52e344c7cd7d393$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($d52e344c7cd7d393$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $d52e344c7cd7d393$var$hasForceUpdate || $d52e344c7cd7d393$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $d52e344c7cd7d393$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $d52e344c7cd7d393$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $d52e344c7cd7d393$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $d52e344c7cd7d393$var$resetHydrationState();
    workInProgress.flags |= 256;
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $d52e344c7cd7d393$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $d52e344c7cd7d393$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $d52e344c7cd7d393$var$getSuspendedCache()
    };
}
function $d52e344c7cd7d393$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $d52e344c7cd7d393$var$workInProgressDeferredLane);
    return current;
}
function $d52e344c7cd7d393$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($d52e344c7cd7d393$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($d52e344c7cd7d393$var$isHydrating) {
            showFallback ? $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($d52e344c7cd7d393$var$isHydrating) {
                var nextInstance = $d52e344c7cd7d393$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $d52e344c7cd7d393$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $d52e344c7cd7d393$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $d52e344c7cd7d393$var$treeContextProvider ? {
                            id: $d52e344c7cd7d393$var$treeContextId,
                            overflow: $d52e344c7cd7d393$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $d52e344c7cd7d393$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress, $d52e344c7cd7d393$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $d52e344c7cd7d393$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $d52e344c7cd7d393$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $d52e344c7cd7d393$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $d52e344c7cd7d393$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $d52e344c7cd7d393$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $d52e344c7cd7d393$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d52e344c7cd7d393$var$SUSPENDED_MARKER, nextProps;
        $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $d52e344c7cd7d393$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $d52e344c7cd7d393$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $d52e344c7cd7d393$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $d52e344c7cd7d393$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $d52e344c7cd7d393$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $d52e344c7cd7d393$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d52e344c7cd7d393$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress), $d52e344c7cd7d393$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($d52e344c7cd7d393$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $d52e344c7cd7d393$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $d52e344c7cd7d393$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($d52e344c7cd7d393$var$didReceiveUpdate || $d52e344c7cd7d393$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $d52e344c7cd7d393$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $d52e344c7cd7d393$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $d52e344c7cd7d393$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(current, nextProps), $d52e344c7cd7d393$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $d52e344c7cd7d393$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $d52e344c7cd7d393$var$renderDidSuspendDelayIfPossible();
            workInProgress = $d52e344c7cd7d393$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(nextInstance.nextSibling), $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress, $d52e344c7cd7d393$var$isHydrating = !0, $d52e344c7cd7d393$var$hydrationErrors = null, $d52e344c7cd7d393$var$rootOrSingletonContext = !1, null !== current && ($d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextId, $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextOverflow, $d52e344c7cd7d393$var$idStack[$d52e344c7cd7d393$var$idStackIndex++] = $d52e344c7cd7d393$var$treeContextProvider, $d52e344c7cd7d393$var$treeContextId = current.id, $d52e344c7cd7d393$var$treeContextOverflow = current.overflow, $d52e344c7cd7d393$var$treeContextProvider = workInProgress), workInProgress = $d52e344c7cd7d393$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $d52e344c7cd7d393$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $d52e344c7cd7d393$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $d52e344c7cd7d393$var$createWorkInProgress(digest, showFallback) : (showFallback = $d52e344c7cd7d393$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $d52e344c7cd7d393$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $d52e344c7cd7d393$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $d52e344c7cd7d393$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $d52e344c7cd7d393$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $d52e344c7cd7d393$var$SUSPENDED_MARKER, nextProps;
    $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $d52e344c7cd7d393$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $d52e344c7cd7d393$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $d52e344c7cd7d393$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $d52e344c7cd7d393$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $d52e344c7cd7d393$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $d52e344c7cd7d393$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $d52e344c7cd7d393$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $d52e344c7cd7d393$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $d52e344c7cd7d393$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $d52e344c7cd7d393$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $d52e344c7cd7d393$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $d52e344c7cd7d393$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $d52e344c7cd7d393$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $d52e344c7cd7d393$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $d52e344c7cd7d393$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $d52e344c7cd7d393$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $d52e344c7cd7d393$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $d52e344c7cd7d393$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $d52e344c7cd7d393$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $d52e344c7cd7d393$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($d52e344c7cd7d393$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $d52e344c7cd7d393$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $d52e344c7cd7d393$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $d52e344c7cd7d393$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $d52e344c7cd7d393$var$checkIfContextChanged(current) ? !0 : !1;
}
function $d52e344c7cd7d393$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $d52e344c7cd7d393$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, current.memoizedState.cache);
            $d52e344c7cd7d393$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $d52e344c7cd7d393$var$pushHostContext(workInProgress);
            break;
        case 4:
            $d52e344c7cd7d393$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $d52e344c7cd7d393$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $d52e344c7cd7d393$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $d52e344c7cd7d393$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($d52e344c7cd7d393$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $d52e344c7cd7d393$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, $d52e344c7cd7d393$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $d52e344c7cd7d393$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, current.memoizedState.cache);
    }
    return $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $d52e344c7cd7d393$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $d52e344c7cd7d393$var$didReceiveUpdate = !0;
        else {
            if (!$d52e344c7cd7d393$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $d52e344c7cd7d393$var$didReceiveUpdate = !1, $d52e344c7cd7d393$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $d52e344c7cd7d393$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $d52e344c7cd7d393$var$didReceiveUpdate = !1, $d52e344c7cd7d393$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $d52e344c7cd7d393$var$pushTreeId(workInProgress, $d52e344c7cd7d393$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $d52e344c7cd7d393$var$shouldConstruct(lazyComponent) ? (current = $d52e344c7cd7d393$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $d52e344c7cd7d393$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $d52e344c7cd7d393$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $d52e344c7cd7d393$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $d52e344c7cd7d393$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $d52e344c7cd7d393$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $d52e344c7cd7d393$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $d52e344c7cd7d393$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $d52e344c7cd7d393$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $d52e344c7cd7d393$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $d52e344c7cd7d393$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $d52e344c7cd7d393$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $d52e344c7cd7d393$var$cloneUpdateQueue(current, workInProgress);
                $d52e344c7cd7d393$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $d52e344c7cd7d393$var$propagateContextChanges(workInProgress, [
                    $d52e344c7cd7d393$var$CacheContext
                ], renderLanes, !0);
                $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $d52e344c7cd7d393$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $d52e344c7cd7d393$var$createCapturedValueAtFiber(Error($d52e344c7cd7d393$var$formatProdErrorMessage(424)), workInProgress);
                        $d52e344c7cd7d393$var$queueHydrationError(init);
                        workInProgress = $d52e344c7cd7d393$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(current.firstChild);
                        $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress;
                        $d52e344c7cd7d393$var$isHydrating = !0;
                        $d52e344c7cd7d393$var$hydrationErrors = null;
                        $d52e344c7cd7d393$var$rootOrSingletonContext = !0;
                        renderLanes = $d52e344c7cd7d393$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $d52e344c7cd7d393$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $d52e344c7cd7d393$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $d52e344c7cd7d393$var$markRef(current, workInProgress), null === current ? (renderLanes = $d52e344c7cd7d393$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $d52e344c7cd7d393$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $d52e344c7cd7d393$var$getOwnerDocumentFromRootContainer($d52e344c7cd7d393$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$d52e344c7cd7d393$var$internalInstanceKey] = workInProgress, lazyComponent[$d52e344c7cd7d393$var$internalPropsKey] = current, $d52e344c7cd7d393$var$setInitialProperties(lazyComponent, renderLanes, current), $d52e344c7cd7d393$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $d52e344c7cd7d393$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $d52e344c7cd7d393$var$pushHostContext(workInProgress), null === current && $d52e344c7cd7d393$var$isHydrating && (lazyComponent = workInProgress.stateNode = $d52e344c7cd7d393$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $d52e344c7cd7d393$var$rootInstanceStackCursor.current), $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress, $d52e344c7cd7d393$var$rootOrSingletonContext = !0, init = $d52e344c7cd7d393$var$nextHydratableInstance, $d52e344c7cd7d393$var$isSingletonScope(workInProgress.type) ? ($d52e344c7cd7d393$var$previousHydratableOnEnteringScopedSingleton = init, $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(lazyComponent.firstChild)) : $d52e344c7cd7d393$var$nextHydratableInstance = init), $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $d52e344c7cd7d393$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $d52e344c7cd7d393$var$isHydrating) {
                if (init = lazyComponent = $d52e344c7cd7d393$var$nextHydratableInstance) lazyComponent = $d52e344c7cd7d393$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $d52e344c7cd7d393$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress, $d52e344c7cd7d393$var$nextHydratableInstance = $d52e344c7cd7d393$var$getNextHydratable(lazyComponent.firstChild), $d52e344c7cd7d393$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $d52e344c7cd7d393$var$throwOnHydrationMismatch(workInProgress);
            }
            $d52e344c7cd7d393$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $d52e344c7cd7d393$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $d52e344c7cd7d393$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $d52e344c7cd7d393$var$renderWithHooks(current, workInProgress, $d52e344c7cd7d393$var$TransitionAwareHostComponent, null, null, renderLanes), $d52e344c7cd7d393$var$HostTransitionContext._currentValue = init);
            $d52e344c7cd7d393$var$markRef(current, workInProgress);
            $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $d52e344c7cd7d393$var$isHydrating) {
                if (current = renderLanes = $d52e344c7cd7d393$var$nextHydratableInstance) renderLanes = $d52e344c7cd7d393$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $d52e344c7cd7d393$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $d52e344c7cd7d393$var$hydrationParentFiber = workInProgress, $d52e344c7cd7d393$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $d52e344c7cd7d393$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $d52e344c7cd7d393$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $d52e344c7cd7d393$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $d52e344c7cd7d393$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $d52e344c7cd7d393$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $d52e344c7cd7d393$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $d52e344c7cd7d393$var$prepareToReadContext(workInProgress), init = $d52e344c7cd7d393$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $d52e344c7cd7d393$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $d52e344c7cd7d393$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $d52e344c7cd7d393$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $d52e344c7cd7d393$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $d52e344c7cd7d393$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $d52e344c7cd7d393$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $d52e344c7cd7d393$var$prepareToReadContext(workInProgress), lazyComponent = $d52e344c7cd7d393$var$readContext($d52e344c7cd7d393$var$CacheContext), null === current ? (init = $d52e344c7cd7d393$var$peekCacheFromPool(), null === init && (init = $d52e344c7cd7d393$var$workInProgressRoot, prevState = $d52e344c7cd7d393$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $d52e344c7cd7d393$var$initializeUpdateQueue(workInProgress), $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($d52e344c7cd7d393$var$cloneUpdateQueue(current, workInProgress), $d52e344c7cd7d393$var$processUpdateQueue(workInProgress, null, null, renderLanes), $d52e344c7cd7d393$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $d52e344c7cd7d393$var$pushProvider(workInProgress, $d52e344c7cd7d393$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $d52e344c7cd7d393$var$propagateContextChanges(workInProgress, [
                $d52e344c7cd7d393$var$CacheContext
            ], renderLanes, !0))), $d52e344c7cd7d393$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d52e344c7cd7d393$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $d52e344c7cd7d393$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$d52e344c7cd7d393$var$preloadResource(resource)) {
        resource = $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 4194048) === $d52e344c7cd7d393$var$workInProgressRootRenderLanes ? null !== $d52e344c7cd7d393$var$shellBoundary : ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 62914560) !== $d52e344c7cd7d393$var$workInProgressRootRenderLanes && 0 === ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 536870912) || resource !== $d52e344c7cd7d393$var$shellBoundary)) throw $d52e344c7cd7d393$var$suspendedThenable = $d52e344c7cd7d393$var$noopSuspenseyCommitThenable, $d52e344c7cd7d393$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $d52e344c7cd7d393$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $d52e344c7cd7d393$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $d52e344c7cd7d393$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$d52e344c7cd7d393$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $d52e344c7cd7d393$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $d52e344c7cd7d393$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $d52e344c7cd7d393$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
        case 1:
            return $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext);
            $d52e344c7cd7d393$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $d52e344c7cd7d393$var$popHydrationState(workInProgress) ? $d52e344c7cd7d393$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $d52e344c7cd7d393$var$upgradeHydrationErrorsToRecoverable());
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($d52e344c7cd7d393$var$markUpdate(workInProgress), null !== renderLanes ? ($d52e344c7cd7d393$var$bubbleProperties(workInProgress), $d52e344c7cd7d393$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($d52e344c7cd7d393$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($d52e344c7cd7d393$var$markUpdate(workInProgress), $d52e344c7cd7d393$var$bubbleProperties(workInProgress), $d52e344c7cd7d393$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($d52e344c7cd7d393$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $d52e344c7cd7d393$var$markUpdate(workInProgress), $d52e344c7cd7d393$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $d52e344c7cd7d393$var$popHostContext(workInProgress);
            renderLanes = $d52e344c7cd7d393$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d52e344c7cd7d393$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(166));
                    $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $d52e344c7cd7d393$var$contextStackCursor.current;
                $d52e344c7cd7d393$var$popHydrationState(workInProgress) ? $d52e344c7cd7d393$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $d52e344c7cd7d393$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $d52e344c7cd7d393$var$markUpdate(workInProgress));
            }
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $d52e344c7cd7d393$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d52e344c7cd7d393$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(166));
                    $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $d52e344c7cd7d393$var$contextStackCursor.current;
                if ($d52e344c7cd7d393$var$popHydrationState(workInProgress)) $d52e344c7cd7d393$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $d52e344c7cd7d393$var$getOwnerDocumentFromRootContainer($d52e344c7cd7d393$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$d52e344c7cd7d393$var$internalInstanceKey] = workInProgress;
                    current[$d52e344c7cd7d393$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($d52e344c7cd7d393$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $d52e344c7cd7d393$var$markUpdate(workInProgress);
                }
            }
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $d52e344c7cd7d393$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(166));
                current = $d52e344c7cd7d393$var$rootInstanceStackCursor.current;
                if ($d52e344c7cd7d393$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $d52e344c7cd7d393$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$d52e344c7cd7d393$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $d52e344c7cd7d393$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $d52e344c7cd7d393$var$throwOnHydrationMismatch(workInProgress);
                } else current = $d52e344c7cd7d393$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$d52e344c7cd7d393$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $d52e344c7cd7d393$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(317));
                        type[$d52e344c7cd7d393$var$internalInstanceKey] = workInProgress;
                    } else $d52e344c7cd7d393$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $d52e344c7cd7d393$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress), workInProgress;
                    $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $d52e344c7cd7d393$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $d52e344c7cd7d393$var$popHostContainer(), null === current && $d52e344c7cd7d393$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
        case 10:
            return $d52e344c7cd7d393$var$popProvider(workInProgress.type), $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
        case 19:
            $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $d52e344c7cd7d393$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $d52e344c7cd7d393$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $d52e344c7cd7d393$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $d52e344c7cd7d393$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $d52e344c7cd7d393$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$d52e344c7cd7d393$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, $d52e344c7cd7d393$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $d52e344c7cd7d393$var$now() > $d52e344c7cd7d393$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $d52e344c7cd7d393$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $d52e344c7cd7d393$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $d52e344c7cd7d393$var$scheduleRetryEffect(workInProgress, current), $d52e344c7cd7d393$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$d52e344c7cd7d393$var$isHydrating) return $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
                    } else 2 * $d52e344c7cd7d393$var$now() - type.renderingStartTime > $d52e344c7cd7d393$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $d52e344c7cd7d393$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $d52e344c7cd7d393$var$now(), workInProgress.sibling = null, current = $d52e344c7cd7d393$var$suspenseStackCursor.current, $d52e344c7cd7d393$var$push($d52e344c7cd7d393$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $d52e344c7cd7d393$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress), $d52e344c7cd7d393$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($d52e344c7cd7d393$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $d52e344c7cd7d393$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $d52e344c7cd7d393$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext), $d52e344c7cd7d393$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $d52e344c7cd7d393$var$unwindWork(current, workInProgress) {
    $d52e344c7cd7d393$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext), $d52e344c7cd7d393$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $d52e344c7cd7d393$var$popHostContext(workInProgress), null;
        case 13:
            $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(340));
                $d52e344c7cd7d393$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$suspenseStackCursor), null;
        case 4:
            return $d52e344c7cd7d393$var$popHostContainer(), null;
        case 10:
            return $d52e344c7cd7d393$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $d52e344c7cd7d393$var$popSuspenseHandler(workInProgress), $d52e344c7cd7d393$var$popHiddenContext(), null !== current && $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $d52e344c7cd7d393$var$unwindInterruptedWork(current, interruptedWork) {
    $d52e344c7cd7d393$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext);
            $d52e344c7cd7d393$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $d52e344c7cd7d393$var$popHostContext(interruptedWork);
            break;
        case 4:
            $d52e344c7cd7d393$var$popHostContainer();
            break;
        case 13:
            $d52e344c7cd7d393$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$suspenseStackCursor);
            break;
        case 10:
            $d52e344c7cd7d393$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $d52e344c7cd7d393$var$popSuspenseHandler(interruptedWork);
            $d52e344c7cd7d393$var$popHiddenContext();
            null !== current && $d52e344c7cd7d393$var$pop($d52e344c7cd7d393$var$resumedCache);
            break;
        case 24:
            $d52e344c7cd7d393$var$popProvider($d52e344c7cd7d393$var$CacheContext);
    }
}
function $d52e344c7cd7d393$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d52e344c7cd7d393$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $d52e344c7cd7d393$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d52e344c7cd7d393$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $d52e344c7cd7d393$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $d52e344c7cd7d393$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $d52e344c7cd7d393$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d52e344c7cd7d393$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $d52e344c7cd7d393$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $d52e344c7cd7d393$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $d52e344c7cd7d393$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $d52e344c7cd7d393$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d52e344c7cd7d393$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $d52e344c7cd7d393$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$d52e344c7cd7d393$var$internalPropsKey] = newProps;
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d52e344c7cd7d393$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $d52e344c7cd7d393$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $d52e344c7cd7d393$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $d52e344c7cd7d393$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $d52e344c7cd7d393$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $d52e344c7cd7d393$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $d52e344c7cd7d393$var$noop$1));
    else if (4 !== tag && (27 === tag && $d52e344c7cd7d393$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($d52e344c7cd7d393$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$d52e344c7cd7d393$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $d52e344c7cd7d393$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $d52e344c7cd7d393$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($d52e344c7cd7d393$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$d52e344c7cd7d393$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $d52e344c7cd7d393$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $d52e344c7cd7d393$var$setInitialProperties(singleton, type, props);
        singleton[$d52e344c7cd7d393$var$internalInstanceKey] = finishedWork;
        singleton[$d52e344c7cd7d393$var$internalPropsKey] = props;
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $d52e344c7cd7d393$var$offscreenSubtreeIsHidden = !1, $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = !1, $d52e344c7cd7d393$var$needsFormReset = !1, $d52e344c7cd7d393$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $d52e344c7cd7d393$var$nextEffect = null;
function $d52e344c7cd7d393$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $d52e344c7cd7d393$var$eventsEnabled = $d52e344c7cd7d393$var$_enabled;
    root = $d52e344c7cd7d393$var$getActiveElementDeep(root);
    if ($d52e344c7cd7d393$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $d52e344c7cd7d393$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $d52e344c7cd7d393$var$_enabled = !1;
    for($d52e344c7cd7d393$var$nextEffect = firstChild; null !== $d52e344c7cd7d393$var$nextEffect;)if (firstChild = $d52e344c7cd7d393$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $d52e344c7cd7d393$var$nextEffect = root;
    else for(; null !== $d52e344c7cd7d393$var$nextEffect;){
        firstChild = $d52e344c7cd7d393$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $d52e344c7cd7d393$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $d52e344c7cd7d393$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $d52e344c7cd7d393$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $d52e344c7cd7d393$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $d52e344c7cd7d393$var$nextEffect = root;
            break;
        }
        $d52e344c7cd7d393$var$nextEffect = firstChild.return;
    }
}
function $d52e344c7cd7d393$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d52e344c7cd7d393$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $d52e344c7cd7d393$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $d52e344c7cd7d393$var$commitClassCallbacks(finishedWork);
            flags & 512 && $d52e344c7cd7d393$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $d52e344c7cd7d393$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $d52e344c7cd7d393$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $d52e344c7cd7d393$var$commitHostMount(finishedWork);
            flags & 512 && $d52e344c7cd7d393$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $d52e344c7cd7d393$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $d52e344c7cd7d393$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $d52e344c7cd7d393$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $d52e344c7cd7d393$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $d52e344c7cd7d393$var$offscreenSubtreeWasHidden;
                prevProps = $d52e344c7cd7d393$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $d52e344c7cd7d393$var$offscreenSubtreeWasHidden;
                $d52e344c7cd7d393$var$offscreenSubtreeIsHidden = flags;
                ($d52e344c7cd7d393$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $d52e344c7cd7d393$var$offscreenSubtreeIsHidden = prevProps;
                $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $d52e344c7cd7d393$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $d52e344c7cd7d393$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $d52e344c7cd7d393$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $d52e344c7cd7d393$var$hostParent = null, $d52e344c7cd7d393$var$hostParentIsContainer = !1;
function $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$d52e344c7cd7d393$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $d52e344c7cd7d393$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($d52e344c7cd7d393$var$injectedHook && "function" === typeof $d52e344c7cd7d393$var$injectedHook.onCommitFiberUnmount) try {
        $d52e344c7cd7d393$var$injectedHook.onCommitFiberUnmount($d52e344c7cd7d393$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $d52e344c7cd7d393$var$hostParent, prevHostParentIsContainer = $d52e344c7cd7d393$var$hostParentIsContainer;
            $d52e344c7cd7d393$var$isSingletonScope(deletedFiber.type) && ($d52e344c7cd7d393$var$hostParent = deletedFiber.stateNode, $d52e344c7cd7d393$var$hostParentIsContainer = !1);
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d52e344c7cd7d393$var$releaseSingletonInstance(deletedFiber.stateNode);
            $d52e344c7cd7d393$var$hostParent = prevHostParent;
            $d52e344c7cd7d393$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $d52e344c7cd7d393$var$hostParent;
            prevHostParentIsContainer = $d52e344c7cd7d393$var$hostParentIsContainer;
            $d52e344c7cd7d393$var$hostParent = null;
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d52e344c7cd7d393$var$hostParent = prevHostParent;
            $d52e344c7cd7d393$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $d52e344c7cd7d393$var$hostParent) {
                if ($d52e344c7cd7d393$var$hostParentIsContainer) try {
                    (9 === $d52e344c7cd7d393$var$hostParent.nodeType ? $d52e344c7cd7d393$var$hostParent.body : "HTML" === $d52e344c7cd7d393$var$hostParent.nodeName ? $d52e344c7cd7d393$var$hostParent.ownerDocument.body : $d52e344c7cd7d393$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $d52e344c7cd7d393$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $d52e344c7cd7d393$var$hostParent && ($d52e344c7cd7d393$var$hostParentIsContainer ? (finishedRoot = $d52e344c7cd7d393$var$hostParent, $d52e344c7cd7d393$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $d52e344c7cd7d393$var$retryIfBlockedOn(finishedRoot)) : $d52e344c7cd7d393$var$clearSuspenseBoundary($d52e344c7cd7d393$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $d52e344c7cd7d393$var$hostParent;
            prevHostParentIsContainer = $d52e344c7cd7d393$var$hostParentIsContainer;
            $d52e344c7cd7d393$var$hostParent = deletedFiber.stateNode.containerInfo;
            $d52e344c7cd7d393$var$hostParentIsContainer = !0;
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d52e344c7cd7d393$var$hostParent = prevHostParent;
            $d52e344c7cd7d393$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || ($d52e344c7cd7d393$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $d52e344c7cd7d393$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = (prevHostParent = $d52e344c7cd7d393$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $d52e344c7cd7d393$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $d52e344c7cd7d393$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $d52e344c7cd7d393$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $d52e344c7cd7d393$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $d52e344c7cd7d393$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $d52e344c7cd7d393$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $d52e344c7cd7d393$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $d52e344c7cd7d393$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($d52e344c7cd7d393$var$isSingletonScope(parent.type)) {
                        $d52e344c7cd7d393$var$hostParent = parent.stateNode;
                        $d52e344c7cd7d393$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $d52e344c7cd7d393$var$hostParent = parent.stateNode;
                    $d52e344c7cd7d393$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $d52e344c7cd7d393$var$hostParent = parent.stateNode.containerInfo;
                    $d52e344c7cd7d393$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $d52e344c7cd7d393$var$hostParent) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(160));
        $d52e344c7cd7d393$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $d52e344c7cd7d393$var$hostParent = null;
        $d52e344c7cd7d393$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$d52e344c7cd7d393$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $d52e344c7cd7d393$var$currentHoistableRoot = null;
function $d52e344c7cd7d393$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($d52e344c7cd7d393$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $d52e344c7cd7d393$var$commitHookEffectListMount(3, finishedWork), $d52e344c7cd7d393$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d52e344c7cd7d393$var$offscreenSubtreeWasHidden || null === current || $d52e344c7cd7d393$var$safelyDetachRef(current, current.return));
            flags & 64 && $d52e344c7cd7d393$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $d52e344c7cd7d393$var$currentHoistableRoot;
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d52e344c7cd7d393$var$offscreenSubtreeWasHidden || null === current || $d52e344c7cd7d393$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$d52e344c7cd7d393$var$internalHoistableMarker] || currentResource[$d52e344c7cd7d393$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $d52e344c7cd7d393$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$d52e344c7cd7d393$var$internalInstanceKey] = finishedWork;
                                        $d52e344c7cd7d393$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $d52e344c7cd7d393$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d52e344c7cd7d393$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $d52e344c7cd7d393$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $d52e344c7cd7d393$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$d52e344c7cd7d393$var$internalInstanceKey] = finishedWork;
                                $d52e344c7cd7d393$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $d52e344c7cd7d393$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $d52e344c7cd7d393$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $d52e344c7cd7d393$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $d52e344c7cd7d393$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $d52e344c7cd7d393$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d52e344c7cd7d393$var$offscreenSubtreeWasHidden || null === current || $d52e344c7cd7d393$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $d52e344c7cd7d393$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($d52e344c7cd7d393$var$offscreenSubtreeWasHidden || null === current || $d52e344c7cd7d393$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $d52e344c7cd7d393$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $d52e344c7cd7d393$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($d52e344c7cd7d393$var$needsFormReset = !0);
            break;
        case 6:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $d52e344c7cd7d393$var$tagCaches = null;
            hoistableRoot = $d52e344c7cd7d393$var$currentHoistableRoot;
            $d52e344c7cd7d393$var$currentHoistableRoot = $d52e344c7cd7d393$var$getHoistableRoot(root.containerInfo);
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$currentHoistableRoot = hoistableRoot;
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $d52e344c7cd7d393$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $d52e344c7cd7d393$var$needsFormReset && ($d52e344c7cd7d393$var$needsFormReset = !1, $d52e344c7cd7d393$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $d52e344c7cd7d393$var$currentHoistableRoot;
            $d52e344c7cd7d393$var$currentHoistableRoot = $d52e344c7cd7d393$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            $d52e344c7cd7d393$var$currentHoistableRoot = flags;
            break;
        case 12:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($d52e344c7cd7d393$var$globalMostRecentFallbackTime = $d52e344c7cd7d393$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d52e344c7cd7d393$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $d52e344c7cd7d393$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $d52e344c7cd7d393$var$offscreenSubtreeWasHidden;
            $d52e344c7cd7d393$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $d52e344c7cd7d393$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $d52e344c7cd7d393$var$offscreenSubtreeIsHidden || $d52e344c7cd7d393$var$offscreenSubtreeWasHidden || $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $d52e344c7cd7d393$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $d52e344c7cd7d393$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $d52e344c7cd7d393$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $d52e344c7cd7d393$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyTraverseMutationEffects(root, finishedWork), $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork);
    }
}
function $d52e344c7cd7d393$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($d52e344c7cd7d393$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $d52e344c7cd7d393$var$getHostSibling(finishedWork);
                    $d52e344c7cd7d393$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($d52e344c7cd7d393$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $d52e344c7cd7d393$var$getHostSibling(finishedWork);
                    $d52e344c7cd7d393$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $d52e344c7cd7d393$var$getHostSibling(finishedWork);
                    $d52e344c7cd7d393$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $d52e344c7cd7d393$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $d52e344c7cd7d393$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $d52e344c7cd7d393$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$d52e344c7cd7d393$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $d52e344c7cd7d393$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $d52e344c7cd7d393$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $d52e344c7cd7d393$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $d52e344c7cd7d393$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $d52e344c7cd7d393$var$safelyDetachRef(finishedWork, finishedWork.return);
                $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $d52e344c7cd7d393$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d52e344c7cd7d393$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$d52e344c7cd7d393$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $d52e344c7cd7d393$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $d52e344c7cd7d393$var$commitClassCallbacks(finishedWork);
                $d52e344c7cd7d393$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $d52e344c7cd7d393$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $d52e344c7cd7d393$var$commitHostMount(finishedWork);
                $d52e344c7cd7d393$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $d52e344c7cd7d393$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $d52e344c7cd7d393$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $d52e344c7cd7d393$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d52e344c7cd7d393$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $d52e344c7cd7d393$var$releaseCache(previousCache));
}
function $d52e344c7cd7d393$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $d52e344c7cd7d393$var$releaseCache(current));
}
function $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d52e344c7cd7d393$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $d52e344c7cd7d393$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d52e344c7cd7d393$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $d52e344c7cd7d393$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $d52e344c7cd7d393$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $d52e344c7cd7d393$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $d52e344c7cd7d393$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $d52e344c7cd7d393$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $d52e344c7cd7d393$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $d52e344c7cd7d393$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d52e344c7cd7d393$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d52e344c7cd7d393$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $d52e344c7cd7d393$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $d52e344c7cd7d393$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $d52e344c7cd7d393$var$suspenseyCommitFlag = 8192;
function $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $d52e344c7cd7d393$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$d52e344c7cd7d393$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $d52e344c7cd7d393$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $d52e344c7cd7d393$var$suspenseyCommitFlag && null !== fiber.memoizedState && $d52e344c7cd7d393$var$suspendResource($d52e344c7cd7d393$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $d52e344c7cd7d393$var$currentHoistableRoot;
            $d52e344c7cd7d393$var$currentHoistableRoot = $d52e344c7cd7d393$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $d52e344c7cd7d393$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $d52e344c7cd7d393$var$suspenseyCommitFlag, $d52e344c7cd7d393$var$suspenseyCommitFlag = 16777216, $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber), $d52e344c7cd7d393$var$suspenseyCommitFlag = previousHoistableRoot) : $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $d52e344c7cd7d393$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d52e344c7cd7d393$var$nextEffect = childToDelete;
            $d52e344c7cd7d393$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d52e344c7cd7d393$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$d52e344c7cd7d393$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $d52e344c7cd7d393$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $d52e344c7cd7d393$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $d52e344c7cd7d393$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $d52e344c7cd7d393$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $d52e344c7cd7d393$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $d52e344c7cd7d393$var$nextEffect = childToDelete;
            $d52e344c7cd7d393$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $d52e344c7cd7d393$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $d52e344c7cd7d393$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $d52e344c7cd7d393$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $d52e344c7cd7d393$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $d52e344c7cd7d393$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $d52e344c7cd7d393$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $d52e344c7cd7d393$var$nextEffect;){
        var fiber = $d52e344c7cd7d393$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $d52e344c7cd7d393$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $d52e344c7cd7d393$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $d52e344c7cd7d393$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $d52e344c7cd7d393$var$nextEffect;){
            cache = $d52e344c7cd7d393$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $d52e344c7cd7d393$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $d52e344c7cd7d393$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $d52e344c7cd7d393$var$nextEffect = sibling;
                break a;
            }
            $d52e344c7cd7d393$var$nextEffect = returnFiber;
        }
    }
}
var $d52e344c7cd7d393$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $d52e344c7cd7d393$var$readContext($d52e344c7cd7d393$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $d52e344c7cd7d393$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $d52e344c7cd7d393$var$executionContext = 0, $d52e344c7cd7d393$var$workInProgressRoot = null, $d52e344c7cd7d393$var$workInProgress = null, $d52e344c7cd7d393$var$workInProgressRootRenderLanes = 0, $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0, $d52e344c7cd7d393$var$workInProgressThrownValue = null, $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings = !1, $d52e344c7cd7d393$var$workInProgressRootIsPrerendering = !1, $d52e344c7cd7d393$var$workInProgressRootDidAttachPingListener = !1, $d52e344c7cd7d393$var$entangledRenderLanes = 0, $d52e344c7cd7d393$var$workInProgressRootExitStatus = 0, $d52e344c7cd7d393$var$workInProgressRootSkippedLanes = 0, $d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes = 0, $d52e344c7cd7d393$var$workInProgressRootPingedLanes = 0, $d52e344c7cd7d393$var$workInProgressDeferredLane = 0, $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes = 0, $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors = null, $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = null, $d52e344c7cd7d393$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $d52e344c7cd7d393$var$globalMostRecentFallbackTime = 0, $d52e344c7cd7d393$var$workInProgressRootRenderTargetTime = Infinity, $d52e344c7cd7d393$var$workInProgressTransitions = null, $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed = null, $d52e344c7cd7d393$var$pendingEffectsStatus = 0, $d52e344c7cd7d393$var$pendingEffectsRoot = null, $d52e344c7cd7d393$var$pendingFinishedWork = null, $d52e344c7cd7d393$var$pendingEffectsLanes = 0, $d52e344c7cd7d393$var$pendingEffectsRemainingLanes = 0, $d52e344c7cd7d393$var$pendingPassiveTransitions = null, $d52e344c7cd7d393$var$pendingRecoverableErrors = null, $d52e344c7cd7d393$var$nestedUpdateCount = 0, $d52e344c7cd7d393$var$rootWithNestedUpdates = null;
function $d52e344c7cd7d393$var$requestUpdateLane() {
    if (0 !== ($d52e344c7cd7d393$var$executionContext & 2) && 0 !== $d52e344c7cd7d393$var$workInProgressRootRenderLanes) return $d52e344c7cd7d393$var$workInProgressRootRenderLanes & -$d52e344c7cd7d393$var$workInProgressRootRenderLanes;
    if (null !== $d52e344c7cd7d393$var$ReactSharedInternals.T) {
        var actionScopeLane = $d52e344c7cd7d393$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $d52e344c7cd7d393$var$requestTransitionLane();
    }
    return $d52e344c7cd7d393$var$resolveUpdatePriority();
}
function $d52e344c7cd7d393$var$requestDeferredLane() {
    0 === $d52e344c7cd7d393$var$workInProgressDeferredLane && ($d52e344c7cd7d393$var$workInProgressDeferredLane = 0 === ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 536870912) || $d52e344c7cd7d393$var$isHydrating ? $d52e344c7cd7d393$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $d52e344c7cd7d393$var$workInProgressDeferredLane;
}
function $d52e344c7cd7d393$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $d52e344c7cd7d393$var$workInProgressRoot && (2 === $d52e344c7cd7d393$var$workInProgressSuspendedReason || 9 === $d52e344c7cd7d393$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $d52e344c7cd7d393$var$prepareFreshStack(root, 0), $d52e344c7cd7d393$var$markRootSuspended(root, $d52e344c7cd7d393$var$workInProgressRootRenderLanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, !1);
    $d52e344c7cd7d393$var$markRootUpdated$1(root, lane);
    if (0 === ($d52e344c7cd7d393$var$executionContext & 2) || root !== $d52e344c7cd7d393$var$workInProgressRoot) root === $d52e344c7cd7d393$var$workInProgressRoot && (0 === ($d52e344c7cd7d393$var$executionContext & 2) && ($d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $d52e344c7cd7d393$var$workInProgressRootExitStatus && $d52e344c7cd7d393$var$markRootSuspended(root, $d52e344c7cd7d393$var$workInProgressRootRenderLanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, !1)), $d52e344c7cd7d393$var$ensureRootIsScheduled(root);
}
function $d52e344c7cd7d393$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($d52e344c7cd7d393$var$executionContext & 6)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $d52e344c7cd7d393$var$renderRootConcurrent(root$jscomp$0, lanes) : $d52e344c7cd7d393$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $d52e344c7cd7d393$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $d52e344c7cd7d393$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$d52e344c7cd7d393$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $d52e344c7cd7d393$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($d52e344c7cd7d393$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $d52e344c7cd7d393$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($d52e344c7cd7d393$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors;
                            $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors ? $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors.push.apply($d52e344c7cd7d393$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $d52e344c7cd7d393$var$prepareFreshStack(root$jscomp$0, 0);
                $d52e344c7cd7d393$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $d52e344c7cd7d393$var$markRootSuspended(shouldTimeSlice, lanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, !$d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $d52e344c7cd7d393$var$globalMostRecentFallbackTime + 300 - $d52e344c7cd7d393$var$now(), 10 < exitStatus)) {
                    $d52e344c7cd7d393$var$markRootSuspended(shouldTimeSlice, lanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, !$d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $d52e344c7cd7d393$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $d52e344c7cd7d393$var$scheduleTimeout($d52e344c7cd7d393$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors, $d52e344c7cd7d393$var$workInProgressTransitions, $d52e344c7cd7d393$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, $d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes, $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes, $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $d52e344c7cd7d393$var$commitRootWhenReady(shouldTimeSlice, forceSync, $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors, $d52e344c7cd7d393$var$workInProgressTransitions, $d52e344c7cd7d393$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, $d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes, $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes, $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $d52e344c7cd7d393$var$ensureRootIsScheduled(root$jscomp$0);
}
function $d52e344c7cd7d393$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($d52e344c7cd7d393$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $d52e344c7cd7d393$var$noop
        }, $d52e344c7cd7d393$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $d52e344c7cd7d393$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($d52e344c7cd7d393$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $d52e344c7cd7d393$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $d52e344c7cd7d393$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $d52e344c7cd7d393$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$d52e344c7cd7d393$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $d52e344c7cd7d393$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$d52e344c7cd7d393$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $d52e344c7cd7d393$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $d52e344c7cd7d393$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $d52e344c7cd7d393$var$flushSyncWork$1() {
    return 0 === ($d52e344c7cd7d393$var$executionContext & 6) ? ($d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $d52e344c7cd7d393$var$resetWorkInProgressStack() {
    if (null !== $d52e344c7cd7d393$var$workInProgress) {
        if (0 === $d52e344c7cd7d393$var$workInProgressSuspendedReason) var interruptedWork = $d52e344c7cd7d393$var$workInProgress.return;
        else interruptedWork = $d52e344c7cd7d393$var$workInProgress, $d52e344c7cd7d393$var$lastContextDependency = $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = null, $d52e344c7cd7d393$var$resetHooksOnUnwind(interruptedWork), $d52e344c7cd7d393$var$thenableState = null, $d52e344c7cd7d393$var$thenableIndexCounter = 0, interruptedWork = $d52e344c7cd7d393$var$workInProgress;
        for(; null !== interruptedWork;)$d52e344c7cd7d393$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $d52e344c7cd7d393$var$workInProgress = null;
    }
}
function $d52e344c7cd7d393$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $d52e344c7cd7d393$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $d52e344c7cd7d393$var$resetWorkInProgressStack();
    $d52e344c7cd7d393$var$workInProgressRoot = root;
    $d52e344c7cd7d393$var$workInProgress = timeoutHandle = $d52e344c7cd7d393$var$createWorkInProgress(root.current, null);
    $d52e344c7cd7d393$var$workInProgressRootRenderLanes = lanes;
    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
    $d52e344c7cd7d393$var$workInProgressThrownValue = null;
    $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $d52e344c7cd7d393$var$workInProgressRootIsPrerendering = $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root, lanes);
    $d52e344c7cd7d393$var$workInProgressRootDidAttachPingListener = !1;
    $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes = $d52e344c7cd7d393$var$workInProgressDeferredLane = $d52e344c7cd7d393$var$workInProgressRootPingedLanes = $d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes = $d52e344c7cd7d393$var$workInProgressRootSkippedLanes = $d52e344c7cd7d393$var$workInProgressRootExitStatus = 0;
    $d52e344c7cd7d393$var$workInProgressRootRecoverableErrors = $d52e344c7cd7d393$var$workInProgressRootConcurrentErrors = null;
    $d52e344c7cd7d393$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $d52e344c7cd7d393$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $d52e344c7cd7d393$var$entangledRenderLanes = lanes;
    $d52e344c7cd7d393$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $d52e344c7cd7d393$var$handleThrow(root, thrownValue) {
    $d52e344c7cd7d393$var$currentlyRenderingFiber = null;
    $d52e344c7cd7d393$var$ReactSharedInternals.H = $d52e344c7cd7d393$var$ContextOnlyDispatcher;
    thrownValue === $d52e344c7cd7d393$var$SuspenseException || thrownValue === $d52e344c7cd7d393$var$SuspenseActionException ? (thrownValue = $d52e344c7cd7d393$var$getSuspendedThenable(), $d52e344c7cd7d393$var$workInProgressSuspendedReason = 3) : thrownValue === $d52e344c7cd7d393$var$SuspenseyCommitException ? (thrownValue = $d52e344c7cd7d393$var$getSuspendedThenable(), $d52e344c7cd7d393$var$workInProgressSuspendedReason = 4) : $d52e344c7cd7d393$var$workInProgressSuspendedReason = thrownValue === $d52e344c7cd7d393$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $d52e344c7cd7d393$var$workInProgressThrownValue = thrownValue;
    null === $d52e344c7cd7d393$var$workInProgress && ($d52e344c7cd7d393$var$workInProgressRootExitStatus = 1, $d52e344c7cd7d393$var$logUncaughtError(root, $d52e344c7cd7d393$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $d52e344c7cd7d393$var$pushDispatcher() {
    var prevDispatcher = $d52e344c7cd7d393$var$ReactSharedInternals.H;
    $d52e344c7cd7d393$var$ReactSharedInternals.H = $d52e344c7cd7d393$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $d52e344c7cd7d393$var$ContextOnlyDispatcher : prevDispatcher;
}
function $d52e344c7cd7d393$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $d52e344c7cd7d393$var$ReactSharedInternals.A;
    $d52e344c7cd7d393$var$ReactSharedInternals.A = $d52e344c7cd7d393$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $d52e344c7cd7d393$var$renderDidSuspendDelayIfPossible() {
    $d52e344c7cd7d393$var$workInProgressRootExitStatus = 4;
    $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings || ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 4194048) !== $d52e344c7cd7d393$var$workInProgressRootRenderLanes && null !== $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current || ($d52e344c7cd7d393$var$workInProgressRootIsPrerendering = !0);
    0 === ($d52e344c7cd7d393$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($d52e344c7cd7d393$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $d52e344c7cd7d393$var$workInProgressRoot || $d52e344c7cd7d393$var$markRootSuspended($d52e344c7cd7d393$var$workInProgressRoot, $d52e344c7cd7d393$var$workInProgressRootRenderLanes, $d52e344c7cd7d393$var$workInProgressDeferredLane, !1);
}
function $d52e344c7cd7d393$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $d52e344c7cd7d393$var$executionContext;
    $d52e344c7cd7d393$var$executionContext |= 2;
    var prevDispatcher = $d52e344c7cd7d393$var$pushDispatcher(), prevAsyncDispatcher = $d52e344c7cd7d393$var$pushAsyncDispatcher();
    if ($d52e344c7cd7d393$var$workInProgressRoot !== root || $d52e344c7cd7d393$var$workInProgressRootRenderLanes !== lanes) $d52e344c7cd7d393$var$workInProgressTransitions = null, $d52e344c7cd7d393$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $d52e344c7cd7d393$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $d52e344c7cd7d393$var$workInProgressSuspendedReason && null !== $d52e344c7cd7d393$var$workInProgress) {
            var unitOfWork = $d52e344c7cd7d393$var$workInProgress, thrownValue = $d52e344c7cd7d393$var$workInProgressThrownValue;
            switch($d52e344c7cd7d393$var$workInProgressSuspendedReason){
                case 8:
                    $d52e344c7cd7d393$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $d52e344c7cd7d393$var$workInProgressSuspendedReason;
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                    $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                    $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $d52e344c7cd7d393$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $d52e344c7cd7d393$var$workInProgressSuspendedReason, $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0, $d52e344c7cd7d393$var$workInProgressThrownValue = null, $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $d52e344c7cd7d393$var$workLoopSync();
        exitStatus = $d52e344c7cd7d393$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $d52e344c7cd7d393$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $d52e344c7cd7d393$var$lastContextDependency = $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = null;
    $d52e344c7cd7d393$var$executionContext = prevExecutionContext;
    $d52e344c7cd7d393$var$ReactSharedInternals.H = prevDispatcher;
    $d52e344c7cd7d393$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $d52e344c7cd7d393$var$workInProgress && ($d52e344c7cd7d393$var$workInProgressRoot = null, $d52e344c7cd7d393$var$workInProgressRootRenderLanes = 0, $d52e344c7cd7d393$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $d52e344c7cd7d393$var$workLoopSync() {
    for(; null !== $d52e344c7cd7d393$var$workInProgress;)$d52e344c7cd7d393$var$performUnitOfWork($d52e344c7cd7d393$var$workInProgress);
}
function $d52e344c7cd7d393$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $d52e344c7cd7d393$var$executionContext;
    $d52e344c7cd7d393$var$executionContext |= 2;
    var prevDispatcher = $d52e344c7cd7d393$var$pushDispatcher(), prevAsyncDispatcher = $d52e344c7cd7d393$var$pushAsyncDispatcher();
    $d52e344c7cd7d393$var$workInProgressRoot !== root || $d52e344c7cd7d393$var$workInProgressRootRenderLanes !== lanes ? ($d52e344c7cd7d393$var$workInProgressTransitions = null, $d52e344c7cd7d393$var$workInProgressRootRenderTargetTime = $d52e344c7cd7d393$var$now() + 500, $d52e344c7cd7d393$var$prepareFreshStack(root, lanes)) : $d52e344c7cd7d393$var$workInProgressRootIsPrerendering = $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $d52e344c7cd7d393$var$workInProgressSuspendedReason && null !== $d52e344c7cd7d393$var$workInProgress) {
            lanes = $d52e344c7cd7d393$var$workInProgress;
            var thrownValue = $d52e344c7cd7d393$var$workInProgressThrownValue;
            b: switch($d52e344c7cd7d393$var$workInProgressSuspendedReason){
                case 1:
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                    $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                    $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($d52e344c7cd7d393$var$isThenableResolved(thrownValue)) {
                        $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                        $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                        $d52e344c7cd7d393$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $d52e344c7cd7d393$var$workInProgressSuspendedReason && 9 !== $d52e344c7cd7d393$var$workInProgressSuspendedReason || $d52e344c7cd7d393$var$workInProgressRoot !== root || ($d52e344c7cd7d393$var$workInProgressSuspendedReason = 7);
                        $d52e344c7cd7d393$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $d52e344c7cd7d393$var$isThenableResolved(thrownValue) ? ($d52e344c7cd7d393$var$workInProgressSuspendedReason = 0, $d52e344c7cd7d393$var$workInProgressThrownValue = null, $d52e344c7cd7d393$var$replaySuspendedUnitOfWork(lanes)) : ($d52e344c7cd7d393$var$workInProgressSuspendedReason = 0, $d52e344c7cd7d393$var$workInProgressThrownValue = null, $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($d52e344c7cd7d393$var$workInProgress.tag){
                        case 26:
                            resource = $d52e344c7cd7d393$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $d52e344c7cd7d393$var$workInProgress;
                            if (resource ? $d52e344c7cd7d393$var$preloadResource(resource) : 1) {
                                $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                                $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $d52e344c7cd7d393$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($d52e344c7cd7d393$var$workInProgress = returnFiber, $d52e344c7cd7d393$var$completeUnitOfWork(returnFiber)) : $d52e344c7cd7d393$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                    $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                    $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $d52e344c7cd7d393$var$workInProgressSuspendedReason = 0;
                    $d52e344c7cd7d393$var$workInProgressThrownValue = null;
                    $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $d52e344c7cd7d393$var$resetWorkInProgressStack();
                    $d52e344c7cd7d393$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(462));
            }
        }
        $d52e344c7cd7d393$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $d52e344c7cd7d393$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $d52e344c7cd7d393$var$lastContextDependency = $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = null;
    $d52e344c7cd7d393$var$ReactSharedInternals.H = prevDispatcher;
    $d52e344c7cd7d393$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $d52e344c7cd7d393$var$executionContext = prevExecutionContext;
    if (null !== $d52e344c7cd7d393$var$workInProgress) return 0;
    $d52e344c7cd7d393$var$workInProgressRoot = null;
    $d52e344c7cd7d393$var$workInProgressRootRenderLanes = 0;
    $d52e344c7cd7d393$var$finishQueueingConcurrentUpdates();
    return $d52e344c7cd7d393$var$workInProgressRootExitStatus;
}
function $d52e344c7cd7d393$var$workLoopConcurrentByScheduler() {
    for(; null !== $d52e344c7cd7d393$var$workInProgress && !$d52e344c7cd7d393$var$shouldYield();)$d52e344c7cd7d393$var$performUnitOfWork($d52e344c7cd7d393$var$workInProgress);
}
function $d52e344c7cd7d393$var$performUnitOfWork(unitOfWork) {
    var next = $d52e344c7cd7d393$var$beginWork(unitOfWork.alternate, unitOfWork, $d52e344c7cd7d393$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d52e344c7cd7d393$var$completeUnitOfWork(unitOfWork) : $d52e344c7cd7d393$var$workInProgress = next;
}
function $d52e344c7cd7d393$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $d52e344c7cd7d393$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $d52e344c7cd7d393$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $d52e344c7cd7d393$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $d52e344c7cd7d393$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $d52e344c7cd7d393$var$resetHooksOnUnwind(next);
        default:
            $d52e344c7cd7d393$var$unwindInterruptedWork(current, next), next = $d52e344c7cd7d393$var$workInProgress = $d52e344c7cd7d393$var$resetWorkInProgress(next, $d52e344c7cd7d393$var$entangledRenderLanes), next = $d52e344c7cd7d393$var$beginWork(current, next, $d52e344c7cd7d393$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $d52e344c7cd7d393$var$completeUnitOfWork(unitOfWork) : $d52e344c7cd7d393$var$workInProgress = next;
}
function $d52e344c7cd7d393$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $d52e344c7cd7d393$var$lastContextDependency = $d52e344c7cd7d393$var$currentlyRenderingFiber$1 = null;
    $d52e344c7cd7d393$var$resetHooksOnUnwind(unitOfWork);
    $d52e344c7cd7d393$var$thenableState = null;
    $d52e344c7cd7d393$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($d52e344c7cd7d393$var$throwException(root, returnFiber, unitOfWork, thrownValue, $d52e344c7cd7d393$var$workInProgressRootRenderLanes)) {
            $d52e344c7cd7d393$var$workInProgressRootExitStatus = 1;
            $d52e344c7cd7d393$var$logUncaughtError(root, $d52e344c7cd7d393$var$createCapturedValueAtFiber(thrownValue, root.current));
            $d52e344c7cd7d393$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $d52e344c7cd7d393$var$workInProgress = returnFiber, error;
        $d52e344c7cd7d393$var$workInProgressRootExitStatus = 1;
        $d52e344c7cd7d393$var$logUncaughtError(root, $d52e344c7cd7d393$var$createCapturedValueAtFiber(thrownValue, root.current));
        $d52e344c7cd7d393$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($d52e344c7cd7d393$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($d52e344c7cd7d393$var$workInProgressRootIsPrerendering || 0 !== ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $d52e344c7cd7d393$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $d52e344c7cd7d393$var$unwindUnitOfWork(unitOfWork, root);
    } else $d52e344c7cd7d393$var$completeUnitOfWork(unitOfWork);
}
function $d52e344c7cd7d393$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $d52e344c7cd7d393$var$unwindUnitOfWork(completedWork, $d52e344c7cd7d393$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $d52e344c7cd7d393$var$completeWork(completedWork.alternate, completedWork, $d52e344c7cd7d393$var$entangledRenderLanes);
        if (null !== next) {
            $d52e344c7cd7d393$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $d52e344c7cd7d393$var$workInProgress = completedWork;
            return;
        }
        $d52e344c7cd7d393$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $d52e344c7cd7d393$var$workInProgressRootExitStatus && ($d52e344c7cd7d393$var$workInProgressRootExitStatus = 5);
}
function $d52e344c7cd7d393$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $d52e344c7cd7d393$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $d52e344c7cd7d393$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $d52e344c7cd7d393$var$workInProgress = unitOfWork;
            return;
        }
        $d52e344c7cd7d393$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $d52e344c7cd7d393$var$workInProgressRootExitStatus = 6;
    $d52e344c7cd7d393$var$workInProgress = null;
}
function $d52e344c7cd7d393$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $d52e344c7cd7d393$var$flushPendingEffects();
    while (0 !== $d52e344c7cd7d393$var$pendingEffectsStatus);
    if (0 !== ($d52e344c7cd7d393$var$executionContext & 6)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $d52e344c7cd7d393$var$concurrentlyUpdatedLanes;
        $d52e344c7cd7d393$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $d52e344c7cd7d393$var$workInProgressRoot && ($d52e344c7cd7d393$var$workInProgress = $d52e344c7cd7d393$var$workInProgressRoot = null, $d52e344c7cd7d393$var$workInProgressRootRenderLanes = 0);
        $d52e344c7cd7d393$var$pendingFinishedWork = finishedWork;
        $d52e344c7cd7d393$var$pendingEffectsRoot = root;
        $d52e344c7cd7d393$var$pendingEffectsLanes = lanes;
        $d52e344c7cd7d393$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $d52e344c7cd7d393$var$pendingPassiveTransitions = transitions;
        $d52e344c7cd7d393$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $d52e344c7cd7d393$var$scheduleCallback$1($d52e344c7cd7d393$var$NormalPriority$1, function() {
            $d52e344c7cd7d393$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $d52e344c7cd7d393$var$ReactSharedInternals.T;
            $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
            transitions = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
            $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $d52e344c7cd7d393$var$executionContext;
            $d52e344c7cd7d393$var$executionContext |= 4;
            try {
                $d52e344c7cd7d393$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $d52e344c7cd7d393$var$executionContext = spawnedLane, $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = transitions, $d52e344c7cd7d393$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $d52e344c7cd7d393$var$pendingEffectsStatus = 1;
        $d52e344c7cd7d393$var$flushMutationEffects();
        $d52e344c7cd7d393$var$flushLayoutEffects();
        $d52e344c7cd7d393$var$flushSpawnedWork();
    }
}
function $d52e344c7cd7d393$var$flushMutationEffects() {
    if (1 === $d52e344c7cd7d393$var$pendingEffectsStatus) {
        $d52e344c7cd7d393$var$pendingEffectsStatus = 0;
        var root = $d52e344c7cd7d393$var$pendingEffectsRoot, finishedWork = $d52e344c7cd7d393$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $d52e344c7cd7d393$var$ReactSharedInternals.T;
            $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
            var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
            $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d52e344c7cd7d393$var$executionContext;
            $d52e344c7cd7d393$var$executionContext |= 4;
            try {
                $d52e344c7cd7d393$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $d52e344c7cd7d393$var$selectionInformation, curFocusedElem = $d52e344c7cd7d393$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $d52e344c7cd7d393$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $d52e344c7cd7d393$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $d52e344c7cd7d393$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $d52e344c7cd7d393$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $d52e344c7cd7d393$var$_enabled = !!$d52e344c7cd7d393$var$eventsEnabled;
                $d52e344c7cd7d393$var$selectionInformation = $d52e344c7cd7d393$var$eventsEnabled = null;
            } finally{
                $d52e344c7cd7d393$var$executionContext = prevExecutionContext, $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $d52e344c7cd7d393$var$pendingEffectsStatus = 2;
    }
}
function $d52e344c7cd7d393$var$flushLayoutEffects() {
    if (2 === $d52e344c7cd7d393$var$pendingEffectsStatus) {
        $d52e344c7cd7d393$var$pendingEffectsStatus = 0;
        var root = $d52e344c7cd7d393$var$pendingEffectsRoot, finishedWork = $d52e344c7cd7d393$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $d52e344c7cd7d393$var$ReactSharedInternals.T;
            $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
            var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
            $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $d52e344c7cd7d393$var$executionContext;
            $d52e344c7cd7d393$var$executionContext |= 4;
            try {
                $d52e344c7cd7d393$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $d52e344c7cd7d393$var$executionContext = prevExecutionContext, $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $d52e344c7cd7d393$var$pendingEffectsStatus = 3;
    }
}
function $d52e344c7cd7d393$var$flushSpawnedWork() {
    if (4 === $d52e344c7cd7d393$var$pendingEffectsStatus || 3 === $d52e344c7cd7d393$var$pendingEffectsStatus) {
        $d52e344c7cd7d393$var$pendingEffectsStatus = 0;
        $d52e344c7cd7d393$var$requestPaint();
        var root = $d52e344c7cd7d393$var$pendingEffectsRoot, finishedWork = $d52e344c7cd7d393$var$pendingFinishedWork, lanes = $d52e344c7cd7d393$var$pendingEffectsLanes, recoverableErrors = $d52e344c7cd7d393$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $d52e344c7cd7d393$var$pendingEffectsStatus = 5 : ($d52e344c7cd7d393$var$pendingEffectsStatus = 0, $d52e344c7cd7d393$var$pendingFinishedWork = $d52e344c7cd7d393$var$pendingEffectsRoot = null, $d52e344c7cd7d393$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $d52e344c7cd7d393$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($d52e344c7cd7d393$var$injectedHook && "function" === typeof $d52e344c7cd7d393$var$injectedHook.onCommitFiberRoot) try {
            $d52e344c7cd7d393$var$injectedHook.onCommitFiberRoot($d52e344c7cd7d393$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $d52e344c7cd7d393$var$ReactSharedInternals.T;
            remainingLanes = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
            $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 2;
            $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $d52e344c7cd7d393$var$ReactSharedInternals.T = finishedWork, $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($d52e344c7cd7d393$var$pendingEffectsLanes & 3) && $d52e344c7cd7d393$var$flushPendingEffects();
        $d52e344c7cd7d393$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $d52e344c7cd7d393$var$rootWithNestedUpdates ? $d52e344c7cd7d393$var$nestedUpdateCount++ : ($d52e344c7cd7d393$var$nestedUpdateCount = 0, $d52e344c7cd7d393$var$rootWithNestedUpdates = root) : $d52e344c7cd7d393$var$nestedUpdateCount = 0;
        $d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $d52e344c7cd7d393$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $d52e344c7cd7d393$var$releaseCache(remainingLanes)));
}
function $d52e344c7cd7d393$var$flushPendingEffects(wasDelayedCommit) {
    $d52e344c7cd7d393$var$flushMutationEffects();
    $d52e344c7cd7d393$var$flushLayoutEffects();
    $d52e344c7cd7d393$var$flushSpawnedWork();
    return $d52e344c7cd7d393$var$flushPassiveEffects(wasDelayedCommit);
}
function $d52e344c7cd7d393$var$flushPassiveEffects() {
    if (5 !== $d52e344c7cd7d393$var$pendingEffectsStatus) return !1;
    var root = $d52e344c7cd7d393$var$pendingEffectsRoot, remainingLanes = $d52e344c7cd7d393$var$pendingEffectsRemainingLanes;
    $d52e344c7cd7d393$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $d52e344c7cd7d393$var$lanesToEventPriority($d52e344c7cd7d393$var$pendingEffectsLanes), prevTransition = $d52e344c7cd7d393$var$ReactSharedInternals.T, previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    try {
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
        renderPriority = $d52e344c7cd7d393$var$pendingPassiveTransitions;
        $d52e344c7cd7d393$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $d52e344c7cd7d393$var$pendingEffectsRoot, lanes = $d52e344c7cd7d393$var$pendingEffectsLanes;
        $d52e344c7cd7d393$var$pendingEffectsStatus = 0;
        $d52e344c7cd7d393$var$pendingFinishedWork = $d52e344c7cd7d393$var$pendingEffectsRoot = null;
        $d52e344c7cd7d393$var$pendingEffectsLanes = 0;
        if (0 !== ($d52e344c7cd7d393$var$executionContext & 6)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(331));
        var prevExecutionContext = $d52e344c7cd7d393$var$executionContext;
        $d52e344c7cd7d393$var$executionContext |= 4;
        $d52e344c7cd7d393$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $d52e344c7cd7d393$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $d52e344c7cd7d393$var$executionContext = prevExecutionContext;
        $d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($d52e344c7cd7d393$var$injectedHook && "function" === typeof $d52e344c7cd7d393$var$injectedHook.onPostCommitFiberRoot) try {
            $d52e344c7cd7d393$var$injectedHook.onPostCommitFiberRoot($d52e344c7cd7d393$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = prevTransition, $d52e344c7cd7d393$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $d52e344c7cd7d393$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $d52e344c7cd7d393$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $d52e344c7cd7d393$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $d52e344c7cd7d393$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($d52e344c7cd7d393$var$markRootUpdated$1(rootFiber, 2), $d52e344c7cd7d393$var$ensureRootIsScheduled(rootFiber));
}
function $d52e344c7cd7d393$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $d52e344c7cd7d393$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $d52e344c7cd7d393$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed || !$d52e344c7cd7d393$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $d52e344c7cd7d393$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $d52e344c7cd7d393$var$createClassErrorUpdate(2);
                instance = $d52e344c7cd7d393$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($d52e344c7cd7d393$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $d52e344c7cd7d393$var$markRootUpdated$1(instance, 2), $d52e344c7cd7d393$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $d52e344c7cd7d393$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $d52e344c7cd7d393$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($d52e344c7cd7d393$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $d52e344c7cd7d393$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $d52e344c7cd7d393$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $d52e344c7cd7d393$var$workInProgressRoot === root && ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $d52e344c7cd7d393$var$workInProgressRootExitStatus || 3 === $d52e344c7cd7d393$var$workInProgressRootExitStatus && ($d52e344c7cd7d393$var$workInProgressRootRenderLanes & 62914560) === $d52e344c7cd7d393$var$workInProgressRootRenderLanes && 300 > $d52e344c7cd7d393$var$now() - $d52e344c7cd7d393$var$globalMostRecentFallbackTime ? 0 === ($d52e344c7cd7d393$var$executionContext & 2) && $d52e344c7cd7d393$var$prepareFreshStack(root, 0) : $d52e344c7cd7d393$var$workInProgressRootPingedLanes |= pingedLanes, $d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes === $d52e344c7cd7d393$var$workInProgressRootRenderLanes && ($d52e344c7cd7d393$var$workInProgressSuspendedRetryLanes = 0));
    $d52e344c7cd7d393$var$ensureRootIsScheduled(root);
}
function $d52e344c7cd7d393$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $d52e344c7cd7d393$var$claimNextRetryLane());
    boundaryFiber = $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($d52e344c7cd7d393$var$markRootUpdated$1(boundaryFiber, retryLane), $d52e344c7cd7d393$var$ensureRootIsScheduled(boundaryFiber));
}
function $d52e344c7cd7d393$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $d52e344c7cd7d393$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d52e344c7cd7d393$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $d52e344c7cd7d393$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $d52e344c7cd7d393$var$scheduleCallback$1(priorityLevel, callback) {
    return $d52e344c7cd7d393$var$scheduleCallback$3(priorityLevel, callback);
}
var $d52e344c7cd7d393$var$firstScheduledRoot = null, $d52e344c7cd7d393$var$lastScheduledRoot = null, $d52e344c7cd7d393$var$didScheduleMicrotask = !1, $d52e344c7cd7d393$var$mightHavePendingSyncWork = !1, $d52e344c7cd7d393$var$isFlushingWork = !1, $d52e344c7cd7d393$var$currentEventTransitionLane = 0;
function $d52e344c7cd7d393$var$ensureRootIsScheduled(root) {
    root !== $d52e344c7cd7d393$var$lastScheduledRoot && null === root.next && (null === $d52e344c7cd7d393$var$lastScheduledRoot ? $d52e344c7cd7d393$var$firstScheduledRoot = $d52e344c7cd7d393$var$lastScheduledRoot = root : $d52e344c7cd7d393$var$lastScheduledRoot = $d52e344c7cd7d393$var$lastScheduledRoot.next = root);
    $d52e344c7cd7d393$var$mightHavePendingSyncWork = !0;
    $d52e344c7cd7d393$var$didScheduleMicrotask || ($d52e344c7cd7d393$var$didScheduleMicrotask = !0, $d52e344c7cd7d393$var$scheduleImmediateRootScheduleTask());
}
function $d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$d52e344c7cd7d393$var$isFlushingWork && $d52e344c7cd7d393$var$mightHavePendingSyncWork) {
        $d52e344c7cd7d393$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $d52e344c7cd7d393$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $d52e344c7cd7d393$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $d52e344c7cd7d393$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $d52e344c7cd7d393$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $d52e344c7cd7d393$var$getNextLanes(root$174, root$174 === $d52e344c7cd7d393$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $d52e344c7cd7d393$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $d52e344c7cd7d393$var$isFlushingWork = !1;
    }
}
function $d52e344c7cd7d393$var$processRootScheduleInImmediateTask() {
    $d52e344c7cd7d393$var$processRootScheduleInMicrotask();
}
function $d52e344c7cd7d393$var$processRootScheduleInMicrotask() {
    $d52e344c7cd7d393$var$mightHavePendingSyncWork = $d52e344c7cd7d393$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $d52e344c7cd7d393$var$currentEventTransitionLane && ($d52e344c7cd7d393$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $d52e344c7cd7d393$var$currentEventTransitionLane), $d52e344c7cd7d393$var$currentEventTransitionLane = 0);
    for(var currentTime = $d52e344c7cd7d393$var$now(), prev = null, root = $d52e344c7cd7d393$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $d52e344c7cd7d393$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $d52e344c7cd7d393$var$firstScheduledRoot = next : prev.next = next, null === next && ($d52e344c7cd7d393$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $d52e344c7cd7d393$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $d52e344c7cd7d393$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $d52e344c7cd7d393$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $d52e344c7cd7d393$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $d52e344c7cd7d393$var$workInProgressRoot;
    suspendedLanes = $d52e344c7cd7d393$var$workInProgressRootRenderLanes;
    suspendedLanes = $d52e344c7cd7d393$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $d52e344c7cd7d393$var$workInProgressSuspendedReason || 9 === $d52e344c7cd7d393$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $d52e344c7cd7d393$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $d52e344c7cd7d393$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $d52e344c7cd7d393$var$cancelCallback$1(pingedLanes);
        switch($d52e344c7cd7d393$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $d52e344c7cd7d393$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $d52e344c7cd7d393$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $d52e344c7cd7d393$var$IdlePriority;
                break;
            default:
                suspendedLanes = $d52e344c7cd7d393$var$NormalPriority$1;
        }
        pingedLanes = $d52e344c7cd7d393$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $d52e344c7cd7d393$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $d52e344c7cd7d393$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $d52e344c7cd7d393$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $d52e344c7cd7d393$var$pendingEffectsStatus && 5 !== $d52e344c7cd7d393$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($d52e344c7cd7d393$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $d52e344c7cd7d393$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $d52e344c7cd7d393$var$getNextLanes(root, root === $d52e344c7cd7d393$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $d52e344c7cd7d393$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $d52e344c7cd7d393$var$scheduleTaskForRootDuringMicrotask(root, $d52e344c7cd7d393$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $d52e344c7cd7d393$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $d52e344c7cd7d393$var$performSyncWorkOnRoot(root, lanes) {
    if ($d52e344c7cd7d393$var$flushPendingEffects()) return null;
    $d52e344c7cd7d393$var$performWorkOnRoot(root, lanes, !0);
}
function $d52e344c7cd7d393$var$scheduleImmediateRootScheduleTask() {
    $d52e344c7cd7d393$var$scheduleMicrotask(function() {
        0 !== ($d52e344c7cd7d393$var$executionContext & 6) ? $d52e344c7cd7d393$var$scheduleCallback$3($d52e344c7cd7d393$var$ImmediatePriority, $d52e344c7cd7d393$var$processRootScheduleInImmediateTask) : $d52e344c7cd7d393$var$processRootScheduleInMicrotask();
    });
}
function $d52e344c7cd7d393$var$requestTransitionLane() {
    0 === $d52e344c7cd7d393$var$currentEventTransitionLane && ($d52e344c7cd7d393$var$currentEventTransitionLane = $d52e344c7cd7d393$var$claimNextTransitionLane());
    return $d52e344c7cd7d393$var$currentEventTransitionLane;
}
function $d52e344c7cd7d393$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $d52e344c7cd7d393$var$sanitizeURL("" + actionProp);
}
function $d52e344c7cd7d393$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $d52e344c7cd7d393$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $d52e344c7cd7d393$var$coerceFormActionProp((nativeEventTarget[$d52e344c7cd7d393$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$d52e344c7cd7d393$var$internalPropsKey] || null) ? $d52e344c7cd7d393$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $d52e344c7cd7d393$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $d52e344c7cd7d393$var$currentEventTransitionLane) {
                                var formData = submitter ? $d52e344c7cd7d393$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $d52e344c7cd7d393$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $d52e344c7cd7d393$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $d52e344c7cd7d393$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $d52e344c7cd7d393$var$i$jscomp$inline_1528 = 0; $d52e344c7cd7d393$var$i$jscomp$inline_1528 < $d52e344c7cd7d393$var$simpleEventPluginEvents.length; $d52e344c7cd7d393$var$i$jscomp$inline_1528++){
    var $d52e344c7cd7d393$var$eventName$jscomp$inline_1529 = $d52e344c7cd7d393$var$simpleEventPluginEvents[$d52e344c7cd7d393$var$i$jscomp$inline_1528], $d52e344c7cd7d393$var$domEventName$jscomp$inline_1530 = $d52e344c7cd7d393$var$eventName$jscomp$inline_1529.toLowerCase(), $d52e344c7cd7d393$var$capitalizedEvent$jscomp$inline_1531 = $d52e344c7cd7d393$var$eventName$jscomp$inline_1529[0].toUpperCase() + $d52e344c7cd7d393$var$eventName$jscomp$inline_1529.slice(1);
    $d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$domEventName$jscomp$inline_1530, "on" + $d52e344c7cd7d393$var$capitalizedEvent$jscomp$inline_1531);
}
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$ANIMATION_END, "onAnimationEnd");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$ANIMATION_ITERATION, "onAnimationIteration");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$ANIMATION_START, "onAnimationStart");
$d52e344c7cd7d393$var$registerSimpleEvent("dblclick", "onDoubleClick");
$d52e344c7cd7d393$var$registerSimpleEvent("focusin", "onFocus");
$d52e344c7cd7d393$var$registerSimpleEvent("focusout", "onBlur");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$TRANSITION_RUN, "onTransitionRun");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$TRANSITION_START, "onTransitionStart");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$TRANSITION_CANCEL, "onTransitionCancel");
$d52e344c7cd7d393$var$registerSimpleEvent($d52e344c7cd7d393$var$TRANSITION_END, "onTransitionEnd");
$d52e344c7cd7d393$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$d52e344c7cd7d393$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$d52e344c7cd7d393$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$d52e344c7cd7d393$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$d52e344c7cd7d393$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $d52e344c7cd7d393$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $d52e344c7cd7d393$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($d52e344c7cd7d393$var$mediaEventTypes));
function $d52e344c7cd7d393$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d52e344c7cd7d393$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $d52e344c7cd7d393$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $d52e344c7cd7d393$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$d52e344c7cd7d393$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$d52e344c7cd7d393$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($d52e344c7cd7d393$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $d52e344c7cd7d393$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $d52e344c7cd7d393$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $d52e344c7cd7d393$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $d52e344c7cd7d393$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$d52e344c7cd7d393$var$listeningMarker]) {
        rootContainerElement[$d52e344c7cd7d393$var$listeningMarker] = !0;
        $d52e344c7cd7d393$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($d52e344c7cd7d393$var$nonDelegatedEvents.has(domEventName) || $d52e344c7cd7d393$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $d52e344c7cd7d393$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$d52e344c7cd7d393$var$listeningMarker] || (ownerDocument[$d52e344c7cd7d393$var$listeningMarker] = !0, $d52e344c7cd7d393$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $d52e344c7cd7d393$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($d52e344c7cd7d393$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $d52e344c7cd7d393$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $d52e344c7cd7d393$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $d52e344c7cd7d393$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$d52e344c7cd7d393$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $d52e344c7cd7d393$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $d52e344c7cd7d393$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $d52e344c7cd7d393$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $d52e344c7cd7d393$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $d52e344c7cd7d393$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $d52e344c7cd7d393$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticTouchEvent;
                        break;
                    case $d52e344c7cd7d393$var$ANIMATION_END:
                    case $d52e344c7cd7d393$var$ANIMATION_ITERATION:
                    case $d52e344c7cd7d393$var$ANIMATION_START:
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticAnimationEvent;
                        break;
                    case $d52e344c7cd7d393$var$TRANSITION_END:
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $d52e344c7cd7d393$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $d52e344c7cd7d393$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($d52e344c7cd7d393$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $d52e344c7cd7d393$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($d52e344c7cd7d393$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$d52e344c7cd7d393$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $d52e344c7cd7d393$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $d52e344c7cd7d393$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $d52e344c7cd7d393$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $d52e344c7cd7d393$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $d52e344c7cd7d393$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $d52e344c7cd7d393$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $d52e344c7cd7d393$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $d52e344c7cd7d393$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $d52e344c7cd7d393$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $d52e344c7cd7d393$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $d52e344c7cd7d393$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $d52e344c7cd7d393$var$getParent(inCapturePhase);
                                reactEventName = $d52e344c7cd7d393$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $d52e344c7cd7d393$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $d52e344c7cd7d393$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $d52e344c7cd7d393$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $d52e344c7cd7d393$var$getTargetInstForChangeEvent;
                else if ($d52e344c7cd7d393$var$isTextInputElement(reactName)) {
                    if ($d52e344c7cd7d393$var$isInputEventSupported) getTargetInstFunc = $d52e344c7cd7d393$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $d52e344c7cd7d393$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $d52e344c7cd7d393$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $d52e344c7cd7d393$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $d52e344c7cd7d393$var$getTargetInstForChangeEvent) : getTargetInstFunc = $d52e344c7cd7d393$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $d52e344c7cd7d393$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $d52e344c7cd7d393$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $d52e344c7cd7d393$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($d52e344c7cd7d393$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $d52e344c7cd7d393$var$activeElement = handleEventFunc, $d52e344c7cd7d393$var$activeElementInst = targetInst, $d52e344c7cd7d393$var$lastSelection = null;
                    break;
                case "focusout":
                    $d52e344c7cd7d393$var$lastSelection = $d52e344c7cd7d393$var$activeElementInst = $d52e344c7cd7d393$var$activeElement = null;
                    break;
                case "mousedown":
                    $d52e344c7cd7d393$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $d52e344c7cd7d393$var$mouseDown = !1;
                    $d52e344c7cd7d393$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($d52e344c7cd7d393$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $d52e344c7cd7d393$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($d52e344c7cd7d393$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $d52e344c7cd7d393$var$isComposing ? $d52e344c7cd7d393$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($d52e344c7cd7d393$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($d52e344c7cd7d393$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $d52e344c7cd7d393$var$isComposing && (fallbackData = $d52e344c7cd7d393$var$getData()) : ($d52e344c7cd7d393$var$root = nativeEventTarget, $d52e344c7cd7d393$var$startText = "value" in $d52e344c7cd7d393$var$root ? $d52e344c7cd7d393$var$root.value : $d52e344c7cd7d393$var$root.textContent, $d52e344c7cd7d393$var$isComposing = !0)), handleEventFunc = $d52e344c7cd7d393$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $d52e344c7cd7d393$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $d52e344c7cd7d393$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $d52e344c7cd7d393$var$canUseTextInputEvent ? $d52e344c7cd7d393$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $d52e344c7cd7d393$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $d52e344c7cd7d393$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $d52e344c7cd7d393$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $d52e344c7cd7d393$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $d52e344c7cd7d393$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $d52e344c7cd7d393$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $d52e344c7cd7d393$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $d52e344c7cd7d393$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($d52e344c7cd7d393$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $d52e344c7cd7d393$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($d52e344c7cd7d393$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $d52e344c7cd7d393$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $d52e344c7cd7d393$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $d52e344c7cd7d393$var$getListener(target, registrationName), null != stateNode && listeners.unshift($d52e344c7cd7d393$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $d52e344c7cd7d393$var$getListener(target, registrationName), null != stateNode && listeners.push($d52e344c7cd7d393$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $d52e344c7cd7d393$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $d52e344c7cd7d393$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $d52e344c7cd7d393$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($d52e344c7cd7d393$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($d52e344c7cd7d393$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $d52e344c7cd7d393$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $d52e344c7cd7d393$var$normalizeMarkupForTextOrAttribute(clientText);
    return $d52e344c7cd7d393$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $d52e344c7cd7d393$var$noop$1() {}
function $d52e344c7cd7d393$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $d52e344c7cd7d393$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $d52e344c7cd7d393$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $d52e344c7cd7d393$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $d52e344c7cd7d393$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $d52e344c7cd7d393$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $d52e344c7cd7d393$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $d52e344c7cd7d393$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d52e344c7cd7d393$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $d52e344c7cd7d393$var$setProp(domElement, tag, "name", props.name, props, null), $d52e344c7cd7d393$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $d52e344c7cd7d393$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $d52e344c7cd7d393$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($d52e344c7cd7d393$var$setProp(domElement, tag, "encType", props.encType, props, null), $d52e344c7cd7d393$var$setProp(domElement, tag, "method", props.method, props, null), $d52e344c7cd7d393$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $d52e344c7cd7d393$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d52e344c7cd7d393$var$noop$1);
            break;
        case "onScroll":
            null != value && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $d52e344c7cd7d393$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("toggle", domElement);
            $d52e344c7cd7d393$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $d52e344c7cd7d393$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $d52e344c7cd7d393$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $d52e344c7cd7d393$var$aliases.get(key) || key, $d52e344c7cd7d393$var$setValueForAttribute(domElement, key, value);
    }
}
function $d52e344c7cd7d393$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $d52e344c7cd7d393$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $d52e344c7cd7d393$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $d52e344c7cd7d393$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $d52e344c7cd7d393$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $d52e344c7cd7d393$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$d52e344c7cd7d393$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$d52e344c7cd7d393$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $d52e344c7cd7d393$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $d52e344c7cd7d393$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("error", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(137, tag));
                    default:
                        $d52e344c7cd7d393$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $d52e344c7cd7d393$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $d52e344c7cd7d393$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $d52e344c7cd7d393$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $d52e344c7cd7d393$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $d52e344c7cd7d393$var$track(domElement);
            return;
        case "select":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $d52e344c7cd7d393$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $d52e344c7cd7d393$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(91));
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $d52e344c7cd7d393$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $d52e344c7cd7d393$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("toggle", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("cancel", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $d52e344c7cd7d393$var$mediaEventTypes.length; hasSrc++)$d52e344c7cd7d393$var$listenToNonDelegatedEvent($d52e344c7cd7d393$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("error", domElement);
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $d52e344c7cd7d393$var$listenToNonDelegatedEvent("error", domElement), $d52e344c7cd7d393$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(137, tag));
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($d52e344c7cd7d393$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $d52e344c7cd7d393$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $d52e344c7cd7d393$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $d52e344c7cd7d393$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $d52e344c7cd7d393$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $d52e344c7cd7d393$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $d52e344c7cd7d393$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $d52e344c7cd7d393$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $d52e344c7cd7d393$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $d52e344c7cd7d393$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $d52e344c7cd7d393$var$updateOptions(domElement, !!lastProps, tag, !0) : $d52e344c7cd7d393$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $d52e344c7cd7d393$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $d52e344c7cd7d393$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $d52e344c7cd7d393$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $d52e344c7cd7d393$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($d52e344c7cd7d393$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $d52e344c7cd7d393$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $d52e344c7cd7d393$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $d52e344c7cd7d393$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $d52e344c7cd7d393$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $d52e344c7cd7d393$var$eventsEnabled = null, $d52e344c7cd7d393$var$selectionInformation = null;
function $d52e344c7cd7d393$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $d52e344c7cd7d393$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $d52e344c7cd7d393$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $d52e344c7cd7d393$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $d52e344c7cd7d393$var$currentPopstateTransitionEvent = null;
function $d52e344c7cd7d393$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $d52e344c7cd7d393$var$currentPopstateTransitionEvent) return !1;
        $d52e344c7cd7d393$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $d52e344c7cd7d393$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $d52e344c7cd7d393$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $d52e344c7cd7d393$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $d52e344c7cd7d393$var$localPromise = "function" === typeof Promise ? Promise : void 0, $d52e344c7cd7d393$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $d52e344c7cd7d393$var$localPromise ? function(callback) {
    return $d52e344c7cd7d393$var$localPromise.resolve(null).then(callback).catch($d52e344c7cd7d393$var$handleErrorInNextTick);
} : $d52e344c7cd7d393$var$scheduleTimeout;
function $d52e344c7cd7d393$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $d52e344c7cd7d393$var$isSingletonScope(type) {
    return "head" === type;
}
function $d52e344c7cd7d393$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $d52e344c7cd7d393$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $d52e344c7cd7d393$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $d52e344c7cd7d393$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$d52e344c7cd7d393$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $d52e344c7cd7d393$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $d52e344c7cd7d393$var$retryIfBlockedOn(suspenseInstance);
}
function $d52e344c7cd7d393$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $d52e344c7cd7d393$var$clearContainerSparingly(node);
                $d52e344c7cd7d393$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $d52e344c7cd7d393$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$d52e344c7cd7d393$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $d52e344c7cd7d393$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $d52e344c7cd7d393$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $d52e344c7cd7d393$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $d52e344c7cd7d393$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $d52e344c7cd7d393$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $d52e344c7cd7d393$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $d52e344c7cd7d393$var$previousHydratableOnEnteringScopedSingleton = null;
function $d52e344c7cd7d393$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $d52e344c7cd7d393$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $d52e344c7cd7d393$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(451));
    }
}
function $d52e344c7cd7d393$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $d52e344c7cd7d393$var$detachDeletedInstance(instance);
}
var $d52e344c7cd7d393$var$preloadPropsMap = new Map(), $d52e344c7cd7d393$var$preconnectsSet = new Set();
function $d52e344c7cd7d393$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $d52e344c7cd7d393$var$previousDispatcher = $d52e344c7cd7d393$var$ReactDOMSharedInternals.d;
$d52e344c7cd7d393$var$ReactDOMSharedInternals.d = {
    f: $d52e344c7cd7d393$var$flushSyncWork,
    r: $d52e344c7cd7d393$var$requestFormReset,
    D: $d52e344c7cd7d393$var$prefetchDNS,
    C: $d52e344c7cd7d393$var$preconnect,
    L: $d52e344c7cd7d393$var$preload,
    m: $d52e344c7cd7d393$var$preloadModule,
    X: $d52e344c7cd7d393$var$preinitScript,
    S: $d52e344c7cd7d393$var$preinitStyle,
    M: $d52e344c7cd7d393$var$preinitModuleScript
};
function $d52e344c7cd7d393$var$flushSyncWork() {
    var previousWasRendering = $d52e344c7cd7d393$var$previousDispatcher.f(), wasRendering = $d52e344c7cd7d393$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $d52e344c7cd7d393$var$requestFormReset(form) {
    var formInst = $d52e344c7cd7d393$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $d52e344c7cd7d393$var$requestFormReset$1(formInst) : $d52e344c7cd7d393$var$previousDispatcher.r(form);
}
var $d52e344c7cd7d393$var$globalDocument = "undefined" === typeof document ? null : document;
function $d52e344c7cd7d393$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $d52e344c7cd7d393$var$preconnectsSet.has(limitedEscapedHref) || ($d52e344c7cd7d393$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $d52e344c7cd7d393$var$setInitialProperties(href, "link", rel), $d52e344c7cd7d393$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $d52e344c7cd7d393$var$prefetchDNS(href) {
    $d52e344c7cd7d393$var$previousDispatcher.D(href);
    $d52e344c7cd7d393$var$preconnectAs("dns-prefetch", href, null);
}
function $d52e344c7cd7d393$var$preconnect(href, crossOrigin) {
    $d52e344c7cd7d393$var$previousDispatcher.C(href, crossOrigin);
    $d52e344c7cd7d393$var$preconnectAs("preconnect", href, crossOrigin);
}
function $d52e344c7cd7d393$var$preload(href, as, options) {
    $d52e344c7cd7d393$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $d52e344c7cd7d393$var$getStyleKey(href);
                break;
            case "script":
                key = $d52e344c7cd7d393$var$getScriptKey(href);
        }
        $d52e344c7cd7d393$var$preloadPropsMap.has(key) || (href = $d52e344c7cd7d393$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $d52e344c7cd7d393$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($d52e344c7cd7d393$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($d52e344c7cd7d393$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $d52e344c7cd7d393$var$setInitialProperties(as, "link", href), $d52e344c7cd7d393$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $d52e344c7cd7d393$var$preloadModule(href, options) {
    $d52e344c7cd7d393$var$previousDispatcher.m(href, options);
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $d52e344c7cd7d393$var$getScriptKey(href);
        }
        if (!$d52e344c7cd7d393$var$preloadPropsMap.has(key) && (href = $d52e344c7cd7d393$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $d52e344c7cd7d393$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($d52e344c7cd7d393$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $d52e344c7cd7d393$var$setInitialProperties(as, "link", href);
            $d52e344c7cd7d393$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $d52e344c7cd7d393$var$preinitStyle(href, precedence, options) {
    $d52e344c7cd7d393$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $d52e344c7cd7d393$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $d52e344c7cd7d393$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($d52e344c7cd7d393$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $d52e344c7cd7d393$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $d52e344c7cd7d393$var$preloadPropsMap.get(key)) && $d52e344c7cd7d393$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $d52e344c7cd7d393$var$markNodeAsHoistable(link);
                $d52e344c7cd7d393$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $d52e344c7cd7d393$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $d52e344c7cd7d393$var$preinitScript(src, options) {
    $d52e344c7cd7d393$var$previousDispatcher.X(src, options);
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d52e344c7cd7d393$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d52e344c7cd7d393$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d52e344c7cd7d393$var$getScriptSelectorFromKey(key)), resource || (src = $d52e344c7cd7d393$var$assign({
            src: src,
            async: !0
        }, options), (options = $d52e344c7cd7d393$var$preloadPropsMap.get(key)) && $d52e344c7cd7d393$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d52e344c7cd7d393$var$markNodeAsHoistable(resource), $d52e344c7cd7d393$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d52e344c7cd7d393$var$preinitModuleScript(src, options) {
    $d52e344c7cd7d393$var$previousDispatcher.M(src, options);
    var ownerDocument = $d52e344c7cd7d393$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $d52e344c7cd7d393$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $d52e344c7cd7d393$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($d52e344c7cd7d393$var$getScriptSelectorFromKey(key)), resource || (src = $d52e344c7cd7d393$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $d52e344c7cd7d393$var$preloadPropsMap.get(key)) && $d52e344c7cd7d393$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $d52e344c7cd7d393$var$markNodeAsHoistable(resource), $d52e344c7cd7d393$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $d52e344c7cd7d393$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $d52e344c7cd7d393$var$rootInstanceStackCursor.current) ? $d52e344c7cd7d393$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $d52e344c7cd7d393$var$getStyleKey(pendingProps.href), pendingProps = $d52e344c7cd7d393$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $d52e344c7cd7d393$var$getStyleKey(pendingProps.href);
                var styles$244 = $d52e344c7cd7d393$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($d52e344c7cd7d393$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $d52e344c7cd7d393$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $d52e344c7cd7d393$var$preloadPropsMap.set(type, pendingProps), styles$244 || $d52e344c7cd7d393$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $d52e344c7cd7d393$var$getScriptKey(pendingProps), pendingProps = $d52e344c7cd7d393$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(444, type));
    }
}
function $d52e344c7cd7d393$var$getStyleKey(href) {
    return 'href="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $d52e344c7cd7d393$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $d52e344c7cd7d393$var$stylesheetPropsFromRawProps(rawProps) {
    return $d52e344c7cd7d393$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $d52e344c7cd7d393$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $d52e344c7cd7d393$var$setInitialProperties(key, "link", preloadProps), $d52e344c7cd7d393$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $d52e344c7cd7d393$var$getScriptKey(src) {
    return '[src="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $d52e344c7cd7d393$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $d52e344c7cd7d393$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $d52e344c7cd7d393$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $d52e344c7cd7d393$var$markNodeAsHoistable(instance), instance;
            var styleProps = $d52e344c7cd7d393$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $d52e344c7cd7d393$var$markNodeAsHoistable(instance);
            $d52e344c7cd7d393$var$setInitialProperties(instance, "style", styleProps);
            $d52e344c7cd7d393$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $d52e344c7cd7d393$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($d52e344c7cd7d393$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $d52e344c7cd7d393$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $d52e344c7cd7d393$var$stylesheetPropsFromRawProps(props);
            (styleProps = $d52e344c7cd7d393$var$preloadPropsMap.get(styleProps)) && $d52e344c7cd7d393$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $d52e344c7cd7d393$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d52e344c7cd7d393$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $d52e344c7cd7d393$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $d52e344c7cd7d393$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($d52e344c7cd7d393$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $d52e344c7cd7d393$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $d52e344c7cd7d393$var$preloadPropsMap.get(instance$250)) instance = $d52e344c7cd7d393$var$assign({}, props), $d52e344c7cd7d393$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $d52e344c7cd7d393$var$markNodeAsHoistable(styleProps);
            $d52e344c7cd7d393$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $d52e344c7cd7d393$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $d52e344c7cd7d393$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $d52e344c7cd7d393$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $d52e344c7cd7d393$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $d52e344c7cd7d393$var$tagCaches = null;
function $d52e344c7cd7d393$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $d52e344c7cd7d393$var$tagCaches) {
        var cache = new Map();
        var caches = $d52e344c7cd7d393$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $d52e344c7cd7d393$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$d52e344c7cd7d393$var$internalHoistableMarker] || node[$d52e344c7cd7d393$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $d52e344c7cd7d393$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $d52e344c7cd7d393$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $d52e344c7cd7d393$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $d52e344c7cd7d393$var$suspendedState = null;
function $d52e344c7cd7d393$var$noop() {}
function $d52e344c7cd7d393$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $d52e344c7cd7d393$var$suspendedState) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(475));
    var state = $d52e344c7cd7d393$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $d52e344c7cd7d393$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($d52e344c7cd7d393$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $d52e344c7cd7d393$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $d52e344c7cd7d393$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $d52e344c7cd7d393$var$stylesheetPropsFromRawProps(props);
            (key = $d52e344c7cd7d393$var$preloadPropsMap.get(key)) && $d52e344c7cd7d393$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $d52e344c7cd7d393$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $d52e344c7cd7d393$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $d52e344c7cd7d393$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $d52e344c7cd7d393$var$waitForCommitToBeReady() {
    if (null === $d52e344c7cd7d393$var$suspendedState) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(475));
    var state = $d52e344c7cd7d393$var$suspendedState;
    state.stylesheets && 0 === state.count && $d52e344c7cd7d393$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $d52e344c7cd7d393$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $d52e344c7cd7d393$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $d52e344c7cd7d393$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $d52e344c7cd7d393$var$precedencesByRoot = null;
function $d52e344c7cd7d393$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $d52e344c7cd7d393$var$precedencesByRoot = new Map(), resources.forEach($d52e344c7cd7d393$var$insertStylesheetIntoRoot, state), $d52e344c7cd7d393$var$precedencesByRoot = null, $d52e344c7cd7d393$var$onUnsuspend.call(state));
}
function $d52e344c7cd7d393$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $d52e344c7cd7d393$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $d52e344c7cd7d393$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $d52e344c7cd7d393$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $d52e344c7cd7d393$var$HostTransitionContext = {
    $$typeof: $d52e344c7cd7d393$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $d52e344c7cd7d393$var$sharedNotPendingObject,
    _currentValue2: $d52e344c7cd7d393$var$sharedNotPendingObject,
    _threadCount: 0
};
function $d52e344c7cd7d393$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $d52e344c7cd7d393$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $d52e344c7cd7d393$var$createLaneMap(0);
    this.hiddenUpdates = $d52e344c7cd7d393$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $d52e344c7cd7d393$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $d52e344c7cd7d393$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $d52e344c7cd7d393$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $d52e344c7cd7d393$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $d52e344c7cd7d393$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $d52e344c7cd7d393$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $d52e344c7cd7d393$var$emptyContextObject;
    parentComponent = $d52e344c7cd7d393$var$emptyContextObject;
    return parentComponent;
}
function $d52e344c7cd7d393$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $d52e344c7cd7d393$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $d52e344c7cd7d393$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $d52e344c7cd7d393$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($d52e344c7cd7d393$var$scheduleUpdateOnFiber(element, rootFiber, lane), $d52e344c7cd7d393$var$entangleTransitions(element, rootFiber, lane));
}
function $d52e344c7cd7d393$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $d52e344c7cd7d393$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $d52e344c7cd7d393$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $d52e344c7cd7d393$var$markRetryLaneImpl(fiber, retryLane);
}
function $d52e344c7cd7d393$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $d52e344c7cd7d393$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $d52e344c7cd7d393$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $d52e344c7cd7d393$var$_enabled = !0;
function $d52e344c7cd7d393$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d52e344c7cd7d393$var$ReactSharedInternals.T;
    $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
    var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    try {
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 2, $d52e344c7cd7d393$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d52e344c7cd7d393$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $d52e344c7cd7d393$var$ReactSharedInternals.T;
    $d52e344c7cd7d393$var$ReactSharedInternals.T = null;
    var previousPriority = $d52e344c7cd7d393$var$ReactDOMSharedInternals.p;
    try {
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = 8, $d52e344c7cd7d393$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $d52e344c7cd7d393$var$ReactDOMSharedInternals.p = previousPriority, $d52e344c7cd7d393$var$ReactSharedInternals.T = prevTransition;
    }
}
function $d52e344c7cd7d393$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($d52e344c7cd7d393$var$_enabled) {
        var blockedOn = $d52e344c7cd7d393$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $d52e344c7cd7d393$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d52e344c7cd7d393$var$return_targetInst, targetContainer), $d52e344c7cd7d393$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($d52e344c7cd7d393$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($d52e344c7cd7d393$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $d52e344c7cd7d393$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $d52e344c7cd7d393$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $d52e344c7cd7d393$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $d52e344c7cd7d393$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $d52e344c7cd7d393$var$ensureRootIsScheduled(fiber);
                                0 === ($d52e344c7cd7d393$var$executionContext & 6) && ($d52e344c7cd7d393$var$workInProgressRootRenderTargetTime = $d52e344c7cd7d393$var$now() + 500, $d52e344c7cd7d393$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $d52e344c7cd7d393$var$scheduleUpdateOnFiber(root, fiber, 2), $d52e344c7cd7d393$var$flushSyncWork$1(), $d52e344c7cd7d393$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $d52e344c7cd7d393$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $d52e344c7cd7d393$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $d52e344c7cd7d393$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $d52e344c7cd7d393$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $d52e344c7cd7d393$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $d52e344c7cd7d393$var$getEventTarget(nativeEvent);
    return $d52e344c7cd7d393$var$findInstanceBlockingTarget(nativeEvent);
}
var $d52e344c7cd7d393$var$return_targetInst = null;
function $d52e344c7cd7d393$var$findInstanceBlockingTarget(targetNode) {
    $d52e344c7cd7d393$var$return_targetInst = null;
    targetNode = $d52e344c7cd7d393$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $d52e344c7cd7d393$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $d52e344c7cd7d393$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $d52e344c7cd7d393$var$return_targetInst = targetNode;
    return null;
}
function $d52e344c7cd7d393$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($d52e344c7cd7d393$var$getCurrentPriorityLevel()){
                case $d52e344c7cd7d393$var$ImmediatePriority:
                    return 2;
                case $d52e344c7cd7d393$var$UserBlockingPriority:
                    return 8;
                case $d52e344c7cd7d393$var$NormalPriority$1:
                case $d52e344c7cd7d393$var$LowPriority:
                    return 32;
                case $d52e344c7cd7d393$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $d52e344c7cd7d393$var$hasScheduledReplayAttempt = !1, $d52e344c7cd7d393$var$queuedFocus = null, $d52e344c7cd7d393$var$queuedDrag = null, $d52e344c7cd7d393$var$queuedMouse = null, $d52e344c7cd7d393$var$queuedPointers = new Map(), $d52e344c7cd7d393$var$queuedPointerCaptures = new Map(), $d52e344c7cd7d393$var$queuedExplicitHydrationTargets = [], $d52e344c7cd7d393$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $d52e344c7cd7d393$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $d52e344c7cd7d393$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $d52e344c7cd7d393$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $d52e344c7cd7d393$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $d52e344c7cd7d393$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $d52e344c7cd7d393$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $d52e344c7cd7d393$var$getInstanceFromNode(blockedOn), null !== blockedOn && $d52e344c7cd7d393$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $d52e344c7cd7d393$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $d52e344c7cd7d393$var$queuedFocus = $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent($d52e344c7cd7d393$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $d52e344c7cd7d393$var$queuedDrag = $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent($d52e344c7cd7d393$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $d52e344c7cd7d393$var$queuedMouse = $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent($d52e344c7cd7d393$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $d52e344c7cd7d393$var$queuedPointers.set(pointerId, $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent($d52e344c7cd7d393$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $d52e344c7cd7d393$var$queuedPointerCaptures.set(pointerId, $d52e344c7cd7d393$var$accumulateOrCreateContinuousQueuedReplayableEvent($d52e344c7cd7d393$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $d52e344c7cd7d393$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $d52e344c7cd7d393$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $d52e344c7cd7d393$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $d52e344c7cd7d393$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $d52e344c7cd7d393$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $d52e344c7cd7d393$var$requestUpdateLane();
                            lane = $d52e344c7cd7d393$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $d52e344c7cd7d393$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $d52e344c7cd7d393$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $d52e344c7cd7d393$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $d52e344c7cd7d393$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $d52e344c7cd7d393$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $d52e344c7cd7d393$var$currentReplayingEvent = null;
        } else return targetContainers = $d52e344c7cd7d393$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $d52e344c7cd7d393$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $d52e344c7cd7d393$var$replayUnblockedEvents() {
    $d52e344c7cd7d393$var$hasScheduledReplayAttempt = !1;
    null !== $d52e344c7cd7d393$var$queuedFocus && $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEvent($d52e344c7cd7d393$var$queuedFocus) && ($d52e344c7cd7d393$var$queuedFocus = null);
    null !== $d52e344c7cd7d393$var$queuedDrag && $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEvent($d52e344c7cd7d393$var$queuedDrag) && ($d52e344c7cd7d393$var$queuedDrag = null);
    null !== $d52e344c7cd7d393$var$queuedMouse && $d52e344c7cd7d393$var$attemptReplayContinuousQueuedEvent($d52e344c7cd7d393$var$queuedMouse) && ($d52e344c7cd7d393$var$queuedMouse = null);
    $d52e344c7cd7d393$var$queuedPointers.forEach($d52e344c7cd7d393$var$attemptReplayContinuousQueuedEventInMap);
    $d52e344c7cd7d393$var$queuedPointerCaptures.forEach($d52e344c7cd7d393$var$attemptReplayContinuousQueuedEventInMap);
}
function $d52e344c7cd7d393$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $d52e344c7cd7d393$var$hasScheduledReplayAttempt || ($d52e344c7cd7d393$var$hasScheduledReplayAttempt = !0, $aXDU1.unstable_scheduleCallback($aXDU1.unstable_NormalPriority, $d52e344c7cd7d393$var$replayUnblockedEvents)));
}
var $d52e344c7cd7d393$var$lastScheduledReplayQueue = null;
function $d52e344c7cd7d393$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $d52e344c7cd7d393$var$lastScheduledReplayQueue !== formReplayingQueue && ($d52e344c7cd7d393$var$lastScheduledReplayQueue = formReplayingQueue, $aXDU1.unstable_scheduleCallback($aXDU1.unstable_NormalPriority, function() {
        $d52e344c7cd7d393$var$lastScheduledReplayQueue === formReplayingQueue && ($d52e344c7cd7d393$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $d52e344c7cd7d393$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $d52e344c7cd7d393$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $d52e344c7cd7d393$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $d52e344c7cd7d393$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $d52e344c7cd7d393$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $d52e344c7cd7d393$var$queuedFocus && $d52e344c7cd7d393$var$scheduleCallbackIfUnblocked($d52e344c7cd7d393$var$queuedFocus, unblocked);
    null !== $d52e344c7cd7d393$var$queuedDrag && $d52e344c7cd7d393$var$scheduleCallbackIfUnblocked($d52e344c7cd7d393$var$queuedDrag, unblocked);
    null !== $d52e344c7cd7d393$var$queuedMouse && $d52e344c7cd7d393$var$scheduleCallbackIfUnblocked($d52e344c7cd7d393$var$queuedMouse, unblocked);
    $d52e344c7cd7d393$var$queuedPointers.forEach(unblock);
    $d52e344c7cd7d393$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $d52e344c7cd7d393$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $d52e344c7cd7d393$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $d52e344c7cd7d393$var$queuedExplicitHydrationTargets.length && (i = $d52e344c7cd7d393$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$d52e344c7cd7d393$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $d52e344c7cd7d393$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$d52e344c7cd7d393$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $d52e344c7cd7d393$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$d52e344c7cd7d393$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $d52e344c7cd7d393$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $d52e344c7cd7d393$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $d52e344c7cd7d393$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d52e344c7cd7d393$var$ReactDOMHydrationRoot.prototype.render = $d52e344c7cd7d393$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(409));
    var current = root.current, lane = $d52e344c7cd7d393$var$requestUpdateLane();
    $d52e344c7cd7d393$var$updateContainerImpl(current, lane, children, root, null, null);
};
$d52e344c7cd7d393$var$ReactDOMHydrationRoot.prototype.unmount = $d52e344c7cd7d393$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $d52e344c7cd7d393$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $d52e344c7cd7d393$var$flushSyncWork$1();
        container[$d52e344c7cd7d393$var$internalContainerInstanceKey] = null;
    }
};
function $d52e344c7cd7d393$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$d52e344c7cd7d393$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $d52e344c7cd7d393$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $d52e344c7cd7d393$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $d52e344c7cd7d393$var$queuedExplicitHydrationTargets[i].priority; i++);
        $d52e344c7cd7d393$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $d52e344c7cd7d393$var$attemptExplicitHydrationTarget(target);
    }
};
var $d52e344c7cd7d393$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $6PIFj.version;
if ("19.1.1" !== $d52e344c7cd7d393$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(527, $d52e344c7cd7d393$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$d52e344c7cd7d393$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $d52e344c7cd7d393$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $d52e344c7cd7d393$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $d52e344c7cd7d393$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $d52e344c7cd7d393$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $d52e344c7cd7d393$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$d52e344c7cd7d393$var$hook$jscomp$inline_2257.isDisabled && $d52e344c7cd7d393$var$hook$jscomp$inline_2257.supportsFiber) try {
        $d52e344c7cd7d393$var$rendererID = $d52e344c7cd7d393$var$hook$jscomp$inline_2257.inject($d52e344c7cd7d393$var$internals$jscomp$inline_2256), $d52e344c7cd7d393$var$injectedHook = $d52e344c7cd7d393$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$d52e344c7cd7d393$export$882461b6382ed46c = function(container, options) {
    if (!$d52e344c7cd7d393$var$isValidContainer(container)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d52e344c7cd7d393$var$defaultOnUncaughtError, onCaughtError = $d52e344c7cd7d393$var$defaultOnCaughtError, onRecoverableError = $d52e344c7cd7d393$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $d52e344c7cd7d393$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$d52e344c7cd7d393$var$internalContainerInstanceKey] = options.current;
    $d52e344c7cd7d393$var$listenToAllSupportedEvents(container);
    return new $d52e344c7cd7d393$var$ReactDOMRoot(options);
};
$d52e344c7cd7d393$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$d52e344c7cd7d393$var$isValidContainer(container)) throw Error($d52e344c7cd7d393$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $d52e344c7cd7d393$var$defaultOnUncaughtError, onCaughtError = $d52e344c7cd7d393$var$defaultOnCaughtError, onRecoverableError = $d52e344c7cd7d393$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $d52e344c7cd7d393$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $d52e344c7cd7d393$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $d52e344c7cd7d393$var$requestUpdateLane();
    isStrictMode = $d52e344c7cd7d393$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $d52e344c7cd7d393$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $d52e344c7cd7d393$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $d52e344c7cd7d393$var$markRootUpdated$1(initialChildren, options);
    $d52e344c7cd7d393$var$ensureRootIsScheduled(initialChildren);
    container[$d52e344c7cd7d393$var$internalContainerInstanceKey] = initialChildren.current;
    $d52e344c7cd7d393$var$listenToAllSupportedEvents(container);
    return new $d52e344c7cd7d393$var$ReactDOMHydrationRoot(initialChildren);
};
$d52e344c7cd7d393$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("aXDU1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("03RjC"));

});
parcelRegister("03RjC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $00b9a345a914ff1f$export$c4744153514ff05d, (v) => $00b9a345a914ff1f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $00b9a345a914ff1f$export$3e506c1ccc9cc1a7, (v) => $00b9a345a914ff1f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $00b9a345a914ff1f$export$e26fe2ed2fa76875, (v) => $00b9a345a914ff1f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $00b9a345a914ff1f$export$502329bbf4b505b1, (v) => $00b9a345a914ff1f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $00b9a345a914ff1f$export$6e3807111c4874c4, (v) => $00b9a345a914ff1f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $00b9a345a914ff1f$export$c27134553091fb3a, (v) => $00b9a345a914ff1f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $00b9a345a914ff1f$export$33ee1acdc04fd2a2, (v) => $00b9a345a914ff1f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $00b9a345a914ff1f$export$b00a404bbd5edef2, (v) => $00b9a345a914ff1f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $00b9a345a914ff1f$export$d66a1c1c77bd778b, (v) => $00b9a345a914ff1f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $00b9a345a914ff1f$export$d3dfb8e4810cb555, (v) => $00b9a345a914ff1f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $00b9a345a914ff1f$export$72fdf0e06517287b, (v) => $00b9a345a914ff1f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $00b9a345a914ff1f$export$816d2913ae6b83b1, (v) => $00b9a345a914ff1f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $00b9a345a914ff1f$export$61bcfe829111a1d0, (v) => $00b9a345a914ff1f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $00b9a345a914ff1f$export$7ee8c9beb337bc3f, (v) => $00b9a345a914ff1f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $00b9a345a914ff1f$export$b5836b71941fa3ed, (v) => $00b9a345a914ff1f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $00b9a345a914ff1f$export$cf845f2c119da08a, (v) => $00b9a345a914ff1f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $00b9a345a914ff1f$export$c4744153514ff05d;
var $00b9a345a914ff1f$export$3e506c1ccc9cc1a7;
var $00b9a345a914ff1f$export$e26fe2ed2fa76875;
var $00b9a345a914ff1f$export$502329bbf4b505b1;
var $00b9a345a914ff1f$export$6e3807111c4874c4;
var $00b9a345a914ff1f$export$c27134553091fb3a;
var $00b9a345a914ff1f$export$33ee1acdc04fd2a2;
var $00b9a345a914ff1f$export$b00a404bbd5edef2;
var $00b9a345a914ff1f$export$d66a1c1c77bd778b;
var $00b9a345a914ff1f$export$d3dfb8e4810cb555;
var $00b9a345a914ff1f$export$72fdf0e06517287b;
var $00b9a345a914ff1f$export$816d2913ae6b83b1;
var $00b9a345a914ff1f$export$61bcfe829111a1d0;
var $00b9a345a914ff1f$export$7ee8c9beb337bc3f;
var $00b9a345a914ff1f$export$b5836b71941fa3ed;
var $00b9a345a914ff1f$export$cf845f2c119da08a;
"use strict";
function $00b9a345a914ff1f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $00b9a345a914ff1f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $00b9a345a914ff1f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $00b9a345a914ff1f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $00b9a345a914ff1f$var$compare(left, last)) rightIndex < length && 0 > $00b9a345a914ff1f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $00b9a345a914ff1f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $00b9a345a914ff1f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$00b9a345a914ff1f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $00b9a345a914ff1f$var$localPerformance = performance;
    $00b9a345a914ff1f$export$c4744153514ff05d = function() {
        return $00b9a345a914ff1f$var$localPerformance.now();
    };
} else {
    var $00b9a345a914ff1f$var$localDate = Date, $00b9a345a914ff1f$var$initialTime = $00b9a345a914ff1f$var$localDate.now();
    $00b9a345a914ff1f$export$c4744153514ff05d = function() {
        return $00b9a345a914ff1f$var$localDate.now() - $00b9a345a914ff1f$var$initialTime;
    };
}
var $00b9a345a914ff1f$var$taskQueue = [], $00b9a345a914ff1f$var$timerQueue = [], $00b9a345a914ff1f$var$taskIdCounter = 1, $00b9a345a914ff1f$var$currentTask = null, $00b9a345a914ff1f$var$currentPriorityLevel = 3, $00b9a345a914ff1f$var$isPerformingWork = !1, $00b9a345a914ff1f$var$isHostCallbackScheduled = !1, $00b9a345a914ff1f$var$isHostTimeoutScheduled = !1, $00b9a345a914ff1f$var$needsPaint = !1, $00b9a345a914ff1f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $00b9a345a914ff1f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $00b9a345a914ff1f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $00b9a345a914ff1f$var$advanceTimers(currentTime) {
    for(var timer = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $00b9a345a914ff1f$var$pop($00b9a345a914ff1f$var$timerQueue);
        else if (timer.startTime <= currentTime) $00b9a345a914ff1f$var$pop($00b9a345a914ff1f$var$timerQueue), timer.sortIndex = timer.expirationTime, $00b9a345a914ff1f$var$push($00b9a345a914ff1f$var$taskQueue, timer);
        else break;
        timer = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$timerQueue);
    }
}
function $00b9a345a914ff1f$var$handleTimeout(currentTime) {
    $00b9a345a914ff1f$var$isHostTimeoutScheduled = !1;
    $00b9a345a914ff1f$var$advanceTimers(currentTime);
    if (!$00b9a345a914ff1f$var$isHostCallbackScheduled) {
        if (null !== $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$taskQueue)) $00b9a345a914ff1f$var$isHostCallbackScheduled = !0, $00b9a345a914ff1f$var$isMessageLoopRunning || ($00b9a345a914ff1f$var$isMessageLoopRunning = !0, $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$timerQueue);
            null !== firstTimer && $00b9a345a914ff1f$var$requestHostTimeout($00b9a345a914ff1f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $00b9a345a914ff1f$var$isMessageLoopRunning = !1, $00b9a345a914ff1f$var$taskTimeoutID = -1, $00b9a345a914ff1f$var$frameInterval = 5, $00b9a345a914ff1f$var$startTime = -1;
function $00b9a345a914ff1f$var$shouldYieldToHost() {
    return $00b9a345a914ff1f$var$needsPaint ? !0 : $00b9a345a914ff1f$export$c4744153514ff05d() - $00b9a345a914ff1f$var$startTime < $00b9a345a914ff1f$var$frameInterval ? !1 : !0;
}
function $00b9a345a914ff1f$var$performWorkUntilDeadline() {
    $00b9a345a914ff1f$var$needsPaint = !1;
    if ($00b9a345a914ff1f$var$isMessageLoopRunning) {
        var currentTime = $00b9a345a914ff1f$export$c4744153514ff05d();
        $00b9a345a914ff1f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $00b9a345a914ff1f$var$isHostCallbackScheduled = !1;
                $00b9a345a914ff1f$var$isHostTimeoutScheduled && ($00b9a345a914ff1f$var$isHostTimeoutScheduled = !1, $00b9a345a914ff1f$var$localClearTimeout($00b9a345a914ff1f$var$taskTimeoutID), $00b9a345a914ff1f$var$taskTimeoutID = -1);
                $00b9a345a914ff1f$var$isPerformingWork = !0;
                var previousPriorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
                try {
                    b: {
                        $00b9a345a914ff1f$var$advanceTimers(currentTime);
                        for($00b9a345a914ff1f$var$currentTask = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$taskQueue); null !== $00b9a345a914ff1f$var$currentTask && !($00b9a345a914ff1f$var$currentTask.expirationTime > currentTime && $00b9a345a914ff1f$var$shouldYieldToHost());){
                            var callback = $00b9a345a914ff1f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $00b9a345a914ff1f$var$currentTask.callback = null;
                                $00b9a345a914ff1f$var$currentPriorityLevel = $00b9a345a914ff1f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($00b9a345a914ff1f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $00b9a345a914ff1f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $00b9a345a914ff1f$var$currentTask.callback = continuationCallback;
                                    $00b9a345a914ff1f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $00b9a345a914ff1f$var$currentTask === $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$taskQueue) && $00b9a345a914ff1f$var$pop($00b9a345a914ff1f$var$taskQueue);
                                $00b9a345a914ff1f$var$advanceTimers(currentTime);
                            } else $00b9a345a914ff1f$var$pop($00b9a345a914ff1f$var$taskQueue);
                            $00b9a345a914ff1f$var$currentTask = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$taskQueue);
                        }
                        if (null !== $00b9a345a914ff1f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$timerQueue);
                            null !== firstTimer && $00b9a345a914ff1f$var$requestHostTimeout($00b9a345a914ff1f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $00b9a345a914ff1f$var$currentTask = null, $00b9a345a914ff1f$var$currentPriorityLevel = previousPriorityLevel, $00b9a345a914ff1f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline() : $00b9a345a914ff1f$var$isMessageLoopRunning = !1;
        }
    }
}
var $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $00b9a345a914ff1f$var$localSetImmediate) $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline = function() {
    $00b9a345a914ff1f$var$localSetImmediate($00b9a345a914ff1f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $00b9a345a914ff1f$var$channel = new MessageChannel(), $00b9a345a914ff1f$var$port = $00b9a345a914ff1f$var$channel.port2;
    $00b9a345a914ff1f$var$channel.port1.onmessage = $00b9a345a914ff1f$var$performWorkUntilDeadline;
    $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline = function() {
        $00b9a345a914ff1f$var$port.postMessage(null);
    };
} else $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline = function() {
    $00b9a345a914ff1f$var$localSetTimeout($00b9a345a914ff1f$var$performWorkUntilDeadline, 0);
};
function $00b9a345a914ff1f$var$requestHostTimeout(callback, ms) {
    $00b9a345a914ff1f$var$taskTimeoutID = $00b9a345a914ff1f$var$localSetTimeout(function() {
        callback($00b9a345a914ff1f$export$c4744153514ff05d());
    }, ms);
}
$00b9a345a914ff1f$export$3e506c1ccc9cc1a7 = 5;
$00b9a345a914ff1f$export$e26fe2ed2fa76875 = 1;
$00b9a345a914ff1f$export$502329bbf4b505b1 = 4;
$00b9a345a914ff1f$export$6e3807111c4874c4 = 3;
$00b9a345a914ff1f$export$c27134553091fb3a = null;
$00b9a345a914ff1f$export$33ee1acdc04fd2a2 = 2;
$00b9a345a914ff1f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$00b9a345a914ff1f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $00b9a345a914ff1f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$00b9a345a914ff1f$export$d3dfb8e4810cb555 = function() {
    return $00b9a345a914ff1f$var$currentPriorityLevel;
};
$00b9a345a914ff1f$export$72fdf0e06517287b = function(eventHandler) {
    switch($00b9a345a914ff1f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
    $00b9a345a914ff1f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $00b9a345a914ff1f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$00b9a345a914ff1f$export$816d2913ae6b83b1 = function() {
    $00b9a345a914ff1f$var$needsPaint = !0;
};
$00b9a345a914ff1f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
    $00b9a345a914ff1f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $00b9a345a914ff1f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$00b9a345a914ff1f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $00b9a345a914ff1f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $00b9a345a914ff1f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $00b9a345a914ff1f$var$push($00b9a345a914ff1f$var$timerQueue, priorityLevel), null === $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$taskQueue) && priorityLevel === $00b9a345a914ff1f$var$peek($00b9a345a914ff1f$var$timerQueue) && ($00b9a345a914ff1f$var$isHostTimeoutScheduled ? ($00b9a345a914ff1f$var$localClearTimeout($00b9a345a914ff1f$var$taskTimeoutID), $00b9a345a914ff1f$var$taskTimeoutID = -1) : $00b9a345a914ff1f$var$isHostTimeoutScheduled = !0, $00b9a345a914ff1f$var$requestHostTimeout($00b9a345a914ff1f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $00b9a345a914ff1f$var$push($00b9a345a914ff1f$var$taskQueue, priorityLevel), $00b9a345a914ff1f$var$isHostCallbackScheduled || $00b9a345a914ff1f$var$isPerformingWork || ($00b9a345a914ff1f$var$isHostCallbackScheduled = !0, $00b9a345a914ff1f$var$isMessageLoopRunning || ($00b9a345a914ff1f$var$isMessageLoopRunning = !0, $00b9a345a914ff1f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$00b9a345a914ff1f$export$b5836b71941fa3ed = $00b9a345a914ff1f$var$shouldYieldToHost;
$00b9a345a914ff1f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $00b9a345a914ff1f$var$currentPriorityLevel;
        $00b9a345a914ff1f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $00b9a345a914ff1f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8GGcu", function(module, exports) {
'use strict';
function $6532fb1ec57a5862$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($6532fb1ec57a5862$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$6532fb1ec57a5862$var$checkDCE();

module.exports = (parcelRequire("81O9k"));

});
parcelRegister("81O9k", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $5d8551575ee9195a$export$69ce8ef3fe5cead0, (v) => $5d8551575ee9195a$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $5d8551575ee9195a$export$d39a5bbd09211389, (v) => $5d8551575ee9195a$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $5d8551575ee9195a$export$cd75ccfd720a3cd4, (v) => $5d8551575ee9195a$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $5d8551575ee9195a$export$a0816fa17a9e79be, (v) => $5d8551575ee9195a$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $5d8551575ee9195a$export$7292efcadded39f3, (v) => $5d8551575ee9195a$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $5d8551575ee9195a$export$da407abadb9b8f86, (v) => $5d8551575ee9195a$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $5d8551575ee9195a$export$314cfea32580671c, (v) => $5d8551575ee9195a$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $5d8551575ee9195a$export$513ccb98c53b8039, (v) => $5d8551575ee9195a$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $5d8551575ee9195a$export$dbca993bc2d264a, (v) => $5d8551575ee9195a$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $5d8551575ee9195a$export$4797a8006f0655d0, (v) => $5d8551575ee9195a$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $5d8551575ee9195a$export$c78a37762a8d58e1, (v) => $5d8551575ee9195a$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $5d8551575ee9195a$export$606f11b2eb45ecc6, (v) => $5d8551575ee9195a$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $5d8551575ee9195a$export$f7e8a0bf92324b1e, (v) => $5d8551575ee9195a$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $5d8551575ee9195a$export$83d89fbfd8236492, (v) => $5d8551575ee9195a$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5d8551575ee9195a$export$69ce8ef3fe5cead0;
var $5d8551575ee9195a$export$d39a5bbd09211389;
var $5d8551575ee9195a$export$cd75ccfd720a3cd4;
var $5d8551575ee9195a$export$a0816fa17a9e79be;
var $5d8551575ee9195a$export$7292efcadded39f3;
var $5d8551575ee9195a$export$da407abadb9b8f86;
var $5d8551575ee9195a$export$314cfea32580671c;
var $5d8551575ee9195a$export$513ccb98c53b8039;
var $5d8551575ee9195a$export$dbca993bc2d264a;
var $5d8551575ee9195a$export$4797a8006f0655d0;
var $5d8551575ee9195a$export$c78a37762a8d58e1;
var $5d8551575ee9195a$export$606f11b2eb45ecc6;
var $5d8551575ee9195a$export$f7e8a0bf92324b1e;
var $5d8551575ee9195a$export$83d89fbfd8236492;
"use strict";

var $6PIFj = parcelRequire("6PIFj");
function $5d8551575ee9195a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5d8551575ee9195a$var$noop() {}
var $5d8551575ee9195a$var$Internals = {
    d: {
        f: $5d8551575ee9195a$var$noop,
        r: function() {
            throw Error($5d8551575ee9195a$var$formatProdErrorMessage(522));
        },
        D: $5d8551575ee9195a$var$noop,
        C: $5d8551575ee9195a$var$noop,
        L: $5d8551575ee9195a$var$noop,
        m: $5d8551575ee9195a$var$noop,
        X: $5d8551575ee9195a$var$noop,
        S: $5d8551575ee9195a$var$noop,
        M: $5d8551575ee9195a$var$noop
    },
    p: 0,
    findDOMNode: null
}, $5d8551575ee9195a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $5d8551575ee9195a$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5d8551575ee9195a$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $5d8551575ee9195a$var$ReactSharedInternals = $6PIFj.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $5d8551575ee9195a$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$5d8551575ee9195a$export$69ce8ef3fe5cead0 = $5d8551575ee9195a$var$Internals;
$5d8551575ee9195a$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($5d8551575ee9195a$var$formatProdErrorMessage(299));
    return $5d8551575ee9195a$var$createPortal$1(children, container, null, key);
};
$5d8551575ee9195a$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $5d8551575ee9195a$var$ReactSharedInternals.T, previousUpdatePriority = $5d8551575ee9195a$var$Internals.p;
    try {
        if ($5d8551575ee9195a$var$ReactSharedInternals.T = null, $5d8551575ee9195a$var$Internals.p = 2, fn) return fn();
    } finally{
        $5d8551575ee9195a$var$ReactSharedInternals.T = previousTransition, $5d8551575ee9195a$var$Internals.p = previousUpdatePriority, $5d8551575ee9195a$var$Internals.d.f();
    }
};
$5d8551575ee9195a$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $5d8551575ee9195a$var$Internals.d.C(href, options));
};
$5d8551575ee9195a$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $5d8551575ee9195a$var$Internals.d.D(href);
};
$5d8551575ee9195a$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5d8551575ee9195a$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $5d8551575ee9195a$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $5d8551575ee9195a$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$5d8551575ee9195a$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $5d8551575ee9195a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $5d8551575ee9195a$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $5d8551575ee9195a$var$Internals.d.M(href);
    }
};
$5d8551575ee9195a$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $5d8551575ee9195a$var$getCrossOriginStringAs(as, options.crossOrigin);
        $5d8551575ee9195a$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$5d8551575ee9195a$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $5d8551575ee9195a$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $5d8551575ee9195a$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $5d8551575ee9195a$var$Internals.d.m(href);
    }
};
$5d8551575ee9195a$export$4797a8006f0655d0 = function(form) {
    $5d8551575ee9195a$var$Internals.d.r(form);
};
$5d8551575ee9195a$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$5d8551575ee9195a$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $5d8551575ee9195a$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$5d8551575ee9195a$export$f7e8a0bf92324b1e = function() {
    return $5d8551575ee9195a$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$5d8551575ee9195a$export$83d89fbfd8236492 = "19.1.1";

});




parcelRegister("9CCCV", function(module, exports) {

$parcel$export(module.exports, "ProjectBoardForm", () => $f0c4e5af077f3cf3$export$2ae966031755270b);

var $1srIE = parcelRequire("1srIE");

var $6PIFj = parcelRequire("6PIFj");

var $lEQ03 = parcelRequire("lEQ03");

var $iouPm = parcelRequire("iouPm");

var $akJza = parcelRequire("akJza");

var $9zaOw = parcelRequire("9zaOw");

var $bWUN0 = parcelRequire("bWUN0");

function $f0c4e5af077f3cf3$export$2ae966031755270b({ board: board, onBoardSaved: onBoardSaved, onSubmitApi: onSubmitApi, flyoutId: flyoutId }) {
    const deriveSegmentIds = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback((sourceBoard)=>{
        if (!sourceBoard) return [];
        if (Array.isArray(sourceBoard.segmentTypeIds) && sourceBoard.segmentTypeIds.length) return sourceBoard.segmentTypeIds.map((s)=>{
            if (typeof s === 'number') return s;
            if (typeof s === 'string') return parseInt(s, 10);
            return s?.id;
        }).filter((value)=>Number.isFinite(value)).map((id)=>id.toString());
        if (Array.isArray(sourceBoard.segmentTypes)) return sourceBoard.segmentTypes.map((s)=>s.id.toString());
        return [];
    }, []);
    const boardSegmentIds = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>deriveSegmentIds(board), [
        board,
        deriveSegmentIds
    ]);
    const { register: register, handleSubmit: handleSubmit, watch: watch, formState: { errors: errors, isSubmitSuccessful: isSubmitSuccessful }, setError: setError, reset: reset } = (0, $lEQ03.useForm)({
        reValidateMode: 'onSubmit',
        defaultValues: {
            name: board?.name || '',
            segmentTypeIds: boardSegmentIds,
            notes: board?.notes || ''
        }
    });
    const [segmentTypes, setSegmentTypes] = (0, $6PIFj.useState)([]);
    const [boardId, setBoardId] = (0, $6PIFj.useState)(board?.id || null);
    const boardName = watch("name");
    const selectedSegments = watch("segmentTypeIds");
    (0, $6PIFj.useEffect)(()=>{
        if (!board) return;
        const nextValues = {
            name: board.name || '',
            segmentTypeIds: boardSegmentIds,
            notes: board.notes || ''
        };
        reset(nextValues);
        setBoardId(board.id || null);
    }, [
        board,
        boardSegmentIds,
        reset
    ]);
    // Load segments
    (0, $6PIFj.useEffect)(()=>{
        (0, $iouPm.segmentTypesList)().then((data)=>{
            setSegmentTypes(data);
        }).catch((e)=>console.error('Error loading segment types:', e));
    }, []);
    // Handle flyout close after successful submit
    (0, $6PIFj.useEffect)(()=>{
        if (isSubmitSuccessful && boardId) {
            if (flyoutId) (0, $9zaOw.FlyoutManager).close(flyoutId);
            reset();
            if (onBoardSaved) onBoardSaved(boardId);
        }
    }, [
        isSubmitSuccessful,
        boardId,
        flyoutId,
        reset,
        onBoardSaved
    ]);
    const onSubmit = (0, $akJza.createApiOnSubmit)(async (data)=>{
        let id;
        const segmentTypeIds = Array.isArray(data.segmentTypeIds) ? data.segmentTypeIds.map((id)=>parseInt(id, 10)).filter(Number.isFinite) : [];
        if (onSubmitApi) id = await onSubmitApi({
            id: board?.id,
            name: data.name,
            segmentTypeIds: segmentTypeIds,
            notes: data.notes
        });
        else {
            const { projectBoardsCreate: projectBoardsCreate } = await Promise.resolve((parcelRequire("iouPm")));
            id = await projectBoardsCreate({
                name: data.name,
                segmentTypeIds: segmentTypeIds,
                notes: data.notes
            });
        }
        setBoardId(id);
        // GTM: Track successful project board creation
        (0, $bWUN0.pushEvent)({
            'event': 'formSubmission',
            'formID': 'createProjectBoard'
        });
        if (onBoardSaved) onBoardSaved(id, {
            name: data.name,
            notes: data.notes,
            segmentTypeIds: segmentTypeIds
        });
        if (flyoutId) (0, $9zaOw.FlyoutManager).close(flyoutId);
    }, setError);
    const isDisabled = !boardName?.trim() || !selectedSegments?.length;
    return /*#__PURE__*/ (0, $1srIE.jsx)("div", {
        className: "projectboard-flyout",
        children: /*#__PURE__*/ (0, $1srIE.jsxs)("form", {
            onSubmit: handleSubmit(onSubmit),
            children: [
                /*#__PURE__*/ (0, $1srIE.jsx)("h4", {
                    children: board ? 'Edit Project Board' : 'Create a New Project Board'
                }),
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "projectboard-flyout__group",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("label", {
                            htmlFor: "boardName",
                            children: "Board name"
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("input", {
                            className: "projectboard-flyout__input",
                            id: "boardName",
                            type: "text",
                            ...register("name", {
                                required: true
                            })
                        }),
                        errors.root?.Name && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                            className: "error",
                            children: errors.root.Name.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "projectboard-flyout__group",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                            className: "label projectboard-flyout__label",
                            children: "Board segment"
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                            className: "projectboard-flyout__segments",
                            children: segmentTypes.map((segmentType)=>/*#__PURE__*/ (0, $1srIE.jsxs)("label", {
                                    className: "segment-option",
                                    children: [
                                        /*#__PURE__*/ (0, $1srIE.jsx)("input", {
                                            type: "checkbox",
                                            value: segmentType.id,
                                            ...register("segmentTypeIds"),
                                            defaultChecked: boardSegmentIds.includes(segmentType.id.toString())
                                        }),
                                        /*#__PURE__*/ (0, $1srIE.jsx)("span", {
                                            children: segmentType.name
                                        })
                                    ]
                                }, segmentType.id))
                        }),
                        errors.root?.SegmentTypeIds && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                            className: "error",
                            children: errors.root.SegmentTypeIds.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "projectboard-flyout__group",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("label", {
                            htmlFor: "boardNotes",
                            children: "Board notes"
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("textarea", {
                            id: "boardNotes",
                            ...register("notes"),
                            rows: 6
                        }),
                        errors.root?.Notes && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                            className: "error",
                            children: errors.root.Notes.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                    children: /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                        className: "btn",
                        type: "submit",
                        disabled: isDisabled,
                        children: board ? 'Update Board' : 'Create Board'
                    })
                })
            ]
        })
    });
}

});
parcelRegister("lEQ03", function(module, exports) {

$parcel$export(module.exports, "useForm", () => $be32f8466032eb0d$export$87c0cf8eb5a167e0);

var $6PIFj = parcelRequire("6PIFj");
var $be32f8466032eb0d$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $be32f8466032eb0d$var$isDateObject = (value1)=>value1 instanceof Date;
var $be32f8466032eb0d$var$isNullOrUndefined = (value1)=>value1 == null;
const $be32f8466032eb0d$var$isObjectType = (value1)=>typeof value1 === 'object';
var $be32f8466032eb0d$var$isObject = (value1)=>!$be32f8466032eb0d$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $be32f8466032eb0d$var$isObjectType(value1) && !$be32f8466032eb0d$var$isDateObject(value1);
var $be32f8466032eb0d$var$getEventValue = (event)=>$be32f8466032eb0d$var$isObject(event) && event.target ? $be32f8466032eb0d$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $be32f8466032eb0d$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $be32f8466032eb0d$var$isNameInFieldArray = (names, name)=>names.has($be32f8466032eb0d$var$getNodeParentName(name));
var $be32f8466032eb0d$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $be32f8466032eb0d$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $be32f8466032eb0d$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $be32f8466032eb0d$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($be32f8466032eb0d$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $be32f8466032eb0d$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!isArray && !$be32f8466032eb0d$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $be32f8466032eb0d$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $be32f8466032eb0d$var$isKey = (value1)=>/^\w*$/.test(value1);
var $be32f8466032eb0d$var$isUndefined = (val)=>val === undefined;
var $be32f8466032eb0d$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $be32f8466032eb0d$var$stringToPath = (input)=>$be32f8466032eb0d$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $be32f8466032eb0d$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$be32f8466032eb0d$var$isObject(object)) return defaultValue;
    const result = ($be32f8466032eb0d$var$isKey(path) ? [
        path
    ] : $be32f8466032eb0d$var$stringToPath(path)).reduce((result, key)=>$be32f8466032eb0d$var$isNullOrUndefined(result) ? result : result[key], object);
    return $be32f8466032eb0d$var$isUndefined(result) || result === object ? $be32f8466032eb0d$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $be32f8466032eb0d$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $be32f8466032eb0d$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $be32f8466032eb0d$var$isKey(path) ? [
        path
    ] : $be32f8466032eb0d$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $be32f8466032eb0d$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $be32f8466032eb0d$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $be32f8466032eb0d$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $be32f8466032eb0d$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $be32f8466032eb0d$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).createContext(null);
$be32f8466032eb0d$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $be32f8466032eb0d$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useContext($be32f8466032eb0d$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $be32f8466032eb0d$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).createElement($be32f8466032eb0d$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $be32f8466032eb0d$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $be32f8466032eb0d$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $be32f8466032eb0d$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $be32f8466032eb0d$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $be32f8466032eb0d$export$606f11b2eb45ecc6(props) {
    const methods = $be32f8466032eb0d$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $be32f8466032eb0d$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>$be32f8466032eb0d$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $be32f8466032eb0d$var$isString = (value1)=>typeof value1 === 'string';
var $be32f8466032eb0d$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($be32f8466032eb0d$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $be32f8466032eb0d$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $be32f8466032eb0d$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $be32f8466032eb0d$var$isPrimitive = (value1)=>$be32f8466032eb0d$var$isNullOrUndefined(value1) || !$be32f8466032eb0d$var$isObjectType(value1);
function $be32f8466032eb0d$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($be32f8466032eb0d$var$isPrimitive(object1) || $be32f8466032eb0d$var$isPrimitive(object2)) return object1 === object2;
    if ($be32f8466032eb0d$var$isDateObject(object1) && $be32f8466032eb0d$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($be32f8466032eb0d$var$isDateObject(val1) && $be32f8466032eb0d$var$isDateObject(val2) || $be32f8466032eb0d$var$isObject(val1) && $be32f8466032eb0d$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$be32f8466032eb0d$var$deepEqual(val1, val2, _internal_visited) : val1 !== val2) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $be32f8466032eb0d$export$3c773aa2b84f29e0(props) {
    const methods = $be32f8466032eb0d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(undefined);
    _compute.current = compute;
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>control._getWatch(name, _defaultValue.current), [
        control,
        name
    ]);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
    $be32f8466032eb0d$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                if (!disabled) {
                    const formValues = $be32f8466032eb0d$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current);
                    if (_compute.current) {
                        const computedFormValues = _compute.current(formValues);
                        if (!$be32f8466032eb0d$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                            updateValue(computedFormValues);
                            _computeFormValues.current = computedFormValues;
                        }
                    } else updateValue(formValues);
                }
            }
        }), [
        control,
        disabled,
        name,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $be32f8466032eb0d$export$e8c786024a2b0a79(props) {
    const methods = $be32f8466032eb0d$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $be32f8466032eb0d$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>$be32f8466032eb0d$export$3988ae62b71be9a3(control._formValues, name, $be32f8466032eb0d$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $be32f8466032eb0d$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $be32f8466032eb0d$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(props);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$be32f8466032eb0d$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$be32f8466032eb0d$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$be32f8466032eb0d$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$be32f8466032eb0d$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$be32f8466032eb0d$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$be32f8466032eb0d$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $be32f8466032eb0d$var$getEventValue(event),
                name: name
            },
            type: $be32f8466032eb0d$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $be32f8466032eb0d$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $be32f8466032eb0d$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback((elm)=>{
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>({
            name: name,
            value: value1,
            ...$be32f8466032eb0d$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        control.register(name, {
            ..._props.current.rules,
            ...$be32f8466032eb0d$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $be32f8466032eb0d$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $be32f8466032eb0d$var$cloneObject($be32f8466032eb0d$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $be32f8466032eb0d$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($be32f8466032eb0d$var$isUndefined($be32f8466032eb0d$export$3988ae62b71be9a3(control._formValues, name))) $be32f8466032eb0d$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $be32f8466032eb0d$export$bd0bf19f25da8474 = (props)=>props.render($be32f8466032eb0d$export$e8c786024a2b0a79(props));
const $be32f8466032eb0d$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($be32f8466032eb0d$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $be32f8466032eb0d$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $be32f8466032eb0d$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $be32f8466032eb0d$export$a7fed597f4b8afd8(props) {
    const methods = $be32f8466032eb0d$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $be32f8466032eb0d$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $be32f8466032eb0d$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $be32f8466032eb0d$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $be32f8466032eb0d$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $be32f8466032eb0d$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $be32f8466032eb0d$var$isEmptyObject = (value1)=>$be32f8466032eb0d$var$isObject(value1) && !Object.keys(value1).length;
var $be32f8466032eb0d$var$isFileInput = (element)=>element.type === 'file';
var $be32f8466032eb0d$var$isFunction = (value1)=>typeof value1 === 'function';
var $be32f8466032eb0d$var$isHTMLElement = (value1)=>{
    if (!$be32f8466032eb0d$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $be32f8466032eb0d$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $be32f8466032eb0d$var$isRadioInput = (element)=>element.type === 'radio';
var $be32f8466032eb0d$var$isRadioOrCheckbox = (ref)=>$be32f8466032eb0d$var$isRadioInput(ref) || $be32f8466032eb0d$var$isCheckBoxInput(ref);
var $be32f8466032eb0d$var$live = (ref)=>$be32f8466032eb0d$var$isHTMLElement(ref) && ref.isConnected;
function $be32f8466032eb0d$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $be32f8466032eb0d$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $be32f8466032eb0d$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$be32f8466032eb0d$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $be32f8466032eb0d$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $be32f8466032eb0d$var$isKey(path) ? [
        path
    ] : $be32f8466032eb0d$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $be32f8466032eb0d$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($be32f8466032eb0d$var$isObject(childObject) && $be32f8466032eb0d$var$isEmptyObject(childObject) || Array.isArray(childObject) && $be32f8466032eb0d$var$isEmptyArray(childObject))) $be32f8466032eb0d$var$unset(object, paths.slice(0, -1));
    return object;
}
var $be32f8466032eb0d$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($be32f8466032eb0d$var$isFunction(data[key])) return true;
    }
    return false;
};
function $be32f8466032eb0d$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($be32f8466032eb0d$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $be32f8466032eb0d$var$isObject(data[key]) && !$be32f8466032eb0d$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $be32f8466032eb0d$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$be32f8466032eb0d$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $be32f8466032eb0d$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($be32f8466032eb0d$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $be32f8466032eb0d$var$isObject(data[key]) && !$be32f8466032eb0d$var$objectHasFunction(data[key])) {
            if ($be32f8466032eb0d$var$isUndefined(formValues) || $be32f8466032eb0d$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $be32f8466032eb0d$var$markFieldsDirty(data[key], []) : {
                ...$be32f8466032eb0d$var$markFieldsDirty(data[key])
            };
            else $be32f8466032eb0d$var$getDirtyFieldsFromDefaultValues(data[key], $be32f8466032eb0d$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$be32f8466032eb0d$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $be32f8466032eb0d$var$getDirtyFields = (defaultValues, formValues)=>$be32f8466032eb0d$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $be32f8466032eb0d$var$markFieldsDirty(formValues));
const $be32f8466032eb0d$var$defaultResult = {
    value: false,
    isValid: false
};
const $be32f8466032eb0d$var$validResult = {
    value: true,
    isValid: true
};
var $be32f8466032eb0d$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$be32f8466032eb0d$var$isUndefined(options[0].attributes.value) ? $be32f8466032eb0d$var$isUndefined(options[0].value) || options[0].value === '' ? $be32f8466032eb0d$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $be32f8466032eb0d$var$validResult : $be32f8466032eb0d$var$defaultResult;
    }
    return $be32f8466032eb0d$var$defaultResult;
};
var $be32f8466032eb0d$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$be32f8466032eb0d$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $be32f8466032eb0d$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $be32f8466032eb0d$var$defaultReturn = {
    isValid: false,
    value: null
};
var $be32f8466032eb0d$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $be32f8466032eb0d$var$defaultReturn) : $be32f8466032eb0d$var$defaultReturn;
function $be32f8466032eb0d$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($be32f8466032eb0d$var$isFileInput(ref)) return ref.files;
    if ($be32f8466032eb0d$var$isRadioInput(ref)) return $be32f8466032eb0d$var$getRadioValue(_f.refs).value;
    if ($be32f8466032eb0d$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($be32f8466032eb0d$var$isCheckBoxInput(ref)) return $be32f8466032eb0d$var$getCheckboxValue(_f.refs).value;
    return $be32f8466032eb0d$var$getFieldValueAs($be32f8466032eb0d$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $be32f8466032eb0d$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        field && $be32f8466032eb0d$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $be32f8466032eb0d$var$isRegex = (value1)=>value1 instanceof RegExp;
var $be32f8466032eb0d$var$getRuleValue = (rule)=>$be32f8466032eb0d$var$isUndefined(rule) ? rule : $be32f8466032eb0d$var$isRegex(rule) ? rule.source : $be32f8466032eb0d$var$isObject(rule) ? $be32f8466032eb0d$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $be32f8466032eb0d$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $be32f8466032eb0d$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $be32f8466032eb0d$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $be32f8466032eb0d$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $be32f8466032eb0d$var$VALIDATION_MODE.all,
        isOnTouch: mode === $be32f8466032eb0d$var$VALIDATION_MODE.onTouched
    });
const $be32f8466032eb0d$var$ASYNC_FUNCTION = 'AsyncFunction';
var $be32f8466032eb0d$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($be32f8466032eb0d$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $be32f8466032eb0d$var$ASYNC_FUNCTION || $be32f8466032eb0d$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $be32f8466032eb0d$var$ASYNC_FUNCTION));
var $be32f8466032eb0d$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $be32f8466032eb0d$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $be32f8466032eb0d$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($be32f8466032eb0d$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($be32f8466032eb0d$var$isObject(currentField)) {
                if ($be32f8466032eb0d$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $be32f8466032eb0d$var$schemaErrorLookup(errors, _fields, name) {
    const error = $be32f8466032eb0d$export$3988ae62b71be9a3(errors, name);
    if (error || $be32f8466032eb0d$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $be32f8466032eb0d$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $be32f8466032eb0d$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $be32f8466032eb0d$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $be32f8466032eb0d$var$VALIDATION_MODE.all));
};
var $be32f8466032eb0d$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $be32f8466032eb0d$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $be32f8466032eb0d$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $be32f8466032eb0d$var$unsetEmptyArray = (ref, name)=>!$be32f8466032eb0d$var$compact($be32f8466032eb0d$export$3988ae62b71be9a3(ref, name)).length && $be32f8466032eb0d$var$unset(ref, name);
var $be32f8466032eb0d$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $be32f8466032eb0d$var$convertToArrayPayload($be32f8466032eb0d$export$3988ae62b71be9a3(errors, name));
    $be32f8466032eb0d$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $be32f8466032eb0d$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $be32f8466032eb0d$var$isMessage = (value1)=>$be32f8466032eb0d$var$isString(value1);
function $be32f8466032eb0d$var$getValidateError(result, ref, type = 'validate') {
    if ($be32f8466032eb0d$var$isMessage(result) || Array.isArray(result) && result.every($be32f8466032eb0d$var$isMessage) || $be32f8466032eb0d$var$isBoolean(result) && !result) return {
        type: type,
        message: $be32f8466032eb0d$var$isMessage(result) ? result : '',
        ref: ref
    };
}
var $be32f8466032eb0d$var$getValueAndMessage = (validationData)=>$be32f8466032eb0d$var$isObject(validationData) && !$be32f8466032eb0d$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $be32f8466032eb0d$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $be32f8466032eb0d$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($be32f8466032eb0d$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $be32f8466032eb0d$var$isRadioInput(ref);
    const isCheckBox = $be32f8466032eb0d$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $be32f8466032eb0d$var$isFileInput(ref)) && $be32f8466032eb0d$var$isUndefined(ref.value) && $be32f8466032eb0d$var$isUndefined(inputValue) || $be32f8466032eb0d$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $be32f8466032eb0d$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.maxLength, minType = $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $be32f8466032eb0d$var$isNullOrUndefined(inputValue)) || $be32f8466032eb0d$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$be32f8466032eb0d$var$getCheckboxValue(refs).isValid || isRadio && !$be32f8466032eb0d$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $be32f8466032eb0d$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $be32f8466032eb0d$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($be32f8466032eb0d$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$be32f8466032eb0d$var$isNullOrUndefined(min) || !$be32f8466032eb0d$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $be32f8466032eb0d$var$getValueAndMessage(max);
        const minOutput = $be32f8466032eb0d$var$getValueAndMessage(min);
        if (!$be32f8466032eb0d$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$be32f8466032eb0d$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$be32f8466032eb0d$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($be32f8466032eb0d$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($be32f8466032eb0d$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.max, $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($be32f8466032eb0d$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $be32f8466032eb0d$var$getValueAndMessage(maxLength);
        const minLengthOutput = $be32f8466032eb0d$var$getValueAndMessage(minLength);
        const exceedMax = !$be32f8466032eb0d$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$be32f8466032eb0d$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $be32f8466032eb0d$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $be32f8466032eb0d$var$getValueAndMessage(pattern);
        if ($be32f8466032eb0d$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $be32f8466032eb0d$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($be32f8466032eb0d$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($be32f8466032eb0d$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $be32f8466032eb0d$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($be32f8466032eb0d$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($be32f8466032eb0d$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$be32f8466032eb0d$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $be32f8466032eb0d$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$be32f8466032eb0d$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $be32f8466032eb0d$var$defaultOptions = {
    mode: $be32f8466032eb0d$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $be32f8466032eb0d$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $be32f8466032eb0d$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$be32f8466032eb0d$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $be32f8466032eb0d$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $be32f8466032eb0d$var$isObject(_options.defaultValues) || $be32f8466032eb0d$var$isObject(_options.values) ? $be32f8466032eb0d$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $be32f8466032eb0d$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $be32f8466032eb0d$var$createSubject(),
        state: $be32f8466032eb0d$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $be32f8466032eb0d$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $be32f8466032eb0d$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $be32f8466032eb0d$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$be32f8466032eb0d$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $be32f8466032eb0d$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $be32f8466032eb0d$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($be32f8466032eb0d$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($be32f8466032eb0d$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $be32f8466032eb0d$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $be32f8466032eb0d$export$3988ae62b71be9a3(_formValues, name, $be32f8466032eb0d$var$isUndefined(value1) ? $be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $be32f8466032eb0d$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $be32f8466032eb0d$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $be32f8466032eb0d$var$deepEqual($be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$be32f8466032eb0d$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $be32f8466032eb0d$var$unset(_formState.dirtyFields, name) : $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $be32f8466032eb0d$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $be32f8466032eb0d$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $be32f8466032eb0d$var$unset(_formState.errors, name);
        }
        if ((error ? !$be32f8466032eb0d$var$deepEqual(previousFieldError, error) : previousFieldError) || !$be32f8466032eb0d$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $be32f8466032eb0d$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $be32f8466032eb0d$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $be32f8466032eb0d$export$3988ae62b71be9a3(errors, name);
            error ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $be32f8466032eb0d$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $be32f8466032eb0d$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ], true);
                    const fieldError = await $be32f8466032eb0d$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($be32f8466032eb0d$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $be32f8466032eb0d$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $be32f8466032eb0d$var$unset(_formState.errors, _f.name));
                }
                !$be32f8466032eb0d$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$be32f8466032eb0d$var$live(ref)) : !$be32f8466032eb0d$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, data), !$be32f8466032eb0d$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$be32f8466032eb0d$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $be32f8466032eb0d$var$isUndefined(defaultValue) ? _defaultValues : $be32f8466032eb0d$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$be32f8466032eb0d$var$compact($be32f8466032eb0d$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, $be32f8466032eb0d$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $be32f8466032eb0d$var$isHTMLElement(fieldReference.ref) && $be32f8466032eb0d$var$isNullOrUndefined(value1) ? '' : value1;
                if ($be32f8466032eb0d$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($be32f8466032eb0d$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($be32f8466032eb0d$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $be32f8466032eb0d$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $be32f8466032eb0d$var$isObject(fieldValue) || field && !field._f) && !$be32f8466032eb0d$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $be32f8466032eb0d$var$cloneObject(value1);
        $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $be32f8466032eb0d$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $be32f8466032eb0d$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$be32f8466032eb0d$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $be32f8466032eb0d$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $be32f8466032eb0d$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $be32f8466032eb0d$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $be32f8466032eb0d$var$deepEqual(fieldValue, $be32f8466032eb0d$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $be32f8466032eb0d$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $be32f8466032eb0d$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $be32f8466032eb0d$var$getFieldValue(field._f) : $be32f8466032eb0d$var$getEventValue(event);
            const isBlurEvent = event.type === $be32f8466032eb0d$var$EVENTS.BLUR || event.type === $be32f8466032eb0d$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$be32f8466032eb0d$var$hasValidation(field._f) && !_options.resolver && !$be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $be32f8466032eb0d$var$skipValidation(isBlurEvent, $be32f8466032eb0d$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $be32f8466032eb0d$var$isWatched(name, _names, isBlurEvent);
            $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$be32f8466032eb0d$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $be32f8466032eb0d$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $be32f8466032eb0d$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $be32f8466032eb0d$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $be32f8466032eb0d$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $be32f8466032eb0d$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $be32f8466032eb0d$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($be32f8466032eb0d$var$isUndefined(name) ? name : fieldNames);
            isValid = $be32f8466032eb0d$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$be32f8466032eb0d$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$be32f8466032eb0d$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $be32f8466032eb0d$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        return $be32f8466032eb0d$var$isUndefined(fieldNames) ? values : $be32f8466032eb0d$var$isString(fieldNames) ? $be32f8466032eb0d$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$be32f8466032eb0d$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$be32f8466032eb0d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$be32f8466032eb0d$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $be32f8466032eb0d$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$be32f8466032eb0d$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$be32f8466032eb0d$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $be32f8466032eb0d$var$convertToArrayPayload(name).forEach((inputName)=>$be32f8466032eb0d$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $be32f8466032eb0d$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $be32f8466032eb0d$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$be32f8466032eb0d$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($be32f8466032eb0d$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $be32f8466032eb0d$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $be32f8466032eb0d$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $be32f8466032eb0d$var$unset(_fields, fieldName);
                $be32f8466032eb0d$var$unset(_formValues, fieldName);
            }
            !options.keepError && $be32f8466032eb0d$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $be32f8466032eb0d$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $be32f8466032eb0d$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $be32f8466032eb0d$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $be32f8466032eb0d$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $be32f8466032eb0d$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($be32f8466032eb0d$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $be32f8466032eb0d$var$isBoolean(options.disabled) || $be32f8466032eb0d$var$isBoolean(_options.disabled);
        $be32f8466032eb0d$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $be32f8466032eb0d$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $be32f8466032eb0d$var$getRuleValue(options.min),
                max: $be32f8466032eb0d$var$getRuleValue(options.max),
                minLength: $be32f8466032eb0d$var$getRuleValue(options.minLength),
                maxLength: $be32f8466032eb0d$var$getRuleValue(options.maxLength),
                pattern: $be32f8466032eb0d$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $be32f8466032eb0d$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $be32f8466032eb0d$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $be32f8466032eb0d$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($be32f8466032eb0d$var$live),
                                    fieldRef,
                                    ...Array.isArray($be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($be32f8466032eb0d$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $be32f8466032eb0d$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($be32f8466032eb0d$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $be32f8466032eb0d$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $be32f8466032eb0d$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $be32f8466032eb0d$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$be32f8466032eb0d$var$unset(fieldValues, name);
            $be32f8466032eb0d$var$unset(_formState.errors, 'root');
            if ($be32f8466032eb0d$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $be32f8466032eb0d$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name)) {
            if ($be32f8466032eb0d$var$isUndefined(options.defaultValue)) setValue(name, $be32f8466032eb0d$var$cloneObject($be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $be32f8466032eb0d$export$adaa4cf7ef1b65be(_defaultValues, name, $be32f8466032eb0d$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $be32f8466032eb0d$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $be32f8466032eb0d$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $be32f8466032eb0d$var$cloneObject($be32f8466032eb0d$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $be32f8466032eb0d$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $be32f8466032eb0d$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $be32f8466032eb0d$var$cloneObject(updatedValues);
        const isEmptyResetValues = $be32f8466032eb0d$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($be32f8466032eb0d$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$be32f8466032eb0d$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(values, fieldName, $be32f8466032eb0d$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $be32f8466032eb0d$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($be32f8466032eb0d$var$isWeb && $be32f8466032eb0d$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($be32f8466032eb0d$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $be32f8466032eb0d$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $be32f8466032eb0d$var$cloneObject(_defaultValues) : {} : $be32f8466032eb0d$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$be32f8466032eb0d$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $be32f8466032eb0d$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $be32f8466032eb0d$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($be32f8466032eb0d$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $be32f8466032eb0d$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $be32f8466032eb0d$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$be32f8466032eb0d$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $be32f8466032eb0d$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $be32f8466032eb0d$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $be32f8466032eb0d$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$be32f8466032eb0d$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $be32f8466032eb0d$var$appendAt = (data, value1)=>[
        ...data,
        ...$be32f8466032eb0d$var$convertToArrayPayload(value1)
    ];
var $be32f8466032eb0d$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $be32f8466032eb0d$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$be32f8466032eb0d$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $be32f8466032eb0d$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($be32f8466032eb0d$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $be32f8466032eb0d$var$prependAt = (data, value1)=>[
        ...$be32f8466032eb0d$var$convertToArrayPayload(value1),
        ...$be32f8466032eb0d$var$convertToArrayPayload(data)
    ];
function $be32f8466032eb0d$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $be32f8466032eb0d$var$compact(temp).length ? temp : [];
}
var $be32f8466032eb0d$var$removeArrayAt = (data, index)=>$be32f8466032eb0d$var$isUndefined(index) ? [] : $be32f8466032eb0d$var$removeAtIndexes(data, $be32f8466032eb0d$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $be32f8466032eb0d$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $be32f8466032eb0d$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $be32f8466032eb0d$export$310131896651d559(props) {
    const methods = $be32f8466032eb0d$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(control._getFieldArray(name).map($be32f8466032eb0d$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(fields);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(false);
    _fieldIds.current = fields;
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>rules && control.register(name, rules), [
        control,
        rules,
        name
    ]);
    $be32f8466032eb0d$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $be32f8466032eb0d$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($be32f8466032eb0d$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $be32f8466032eb0d$var$convertToArrayPayload($be32f8466032eb0d$var$cloneObject(value1));
        const updatedFieldArrayValues = $be32f8466032eb0d$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $be32f8466032eb0d$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $be32f8466032eb0d$var$appendAt(ids.current, appendValue.map($be32f8466032eb0d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$appendAt, {
            argA: $be32f8466032eb0d$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $be32f8466032eb0d$var$convertToArrayPayload($be32f8466032eb0d$var$cloneObject(value1));
        const updatedFieldArrayValues = $be32f8466032eb0d$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $be32f8466032eb0d$var$getFocusFieldName(name, 0, options);
        ids.current = $be32f8466032eb0d$var$prependAt(ids.current, prependValue.map($be32f8466032eb0d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$prependAt, {
            argA: $be32f8466032eb0d$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $be32f8466032eb0d$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $be32f8466032eb0d$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($be32f8466032eb0d$export$3988ae62b71be9a3(control._fields, name)) && $be32f8466032eb0d$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $be32f8466032eb0d$var$convertToArrayPayload($be32f8466032eb0d$var$cloneObject(value1));
        const updatedFieldArrayValues = $be32f8466032eb0d$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $be32f8466032eb0d$var$getFocusFieldName(name, index, options);
        ids.current = $be32f8466032eb0d$var$insert(ids.current, index, insertValue.map($be32f8466032eb0d$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$insert, {
            argA: index,
            argB: $be32f8466032eb0d$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $be32f8466032eb0d$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $be32f8466032eb0d$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $be32f8466032eb0d$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $be32f8466032eb0d$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $be32f8466032eb0d$var$cloneObject(value1);
        const updatedFieldArrayValues = $be32f8466032eb0d$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $be32f8466032eb0d$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $be32f8466032eb0d$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $be32f8466032eb0d$var$convertToArrayPayload($be32f8466032eb0d$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($be32f8466032eb0d$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        control._state.action = false;
        $be32f8466032eb0d$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$be32f8466032eb0d$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$be32f8466032eb0d$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $be32f8466032eb0d$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $be32f8466032eb0d$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $be32f8466032eb0d$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $be32f8466032eb0d$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $be32f8466032eb0d$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($be32f8466032eb0d$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $be32f8466032eb0d$var$getValidationModes(control._options.mode).isOnSubmit)) $be32f8466032eb0d$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $be32f8466032eb0d$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$be32f8466032eb0d$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $be32f8466032eb0d$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $be32f8466032eb0d$var$cloneObject(control._formValues)
        });
        control._names.focus && $be32f8466032eb0d$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        !$be32f8466032eb0d$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $be32f8466032eb0d$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $be32f8466032eb0d$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $be32f8466032eb0d$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $be32f8466032eb0d$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $be32f8466032eb0d$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$be32f8466032eb0d$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $be32f8466032eb0d$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $be32f8466032eb0d$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        if (props.values && !$be32f8466032eb0d$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($6PIFj))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $be32f8466032eb0d$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRegister("akJza", function(module, exports) {

$parcel$export(module.exports, "createApiOnSubmit", () => $785f1e21df5cec36$export$6b3ff76c9b0c7a9c);

var $iouPm = parcelRequire("iouPm");
function $785f1e21df5cec36$export$4852a3f845872b81(validationErrorsInstance, reactFormsSetError) {
    for (const key of Object.keys(validationErrorsInstance.errors)){
        const errors = validationErrorsInstance.errors[key];
        if (errors.length > 0) reactFormsSetError(`root.${key}`, {
            type: 'custom',
            message: errors.join(', ')
        });
    }
}
function $785f1e21df5cec36$export$6b3ff76c9b0c7a9c(onSubmit, setError) {
    return async (data)=>{
        try {
            await onSubmit(data);
        } catch (e) {
            if (e instanceof (0, $iouPm.ValidationError)) $785f1e21df5cec36$export$4852a3f845872b81(e, setError);
            else throw e;
        }
    };
}

});


parcelRegister("7H02q", function(module, exports) {

$parcel$export(module.exports, "default", () => $599c941e4fb4eb77$export$2e2bcd8739ae039);

var $iouPm = parcelRequire("iouPm");

var $8cF6f = parcelRequire("8cF6f");

var $bWUN0 = parcelRequire("bWUN0");
const $599c941e4fb4eb77$var$CartManager = (()=>{
    let state = {
        isAddingToCart: false,
        cartCount: null
    };
    const SELECTORS = {
        cartCountBadges: '.profile-avatar__item-count, .item-count',
        cartCountMobile: '.item-count-mobile'
    };
    // todo: this resize observer should be moved to header.js as it does not seem related to the cart
    // Initialize ResizeObserver to automatically update main padding when header height changes
    (()=>{
        const header = document.querySelector('.header-nav');
        const main = document.querySelector('main');
        if (!header || !main) return;
        const observer = new ResizeObserver(()=>{
            // header.js does some weird stuff where it can replace the entire header DOM element.
            // that appears to trigger this observer, but the "offsetHeight" is then 0.
            // we must make sure to re-query the header nav in this callback so that we have the element that's on the page.
            const header = document.querySelector('.header-nav');
            if (!header) return;
            main.style.paddingTop = `${header.offsetHeight}px`;
        });
        observer.observe(header);
    })();
    // Helper: Check auth and handle 401 responses
    async function handleAuthResponse(response) {
        if (response.status === 401) {
            handleAuthRequired();
            return true;
        }
        return false;
    }
    // Helper: Refresh cart count and update UI
    async function refreshAndUpdateCartCount() {
        const newCount = await getCartCount();
        if (newCount !== null) updateCartCountDisplay(newCount);
        return newCount;
    }
    // Helper: Execute cart operation with common workflow
    async function executeCartOperation(operation) {
        if (state.isAddingToCart) return {
            success: false,
            error: 'ALREADY_ADDING'
        };
        state.isAddingToCart = true;
        try {
            const headers = await (0, $iouPm.getHeadersWithToken)({
                'Content-Type': 'application/json'
            });
            const result = await operation(headers);
            if (result.authRequired) return {
                success: false,
                error: 'AUTH_REQUIRED'
            };
            if (result.success) {
                const newCount = await refreshAndUpdateCartCount();
                return {
                    ...result,
                    count: newCount
                };
            }
            return result;
        } catch (error) {
            console.error('Error in cart operation:', error);
            return {
                success: false,
                error: error.message
            };
        } finally{
            state.isAddingToCart = false;
        }
    }
    // Add a sample to cart using a known sample code (AddToCart → GetCartCount → Update UI)
    // productInfo (required): { itemName, itemCollection, itemColor } for GTM tracking
    // Returns: { success: boolean, count?: number, error?: string }
    async function addSampleToCart(sampleCode, quantity = 1, { itemName: itemName, itemCollection: itemCollection, itemColor: itemColor }) {
        return executeCartOperation(async (headers)=>{
            // Add to cart
            const addResponse = await fetch('/api/cart/AddToCart', {
                method: 'POST',
                headers: await (0, $iouPm.getHeadersWithToken)({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    Code: sampleCode,
                    Quantity: quantity
                })
            });
            if (await handleAuthResponse(addResponse)) return {
                authRequired: true
            };
            if (!addResponse.ok) try {
                const errorData = await addResponse.json();
                console.error('AddToCart error response:', errorData);
                // Backend returns { type: string, message: string }
                return {
                    success: false,
                    error: errorData.type || 'ValidationError',
                    message: errorData.message || 'Failed to add item to cart.'
                };
            } catch (e) {
                console.error('Failed to parse error response:', e);
                return {
                    success: false,
                    error: 'UnknownError',
                    message: 'Failed to add item to cart. Please try again.'
                };
            }
            // Success - track GTM event
            (0, $bWUN0.pushEvent)({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'USD',
                    value: 0,
                    items: [
                        {
                            item_id: sampleCode,
                            item_name: itemName || '',
                            item_collection: itemCollection || '',
                            item_color: itemColor || '',
                            quantity: quantity
                        }
                    ]
                }
            });
            return {
                success: true
            };
        });
    }
    /**
     * Adds the best sample for a product variant (colorway or style) to the cart.
     * <br/>
     * The backend will take care of selecting the best sample.
     * @param productVariantCode A colorway or style catalog code.
     * @param quantity - The number of samples to add (default: 1).
     * @returns {Promise<{success: boolean, error: string}|{success: boolean, error: string}|{[p: string]: *}|*|{success: boolean, error: *}|undefined>}
     */ async function addBestSampleToCart(productVariantCode, quantity = 1) {
        return executeCartOperation(async (_)=>{
            // Add to cart
            const addResponse = await fetch('/api/cart/AddBestSampleToCart', {
                method: 'POST',
                headers: await (0, $iouPm.getHeadersWithToken)({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    Code: productVariantCode,
                    Quantity: quantity
                })
            });
            if (await handleAuthResponse(addResponse)) return {
                authRequired: true
            };
            if (!addResponse.ok) try {
                const errorData = await addResponse.json();
                console.error('AddBestSampleToCart error response:', errorData);
                // Backend returns { type: string, message: string }
                return {
                    success: false,
                    error: errorData.type || 'ValidationError',
                    message: errorData.message || 'Failed to add item to cart.'
                };
            } catch (e) {
                console.error('Failed to parse error response:', e);
                return {
                    success: false,
                    error: 'UnknownError',
                    message: 'Failed to add item to cart. Please try again.'
                };
            }
            const json = await addResponse.json();
            // Success - track GTM event
            (0, $bWUN0.pushEvent)({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'USD',
                    value: 0,
                    items: [
                        {
                            item_id: json.sampleCatalogCode,
                            item_name: json.patternFamilyName || '',
                            item_collection: json.collectionName || '',
                            item_color: json.colorwayName || '',
                            item_style: json.variantType === 'Style' ? json.variantName : '',
                            quantity: quantity
                        }
                    ]
                }
            });
            return {
                ...json,
                success: true
            };
        });
    }
    // Get current cart item count from server
    async function getCartCount() {
        try {
            const response = await fetch('/api/cart/GetCartCount', {
                headers: await (0, $iouPm.getHeadersWithToken)()
            });
            if (!response.ok) {
                console.error('Failed to get cart count:', response.statusText);
                return null;
            }
            const data = await response.json();
            state.cartCount = data.count;
            return data.count;
        } catch (error) {
            console.error('Error getting cart count:', error);
            return null;
        }
    }
    // Refresh cart count from server and update display
    async function refreshCartCount() {
        const count = await getCartCount();
        if (count !== null) updateCartCountDisplay(count);
        return count;
    }
    // Update all cart count badges in the DOM
    function updateCartCountDisplay(count) {
        const badges = document.querySelectorAll(SELECTORS.cartCountBadges);
        const mobileBadges = document.querySelectorAll(SELECTORS.cartCountMobile);
        badges.forEach((badge)=>{
            badge.textContent = count;
            badge.style.display = count > 0 ? '' : 'none';
        });
        mobileBadges.forEach((badge)=>{
            badge.textContent = `(${count})`;
        });
        state.cartCount = count;
    }
    // Handle authentication required - trigger sign-in flyout or redirect
    function handleAuthRequired() {
        // Try to open sign-in flyout (existing modal system)
        const signInButton = document.querySelector('[data-flyout-trigger="SignInForm"]');
        if (signInButton) signInButton.click();
        else {
            // Fallback: redirect to account page if flyout not found
            const returnUrl = encodeURIComponent(window.location.pathname);
            window.location.href = `/en/account?returnUrl=${returnUrl}`;
        }
    }
    // Helper: Get user-friendly error message (fallback for client-side errors)
    function getClientErrorMessage(errorType) {
        switch(errorType){
            case 'AUTH_REQUIRED':
                return 'Please sign in to order samples.';
            case 'ALREADY_ADDING':
                return 'Please wait while we add the item to your cart.';
            default:
                return 'Unable to add sample to cart. Please try again.';
        }
    }
    // Add multiple samples to cart using known sample codes
    // Returns: { success: boolean, successCount: number, failureCount: number, results: [], authRequired?: boolean }
    async function addSamplesToCart(sampleCodes) {
        if (!Array.isArray(sampleCodes) || sampleCodes.length === 0) return {
            success: false,
            successCount: 0,
            failureCount: 0,
            results: []
        };
        return executeCartOperation(async (headers)=>{
            // Bulk add to cart
            const addResponse = await fetch('/api/cart/BulkAddToCart', {
                method: 'POST',
                headers: await (0, $iouPm.getHeadersWithToken)({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    Codes: sampleCodes,
                    Quantity: 1
                })
            });
            if (await handleAuthResponse(addResponse)) return {
                authRequired: true
            };
            if (!addResponse.ok) {
                const errorText = await addResponse.text();
                console.error('BulkAddToCart error response:', errorText);
                return {
                    success: false,
                    successCount: 0,
                    failureCount: sampleCodes.length,
                    results: []
                };
            }
            const result = await addResponse.json();
            return {
                success: result.successCount > 0,
                successCount: result.successCount,
                failureCount: result.failureCount,
                results: result.results
            };
        });
    }
    // Get current state (for debugging)
    function getState() {
        return {
            ...state
        };
    }
    async function getBestSampleCode(catalogCode) {
        const url = `/api/catalog/bestsample?code=${catalogCode}`;
        const response = await fetch(url, {
            headers: await (0, $iouPm.getHeadersWithToken)()
        });
        if (response.status === 404) {
            console.debug('Best sample not found:', catalogCode);
            return null;
        }
        if (!response.ok) {
            console.error('Failed to get best sample code:', response.statusText);
            return null;
        }
        return await response.json();
    }
    return {
        addBestSampleToCart: addBestSampleToCart,
        addSampleToCart: addSampleToCart,
        addSamplesToCart: addSamplesToCart,
        getBestSampleCode: getBestSampleCode,
        getCartCount: getCartCount,
        refreshCartCount: refreshCartCount,
        updateCartCountDisplay: updateCartCountDisplay,
        showToast: $8cF6f.showToast,
        handleAuthRequired: handleAuthRequired,
        getClientErrorMessage: getClientErrorMessage,
        getState: getState
    };
})();
var $599c941e4fb4eb77$export$2e2bcd8739ae039 = $599c941e4fb4eb77$var$CartManager;

});

parcelRegister("eUy0V", function(module, exports) {

$parcel$export(module.exports, "default", () => $adb0ae1ada1f9f50$export$2e2bcd8739ae039);
var htmx = function() {
    'use strict';
    // Public API
    const htmx = {
        // Tsc madness here, assigning the functions directly results in an invalid TypeScript output, but reassigning is fine
        /* Event processing */ /** @type {typeof onLoadHelper} */ onLoad: null,
        /** @type {typeof processNode} */ process: null,
        /** @type {typeof addEventListenerImpl} */ on: null,
        /** @type {typeof removeEventListenerImpl} */ off: null,
        /** @type {typeof triggerEvent} */ trigger: null,
        /** @type {typeof ajaxHelper} */ ajax: null,
        /* DOM querying helpers */ /** @type {typeof find} */ find: null,
        /** @type {typeof findAll} */ findAll: null,
        /** @type {typeof closest} */ closest: null,
        /**
     * Returns the input values that would resolve for a given element via the htmx value resolution mechanism
     *
     * @see https://htmx.org/api/#values
     *
     * @param {Element} elt the element to resolve values on
     * @param {HttpVerb} type the request type (e.g. **get** or **post**) non-GET's will include the enclosing form of the element. Defaults to **post**
     * @returns {Object}
     */ values: function(elt, type) {
            const inputValues = getInputValues(elt, type || 'post');
            return inputValues.values;
        },
        /* DOM manipulation helpers */ /** @type {typeof removeElement} */ remove: null,
        /** @type {typeof addClassToElement} */ addClass: null,
        /** @type {typeof removeClassFromElement} */ removeClass: null,
        /** @type {typeof toggleClassOnElement} */ toggleClass: null,
        /** @type {typeof takeClassForElement} */ takeClass: null,
        /** @type {typeof swap} */ swap: null,
        /* Extension entrypoints */ /** @type {typeof defineExtension} */ defineExtension: null,
        /** @type {typeof removeExtension} */ removeExtension: null,
        /* Debugging */ /** @type {typeof logAll} */ logAll: null,
        /** @type {typeof logNone} */ logNone: null,
        /* Debugging */ /**
     * The logger htmx uses to log with
     *
     * @see https://htmx.org/api/#logger
     */ logger: null,
        /**
     * A property holding the configuration htmx uses at runtime.
     *
     * Note that using a [meta tag](https://htmx.org/docs/#config) is the preferred mechanism for setting these properties.
     *
     * @see https://htmx.org/api/#config
     */ config: {
            /**
       * Whether to use history.
       * @type boolean
       * @default true
       */ historyEnabled: true,
            /**
       * The number of pages to keep in **sessionStorage** for history support.
       * @type number
       * @default 10
       */ historyCacheSize: 10,
            /**
       * @type boolean
       * @default false
       */ refreshOnHistoryMiss: false,
            /**
       * The default swap style to use if **[hx-swap](https://htmx.org/attributes/hx-swap)** is omitted.
       * @type HtmxSwapStyle
       * @default 'innerHTML'
       */ defaultSwapStyle: 'innerHTML',
            /**
       * The default delay between receiving a response from the server and doing the swap.
       * @type number
       * @default 0
       */ defaultSwapDelay: 0,
            /**
       * The default delay between completing the content swap and settling attributes.
       * @type number
       * @default 20
       */ defaultSettleDelay: 20,
            /**
       * If true, htmx will inject a small amount of CSS into the page to make indicators invisible unless the **htmx-indicator** class is present.
       * @type boolean
       * @default true
       */ includeIndicatorStyles: true,
            /**
       * The class to place on indicators when a request is in flight.
       * @type string
       * @default 'htmx-indicator'
       */ indicatorClass: 'htmx-indicator',
            /**
       * The class to place on triggering elements when a request is in flight.
       * @type string
       * @default 'htmx-request'
       */ requestClass: 'htmx-request',
            /**
       * The class to temporarily place on elements that htmx has added to the DOM.
       * @type string
       * @default 'htmx-added'
       */ addedClass: 'htmx-added',
            /**
       * The class to place on target elements when htmx is in the settling phase.
       * @type string
       * @default 'htmx-settling'
       */ settlingClass: 'htmx-settling',
            /**
       * The class to place on target elements when htmx is in the swapping phase.
       * @type string
       * @default 'htmx-swapping'
       */ swappingClass: 'htmx-swapping',
            /**
       * Allows the use of eval-like functionality in htmx, to enable **hx-vars**, trigger conditions & script tag evaluation. Can be set to **false** for CSP compatibility.
       * @type boolean
       * @default true
       */ allowEval: true,
            /**
       * If set to false, disables the interpretation of script tags.
       * @type boolean
       * @default true
       */ allowScriptTags: true,
            /**
       * If set, the nonce will be added to inline scripts.
       * @type string
       * @default ''
       */ inlineScriptNonce: '',
            /**
       * If set, the nonce will be added to inline styles.
       * @type string
       * @default ''
       */ inlineStyleNonce: '',
            /**
       * The attributes to settle during the settling phase.
       * @type string[]
       * @default ['class', 'style', 'width', 'height']
       */ attributesToSettle: [
                'class',
                'style',
                'width',
                'height'
            ],
            /**
       * Allow cross-site Access-Control requests using credentials such as cookies, authorization headers or TLS client certificates.
       * @type boolean
       * @default false
       */ withCredentials: false,
            /**
       * @type number
       * @default 0
       */ timeout: 0,
            /**
       * The default implementation of **getWebSocketReconnectDelay** for reconnecting after unexpected connection loss by the event code **Abnormal Closure**, **Service Restart** or **Try Again Later**.
       * @type {'full-jitter' | ((retryCount:number) => number)}
       * @default "full-jitter"
       */ wsReconnectDelay: 'full-jitter',
            /**
       * The type of binary data being received over the WebSocket connection
       * @type BinaryType
       * @default 'blob'
       */ wsBinaryType: 'blob',
            /**
       * @type string
       * @default '[hx-disable], [data-hx-disable]'
       */ disableSelector: '[hx-disable], [data-hx-disable]',
            /**
       * @type {'auto' | 'instant' | 'smooth'}
       * @default 'instant'
       */ scrollBehavior: 'instant',
            /**
       * If the focused element should be scrolled into view.
       * @type boolean
       * @default false
       */ defaultFocusScroll: false,
            /**
       * If set to true htmx will include a cache-busting parameter in GET requests to avoid caching partial responses by the browser
       * @type boolean
       * @default false
       */ getCacheBusterParam: false,
            /**
       * If set to true, htmx will use the View Transition API when swapping in new content.
       * @type boolean
       * @default false
       */ globalViewTransitions: false,
            /**
       * htmx will format requests with these methods by encoding their parameters in the URL, not the request body
       * @type {(HttpVerb)[]}
       * @default ['get', 'delete']
       */ methodsThatUseUrlParams: [
                'get',
                'delete'
            ],
            /**
       * If set to true, disables htmx-based requests to non-origin hosts.
       * @type boolean
       * @default false
       */ selfRequestsOnly: true,
            /**
       * If set to true htmx will not update the title of the document when a title tag is found in new content
       * @type boolean
       * @default false
       */ ignoreTitle: false,
            /**
       * Whether the target of a boosted element is scrolled into the viewport.
       * @type boolean
       * @default true
       */ scrollIntoViewOnBoost: true,
            /**
       * The cache to store evaluated trigger specifications into.
       * You may define a simple object to use a never-clearing cache, or implement your own system using a [proxy object](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Proxy)
       * @type {Object|null}
       * @default null
       */ triggerSpecsCache: null,
            /** @type boolean */ disableInheritance: false,
            /** @type HtmxResponseHandlingConfig[] */ responseHandling: [
                {
                    code: '204',
                    swap: false
                },
                {
                    code: '[23]..',
                    swap: true
                },
                {
                    code: '[45]..',
                    swap: false,
                    error: true
                }
            ],
            /**
       * Whether to process OOB swaps on elements that are nested within the main response element.
       * @type boolean
       * @default true
       */ allowNestedOobSwaps: true,
            /**
       * Whether to treat history cache miss full page reload requests as a "HX-Request" by returning this response header
       * This should always be disabled when using HX-Request header to optionally return partial responses
       * @type boolean
       * @default true
       */ historyRestoreAsHxRequest: true
        },
        /** @type {typeof parseInterval} */ parseInterval: null,
        location: /**
     * proxy of window.location used for page reload functions
     * @type location
     */ location,
        /** @type {typeof internalEval} */ _: null,
        version: '2.0.6'
    };
    // Tsc madness part 2
    htmx.onLoad = onLoadHelper;
    htmx.process = processNode;
    htmx.on = addEventListenerImpl;
    htmx.off = removeEventListenerImpl;
    htmx.trigger = triggerEvent;
    htmx.ajax = ajaxHelper;
    htmx.find = find;
    htmx.findAll = findAll;
    htmx.closest = closest;
    htmx.remove = removeElement;
    htmx.addClass = addClassToElement;
    htmx.removeClass = removeClassFromElement;
    htmx.toggleClass = toggleClassOnElement;
    htmx.takeClass = takeClassForElement;
    htmx.swap = swap;
    htmx.defineExtension = defineExtension;
    htmx.removeExtension = removeExtension;
    htmx.logAll = logAll;
    htmx.logNone = logNone;
    htmx.parseInterval = parseInterval;
    htmx._ = internalEval;
    const internalAPI = {
        addTriggerHandler: addTriggerHandler,
        bodyContains: bodyContains,
        canAccessLocalStorage: canAccessLocalStorage,
        findThisElement: findThisElement,
        filterValues: filterValues,
        swap: swap,
        hasAttribute: hasAttribute,
        getAttributeValue: getAttributeValue,
        getClosestAttributeValue: getClosestAttributeValue,
        getClosestMatch: getClosestMatch,
        getExpressionVars: getExpressionVars,
        getHeaders: getHeaders,
        getInputValues: getInputValues,
        getInternalData: getInternalData,
        getSwapSpecification: getSwapSpecification,
        getTriggerSpecs: getTriggerSpecs,
        getTarget: getTarget,
        makeFragment: makeFragment,
        mergeObjects: mergeObjects,
        makeSettleInfo: makeSettleInfo,
        oobSwap: oobSwap,
        querySelectorExt: querySelectorExt,
        settleImmediately: settleImmediately,
        shouldCancel: shouldCancel,
        triggerEvent: triggerEvent,
        triggerErrorEvent: triggerErrorEvent,
        withExtensions: withExtensions
    };
    const VERBS = [
        'get',
        'post',
        'put',
        'delete',
        'patch'
    ];
    const VERB_SELECTOR = VERBS.map(function(verb) {
        return '[hx-' + verb + '], [data-hx-' + verb + ']';
    }).join(', ');
    //= ===================================================================
    // Utilities
    //= ===================================================================
    /**
   * Parses an interval string consistent with the way htmx does. Useful for plugins that have timing-related attributes.
   *
   * Caution: Accepts an int followed by either **s** or **ms**. All other values use **parseFloat**
   *
   * @see https://htmx.org/api/#parseInterval
   *
   * @param {string} str timing string
   * @returns {number|undefined}
   */ function parseInterval(str) {
        if (str == undefined) return undefined;
        let interval = NaN;
        if (str.slice(-2) == 'ms') interval = parseFloat(str.slice(0, -2));
        else if (str.slice(-1) == 's') interval = parseFloat(str.slice(0, -1)) * 1000;
        else if (str.slice(-1) == 'm') interval = parseFloat(str.slice(0, -1)) * 60000;
        else interval = parseFloat(str);
        return isNaN(interval) ? undefined : interval;
    }
    /**
   * @param {Node} elt
   * @param {string} name
   * @returns {(string | null)}
   */ function getRawAttribute(elt, name) {
        return elt instanceof Element && elt.getAttribute(name);
    }
    /**
   * @param {Element} elt
   * @param {string} qualifiedName
   * @returns {boolean}
   */ // resolve with both hx and data-hx prefixes
    function hasAttribute(elt, qualifiedName) {
        return !!elt.hasAttribute && (elt.hasAttribute(qualifiedName) || elt.hasAttribute('data-' + qualifiedName));
    }
    /**
   *
   * @param {Node} elt
   * @param {string} qualifiedName
   * @returns {(string | null)}
   */ function getAttributeValue(elt, qualifiedName) {
        return getRawAttribute(elt, qualifiedName) || getRawAttribute(elt, 'data-' + qualifiedName);
    }
    /**
   * @param {Node} elt
   * @returns {Node | null}
   */ function parentElt(elt) {
        const parent = elt.parentElement;
        if (!parent && elt.parentNode instanceof ShadowRoot) return elt.parentNode;
        return parent;
    }
    /**
   * @returns {Document}
   */ function getDocument() {
        return document;
    }
    /**
   * @param {Node} elt
   * @param {boolean} global
   * @returns {Node|Document}
   */ function getRootNode(elt, global) {
        return elt.getRootNode ? elt.getRootNode({
            composed: global
        }) : getDocument();
    }
    /**
   * @param {Node} elt
   * @param {(e:Node) => boolean} condition
   * @returns {Node | null}
   */ function getClosestMatch(elt, condition) {
        while(elt && !condition(elt))elt = parentElt(elt);
        return elt || null;
    }
    /**
   * @param {Element} initialElement
   * @param {Element} ancestor
   * @param {string} attributeName
   * @returns {string|null}
   */ function getAttributeValueWithDisinheritance(initialElement, ancestor, attributeName) {
        const attributeValue = getAttributeValue(ancestor, attributeName);
        const disinherit = getAttributeValue(ancestor, 'hx-disinherit');
        var inherit = getAttributeValue(ancestor, 'hx-inherit');
        if (initialElement !== ancestor) {
            if (htmx.config.disableInheritance) {
                if (inherit && (inherit === '*' || inherit.split(' ').indexOf(attributeName) >= 0)) return attributeValue;
                else return null;
            }
            if (disinherit && (disinherit === '*' || disinherit.split(' ').indexOf(attributeName) >= 0)) return 'unset';
        }
        return attributeValue;
    }
    /**
   * @param {Element} elt
   * @param {string} attributeName
   * @returns {string | null}
   */ function getClosestAttributeValue(elt, attributeName) {
        let closestAttr = null;
        getClosestMatch(elt, function(e) {
            return !!(closestAttr = getAttributeValueWithDisinheritance(elt, asElement(e), attributeName));
        });
        if (closestAttr !== 'unset') return closestAttr;
    }
    /**
   * @param {Node} elt
   * @param {string} selector
   * @returns {boolean}
   */ function matches(elt, selector) {
        return elt instanceof Element && elt.matches(selector);
    }
    /**
   * @param {string} str
   * @returns {string}
   */ function getStartTag(str) {
        const tagMatcher = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
        const match = tagMatcher.exec(str);
        if (match) return match[1].toLowerCase();
        else return '';
    }
    /**
   * @param {string} resp
   * @returns {Document}
   */ function parseHTML(resp) {
        const parser = new DOMParser();
        return parser.parseFromString(resp, 'text/html');
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {Node} elt
   */ function takeChildrenFor(fragment, elt) {
        while(elt.childNodes.length > 0)fragment.append(elt.childNodes[0]);
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {HTMLScriptElement}
   */ function duplicateScript(script) {
        const newScript = getDocument().createElement('script');
        forEach(script.attributes, function(attr) {
            newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = script.textContent;
        newScript.async = false;
        if (htmx.config.inlineScriptNonce) newScript.nonce = htmx.config.inlineScriptNonce;
        return newScript;
    }
    /**
   * @param {HTMLScriptElement} script
   * @returns {boolean}
   */ function isJavaScriptScriptNode(script) {
        return script.matches('script') && (script.type === 'text/javascript' || script.type === 'module' || script.type === '');
    }
    /**
   * we have to make new copies of script tags that we are going to insert because
   * SOME browsers (not saying who, but it involves an element and an animal) don't
   * execute scripts created in <template> tags when they are inserted into the DOM
   * and all the others do lmao
   * @param {DocumentFragment} fragment
   */ function normalizeScriptTags(fragment) {
        Array.from(fragment.querySelectorAll('script')).forEach(/** @param {HTMLScriptElement} script */ (script)=>{
            if (isJavaScriptScriptNode(script)) {
                const newScript = duplicateScript(script);
                const parent = script.parentNode;
                try {
                    parent.insertBefore(newScript, script);
                } catch (e) {
                    logError(e);
                } finally{
                    script.remove();
                }
            }
        });
    }
    /**
   * @typedef {DocumentFragment & {title?: string}} DocumentFragmentWithTitle
   * @description  a document fragment representing the response HTML, including
   * a `title` property for any title information found
   */ /**
   * @param {string} response HTML
   * @returns {DocumentFragmentWithTitle}
   */ function makeFragment(response) {
        // strip head tag to determine shape of response we are dealing with
        const responseWithNoHead = response.replace(/<head(\s[^>]*)?>[\s\S]*?<\/head>/i, '');
        const startTag = getStartTag(responseWithNoHead);
        /** @type DocumentFragmentWithTitle */ let fragment;
        if (startTag === 'html') {
            // if it is a full document, parse it and return the body
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(response);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else if (startTag === 'body') {
            // parse body w/o wrapping in template
            fragment = /** @type DocumentFragmentWithTitle */ new DocumentFragment();
            const doc = parseHTML(responseWithNoHead);
            takeChildrenFor(fragment, doc.body);
            fragment.title = doc.title;
        } else {
            // otherwise we have non-body partial HTML content, so wrap it in a template to maximize parsing flexibility
            const doc = parseHTML('<body><template class="internal-htmx-wrapper">' + responseWithNoHead + '</template></body>');
            fragment = /** @type DocumentFragmentWithTitle */ doc.querySelector('template').content;
            // extract title into fragment for later processing
            fragment.title = doc.title;
            // for legacy reasons we support a title tag at the root level of non-body responses, so we need to handle it
            var titleElement = fragment.querySelector('title');
            if (titleElement && titleElement.parentNode === fragment) {
                titleElement.remove();
                fragment.title = titleElement.innerText;
            }
        }
        if (fragment) {
            if (htmx.config.allowScriptTags) normalizeScriptTags(fragment);
            else // remove all script tags if scripts are disabled
            fragment.querySelectorAll('script').forEach((script)=>script.remove());
        }
        return fragment;
    }
    /**
   * @param {Function} func
   */ function maybeCall(func) {
        if (func) func();
    }
    /**
   * @param {any} o
   * @param {string} type
   * @returns
   */ function isType(o, type) {
        return Object.prototype.toString.call(o) === '[object ' + type + ']';
    }
    /**
   * @param {*} o
   * @returns {o is Function}
   */ function isFunction(o) {
        return typeof o === 'function';
    }
    /**
   * @param {*} o
   * @returns {o is Object}
   */ function isRawObject(o) {
        return isType(o, 'Object');
    }
    /**
   * @typedef {Object} OnHandler
   * @property {(keyof HTMLElementEventMap)|string} event
   * @property {EventListener} listener
   */ /**
   * @typedef {Object} ListenerInfo
   * @property {string} trigger
   * @property {EventListener} listener
   * @property {EventTarget} on
   */ /**
   * @typedef {Object} HtmxNodeInternalData
   * Element data
   * @property {number} [initHash]
   * @property {boolean} [boosted]
   * @property {OnHandler[]} [onHandlers]
   * @property {number} [timeout]
   * @property {ListenerInfo[]} [listenerInfos]
   * @property {boolean} [cancelled]
   * @property {boolean} [triggeredOnce]
   * @property {number} [delayed]
   * @property {number|null} [throttle]
   * @property {WeakMap<HtmxTriggerSpecification,WeakMap<EventTarget,string>>} [lastValue]
   * @property {boolean} [loaded]
   * @property {string} [path]
   * @property {string} [verb]
   * @property {boolean} [polling]
   * @property {HTMLButtonElement|HTMLInputElement|null} [lastButtonClicked]
   * @property {number} [requestCount]
   * @property {XMLHttpRequest} [xhr]
   * @property {(() => void)[]} [queuedRequests]
   * @property {boolean} [abortable]
   * @property {boolean} [firstInitCompleted]
   *
   * Event data
   * @property {HtmxTriggerSpecification} [triggerSpec]
   * @property {EventTarget[]} [handledFor]
   */ /**
   * getInternalData retrieves "private" data stored by htmx within an element
   * @param {EventTarget|Event} elt
   * @returns {HtmxNodeInternalData}
   */ function getInternalData(elt) {
        const dataProp = 'htmx-internal-data';
        let data = elt[dataProp];
        if (!data) data = elt[dataProp] = {};
        return data;
    }
    /**
   * toArray converts an ArrayLike object into a real array.
   * @template T
   * @param {ArrayLike<T>} arr
   * @returns {T[]}
   */ function toArray(arr) {
        const returnArr = [];
        if (arr) for(let i = 0; i < arr.length; i++)returnArr.push(arr[i]);
        return returnArr;
    }
    /**
   * @template T
   * @param {T[]|NamedNodeMap|HTMLCollection|HTMLFormControlsCollection|ArrayLike<T>} arr
   * @param {(T) => void} func
   */ function forEach(arr, func) {
        if (arr) for(let i = 0; i < arr.length; i++)func(arr[i]);
    }
    /**
   * @param {Element} el
   * @returns {boolean}
   */ function isScrolledIntoView(el) {
        const rect = el.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop < window.innerHeight && elemBottom >= 0;
    }
    /**
   * Checks whether the element is in the document (includes shadow roots).
   * This function this is a slight misnomer; it will return true even for elements in the head.
   *
   * @param {Node} elt
   * @returns {boolean}
   */ function bodyContains(elt) {
        return elt.getRootNode({
            composed: true
        }) === document;
    }
    /**
   * @param {string} trigger
   * @returns {string[]}
   */ function splitOnWhitespace(trigger) {
        return trigger.trim().split(/\s+/);
    }
    /**
   * mergeObjects takes all the keys from
   * obj2 and duplicates them into obj1
   * @template T1
   * @template T2
   * @param {T1} obj1
   * @param {T2} obj2
   * @returns {T1 & T2}
   */ function mergeObjects(obj1, obj2) {
        for(const key in obj2)if (obj2.hasOwnProperty(key)) // @ts-ignore tsc doesn't seem to properly handle types merging
        obj1[key] = obj2[key];
        // @ts-ignore tsc doesn't seem to properly handle types merging
        return obj1;
    }
    /**
   * @param {string} jString
   * @returns {any|null}
   */ function parseJSON(jString) {
        try {
            return JSON.parse(jString);
        } catch (error) {
            logError(error);
            return null;
        }
    }
    /**
   * @returns {boolean}
   */ function canAccessLocalStorage() {
        const test = 'htmx:sessionStorageTest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
   * @param {string} path
   * @returns {string}
   */ function normalizePath(path) {
        // use dummy base URL to allow normalize on path only
        const url = new URL(path, 'http://x');
        if (url) path = url.pathname + url.search;
        // remove trailing slash, unless index page
        if (path != '/') path = path.replace(/\/+$/, '');
        return path;
    }
    //= =========================================================================================
    // public API
    //= =========================================================================================
    /**
   * @param {string} str
   * @returns {any}
   */ function internalEval(str) {
        return maybeEval(getDocument().body, function() {
            return eval(str);
        });
    }
    /**
   * Adds a callback for the **htmx:load** event. This can be used to process new content, for example initializing the content with a javascript library
   *
   * @see https://htmx.org/api/#onLoad
   *
   * @param {(elt: Node) => void} callback the callback to call on newly loaded content
   * @returns {EventListener}
   */ function onLoadHelper(callback) {
        const value = htmx.on('htmx:load', /** @param {CustomEvent} evt */ function(evt) {
            callback(evt.detail.elt);
        });
        return value;
    }
    /**
   * Log all htmx events, useful for debugging.
   *
   * @see https://htmx.org/api/#logAll
   */ function logAll() {
        htmx.logger = function(elt, event, data) {
            if (console) console.log(event, elt, data);
        };
    }
    function logNone() {
        htmx.logger = null;
    }
    /**
   * Finds an element matching the selector
   *
   * @see https://htmx.org/api/#find
   *
   * @param {ParentNode|string} eltOrSelector  the root element to find the matching element in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {Element|null}
   */ function find(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelector(selector);
        else return find(getDocument(), eltOrSelector);
    }
    /**
   * Finds all elements matching the selector
   *
   * @see https://htmx.org/api/#findAll
   *
   * @param {ParentNode|string} eltOrSelector the root element to find the matching elements in, inclusive | the selector to match
   * @param {string} [selector] the selector to match
   * @returns {NodeListOf<Element>}
   */ function findAll(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return eltOrSelector.querySelectorAll(selector);
        else return findAll(getDocument(), eltOrSelector);
    }
    /**
   * @returns Window
   */ function getWindow() {
        return window;
    }
    /**
   * Removes an element from the DOM
   *
   * @see https://htmx.org/api/#remove
   *
   * @param {Node} elt
   * @param {number} [delay]
   */ function removeElement(elt, delay) {
        elt = resolveTarget(elt);
        if (delay) getWindow().setTimeout(function() {
            removeElement(elt);
            elt = null;
        }, delay);
        else parentElt(elt).removeChild(elt);
    }
    /**
   * @param {any} elt
   * @return {Element|null}
   */ function asElement(elt) {
        return elt instanceof Element ? elt : null;
    }
    /**
   * @param {any} elt
   * @return {HTMLElement|null}
   */ function asHtmlElement(elt) {
        return elt instanceof HTMLElement ? elt : null;
    }
    /**
   * @param {any} value
   * @return {string|null}
   */ function asString(value) {
        return typeof value === 'string' ? value : null;
    }
    /**
   * @param {EventTarget} elt
   * @return {ParentNode|null}
   */ function asParentNode(elt) {
        return elt instanceof Element || elt instanceof Document || elt instanceof DocumentFragment ? elt : null;
    }
    /**
   * This method adds a class to the given element.
   *
   * @see https://htmx.org/api/#addClass
   *
   * @param {Element|string} elt the element to add the class to
   * @param {string} clazz the class to add
   * @param {number} [delay] the delay (in milliseconds) before class is added
   */ function addClassToElement(elt, clazz, delay) {
        elt = asElement(resolveTarget(elt));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            addClassToElement(elt, clazz);
            elt = null;
        }, delay);
        else elt.classList && elt.classList.add(clazz);
    }
    /**
   * Removes a class from the given element
   *
   * @see https://htmx.org/api/#removeClass
   *
   * @param {Node|string} node element to remove the class from
   * @param {string} clazz the class to remove
   * @param {number} [delay] the delay (in milliseconds before class is removed)
   */ function removeClassFromElement(node, clazz, delay) {
        let elt = asElement(resolveTarget(node));
        if (!elt) return;
        if (delay) getWindow().setTimeout(function() {
            removeClassFromElement(elt, clazz);
            elt = null;
        }, delay);
        else if (elt.classList) {
            elt.classList.remove(clazz);
            // if there are no classes left, remove the class attribute
            if (elt.classList.length === 0) elt.removeAttribute('class');
        }
    }
    /**
   * Toggles the given class on an element
   *
   * @see https://htmx.org/api/#toggleClass
   *
   * @param {Element|string} elt the element to toggle the class on
   * @param {string} clazz the class to toggle
   */ function toggleClassOnElement(elt, clazz) {
        elt = resolveTarget(elt);
        elt.classList.toggle(clazz);
    }
    /**
   * Takes the given class from its siblings, so that among its siblings, only the given element will have the class.
   *
   * @see https://htmx.org/api/#takeClass
   *
   * @param {Node|string} elt the element that will take the class
   * @param {string} clazz the class to take
   */ function takeClassForElement(elt, clazz) {
        elt = resolveTarget(elt);
        forEach(elt.parentElement.children, function(child) {
            removeClassFromElement(child, clazz);
        });
        addClassToElement(asElement(elt), clazz);
    }
    /**
   * Finds the closest matching element in the given elements parentage, inclusive of the element
   *
   * @see https://htmx.org/api/#closest
   *
   * @param {Element|string} elt the element to find the selector from
   * @param {string} selector the selector to find
   * @returns {Element|null}
   */ function closest(elt, selector) {
        elt = asElement(resolveTarget(elt));
        if (elt) return elt.closest(selector);
        return null;
    }
    /**
   * @param {string} str
   * @param {string} prefix
   * @returns {boolean}
   */ function startsWith(str, prefix) {
        return str.substring(0, prefix.length) === prefix;
    }
    /**
   * @param {string} str
   * @param {string} suffix
   * @returns {boolean}
   */ function endsWith(str, suffix) {
        return str.substring(str.length - suffix.length) === suffix;
    }
    /**
   * @param {string} selector
   * @returns {string}
   */ function normalizeSelector(selector) {
        const trimmedSelector = selector.trim();
        if (startsWith(trimmedSelector, '<') && endsWith(trimmedSelector, '/>')) return trimmedSelector.substring(1, trimmedSelector.length - 2);
        else return trimmedSelector;
    }
    /**
   * @param {Node|Element|Document|string} elt
   * @param {string} selector
   * @param {boolean=} global
   * @returns {(Node|Window)[]}
   */ function querySelectorAllExt(elt, selector, global) {
        if (selector.indexOf('global ') === 0) return querySelectorAllExt(elt, selector.slice(7), true);
        elt = resolveTarget(elt);
        const parts = [];
        {
            let chevronsCount = 0;
            let offset = 0;
            for(let i = 0; i < selector.length; i++){
                const char = selector[i];
                if (char === ',' && chevronsCount === 0) {
                    parts.push(selector.substring(offset, i));
                    offset = i + 1;
                    continue;
                }
                if (char === '<') chevronsCount++;
                else if (char === '/' && i < selector.length - 1 && selector[i + 1] === '>') chevronsCount--;
            }
            if (offset < selector.length) parts.push(selector.substring(offset));
        }
        const result = [];
        const unprocessedParts = [];
        while(parts.length > 0){
            const selector = normalizeSelector(parts.shift());
            let item;
            if (selector.indexOf('closest ') === 0) item = closest(asElement(elt), normalizeSelector(selector.slice(8)));
            else if (selector.indexOf('find ') === 0) item = find(asParentNode(elt), normalizeSelector(selector.slice(5)));
            else if (selector === 'next' || selector === 'nextElementSibling') item = asElement(elt).nextElementSibling;
            else if (selector.indexOf('next ') === 0) item = scanForwardQuery(elt, normalizeSelector(selector.slice(5)), !!global);
            else if (selector === 'previous' || selector === 'previousElementSibling') item = asElement(elt).previousElementSibling;
            else if (selector.indexOf('previous ') === 0) item = scanBackwardsQuery(elt, normalizeSelector(selector.slice(9)), !!global);
            else if (selector === 'document') item = document;
            else if (selector === 'window') item = window;
            else if (selector === 'body') item = document.body;
            else if (selector === 'root') item = getRootNode(elt, !!global);
            else if (selector === 'host') item = /** @type ShadowRoot */ elt.getRootNode().host;
            else unprocessedParts.push(selector);
            if (item) result.push(item);
        }
        if (unprocessedParts.length > 0) {
            const standardSelector = unprocessedParts.join(',');
            const rootNode = asParentNode(getRootNode(elt, !!global));
            result.push(...toArray(rootNode.querySelectorAll(standardSelector)));
        }
        return result;
    }
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanForwardQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = 0; i < results.length; i++){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) return elt;
        }
    };
    /**
   * @param {Node} start
   * @param {string} match
   * @param {boolean} global
   * @returns {Element}
   */ var scanBackwardsQuery = function(start, match, global) {
        const results = asParentNode(getRootNode(start, global)).querySelectorAll(match);
        for(let i = results.length - 1; i >= 0; i--){
            const elt = results[i];
            if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_FOLLOWING) return elt;
        }
    };
    /**
   * @param {Node|string} eltOrSelector
   * @param {string=} selector
   * @returns {Node|Window}
   */ function querySelectorExt(eltOrSelector, selector) {
        if (typeof eltOrSelector !== 'string') return querySelectorAllExt(eltOrSelector, selector)[0];
        else return querySelectorAllExt(getDocument().body, eltOrSelector)[0];
    }
    /**
   * @template {EventTarget} T
   * @param {T|string} eltOrSelector
   * @param {T} [context]
   * @returns {Element|T|null}
   */ function resolveTarget(eltOrSelector, context) {
        if (typeof eltOrSelector === 'string') return find(asParentNode(context) || document, eltOrSelector);
        else return eltOrSelector;
    }
    /**
   * @typedef {keyof HTMLElementEventMap|string} AnyEventName
   */ /**
   * @typedef {Object} EventArgs
   * @property {EventTarget} target
   * @property {AnyEventName} event
   * @property {EventListener} listener
   * @property {Object|boolean} options
   */ /**
   * @param {EventTarget|AnyEventName} arg1
   * @param {AnyEventName|EventListener} arg2
   * @param {EventListener|Object|boolean} [arg3]
   * @param {Object|boolean} [arg4]
   * @returns {EventArgs}
   */ function processEventArgs(arg1, arg2, arg3, arg4) {
        if (isFunction(arg2)) return {
            target: getDocument().body,
            event: asString(arg1),
            listener: arg2,
            options: arg3
        };
        else return {
            target: resolveTarget(arg1),
            event: asString(arg2),
            listener: arg3,
            options: arg4
        };
    }
    /**
   * Adds an event listener to an element
   *
   * @see https://htmx.org/api/#on
   *
   * @param {EventTarget|string} arg1 the element to add the listener to | the event name to add the listener for
   * @param {string|EventListener} arg2 the event name to add the listener for | the listener to add
   * @param {EventListener|Object|boolean} [arg3] the listener to add | options to add
   * @param {Object|boolean} [arg4] options to add
   * @returns {EventListener}
   */ function addEventListenerImpl(arg1, arg2, arg3, arg4) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3, arg4);
            eventArgs.target.addEventListener(eventArgs.event, eventArgs.listener, eventArgs.options);
        });
        const b = isFunction(arg2);
        return b ? arg2 : arg3;
    }
    /**
   * Removes an event listener from an element
   *
   * @see https://htmx.org/api/#off
   *
   * @param {EventTarget|string} arg1 the element to remove the listener from | the event name to remove the listener from
   * @param {string|EventListener} arg2 the event name to remove the listener from | the listener to remove
   * @param {EventListener} [arg3] the listener to remove
   * @returns {EventListener}
   */ function removeEventListenerImpl(arg1, arg2, arg3) {
        ready(function() {
            const eventArgs = processEventArgs(arg1, arg2, arg3);
            eventArgs.target.removeEventListener(eventArgs.event, eventArgs.listener);
        });
        return isFunction(arg2) ? arg2 : arg3;
    }
    //= ===================================================================
    // Node processing
    //= ===================================================================
    const DUMMY_ELT = getDocument().createElement('output') // dummy element for bad selectors
    ;
    /**
   * @param {Element} elt
   * @param {string} attrName
   * @returns {(Node|Window)[]}
   */ function findAttributeTargets(elt, attrName) {
        const attrTarget = getClosestAttributeValue(elt, attrName);
        if (attrTarget) {
            if (attrTarget === 'this') return [
                findThisElement(elt, attrName)
            ];
            else {
                const result = querySelectorAllExt(elt, attrTarget);
                // find `inherit` whole word in value, make sure it's surrounded by commas or is at the start/end of string
                const shouldInherit = /(^|,)(\s*)inherit(\s*)($|,)/.test(attrTarget);
                if (shouldInherit) {
                    const eltToInheritFrom = asElement(getClosestMatch(elt, function(parent) {
                        return parent !== elt && hasAttribute(asElement(parent), attrName);
                    }));
                    if (eltToInheritFrom) result.push(...findAttributeTargets(eltToInheritFrom, attrName));
                }
                if (result.length === 0) {
                    logError('The selector "' + attrTarget + '" on ' + attrName + ' returned no matches!');
                    return [
                        DUMMY_ELT
                    ];
                } else return result;
            }
        }
    }
    /**
   * @param {Element} elt
   * @param {string} attribute
   * @returns {Element|null}
   */ function findThisElement(elt, attribute) {
        return asElement(getClosestMatch(elt, function(elt) {
            return getAttributeValue(asElement(elt), attribute) != null;
        }));
    }
    /**
   * @param {Element} elt
   * @returns {Node|Window|null}
   */ function getTarget(elt) {
        const targetStr = getClosestAttributeValue(elt, 'hx-target');
        if (targetStr) {
            if (targetStr === 'this') return findThisElement(elt, 'hx-target');
            else return querySelectorExt(elt, targetStr);
        } else {
            const data = getInternalData(elt);
            if (data.boosted) return getDocument().body;
            else return elt;
        }
    }
    /**
   * @param {string} name
   * @returns {boolean}
   */ function shouldSettleAttribute(name) {
        return htmx.config.attributesToSettle.includes(name);
    }
    /**
   * @param {Element} mergeTo
   * @param {Element} mergeFrom
   */ function cloneAttributes(mergeTo, mergeFrom) {
        forEach(mergeTo.attributes, function(attr) {
            if (!mergeFrom.hasAttribute(attr.name) && shouldSettleAttribute(attr.name)) mergeTo.removeAttribute(attr.name);
        });
        forEach(mergeFrom.attributes, function(attr) {
            if (shouldSettleAttribute(attr.name)) mergeTo.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} target
   * @returns {boolean}
   */ function isInlineSwap(swapStyle, target) {
        const extensions = getExtensions(target);
        for(let i = 0; i < extensions.length; i++){
            const extension = extensions[i];
            try {
                if (extension.isInlineSwap(swapStyle)) return true;
            } catch (e) {
                logError(e);
            }
        }
        return swapStyle === 'outerHTML';
    }
    /**
   * @param {string} oobValue
   * @param {Element} oobElement
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   * @returns
   */ function oobSwap(oobValue, oobElement, settleInfo, rootNode) {
        rootNode = rootNode || getDocument();
        let selector = '#' + CSS.escape(getRawAttribute(oobElement, 'id'));
        /** @type HtmxSwapStyle */ let swapStyle = 'outerHTML';
        if (oobValue === 'true') ;
        else if (oobValue.indexOf(':') > 0) {
            swapStyle = oobValue.substring(0, oobValue.indexOf(':'));
            selector = oobValue.substring(oobValue.indexOf(':') + 1);
        } else swapStyle = oobValue;
        oobElement.removeAttribute('hx-swap-oob');
        oobElement.removeAttribute('data-hx-swap-oob');
        const targets = querySelectorAllExt(rootNode, selector, false);
        if (targets.length) {
            forEach(targets, function(target) {
                let fragment;
                const oobElementClone = oobElement.cloneNode(true);
                fragment = getDocument().createDocumentFragment();
                fragment.appendChild(oobElementClone);
                if (!isInlineSwap(swapStyle, target)) fragment = asParentNode(oobElementClone) // if this is not an inline swap, we use the content of the node, not the node itself
                ;
                const beforeSwapDetails = {
                    shouldSwap: true,
                    target: target,
                    fragment: fragment
                };
                if (!triggerEvent(target, 'htmx:oobBeforeSwap', beforeSwapDetails)) return;
                target = beforeSwapDetails.target // allow re-targeting
                ;
                if (beforeSwapDetails.shouldSwap) {
                    handlePreservedElements(fragment);
                    swapWithStyle(swapStyle, target, target, fragment, settleInfo);
                    restorePreservedElements();
                }
                forEach(settleInfo.elts, function(elt) {
                    triggerEvent(elt, 'htmx:oobAfterSwap', beforeSwapDetails);
                });
            });
            oobElement.parentNode.removeChild(oobElement);
        } else {
            oobElement.parentNode.removeChild(oobElement);
            triggerErrorEvent(getDocument().body, 'htmx:oobErrorNoTarget', {
                content: oobElement
            });
        }
        return oobValue;
    }
    function restorePreservedElements() {
        const pantry = find('#--htmx-preserve-pantry--');
        if (pantry) {
            for (const preservedElt of [
                ...pantry.children
            ]){
                const existingElement = find('#' + preservedElt.id);
                // @ts-ignore - use proposed moveBefore feature
                existingElement.parentNode.moveBefore(preservedElt, existingElement);
                existingElement.remove();
            }
            pantry.remove();
        }
    }
    /**
   * @param {DocumentFragment|ParentNode} fragment
   */ function handlePreservedElements(fragment) {
        forEach(findAll(fragment, '[hx-preserve], [data-hx-preserve]'), function(preservedElt) {
            const id = getAttributeValue(preservedElt, 'id');
            const existingElement = getDocument().getElementById(id);
            if (existingElement != null) {
                if (preservedElt.moveBefore) {
                    // get or create a storage spot for stuff
                    let pantry = find('#--htmx-preserve-pantry--');
                    if (pantry == null) {
                        getDocument().body.insertAdjacentHTML('afterend', "<div id='--htmx-preserve-pantry--'></div>");
                        pantry = find('#--htmx-preserve-pantry--');
                    }
                    // @ts-ignore - use proposed moveBefore feature
                    pantry.moveBefore(existingElement, null);
                } else preservedElt.parentNode.replaceChild(existingElement, preservedElt);
            }
        });
    }
    /**
   * @param {Node} parentNode
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function handleAttributes(parentNode, fragment, settleInfo) {
        forEach(fragment.querySelectorAll('[id]'), function(newNode) {
            const id = getRawAttribute(newNode, 'id');
            if (id && id.length > 0) {
                const normalizedId = id.replace("'", "\\'");
                const normalizedTag = newNode.tagName.replace(':', '\\:');
                const parentElt = asParentNode(parentNode);
                const oldNode = parentElt && parentElt.querySelector(normalizedTag + "[id='" + normalizedId + "']");
                if (oldNode && oldNode !== parentElt) {
                    const newAttributes = newNode.cloneNode();
                    cloneAttributes(newNode, oldNode);
                    settleInfo.tasks.push(function() {
                        cloneAttributes(newNode, newAttributes);
                    });
                }
            }
        });
    }
    /**
   * @param {Node} child
   * @returns {HtmxSettleTask}
   */ function makeAjaxLoadTask(child) {
        return function() {
            removeClassFromElement(child, htmx.config.addedClass);
            processNode(asElement(child));
            processFocus(asParentNode(child));
            triggerEvent(child, 'htmx:load');
        };
    }
    /**
   * @param {ParentNode} child
   */ function processFocus(child) {
        const autofocus = '[autofocus]';
        const autoFocusedElt = asHtmlElement(matches(child, autofocus) ? child : child.querySelector(autofocus));
        if (autoFocusedElt != null) autoFocusedElt.focus();
    }
    /**
   * @param {Node} parentNode
   * @param {Node} insertBefore
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function insertNodesBefore(parentNode, insertBefore, fragment, settleInfo) {
        handleAttributes(parentNode, fragment, settleInfo);
        while(fragment.childNodes.length > 0){
            const child = fragment.firstChild;
            addClassToElement(asElement(child), htmx.config.addedClass);
            parentNode.insertBefore(child, insertBefore);
            if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
        }
    }
    /**
   * based on https://gist.github.com/hyamamoto/fd435505d29ebfa3d9716fd2be8d42f0,
   * derived from Java's string hashcode implementation
   * @param {string} string
   * @param {number} hash
   * @returns {number}
   */ function stringHash(string, hash) {
        let char = 0;
        while(char < string.length)hash = (hash << 5) - hash + string.charCodeAt(char++) | 0 // bitwise or ensures we have a 32-bit int
        ;
        return hash;
    }
    /**
   * @param {Element} elt
   * @returns {number}
   */ function attributeHash(elt) {
        let hash = 0;
        for(let i = 0; i < elt.attributes.length; i++){
            const attribute = elt.attributes[i];
            if (attribute.value) {
                hash = stringHash(attribute.name, hash);
                hash = stringHash(attribute.value, hash);
            }
        }
        return hash;
    }
    /**
   * @param {EventTarget} elt
   */ function deInitOnHandlers(elt) {
        const internalData = getInternalData(elt);
        if (internalData.onHandlers) {
            for(let i = 0; i < internalData.onHandlers.length; i++){
                const handlerInfo = internalData.onHandlers[i];
                removeEventListenerImpl(elt, handlerInfo.event, handlerInfo.listener);
            }
            delete internalData.onHandlers;
        }
    }
    /**
   * @param {Node} element
   */ function deInitNode(element) {
        const internalData = getInternalData(element);
        if (internalData.timeout) clearTimeout(internalData.timeout);
        if (internalData.listenerInfos) forEach(internalData.listenerInfos, function(info) {
            if (info.on) removeEventListenerImpl(info.on, info.trigger, info.listener);
        });
        deInitOnHandlers(element);
        forEach(Object.keys(internalData), function(key) {
            if (key !== 'firstInitCompleted') delete internalData[key];
        });
    }
    /**
   * @param {Node} element
   */ function cleanUpElement(element) {
        triggerEvent(element, 'htmx:beforeCleanupElement');
        deInitNode(element);
        // @ts-ignore
        forEach(element.children, function(child) {
            cleanUpElement(child);
        });
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapOuterHTML(target, fragment, settleInfo) {
        if (target.tagName === 'BODY') return swapInnerHTML(target, fragment, settleInfo);
        /** @type {Node} */ let newElt;
        const eltBeforeNewContent = target.previousSibling;
        const parentNode = parentElt(target);
        if (!parentNode) return;
        insertNodesBefore(parentNode, target, fragment, settleInfo);
        if (eltBeforeNewContent == null) newElt = parentNode.firstChild;
        else newElt = eltBeforeNewContent.nextSibling;
        settleInfo.elts = settleInfo.elts.filter(function(e) {
            return e !== target;
        });
        // scan through all newly added content and add all elements to the settle info so we trigger
        // events properly on them
        while(newElt && newElt !== target){
            if (newElt instanceof Element) settleInfo.elts.push(newElt);
            newElt = newElt.nextSibling;
        }
        cleanUpElement(target);
        target.remove();
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterBegin(target, fragment, settleInfo) {
        return insertNodesBefore(target, target.firstChild, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeBegin(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapBeforeEnd(target, fragment, settleInfo) {
        return insertNodesBefore(target, null, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapAfterEnd(target, fragment, settleInfo) {
        return insertNodesBefore(parentElt(target), target.nextSibling, fragment, settleInfo);
    }
    /**
   * @param {Element} target
   */ function swapDelete(target) {
        cleanUpElement(target);
        const parent = parentElt(target);
        if (parent) return parent.removeChild(target);
    }
    /**
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapInnerHTML(target, fragment, settleInfo) {
        const firstChild = target.firstChild;
        insertNodesBefore(target, firstChild, fragment, settleInfo);
        if (firstChild) {
            while(firstChild.nextSibling){
                cleanUpElement(firstChild.nextSibling);
                target.removeChild(firstChild.nextSibling);
            }
            cleanUpElement(firstChild);
            target.removeChild(firstChild);
        }
    }
    /**
   * @param {HtmxSwapStyle} swapStyle
   * @param {Element} elt
   * @param {Element} target
   * @param {ParentNode} fragment
   * @param {HtmxSettleInfo} settleInfo
   */ function swapWithStyle(swapStyle, elt, target, fragment, settleInfo) {
        switch(swapStyle){
            case 'none':
                return;
            case 'outerHTML':
                swapOuterHTML(target, fragment, settleInfo);
                return;
            case 'afterbegin':
                swapAfterBegin(target, fragment, settleInfo);
                return;
            case 'beforebegin':
                swapBeforeBegin(target, fragment, settleInfo);
                return;
            case 'beforeend':
                swapBeforeEnd(target, fragment, settleInfo);
                return;
            case 'afterend':
                swapAfterEnd(target, fragment, settleInfo);
                return;
            case 'delete':
                swapDelete(target);
                return;
            default:
                var extensions = getExtensions(elt);
                for(let i = 0; i < extensions.length; i++){
                    const ext = extensions[i];
                    try {
                        const newElements = ext.handleSwap(swapStyle, target, fragment, settleInfo);
                        if (newElements) {
                            if (Array.isArray(newElements)) // if handleSwap returns an array (like) of elements, we handle them
                            for(let j = 0; j < newElements.length; j++){
                                const child = newElements[j];
                                if (child.nodeType !== Node.TEXT_NODE && child.nodeType !== Node.COMMENT_NODE) settleInfo.tasks.push(makeAjaxLoadTask(child));
                            }
                            return;
                        }
                    } catch (e) {
                        logError(e);
                    }
                }
                if (swapStyle === 'innerHTML') swapInnerHTML(target, fragment, settleInfo);
                else swapWithStyle(htmx.config.defaultSwapStyle, elt, target, fragment, settleInfo);
        }
    }
    /**
   * @param {DocumentFragment} fragment
   * @param {HtmxSettleInfo} settleInfo
   * @param {Node|Document} [rootNode]
   */ function findAndSwapOobElements(fragment, settleInfo, rootNode) {
        var oobElts = findAll(fragment, '[hx-swap-oob], [data-hx-swap-oob]');
        forEach(oobElts, function(oobElement) {
            if (htmx.config.allowNestedOobSwaps || oobElement.parentElement === null) {
                const oobValue = getAttributeValue(oobElement, 'hx-swap-oob');
                if (oobValue != null) oobSwap(oobValue, oobElement, settleInfo, rootNode);
            } else {
                oobElement.removeAttribute('hx-swap-oob');
                oobElement.removeAttribute('data-hx-swap-oob');
            }
        });
        return oobElts.length > 0;
    }
    /**
   * Implements complete swapping pipeline, including: delay, view transitions, focus and selection preservation,
   * title updates, scroll, OOB swapping, normal swapping and settling
   * @param {string|Element} target
   * @param {string} content
   * @param {HtmxSwapSpecification} swapSpec
   * @param {SwapOptions} [swapOptions]
   */ function swap(target, content, swapSpec, swapOptions) {
        if (!swapOptions) swapOptions = {};
        // optional transition API promise callbacks
        let settleResolve = null;
        let settleReject = null;
        let doSwap = function() {
            maybeCall(swapOptions.beforeSwapCallback);
            target = resolveTarget(target);
            const rootNode = swapOptions.contextElement ? getRootNode(swapOptions.contextElement, false) : getDocument();
            // preserve focus and selection
            const activeElt = document.activeElement;
            let selectionInfo = {};
            selectionInfo = {
                elt: activeElt,
                // @ts-ignore
                start: activeElt ? activeElt.selectionStart : null,
                // @ts-ignore
                end: activeElt ? activeElt.selectionEnd : null
            };
            const settleInfo = makeSettleInfo(target);
            // For text content swaps, don't parse the response as HTML, just insert it
            if (swapSpec.swapStyle === 'textContent') target.textContent = content;
            else {
                let fragment = makeFragment(content);
                settleInfo.title = swapOptions.title || fragment.title;
                if (swapOptions.historyRequest) // @ts-ignore fragment can be a parentNode Element
                fragment = fragment.querySelector('[hx-history-elt],[data-hx-history-elt]') || fragment;
                // select-oob swaps
                if (swapOptions.selectOOB) {
                    const oobSelectValues = swapOptions.selectOOB.split(',');
                    for(let i = 0; i < oobSelectValues.length; i++){
                        const oobSelectValue = oobSelectValues[i].split(':', 2);
                        let id = oobSelectValue[0].trim();
                        if (id.indexOf('#') === 0) id = id.substring(1);
                        const oobValue = oobSelectValue[1] || 'true';
                        const oobElement = fragment.querySelector('#' + id);
                        if (oobElement) oobSwap(oobValue, oobElement, settleInfo, rootNode);
                    }
                }
                // oob swaps
                findAndSwapOobElements(fragment, settleInfo, rootNode);
                forEach(findAll(fragment, 'template'), /** @param {HTMLTemplateElement} template */ function(template) {
                    if (template.content && findAndSwapOobElements(template.content, settleInfo, rootNode)) // Avoid polluting the DOM with empty templates that were only used to encapsulate oob swap
                    template.remove();
                });
                // normal swap
                if (swapOptions.select) {
                    const newFragment = getDocument().createDocumentFragment();
                    forEach(fragment.querySelectorAll(swapOptions.select), function(node) {
                        newFragment.appendChild(node);
                    });
                    fragment = newFragment;
                }
                handlePreservedElements(fragment);
                swapWithStyle(swapSpec.swapStyle, swapOptions.contextElement, target, fragment, settleInfo);
                restorePreservedElements();
            }
            // apply saved focus and selection information to swapped content
            if (selectionInfo.elt && !bodyContains(selectionInfo.elt) && getRawAttribute(selectionInfo.elt, 'id')) {
                const newActiveElt = document.getElementById(getRawAttribute(selectionInfo.elt, 'id'));
                const focusOptions = {
                    preventScroll: swapSpec.focusScroll !== undefined ? !swapSpec.focusScroll : !htmx.config.defaultFocusScroll
                };
                if (newActiveElt) {
                    // @ts-ignore
                    if (selectionInfo.start && newActiveElt.setSelectionRange) try {
                        // @ts-ignore
                        newActiveElt.setSelectionRange(selectionInfo.start, selectionInfo.end);
                    } catch (e) {
                    // the setSelectionRange method is present on fields that don't support it, so just let this fail
                    }
                    newActiveElt.focus(focusOptions);
                }
            }
            target.classList.remove(htmx.config.swappingClass);
            forEach(settleInfo.elts, function(elt) {
                if (elt.classList) elt.classList.add(htmx.config.settlingClass);
                triggerEvent(elt, 'htmx:afterSwap', swapOptions.eventInfo);
            });
            maybeCall(swapOptions.afterSwapCallback);
            // merge in new title after swap but before settle
            if (!swapSpec.ignoreTitle) handleTitle(settleInfo.title);
            // settle
            const doSettle = function() {
                forEach(settleInfo.tasks, function(task) {
                    task.call();
                });
                forEach(settleInfo.elts, function(elt) {
                    if (elt.classList) elt.classList.remove(htmx.config.settlingClass);
                    triggerEvent(elt, 'htmx:afterSettle', swapOptions.eventInfo);
                });
                if (swapOptions.anchor) {
                    const anchorTarget = asElement(resolveTarget('#' + swapOptions.anchor));
                    if (anchorTarget) anchorTarget.scrollIntoView({
                        block: 'start',
                        behavior: 'auto'
                    });
                }
                updateScrollState(settleInfo.elts, swapSpec);
                maybeCall(swapOptions.afterSettleCallback);
                maybeCall(settleResolve);
            };
            if (swapSpec.settleDelay > 0) getWindow().setTimeout(doSettle, swapSpec.settleDelay);
            else doSettle();
        };
        let shouldTransition = htmx.config.globalViewTransitions;
        if (swapSpec.hasOwnProperty('transition')) shouldTransition = swapSpec.transition;
        const elt = swapOptions.contextElement || getDocument();
        if (shouldTransition && triggerEvent(elt, 'htmx:beforeTransition', swapOptions.eventInfo) && typeof Promise !== 'undefined' && // @ts-ignore experimental feature atm
        document.startViewTransition) {
            const settlePromise = new Promise(function(_resolve, _reject) {
                settleResolve = _resolve;
                settleReject = _reject;
            });
            // wrap the original doSwap() in a call to startViewTransition()
            const innerDoSwap = doSwap;
            doSwap = function() {
                // @ts-ignore experimental feature atm
                document.startViewTransition(function() {
                    innerDoSwap();
                    return settlePromise;
                });
            };
        }
        try {
            if (swapSpec?.swapDelay && swapSpec.swapDelay > 0) getWindow().setTimeout(doSwap, swapSpec.swapDelay);
            else doSwap();
        } catch (e) {
            triggerErrorEvent(elt, 'htmx:swapError', swapOptions.eventInfo);
            maybeCall(settleReject);
            throw e;
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {EventTarget} elt
   */ function handleTriggerHeader(xhr, header, elt) {
        const triggerBody = xhr.getResponseHeader(header);
        if (triggerBody.indexOf('{') === 0) {
            const triggers = parseJSON(triggerBody);
            for(const eventName in triggers)if (triggers.hasOwnProperty(eventName)) {
                let detail = triggers[eventName];
                if (isRawObject(detail)) // @ts-ignore
                elt = detail.target !== undefined ? detail.target : elt;
                else detail = {
                    value: detail
                };
                triggerEvent(elt, eventName, detail);
            }
        } else {
            const eventNames = triggerBody.split(',');
            for(let i = 0; i < eventNames.length; i++)triggerEvent(elt, eventNames[i].trim(), []);
        }
    }
    const WHITESPACE = /\s/;
    const WHITESPACE_OR_COMMA = /[\s,]/;
    const SYMBOL_START = /[_$a-zA-Z]/;
    const SYMBOL_CONT = /[_$a-zA-Z0-9]/;
    const STRINGISH_START = [
        '"',
        "'",
        '/'
    ];
    const NOT_WHITESPACE = /[^\s]/;
    const COMBINED_SELECTOR_START = /[{(]/;
    const COMBINED_SELECTOR_END = /[})]/;
    /**
   * @param {string} str
   * @returns {string[]}
   */ function tokenizeString(str) {
        /** @type string[] */ const tokens = [];
        let position = 0;
        while(position < str.length){
            if (SYMBOL_START.exec(str.charAt(position))) {
                var startPosition = position;
                while(SYMBOL_CONT.exec(str.charAt(position + 1)))position++;
                tokens.push(str.substring(startPosition, position + 1));
            } else if (STRINGISH_START.indexOf(str.charAt(position)) !== -1) {
                const startChar = str.charAt(position);
                var startPosition = position;
                position++;
                while(position < str.length && str.charAt(position) !== startChar){
                    if (str.charAt(position) === '\\') position++;
                    position++;
                }
                tokens.push(str.substring(startPosition, position + 1));
            } else {
                const symbol = str.charAt(position);
                tokens.push(symbol);
            }
            position++;
        }
        return tokens;
    }
    /**
   * @param {string} token
   * @param {string|null} last
   * @param {string} paramName
   * @returns {boolean}
   */ function isPossibleRelativeReference(token, last, paramName) {
        return SYMBOL_START.exec(token.charAt(0)) && token !== 'true' && token !== 'false' && token !== 'this' && token !== paramName && last !== '.';
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string[]} tokens
   * @param {string} paramName
   * @returns {ConditionalFunction|null}
   */ function maybeGenerateConditional(elt, tokens, paramName) {
        if (tokens[0] === '[') {
            tokens.shift();
            let bracketCount = 1;
            let conditionalSource = ' return (function(' + paramName + '){ return (';
            let last = null;
            while(tokens.length > 0){
                const token = tokens[0];
                // @ts-ignore For some reason tsc doesn't understand the shift call, and thinks we're comparing the same value here, i.e. '[' vs ']'
                if (token === ']') {
                    bracketCount--;
                    if (bracketCount === 0) {
                        if (last === null) conditionalSource = conditionalSource + 'true';
                        tokens.shift();
                        conditionalSource += ')})';
                        try {
                            const conditionFunction = maybeEval(elt, function() {
                                return Function(conditionalSource)();
                            }, function() {
                                return true;
                            });
                            conditionFunction.source = conditionalSource;
                            return conditionFunction;
                        } catch (e) {
                            triggerErrorEvent(getDocument().body, 'htmx:syntax:error', {
                                error: e,
                                source: conditionalSource
                            });
                            return null;
                        }
                    }
                } else if (token === '[') bracketCount++;
                if (isPossibleRelativeReference(token, last, paramName)) conditionalSource += '((' + paramName + '.' + token + ') ? (' + paramName + '.' + token + ') : (window.' + token + '))';
                else conditionalSource = conditionalSource + token;
                last = tokens.shift();
            }
        }
    }
    /**
   * @param {string[]} tokens
   * @param {RegExp} match
   * @returns {string}
   */ function consumeUntil(tokens, match) {
        let result = '';
        while(tokens.length > 0 && !match.test(tokens[0]))result += tokens.shift();
        return result;
    }
    /**
   * @param {string[]} tokens
   * @returns {string}
   */ function consumeCSSSelector(tokens) {
        let result;
        if (tokens.length > 0 && COMBINED_SELECTOR_START.test(tokens[0])) {
            tokens.shift();
            result = consumeUntil(tokens, COMBINED_SELECTOR_END).trim();
            tokens.shift();
        } else result = consumeUntil(tokens, WHITESPACE_OR_COMMA);
        return result;
    }
    const INPUT_SELECTOR = 'input, textarea, select';
    /**
   * @param {Element} elt
   * @param {string} explicitTrigger
   * @param {Object} cache for trigger specs
   * @returns {HtmxTriggerSpecification[]}
   */ function parseAndCacheTrigger(elt, explicitTrigger, cache) {
        /** @type HtmxTriggerSpecification[] */ const triggerSpecs = [];
        const tokens = tokenizeString(explicitTrigger);
        do {
            consumeUntil(tokens, NOT_WHITESPACE);
            const initialLength = tokens.length;
            const trigger = consumeUntil(tokens, /[,\[\s]/);
            if (trigger !== '') {
                if (trigger === 'every') {
                    /** @type HtmxTriggerSpecification */ const every = {
                        trigger: 'every'
                    };
                    consumeUntil(tokens, NOT_WHITESPACE);
                    every.pollInterval = parseInterval(consumeUntil(tokens, /[,\[\s]/));
                    consumeUntil(tokens, NOT_WHITESPACE);
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) every.eventFilter = eventFilter;
                    triggerSpecs.push(every);
                } else {
                    /** @type HtmxTriggerSpecification */ const triggerSpec = {
                        trigger: trigger
                    };
                    var eventFilter = maybeGenerateConditional(elt, tokens, 'event');
                    if (eventFilter) triggerSpec.eventFilter = eventFilter;
                    consumeUntil(tokens, NOT_WHITESPACE);
                    while(tokens.length > 0 && tokens[0] !== ','){
                        const token = tokens.shift();
                        if (token === 'changed') triggerSpec.changed = true;
                        else if (token === 'once') triggerSpec.once = true;
                        else if (token === 'consume') triggerSpec.consume = true;
                        else if (token === 'delay' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.delay = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'from' && tokens[0] === ':') {
                            tokens.shift();
                            if (COMBINED_SELECTOR_START.test(tokens[0])) var from_arg = consumeCSSSelector(tokens);
                            else {
                                var from_arg = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                                if (from_arg === 'closest' || from_arg === 'find' || from_arg === 'next' || from_arg === 'previous') {
                                    tokens.shift();
                                    const selector = consumeCSSSelector(tokens);
                                    // `next` and `previous` allow a selector-less syntax
                                    if (selector.length > 0) from_arg += ' ' + selector;
                                }
                            }
                            triggerSpec.from = from_arg;
                        } else if (token === 'target' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.target = consumeCSSSelector(tokens);
                        } else if (token === 'throttle' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.throttle = parseInterval(consumeUntil(tokens, WHITESPACE_OR_COMMA));
                        } else if (token === 'queue' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec.queue = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else if (token === 'root' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeCSSSelector(tokens);
                        } else if (token === 'threshold' && tokens[0] === ':') {
                            tokens.shift();
                            triggerSpec[token] = consumeUntil(tokens, WHITESPACE_OR_COMMA);
                        } else triggerErrorEvent(elt, 'htmx:syntax:error', {
                            token: tokens.shift()
                        });
                        consumeUntil(tokens, NOT_WHITESPACE);
                    }
                    triggerSpecs.push(triggerSpec);
                }
            }
            if (tokens.length === initialLength) triggerErrorEvent(elt, 'htmx:syntax:error', {
                token: tokens.shift()
            });
            consumeUntil(tokens, NOT_WHITESPACE);
        }while (tokens[0] === ',' && tokens.shift());
        if (cache) cache[explicitTrigger] = triggerSpecs;
        return triggerSpecs;
    }
    /**
   * @param {Element} elt
   * @returns {HtmxTriggerSpecification[]}
   */ function getTriggerSpecs(elt) {
        const explicitTrigger = getAttributeValue(elt, 'hx-trigger');
        let triggerSpecs = [];
        if (explicitTrigger) {
            const cache = htmx.config.triggerSpecsCache;
            triggerSpecs = cache && cache[explicitTrigger] || parseAndCacheTrigger(elt, explicitTrigger, cache);
        }
        if (triggerSpecs.length > 0) return triggerSpecs;
        else if (matches(elt, 'form')) return [
            {
                trigger: 'submit'
            }
        ];
        else if (matches(elt, 'input[type="button"], input[type="submit"]')) return [
            {
                trigger: 'click'
            }
        ];
        else if (matches(elt, INPUT_SELECTOR)) return [
            {
                trigger: 'change'
            }
        ];
        else return [
            {
                trigger: 'click'
            }
        ];
    }
    /**
   * @param {Element} elt
   */ function cancelPolling(elt) {
        getInternalData(elt).cancelled = true;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxTriggerSpecification} spec
   */ function processPolling(elt, handler, spec) {
        const nodeData = getInternalData(elt);
        nodeData.timeout = getWindow().setTimeout(function() {
            if (bodyContains(elt) && nodeData.cancelled !== true) {
                if (!maybeFilterEvent(spec, elt, makeEvent('hx:poll:trigger', {
                    triggerSpec: spec,
                    target: elt
                }))) handler(elt);
                processPolling(elt, handler, spec);
            }
        }, spec.pollInterval);
    }
    /**
   * @param {HTMLAnchorElement} elt
   * @returns {boolean}
   */ function isLocalLink(elt) {
        return location.hostname === elt.hostname && getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') !== 0;
    }
    /**
   * @param {Element} elt
   */ function eltIsDisabled(elt) {
        return closest(elt, htmx.config.disableSelector);
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   */ function boostElement(elt, nodeData, triggerSpecs) {
        if (elt instanceof HTMLAnchorElement && isLocalLink(elt) && (elt.target === '' || elt.target === '_self') || elt.tagName === 'FORM' && String(getRawAttribute(elt, 'method')).toLowerCase() !== 'dialog') {
            nodeData.boosted = true;
            let verb, path;
            if (elt.tagName === 'A') {
                verb = /** @type HttpVerb */ 'get';
                path = getRawAttribute(elt, 'href');
            } else {
                const rawAttribute = getRawAttribute(elt, 'method');
                verb = /** @type HttpVerb */ rawAttribute ? rawAttribute.toLowerCase() : 'get';
                path = getRawAttribute(elt, 'action');
                if (path == null || path === '') // if there is no action attribute on the form set path to current href before the
                // following logic to properly clear parameters on a GET (not on a POST!)
                path = location.href;
                if (verb === 'get' && path.includes('?')) path = path.replace(/\?[^#]+/, '');
            }
            triggerSpecs.forEach(function(triggerSpec) {
                addEventListener(elt, function(node, evt) {
                    const elt = asElement(node);
                    if (eltIsDisabled(elt)) {
                        cleanUpElement(elt);
                        return;
                    }
                    issueAjaxRequest(verb, path, elt, evt);
                }, nodeData, triggerSpec, true);
            });
        }
    }
    /**
   * @param {Event} evt
   * @param {Element} elt
   * @returns {boolean}
   */ function shouldCancel(evt, elt) {
        if (evt.type === 'submit' || evt.type === 'click') {
            // use elt from event that was submitted/clicked where possible to determining if default form/link behavior should be canceled
            elt = asElement(evt.target) || elt;
            if (elt.tagName === 'FORM') return true;
            // @ts-ignore Do not cancel on buttons that 1) don't have a related form or 2) have a type attribute of 'reset'/'button'.
            // The properties will resolve to undefined for elements that don't define 'type' or 'form', which is fine
            if (elt.form && elt.type === 'submit') return true;
            elt = elt.closest('a');
            // @ts-ignore check for a link wrapping the event elt or if elt is a link. elt will be link so href check is fine
            if (elt && elt.href && (elt.getAttribute('href') === '#' || elt.getAttribute('href').indexOf('#') !== 0)) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @param {Event|MouseEvent|KeyboardEvent|TouchEvent} evt
   * @returns {boolean}
   */ function ignoreBoostedAnchorCtrlClick(elt, evt) {
        return getInternalData(elt).boosted && elt instanceof HTMLAnchorElement && evt.type === 'click' && // @ts-ignore this will resolve to undefined for events that don't define those properties, which is fine
        (evt.ctrlKey || evt.metaKey);
    }
    /**
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {Node} elt
   * @param {Event} evt
   * @returns {boolean}
   */ function maybeFilterEvent(triggerSpec, elt, evt) {
        const eventFilter = triggerSpec.eventFilter;
        if (eventFilter) try {
            return eventFilter.call(elt, evt) !== true;
        } catch (e) {
            const source = eventFilter.source;
            triggerErrorEvent(getDocument().body, 'htmx:eventFilter:error', {
                error: e,
                source: source
            });
            return true;
        }
        return false;
    }
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {boolean} [explicitCancel]
   */ function addEventListener(elt, handler, nodeData, triggerSpec, explicitCancel) {
        const elementData = getInternalData(elt);
        /** @type {(Node|Window)[]} */ let eltsToListenOn;
        if (triggerSpec.from) eltsToListenOn = querySelectorAllExt(elt, triggerSpec.from);
        else eltsToListenOn = [
            elt
        ];
        // store the initial values of the elements, so we can tell if they change
        if (triggerSpec.changed) {
            if (!('lastValue' in elementData)) elementData.lastValue = new WeakMap();
            eltsToListenOn.forEach(function(eltToListenOn) {
                if (!elementData.lastValue.has(triggerSpec)) elementData.lastValue.set(triggerSpec, new WeakMap());
                // @ts-ignore value will be undefined for non-input elements, which is fine
                elementData.lastValue.get(triggerSpec).set(eltToListenOn, eltToListenOn.value);
            });
        }
        forEach(eltsToListenOn, function(eltToListenOn) {
            /** @type EventListener */ const eventListener = function(evt) {
                if (!bodyContains(elt)) {
                    eltToListenOn.removeEventListener(triggerSpec.trigger, eventListener);
                    return;
                }
                if (ignoreBoostedAnchorCtrlClick(elt, evt)) return;
                if (explicitCancel || shouldCancel(evt, elt)) evt.preventDefault();
                if (maybeFilterEvent(triggerSpec, elt, evt)) return;
                const eventData = getInternalData(evt);
                eventData.triggerSpec = triggerSpec;
                if (eventData.handledFor == null) eventData.handledFor = [];
                if (eventData.handledFor.indexOf(elt) < 0) {
                    eventData.handledFor.push(elt);
                    if (triggerSpec.consume) evt.stopPropagation();
                    if (triggerSpec.target && evt.target) {
                        if (!matches(asElement(evt.target), triggerSpec.target)) return;
                    }
                    if (triggerSpec.once) {
                        if (elementData.triggeredOnce) return;
                        else elementData.triggeredOnce = true;
                    }
                    if (triggerSpec.changed) {
                        const node = evt.target;
                        // @ts-ignore value will be undefined for non-input elements, which is fine
                        const value = node.value;
                        const lastValue = elementData.lastValue.get(triggerSpec);
                        if (lastValue.has(node) && lastValue.get(node) === value) return;
                        lastValue.set(node, value);
                    }
                    if (elementData.delayed) clearTimeout(elementData.delayed);
                    if (elementData.throttle) return;
                    if (triggerSpec.throttle > 0) {
                        if (!elementData.throttle) {
                            triggerEvent(elt, 'htmx:trigger');
                            handler(elt, evt);
                            elementData.throttle = getWindow().setTimeout(function() {
                                elementData.throttle = null;
                            }, triggerSpec.throttle);
                        }
                    } else if (triggerSpec.delay > 0) elementData.delayed = getWindow().setTimeout(function() {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }, triggerSpec.delay);
                    else {
                        triggerEvent(elt, 'htmx:trigger');
                        handler(elt, evt);
                    }
                }
            };
            if (nodeData.listenerInfos == null) nodeData.listenerInfos = [];
            nodeData.listenerInfos.push({
                trigger: triggerSpec.trigger,
                listener: eventListener,
                on: eltToListenOn
            });
            eltToListenOn.addEventListener(triggerSpec.trigger, eventListener);
        });
    }
    let windowIsScrolling = false // used by initScrollHandler
    ;
    let scrollHandler = null;
    function initScrollHandler() {
        if (!scrollHandler) {
            scrollHandler = function() {
                windowIsScrolling = true;
            };
            window.addEventListener('scroll', scrollHandler);
            window.addEventListener('resize', scrollHandler);
            setInterval(function() {
                if (windowIsScrolling) {
                    windowIsScrolling = false;
                    forEach(getDocument().querySelectorAll("[hx-trigger*='revealed'],[data-hx-trigger*='revealed']"), function(elt) {
                        maybeReveal(elt);
                    });
                }
            }, 200);
        }
    }
    /**
   * @param {Element} elt
   */ function maybeReveal(elt) {
        if (!hasAttribute(elt, 'data-hx-revealed') && isScrolledIntoView(elt)) {
            elt.setAttribute('data-hx-revealed', 'true');
            const nodeData = getInternalData(elt);
            if (nodeData.initHash) triggerEvent(elt, 'revealed');
            else // if the node isn't initialized, wait for it before triggering the request
            elt.addEventListener('htmx:afterProcessNode', function() {
                triggerEvent(elt, 'revealed');
            }, {
                once: true
            });
        }
    }
    //= ===================================================================
    /**
   * @param {Element} elt
   * @param {TriggerHandler} handler
   * @param {HtmxNodeInternalData} nodeData
   * @param {number} delay
   */ function loadImmediately(elt, handler, nodeData, delay) {
        const load = function() {
            if (!nodeData.loaded) {
                nodeData.loaded = true;
                triggerEvent(elt, 'htmx:trigger');
                handler(elt);
            }
        };
        if (delay > 0) getWindow().setTimeout(load, delay);
        else load();
    }
    /**
   * @param {Element} elt
   * @param {HtmxNodeInternalData} nodeData
   * @param {HtmxTriggerSpecification[]} triggerSpecs
   * @returns {boolean}
   */ function processVerbs(elt, nodeData, triggerSpecs) {
        let explicitAction = false;
        forEach(VERBS, function(verb) {
            if (hasAttribute(elt, 'hx-' + verb)) {
                const path = getAttributeValue(elt, 'hx-' + verb);
                explicitAction = true;
                nodeData.path = path;
                nodeData.verb = verb;
                triggerSpecs.forEach(function(triggerSpec) {
                    addTriggerHandler(elt, triggerSpec, nodeData, function(node, evt) {
                        const elt = asElement(node);
                        if (eltIsDisabled(elt)) {
                            cleanUpElement(elt);
                            return;
                        }
                        issueAjaxRequest(verb, path, elt, evt);
                    });
                });
            }
        });
        return explicitAction;
    }
    /**
   * @callback TriggerHandler
   * @param {Element} elt
   * @param {Event} [evt]
   */ /**
   * @param {Element} elt
   * @param {HtmxTriggerSpecification} triggerSpec
   * @param {HtmxNodeInternalData} nodeData
   * @param {TriggerHandler} handler
   */ function addTriggerHandler(elt, triggerSpec, nodeData, handler) {
        if (triggerSpec.trigger === 'revealed') {
            initScrollHandler();
            addEventListener(elt, handler, nodeData, triggerSpec);
            maybeReveal(asElement(elt));
        } else if (triggerSpec.trigger === 'intersect') {
            const observerOptions = {};
            if (triggerSpec.root) observerOptions.root = querySelectorExt(elt, triggerSpec.root);
            if (triggerSpec.threshold) observerOptions.threshold = parseFloat(triggerSpec.threshold);
            const observer = new IntersectionObserver(function(entries) {
                for(let i = 0; i < entries.length; i++){
                    const entry = entries[i];
                    if (entry.isIntersecting) {
                        triggerEvent(elt, 'intersect');
                        break;
                    }
                }
            }, observerOptions);
            observer.observe(asElement(elt));
            addEventListener(asElement(elt), handler, nodeData, triggerSpec);
        } else if (!nodeData.firstInitCompleted && triggerSpec.trigger === 'load') {
            if (!maybeFilterEvent(triggerSpec, elt, makeEvent('load', {
                elt: elt
            }))) loadImmediately(asElement(elt), handler, nodeData, triggerSpec.delay);
        } else if (triggerSpec.pollInterval > 0) {
            nodeData.polling = true;
            processPolling(asElement(elt), handler, triggerSpec);
        } else addEventListener(elt, handler, nodeData, triggerSpec);
    }
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function shouldProcessHxOn(node) {
        const elt = asElement(node);
        if (!elt) return false;
        const attributes = elt.attributes;
        for(let j = 0; j < attributes.length; j++){
            const attrName = attributes[j].name;
            if (startsWith(attrName, 'hx-on:') || startsWith(attrName, 'data-hx-on:') || startsWith(attrName, 'hx-on-') || startsWith(attrName, 'data-hx-on-')) return true;
        }
        return false;
    }
    /**
   * @param {Node} elt
   * @returns {Element[]}
   */ const HX_ON_QUERY = new XPathEvaluator().createExpression('.//*[@*[ starts-with(name(), "hx-on:") or starts-with(name(), "data-hx-on:") or starts-with(name(), "hx-on-") or starts-with(name(), "data-hx-on-") ]]');
    function processHXOnRoot(elt, elements) {
        if (shouldProcessHxOn(elt)) elements.push(asElement(elt));
        const iter = HX_ON_QUERY.evaluate(elt);
        let node = null;
        while(node = iter.iterateNext())elements.push(asElement(node));
    }
    function findHxOnWildcardElements(elt) {
        /** @type {Element[]} */ const elements = [];
        if (elt instanceof DocumentFragment) for (const child of elt.childNodes)processHXOnRoot(child, elements);
        else processHXOnRoot(elt, elements);
        return elements;
    }
    /**
   * @param {Element} elt
   * @returns {NodeListOf<Element>|[]}
   */ function findElementsToProcess(elt) {
        if (elt.querySelectorAll) {
            const boostedSelector = ', [hx-boost] a, [data-hx-boost] a, a[hx-boost], a[data-hx-boost]';
            const extensionSelectors = [];
            for(const e in extensions){
                const extension = extensions[e];
                if (extension.getSelectors) {
                    var selectors = extension.getSelectors();
                    if (selectors) extensionSelectors.push(selectors);
                }
            }
            const results = elt.querySelectorAll(VERB_SELECTOR + boostedSelector + ", form, [type='submit']," + ' [hx-ext], [data-hx-ext], [hx-trigger], [data-hx-trigger]' + extensionSelectors.flat().map((s)=>', ' + s).join(''));
            return results;
        } else return [];
    }
    /**
   * Handle submit buttons/inputs that have the form attribute set
   * see https://developer.mozilla.org/docs/Web/HTML/Element/button
   * @param {Event} evt
   */ function maybeSetLastButtonClicked(evt) {
        const elt = getTargetButton(evt.target);
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = elt;
    }
    /**
   * @param {Event} evt
   */ function maybeUnsetLastButtonClicked(evt) {
        const internalData = getRelatedFormData(evt);
        if (internalData) internalData.lastButtonClicked = null;
    }
    /**
   * @param {EventTarget} target
   * @returns {HTMLButtonElement|HTMLInputElement|null}
   */ function getTargetButton(target) {
        return /** @type {HTMLButtonElement|HTMLInputElement|null} */ closest(asElement(target), "button, input[type='submit']");
    }
    /**
   * @param {Element} elt
   * @returns {HTMLFormElement|null}
   */ function getRelatedForm(elt) {
        // @ts-ignore Get the related form if available, else find the closest parent form
        return elt.form || closest(elt, 'form');
    }
    /**
   * @param {Event} evt
   * @returns {HtmxNodeInternalData|undefined}
   */ function getRelatedFormData(evt) {
        const elt = getTargetButton(evt.target);
        if (!elt) return;
        const form = getRelatedForm(elt);
        return getInternalData(form);
    }
    /**
   * @param {EventTarget} elt
   */ function initButtonTracking(elt) {
        // need to handle both click and focus in:
        //   focusin - in case someone tabs in to a button and hits the space bar
        //   click - on OSX buttons do not focus on click see https://bugs.webkit.org/show_bug.cgi?id=13724
        elt.addEventListener('click', maybeSetLastButtonClicked);
        elt.addEventListener('focusin', maybeSetLastButtonClicked);
        elt.addEventListener('focusout', maybeUnsetLastButtonClicked);
    }
    /**
   * @param {Element} elt
   * @param {string} eventName
   * @param {string} code
   */ function addHxOnEventHandler(elt, eventName, code) {
        const nodeData = getInternalData(elt);
        if (!Array.isArray(nodeData.onHandlers)) nodeData.onHandlers = [];
        let func;
        /** @type EventListener */ const listener = function(e) {
            maybeEval(elt, function() {
                if (eltIsDisabled(elt)) return;
                if (!func) func = new Function('event', code);
                func.call(elt, e);
            });
        };
        elt.addEventListener(eventName, listener);
        nodeData.onHandlers.push({
            event: eventName,
            listener: listener
        });
    }
    /**
   * @param {Element} elt
   */ function processHxOnWildcard(elt) {
        // wipe any previous on handlers so that this function takes precedence
        deInitOnHandlers(elt);
        for(let i = 0; i < elt.attributes.length; i++){
            const name = elt.attributes[i].name;
            const value = elt.attributes[i].value;
            if (startsWith(name, 'hx-on') || startsWith(name, 'data-hx-on')) {
                const afterOnPosition = name.indexOf('-on') + 3;
                const nextChar = name.slice(afterOnPosition, afterOnPosition + 1);
                if (nextChar === '-' || nextChar === ':') {
                    let eventName = name.slice(afterOnPosition + 1);
                    // if the eventName starts with a colon or dash, prepend "htmx" for shorthand support
                    if (startsWith(eventName, ':')) eventName = 'htmx' + eventName;
                    else if (startsWith(eventName, '-')) eventName = 'htmx:' + eventName.slice(1);
                    else if (startsWith(eventName, 'htmx-')) eventName = 'htmx:' + eventName.slice(5);
                    addHxOnEventHandler(elt, eventName, value);
                }
            }
        }
    }
    /**
   * @param {Element|HTMLInputElement} elt
   */ function initNode(elt) {
        triggerEvent(elt, 'htmx:beforeProcessNode');
        const nodeData = getInternalData(elt);
        const triggerSpecs = getTriggerSpecs(elt);
        const hasExplicitHttpAction = processVerbs(elt, nodeData, triggerSpecs);
        if (!hasExplicitHttpAction) {
            if (getClosestAttributeValue(elt, 'hx-boost') === 'true') boostElement(elt, nodeData, triggerSpecs);
            else if (hasAttribute(elt, 'hx-trigger')) triggerSpecs.forEach(function(triggerSpec) {
                // For "naked" triggers, don't do anything at all
                addTriggerHandler(elt, triggerSpec, nodeData, function() {});
            });
        }
        // Handle submit buttons/inputs that have the form attribute set
        // see https://developer.mozilla.org/docs/Web/HTML/Element/button
        if (elt.tagName === 'FORM' || getRawAttribute(elt, 'type') === 'submit' && hasAttribute(elt, 'form')) initButtonTracking(elt);
        nodeData.firstInitCompleted = true;
        triggerEvent(elt, 'htmx:afterProcessNode');
    }
    /**
   * @param {Element} elt
   * @returns {boolean}
   */ function maybeDeInitAndHash(elt) {
        // Ensure only valid Elements and not shadow DOM roots are inited
        if (!(elt instanceof Element)) return false;
        const nodeData = getInternalData(elt);
        const hash = attributeHash(elt);
        if (nodeData.initHash !== hash) {
            deInitNode(elt);
            nodeData.initHash = hash;
            return true;
        }
        return false;
    }
    /**
   * Processes new content, enabling htmx behavior. This can be useful if you have content that is added to the DOM outside of the normal htmx request cycle but still want htmx attributes to work.
   *
   * @see https://htmx.org/api/#process
   *
   * @param {Element|string} elt element to process
   */ function processNode(elt) {
        elt = resolveTarget(elt);
        if (eltIsDisabled(elt)) {
            cleanUpElement(elt);
            return;
        }
        const elementsToInit = [];
        if (maybeDeInitAndHash(elt)) elementsToInit.push(elt);
        forEach(findElementsToProcess(elt), function(child) {
            if (eltIsDisabled(child)) {
                cleanUpElement(child);
                return;
            }
            if (maybeDeInitAndHash(child)) elementsToInit.push(child);
        });
        forEach(findHxOnWildcardElements(elt), processHxOnWildcard);
        forEach(elementsToInit, initNode);
    }
    //= ===================================================================
    // Event/Log Support
    //= ===================================================================
    /**
   * @param {string} str
   * @returns {string}
   */ function kebabEventName(str) {
        return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    }
    /**
   * @param {string} eventName
   * @param {any} detail
   * @returns {CustomEvent}
   */ function makeEvent(eventName, detail) {
        // TODO: `composed: true` here is a hack to make global event handlers work with events in shadow DOM
        // This breaks expected encapsulation but needs to be here until decided otherwise by core devs
        return new CustomEvent(eventName, {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: detail
        });
    }
    /**
   * @param {EventTarget|string} elt
   * @param {string} eventName
   * @param {any=} detail
   */ function triggerErrorEvent(elt, eventName, detail) {
        triggerEvent(elt, eventName, mergeObjects({
            error: eventName
        }, detail));
    }
    /**
   * @param {string} eventName
   * @returns {boolean}
   */ function ignoreEventForLogging(eventName) {
        return eventName === 'htmx:afterProcessNode';
    }
    /**
   * `withExtensions` locates all active extensions for a provided element, then
   * executes the provided function using each of the active extensions. You can filter
   * the element's extensions by giving it a list of extensions to ignore. It should
   * be called internally at every extendable execution point in htmx.
   *
   * @param {Element} elt
   * @param {(extension:HtmxExtension) => void} toDo
   * @param {string[]=} extensionsToIgnore
   * @returns void
   */ function withExtensions(elt, toDo, extensionsToIgnore) {
        forEach(getExtensions(elt, [], extensionsToIgnore), function(extension) {
            try {
                toDo(extension);
            } catch (e) {
                logError(e);
            }
        });
    }
    function logError(msg) {
        console.error(msg);
    }
    /**
   * Triggers a given event on an element
   *
   * @see https://htmx.org/api/#trigger
   *
   * @param {EventTarget|string} elt the element to trigger the event on
   * @param {string} eventName the name of the event to trigger
   * @param {any=} detail details for the event
   * @returns {boolean}
   */ function triggerEvent(elt, eventName, detail) {
        elt = resolveTarget(elt);
        if (detail == null) detail = {};
        detail.elt = elt;
        const event = makeEvent(eventName, detail);
        if (htmx.logger && !ignoreEventForLogging(eventName)) htmx.logger(elt, eventName, detail);
        if (detail.error) {
            logError(detail.error);
            triggerEvent(elt, 'htmx:error', {
                errorInfo: detail
            });
        }
        let eventResult = elt.dispatchEvent(event);
        const kebabName = kebabEventName(eventName);
        if (eventResult && kebabName !== eventName) {
            const kebabedEvent = makeEvent(kebabName, event.detail);
            eventResult = eventResult && elt.dispatchEvent(kebabedEvent);
        }
        withExtensions(asElement(elt), function(extension) {
            eventResult = eventResult && extension.onEvent(eventName, event) !== false && !event.defaultPrevented;
        });
        return eventResult;
    }
    //= ===================================================================
    // History Support
    //= ===================================================================
    let currentPathForHistory = location.pathname + location.search;
    /**
   * @param {string} path
   */ function setCurrentPathForHistory(path) {
        currentPathForHistory = path;
        if (canAccessLocalStorage()) sessionStorage.setItem('htmx-current-path-for-history', path);
    }
    /**
   * @returns {Element}
   */ function getHistoryElement() {
        const historyElt = getDocument().querySelector('[hx-history-elt],[data-hx-history-elt]');
        return historyElt || getDocument().body;
    }
    /**
   * @param {string} url
   * @param {Element} rootElt
   */ function saveToHistoryCache(url, rootElt) {
        if (!canAccessLocalStorage()) return;
        // get state to save
        const innerHTML = cleanInnerHtmlForHistory(rootElt);
        const title = getDocument().title;
        const scroll = window.scrollY;
        if (htmx.config.historyCacheSize <= 0) {
            // make sure that an eventually already existing cache is purged
            sessionStorage.removeItem('htmx-history-cache');
            return;
        }
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++)if (historyCache[i].url === url) {
            historyCache.splice(i, 1);
            break;
        }
        /** @type HtmxHistoryItem */ const newHistoryItem = {
            url: url,
            content: innerHTML,
            title: title,
            scroll: scroll
        };
        triggerEvent(getDocument().body, 'htmx:historyItemCreated', {
            item: newHistoryItem,
            cache: historyCache
        });
        historyCache.push(newHistoryItem);
        while(historyCache.length > htmx.config.historyCacheSize)historyCache.shift();
        // keep trying to save the cache until it succeeds or is empty
        while(historyCache.length > 0)try {
            sessionStorage.setItem('htmx-history-cache', JSON.stringify(historyCache));
            break;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:historyCacheError', {
                cause: e,
                cache: historyCache
            });
            historyCache.shift() // shrink the cache and retry
            ;
        }
    }
    /**
   * @typedef {Object} HtmxHistoryItem
   * @property {string} url
   * @property {string} content
   * @property {string} title
   * @property {number} scroll
   */ /**
   * @param {string} url
   * @returns {HtmxHistoryItem|null}
   */ function getCachedHistory(url) {
        if (!canAccessLocalStorage()) return null;
        url = normalizePath(url);
        const historyCache = parseJSON(sessionStorage.getItem('htmx-history-cache')) || [];
        for(let i = 0; i < historyCache.length; i++){
            if (historyCache[i].url === url) return historyCache[i];
        }
        return null;
    }
    /**
   * @param {Element} elt
   * @returns {string}
   */ function cleanInnerHtmlForHistory(elt) {
        const className = htmx.config.requestClass;
        const clone = /** @type Element */ elt.cloneNode(true);
        forEach(findAll(clone, '.' + className), function(child) {
            removeClassFromElement(child, className);
        });
        // remove the disabled attribute for any element disabled due to an htmx request
        forEach(findAll(clone, '[data-disabled-by-htmx]'), function(child) {
            child.removeAttribute('disabled');
        });
        return clone.innerHTML;
    }
    function saveCurrentPageToHistory() {
        const elt = getHistoryElement();
        let path = currentPathForHistory;
        if (canAccessLocalStorage()) path = sessionStorage.getItem('htmx-current-path-for-history');
        path = path || location.pathname + location.search;
        // Allow history snapshot feature to be disabled where hx-history="false"
        // is present *anywhere* in the current document we're about to save,
        // so we can prevent privileged data entering the cache.
        // The page will still be reachable as a history entry, but htmx will fetch it
        // live from the server onpopstate rather than look in the sessionStorage cache
        const disableHistoryCache = getDocument().querySelector('[hx-history="false" i],[data-hx-history="false" i]');
        if (!disableHistoryCache) {
            triggerEvent(getDocument().body, 'htmx:beforeHistorySave', {
                path: path,
                historyElt: elt
            });
            saveToHistoryCache(path, elt);
        }
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, getDocument().title, location.href);
    }
    /**
   * @param {string} path
   */ function pushUrlIntoHistory(path) {
        // remove the cache buster parameter, if any
        if (htmx.config.getCacheBusterParam) {
            path = path.replace(/org\.htmx\.cache-buster=[^&]*&?/, '');
            if (endsWith(path, '&') || endsWith(path, '?')) path = path.slice(0, -1);
        }
        if (htmx.config.historyEnabled) history.pushState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {string} path
   */ function replaceUrlInHistory(path) {
        if (htmx.config.historyEnabled) history.replaceState({
            htmx: true
        }, '', path);
        setCurrentPathForHistory(path);
    }
    /**
   * @param {HtmxSettleTask[]} tasks
   */ function settleImmediately(tasks) {
        forEach(tasks, function(task) {
            task.call(undefined);
        });
    }
    /**
   * @param {string} path
   */ function loadHistoryFromServer(path) {
        const request = new XMLHttpRequest();
        const swapSpec = {
            swapStyle: 'innerHTML',
            swapDelay: 0,
            settleDelay: 0
        };
        const details = {
            path: path,
            xhr: request,
            historyElt: getHistoryElement(),
            swapSpec: swapSpec
        };
        request.open('GET', path, true);
        if (htmx.config.historyRestoreAsHxRequest) request.setRequestHeader('HX-Request', 'true');
        request.setRequestHeader('HX-History-Restore-Request', 'true');
        request.setRequestHeader('HX-Current-URL', location.href);
        request.onload = function() {
            if (this.status >= 200 && this.status < 400) {
                details.response = this.response;
                triggerEvent(getDocument().body, 'htmx:historyCacheMissLoad', details);
                swap(details.historyElt, details.response, swapSpec, {
                    contextElement: details.historyElt,
                    historyRequest: true
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', {
                    path: path,
                    cacheMiss: true,
                    serverResponse: details.response
                });
            } else triggerErrorEvent(getDocument().body, 'htmx:historyCacheMissLoadError', details);
        };
        if (triggerEvent(getDocument().body, 'htmx:historyCacheMiss', details)) request.send() // only send request if event not prevented
        ;
    }
    /**
   * @param {string} [path]
   */ function restoreHistory(path) {
        saveCurrentPageToHistory();
        path = path || location.pathname + location.search;
        const cached = getCachedHistory(path);
        if (cached) {
            const swapSpec = {
                swapStyle: 'innerHTML',
                swapDelay: 0,
                settleDelay: 0,
                scroll: cached.scroll
            };
            const details = {
                path: path,
                item: cached,
                historyElt: getHistoryElement(),
                swapSpec: swapSpec
            };
            if (triggerEvent(getDocument().body, 'htmx:historyCacheHit', details)) {
                swap(details.historyElt, cached.content, swapSpec, {
                    contextElement: details.historyElt,
                    title: cached.title
                });
                setCurrentPathForHistory(details.path);
                triggerEvent(getDocument().body, 'htmx:historyRestore', details);
            }
        } else if (htmx.config.refreshOnHistoryMiss) // @ts-ignore: optional parameter in reload() function throws error
        // noinspection JSUnresolvedReference
        htmx.location.reload(true);
        else loadHistoryFromServer(path);
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function addRequestIndicatorClasses(elt) {
        let indicators = /** @type Element[] */ findAttributeTargets(elt, 'hx-indicator');
        if (indicators == null) indicators = [
            elt
        ];
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            ic.classList.add.call(ic.classList, htmx.config.requestClass);
        });
        return indicators;
    }
    /**
   * @param {Element} elt
   * @returns {Element[]}
   */ function disableElements(elt) {
        let disabledElts = /** @type Element[] */ findAttributeTargets(elt, 'hx-disabled-elt');
        if (disabledElts == null) disabledElts = [];
        forEach(disabledElts, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            internalData.requestCount = (internalData.requestCount || 0) + 1;
            disabledElement.setAttribute('disabled', '');
            disabledElement.setAttribute('data-disabled-by-htmx', '');
        });
        return disabledElts;
    }
    /**
   * @param {Element[]} indicators
   * @param {Element[]} disabled
   */ function removeRequestIndicators(indicators, disabled) {
        forEach(indicators.concat(disabled), function(ele) {
            const internalData = getInternalData(ele);
            internalData.requestCount = (internalData.requestCount || 1) - 1;
        });
        forEach(indicators, function(ic) {
            const internalData = getInternalData(ic);
            if (internalData.requestCount === 0) ic.classList.remove.call(ic.classList, htmx.config.requestClass);
        });
        forEach(disabled, function(disabledElement) {
            const internalData = getInternalData(disabledElement);
            if (internalData.requestCount === 0) {
                disabledElement.removeAttribute('disabled');
                disabledElement.removeAttribute('data-disabled-by-htmx');
            }
        });
    }
    //= ===================================================================
    // Input Value Processing
    //= ===================================================================
    /**
   * @param {Element[]} processed
   * @param {Element} elt
   * @returns {boolean}
   */ function haveSeenNode(processed, elt) {
        for(let i = 0; i < processed.length; i++){
            const node = processed[i];
            if (node.isSameNode(elt)) return true;
        }
        return false;
    }
    /**
   * @param {Element} element
   * @return {boolean}
   */ function shouldInclude(element) {
        // Cast to trick tsc, undefined values will work fine here
        const elt = /** @type {HTMLInputElement} */ element;
        if (elt.name === '' || elt.name == null || elt.disabled || closest(elt, 'fieldset[disabled]')) return false;
        // ignore "submitter" types (see jQuery src/serialize.js)
        if (elt.type === 'button' || elt.type === 'submit' || elt.tagName === 'image' || elt.tagName === 'reset' || elt.tagName === 'file') return false;
        if (elt.type === 'checkbox' || elt.type === 'radio') return elt.checked;
        return true;
    }
    /**
   * @param {string} name
   * @param {string|Array|FormDataEntryValue} value
   * @param {FormData} formData */ function addValueToFormData(name, value, formData) {
        if (name != null && value != null) {
            if (Array.isArray(value)) value.forEach(function(v) {
                formData.append(name, v);
            });
            else formData.append(name, value);
        }
    }
    /**
   * @param {string} name
   * @param {string|Array} value
   * @param {FormData} formData */ function removeValueFromFormData(name, value, formData) {
        if (name != null && value != null) {
            let values = formData.getAll(name);
            if (Array.isArray(value)) values = values.filter((v)=>value.indexOf(v) < 0);
            else values = values.filter((v)=>v !== value);
            formData.delete(name);
            forEach(values, (v)=>formData.append(name, v));
        }
    }
    /**
   * @param {Element} elt
   * @returns {string|Array}
   */ function getValueFromInput(elt) {
        if (elt instanceof HTMLSelectElement && elt.multiple) return toArray(elt.querySelectorAll('option:checked')).map(function(e) {
            return /** @type HTMLOptionElement */ e.value;
        });
        // include file inputs
        if (elt instanceof HTMLInputElement && elt.files) return toArray(elt.files);
        // @ts-ignore value will be undefined for non-input elements, which is fine
        return elt.value;
    }
    /**
   * @param {Element[]} processed
   * @param {FormData} formData
   * @param {HtmxElementValidationError[]} errors
   * @param {Element|HTMLInputElement|HTMLSelectElement|HTMLFormElement} elt
   * @param {boolean} validate
   */ function processInputValue(processed, formData, errors, elt, validate) {
        if (elt == null || haveSeenNode(processed, elt)) return;
        else processed.push(elt);
        if (shouldInclude(elt)) {
            const name = getRawAttribute(elt, 'name');
            addValueToFormData(name, getValueFromInput(elt), formData);
            if (validate) validateElement(elt, errors);
        }
        if (elt instanceof HTMLFormElement) {
            forEach(elt.elements, function(input) {
                if (processed.indexOf(input) >= 0) // The input has already been processed and added to the values, but the FormData that will be
                //  constructed right after on the form, will include it once again. So remove that input's value
                //  now to avoid duplicates
                removeValueFromFormData(input.name, getValueFromInput(input), formData);
                else processed.push(input);
                if (validate) validateElement(input, errors);
            });
            new FormData(elt).forEach(function(value, name) {
                if (value instanceof File && value.name === '') return; // ignore no-name files
                addValueToFormData(name, value, formData);
            });
        }
    }
    /**
   * @param {Element} elt
   * @param {HtmxElementValidationError[]} errors
   */ function validateElement(elt, errors) {
        const element = /** @type {HTMLElement & ElementInternals} */ elt;
        if (element.willValidate) {
            triggerEvent(element, 'htmx:validation:validate');
            if (!element.checkValidity()) {
                errors.push({
                    elt: element,
                    message: element.validationMessage,
                    validity: element.validity
                });
                triggerEvent(element, 'htmx:validation:failed', {
                    message: element.validationMessage,
                    validity: element.validity
                });
            }
        }
    }
    /**
   * Override values in the one FormData with those from another.
   * @param {FormData} receiver the formdata that will be mutated
   * @param {FormData} donor the formdata that will provide the overriding values
   * @returns {FormData} the {@linkcode receiver}
   */ function overrideFormData(receiver, donor) {
        for (const key of donor.keys())receiver.delete(key);
        donor.forEach(function(value, key) {
            receiver.append(key, value);
        });
        return receiver;
    }
    /**
 * @param {Element|HTMLFormElement} elt
 * @param {HttpVerb} verb
 * @returns {{errors: HtmxElementValidationError[], formData: FormData, values: Object}}
 */ function getInputValues(elt, verb) {
        /** @type Element[] */ const processed = [];
        const formData = new FormData();
        const priorityFormData = new FormData();
        /** @type HtmxElementValidationError[] */ const errors = [];
        const internalData = getInternalData(elt);
        if (internalData.lastButtonClicked && !bodyContains(internalData.lastButtonClicked)) internalData.lastButtonClicked = null;
        // only validate when form is directly submitted and novalidate or formnovalidate are not set
        // or if the element has an explicit hx-validate="true" on it
        let validate = elt instanceof HTMLFormElement && elt.noValidate !== true || getAttributeValue(elt, 'hx-validate') === 'true';
        if (internalData.lastButtonClicked) validate = validate && internalData.lastButtonClicked.formNoValidate !== true;
        // for a non-GET include the related form, which may or may not be a parent element of elt
        if (verb !== 'get') processInputValue(processed, priorityFormData, errors, getRelatedForm(elt), validate);
        // include the element itself
        processInputValue(processed, formData, errors, elt, validate);
        // if a button or submit was clicked last, include its value
        if (internalData.lastButtonClicked || elt.tagName === 'BUTTON' || elt.tagName === 'INPUT' && getRawAttribute(elt, 'type') === 'submit') {
            const button = internalData.lastButtonClicked || /** @type HTMLInputElement|HTMLButtonElement */ elt;
            const name = getRawAttribute(button, 'name');
            addValueToFormData(name, button.value, priorityFormData);
        }
        // include any explicit includes
        const includes = findAttributeTargets(elt, 'hx-include');
        forEach(includes, function(node) {
            processInputValue(processed, formData, errors, asElement(node), validate);
            // if a non-form is included, include any input values within it
            if (!matches(node, 'form')) forEach(asParentNode(node).querySelectorAll(INPUT_SELECTOR), function(descendant) {
                processInputValue(processed, formData, errors, descendant, validate);
            });
        });
        // values from a <form> take precedence, overriding the regular values
        overrideFormData(formData, priorityFormData);
        return {
            errors: errors,
            formData: formData,
            values: formDataProxy(formData)
        };
    }
    /**
   * @param {string} returnStr
   * @param {string} name
   * @param {any} realValue
   * @returns {string}
   */ function appendParam(returnStr, name, realValue) {
        if (returnStr !== '') returnStr += '&';
        if (String(realValue) === '[object Object]') realValue = JSON.stringify(realValue);
        const s = encodeURIComponent(realValue);
        returnStr += encodeURIComponent(name) + '=' + s;
        return returnStr;
    }
    /**
   * @param {FormData|Object} values
   * @returns string
   */ function urlEncode(values) {
        values = formDataFromObject(values);
        let returnStr = '';
        values.forEach(function(value, key) {
            returnStr = appendParam(returnStr, key, value);
        });
        return returnStr;
    }
    //= ===================================================================
    // Ajax
    //= ===================================================================
    /**
 * @param {Element} elt
 * @param {Element} target
 * @param {string} prompt
 * @returns {HtmxHeaderSpecification}
 */ function getHeaders(elt, target, prompt1) {
        /** @type HtmxHeaderSpecification */ const headers = {
            'HX-Request': 'true',
            'HX-Trigger': getRawAttribute(elt, 'id'),
            'HX-Trigger-Name': getRawAttribute(elt, 'name'),
            'HX-Target': getAttributeValue(target, 'id'),
            'HX-Current-URL': location.href
        };
        getValuesForElement(elt, 'hx-headers', false, headers);
        if (prompt1 !== undefined) headers['HX-Prompt'] = prompt1;
        if (getInternalData(elt).boosted) headers['HX-Boosted'] = 'true';
        return headers;
    }
    /**
 * filterValues takes an object containing form input values
 * and returns a new object that only contains keys that are
 * specified by the closest "hx-params" attribute
 * @param {FormData} inputValues
 * @param {Element} elt
 * @returns {FormData}
 */ function filterValues(inputValues, elt) {
        const paramsValue = getClosestAttributeValue(elt, 'hx-params');
        if (paramsValue) {
            if (paramsValue === 'none') return new FormData();
            else if (paramsValue === '*') return inputValues;
            else if (paramsValue.indexOf('not ') === 0) {
                forEach(paramsValue.slice(4).split(','), function(name) {
                    name = name.trim();
                    inputValues.delete(name);
                });
                return inputValues;
            } else {
                const newValues = new FormData();
                forEach(paramsValue.split(','), function(name) {
                    name = name.trim();
                    if (inputValues.has(name)) inputValues.getAll(name).forEach(function(value) {
                        newValues.append(name, value);
                    });
                });
                return newValues;
            }
        } else return inputValues;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function isAnchorLink(elt) {
        return !!getRawAttribute(elt, 'href') && getRawAttribute(elt, 'href').indexOf('#') >= 0;
    }
    /**
 * @param {Element} elt
 * @param {HtmxSwapStyle} [swapInfoOverride]
 * @returns {HtmxSwapSpecification}
 */ function getSwapSpecification(elt, swapInfoOverride) {
        const swapInfo = swapInfoOverride || getClosestAttributeValue(elt, 'hx-swap');
        /** @type HtmxSwapSpecification */ const swapSpec = {
            swapStyle: getInternalData(elt).boosted ? 'innerHTML' : htmx.config.defaultSwapStyle,
            swapDelay: htmx.config.defaultSwapDelay,
            settleDelay: htmx.config.defaultSettleDelay
        };
        if (htmx.config.scrollIntoViewOnBoost && getInternalData(elt).boosted && !isAnchorLink(elt)) swapSpec.show = 'top';
        if (swapInfo) {
            const split = splitOnWhitespace(swapInfo);
            if (split.length > 0) for(let i = 0; i < split.length; i++){
                const value = split[i];
                if (value.indexOf('swap:') === 0) swapSpec.swapDelay = parseInterval(value.slice(5));
                else if (value.indexOf('settle:') === 0) swapSpec.settleDelay = parseInterval(value.slice(7));
                else if (value.indexOf('transition:') === 0) swapSpec.transition = value.slice(11) === 'true';
                else if (value.indexOf('ignoreTitle:') === 0) swapSpec.ignoreTitle = value.slice(12) === 'true';
                else if (value.indexOf('scroll:') === 0) {
                    const scrollSpec = value.slice(7);
                    var splitSpec = scrollSpec.split(':');
                    const scrollVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    // @ts-ignore
                    swapSpec.scroll = scrollVal;
                    swapSpec.scrollTarget = selectorVal;
                } else if (value.indexOf('show:') === 0) {
                    const showSpec = value.slice(5);
                    var splitSpec = showSpec.split(':');
                    const showVal = splitSpec.pop();
                    var selectorVal = splitSpec.length > 0 ? splitSpec.join(':') : null;
                    swapSpec.show = showVal;
                    swapSpec.showTarget = selectorVal;
                } else if (value.indexOf('focus-scroll:') === 0) {
                    const focusScrollVal = value.slice(13);
                    swapSpec.focusScroll = focusScrollVal == 'true';
                } else if (i == 0) swapSpec.swapStyle = value;
                else logError('Unknown modifier in hx-swap: ' + value);
            }
        }
        return swapSpec;
    }
    /**
   * @param {Element} elt
   * @return {boolean}
   */ function usesFormData(elt) {
        return getClosestAttributeValue(elt, 'hx-encoding') === 'multipart/form-data' || matches(elt, 'form') && getRawAttribute(elt, 'enctype') === 'multipart/form-data';
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {Element} elt
   * @param {FormData} filteredParameters
   * @returns {*|string|null}
   */ function encodeParamsForBody(xhr, elt, filteredParameters) {
        let encodedParameters = null;
        withExtensions(elt, function(extension) {
            if (encodedParameters == null) encodedParameters = extension.encodeParameters(xhr, filteredParameters, elt);
        });
        if (encodedParameters != null) return encodedParameters;
        else {
            if (usesFormData(elt)) // Force conversion to an actual FormData object in case filteredParameters is a formDataProxy
            // See https://github.com/bigskysoftware/htmx/issues/2317
            return overrideFormData(new FormData(), formDataFromObject(filteredParameters));
            else return urlEncode(filteredParameters);
        }
    }
    /**
 *
 * @param {Element} target
 * @returns {HtmxSettleInfo}
 */ function makeSettleInfo(target) {
        return {
            tasks: [],
            elts: [
                target
            ]
        };
    }
    /**
   * @param {Element[]} content
   * @param {HtmxSwapSpecification} swapSpec
   */ function updateScrollState(content, swapSpec) {
        const first = content[0];
        const last = content[content.length - 1];
        if (swapSpec.scroll) {
            var target = null;
            if (swapSpec.scrollTarget) target = asElement(querySelectorExt(first, swapSpec.scrollTarget));
            if (swapSpec.scroll === 'top' && (first || target)) {
                target = target || first;
                target.scrollTop = 0;
            }
            if (swapSpec.scroll === 'bottom' && (last || target)) {
                target = target || last;
                target.scrollTop = target.scrollHeight;
            }
            if (typeof swapSpec.scroll === 'number') getWindow().setTimeout(function() {
                window.scrollTo(0, /** @type number */ swapSpec.scroll);
            }, 0) // next 'tick', so browser has time to render layout
            ;
        }
        if (swapSpec.show) {
            var target = null;
            if (swapSpec.showTarget) {
                let targetStr = swapSpec.showTarget;
                if (swapSpec.showTarget === 'window') targetStr = 'body';
                target = asElement(querySelectorExt(first, targetStr));
            }
            if (swapSpec.show === 'top' && (first || target)) {
                target = target || first;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'start',
                    behavior: htmx.config.scrollBehavior
                });
            }
            if (swapSpec.show === 'bottom' && (last || target)) {
                target = target || last;
                // @ts-ignore For some reason tsc doesn't recognize "instant" as a valid option for now
                target.scrollIntoView({
                    block: 'end',
                    behavior: htmx.config.scrollBehavior
                });
            }
        }
    }
    /**
 * @param {Element} elt
 * @param {string} attr
 * @param {boolean=} evalAsDefault
 * @param {Object=} values
 * @param {Event=} event
 * @returns {Object}
 */ function getValuesForElement(elt, attr, evalAsDefault, values, event) {
        if (values == null) values = {};
        if (elt == null) return values;
        const attributeValue = getAttributeValue(elt, attr);
        if (attributeValue) {
            let str = attributeValue.trim();
            let evaluateValue = evalAsDefault;
            if (str === 'unset') return null;
            if (str.indexOf('javascript:') === 0) {
                str = str.slice(11);
                evaluateValue = true;
            } else if (str.indexOf('js:') === 0) {
                str = str.slice(3);
                evaluateValue = true;
            }
            if (str.indexOf('{') !== 0) str = '{' + str + '}';
            let varsValues;
            if (evaluateValue) varsValues = maybeEval(elt, function() {
                if (event) return Function('event', 'return (' + str + ')').call(elt, event);
                else return Function('return (' + str + ')').call(elt);
            }, {});
            else varsValues = parseJSON(str);
            for(const key in varsValues){
                if (varsValues.hasOwnProperty(key)) {
                    if (values[key] == null) values[key] = varsValues[key];
                }
            }
        }
        return getValuesForElement(asElement(parentElt(elt)), attr, evalAsDefault, values, event);
    }
    /**
   * @param {EventTarget|string} elt
   * @param {() => any} toEval
   * @param {any=} defaultVal
   * @returns {any}
   */ function maybeEval(elt, toEval, defaultVal) {
        if (htmx.config.allowEval) return toEval();
        else {
            triggerErrorEvent(elt, 'htmx:evalDisallowedError');
            return defaultVal;
        }
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXVarsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vars', true, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @param {*?=} expressionVars
 * @returns
 */ function getHXValsForElement(elt, event, expressionVars) {
        return getValuesForElement(elt, 'hx-vals', false, expressionVars, event);
    }
    /**
 * @param {Element} elt
 * @param {Event=} event
 * @returns {FormData}
 */ function getExpressionVars(elt, event) {
        return mergeObjects(getHXVarsForElement(elt, event), getHXValsForElement(elt, event));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {string} header
   * @param {string|null} headerValue
   */ function safelySetHeaderValue(xhr, header, headerValue) {
        if (headerValue !== null) try {
            xhr.setRequestHeader(header, headerValue);
        } catch (e) {
            // On an exception, try to set the header URI encoded instead
            xhr.setRequestHeader(header, encodeURIComponent(headerValue));
            xhr.setRequestHeader(header + '-URI-AutoEncoded', 'true');
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {string}
   */ function getPathFromResponse(xhr) {
        if (xhr.responseURL) try {
            const url = new URL(xhr.responseURL);
            return url.pathname + url.search;
        } catch (e) {
            triggerErrorEvent(getDocument().body, 'htmx:badResponseUrl', {
                url: xhr.responseURL
            });
        }
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @param {RegExp} regexp
   * @return {boolean}
   */ function hasHeader(xhr, regexp) {
        return regexp.test(xhr.getAllResponseHeaders());
    }
    /**
   * Issues an htmx-style AJAX request
   *
   * @see https://htmx.org/api/#ajax
   *
   * @param {HttpVerb} verb
   * @param {string} path the URL path to make the AJAX
   * @param {Element|string|HtmxAjaxHelperContext} context the element to target (defaults to the **body**) | a selector for the target | a context object that contains any of the following
   * @return {Promise<void>} Promise that resolves immediately if no request is sent, or when the request is complete
   */ function ajaxHelper(verb, path, context) {
        verb = /** @type HttpVerb */ verb.toLowerCase();
        if (context) {
            if (context instanceof Element || typeof context === 'string') return issueAjaxRequest(verb, path, null, null, {
                targetOverride: resolveTarget(context) || DUMMY_ELT,
                returnPromise: true
            });
            else {
                let resolvedTarget = resolveTarget(context.target);
                // If target is supplied but can't resolve OR source is supplied but both target and source can't be resolved
                // then use DUMMY_ELT to abort the request with htmx:targetError to avoid it replacing body by mistake
                if (context.target && !resolvedTarget || context.source && !resolvedTarget && !resolveTarget(context.source)) resolvedTarget = DUMMY_ELT;
                return issueAjaxRequest(verb, path, resolveTarget(context.source), context.event, {
                    handler: context.handler,
                    headers: context.headers,
                    values: context.values,
                    targetOverride: resolvedTarget,
                    swapOverride: context.swap,
                    select: context.select,
                    returnPromise: true
                });
            }
        } else return issueAjaxRequest(verb, path, null, null, {
            returnPromise: true
        });
    }
    /**
   * @param {Element} elt
   * @return {Element[]}
   */ function hierarchyForElt(elt) {
        const arr = [];
        while(elt){
            arr.push(elt);
            elt = elt.parentElement;
        }
        return arr;
    }
    /**
   * @param {Element} elt
   * @param {string} path
   * @param {HtmxRequestConfig} requestConfig
   * @return {boolean}
   */ function verifyPath(elt, path, requestConfig) {
        const url = new URL(path, location.protocol !== 'about:' ? location.href : window.origin);
        const origin = location.protocol !== 'about:' ? location.origin : window.origin;
        const sameHost = origin === url.origin;
        if (htmx.config.selfRequestsOnly) {
            if (!sameHost) return false;
        }
        return triggerEvent(elt, 'htmx:validateUrl', mergeObjects({
            url: url,
            sameHost: sameHost
        }, requestConfig));
    }
    /**
   * @param {Object|FormData} obj
   * @return {FormData}
   */ function formDataFromObject(obj) {
        if (obj instanceof FormData) return obj;
        const formData = new FormData();
        for(const key in obj)if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key].forEach === 'function') obj[key].forEach(function(v) {
                formData.append(key, v);
            });
            else if (typeof obj[key] === 'object' && !(obj[key] instanceof Blob)) formData.append(key, JSON.stringify(obj[key]));
            else formData.append(key, obj[key]);
        }
        return formData;
    }
    /**
   * @param {FormData} formData
   * @param {string} name
   * @param {Array} array
   * @returns {Array}
   */ function formDataArrayProxy(formData, name, array) {
        // mutating the array should mutate the underlying form data
        return new Proxy(array, {
            get: function(target, key) {
                if (typeof key === 'number') return target[key];
                if (key === 'length') return target.length;
                if (key === 'push') return function(value) {
                    target.push(value);
                    formData.append(name, value);
                };
                if (typeof target[key] === 'function') return function() {
                    target[key].apply(target, arguments);
                    formData.delete(name);
                    target.forEach(function(v) {
                        formData.append(name, v);
                    });
                };
                if (target[key] && target[key].length === 1) return target[key][0];
                else return target[key];
            },
            set: function(target, index, value) {
                target[index] = value;
                formData.delete(name);
                target.forEach(function(v) {
                    formData.append(name, v);
                });
                return true;
            }
        });
    }
    /**
   * @param {FormData} formData
   * @returns {Object}
   */ function formDataProxy(formData) {
        return new Proxy(formData, {
            get: function(target, name) {
                if (typeof name === 'symbol') {
                    // Forward symbol calls to the FormData itself directly
                    const result = Reflect.get(target, name);
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof result === 'function') return function() {
                        return result.apply(formData, arguments);
                    };
                    else return result;
                }
                if (name === 'toJSON') // Support JSON.stringify call on proxy
                return ()=>Object.fromEntries(formData);
                if (name in target) {
                    // Wrap in function with apply to correctly bind the FormData context, as a direct call would result in an illegal invocation error
                    if (typeof target[name] === 'function') return function() {
                        return formData[name].apply(formData, arguments);
                    };
                }
                const array = formData.getAll(name);
                // Those 2 undefined & single value returns are for retro-compatibility as we weren't using FormData before
                if (array.length === 0) return undefined;
                else if (array.length === 1) return array[0];
                else return formDataArrayProxy(target, name, array);
            },
            set: function(target, name, value) {
                if (typeof name !== 'string') return false;
                target.delete(name);
                if (value && typeof value.forEach === 'function') value.forEach(function(v) {
                    target.append(name, v);
                });
                else if (typeof value === 'object' && !(value instanceof Blob)) target.append(name, JSON.stringify(value));
                else target.append(name, value);
                return true;
            },
            deleteProperty: function(target, name) {
                if (typeof name === 'string') target.delete(name);
                return true;
            },
            // Support Object.assign call from proxy
            ownKeys: function(target) {
                return Reflect.ownKeys(Object.fromEntries(target));
            },
            getOwnPropertyDescriptor: function(target, prop) {
                return Reflect.getOwnPropertyDescriptor(Object.fromEntries(target), prop);
            }
        });
    }
    /**
   * @param {HttpVerb} verb
   * @param {string} path
   * @param {Element} elt
   * @param {Event} event
   * @param {HtmxAjaxEtc} [etc]
   * @param {boolean} [confirmed]
   * @return {Promise<void>}
   */ function issueAjaxRequest(verb, path, elt, event, etc, confirmed) {
        let resolve = null;
        let reject = null;
        etc = etc != null ? etc : {};
        if (etc.returnPromise && typeof Promise !== 'undefined') var promise = new Promise(function(_resolve, _reject) {
            resolve = _resolve;
            reject = _reject;
        });
        if (elt == null) elt = getDocument().body;
        const responseHandler = etc.handler || handleAjaxResponse;
        const select = etc.select || null;
        if (!bodyContains(elt)) {
            // do not issue requests for elements removed from the DOM
            maybeCall(resolve);
            return promise;
        }
        const target = etc.targetOverride || asElement(getTarget(elt));
        if (target == null || target == DUMMY_ELT) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: getClosestAttributeValue(elt, 'hx-target')
            });
            maybeCall(reject);
            return promise;
        }
        let eltData = getInternalData(elt);
        const submitter = eltData.lastButtonClicked;
        if (submitter) {
            const buttonPath = getRawAttribute(submitter, 'formaction');
            if (buttonPath != null) path = buttonPath;
            const buttonVerb = getRawAttribute(submitter, 'formmethod');
            if (buttonVerb != null) {
                if (VERBS.includes(buttonVerb.toLowerCase())) verb = /** @type HttpVerb */ buttonVerb;
                else {
                    maybeCall(resolve);
                    return promise;
                }
            }
        }
        const confirmQuestion = getClosestAttributeValue(elt, 'hx-confirm');
        // allow event-based confirmation w/ a callback
        if (confirmed === undefined) {
            const issueRequest = function(skipConfirmation) {
                return issueAjaxRequest(verb, path, elt, event, etc, !!skipConfirmation);
            };
            const confirmDetails = {
                target: target,
                elt: elt,
                path: path,
                verb: verb,
                triggeringEvent: event,
                etc: etc,
                issueRequest: issueRequest,
                question: confirmQuestion
            };
            if (triggerEvent(elt, 'htmx:confirm', confirmDetails) === false) {
                maybeCall(resolve);
                return promise;
            }
        }
        let syncElt = elt;
        let syncStrategy = getClosestAttributeValue(elt, 'hx-sync');
        let queueStrategy = null;
        let abortable = false;
        if (syncStrategy) {
            const syncStrings = syncStrategy.split(':');
            const selector = syncStrings[0].trim();
            if (selector === 'this') syncElt = findThisElement(elt, 'hx-sync');
            else syncElt = asElement(querySelectorExt(elt, selector));
            // default to the drop strategy
            syncStrategy = (syncStrings[1] || 'drop').trim();
            eltData = getInternalData(syncElt);
            if (syncStrategy === 'drop' && eltData.xhr && eltData.abortable !== true) {
                maybeCall(resolve);
                return promise;
            } else if (syncStrategy === 'abort') {
                if (eltData.xhr) {
                    maybeCall(resolve);
                    return promise;
                } else abortable = true;
            } else if (syncStrategy === 'replace') triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else if (syncStrategy.indexOf('queue') === 0) {
                const queueStrArray = syncStrategy.split(' ');
                queueStrategy = (queueStrArray[1] || 'last').trim();
            }
        }
        if (eltData.xhr) {
            if (eltData.abortable) triggerEvent(syncElt, 'htmx:abort') // abort the current request and continue
            ;
            else {
                if (queueStrategy == null) {
                    if (event) {
                        const eventData = getInternalData(event);
                        if (eventData && eventData.triggerSpec && eventData.triggerSpec.queue) queueStrategy = eventData.triggerSpec.queue;
                    }
                    if (queueStrategy == null) queueStrategy = 'last';
                }
                if (eltData.queuedRequests == null) eltData.queuedRequests = [];
                if (queueStrategy === 'first' && eltData.queuedRequests.length === 0) eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'all') eltData.queuedRequests.push(function() {
                    issueAjaxRequest(verb, path, elt, event, etc);
                });
                else if (queueStrategy === 'last') {
                    eltData.queuedRequests = [] // dump existing queue
                    ;
                    eltData.queuedRequests.push(function() {
                        issueAjaxRequest(verb, path, elt, event, etc);
                    });
                }
                maybeCall(resolve);
                return promise;
            }
        }
        const xhr = new XMLHttpRequest();
        eltData.xhr = xhr;
        eltData.abortable = abortable;
        const endRequestLock = function() {
            eltData.xhr = null;
            eltData.abortable = false;
            if (eltData.queuedRequests != null && eltData.queuedRequests.length > 0) {
                const queuedRequest = eltData.queuedRequests.shift();
                queuedRequest();
            }
        };
        const promptQuestion = getClosestAttributeValue(elt, 'hx-prompt');
        if (promptQuestion) {
            var promptResponse = prompt(promptQuestion);
            // prompt returns null if cancelled and empty string if accepted with no entry
            if (promptResponse === null || !triggerEvent(elt, 'htmx:prompt', {
                prompt: promptResponse,
                target: target
            })) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        if (confirmQuestion && !confirmed) {
            if (!confirm(confirmQuestion)) {
                maybeCall(resolve);
                endRequestLock();
                return promise;
            }
        }
        let headers = getHeaders(elt, target, promptResponse);
        if (verb !== 'get' && !usesFormData(elt)) headers['Content-Type'] = 'application/x-www-form-urlencoded';
        if (etc.headers) headers = mergeObjects(headers, etc.headers);
        const results = getInputValues(elt, verb);
        let errors = results.errors;
        const rawFormData = results.formData;
        if (etc.values) overrideFormData(rawFormData, formDataFromObject(etc.values));
        const expressionVars = formDataFromObject(getExpressionVars(elt, event));
        const allFormData = overrideFormData(rawFormData, expressionVars);
        let filteredFormData = filterValues(allFormData, elt);
        if (htmx.config.getCacheBusterParam && verb === 'get') filteredFormData.set('org.htmx.cache-buster', getRawAttribute(target, 'id') || 'true');
        // behavior of anchors w/ empty href is to use the current URL
        if (path == null || path === '') path = location.href;
        /**
     * @type {Object}
     * @property {boolean} [credentials]
     * @property {number} [timeout]
     * @property {boolean} [noHeaders]
     */ const requestAttrValues = getValuesForElement(elt, 'hx-request');
        const eltIsBoosted = getInternalData(elt).boosted;
        let useUrlParams = htmx.config.methodsThatUseUrlParams.indexOf(verb) >= 0;
        /** @type HtmxRequestConfig */ const requestConfig = {
            boosted: eltIsBoosted,
            useUrlParams: useUrlParams,
            formData: filteredFormData,
            parameters: formDataProxy(filteredFormData),
            unfilteredFormData: allFormData,
            unfilteredParameters: formDataProxy(allFormData),
            headers: headers,
            elt: elt,
            target: target,
            verb: verb,
            errors: errors,
            withCredentials: etc.credentials || requestAttrValues.credentials || htmx.config.withCredentials,
            timeout: etc.timeout || requestAttrValues.timeout || htmx.config.timeout,
            path: path,
            triggeringEvent: event
        };
        if (!triggerEvent(elt, 'htmx:configRequest', requestConfig)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        // copy out in case the object was overwritten
        path = requestConfig.path;
        verb = requestConfig.verb;
        headers = requestConfig.headers;
        filteredFormData = formDataFromObject(requestConfig.parameters);
        errors = requestConfig.errors;
        useUrlParams = requestConfig.useUrlParams;
        if (errors && errors.length > 0) {
            triggerEvent(elt, 'htmx:validation:halted', requestConfig);
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        const splitPath = path.split('#');
        const pathNoAnchor = splitPath[0];
        const anchor = splitPath[1];
        let finalPath = path;
        if (useUrlParams) {
            finalPath = pathNoAnchor;
            const hasValues = !filteredFormData.keys().next().done;
            if (hasValues) {
                if (finalPath.indexOf('?') < 0) finalPath += '?';
                else finalPath += '&';
                finalPath += urlEncode(filteredFormData);
                if (anchor) finalPath += '#' + anchor;
            }
        }
        if (!verifyPath(elt, finalPath, requestConfig)) {
            triggerErrorEvent(elt, 'htmx:invalidPath', requestConfig);
            maybeCall(reject);
            endRequestLock();
            return promise;
        }
        xhr.open(verb.toUpperCase(), finalPath, true);
        xhr.overrideMimeType('text/html');
        xhr.withCredentials = requestConfig.withCredentials;
        xhr.timeout = requestConfig.timeout;
        // request headers
        if (requestAttrValues.noHeaders) ;
        else {
            for(const header in headers)if (headers.hasOwnProperty(header)) {
                const headerValue = headers[header];
                safelySetHeaderValue(xhr, header, headerValue);
            }
        }
        /** @type {HtmxResponseInfo} */ const responseInfo = {
            xhr: xhr,
            target: target,
            requestConfig: requestConfig,
            etc: etc,
            boosted: eltIsBoosted,
            select: select,
            pathInfo: {
                requestPath: path,
                finalRequestPath: finalPath,
                responsePath: null,
                anchor: anchor
            }
        };
        xhr.onload = function() {
            try {
                const hierarchy = hierarchyForElt(elt);
                responseInfo.pathInfo.responsePath = getPathFromResponse(xhr);
                responseHandler(elt, responseInfo);
                if (responseInfo.keepIndicators !== true) removeRequestIndicators(indicators, disableElts);
                triggerEvent(elt, 'htmx:afterRequest', responseInfo);
                triggerEvent(elt, 'htmx:afterOnLoad', responseInfo);
                // if the body no longer contains the element, trigger the event on the closest parent
                // remaining in the DOM
                if (!bodyContains(elt)) {
                    let secondaryTriggerElt = null;
                    while(hierarchy.length > 0 && secondaryTriggerElt == null){
                        const parentEltInHierarchy = hierarchy.shift();
                        if (bodyContains(parentEltInHierarchy)) secondaryTriggerElt = parentEltInHierarchy;
                    }
                    if (secondaryTriggerElt) {
                        triggerEvent(secondaryTriggerElt, 'htmx:afterRequest', responseInfo);
                        triggerEvent(secondaryTriggerElt, 'htmx:afterOnLoad', responseInfo);
                    }
                }
                maybeCall(resolve);
            } catch (e) {
                triggerErrorEvent(elt, 'htmx:onLoadError', mergeObjects({
                    error: e
                }, responseInfo));
                throw e;
            } finally{
                endRequestLock();
            }
        };
        xhr.onerror = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendError', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.onabort = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:sendAbort', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        xhr.ontimeout = function() {
            removeRequestIndicators(indicators, disableElts);
            triggerErrorEvent(elt, 'htmx:afterRequest', responseInfo);
            triggerErrorEvent(elt, 'htmx:timeout', responseInfo);
            maybeCall(reject);
            endRequestLock();
        };
        if (!triggerEvent(elt, 'htmx:beforeRequest', responseInfo)) {
            maybeCall(resolve);
            endRequestLock();
            return promise;
        }
        var indicators = addRequestIndicatorClasses(elt);
        var disableElts = disableElements(elt);
        forEach([
            'loadstart',
            'loadend',
            'progress',
            'abort'
        ], function(eventName) {
            forEach([
                xhr,
                xhr.upload
            ], function(target) {
                target.addEventListener(eventName, function(event) {
                    triggerEvent(elt, 'htmx:xhr:' + eventName, {
                        lengthComputable: event.lengthComputable,
                        loaded: event.loaded,
                        total: event.total
                    });
                });
            });
        });
        triggerEvent(elt, 'htmx:beforeSend', responseInfo);
        const params = useUrlParams ? null : encodeParamsForBody(xhr, elt, filteredFormData);
        xhr.send(params);
        return promise;
    }
    /**
   * @typedef {Object} HtmxHistoryUpdate
   * @property {string|null} [type]
   * @property {string|null} [path]
   */ /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   * @return {HtmxHistoryUpdate}
   */ function determineHistoryUpdates(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        //= ==========================================
        // First consult response headers
        //= ==========================================
        let pathFromHeaders = null;
        let typeFromHeaders = null;
        if (hasHeader(xhr, /HX-Push:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Push-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Push-Url');
            typeFromHeaders = 'push';
        } else if (hasHeader(xhr, /HX-Replace-Url:/i)) {
            pathFromHeaders = xhr.getResponseHeader('HX-Replace-Url');
            typeFromHeaders = 'replace';
        }
        // if there was a response header, that has priority
        if (pathFromHeaders) {
            if (pathFromHeaders === 'false') return {};
            else return {
                type: typeFromHeaders,
                path: pathFromHeaders
            };
        }
        //= ==========================================
        // Next resolve via DOM values
        //= ==========================================
        const requestPath = responseInfo.pathInfo.finalRequestPath;
        const responsePath = responseInfo.pathInfo.responsePath;
        const pushUrl = getClosestAttributeValue(elt, 'hx-push-url');
        const replaceUrl = getClosestAttributeValue(elt, 'hx-replace-url');
        const elementIsBoosted = getInternalData(elt).boosted;
        let saveType = null;
        let path = null;
        if (pushUrl) {
            saveType = 'push';
            path = pushUrl;
        } else if (replaceUrl) {
            saveType = 'replace';
            path = replaceUrl;
        } else if (elementIsBoosted) {
            saveType = 'push';
            path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
        }
        if (path) {
            // false indicates no push, return empty object
            if (path === 'false') return {};
            // true indicates we want to follow wherever the server ended up sending us
            if (path === 'true') path = responsePath || requestPath // if there is no response path, go with the original request path
            ;
            // restore any anchor associated with the request
            if (responseInfo.pathInfo.anchor && path.indexOf('#') === -1) path = path + '#' + responseInfo.pathInfo.anchor;
            return {
                type: saveType,
                path: path
            };
        } else return {};
    }
    /**
   * @param {HtmxResponseHandlingConfig} responseHandlingConfig
   * @param {number} status
   * @return {boolean}
   */ function codeMatches(responseHandlingConfig, status) {
        var regExp = new RegExp(responseHandlingConfig.code);
        return regExp.test(status.toString(10));
    }
    /**
   * @param {XMLHttpRequest} xhr
   * @return {HtmxResponseHandlingConfig}
   */ function resolveResponseHandling(xhr) {
        for(var i = 0; i < htmx.config.responseHandling.length; i++){
            /** @type HtmxResponseHandlingConfig */ var responseHandlingElement = htmx.config.responseHandling[i];
            if (codeMatches(responseHandlingElement, xhr.status)) return responseHandlingElement;
        }
        // no matches, return no swap
        return {
            swap: false
        };
    }
    /**
   * @param {string} title
   */ function handleTitle(title) {
        if (title) {
            const titleElt = find('title');
            if (titleElt) titleElt.textContent = title;
            else window.document.title = title;
        }
    }
    /**
   * Resove the Retarget selector and throw if not found
   * @param {Element} elt
   * @param {String} target
   * @returns {Element}
   */ function resolveRetarget(elt, target) {
        if (target === 'this') return elt;
        const resolvedTarget = asElement(querySelectorExt(elt, target));
        if (resolvedTarget == null) {
            triggerErrorEvent(elt, 'htmx:targetError', {
                target: target
            });
            throw new Error(`Invalid re-target ${target}`);
        }
        return resolvedTarget;
    }
    /**
   * @param {Element} elt
   * @param {HtmxResponseInfo} responseInfo
   */ function handleAjaxResponse(elt, responseInfo) {
        const xhr = responseInfo.xhr;
        let target = responseInfo.target;
        const etc = responseInfo.etc;
        const responseInfoSelect = responseInfo.select;
        if (!triggerEvent(elt, 'htmx:beforeOnLoad', responseInfo)) return;
        if (hasHeader(xhr, /HX-Trigger:/i)) handleTriggerHeader(xhr, 'HX-Trigger', elt);
        if (hasHeader(xhr, /HX-Location:/i)) {
            saveCurrentPageToHistory();
            let redirectPath = xhr.getResponseHeader('HX-Location');
            /** @type {HtmxAjaxHelperContext&{path:string}} */ var redirectSwapSpec;
            if (redirectPath.indexOf('{') === 0) {
                redirectSwapSpec = parseJSON(redirectPath);
                // what's the best way to throw an error if the user didn't include this
                redirectPath = redirectSwapSpec.path;
                delete redirectSwapSpec.path;
            }
            ajaxHelper('get', redirectPath, redirectSwapSpec).then(function() {
                pushUrlIntoHistory(redirectPath);
            });
            return;
        }
        const shouldRefresh = hasHeader(xhr, /HX-Refresh:/i) && xhr.getResponseHeader('HX-Refresh') === 'true';
        if (hasHeader(xhr, /HX-Redirect:/i)) {
            responseInfo.keepIndicators = true;
            htmx.location.href = xhr.getResponseHeader('HX-Redirect');
            shouldRefresh && htmx.location.reload();
            return;
        }
        if (shouldRefresh) {
            responseInfo.keepIndicators = true;
            htmx.location.reload();
            return;
        }
        const historyUpdate = determineHistoryUpdates(elt, responseInfo);
        const responseHandling = resolveResponseHandling(xhr);
        const shouldSwap = responseHandling.swap;
        let isError = !!responseHandling.error;
        let ignoreTitle = htmx.config.ignoreTitle || responseHandling.ignoreTitle;
        let selectOverride = responseHandling.select;
        if (responseHandling.target) responseInfo.target = resolveRetarget(elt, responseHandling.target);
        var swapOverride = etc.swapOverride;
        if (swapOverride == null && responseHandling.swapOverride) swapOverride = responseHandling.swapOverride;
        // response headers override response handling config
        if (hasHeader(xhr, /HX-Retarget:/i)) responseInfo.target = resolveRetarget(elt, xhr.getResponseHeader('HX-Retarget'));
        if (hasHeader(xhr, /HX-Reswap:/i)) swapOverride = xhr.getResponseHeader('HX-Reswap');
        var serverResponse = xhr.response;
        /** @type HtmxBeforeSwapDetails */ var beforeSwapDetails = mergeObjects({
            shouldSwap: shouldSwap,
            serverResponse: serverResponse,
            isError: isError,
            ignoreTitle: ignoreTitle,
            selectOverride: selectOverride,
            swapOverride: swapOverride
        }, responseInfo);
        if (responseHandling.event && !triggerEvent(target, responseHandling.event, beforeSwapDetails)) return;
        if (!triggerEvent(target, 'htmx:beforeSwap', beforeSwapDetails)) return;
        target = beforeSwapDetails.target // allow re-targeting
        ;
        serverResponse = beforeSwapDetails.serverResponse // allow updating content
        ;
        isError = beforeSwapDetails.isError // allow updating error
        ;
        ignoreTitle = beforeSwapDetails.ignoreTitle // allow updating ignoring title
        ;
        selectOverride = beforeSwapDetails.selectOverride // allow updating select override
        ;
        swapOverride = beforeSwapDetails.swapOverride // allow updating swap override
        ;
        responseInfo.target = target // Make updated target available to response events
        ;
        responseInfo.failed = isError // Make failed property available to response events
        ;
        responseInfo.successful = !isError // Make successful property available to response events
        ;
        if (beforeSwapDetails.shouldSwap) {
            if (xhr.status === 286) cancelPolling(elt);
            withExtensions(elt, function(extension) {
                serverResponse = extension.transformResponse(serverResponse, xhr, elt);
            });
            // Save current page if there will be a history update
            if (historyUpdate.type) saveCurrentPageToHistory();
            var swapSpec = getSwapSpecification(elt, swapOverride);
            if (!swapSpec.hasOwnProperty('ignoreTitle')) swapSpec.ignoreTitle = ignoreTitle;
            target.classList.add(htmx.config.swappingClass);
            if (responseInfoSelect) selectOverride = responseInfoSelect;
            if (hasHeader(xhr, /HX-Reselect:/i)) selectOverride = xhr.getResponseHeader('HX-Reselect');
            const selectOOB = getClosestAttributeValue(elt, 'hx-select-oob');
            const select = getClosestAttributeValue(elt, 'hx-select');
            swap(target, serverResponse, swapSpec, {
                select: selectOverride === 'unset' ? null : selectOverride || select,
                selectOOB: selectOOB,
                eventInfo: responseInfo,
                anchor: responseInfo.pathInfo.anchor,
                contextElement: elt,
                afterSwapCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Swap:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Swap', finalElt);
                    }
                },
                afterSettleCallback: function() {
                    if (hasHeader(xhr, /HX-Trigger-After-Settle:/i)) {
                        let finalElt = elt;
                        if (!bodyContains(elt)) finalElt = getDocument().body;
                        handleTriggerHeader(xhr, 'HX-Trigger-After-Settle', finalElt);
                    }
                },
                beforeSwapCallback: function() {
                    // if we need to save history, do so, before swapping so that relative resources have the correct base URL
                    if (historyUpdate.type) {
                        triggerEvent(getDocument().body, 'htmx:beforeHistoryUpdate', mergeObjects({
                            history: historyUpdate
                        }, responseInfo));
                        if (historyUpdate.type === 'push') {
                            pushUrlIntoHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:pushedIntoHistory', {
                                path: historyUpdate.path
                            });
                        } else {
                            replaceUrlInHistory(historyUpdate.path);
                            triggerEvent(getDocument().body, 'htmx:replacedInHistory', {
                                path: historyUpdate.path
                            });
                        }
                    }
                }
            });
        }
        if (isError) triggerErrorEvent(elt, 'htmx:responseError', mergeObjects({
            error: 'Response Status Error Code ' + xhr.status + ' from ' + responseInfo.pathInfo.requestPath
        }, responseInfo));
    }
    //= ===================================================================
    // Extensions API
    //= ===================================================================
    /** @type {Object<string, HtmxExtension>} */ const extensions = {};
    /**
   * extensionBase defines the default functions for all extensions.
   * @returns {HtmxExtension}
   */ function extensionBase() {
        return {
            init: function(api) {
                return null;
            },
            getSelectors: function() {
                return null;
            },
            onEvent: function(name, evt) {
                return true;
            },
            transformResponse: function(text, xhr, elt) {
                return text;
            },
            isInlineSwap: function(swapStyle) {
                return false;
            },
            handleSwap: function(swapStyle, target, fragment, settleInfo) {
                return false;
            },
            encodeParameters: function(xhr, parameters, elt) {
                return null;
            }
        };
    }
    /**
   * defineExtension initializes the extension and adds it to the htmx registry
   *
   * @see https://htmx.org/api/#defineExtension
   *
   * @param {string} name the extension name
   * @param {Partial<HtmxExtension>} extension the extension definition
   */ function defineExtension(name, extension) {
        if (extension.init) extension.init(internalAPI);
        extensions[name] = mergeObjects(extensionBase(), extension);
    }
    /**
   * removeExtension removes an extension from the htmx registry
   *
   * @see https://htmx.org/api/#removeExtension
   *
   * @param {string} name
   */ function removeExtension(name) {
        delete extensions[name];
    }
    /**
   * getExtensions searches up the DOM tree to return all extensions that can be applied to a given element
   *
   * @param {Element} elt
   * @param {HtmxExtension[]=} extensionsToReturn
   * @param {string[]=} extensionsToIgnore
   * @returns {HtmxExtension[]}
   */ function getExtensions(elt, extensionsToReturn, extensionsToIgnore) {
        if (extensionsToReturn == undefined) extensionsToReturn = [];
        if (elt == undefined) return extensionsToReturn;
        if (extensionsToIgnore == undefined) extensionsToIgnore = [];
        const extensionsForElement = getAttributeValue(elt, 'hx-ext');
        if (extensionsForElement) forEach(extensionsForElement.split(','), function(extensionName) {
            extensionName = extensionName.replace(/ /g, '');
            if (extensionName.slice(0, 7) == 'ignore:') {
                extensionsToIgnore.push(extensionName.slice(7));
                return;
            }
            if (extensionsToIgnore.indexOf(extensionName) < 0) {
                const extension = extensions[extensionName];
                if (extension && extensionsToReturn.indexOf(extension) < 0) extensionsToReturn.push(extension);
            }
        });
        return getExtensions(asElement(parentElt(elt)), extensionsToReturn, extensionsToIgnore);
    }
    //= ===================================================================
    // Initialization
    //= ===================================================================
    var isReady = false;
    getDocument().addEventListener('DOMContentLoaded', function() {
        isReady = true;
    });
    /**
   * Execute a function now if DOMContentLoaded has fired, otherwise listen for it.
   *
   * This function uses isReady because there is no reliable way to ask the browser whether
   * the DOMContentLoaded event has already been fired; there's a gap between DOMContentLoaded
   * firing and readystate=complete.
   */ function ready(fn) {
        // Checking readyState here is a failsafe in case the htmx script tag entered the DOM by
        // some means other than the initial page load.
        if (isReady || getDocument().readyState === 'complete') fn();
        else getDocument().addEventListener('DOMContentLoaded', fn);
    }
    function insertIndicatorStyles() {
        if (htmx.config.includeIndicatorStyles !== false) {
            const nonceAttribute = htmx.config.inlineStyleNonce ? ` nonce="${htmx.config.inlineStyleNonce}"` : '';
            getDocument().head.insertAdjacentHTML('beforeend', '<style' + nonceAttribute + '>\
      .' + htmx.config.indicatorClass + '{opacity:0}\
      .' + htmx.config.requestClass + ' .' + htmx.config.indicatorClass + '{opacity:1; transition: opacity 200ms ease-in;}\
      .' + htmx.config.requestClass + '.' + htmx.config.indicatorClass + '{opacity:1; transition: opacity 200ms ease-in;}\
      </style>');
        }
    }
    function getMetaConfig() {
        /** @type HTMLMetaElement */ const element = getDocument().querySelector('meta[name="htmx-config"]');
        if (element) return parseJSON(element.content);
        else return null;
    }
    function mergeMetaConfig() {
        const metaConfig = getMetaConfig();
        if (metaConfig) htmx.config = mergeObjects(htmx.config, metaConfig);
    }
    // initialize the document
    ready(function() {
        mergeMetaConfig();
        insertIndicatorStyles();
        let body = getDocument().body;
        processNode(body);
        const restoredElts = getDocument().querySelectorAll("[hx-trigger='restored'],[data-hx-trigger='restored']");
        body.addEventListener('htmx:abort', function(evt) {
            const target = evt.target;
            const internalData = getInternalData(target);
            if (internalData && internalData.xhr) internalData.xhr.abort();
        });
        /** @type {(ev: PopStateEvent) => any} */ const originalPopstate = window.onpopstate ? window.onpopstate.bind(window) : null;
        /** @type {(ev: PopStateEvent) => any} */ window.onpopstate = function(event) {
            if (event.state && event.state.htmx) {
                restoreHistory();
                forEach(restoredElts, function(elt) {
                    triggerEvent(elt, 'htmx:restored', {
                        document: getDocument(),
                        triggerEvent: triggerEvent
                    });
                });
            } else if (originalPopstate) originalPopstate(event);
        };
        getWindow().setTimeout(function() {
            triggerEvent(body, 'htmx:load', {}) // give ready handlers a chance to load up before firing this event
            ;
            body = null // kill reference for gc
            ;
        }, 0);
    });
    return htmx;
}();
var /** @typedef {'get'|'head'|'post'|'put'|'delete'|'connect'|'options'|'trace'|'patch'} HttpVerb */ /**
 * @typedef {Object} SwapOptions
 * @property {string} [select]
 * @property {string} [selectOOB]
 * @property {*} [eventInfo]
 * @property {string} [anchor]
 * @property {Element} [contextElement]
 * @property {swapCallback} [afterSwapCallback]
 * @property {swapCallback} [afterSettleCallback]
 * @property {swapCallback} [beforeSwapCallback]
 * @property {string} [title]
 * @property {boolean} [historyRequest]
 */ /**
 * @callback swapCallback
 */ /**
 * @typedef {'innerHTML' | 'outerHTML' | 'beforebegin' | 'afterbegin' | 'beforeend' | 'afterend' | 'delete' | 'none' | string} HtmxSwapStyle
 */ /**
 * @typedef HtmxSwapSpecification
 * @property {HtmxSwapStyle} swapStyle
 * @property {number} swapDelay
 * @property {number} settleDelay
 * @property {boolean} [transition]
 * @property {boolean} [ignoreTitle]
 * @property {string} [head]
 * @property {'top' | 'bottom' | number } [scroll]
 * @property {string} [scrollTarget]
 * @property {string} [show]
 * @property {string} [showTarget]
 * @property {boolean} [focusScroll]
 */ /**
 * @typedef {((this:Node, evt:Event) => boolean) & {source: string}} ConditionalFunction
 */ /**
 * @typedef {Object} HtmxTriggerSpecification
 * @property {string} trigger
 * @property {number} [pollInterval]
 * @property {ConditionalFunction} [eventFilter]
 * @property {boolean} [changed]
 * @property {boolean} [once]
 * @property {boolean} [consume]
 * @property {number} [delay]
 * @property {string} [from]
 * @property {string} [target]
 * @property {number} [throttle]
 * @property {string} [queue]
 * @property {string} [root]
 * @property {string} [threshold]
 */ /**
 * @typedef {{elt: Element, message: string, validity: ValidityState}} HtmxElementValidationError
 */ /**
 * @typedef {Record<string, string>} HtmxHeaderSpecification
 * @property {'true'} HX-Request
 * @property {string|null} HX-Trigger
 * @property {string|null} HX-Trigger-Name
 * @property {string|null} HX-Target
 * @property {string} HX-Current-URL
 * @property {string} [HX-Prompt]
 * @property {'true'} [HX-Boosted]
 * @property {string} [Content-Type]
 * @property {'true'} [HX-History-Restore-Request]
 */ /**
 * @typedef HtmxAjaxHelperContext
 * @property {Element|string} [source]
 * @property {Event} [event]
 * @property {HtmxAjaxHandler} [handler]
 * @property {Element|string} [target]
 * @property {HtmxSwapStyle} [swap]
 * @property {Object|FormData} [values]
 * @property {Record<string,string>} [headers]
 * @property {string} [select]
 */ /**
 * @typedef {Object} HtmxRequestConfig
 * @property {boolean} boosted
 * @property {boolean} useUrlParams
 * @property {FormData} formData
 * @property {Object} parameters formData proxy
 * @property {FormData} unfilteredFormData
 * @property {Object} unfilteredParameters unfilteredFormData proxy
 * @property {HtmxHeaderSpecification} headers
 * @property {Element} elt
 * @property {Element} target
 * @property {HttpVerb} verb
 * @property {HtmxElementValidationError[]} errors
 * @property {boolean} withCredentials
 * @property {number} timeout
 * @property {string} path
 * @property {Event} triggeringEvent
 */ /**
 * @typedef {Object} HtmxResponseInfo
 * @property {XMLHttpRequest} xhr
 * @property {Element} target
 * @property {HtmxRequestConfig} requestConfig
 * @property {HtmxAjaxEtc} etc
 * @property {boolean} boosted
 * @property {string} select
 * @property {{requestPath: string, finalRequestPath: string, responsePath: string|null, anchor: string}} pathInfo
 * @property {boolean} [failed]
 * @property {boolean} [successful]
 * @property {boolean} [keepIndicators]
 */ /**
 * @typedef {Object} HtmxAjaxEtc
 * @property {boolean} [returnPromise]
 * @property {HtmxAjaxHandler} [handler]
 * @property {string} [select]
 * @property {Element} [targetOverride]
 * @property {HtmxSwapStyle} [swapOverride]
 * @property {Record<string,string>} [headers]
 * @property {Object|FormData} [values]
 * @property {boolean} [credentials]
 * @property {number} [timeout]
 */ /**
 * @typedef {Object} HtmxResponseHandlingConfig
 * @property {string} [code]
 * @property {boolean} swap
 * @property {boolean} [error]
 * @property {boolean} [ignoreTitle]
 * @property {string} [select]
 * @property {string} [target]
 * @property {string} [swapOverride]
 * @property {string} [event]
 */ /**
 * @typedef {HtmxResponseInfo & {shouldSwap: boolean, serverResponse: any, isError: boolean, ignoreTitle: boolean, selectOverride:string, swapOverride:string}} HtmxBeforeSwapDetails
 */ /**
 * @callback HtmxAjaxHandler
 * @param {Element} elt
 * @param {HtmxResponseInfo} responseInfo
 */ /**
 * @typedef {(() => void)} HtmxSettleTask
 */ /**
 * @typedef {Object} HtmxSettleInfo
 * @property {HtmxSettleTask[]} tasks
 * @property {Element[]} elts
 * @property {string} [title]
 */ /**
 * @see https://github.com/bigskysoftware/htmx-extensions/blob/main/README.md
 * @typedef {Object} HtmxExtension
 * @property {(api: any) => void} init
 * @property {(name: string, event: CustomEvent) => boolean} onEvent
 * @property {(text: string, xhr: XMLHttpRequest, elt: Element) => string} transformResponse
 * @property {(swapStyle: HtmxSwapStyle) => boolean} isInlineSwap
 * @property {(swapStyle: HtmxSwapStyle, target: Node, fragment: Node, settleInfo: HtmxSettleInfo) => boolean|Node[]} handleSwap
 * @property {(xhr: XMLHttpRequest, parameters: FormData, elt: Node) => *|string|null} encodeParameters
 * @property {() => string[]|null} getSelectors
 */ $adb0ae1ada1f9f50$export$2e2bcd8739ae039 = htmx;

});

parcelRegister("23OgD", function(module, exports) {

module.exports = (parcelRequire("24zrG"))($parcel$resolve("9sefE")).then(()=>parcelRequire('hNws8'));

});

var $af59467420eb5dfe$exports = {};
$parcel$extendImportMap({
    "kr1xC": "projectboardlist.1b1fee9b.js",
    "9rZS7": "projectboarddetails.8deda466.js",
    "9sefE": "productDetails.f5d688ac.js"
});

function $7d4b08104d2dc6af$export$6e9847a60c738c4d() {
    const accordions = document.querySelectorAll('[data-accordion]');
    if (!accordions.length) return;
    accordions.forEach((acc)=>{
        const defaultTriggers = acc.querySelectorAll('.cmp-accordion__trigger[data-expanded-default="true"]');
        defaultTriggers.forEach((btn)=>{
            $7d4b08104d2dc6af$var$togglePanel(btn, true);
        });
        acc.addEventListener('click', (e)=>{
            const btn = e.target.closest('.cmp-accordion__trigger');
            if (!btn || !acc.contains(btn)) return;
            const expanded = btn.getAttribute('aria-expanded') === 'true';
            $7d4b08104d2dc6af$var$togglePanel(btn, !expanded);
        });
    });
}
function $7d4b08104d2dc6af$var$togglePanel(btn, expand) {
    const panelId = btn.getAttribute('aria-controls');
    if (!panelId) return;
    const panel = document.getElementById(panelId);
    if (!panel) return;
    btn.setAttribute('aria-expanded', expand.toString());
    panel.hidden = !expand;
    const indicatorImg = btn.querySelector('.cmp-accordion__indicator-img');
    if (indicatorImg) {
        indicatorImg.src = expand ? '/images/minus-sign.svg' : '/images/plus-sign.svg';
        indicatorImg.alt = expand ? 'Collapse section' : 'Expand section';
    }
}



var $iouPm = parcelRequire("iouPm");

var $iouPm = parcelRequire("iouPm");
const $acf010821545adc4$export$c1f4f1b4e9de260b = (()=>{
    const resetHandlerKey = "__formManagerResetHandler";
    function clearFormState(form) {
        if (!form) return;
        form.querySelectorAll(".alert.alert-success, .alert.alert-error").forEach((alert)=>{
            alert.textContent = "";
        });
        form.querySelectorAll("span[data-valmsg-for]").forEach((span)=>{
            span.textContent = "";
        });
        form.querySelectorAll(".error, .input-error").forEach((element)=>{
            element.classList.remove("error", "input-error");
        });
    }
    function ensureResetHandler(form) {
        if (!form || form[resetHandlerKey]) return;
        const handler = ()=>clearFormState(form);
        form.addEventListener("reset", handler);
        form[resetHandlerKey] = handler;
    }
    async function postForm(form, url, formName, callback) {
        // Find the submit button's containing div
        const submitDiv = form.querySelector('button[type="submit"]').closest('div');
        // Ensure alertSuccessDiv exists
        let alertSuccessDiv = form.querySelector('.alert.alert-success');
        if (!alertSuccessDiv) {
            alertSuccessDiv = document.createElement('div');
            alertSuccessDiv.className = 'alert alert-success';
            submitDiv.parentNode.insertBefore(alertSuccessDiv, submitDiv);
        }
        alertSuccessDiv.textContent = '';
        // Ensure alertErrorDiv exists
        let alertErrorDiv = form.querySelector('.alert.alert-error');
        if (!alertErrorDiv) {
            alertErrorDiv = document.createElement('div');
            alertErrorDiv.className = 'alert alert-error';
            submitDiv.parentNode.insertBefore(alertErrorDiv, submitDiv);
        }
        ensureResetHandler(form);
        clearFormState(form);
        let success = false;
        let error = null;
        let responseData = null;
        try {
            // construct the body
            const jsonObject = constructBody(form);
            // post the form
            const response = await fetch(url, {
                method: 'POST',
                credentials: "include",
                headers: await (0, $iouPm.getHeadersWithToken)({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(jsonObject)
            });
            if (response.ok) {
                alertSuccessDiv.textContent = `${formName} saved successfully.`;
                success = true;
                responseData = await response.json().catch(()=>null);
            } else {
                const result = await response.json();
                responseData = result;
                if (result?.errors) {
                    for (const [key, messages] of Object.entries(result.errors))if (key === "*") alertErrorDiv.textContent = Array.isArray(messages) ? messages.join(" ") : messages;
                    else {
                        const field = form.querySelector(`#${key}`);
                        if (field) {
                            // Add .error class to the input
                            field.classList.add('error');
                            // Find the span with data-valmsg-for equal to the field name
                            const errorSpan = form.querySelector(`span[data-valmsg-for="${key}"]`);
                            if (errorSpan) errorSpan.textContent = Array.isArray(messages) ? messages.join(" ") : messages;
                        } else alertErrorDiv.textContent = `Unhandled validation error for "${key}": ${Array.isArray(messages) ? messages.join(" ") : messages}`;
                    }
                } else alertErrorDiv.textContent = `There was an error saving ${formName}.`;
                error = alertErrorDiv.textContent;
            }
        } catch (err) {
            alertErrorDiv.textContent = `There was an error saving ${formName}. ${err}`;
            error = err;
        }
        // Call the callback if provided
        if (typeof callback === "function") callback({
            success: success,
            error: error,
            data: responseData
        });
    }
    function constructBody(form) {
        const formData = new FormData(form);
        const jsonObject = {};
        for (const [key, value] of formData.entries()){
            const field = form.elements[key];
            // Handle multi-selects
            if (field && field instanceof HTMLSelectElement && field.multiple) // Only set once, as all selected options will be included in FormData
            {
                if (!jsonObject[key]) jsonObject[key] = Array.from(field.selectedOptions).map((opt)=>opt.value);
            } else // Handle multiple fields with the same name (e.g., checkboxes)
            if (jsonObject.hasOwnProperty(key)) {
                if (Array.isArray(jsonObject[key])) jsonObject[key].push(value);
                else jsonObject[key] = [
                    jsonObject[key],
                    value
                ];
            } else jsonObject[key] = value;
        }
        // Now, explicitly handle checkboxes: set to true if checked, false if not
        form.querySelectorAll('input[type="checkbox"]').forEach(function(checkbox) {
            // If the checkbox name is already in jsonObject, set to true if checked, false if not
            // If not present (unchecked), set to false
            if (checkbox.name) jsonObject[checkbox.name] = checkbox.checked;
        });
        return jsonObject;
    }
    function initTriggers() {}
    return {
        initTriggers: initTriggers,
        postForm: postForm,
        clearFormState: clearFormState
    };
})();
function $acf010821545adc4$export$6b5a000cfb5fda7b() {
    document.addEventListener("DOMContentLoaded", ()=>{
        $acf010821545adc4$export$c1f4f1b4e9de260b.initTriggers();
    });
}


function $3bb2332a5ac38c00$export$963762d7be283e09() {
    document.addEventListener('DOMContentLoaded', function() {
        if (document.querySelector('.account-detail')) {
            $3bb2332a5ac38c00$var$initProfileImage();
            $3bb2332a5ac38c00$var$initAccountDetail();
            $3bb2332a5ac38c00$var$initUpdatePassword();
        }
    });
}
function $3bb2332a5ac38c00$var$initProfileImage() {
    const accountProfileImage = document.getElementById('accountProfileImage');
    const accountProfileInitials = document.getElementById('accountProfileInitials');
    const addImageLink = document.getElementById('addImageLink');
    const editImageLink = document.getElementById('editImageLink');
    const deleteImageLink = document.getElementById('deleteImageLink');
    const form = document.getElementById('profileImageForm');
    const fileInput = document.getElementById('profileImage');
    const resultDiv = document.getElementById('uploadResult');
    fileInput.style.display = 'none';
    // show the upload image form (when adding)
    addImageLink.addEventListener('click', function() {
        fileInput.click();
    });
    editImageLink.addEventListener('click', function() {
        fileInput.click();
    });
    fileInput.addEventListener('change', function() {
        if (fileInput.files.length > 0) form.dispatchEvent(new Event('submit', {
            cancelable: true
        }));
    });
    // delete the profile image
    deleteImageLink.addEventListener('click', function() {
        if (!window.confirm('Are you sure you want to delete your profile image?')) return;
        (0, $iouPm.getHeadersWithToken)({
            'Accept': 'application/json'
        }).then((headers)=>fetch('/api/Accounts/My/Profile/Image', {
                method: 'DELETE',
                headers: headers
            })).then((response)=>{
            if (response.ok) {
                // update image, show add link, hide edit/delete links
                accountProfileImage.src = '';
                accountProfileImage.style.display = 'none';
                accountProfileInitials.style.display = 'flex';
                addImageLink.style.display = 'inline-block';
                editImageLink.style.display = 'none';
                deleteImageLink.style.display = 'none';
            } else console.error('Error deleting profile image:', response);
        }).catch((error)=>{
            console.error('Error deleting profile image:', error);
        });
    });
    // new image form upload
    form.addEventListener("submit", function(e) {
        e.preventDefault();
        if (fileInput.files.length === 0) {
            resultDiv.textContent = "Please select a file.";
            return;
        }
        const formData = new FormData();
        formData.append("file", fileInput.files[0]);
        (0, $iouPm.getHeadersWithToken)().then((headers)=>fetch('/api/Accounts/My/Profile/Image', {
                method: 'POST',
                body: formData,
                headers: headers
            })).then((response)=>{
            if (response.status === 201) {
                accountProfileImage.src = response.headers.get("Location");
                accountProfileImage.style.display = 'block';
                accountProfileInitials.style.display = 'none';
                form.style.display = 'none';
                addImageLink.style.display = 'none';
                editImageLink.style.display = 'inline-block';
                deleteImageLink.style.display = 'inline-block';
            } else return response.text().then((text)=>{
                resultDiv.textContent = "Upload failed: " + text;
            });
        }).catch((error)=>{
            resultDiv.textContent = "Error: " + error;
        });
    });
}
function $3bb2332a5ac38c00$var$initAccountDetail() {
    // show/hide the password form
    document.getElementById('updatePasswordLink').addEventListener('click', function() {
        this.style.display = 'none';
        document.getElementById('updatePasswordDiv').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
    });
    // hide the password form
    document.getElementById('cancelUpdatePassword').addEventListener('click', function() {
        document.getElementById('updatePasswordDiv').style.display = 'none';
        document.getElementById('updatePasswordLink').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            form.reset();
            (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
        }
    });
    // dynamically post the account detail form
    const form = document.getElementById('accountDetailForm');
    if (form) form.addEventListener('submit', async function(e) {
        e.preventDefault();
        await (0, $acf010821545adc4$export$c1f4f1b4e9de260b).postForm(form, '/api/Accounts/My/Profile', "Account Details", function(result) {
            if (result.success) ;
            else console.error(result.error);
        });
    });
}
function $3bb2332a5ac38c00$var$initUpdatePassword() {
    // show/hide the password form
    document.getElementById('updatePasswordLink').addEventListener('click', function() {
        this.style.display = 'none';
        document.getElementById('updatePasswordDiv').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
    });
    // hide the password form
    document.getElementById('cancelUpdatePassword').addEventListener('click', function() {
        document.getElementById('updatePasswordDiv').style.display = 'none';
        document.getElementById('updatePasswordLink').style.display = 'block';
        const form = document.getElementById('updatePasswordForm');
        if (form) {
            form.reset();
            (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
        }
    });
    const eyeIcons = document.querySelectorAll('.account-detail__eye-icon');
    eyeIcons.forEach((icon)=>{
        icon.addEventListener('click', function() {
            const input = this.previousElementSibling;
            if (input.type === 'password') {
                input.type = 'text';
                this.src = '/images/eye-icon-hide.svg';
                this.alt = 'Hide password';
            } else {
                input.type = 'password';
                this.src = '/images/eye-icon.svg';
                this.alt = 'Show password';
            }
        });
    });
    // dynamically post the password form
    const form = document.getElementById('updatePasswordForm');
    if (form) form.addEventListener('submit', async function(e) {
        e.preventDefault();
        await (0, $acf010821545adc4$export$c1f4f1b4e9de260b).postForm(form, '/api/Accounts/ChangePassword', "Password", function(result) {
            if (result.success) ;
            else console.error(result.error);
        });
    });
}


/**
 * Swiper 11.2.8
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 23, 2025
 */ /**
 * SSR Window 5.0.0
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2025, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 12, 2025
 */ /* eslint-disable no-param-reassign */ function $cd34a1485c0ed7aa$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $cd34a1485c0ed7aa$var$extend(target, src) {
    if (target === void 0) target = {};
    if (src === void 0) src = {};
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    Object.keys(src).filter((key)=>noExtend.indexOf(key) < 0).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($cd34a1485c0ed7aa$var$isObject(src[key]) && $cd34a1485c0ed7aa$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $cd34a1485c0ed7aa$var$extend(target[key], src[key]);
    });
}
const $cd34a1485c0ed7aa$var$ssrDocument = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $cd34a1485c0ed7aa$export$39b482c5e57630a8() {
    const doc = typeof document !== 'undefined' ? document : {};
    $cd34a1485c0ed7aa$var$extend(doc, $cd34a1485c0ed7aa$var$ssrDocument);
    return doc;
}
const $cd34a1485c0ed7aa$var$ssrWindow = {
    document: $cd34a1485c0ed7aa$var$ssrDocument,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $cd34a1485c0ed7aa$export$407448d2b89b1813() {
    const win = typeof window !== 'undefined' ? window : {};
    $cd34a1485c0ed7aa$var$extend(win, $cd34a1485c0ed7aa$var$ssrWindow);
    return win;
}



function $c3b7d8492a069cd1$export$35e795649ee09318(classes) {
    if (classes === void 0) classes = '';
    return classes.trim().split(' ').filter((c)=>!!c.trim());
}
function $c3b7d8492a069cd1$export$4a5767248b18ef41(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5(callback, delay) {
    if (delay === void 0) delay = 0;
    return setTimeout(callback, delay);
}
function $c3b7d8492a069cd1$export$2d1720544b23b823() {
    return Date.now();
}
function $c3b7d8492a069cd1$var$getComputedStyle(el) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $c3b7d8492a069cd1$export$342063e11d6c3cad(el, axis) {
    if (axis === void 0) axis = 'x';
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $c3b7d8492a069cd1$var$getComputedStyle(el);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $c3b7d8492a069cd1$export$ae1af26003f05816(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $c3b7d8492a069cd1$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $c3b7d8492a069cd1$export$d141bba7fdc215a3() {
    const to = Object(arguments.length <= 0 ? undefined : arguments[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < arguments.length; i += 1){
        const nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
        if (nextSource !== undefined && nextSource !== null && !$c3b7d8492a069cd1$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($c3b7d8492a069cd1$export$ae1af26003f05816(to[nextKey]) && $c3b7d8492a069cd1$export$ae1af26003f05816(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $c3b7d8492a069cd1$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else if (!$c3b7d8492a069cd1$export$ae1af26003f05816(to[nextKey]) && $c3b7d8492a069cd1$export$ae1af26003f05816(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $c3b7d8492a069cd1$export$d141bba7fdc215a3(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $c3b7d8492a069cd1$export$407448d2b89b1813(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $c3b7d8492a069cd1$export$3b14a55fb2447963(_ref) {
    let { swiper: swiper, targetPosition: targetPosition, side: side } = _ref;
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $c3b7d8492a069cd1$export$39b482c5e57630a8(slideEl) {
    return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function $c3b7d8492a069cd1$export$f1e1789686576879(element, selector) {
    if (selector === void 0) selector = '';
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const children = [
        ...element.children
    ];
    if (window1.HTMLSlotElement && element instanceof HTMLSlotElement) children.push(...element.assignedElements());
    if (!selector) return children;
    return children.filter((el)=>el.matches(selector));
}
function $c3b7d8492a069cd1$var$elementIsChildOfSlot(el, slot) {
    // Breadth-first search through all parent's children and assigned elements
    const elementsQueue = [
        slot
    ];
    while(elementsQueue.length > 0){
        const elementToCheck = elementsQueue.shift();
        if (el === elementToCheck) return true;
        elementsQueue.push(...elementToCheck.children, ...elementToCheck.shadowRoot ? elementToCheck.shadowRoot.children : [], ...elementToCheck.assignedElements ? elementToCheck.assignedElements() : []);
    }
}
function $c3b7d8492a069cd1$export$efccba1c4a2ef57b(el, parent) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    let isChild = parent.contains(el);
    if (!isChild && window1.HTMLSlotElement && parent instanceof HTMLSlotElement) {
        const children = [
            ...parent.assignedElements()
        ];
        isChild = children.includes(el);
        if (!isChild) isChild = $c3b7d8492a069cd1$var$elementIsChildOfSlot(el, parent);
    }
    return isChild;
}
function $c3b7d8492a069cd1$export$90a7f3efeed30595(text) {
    try {
        console.warn(text);
        return;
    } catch (err) {
    // err
    }
}
function $c3b7d8492a069cd1$export$db3b6bfb95261072(tag, classes) {
    if (classes === void 0) classes = [];
    const el = document.createElement(tag);
    el.classList.add(...Array.isArray(classes) ? classes : $c3b7d8492a069cd1$export$35e795649ee09318(classes));
    return el;
}
function $c3b7d8492a069cd1$export$4368d992c4eafac0(el) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    const box = el.getBoundingClientRect();
    const body = document1.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    const scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $c3b7d8492a069cd1$export$625550452a3fa3ec(el, selector) {
    const prevEls = [];
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $c3b7d8492a069cd1$export$43caf9889c228507(el, selector) {
    const nextEls = [];
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $c3b7d8492a069cd1$export$9e5f44173e64f162(el, prop) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $c3b7d8492a069cd1$export$23f2a1d2818174ef(el) {
    let child = el;
    let i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $c3b7d8492a069cd1$export$8b22cf2602fb60ce(el, selector) {
    const parents = []; // eslint-disable-line
    let parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $c3b7d8492a069cd1$export$882b5998b3b9117c(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener('transitionend', fireCallBack);
    }
    if (callback) el.addEventListener('transitionend', fireCallBack);
}
function $c3b7d8492a069cd1$export$dda1d9f60106f0e9(el, size, includeMargins) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    if (includeMargins) return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
    return el.offsetWidth;
}
function $c3b7d8492a069cd1$export$953cecd6e717a553(el) {
    return (Array.isArray(el) ? el : [
        el
    ]).filter((e)=>!!e);
}
function $c3b7d8492a069cd1$export$ffb5f4729a158638(swiper) {
    return (v)=>{
        if (Math.abs(v) > 0 && swiper.browser && swiper.browser.need3dFix && Math.abs(v) % 90 === 0) return v + 0.001;
        return v;
    };
}
function $c3b7d8492a069cd1$export$2408f22a0fab9ae5(el, html) {
    if (html === void 0) html = '';
    if (typeof trustedTypes !== 'undefined') el.innerHTML = trustedTypes.createPolicy('html', {
        createHTML: (s)=>s
    }).createHTML(html);
    else el.innerHTML = html;
}


let $74e74a0b53d40157$var$support;
function $74e74a0b53d40157$var$calcSupport() {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    return {
        smoothScroll: document1.documentElement && document1.documentElement.style && 'scrollBehavior' in document1.documentElement.style,
        touch: !!('ontouchstart' in window1 || window1.DocumentTouch && document1 instanceof window1.DocumentTouch)
    };
}
function $74e74a0b53d40157$var$getSupport() {
    if (!$74e74a0b53d40157$var$support) $74e74a0b53d40157$var$support = $74e74a0b53d40157$var$calcSupport();
    return $74e74a0b53d40157$var$support;
}
let $74e74a0b53d40157$var$deviceCached;
function $74e74a0b53d40157$var$calcDevice(_temp) {
    let { userAgent: userAgent } = _temp === void 0 ? {} : _temp;
    const support = $74e74a0b53d40157$var$getSupport();
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const platform = window1.navigator.platform;
    const ua = userAgent || window1.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window1.screen.width;
    const screenHeight = window1.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel';
    // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    }
    // Export object
    return device;
}
function $74e74a0b53d40157$var$getDevice(overrides) {
    if (overrides === void 0) overrides = {};
    if (!$74e74a0b53d40157$var$deviceCached) $74e74a0b53d40157$var$deviceCached = $74e74a0b53d40157$var$calcDevice(overrides);
    return $74e74a0b53d40157$var$deviceCached;
}
let $74e74a0b53d40157$var$browser;
function $74e74a0b53d40157$var$calcBrowser() {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const device = $74e74a0b53d40157$var$getDevice();
    let needPerspectiveFix = false;
    function isSafari() {
        const ua = window1.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    if (isSafari()) {
        const ua = String(window1.navigator.userAgent);
        if (ua.includes('Version/')) {
            const [major, minor] = ua.split('Version/')[1].split(' ')[0].split('.').map((num)=>Number(num));
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    const isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window1.navigator.userAgent);
    const isSafariBrowser = isSafari();
    const need3dFix = isSafariBrowser || isWebView && device.ios;
    return {
        isSafari: needPerspectiveFix || isSafariBrowser,
        needPerspectiveFix: needPerspectiveFix,
        need3dFix: need3dFix,
        isWebView: isWebView
    };
}
function $74e74a0b53d40157$var$getBrowser() {
    if (!$74e74a0b53d40157$var$browser) $74e74a0b53d40157$var$browser = $74e74a0b53d40157$var$calcBrowser();
    return $74e74a0b53d40157$var$browser;
}
function $74e74a0b53d40157$var$Resize(_ref) {
    let { swiper: swiper, on: on, emit: emit } = _ref;
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window1.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach((_ref2)=>{
                    let { contentBoxSize: contentBoxSize, contentRect: contentRect, target: target } = _ref2;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window1.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window1.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window1.addEventListener('resize', resizeHandler);
        window1.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window1.removeEventListener('resize', resizeHandler);
        window1.removeEventListener('orientationchange', orientationChangeHandler);
    });
}
function $74e74a0b53d40157$var$Observer(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const observers = [];
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const attach = function(target, options) {
        if (options === void 0) options = {};
        const ObserverFunc = window1.MutationObserver || window1.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window1.requestAnimationFrame) window1.requestAnimationFrame(observerUpdate);
            else window1.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: swiper.isElement || (typeof options.childList === 'undefined' ? true : options).childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = (0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(swiper.hostEl);
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.hostEl, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}
/* eslint-disable no-underscore-dangle */ var $74e74a0b53d40157$var$eventsEmitter = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler() {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit () {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};
function $74e74a0b53d40157$var$updateSize() {
    const swiper = this;
    let width;
    let height;
    const el = swiper.el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'padding-left') || 0, 10) - parseInt((0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'padding-right') || 0, 10);
    height = height - parseInt((0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'padding-top') || 0, 10) - parseInt((0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}
function $74e74a0b53d40157$var$updateSlides() {
    const swiper = this;
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { wrapperEl: wrapperEl, slidesEl: slidesEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `.${swiper.params.slideClass}, swiper-slide`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach((slideEl)=>{
        if (rtl) slideEl.style.marginLeft = '';
        else slideEl.style.marginRight = '';
        slideEl.style.marginBottom = '';
        slideEl.style.marginTop = '';
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $c3b7d8492a069cd1$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', '');
        (0, $c3b7d8492a069cd1$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slides);
    else if (swiper.grid) swiper.grid.unsetSlides();
    // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        let slide;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slides);
        if (slides[i] && (0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(slide, 'display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[swiper.getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide);
            const currentTransform = slide.style.transform;
            const currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = 'none';
            if (currentWebKitTransform) slide.style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $c3b7d8492a069cd1$export$dda1d9f60106f0e9)(slide, 'width', true) : (0, $c3b7d8492a069cd1$export$dda1d9f60106f0e9)(slide, 'height', true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[swiper.getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) wrapperEl.style.width = `${swiper.virtualSize + spaceBetween}px`;
    if (params.setWrapperSize) wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        const size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            const groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            const groupSize = size * params.slidesPerGroup;
            for(let i = 0; i < groups; i += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(let i = 0; i < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach((slideEl)=>{
            slideEl.style[key] = `${spaceBetween}px`;
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const maxSnap = allSlidesSize > swiperSize ? allSlidesSize - swiperSize : 0;
        snapGrid = snapGrid.map((snap)=>{
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        const offsetSize = (params.slidesOffsetBefore || 0) + (params.slidesOffsetAfter || 0);
        if (allSlidesSize + offsetSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize - offsetSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $c3b7d8492a069cd1$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $c3b7d8492a069cd1$export$407448d2b89b1813)(wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    swiper.emit('slidesUpdated');
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}
function $74e74a0b53d40157$var$updateAutoHeight(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = `${newHeight}px`;
}
function $74e74a0b53d40157$var$updateSlidesOffset() {
    const swiper = this;
    const slides = swiper.slides;
    // eslint-disable-next-line
    const minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}
const $74e74a0b53d40157$var$toggleSlideClasses$1 = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $74e74a0b53d40157$var$updateSlidesProgress(translate) {
    if (translate === void 0) translate = this && this.translate || 0;
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    let spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
    else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
        }
        $74e74a0b53d40157$var$toggleSlideClasses$1(slide, isVisible, params.slideVisibleClass);
        $74e74a0b53d40157$var$toggleSlideClasses$1(slide, isFullyVisible, params.slideFullyVisibleClass);
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}
function $74e74a0b53d40157$var$updateProgress(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd, progressLoop: progressLoop } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        const isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        const isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        const firstSlideIndex = swiper.getSlideIndexByData(0);
        const lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        const firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        const lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        const translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        const translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}
const $74e74a0b53d40157$var$toggleSlideClasses = (slideEl, condition, className)=>{
    if (condition && !slideEl.classList.contains(className)) slideEl.classList.add(className);
    else if (!condition && slideEl.classList.contains(className)) slideEl.classList.remove(className);
};
function $74e74a0b53d40157$var$updateSlidesClasses() {
    const swiper = this;
    const { slides: slides, params: params, slidesEl: slidesEl, activeIndex: activeIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const getFilteredSlide = (selector)=>{
        return (0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `.${params.slideClass}${selector}, swiper-slide${selector}`)[0];
    };
    let activeSlide;
    let prevSlide;
    let nextSlide;
    if (isVirtual) {
        if (params.loop) {
            let slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide(`[data-swiper-slide-index="${slideIndex}"]`);
        } else activeSlide = getFilteredSlide(`[data-swiper-slide-index="${activeIndex}"]`);
    } else if (gridEnabled) {
        activeSlide = slides.find((slideEl)=>slideEl.column === activeIndex);
        nextSlide = slides.find((slideEl)=>slideEl.column === activeIndex + 1);
        prevSlide = slides.find((slideEl)=>slideEl.column === activeIndex - 1);
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        if (!gridEnabled) {
            // Next Slide
            nextSlide = (0, $c3b7d8492a069cd1$export$43caf9889c228507)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            if (params.loop && !nextSlide) nextSlide = slides[0];
            // Prev Slide
            prevSlide = (0, $c3b7d8492a069cd1$export$625550452a3fa3ec)(activeSlide, `.${params.slideClass}, swiper-slide`)[0];
            params.loop;
        }
    }
    slides.forEach((slideEl)=>{
        $74e74a0b53d40157$var$toggleSlideClasses(slideEl, slideEl === activeSlide, params.slideActiveClass);
        $74e74a0b53d40157$var$toggleSlideClasses(slideEl, slideEl === nextSlide, params.slideNextClass);
        $74e74a0b53d40157$var$toggleSlideClasses(slideEl, slideEl === prevSlide, params.slidePrevClass);
    });
    swiper.emitSlidesClasses();
}
const $74e74a0b53d40157$var$processLazyPreloader = (swiper, imageEl)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    const slideSelector = ()=>swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    const slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        let lazyEl = slideEl.querySelector(`.${swiper.params.lazyPreloaderClass}`);
        if (!lazyEl && swiper.isElement) {
            if (slideEl.shadowRoot) lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
            else // init later
            requestAnimationFrame(()=>{
                if (slideEl.shadowRoot) {
                    lazyEl = slideEl.shadowRoot.querySelector(`.${swiper.params.lazyPreloaderClass}`);
                    if (lazyEl) lazyEl.remove();
                }
            });
        }
        if (lazyEl) lazyEl.remove();
    }
};
const $74e74a0b53d40157$var$unlazy = (swiper, index)=>{
    if (!swiper.slides[index]) return;
    const imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute('loading');
};
const $74e74a0b53d40157$var$preload = (swiper)=>{
    if (!swiper || swiper.destroyed || !swiper.params) return;
    let amount = swiper.params.lazyPreloadPrevNext;
    const len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    const slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        const activeColumn = activeIndex;
        const preloadColumns = [
            activeColumn - amount
        ];
        preloadColumns.push(...Array.from({
            length: amount
        }).map((_, i)=>{
            return activeColumn + slidesPerView + i;
        }));
        swiper.slides.forEach((slideEl, i)=>{
            if (preloadColumns.includes(slideEl.column)) $74e74a0b53d40157$var$unlazy(swiper, i);
        });
        return;
    }
    const slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(let i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        const realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $74e74a0b53d40157$var$unlazy(swiper, realIndex);
    }
    else {
        for(let i = Math.max(activeIndex - amount, 0); i <= Math.min(slideIndexLastInView + amount, len - 1); i += 1)if (i !== activeIndex && (i > slideIndexLastInView || i < activeIndex)) $74e74a0b53d40157$var$unlazy(swiper, i);
    }
};
function $74e74a0b53d40157$var$getActiveIndexByTranslate(swiper) {
    const { slidesGrid: slidesGrid, params: params } = swiper;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    let activeIndex;
    for(let i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
    return activeIndex;
}
function $74e74a0b53d40157$var$updateActiveIndex(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    const getVirtualRealIndex = (aIndex)=>{
        let realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === 'undefined') activeIndex = $74e74a0b53d40157$var$getActiveIndexByTranslate(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex && !swiper.params.loop) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    }
    if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    // Get real index
    let realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (gridEnabled) {
        const firstSlideInColumn = swiper.slides.find((slideEl)=>slideEl.column === activeIndex);
        let activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
        if (Number.isNaN(activeSlideIndex)) activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
        realIndex = Math.floor(activeSlideIndex / params.grid.rows);
    } else if (swiper.slides[activeIndex]) {
        const slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
        if (slideIndex) realIndex = parseInt(slideIndex, 10);
        else realIndex = activeIndex;
    } else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) $74e74a0b53d40157$var$preload(swiper);
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) {
        if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
        swiper.emit('slideChange');
    }
}
function $74e74a0b53d40157$var$updateClickedSlide(el, path) {
    const swiper = this;
    const params = swiper.params;
    let slide = el.closest(`.${params.slideClass}, swiper-slide`);
    if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) [
        ...path.slice(path.indexOf(el) + 1, path.length)
    ].forEach((pathEl)=>{
        if (!slide && pathEl.matches && pathEl.matches(`.${params.slideClass}, swiper-slide`)) slide = pathEl;
    });
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}
var $74e74a0b53d40157$var$update = {
    updateSize: $74e74a0b53d40157$var$updateSize,
    updateSlides: $74e74a0b53d40157$var$updateSlides,
    updateAutoHeight: $74e74a0b53d40157$var$updateAutoHeight,
    updateSlidesOffset: $74e74a0b53d40157$var$updateSlidesOffset,
    updateSlidesProgress: $74e74a0b53d40157$var$updateSlidesProgress,
    updateProgress: $74e74a0b53d40157$var$updateProgress,
    updateSlidesClasses: $74e74a0b53d40157$var$updateSlidesClasses,
    updateActiveIndex: $74e74a0b53d40157$var$updateActiveIndex,
    updateClickedSlide: $74e74a0b53d40157$var$updateClickedSlide
};
function $74e74a0b53d40157$var$getSwiperTranslate(axis) {
    if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, wrapperEl: wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $c3b7d8492a069cd1$export$342063e11d6c3cad)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}
function $74e74a0b53d40157$var$setTranslate(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = `translate3d(${x}px, ${y}px, ${z}px)`;
    }
    // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}
function $74e74a0b53d40157$var$minTranslate() {
    return -this.snapGrid[0];
}
function $74e74a0b53d40157$var$maxTranslate() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $74e74a0b53d40157$var$translateTo(translate, speed, runCallbacks, translateBounds, internal) {
    if (translate === void 0) translate = 0;
    if (speed === void 0) speed = this.params.speed;
    if (runCallbacks === void 0) runCallbacks = true;
    if (translateBounds === void 0) translateBounds = true;
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $c3b7d8492a069cd1$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                swiper.animating = false;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}
var $74e74a0b53d40157$var$translate = {
    getTranslate: $74e74a0b53d40157$var$getSwiperTranslate,
    setTranslate: $74e74a0b53d40157$var$setTranslate,
    minTranslate: $74e74a0b53d40157$var$minTranslate,
    maxTranslate: $74e74a0b53d40157$var$maxTranslate,
    translateTo: $74e74a0b53d40157$var$translateTo
};
function $74e74a0b53d40157$var$setTransition(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) {
        swiper.wrapperEl.style.transitionDuration = `${duration}ms`;
        swiper.wrapperEl.style.transitionDelay = duration === 0 ? `0ms` : '';
    }
    swiper.emit('setTransition', duration, byController);
}
function $74e74a0b53d40157$var$transitionEmit(_ref) {
    let { swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step } = _ref;
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && dir === 'reset') swiper.emit(`slideResetTransition${step}`);
    else if (runCallbacks && activeIndex !== previousIndex) {
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}
function $74e74a0b53d40157$var$transitionStart(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    $74e74a0b53d40157$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}
function $74e74a0b53d40157$var$transitionEnd(runCallbacks, direction) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    $74e74a0b53d40157$var$transitionEmit({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}
var $74e74a0b53d40157$var$transition = {
    setTransition: $74e74a0b53d40157$var$setTransition,
    transitionStart: $74e74a0b53d40157$var$transitionStart,
    transitionEnd: $74e74a0b53d40157$var$transitionEnd
};
function $74e74a0b53d40157$var$slideTo(index, speed, runCallbacks, internal, initial) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') index = parseInt(index, 10);
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (!enabled && !internal && !initial || swiper.destroyed || swiper.animating && params.preventInteractionOnTransition) return false;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
    // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset';
    // initial virtual
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const isInitialVirtual = isVirtual && initial;
    // Update Index
    if (!isInitialVirtual && (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate)) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(()=>{
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                });
            } else wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $c3b7d8492a069cd1$export$3b14a55fb2447963)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    const browser = $74e74a0b53d40157$var$getBrowser();
    const isSafari = browser.isSafari;
    if (isVirtual && !initial && isSafari && swiper.isElement) swiper.virtual.update(false, false, slideIndex);
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}
function $74e74a0b53d40157$var$slideToLoop(index, speed, runCallbacks, internal) {
    if (index === void 0) index = 0;
    if (runCallbacks === void 0) runCallbacks = true;
    if (typeof index === 'string') {
        const indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
    let newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else {
            let targetSlideIndex;
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                targetSlideIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else targetSlideIndex = swiper.getSlideIndexByData(newIndex);
            const cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
            const { centeredSlides: centeredSlides } = swiper.params;
            let slidesPerView = swiper.params.slidesPerView;
            if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
            else {
                slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
                if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
            }
            let needLoopFix = cols - targetSlideIndex < slidesPerView;
            if (centeredSlides) needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
            if (internal && centeredSlides && swiper.params.slidesPerView !== 'auto' && !gridEnabled) needLoopFix = false;
            if (needLoopFix) {
                const direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
                swiper.loopFix({
                    direction: direction,
                    slideTo: true,
                    activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
                    slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
                });
            }
            if (gridEnabled) {
                const slideIndex = newIndex * swiper.params.grid.rows;
                newIndex = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex).column;
            } else newIndex = swiper.getSlideIndexByData(newIndex);
        }
    }
    requestAnimationFrame(()=>{
        swiper.slideTo(newIndex, speed, runCallbacks, internal);
    });
    return swiper;
}
/* eslint no-unused-vars: "off" */ function $74e74a0b53d40157$var$slideNext(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { enabled: enabled, params: params, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'next'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
        if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
            requestAnimationFrame(()=>{
                swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
            });
            return true;
        }
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $74e74a0b53d40157$var$slidePrev(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled, animating: animating } = swiper;
    if (!enabled || swiper.destroyed) return swiper;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: 'prev'
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    const isFreeMode = params.freeMode && params.freeMode.enabled;
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && (params.cssMode || isFreeMode)) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = isFreeMode ? snapGrid[prevSnapIndex] : snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
        requestAnimationFrame(()=>{
            swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        });
        return true;
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $74e74a0b53d40157$var$slideReset(speed, runCallbacks, internal) {
    if (runCallbacks === void 0) runCallbacks = true;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}
/* eslint no-unused-vars: "off" */ function $74e74a0b53d40157$var$slideToClosest(speed, runCallbacks, internal, threshold) {
    if (runCallbacks === void 0) runCallbacks = true;
    if (threshold === void 0) threshold = 0.5;
    const swiper = this;
    if (swiper.destroyed) return;
    if (typeof speed === 'undefined') speed = swiper.params.speed;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}
function $74e74a0b53d40157$var$slideToClickedSlide() {
    const swiper = this;
    if (swiper.destroyed) return;
    const { params: params, slidesEl: slidesEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    const slideSelector = swiper.isElement ? `swiper-slide` : `.${params.slideClass}`;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
                (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `${slideSelector}[data-swiper-slide-index="${realIndex}"]`)[0]);
            (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}
var $74e74a0b53d40157$var$slide = {
    slideTo: $74e74a0b53d40157$var$slideTo,
    slideToLoop: $74e74a0b53d40157$var$slideToLoop,
    slideNext: $74e74a0b53d40157$var$slideNext,
    slidePrev: $74e74a0b53d40157$var$slidePrev,
    slideReset: $74e74a0b53d40157$var$slideReset,
    slideToClosest: $74e74a0b53d40157$var$slideToClosest,
    slideToClickedSlide: $74e74a0b53d40157$var$slideToClickedSlide
};
function $74e74a0b53d40157$var$loopCreate(slideRealIndex, initial) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    const initSlides = ()=>{
        const slides = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        slides.forEach((el, index)=>{
            el.setAttribute('data-swiper-slide-index', index);
        });
    };
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    const slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
    const shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
    const shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
    const addBlankSlides = (amountOfSlides)=>{
        for(let i = 0; i < amountOfSlides; i += 1){
            const slideEl = swiper.isElement ? (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('swiper-slide', [
                params.slideBlankClass
            ]) : (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', [
                params.slideClass,
                params.slideBlankClass
            ]);
            swiper.slidesEl.append(slideEl);
        }
    };
    if (shouldFillGroup) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $c3b7d8492a069cd1$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else if (shouldFillGrid) {
        if (params.loopAddBlankSlides) {
            const slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
            addBlankSlides(slidesToAdd);
            swiper.recalcSlides();
            swiper.updateSlides();
        } else (0, $c3b7d8492a069cd1$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
        initSlides();
    } else initSlides();
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : 'next',
        initial: initial
    });
}
function $74e74a0b53d40157$var$loopFix(_temp) {
    let { slideRealIndex: slideRealIndex, slideTo: slideTo = true, direction: direction, setTranslate: setTranslate, activeSlideIndex: activeSlideIndex, initial: initial, byController: byController, byMousewheel: byMousewheel } = _temp === void 0 ? {} : _temp;
    const swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit('beforeLoopFix');
    const { slides: slides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, slidesEl: slidesEl, params: params } = swiper;
    const { centeredSlides: centeredSlides, initialSlide: initialSlide } = params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit('loopFix');
        return;
    }
    let slidesPerView = params.slidesPerView;
    if (slidesPerView === 'auto') slidesPerView = swiper.slidesPerViewDynamic();
    else {
        slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) slidesPerView = slidesPerView + 1;
    }
    const slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
    let loopedSlides = slidesPerGroup;
    if (loopedSlides % slidesPerGroup !== 0) loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
    loopedSlides += params.loopAdditionalSlides;
    swiper.loopedSlides = loopedSlides;
    const gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
    if (slides.length < slidesPerView + loopedSlides || swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) (0, $c3b7d8492a069cd1$export$90a7f3efeed30595)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
    else if (gridEnabled && params.grid.fill === 'row') (0, $c3b7d8492a069cd1$export$90a7f3efeed30595)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
    const prependSlidesIndexes = [];
    const appendSlidesIndexes = [];
    const cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
    const isInitialOverflow = initial && cols - initialSlide < slidesPerView && !centeredSlides;
    let activeIndex = isInitialOverflow ? initialSlide : swiper.activeIndex;
    if (typeof activeSlideIndex === 'undefined') activeSlideIndex = swiper.getSlideIndex(slides.find((el)=>el.classList.contains(params.slideActiveClass)));
    else activeIndex = activeSlideIndex;
    const isNext = direction === 'next' || !direction;
    const isPrev = direction === 'prev' || !direction;
    let slidesPrepended = 0;
    let slidesAppended = 0;
    const activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
    const activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
    // prepend last slides before start
    if (activeColIndexWithShift < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
        for(let i = 0; i < loopedSlides - activeColIndexWithShift; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) {
                const colIndexToPrepend = cols - index - 1;
                for(let i = slides.length - 1; i >= 0; i -= 1)if (slides[i].column === colIndexToPrepend) prependSlidesIndexes.push(i);
            // slides.forEach((slide, slideIndex) => {
            //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
            // });
            } else prependSlidesIndexes.push(cols - index - 1);
        }
    } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
        slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);
        if (isInitialOverflow) slidesAppended = Math.max(slidesAppended, slidesPerView - cols + initialSlide + 1);
        for(let i = 0; i < slidesAppended; i += 1){
            const index = i - Math.floor(i / cols) * cols;
            if (gridEnabled) slides.forEach((slide, slideIndex)=>{
                if (slide.column === index) appendSlidesIndexes.push(slideIndex);
            });
            else appendSlidesIndexes.push(index);
        }
    }
    swiper.__preventObserver__ = true;
    requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
    if (swiper.params.effect === 'cards' && slides.length < slidesPerView + loopedSlides * 2) {
        if (appendSlidesIndexes.includes(activeSlideIndex)) appendSlidesIndexes.splice(appendSlidesIndexes.indexOf(activeSlideIndex), 1);
        if (prependSlidesIndexes.includes(activeSlideIndex)) prependSlidesIndexes.splice(prependSlidesIndexes.indexOf(activeSlideIndex), 1);
    }
    if (isPrev) prependSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach((index)=>{
        slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(slides[index]);
        slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === 'auto') swiper.updateSlides();
    else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) swiper.slides.forEach((slide, slideIndex)=>{
        swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + Math.ceil(slidesPrepended), 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else if (setTranslate) {
                const shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
                swiper.touchEventsData.currentTranslate = swiper.translate;
            }
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === 'undefined') {
                const currentSlideTranslate = swiper.slidesGrid[activeIndex];
                const newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
                const diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) {
                        swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
                        swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
                    }
                }
            } else {
                const shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
                swiper.slideTo(swiper.activeIndex - shift, 0, false, true);
            }
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        const loopParams = {
            slideRealIndex: slideRealIndex,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach((c)=>{
            if (!c.destroyed && c.params.loop) c.loopFix({
                ...loopParams,
                slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
            });
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix({
            ...loopParams,
            slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
        });
    }
    swiper.emit('loopFix');
}
function $74e74a0b53d40157$var$loopDestroy() {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (!params.loop || !slidesEl || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    const newSlidesOrder = [];
    swiper.slides.forEach((slideEl)=>{
        const index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach((slideEl)=>{
        slideEl.removeAttribute('data-swiper-slide-index');
    });
    newSlidesOrder.forEach((slideEl)=>{
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}
var $74e74a0b53d40157$var$loop = {
    loopCreate: $74e74a0b53d40157$var$loopCreate,
    loopFix: $74e74a0b53d40157$var$loopFix,
    loopDestroy: $74e74a0b53d40157$var$loopDestroy
};
function $74e74a0b53d40157$var$setGrabCursor(moving) {
    const swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
function $74e74a0b53d40157$var$unsetGrabCursor() {
    const swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
    if (swiper.isElement) requestAnimationFrame(()=>{
        swiper.__preventObserver__ = false;
    });
}
var $74e74a0b53d40157$var$grabCursor = {
    setGrabCursor: $74e74a0b53d40157$var$setGrabCursor,
    unsetGrabCursor: $74e74a0b53d40157$var$unsetGrabCursor
};
// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $74e74a0b53d40157$var$closestElement(selector, base) {
    if (base === void 0) base = this;
    function __closestFrom(el) {
        if (!el || el === (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)() || el === (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $74e74a0b53d40157$var$preventEdgeSwipe(swiper, event, startX) {
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const { params: params } = swiper;
    const edgeSwipeDetection = params.edgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window1.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') {
            event.preventDefault();
            return true;
        }
        return false;
    }
    return true;
}
function $74e74a0b53d40157$var$onTouchStart(event) {
    const swiper = this;
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    const data = swiper.touchEventsData;
    if (e.type === 'pointerdown') {
        if (data.pointerId !== null && data.pointerId !== e.pointerId) return;
        data.pointerId = e.pointerId;
    } else if (e.type === 'touchstart' && e.targetTouches.length === 1) data.touchId = e.targetTouches[0].identifier;
    if (e.type === 'touchstart') {
        // don't proceed touch event
        $74e74a0b53d40157$var$preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
        return;
    }
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let targetEl = e.target;
    if (params.touchEventsTarget === 'wrapper') {
        if (!(0, $c3b7d8492a069cd1$export$efccba1c4a2ef57b)(targetEl, swiper.wrapperEl)) return;
    }
    if ('which' in e && e.which === 3) return;
    if ('button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
    // eslint-disable-next-line
    const eventPath = e.composedPath ? e.composedPath() : e.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $74e74a0b53d40157$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    if (!$74e74a0b53d40157$var$preventEdgeSwipe(swiper, e, startX)) return;
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    let preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === 'SELECT') data.isTouched = false;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== targetEl && (e.pointerType === 'mouse' || e.pointerType !== 'mouse' && !targetEl.matches(data.focusableElements))) document1.activeElement.blur();
    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}
function $74e74a0b53d40157$var$onTouchMove(event) {
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === 'mouse') return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (e.type === 'pointermove') {
        if (data.touchId !== null) return; // return from pointer if we use touch
        const id = e.pointerId;
        if (id !== data.pointerId) return;
    }
    let targetTouch;
    if (e.type === 'touchmove') {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    } else targetTouch = e;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    const pageX = targetTouch.pageX;
    const pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (rtl && (pageX > touches.startX && -swiper.translate <= swiper.maxTranslate() || pageX < touches.startX && -swiper.translate >= swiper.minTranslate())) return;
        else if (!rtl && (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate())) return;
    }
    if (document1.activeElement && document1.activeElement.matches(data.focusableElements) && document1.activeElement !== e.target && e.pointerType !== 'mouse') document1.activeElement.blur();
    if (document1.activeElement) {
        if (e.target === document1.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    touches.previousX = touches.currentX;
    touches.previousY = touches.currentY;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || e.type === 'touchmove' && data.preventTouchMoveFromPointerMove) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    let diff = swiper.isHorizontal() ? diffX : diffY;
    let touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    const prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
    const isLoop = swiper.params.loop && !params.cssMode;
    const allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
    if (!data.isMoved) {
        if (isLoop && allowLoopFix) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            const evt = new window.CustomEvent('transitionend', {
                bubbles: true,
                cancelable: true,
                detail: {
                    bySwiperTouchMove: true
                }
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    let loopFixed;
    new Date().getTime();
    if (params._loopSwapReset !== false && data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
        Object.assign(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY,
            startTranslate: data.currentTranslate
        });
        data.loopSwapReset = true;
        data.startTranslate = data.currentTranslate;
        return;
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] - (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.activeIndex + 1] + swiper.params.spaceBetween : 0) - swiper.params.spaceBetween : swiper.minTranslate())) swiper.loopFix({
            direction: 'prev',
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
        }
    } else if (diff < 0) {
        if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween + (params.slidesPerView !== 'auto' && swiper.slides.length - params.slidesPerView >= 2 ? swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] + swiper.params.spaceBetween : 0) : swiper.maxTranslate())) swiper.loopFix({
            direction: 'next',
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}
function $74e74a0b53d40157$var$onTouchEnd(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let targetTouch;
    const isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
    if (!isTouchEvent) {
        if (data.touchId !== null) return; // return from pointer if we use touch
        if (e.pointerId !== data.pointerId) return;
        targetTouch = e;
    } else {
        targetTouch = [
            ...e.changedTouches
        ].find((t)=>t.identifier === data.touchId);
        if (!targetTouch || targetTouch.identifier !== data.touchId) return;
    }
    if ([
        'pointercancel',
        'pointerout',
        'pointerleave',
        'contextmenu'
    ].includes(e.type)) {
        const proceed = [
            'pointercancel',
            'contextmenu'
        ].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    data.pointerId = null;
    data.touchId = null;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    if (!params.simulateTouch && e.pointerType === 'mouse') return;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    const touchEndTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
    const timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
    (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    const swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (swipeToLast || currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}
function $74e74a0b53d40157$var$onResize() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    const isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(()=>{
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}
function $74e74a0b53d40157$var$onClick(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}
function $74e74a0b53d40157$var$onScroll() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}
function $74e74a0b53d40157$var$onLoad(e) {
    const swiper = this;
    $74e74a0b53d40157$var$processLazyPreloader(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) return;
    swiper.update();
}
function $74e74a0b53d40157$var$onDocumentTouchStart() {
    const swiper = this;
    if (swiper.documentTouchHandlerProceeded) return;
    swiper.documentTouchHandlerProceeded = true;
    if (swiper.params.touchReleaseOnEdges) swiper.el.style.touchAction = 'auto';
}
const $74e74a0b53d40157$var$events = (swiper, method)=>{
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    const { params: params, el: el, wrapperEl: wrapperEl, device: device } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method;
    if (!el || typeof el === 'string') return;
    // Touch Events
    document1[domMethod]('touchstart', swiper.onDocumentTouchStart, {
        passive: false,
        capture: capture
    });
    el[domMethod]('touchstart', swiper.onTouchStart, {
        passive: false
    });
    el[domMethod]('pointerdown', swiper.onTouchStart, {
        passive: false
    });
    document1[domMethod]('touchmove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('pointermove', swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document1[domMethod]('touchend', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerup', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointercancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('touchcancel', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerout', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('pointerleave', swiper.onTouchEnd, {
        passive: true
    });
    document1[domMethod]('contextmenu', swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', $74e74a0b53d40157$var$onResize, true);
    else swiper[swiperMethod]('observerUpdate', $74e74a0b53d40157$var$onResize, true);
    // Images loader
    el[domMethod]('load', swiper.onLoad, {
        capture: true
    });
};
function $74e74a0b53d40157$var$attachEvents() {
    const swiper = this;
    const { params: params } = swiper;
    swiper.onTouchStart = $74e74a0b53d40157$var$onTouchStart.bind(swiper);
    swiper.onTouchMove = $74e74a0b53d40157$var$onTouchMove.bind(swiper);
    swiper.onTouchEnd = $74e74a0b53d40157$var$onTouchEnd.bind(swiper);
    swiper.onDocumentTouchStart = $74e74a0b53d40157$var$onDocumentTouchStart.bind(swiper);
    if (params.cssMode) swiper.onScroll = $74e74a0b53d40157$var$onScroll.bind(swiper);
    swiper.onClick = $74e74a0b53d40157$var$onClick.bind(swiper);
    swiper.onLoad = $74e74a0b53d40157$var$onLoad.bind(swiper);
    $74e74a0b53d40157$var$events(swiper, 'on');
}
function $74e74a0b53d40157$var$detachEvents() {
    const swiper = this;
    $74e74a0b53d40157$var$events(swiper, 'off');
}
var $74e74a0b53d40157$var$events$1 = {
    attachEvents: $74e74a0b53d40157$var$attachEvents,
    detachEvents: $74e74a0b53d40157$var$detachEvents
};
const $74e74a0b53d40157$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $74e74a0b53d40157$var$setBreakpoint() {
    const swiper = this;
    const { realIndex: realIndex, initialized: initialized, params: params, el: el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    // Get breakpoint for window/container width and update parameters
    const breakpointsBase = params.breakpointsBase === 'window' || !params.breakpointsBase ? params.breakpointsBase : 'container';
    const breakpointContainer = [
        'window',
        'container'
    ].includes(params.breakpointsBase) || !params.breakpointsBase ? swiper.el : document1.querySelector(params.breakpointsBase);
    const breakpoint = swiper.getBreakpoint(breakpoints, breakpointsBase, breakpointContainer);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $74e74a0b53d40157$var$isGridEnabled(swiper, params);
    const isMultiRow = $74e74a0b53d40157$var$isGridEnabled(swiper, breakpointParams);
    const wasGrabCursor = swiper.params.grabCursor;
    const isGrabCursor = breakpointParams.grabCursor;
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    }
    if (wasGrabCursor && !isGrabCursor) swiper.unsetGrabCursor();
    else if (!wasGrabCursor && isGrabCursor) swiper.setGrabCursor();
    // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        if (typeof breakpointParams[prop] === 'undefined') return;
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    const wasLoop = params.loop;
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    const hasLoop = swiper.params.loop;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (initialized) {
        if (needsReLoop) {
            swiper.loopDestroy();
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (!wasLoop && hasLoop) {
            swiper.loopCreate(realIndex);
            swiper.updateSlides();
        } else if (wasLoop && !hasLoop) swiper.loopDestroy();
    }
    swiper.emit('breakpoint', breakpointParams);
}
function $74e74a0b53d40157$var$getBreakpoint(breakpoints, base, containerEl) {
    if (base === void 0) base = 'window';
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window1 = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    const currentHeight = base === 'window' ? window1.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window1.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}
var $74e74a0b53d40157$var$breakpoints = {
    setBreakpoint: $74e74a0b53d40157$var$setBreakpoint,
    getBreakpoint: $74e74a0b53d40157$var$getBreakpoint
};
function $74e74a0b53d40157$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $74e74a0b53d40157$var$addClasses() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, el: el, device: device } = swiper;
    // prettier-ignore
    const suffixes = $74e74a0b53d40157$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    el.classList.add(...classNames);
    swiper.emitContainerClasses();
}
function $74e74a0b53d40157$var$removeClasses() {
    const swiper = this;
    const { el: el, classNames: classNames } = swiper;
    if (!el || typeof el === 'string') return;
    el.classList.remove(...classNames);
    swiper.emitContainerClasses();
}
var $74e74a0b53d40157$var$classes = {
    addClasses: $74e74a0b53d40157$var$addClasses,
    removeClasses: $74e74a0b53d40157$var$removeClasses
};
function $74e74a0b53d40157$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $74e74a0b53d40157$var$checkOverflow$1 = {
    checkOverflow: $74e74a0b53d40157$var$checkOverflow
};
var $74e74a0b53d40157$export$4368d992c4eafac0 = {
    init: true,
    direction: 'horizontal',
    oneWayMovement: false,
    swiperElementNodeName: 'SWIPER-CONTAINER',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    eventsPrefix: 'swiper',
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopAddBlankSlides: true,
    loopAdditionalSlides: 0,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-blank',
    slideActiveClass: 'swiper-slide-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideFullyVisibleClass: 'swiper-slide-fully-visible',
    slideNextClass: 'swiper-slide-next',
    slidePrevClass: 'swiper-slide-prev',
    wrapperClass: 'swiper-wrapper',
    lazyPreloaderClass: 'swiper-lazy-preloader',
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};
function $74e74a0b53d40157$var$moduleExtendParams(params, allModulesParams) {
    return function extendParams(obj) {
        if (obj === void 0) obj = {};
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) params[moduleParamName].auto = true;
        if ([
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) params[moduleParamName].auto = true;
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)(allModulesParams, obj);
            return;
        }
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)(allModulesParams, obj);
    };
}
/* eslint no-param-reassign: "off" */ const $74e74a0b53d40157$var$prototypes = {
    eventsEmitter: $74e74a0b53d40157$var$eventsEmitter,
    update: $74e74a0b53d40157$var$update,
    translate: $74e74a0b53d40157$var$translate,
    transition: $74e74a0b53d40157$var$transition,
    slide: $74e74a0b53d40157$var$slide,
    loop: $74e74a0b53d40157$var$loop,
    grabCursor: $74e74a0b53d40157$var$grabCursor,
    events: $74e74a0b53d40157$var$events$1,
    breakpoints: $74e74a0b53d40157$var$breakpoints,
    checkOverflow: $74e74a0b53d40157$var$checkOverflow$1,
    classes: $74e74a0b53d40157$var$classes
};
const $74e74a0b53d40157$var$extendedDefaults = {};
class $74e74a0b53d40157$export$25ce5a424b770e84 {
    constructor(){
        let el;
        let params;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, params);
        if (el && !params.el) params.el = el;
        const document1 = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        if (params.el && typeof params.el === 'string' && document1.querySelectorAll(params.el).length > 1) {
            const swipers = [];
            document1.querySelectorAll(params.el).forEach((containerEl)=>{
                const newParams = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, params, {
                    el: containerEl
                });
                swipers.push(new $74e74a0b53d40157$export$25ce5a424b770e84(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = $74e74a0b53d40157$var$getSupport();
        swiper.device = $74e74a0b53d40157$var$getDevice({
            userAgent: params.userAgent
        });
        swiper.browser = $74e74a0b53d40157$var$getBrowser();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                params: params,
                swiper: swiper,
                extendParams: $74e74a0b53d40157$var$moduleExtendParams(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        const swiperParams = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, $74e74a0b53d40157$export$4368d992c4eafac0, allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, swiperParams, $74e74a0b53d40157$var$extendedDefaults, params);
        swiper.originalParams = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, swiper.params);
        swiper.passedParams = (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment () {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                pointerId: null,
                touchId: null
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper');
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    getDirectionLabel(property) {
        if (this.isHorizontal()) return property;
        // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    getSlideIndex(slideEl) {
        const { slidesEl: slidesEl, params: params } = this;
        const slides = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
        const firstSlideIndex = (0, $c3b7d8492a069cd1$export$23f2a1d2818174ef)(slides[0]);
        return (0, $c3b7d8492a069cd1$export$23f2a1d2818174ef)(slideEl) - firstSlideIndex;
    }
    getSlideIndexByData(index) {
        return this.getSlideIndex(this.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') * 1 === index));
    }
    recalcSlides() {
        const swiper = this;
        const { slidesEl: slidesEl, params: params } = swiper;
        swiper.slides = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(slidesEl, `.${params.slideClass}, swiper-slide`);
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.forEach((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view, exact) {
        if (view === void 0) view = 'current';
        if (exact === void 0) exact = false;
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (typeof params.slidesPerView === 'number') return params.slidesPerView;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += Math.ceil(slides[i].swiperSlideSize);
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper;
        // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ].forEach((imageEl)=>{
            if (imageEl.complete) $74e74a0b53d40157$var$processLazyPreloader(swiper, imageEl);
        });
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
            setTranslate();
            if (params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                const slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                translated = swiper.slideTo(slides.length - 1, 0, false, true);
            } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.el.classList.remove(`${swiper.params.containerModifierClass}${currentDirection}`);
        swiper.el.classList.add(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.forEach((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.el.classList.add(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.el.classList.remove(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(element) {
        const swiper = this;
        if (swiper.mounted) return true;
        // Find el
        let el = element || swiper.params.el;
        if (typeof el === 'string') el = document.querySelector(el);
        if (!el) return false;
        el.swiper = swiper;
        if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) swiper.isElement = true;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = el.shadowRoot.querySelector(getWrapperSelector());
                // Children needs to return slot items
                return res;
            }
            return (0, $c3b7d8492a069cd1$export$f1e1789686576879)(el, getWrapperSelector())[0];
        };
        // Find Wrapper
        let wrapperEl = getWrapper();
        if (!wrapperEl && swiper.params.createElements) {
            wrapperEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', swiper.params.wrapperClass);
            el.append(wrapperEl);
            (0, $c3b7d8492a069cd1$export$f1e1789686576879)(el, `.${swiper.params.slideClass}`).forEach((slideEl)=>{
                wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            el: el,
            wrapperEl: wrapperEl,
            slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
            hostEl: swiper.isElement ? el.parentNode.host : el,
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || (0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(el, 'direction') === 'rtl'),
            wrongRTL: (0, $c3b7d8492a069cd1$export$9e5f44173e64f162)(wrapperEl, 'display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit');
        // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
        // Add Classes
        swiper.addClasses();
        // Update size
        swiper.updateSize();
        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        // Slide To Initial Slide
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
        // Create loop
        if (swiper.params.loop) swiper.loopCreate(undefined, true);
        // Attach events
        swiper.attachEvents();
        const lazyElements = [
            ...swiper.el.querySelectorAll('[loading="lazy"]')
        ];
        if (swiper.isElement) lazyElements.push(...swiper.hostEl.querySelectorAll('[loading="lazy"]'));
        lazyElements.forEach((imageEl)=>{
            if (imageEl.complete) $74e74a0b53d40157$var$processLazyPreloader(swiper, imageEl);
            else imageEl.addEventListener('load', (e)=>{
                $74e74a0b53d40157$var$processLazyPreloader(swiper, e.target);
            });
        });
        $74e74a0b53d40157$var$preload(swiper);
        // Init Flag
        swiper.initialized = true;
        $74e74a0b53d40157$var$preload(swiper);
        // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        const swiper = this;
        const { params: params, el: el, wrapperEl: wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy');
        // Init Flag
        swiper.initialized = false;
        // Detach events
        swiper.detachEvents();
        // Destroy loop
        if (params.loop) swiper.loopDestroy();
        // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            if (el && typeof el !== 'string') el.removeAttribute('style');
            if (wrapperEl) wrapperEl.removeAttribute('style');
            if (slides && slides.length) slides.forEach((slideEl)=>{
                slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                slideEl.removeAttribute('style');
                slideEl.removeAttribute('data-swiper-slide-index');
            });
        }
        swiper.emit('destroy');
        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            if (swiper.el && typeof swiper.el !== 'string') swiper.el.swiper = null;
            (0, $c3b7d8492a069cd1$export$4a5767248b18ef41)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $c3b7d8492a069cd1$export$d141bba7fdc215a3)($74e74a0b53d40157$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $74e74a0b53d40157$var$extendedDefaults;
    }
    static get defaults() {
        return $74e74a0b53d40157$export$4368d992c4eafac0;
    }
    static installModule(mod) {
        if (!$74e74a0b53d40157$export$25ce5a424b770e84.prototype.__modules__) $74e74a0b53d40157$export$25ce5a424b770e84.prototype.__modules__ = [];
        const modules = $74e74a0b53d40157$export$25ce5a424b770e84.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$74e74a0b53d40157$export$25ce5a424b770e84.installModule(m));
            return $74e74a0b53d40157$export$25ce5a424b770e84;
        }
        $74e74a0b53d40157$export$25ce5a424b770e84.installModule(module);
        return $74e74a0b53d40157$export$25ce5a424b770e84;
    }
}
Object.keys($74e74a0b53d40157$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($74e74a0b53d40157$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $74e74a0b53d40157$export$25ce5a424b770e84.prototype[protoMethod] = $74e74a0b53d40157$var$prototypes[prototypeGroup][protoMethod];
    });
});
$74e74a0b53d40157$export$25ce5a424b770e84.use([
    $74e74a0b53d40157$var$Resize,
    $74e74a0b53d40157$var$Observer
]);




function $7e125f42162cc6f1$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    const tempDOM = document.createElement('div');
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        let slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === 'string') {
                (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(tempDOM, slideEl);
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('swiper-slide');
        else slideEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', swiper.params.slideClass);
        slideEl.setAttribute('data-swiper-slide-index', index);
        if (!params.renderSlide) (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(slideEl, slide);
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    }
    function update(force, beforeInit, forceActiveIndex) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides, loop: isLoop, initialSlide: initialSlide } = swiper.params;
        if (beforeInit && !isLoop && initialSlide > 0) return;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = typeof forceActiveIndex === 'undefined' ? swiper.activeIndex || 0 : forceActiveIndex;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        let from = activeIndex - slidesBefore;
        let to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        let offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach((slideEl)=>{
                slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
            });
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        const getSlideIndex = (index)=>{
            let slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`)).forEach((slideEl)=>{
            slideEl.remove();
        });
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                const slideIndex = getSlideIndex(i);
                swiper.slides.filter((el)=>el.matches(`.${swiper.params.slideClass}[data-swiper-slide-index="${slideIndex}"], swiper-slide[data-swiper-slide-index="${slideIndex}"]`)).forEach((slideEl)=>{
                    slideEl.remove();
                });
            }
        }
        const loopFrom = isLoop ? -slides.length : 0;
        const loopTo = isLoop ? slides.length * 2 : slides.length;
        for(let i = loopFrom; i < loopTo; i += 1)if (i >= from && i <= to) {
            const slideIndex = getSlideIndex(i);
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(slideIndex);
            else {
                if (i > previousTo) appendIndexes.push(slideIndex);
                if (i < previousFrom) prependIndexes.push(slideIndex);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(let i = prependIndexes.length - 1; i >= 0; i -= 1){
            const index = prependIndexes[i];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort((a, b)=>b - a);
            prependIndexes.forEach((index)=>{
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.slidesEl, '.swiper-slide, swiper-slide').forEach((slideEl)=>{
            slideEl.style[offsetProp] = `${offset - Math.abs(swiper.cssOverflowAdjustment())}px`;
        });
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const cachedEl = cache[cachedIndex];
                const cachedElIndex = cachedEl.getAttribute('data-swiper-slide-index');
                if (cachedElIndex) cachedEl.setAttribute('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes[i]];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            if (swiper.params.virtual.cache) {
                delete swiper.virtual.cache[slidesIndexes];
                // shift cache indexes
                Object.keys(swiper.virtual.cache).forEach((key)=>{
                    if (key > slidesIndexes) {
                        swiper.virtual.cache[key - 1] = swiper.virtual.cache[key];
                        swiper.virtual.cache[key - 1].setAttribute('data-swiper-slide-index', key - 1);
                        delete swiper.virtual.cache[key];
                    }
                });
            }
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        let domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === 'undefined') {
            const slides = [
                ...swiper.slidesEl.children
            ].filter((el)=>el.matches(`.${swiper.params.slideClass}, swiper-slide`));
            if (slides && slides.length) {
                swiper.virtual.slides = [
                    ...slides
                ];
                domSlidesAssigned = true;
                slides.forEach((slideEl, slideIndex)=>{
                    slideEl.setAttribute('data-swiper-slide-index', slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        update(false, true);
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $c3b7d8492a069cd1$export$407448d2b89b1813)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}




/* eslint-disable consistent-return */ function $390c2ee4a2ffa6de$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideClass}, swiper-slide`).length > 0 && (0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(swiper.el, `.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const el = swiper.el;
            const swiperWidth = el.clientWidth;
            const swiperHeight = el.clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = (0, $c3b7d8492a069cd1$export$4368d992c4eafac0)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}




/* eslint-disable consistent-return */ function $6dccf879c26b7c90$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: 'swiper-no-mousewheel'
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $c3b7d8492a069cd1$export$2d1720544b23b823)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $c3b7d8492a069cd1$export$2d1720544b23b823)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(`.${swiper.params.mousewheel.noMousewheelClass}`)) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        const targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $c3b7d8492a069cd1$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $c3b7d8492a069cd1$export$2d1720544b23b823)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent.direction < 0 ? 'next' : 'prev',
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                            if (swiper.destroyed || !swiper.params) return;
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                        if (swiper.destroyed || !swiper.params) return;
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit('scroll', e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplay.disableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (params.releaseOnEdges && (position === swiper.minTranslate() || position === swiper.maxTranslate())) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]('mouseenter', handleMouseEnter);
        targetEl[method]('mouseleave', handleMouseLeave);
        targetEl[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('addEventListener');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('removeEventListener');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



function $a58bcccbb053fdd8$export$db3b6bfb95261072(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.el, `.${checkProps[key]}`)[0];
            if (!element) {
                element = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $cc696541be17c66f$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    function getEl(el) {
        let res;
        if (el && typeof el === 'string' && swiper.isElement) {
            res = swiper.el.querySelector(el) || swiper.hostEl.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === 'string') res = [
                ...document.querySelectorAll(el)
            ];
            if (swiper.params.uniqueNavElements && typeof el === 'string' && res && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
            else if (res && res.length === 1) res = res[0];
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    }
    function toggleEl(el, disabled) {
        const params = swiper.params.navigation;
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (subEl) {
                subEl.classList[disabled ? 'add' : 'remove'](...params.disabledClass.split(' '));
                if (subEl.tagName === 'BUTTON') subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
            }
        });
    }
    function update() {
        // Update Navigation Buttons
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $a58bcccbb053fdd8$export$db3b6bfb95261072)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        let nextEl = getEl(params.nextEl);
        let prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        const initButton = (el, dir)=>{
            if (el) el.addEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) el.classList.add(...params.lockClass.split(' '));
        };
        nextEl.forEach((el)=>initButton(el, 'next'));
        prevEl.forEach((el)=>initButton(el, 'prev'));
    }
    function destroy() {
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        const destroyButton = (el, dir)=>{
            el.removeEventListener('click', dir === 'next' ? onNextClick : onPrevClick);
            el.classList.remove(...swiper.params.navigation.disabledClass.split(' '));
        };
        nextEl.forEach((el)=>destroyButton(el, 'next'));
        prevEl.forEach((el)=>destroyButton(el, 'prev'));
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        if (swiper.enabled) {
            update();
            return;
        }
        [
            ...nextEl,
            ...prevEl
        ].filter((el)=>!!el).forEach((el)=>el.classList.add(swiper.params.navigation.lockClass));
    });
    on('click', (_s, e)=>{
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        const targetEl = e.target;
        let targetIsButton = prevEl.includes(targetEl) || nextEl.includes(targetEl);
        if (swiper.isElement && !targetIsButton) {
            const path = e.path || e.composedPath && e.composedPath();
            if (path) targetIsButton = path.find((pathEl)=>nextEl.includes(pathEl) || prevEl.includes(pathEl));
        }
        if (swiper.params.navigation.hideOnClick && !targetIsButton) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            [
                ...nextEl,
                ...prevEl
            ].filter((el)=>!!el).forEach((el)=>el.classList.toggle(swiper.params.navigation.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(...swiper.params.navigation.navigationDisabledClass.split(' '));
        init();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(...swiper.params.navigation.navigationDisabledClass.split(' '));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}


function $df13f0d950a3a860$export$db3b6bfb95261072(classes) {
    if (classes === void 0) classes = '';
    return `.${classes.trim().replace(/([\.:!+\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}




function $883746983c7b8061$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    }
    function setSideBullets(bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        if (!bulletEl) return;
        bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
        if (bulletEl) {
            bulletEl.classList.add(`${bulletActiveClass}-${position}`);
            bulletEl = bulletEl[`${position === 'prev' ? 'previous' : 'next'}ElementSibling`];
            if (bulletEl) bulletEl.classList.add(`${bulletActiveClass}-${position}-${position}`);
        }
    }
    function getMoveDirection(prevIndex, nextIndex, length) {
        prevIndex = prevIndex % length;
        nextIndex = nextIndex % length;
        if (nextIndex === prevIndex + 1) return 'next';
        else if (nextIndex === prevIndex - 1) return 'previous';
        return;
    }
    function onBulletClick(e) {
        const bulletEl = e.target.closest((0, $df13f0d950a3a860$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        const index = (0, $c3b7d8492a069cd1$export$23f2a1d2818174ef)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            const moveDirection = getMoveDirection(swiper.realIndex, index, swiper.slides.length);
            if (moveDirection === 'next') swiper.slideNext();
            else if (moveDirection === 'previous') swiper.slidePrev();
            else swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        // Current/Total
        let current;
        let previousIndex;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== 'undefined') {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $c3b7d8492a069cd1$export$dda1d9f60106f0e9)(bullets[0], swiper.isHorizontal() ? 'width' : 'height', true);
                el.forEach((subEl)=>{
                    subEl.style[swiper.isHorizontal() ? 'width' : 'height'] = `${bulletSize * (params.dynamicMainBullets + 4)}px`;
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach((bulletEl)=>{
                const classesToRemove = [
                    ...[
                        '',
                        '-next',
                        '-next-next',
                        '-prev',
                        '-prev-prev',
                        '-main'
                    ].map((suffix)=>`${params.bulletActiveClass}${suffix}`)
                ].map((s)=>typeof s === 'string' && s.includes(' ') ? s.split(' ') : s).flat();
                bulletEl.classList.remove(...classesToRemove);
            });
            if (el.length > 1) bullets.forEach((bullet)=>{
                const bulletIndex = (0, $c3b7d8492a069cd1$export$23f2a1d2818174ef)(bullet);
                if (bulletIndex === current) bullet.classList.add(...params.bulletActiveClass.split(' '));
                else if (swiper.isElement) bullet.setAttribute('part', 'bullet');
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) bullet.classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets(bullet, 'next');
                }
            });
            else {
                const bullet = bullets[current];
                if (bullet) bullet.classList.add(...params.bulletActiveClass.split(' '));
                if (swiper.isElement) bullets.forEach((bulletEl, bulletIndex)=>{
                    bulletEl.setAttribute('part', bulletIndex === current ? 'bullet-active' : 'bullet');
                });
                if (params.dynamicBullets) {
                    const firstDisplayedBullet = bullets[firstIndex];
                    const lastDisplayedBullet = bullets[lastIndex];
                    for(let i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) bullets[i].classList.add(...`${params.bulletActiveClass}-main`.split(' '));
                    setSideBullets(firstDisplayedBullet, 'prev');
                    setSideBullets(lastDisplayedBullet, 'next');
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.forEach((bullet)=>{
                    bullet.style[swiper.isHorizontal() ? offsetProp : 'top'] = `${bulletsOffset}px`;
                });
            }
        }
        el.forEach((subEl, subElIndex)=>{
            if (params.type === 'fraction') {
                subEl.querySelectorAll((0, $df13f0d950a3a860$export$db3b6bfb95261072)(params.currentClass)).forEach((fractionEl)=>{
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $df13f0d950a3a860$export$db3b6bfb95261072)(params.totalClass)).forEach((totalEl)=>{
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === 'progressbar') {
                let progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                const scale = (current + 1) / total;
                let scaleX = 1;
                let scaleY = 1;
                if (progressbarDirection === 'horizontal') scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $df13f0d950a3a860$export$db3b6bfb95261072)(params.progressbarFillClass)).forEach((progressEl)=>{
                    progressEl.style.transform = `translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`;
                    progressEl.style.transitionDuration = `${swiper.params.speed}ms`;
                });
            }
            if (params.type === 'custom' && params.renderCustom) {
                (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(subEl, params.renderCustom(swiper, current + 1, total));
                if (subElIndex === 0) emit('paginationRender', subEl);
            } else {
                if (subElIndex === 0) emit('paginationRender', subEl);
                emit('paginationUpdate', subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? 'add' : 'remove'](params.lockClass);
        });
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.grid && swiper.params.grid.rows > 1 ? swiper.slides.length / Math.ceil(swiper.params.grid.rows) : swiper.slides.length;
        let el = swiper.pagination.el;
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += `<${params.bulletElement} ${swiper.isElement ? 'part="bullet"' : ''} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
        }
        swiper.pagination.bullets = [];
        el.forEach((subEl)=>{
            if (params.type !== 'custom') (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(subEl, paginationHTML || '');
            if (params.type === 'bullets') swiper.pagination.bullets.push(...subEl.querySelectorAll((0, $df13f0d950a3a860$export$db3b6bfb95261072)(params.bulletClass)));
        });
        if (params.type !== 'custom') emit('paginationRender', el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $a58bcccbb053fdd8$export$db3b6bfb95261072)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') el = [
            ...document.querySelectorAll(params.el)
        ];
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && Array.isArray(el) && el.length > 1) {
            el = [
                ...swiper.el.querySelectorAll(params.el)
            ];
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.find((subEl)=>{
                if ((0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(subEl, '.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            if (params.type === 'bullets' && params.clickable) subEl.classList.add(...(params.clickableClass || '').split(' '));
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === 'bullets' && params.dynamicBullets) {
                subEl.classList.add(`${params.modifierClass}${params.type}-dynamic`);
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === 'progressbar' && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener('click', onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        let el = swiper.pagination.el;
        if (el) {
            el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>{
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) {
                    subEl.classList.remove(...(params.clickableClass || '').split(' '));
                    subEl.removeEventListener('click', onBulletClick);
                }
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach((subEl)=>subEl.classList.remove(...params.bulletActiveClass.split(' ')));
    }
    on('changeDirection', ()=>{
        if (!swiper.pagination || !swiper.pagination.el) return;
        const params = swiper.params.pagination;
        let { el: el } = swiper.pagination;
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        update();
    });
    on('snapGridLengthChange', ()=>{
        render();
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList[swiper.enabled ? 'remove' : 'add'](swiper.params.pagination.lockClass));
        }
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(swiper.pagination.el);
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            el.forEach((subEl)=>subEl.classList.toggle(swiper.params.pagination.hiddenClass));
        }
    });
    const enable = ()=>{
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.remove(swiper.params.pagination.paginationDisabledClass));
        }
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        let { el: el } = swiper.pagination;
        if (el) {
            el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
            el.forEach((subEl)=>subEl.classList.add(swiper.params.pagination.paginationDisabledClass));
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}






function $61bb2313398e74b2$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        const params = swiper.params.scrollbar;
        const progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
            dragEl.style.width = `${newSize}px`;
        } else {
            dragEl.style.transform = `translate3d(0px, ${newPos}px, 0)`;
            dragEl.style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = `${duration}ms`;
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { dragEl: dragEl, el: el } = scrollbar;
        dragEl.style.width = '';
        dragEl.style.height = '';
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = `${dragSize}px`;
        else dragEl.style.height = `${dragSize}px`;
        if (divider >= 1) el.style.display = 'none';
        else el.style.display = '';
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? 'add' : 'remove'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { el: el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $c3b7d8492a069cd1$export$4368d992c4eafac0)(el)[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = '100ms';
        dragEl.style.transitionDuration = '100ms';
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = '0ms';
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style['scroll-snap-type'] = 'none';
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el, dragEl: dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault && e.cancelable) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = '0ms';
        el.style.transitionDuration = '0ms';
        dragEl.style.transitionDuration = '0ms';
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, wrapperEl: wrapperEl } = swiper;
        const { el: el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style['scroll-snap-type'] = '';
            wrapperEl.style.transitionDuration = '';
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                el.style.opacity = 0;
                el.style.transitionDuration = '400ms';
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, params: params } = swiper;
        const el = scrollbar.el;
        if (!el) return;
        const target = el;
        const activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        target[eventMethod]('pointerdown', onDragStart, activeListener);
        document[eventMethod]('pointermove', onDragMove, activeListener);
        document[eventMethod]('pointerup', onDragEnd, passiveListener);
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, el: swiperEl } = swiper;
        swiper.params.scrollbar = (0, $a58bcccbb053fdd8$export$db3b6bfb95261072)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let el;
        if (typeof params.el === 'string' && swiper.isElement) el = swiper.el.querySelector(params.el);
        if (!el && typeof params.el === 'string') {
            el = document.querySelectorAll(params.el);
            if (!el.length) return;
        } else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let dragEl;
        if (el) {
            dragEl = el.querySelector((0, $df13f0d950a3a860$export$db3b6bfb95261072)(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const el = swiper.scrollbar.el;
        if (el) el.classList.remove(...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass));
        disableDraggable();
    }
    on('changeDirection', ()=>{
        if (!swiper.scrollbar || !swiper.scrollbar.el) return;
        const params = swiper.params.scrollbar;
        let { el: el } = swiper.scrollbar;
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock changeDirection', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { el: el } = swiper.scrollbar;
        if (el) el.classList[swiper.enabled ? 'remove' : 'add'](...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.lockClass));
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.el.classList.remove(...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.el.classList.add(...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(...(0, $c3b7d8492a069cd1$export$35e795649ee09318)(swiper.params.scrollbar.scrollbarDisabledClass));
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $416b1fec97095383$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const elementsSelector = '[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]';
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const rtlFactor = rtl ? -1 : 1;
        const p = el.getAttribute('data-swiper-parallax') || '0';
        let x = el.getAttribute('data-swiper-parallax-x');
        let y = el.getAttribute('data-swiper-parallax-y');
        const scale = el.getAttribute('data-swiper-parallax-scale');
        const opacity = el.getAttribute('data-swiper-parallax-opacity');
        const rotate = el.getAttribute('data-swiper-parallax-rotate');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        let transform = `translate3d(${x}, ${y}, 0px)`;
        if (typeof scale !== 'undefined' && scale !== null) {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += ` scale(${currentScale})`;
        }
        if (rotate && typeof rotate !== 'undefined' && rotate !== null) {
            const currentRotate = rotate * progress * -1;
            transform += ` rotate(${currentRotate}deg)`;
        }
        el.style.transform = transform;
    };
    const setTranslate = ()=>{
        const { el: el, slides: slides, progress: progress, snapGrid: snapGrid, isElement: isElement } = swiper;
        const elements = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(el, elementsSelector);
        if (swiper.isElement) elements.push(...(0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.hostEl, elementsSelector));
        elements.forEach((subEl)=>{
            setTransform(subEl, progress);
        });
        slides.forEach((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll(`${elementsSelector}, [data-swiper-parallax-rotate]`).forEach((subEl)=>{
                setTransform(subEl, slideProgress);
            });
        });
    };
    const setTransition = function(duration) {
        if (duration === void 0) duration = swiper.params.speed;
        const { el: el, hostEl: hostEl } = swiper;
        const elements = [
            ...el.querySelectorAll(elementsSelector)
        ];
        if (swiper.isElement) elements.push(...hostEl.querySelectorAll(elementsSelector));
        elements.forEach((parallaxEl)=>{
            let parallaxDuration = parseInt(parallaxEl.getAttribute('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = `${parallaxDuration}ms`;
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}




function $a4ef667c3ef7caf7$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit } = _ref;
    const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    extendParams({
        zoom: {
            enabled: false,
            limitToOriginalSize: false,
            maxRatio: 3,
            minRatio: 1,
            panOnMouseMove: false,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let isPanningWithMouse = false;
    let mousePanStart = {
        x: 0,
        y: 0
    };
    const mousePanSensitivity = -3; // Negative to invert pan direction
    let fakeGestureTouched;
    let fakeGestureMoved;
    const evCache = [];
    const gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.imageEl;
                const slideEl = gesture.slideEl;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        const x1 = evCache[0].pageX;
        const y1 = evCache[0].pageY;
        const x2 = evCache[1].pageX;
        const y2 = evCache[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    }
    function getMaxRatio() {
        const params = swiper.params.zoom;
        const maxRatio = gesture.imageWrapEl.getAttribute('data-swiper-zoom') || params.maxRatio;
        if (params.limitToOriginalSize && gesture.imageEl && gesture.imageEl.naturalWidth) {
            const imageMaxRatio = gesture.imageEl.naturalWidth / gesture.imageEl.offsetWidth;
            return Math.min(imageMaxRatio, maxRatio);
        }
        return maxRatio;
    }
    function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        const box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x - window.scrollX) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y - window.scrollY) / currentScale
        ];
    }
    function getSlideSelector() {
        return swiper.isElement ? `swiper-slide` : `.${swiper.params.slideClass}`;
    }
    function eventWithinSlide(e) {
        const slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter((slideEl)=>slideEl.contains(e.target)).length > 0) return true;
        return false;
    }
    function eventWithinZoomContainer(e) {
        const selector = `.${swiper.params.zoom.containerClass}`;
        if (e.target.matches(selector)) return true;
        if ([
            ...swiper.hostEl.querySelectorAll(selector)
        ].filter((containerEl)=>containerEl.contains(e.target)).length > 0) return true;
        return false;
    }
    // Events
    function onGestureStart(e) {
        if (e.pointerType === 'mouse') evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = getMaxRatio();
        }
        if (gesture.imageEl) {
            const [originX, originY] = getScaleOrigin();
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = '0ms';
        }
        isScaling = true;
    }
    function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === 'mouse' && e.type === 'pointerout') return;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        const pointerIndex = evCache.findIndex((cachedEv)=>cachedEv.pointerId === e.pointerId);
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = `${swiper.params.speed}ms`;
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    }
    let allowTouchMoveTimeout;
    function allowTouchMove() {
        swiper.touchEventsData.preventTouchMoveFromPointerMove = false;
    }
    function preventTouchMove() {
        clearTimeout(allowTouchMoveTimeout);
        swiper.touchEventsData.preventTouchMoveFromPointerMove = true;
        allowTouchMoveTimeout = setTimeout(()=>{
            if (swiper.destroyed) return;
            allowTouchMove();
        });
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        const event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    }
    function onTouchMove(e) {
        const isMouseEvent = e.pointerType === 'mouse';
        const isMousePan = isMouseEvent && swiper.params.zoom.panOnMouseMove;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) {
            if (isMousePan) onMouseMove(e);
            return;
        }
        if (isMousePan) {
            onMouseMove(e);
            return;
        }
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            image.startX = (0, $c3b7d8492a069cd1$export$342063e11d6c3cad)(gesture.imageWrapEl, 'x') || 0;
            image.startY = (0, $c3b7d8492a069cd1$export$342063e11d6c3cad)(gesture.imageWrapEl, 'y') || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = '0ms';
        }
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        const touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                allowTouchMove();
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        preventTouchMove();
        image.isMoved = true;
        const scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        const { originX: originX, originY: originY } = gesture;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        evCache.length = 0;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = `${momentumDuration}ms`;
        gesture.imageWrapEl.style.transform = `translate3d(${image.currentX}px, ${image.currentY}px,0)`;
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
            gesture.slideEl.classList.remove(`${swiper.params.zoom.zoomedSlideClass}`);
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    }
    function onMouseMove(e) {
        // Only pan if zoomed in and mouse panning is enabled
        if (currentScale <= 1 || !gesture.imageWrapEl) return;
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        const currentTransform = window.getComputedStyle(gesture.imageWrapEl).transform;
        const matrix = new window.DOMMatrix(currentTransform);
        if (!isPanningWithMouse) {
            isPanningWithMouse = true;
            mousePanStart.x = e.clientX;
            mousePanStart.y = e.clientY;
            image.startX = matrix.e;
            image.startY = matrix.f;
            image.width = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            image.height = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            return;
        }
        const deltaX = (e.clientX - mousePanStart.x) * mousePanSensitivity;
        const deltaY = (e.clientY - mousePanStart.y) * mousePanSensitivity;
        const scaledWidth = image.width * currentScale;
        const scaledHeight = image.height * currentScale;
        const slideWidth = gesture.slideWidth;
        const slideHeight = gesture.slideHeight;
        const minX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
        const maxX = -minX;
        const minY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
        const maxY = -minY;
        const newX = Math.max(Math.min(image.startX + deltaX, maxX), minX);
        const newY = Math.max(Math.min(image.startY + deltaY, maxY), minY);
        gesture.imageWrapEl.style.transitionDuration = '0ms';
        gesture.imageWrapEl.style.transform = `translate3d(${newX}px, ${newY}px, 0)`;
        mousePanStart.x = e.clientX;
        mousePanStart.y = e.clientY;
        image.startX = newX;
        image.startY = newY;
        image.currentX = newX;
        image.currentY = newY;
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.slideEl.classList.add(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        const prevScale = currentScale;
        const forceZoomRatio = typeof e === 'number' ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
            image.touchesStart.x = undefined;
            image.touchesStart.y = undefined;
        }
        const maxRatio = getMaxRatio();
        zoom.scale = forceZoomRatio || maxRatio;
        currentScale = forceZoomRatio || maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $c3b7d8492a069cd1$export$4368d992c4eafac0)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $c3b7d8492a069cd1$export$4368d992c4eafac0)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth || gesture.imageEl.clientWidth;
            imageHeight = gesture.imageEl.offsetHeight || gesture.imageEl.clientHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            if (prevScale > 0 && forceZoomRatio && typeof image.currentX === 'number' && typeof image.currentY === 'number') {
                translateX = image.currentX * zoom.scale / prevScale;
                translateY = image.currentY * zoom.scale / prevScale;
            } else {
                translateX = diffX * zoom.scale;
                translateY = diffY * zoom.scale;
            }
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        image.currentX = translateX;
        image.currentY = translateY;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = `translate3d(${translateX}px, ${translateY}px,0)`;
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = `translate3d(0,0,0) scale(${zoom.scale})`;
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideActiveClass}`)[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            let imageEl = gesture.slideEl.querySelector(`.${params.containerClass}`);
            if (imageEl) imageEl = imageEl.querySelectorAll('picture, img, svg, canvas, .swiper-zoom-target')[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $c3b7d8492a069cd1$export$8b22cf2602fb60ce)(gesture.imageEl, `.${params.containerClass}`)[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        image.currentX = undefined;
        image.currentY = undefined;
        image.touchesStart.x = undefined;
        image.touchesStart.y = undefined;
        gesture.imageWrapEl.style.transitionDuration = '300ms';
        gesture.imageWrapEl.style.transform = 'translate3d(0,0,0)';
        gesture.imageEl.style.transitionDuration = '300ms';
        gesture.imageEl.style.transform = 'translate3d(0,0,0) scale(1)';
        gesture.slideEl.classList.remove(`${params.zoomedSlideClass}`);
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
        if (swiper.params.zoom.panOnMouseMove) {
            mousePanStart = {
                x: 0,
                y: 0
            };
            if (isPanningWithMouse) {
                isPanningWithMouse = false;
                image.startX = 0;
                image.startY = 0;
            }
        }
    }
    // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.addEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        // Scale image
        swiper.wrapperEl.removeEventListener('pointerdown', onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener('pointermove', onGestureChange, activeListenerWithCapture);
        [
            'pointerup',
            'pointercancel',
            'pointerout'
        ].forEach((eventName)=>{
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener('pointermove', onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd();
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ function $d977cbb283301583$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    }
    function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $c3b7d8492a069cd1$export$7ccc53e8f1e7dfc5)(()=>{
                    c.updateAutoHeight();
                });
                (0, $c3b7d8492a069cd1$export$882b5998b3b9117c)(c.wrapperEl, ()=>{
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        if (typeof window !== 'undefined' && // eslint-disable-line
        (typeof swiper.params.controller.control === 'string' || swiper.params.controller.control instanceof HTMLElement)) {
            const controlElements = typeof swiper.params.controller.control === 'string' ? [
                ...document.querySelectorAll(swiper.params.controller.control)
            ] : [
                swiper.params.controller.control
            ];
            controlElements.forEach((controlElement)=>{
                if (!swiper.controller.control) swiper.controller.control = [];
                if (controlElement && controlElement.swiper) swiper.controller.control.push(controlElement.swiper);
                else if (controlElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onControllerSwiper = (e)=>{
                        swiper.controller.control.push(e.detail[0]);
                        swiper.update();
                        controlElement.removeEventListener(eventName, onControllerSwiper);
                    };
                    controlElement.addEventListener(eventName, onControllerSwiper);
                }
            });
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}





function $7d2dcaff04688711$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            containerRole: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null,
            scrollOnFocus: true
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    let preventFocusHandler;
    let focusTargetSlideEl;
    let visibilityChangedTimestamp = new Date().getTime();
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(notification, message);
    }
    function getRandomNumber(size) {
        if (size === void 0) size = 16;
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable(el) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '0');
        });
    }
    function makeElNotFocusable(el) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('tabIndex', '-1');
        });
    }
    function addElRole(el, role) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('role', role);
        });
    }
    function addElRoleDescription(el, description) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-roledescription', description);
        });
    }
    function addElControls(el, controls) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-controls', controls);
        });
    }
    function addElLabel(el, label) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-label', label);
        });
    }
    function addElId(el, id) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('id', id);
        });
    }
    function addElLive(el, live) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-live', live);
        });
    }
    function disableEl(el) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', true);
        });
    }
    function enableEl(el) {
        el = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(el);
        el.forEach((subEl)=>{
            subEl.setAttribute('aria-disabled', false);
        });
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $df13f0d950a3a860$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.prevEl && swiper.navigation.nextEl) {
            const prevEls = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(swiper.navigation.prevEl);
            const nextEls = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(swiper.navigation.nextEl);
            if (nextEls.includes(targetEl)) {
                if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
                if (swiper.isEnd) notify(params.lastSlideMessage);
                else notify(params.nextSlideMessage);
            }
            if (prevEls.includes(targetEl)) {
                if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
                if (swiper.isBeginning) notify(params.firstSlideMessage);
                else notify(params.prevSlideMessage);
            }
        }
        if (swiper.pagination && targetEl.matches((0, $df13f0d950a3a860$export$db3b6bfb95261072)(swiper.params.pagination.bulletClass))) targetEl.click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { nextEl: nextEl, prevEl: prevEl } = swiper.navigation;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach((bulletEl)=>{
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, 'button');
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $c3b7d8492a069cd1$export$23f2a1d2818174ef)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $df13f0d950a3a860$export$db3b6bfb95261072)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute('aria-current', 'true');
            else bulletEl.removeAttribute('aria-current');
        });
    }
    const initNavEl = (el, wrapperId, message)=>{
        makeElFocusable(el);
        if (el.tagName !== 'BUTTON') {
            addElRole(el, 'button');
            el.addEventListener('keydown', onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    const handlePointerDown = (e)=>{
        if (focusTargetSlideEl && focusTargetSlideEl !== e.target && !focusTargetSlideEl.contains(e.target)) preventFocusHandler = true;
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        preventFocusHandler = false;
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const onVisibilityChange = (e)=>{
        visibilityChangedTimestamp = new Date().getTime();
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked || !swiper.params.a11y.scrollOnFocus) return;
        if (new Date().getTime() - visibilityChangedTimestamp < 100) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}, swiper-slide`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        focusTargetSlideEl = slideEl;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        requestAnimationFrame(()=>{
            if (preventFocusHandler) return;
            if (swiper.params.loop) swiper.slideToLoop(parseInt(slideEl.getAttribute('data-swiper-slide-index')), 0);
            else swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
            preventFocusHandler = false;
        });
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        const slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach((slideEl, index)=>{
            const slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.el.append(liveRegion);
        // Container
        const containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        if (params.containerRole) addElRole(containerEl, params.containerRole);
        // Wrapper
        const wrapperEl = swiper.wrapperEl;
        const wrapperId = params.id || wrapperEl.getAttribute('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>initNavEl(el, wrapperId, params.nextSlideMessage));
        if (prevEl) prevEl.forEach((el)=>initNavEl(el, wrapperId, params.prevSlideMessage));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.addEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        // Tab focus
        const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('focus', handleFocus, true);
        swiper.el.addEventListener('pointerdown', handlePointerDown, true);
        swiper.el.addEventListener('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion) liveRegion.remove();
        let { nextEl: nextEl, prevEl: prevEl } = swiper.navigation ? swiper.navigation : {};
        nextEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(nextEl);
        prevEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(prevEl);
        if (nextEl) nextEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        if (prevEl) prevEl.forEach((el)=>el.removeEventListener('keydown', onEnterOrSpaceKey));
        // Pagination
        if (hasClickablePagination()) {
            const paginationEl = (0, $c3b7d8492a069cd1$export$953cecd6e717a553)(swiper.pagination.el);
            paginationEl.forEach((el)=>{
                el.removeEventListener('keydown', onEnterOrSpaceKey);
            });
        }
        const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
        // Tab focus
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('focus', handleFocus, true);
            swiper.el.removeEventListener('pointerdown', handlePointerDown, true);
            swiper.el.removeEventListener('pointerup', handlePointerUp, true);
        }
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('span', swiper.params.a11y.notificationClass);
        liveRegion.setAttribute('aria-live', 'assertive');
        liveRegion.setAttribute('aria-atomic', 'true');
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $6848c0e8979c4786$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${index}"]`) : swiper.slides[index];
        let value = slugify(slide.getAttribute('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key ? `${key}/` : ''}${value}`;
        } else if (!location.pathname.includes(key)) value = `${key ? `${key}/` : ''}${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides[i];
            const slideHistory = slugify(slide.getAttribute('data-history'));
            if (slideHistory === value) {
                const index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $0f584d3903502d4e$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, on: on } = _ref;
    let initialized = false;
    const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
    const window = (0, $cd34a1485c0ed7aa$export$407448d2b89b1813)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex (_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    const slideWithHash = swiper.slides.find((slideEl)=>slideEl.getAttribute('data-hash') === hash);
                    if (!slideWithHash) return 0;
                    const index = parseInt(slideWithHash.getAttribute('data-swiper-slide-index'), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $c3b7d8492a069cd1$export$f1e1789686576879)(swiper.slidesEl, `.${swiper.params.slideClass}[data-hash="${hash}"], swiper-slide[data-hash="${hash}"]`)[0]);
            }
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') : '';
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === 'undefined' || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        const activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector(`[data-swiper-slide-index="${swiper.activeIndex}"]`) : swiper.slides[swiper.activeIndex];
        const activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute('data-hash') || activeSlideEl.getAttribute('data-history') : '';
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${activeSlideHash}` || '');
            emit('hashSet');
        } else {
            document.location.hash = activeSlideHash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            const index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) window.removeEventListener('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}



/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ function $4c8c320aaa69b88b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on, emit: emit, params: params } = _ref;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: false,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    let timeout;
    let raf;
    let autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    let autoplayTimeLeft;
    let autoplayStartTime = new Date().getTime();
    let wasPaused;
    let isTouched;
    let pausedByTouch;
    let touchStartTimeout;
    let slideChanged;
    let pausedByInteraction;
    let pausedByPointerEnter;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener('transitionend', onTransitionEnd);
        if (pausedByPointerEnter || e.detail && e.detail.bySwiperTouchMove) return;
        resume();
    }
    const calcTimeLeft = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        const timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit('autoplayTimeLeft', timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(()=>{
            calcTimeLeft();
        });
    };
    const getSlideDelay = ()=>{
        let activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.find((slideEl)=>slideEl.classList.contains('swiper-slide-active'));
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        const currentSlideDelay = parseInt(activeSlideEl.getAttribute('data-swiper-autoplay'), 10);
        return currentSlideDelay;
    };
    const run = (delayForce)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        let delay = typeof delayForce === 'undefined' ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        const currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === 'undefined') {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        const speed = swiper.params.speed;
        const proceed = ()=>{
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit('autoplay');
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit('autoplay');
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(()=>{
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                proceed();
            }, delay);
        } else requestAnimationFrame(()=>{
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    const start = ()=>{
        autoplayStartTime = new Date().getTime();
        swiper.autoplay.running = true;
        run();
        emit('autoplayStart');
    };
    const stop = ()=>{
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit('autoplayStop');
    };
    const pause = (internal, reset)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        const proceed = ()=>{
            emit('autoplayPause');
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener('transitionend', onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        const delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    const resume = ()=>{
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit('autoplayResume');
    };
    const onVisibilityChange = ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        if (document.visibilityState === 'hidden') {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === 'visible') resume();
    };
    const onPointerEnter = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByInteraction = true;
        pausedByPointerEnter = true;
        if (swiper.animating || swiper.autoplay.paused) return;
        pause(true);
    };
    const onPointerLeave = (e)=>{
        if (e.pointerType !== 'mouse') return;
        pausedByPointerEnter = false;
        if (swiper.autoplay.paused) resume();
    };
    const attachMouseEvents = ()=>{
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener('pointerenter', onPointerEnter);
            swiper.el.addEventListener('pointerleave', onPointerLeave);
        }
    };
    const detachMouseEvents = ()=>{
        if (swiper.el && typeof swiper.el !== 'string') {
            swiper.el.removeEventListener('pointerenter', onPointerEnter);
            swiper.el.removeEventListener('pointerleave', onPointerLeave);
        }
    };
    const attachDocumentEvents = ()=>{
        const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        document.addEventListener('visibilitychange', onVisibilityChange);
    };
    const detachDocumentEvents = ()=>{
        const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    };
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            start();
        }
    });
    on('destroy', ()=>{
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on('_freeModeStaticRelease', ()=>{
        if (pausedByTouch || pausedByInteraction) resume();
    });
    on('_freeModeNoMomentumRelease', ()=>{
        if (!swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on('sliderFirstMove', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(()=>{
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on('touchEnd', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on('slideChange', ()=>{
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $a925c1254d955523$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            if (thumbsParams.swiper.destroyed) {
                initialized = false;
                return false;
            }
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $c3b7d8492a069cd1$export$ae1af26003f05816)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach((slideEl)=>slideEl.classList.remove(thumbActiveClass));
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)(0, $c3b7d8492a069cd1$export$f1e1789686576879)(thumbsSwiper.slidesEl, `[data-swiper-slide-index="${swiper.realIndex + i}"]`).forEach((slideEl)=>{
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(let i = 0; i < thumbsToActivate; i += 1)if (thumbsSwiper.slides[swiper.realIndex + i]) thumbsSwiper.slides[swiper.realIndex + i].classList.add(thumbActiveClass);
        }
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            const currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                const newThumbsSlide = thumbsSwiper.slides.find((slideEl)=>slideEl.getAttribute('data-swiper-slide-index') === `${swiper.realIndex}`);
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === 'string' || thumbs.swiper instanceof HTMLElement) {
            const document = (0, $cd34a1485c0ed7aa$export$39b482c5e57630a8)();
            const getThumbsElementAndInit = ()=>{
                const thumbsElement = typeof thumbs.swiper === 'string' ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    const eventName = `${swiper.params.eventsPrefix}init`;
                    const onThumbsSwiper = (e)=>{
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener(eventName, onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener(eventName, onThumbsSwiper);
                }
                return thumbsElement;
            };
            const watchForThumbsToAppear = ()=>{
                if (swiper.destroyed) return;
                const thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $10891eb4d02aaaec$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, emit: emit, once: once } = _ref;
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        if (swiper.params.cssMode) return;
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        if (swiper.params.cssMode) return;
        const { touchEventsData: data, touches: touches } = swiper;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $c3b7d8492a069cd1$export$2d1720544b23b823)()
        });
    }
    function onTouchEnd(_ref2) {
        let { currentPos: currentPos } = _ref2;
        if (swiper.params.cssMode) return;
        const { params: params, wrapperEl: wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper;
        // Time diff
        const touchEndTime = (0, $c3b7d8492a069cd1$export$2d1720544b23b823)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $c3b7d8492a069cd1$export$2d1720544b23b823)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $c3b7d8492a069cd1$export$882b5998b3b9117c)(wrapperEl, ()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        (0, $c3b7d8492a069cd1$export$882b5998b3b9117c)(wrapperEl, ()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $c3b7d8492a069cd1$export$882b5998b3b9117c)(wrapperEl, ()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            emit('_freeModeStaticRelease');
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $d297191fe341a2a6$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    let wasMultiRow;
    const getSpaceBetween = ()=>{
        let spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
        else if (typeof spaceBetween === 'string') spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    const initSlides = (slides)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    const unsetSlides = ()=>{
        if (swiper.slides) swiper.slides.forEach((slide)=>{
            if (slide.swiperSlideGridSet) {
                slide.style.height = '';
                slide.style[swiper.getDirectionLabel('margin-top')] = '';
            }
        });
    };
    const updateSlide = (i, slide, slides)=>{
        const { slidesPerGroup: slidesPerGroup } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows, fill: fill } = swiper.params.grid;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : slides.length;
        // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style.height = `calc((100% - ${(rows - 1) * spaceBetween}px) / ${rows})`;
        slide.style[swiper.getDirectionLabel('margin-top')] = row !== 0 ? spaceBetween && `${spaceBetween}px` : '';
        slide.swiperSlideGridSet = true;
    };
    const updateWrapperSize = (slideSize, snapGrid)=>{
        const { centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const spaceBetween = getSpaceBetween();
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        if (!swiper.params.cssMode) swiper.wrapperEl.style[swiper.getDirectionLabel('width')] = `${swiper.virtualSize + spaceBetween}px`;
        if (centeredSlides) {
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            snapGrid.push(...newSlidesGrid);
        }
    };
    const onInit = ()=>{
        wasMultiRow = swiper.params.grid && swiper.params.grid.rows > 1;
    };
    const onUpdate = ()=>{
        const { params: params, el: el } = swiper;
        const isMultiRow = params.grid && params.grid.rows > 1;
        if (wasMultiRow && !isMultiRow) {
            el.classList.remove(`${params.containerModifierClass}grid`, `${params.containerModifierClass}grid-column`);
            numFullColumns = 1;
            swiper.emitContainerClasses();
        } else if (!wasMultiRow && isMultiRow) {
            el.classList.add(`${params.containerModifierClass}grid`);
            if (params.grid.fill === 'column') el.classList.add(`${params.containerModifierClass}grid-column`);
            swiper.emitContainerClasses();
        }
        wasMultiRow = isMultiRow;
    };
    on('init', onInit);
    on('update', onUpdate);
    swiper.grid = {
        initSlides: initSlides,
        unsetSlides: unsetSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}



function $b2e879065b74a820$var$appendSlide(slides) {
    const swiper = this;
    const { params: params, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    const appendElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.append(tempDOM.children[0]);
            (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}
function $b2e879065b74a820$var$prependSlide(slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    const prependElement = (slideEl)=>{
        if (typeof slideEl === 'string') {
            const tempDOM = document.createElement('div');
            (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(tempDOM, slideEl);
            slidesEl.prepend(tempDOM.children[0]);
            (0, $c3b7d8492a069cd1$export$2408f22a0fab9ae5)(tempDOM, '');
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}
function $b2e879065b74a820$var$addSlide(index, slides) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex, slidesEl: slidesEl } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) slidesEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)slidesEl.append(slidesBuffer[i]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $b2e879065b74a820$var$removeSlide(slidesIndexes) {
    const swiper = this;
    const { params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}
function $b2e879065b74a820$var$removeAllSlides() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}
function $b2e879065b74a820$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper } = _ref;
    Object.assign(swiper, {
        appendSlide: $b2e879065b74a820$var$appendSlide.bind(swiper),
        prependSlide: $b2e879065b74a820$var$prependSlide.bind(swiper),
        addSlide: $b2e879065b74a820$var$addSlide.bind(swiper),
        removeSlide: $b2e879065b74a820$var$removeSlide.bind(swiper),
        removeAllSlides: $b2e879065b74a820$var$removeAllSlides.bind(swiper)
    });
}


function $94ae428613873cd3$export$f1e1789686576879(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate _virtualUpdated', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach((slideEl)=>{
                slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>shadowEl.remove());
            });
            // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $9a09f206c8c28f8a$export$f1e1789686576879(effectParams, slideEl) {
    const transformEl = (0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = 'hidden';
        transformEl.style['-webkit-backface-visibility'] = 'hidden';
    }
    return transformEl;
}



function $ccda7fbe6e91c3bb$export$f1e1789686576879(_ref) {
    let { swiper: swiper, duration: duration, transformElements: transformElements, allSlides: allSlides } = _ref;
    const { activeIndex: activeIndex } = swiper;
    const getSlide = (el)=>{
        if (!el.parentElement) {
            // assume shadow root
            const slide = swiper.slides.find((slideEl)=>slideEl.shadowRoot && slideEl.shadowRoot === el.parentNode);
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter((transformEl)=>{
            const el = transformEl.classList.contains('swiper-slide-transform') ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach((el)=>{
            (0, $c3b7d8492a069cd1$export$882b5998b3b9117c)(el, ()=>{
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                const evt = new window.CustomEvent('transitionend', {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $b1cd04b9779c6828$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = swiper.slides[i];
            const offset = slideEl.swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            const targetEl = (0, $9a09f206c8c28f8a$export$f1e1789686576879)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = `translate3d(${tx}px, ${ty}px, 0px)`;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
        });
        (0, $ccda7fbe6e91c3bb$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $34bdd096613c0953$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = (slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) {
            shadowBefore = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}`.split(' '));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', `swiper-slide-shadow-cube swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}`.split(' '));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { el: el, wrapperEl: wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const r = (0, $c3b7d8492a069cd1$export$ffb5f4729a158638)(swiper);
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.wrapperEl.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    swiper.wrapperEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = `${swiperWidth}px`;
            } else {
                cubeShadowEl = el.querySelector('.swiper-cube-shadow');
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', 'swiper-cube-shadow');
                    el.append(cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${r(isHorizontal ? 0 : -slideAngle)}deg) rotateY(${r(isHorizontal ? slideAngle : 0)}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = `50% 50% -${swiperSize / 2}px`;
        wrapperEl.style['-webkit-transform-origin'] = `50% 50% -${swiperSize / 2}px`;
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = `translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${params.shadowScale})`;
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                cubeShadowEl.style.transform = `scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-89.99deg)`;
            }
        }
        const zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = `translate3d(0px,0,${zFactor}px) rotateX(${r(swiper.isHorizontal() ? 0 : wrapperRotate)}deg) rotateY(${r(swiper.isHorizontal() ? -wrapperRotate : 0)}deg)`;
        wrapperEl.style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { el: el, slides: slides } = swiper;
        slides.forEach((slideEl)=>{
            slideEl.style.transitionDuration = `${duration}ms`;
            slideEl.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((subEl)=>{
                subEl.style.transitionDuration = `${duration}ms`;
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            const shadowEl = el.querySelector('.swiper-cube-shadow');
            if (shadowEl) shadowEl.style.transitionDuration = `${duration}ms`;
        }
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}



function $5146d2224683b9af$export$db3b6bfb95261072(suffix, slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}${suffix ? ` swiper-slide-shadow-${suffix}` : ''}`;
    const shadowContainer = (0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl);
    let shadowEl = shadowContainer.querySelector(`.${shadowClass.split(' ').join('.')}`);
    if (!shadowEl) {
        shadowEl = (0, $c3b7d8492a069cd1$export$db3b6bfb95261072)('div', shadowClass.split(' '));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $b203ce8a2d72c270$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    const createSlideShadows = (slideEl, progress)=>{
        let shadowBefore = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
        if (!shadowBefore) shadowBefore = (0, $5146d2224683b9af$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (!shadowAfter) shadowAfter = (0, $5146d2224683b9af$export$db3b6bfb95261072)('flip', slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        swiper.params.flipEffect;
        swiper.slides.forEach((slideEl)=>{
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        const rotateFix = (0, $c3b7d8492a069cd1$export$ffb5f4729a158638)(swiper);
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            let progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            const offset = slideEl.swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateFix(rotateX)}deg) rotateY(${rotateFix(rotateY)}deg)`;
            const targetEl = (0, $9a09f206c8c28f8a$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ccda7fbe6e91c3bb$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $69fcf1d8bfa72271$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth;
        const r = (0, $c3b7d8492a069cd1$export$ffb5f4729a158638)(swiper);
        // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const slideEl = slides[i];
            const slideSize = slidesSizesGrid[i];
            const slideOffset = slideEl.swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${r(rotateX)}deg) rotateY(${r(rotateY)}deg) scale(${scale})`;
            const targetEl = (0, $9a09f206c8c28f8a$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let shadowBeforeEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-left') : slideEl.querySelector('.swiper-slide-shadow-top');
                let shadowAfterEl = isHorizontal ? slideEl.querySelector('.swiper-slide-shadow-right') : slideEl.querySelector('.swiper-slide-shadow-bottom');
                if (!shadowBeforeEl) shadowBeforeEl = (0, $5146d2224683b9af$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'left' : 'top');
                if (!shadowAfterEl) shadowAfterEl = (0, $5146d2224683b9af$export$db3b6bfb95261072)('coverflow', slideEl, isHorizontal ? 'right' : 'bottom');
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}







function $0c3986d81a8048f9$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, wrapperEl: wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        const rotateFix = (0, $c3b7d8492a069cd1$export$ffb5f4729a158638)(swiper);
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = `translateX(calc(50% - ${margin}px))`;
        }
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            const offset = slideEl.swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            });
            // set rotates
            r.forEach((value, index)=>{
                let val = data.rotate[index] * Math.abs(progress * multiplier);
                r[index] = val;
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${rotateFix(r[0])}deg) rotateY(${rotateFix(r[1])}deg) rotateZ(${rotateFix(r[2])}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`;
            // Set shadows
            if (custom && data.shadow || !custom) {
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl && data.shadow) shadowEl = (0, $5146d2224683b9af$export$db3b6bfb95261072)('creative', slideEl);
                if (shadowEl) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const targetEl = (0, $9a09f206c8c28f8a$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ccda7fbe6e91c3bb$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}







function $0f31d76596d27b2b$export$2e2bcd8739ae039(_ref) {
    let { swiper: swiper, extendParams: extendParams, on: on } = _ref;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex, rtlTranslate: rtl } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const slideEl = slides[i];
            const slideProgress = slideEl.progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = `translateX(${swiper.minTranslate()}px)`;
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px ${rtl ? '-' : '+'} (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            /* eslint-disable */ const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rtl ? -rotate : rotate : 0}deg)
        scale(${scaleString})
      `;
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                let shadowEl = slideEl.querySelector('.swiper-slide-shadow');
                if (!shadowEl) shadowEl = (0, $5146d2224683b9af$export$db3b6bfb95261072)('cards', slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const targetEl = (0, $9a09f206c8c28f8a$export$f1e1789686576879)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    const setTransition = (duration)=>{
        const transformElements = swiper.slides.map((slideEl)=>(0, $c3b7d8492a069cd1$export$39b482c5e57630a8)(slideEl));
        transformElements.forEach((el)=>{
            el.style.transitionDuration = `${duration}ms`;
            el.querySelectorAll('.swiper-slide-shadow').forEach((shadowEl)=>{
                shadowEl.style.transitionDuration = `${duration}ms`;
            });
        });
        (0, $ccda7fbe6e91c3bb$export$f1e1789686576879)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $94ae428613873cd3$export$f1e1789686576879)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                _loopSwapReset: false,
                watchSlidesProgress: true,
                loopAdditionalSlides: swiper.params.cardsEffect.rotate ? 3 : 2,
                centeredSlides: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}


// Swiper Class
const $e4f42815606f7e85$var$modules = [
    (0, $7e125f42162cc6f1$export$2e2bcd8739ae039),
    (0, $390c2ee4a2ffa6de$export$2e2bcd8739ae039),
    (0, $6dccf879c26b7c90$export$2e2bcd8739ae039),
    (0, $cc696541be17c66f$export$2e2bcd8739ae039),
    (0, $883746983c7b8061$export$2e2bcd8739ae039),
    (0, $61bb2313398e74b2$export$2e2bcd8739ae039),
    (0, $416b1fec97095383$export$2e2bcd8739ae039),
    (0, $a4ef667c3ef7caf7$export$2e2bcd8739ae039),
    (0, $d977cbb283301583$export$2e2bcd8739ae039),
    (0, $7d2dcaff04688711$export$2e2bcd8739ae039),
    (0, $6848c0e8979c4786$export$2e2bcd8739ae039),
    (0, $0f584d3903502d4e$export$2e2bcd8739ae039),
    (0, $4c8c320aaa69b88b$export$2e2bcd8739ae039),
    (0, $a925c1254d955523$export$2e2bcd8739ae039),
    (0, $10891eb4d02aaaec$export$2e2bcd8739ae039),
    (0, $d297191fe341a2a6$export$2e2bcd8739ae039),
    (0, $b2e879065b74a820$export$2e2bcd8739ae039),
    (0, $b1cd04b9779c6828$export$2e2bcd8739ae039),
    (0, $34bdd096613c0953$export$2e2bcd8739ae039),
    (0, $b203ce8a2d72c270$export$2e2bcd8739ae039),
    (0, $69fcf1d8bfa72271$export$2e2bcd8739ae039),
    (0, $0c3986d81a8048f9$export$2e2bcd8739ae039),
    (0, $0f31d76596d27b2b$export$2e2bcd8739ae039)
];
(0, $74e74a0b53d40157$export$25ce5a424b770e84).use($e4f42815606f7e85$var$modules);




var $fWVzk = parcelRequire("fWVzk");
function $2101ee1b4e112d93$export$f09be6266877bf97() {
    const navWrapper = document.querySelector('.account-navigation__swiper');
    const navList = navWrapper?.querySelector('.account-navigation__nav');
    if (!navWrapper || !navList) return;
    Array.from(navList.querySelectorAll('a')).forEach((a)=>{
        const slide = document.createElement('div');
        slide.classList.add('swiper-slide');
        a.replaceWith(slide);
        slide.appendChild(a);
        if (a.href === window.location.href) a.classList.add('active');
    });
    new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(navWrapper, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
            [(0, $fWVzk.BREAKPOINTS).LARGE]: {
                slidesPerView: 3.2,
                allowTouchMove: false
            }
        }
    });
}


/**
 * Updates modal product information from JSON metadata
 * @param {Object} meta - The metadata object containing product information
 * @param {HTMLElement} modal - The modal element containing the product info elements
 */ function $def8ecdd50291906$export$148e7f13f2b991b1(meta, modal) {
    if (!meta || !modal) return;
    try {
        // Get all the modal elements
        const modalTitle = document.getElementById('modal-title');
        const modalDescription = document.getElementById('modal-description');
        const modalStyleLabel = document.getElementById('modal-style-label') || document.getElementById('bento-modal-style-label');
        const modalStyle = document.getElementById('modal-style') || document.getElementById('bento-modal-style');
        const modalCollectionLabel = document.getElementById('modal-collection-label') || document.getElementById('bento-modal-collection-label');
        const modalCollection = document.getElementById('modal-collection') || document.getElementById('bento-modal-collection');
        const modalStyleNumberLabel = document.getElementById('modal-style-number-label') || document.getElementById('bento-modal-style-number-label');
        const modalStyleNumber = document.getElementById('modal-style-number') || document.getElementById('bento-modal-style-number');
        const modalColorwayLabel = document.getElementById('modal-colorway-label') || document.getElementById('bento-modal-colorway-label');
        const modalColorway = document.getElementById('modal-colorway') || document.getElementById('bento-modal-colorway');
        const modalProductLink = modal?.querySelector('.cmp-gallery-productinfo__productlink');
        const modalLinks = document.getElementById('modal-links') || document.getElementById('bento-modal-links');
        const modalProductLinksSection = document.getElementById('modal-product-links-section');
        const modalAttribution = document.getElementById('modal-attribution') || document.getElementById('bento-modal-attribution');
        // Update title if present
        if (modalTitle) modalTitle.innerHTML = meta.title || '';
        // Update description if present
        if (modalDescription) modalDescription.innerHTML = meta.description || '';
        // Update style information
        if (modalStyleLabel) modalStyleLabel.innerHTML = meta.styleName ? 'Style' : '';
        if (modalStyle) modalStyle.innerHTML = meta.styleName || '';
        if (modalCollectionLabel) modalCollectionLabel.innerHTML = meta.collectionName ? 'Collection' : '';
        if (modalCollection) modalCollection.innerHTML = meta.collectionName || '';
        if (modalStyleNumberLabel) modalStyleNumberLabel.innerHTML = meta.styleNumber ? 'Style #' : '';
        if (modalStyleNumber) modalStyleNumber.innerHTML = meta.styleNumber || '';
        if (modalColorwayLabel) modalColorwayLabel.innerHTML = meta.colorwayName ? 'Colorway' : '';
        if (modalColorway) modalColorway.innerHTML = meta.colorwayName || '';
        // Update catalog URL link
        if (modalProductLink) {
            if (meta.catalogUrl) {
                modalProductLink.setAttribute('href', meta.catalogUrl);
                modalProductLink.classList.remove('cmp-gallery-productinfo__hidden');
            } else {
                modalProductLink.setAttribute('href', '');
                modalProductLink.classList.add('cmp-gallery-productinfo__hidden');
            }
        }
        // Update product links if present
        if (modalLinks) {
            if (meta.productLinks && meta.productLinks.length > 0) {
                modalLinks.innerHTML = meta.productLinks.map((url)=>`<li><a href="${url}" class="cmp-imagegallery__modal-link">${url}</a></li>`).join('');
                if (modalProductLinksSection) modalProductLinksSection.style.display = '';
            } else {
                modalLinks.innerHTML = '';
                if (modalProductLinksSection) modalProductLinksSection.style.display = 'none';
            }
        }
        // Update attribution
        if (modalAttribution) modalAttribution.innerHTML = meta.attribution || '';
    } catch (e) {
        console.error('Error updating modal product info:', e);
    }
}


function $2b90fe259d1f6d7e$export$dba48aad7ea58a0() {
    try {
        const cards = document.querySelectorAll('.cmp-bentobox-gallery-card');
        const modal = document.getElementById('bento-modal');
        const modalImg = document.getElementById('bento-modal-image');
        const modalTitle = document.getElementById('bento-modal-title');
        const modalDesc = document.getElementById('bento-modal-description');
        const closeBtnDesktop = document.getElementById('bento-modal-close');
        const closeBtnMobile = document.getElementById('bento-modal-close-mobile');
        const overlay = modal?.querySelector('.cmp-bentobox-gallery-modal__overlay');
        const closeModal = ()=>{
            modal.setAttribute('hidden', 'true');
            modalImg.src = '';
        };
        cards.forEach((card)=>{
            const button = card.querySelector('.cmp-bentobox-gallery__modal-button');
            const imageUrl = card.getAttribute('data-full-image-url');
            const metaScript = card.querySelector('.cmp-bentobox-gallery__modal-meta');
            button?.addEventListener('click', ()=>{
                modal.removeAttribute('hidden');
                modalImg.src = imageUrl;
                if (metaScript) try {
                    const meta = JSON.parse(metaScript.textContent);
                    // Clear description for bentobox
                    modalTitle.innerHTML = meta.title || '';
                    modalDesc.innerHTML = '';
                    // Update product info using shared utility
                    (0, $def8ecdd50291906$export$148e7f13f2b991b1)(meta, modal);
                } catch (e) {
                    console.error('Error parsing bentobox modal metadata:', e);
                }
            });
        });
        closeBtnDesktop?.addEventListener('click', closeModal);
        closeBtnMobile?.addEventListener('click', closeModal);
        overlay?.addEventListener('click', closeModal);
    } catch (e) {
        console.error('Error initializing bentobox modal:', e);
    }
}


function $f96d6717bc10e65b$export$4c75c8c3488dfe0() {
    const copyBtn = document.querySelector('.js-copy-link');
    if (copyBtn) copyBtn.addEventListener('click', function() {
        const url = this.getAttribute('data-link');
        navigator.clipboard.writeText(url).then(()=>{
            const tooltip = this.closest('.tmp-blogdetail__share-icon-wrapper').querySelector('.copy-tooltip');
            tooltip.classList.add('show');
            setTimeout(()=>{
                tooltip.classList.remove('show');
            }, 2000);
        }).catch((err)=>{
            console.error('Copy failed', err);
        });
    });
}


function $3ff5e247f05a2348$export$d2ccd73696d1a549(loadPostsCallback) {
    const toggles = document.querySelectorAll('.blog-filter-toggle');
    const dropdowns = document.querySelectorAll('.blog-filter-dropdown');
    if (toggles.length === 0 || dropdowns.length === 0) return;
    toggles.forEach((toggle)=>{
        const key = toggle.dataset.filter;
        const dropdown = document.querySelector(`.blog-filter-dropdown[data-filter="${key}"]`);
        if (!dropdown) return;
        toggle.addEventListener('click', ()=>{
            dropdown.classList.toggle('open');
            toggle.classList.toggle('open');
        });
    });
    document.addEventListener('click', (e)=>{
        dropdowns.forEach((dropdown)=>{
            const toggle = dropdown.previousElementSibling;
            if (!dropdown.contains(e.target) && !toggle.contains(e.target)) {
                dropdown.classList.remove('open');
                toggle.classList.remove('open');
            }
        });
    });
    const clears = document.querySelectorAll('.blog-filter-clear');
    clears.forEach((btn)=>{
        const filter = btn.dataset.filter;
        if (!filter) return;
        btn.addEventListener('click', ()=>{
            const checkboxes = document.querySelectorAll(`input[name="${filter}"]`);
            checkboxes.forEach((cb)=>cb.checked = false);
            updateFilterCounts();
            loadPostsCallback(getSelectedFilters());
        });
    });
    const filterInputs = document.querySelectorAll('.blog-filter-dropdown input[type="checkbox"]');
    if (filterInputs.length > 0) filterInputs.forEach((cb)=>{
        cb.addEventListener('change', ()=>{
            updateFilterCounts();
            loadPostsCallback(getSelectedFilters());
        });
    });
    function getSelectedFilters() {
        const filters = {};
        [
            'topic',
            'segment'
        ].forEach((type)=>{
            const checked = document.querySelectorAll(`input[name="${type}"]:checked`);
            if (checked.length > 0) filters[type] = Array.from(checked).map((cb)=>cb.value);
        });
        return filters;
    }
    function updateFilterCounts() {
        toggles.forEach((toggle)=>{
            const filter = toggle.dataset.filter;
            const count = document.querySelectorAll(`input[name="${filter}"]:checked`).length;
            const countSpan = toggle.querySelector('.count');
            if (countSpan) countSpan.textContent = count > 0 ? `(${count})` : '';
        });
        renderActiveFilters();
    }
    function renderActiveFilters() {
        const container = document.getElementById('activeFilters');
        if (!container) return;
        container.innerHTML = '';
        [
            'topic',
            'segment'
        ].forEach((type)=>{
            const checkboxes = document.querySelectorAll(`input[name="${type}"]:checked`);
            checkboxes.forEach((cb)=>{
                const pill = document.createElement('div');
                pill.className = 'tmp-overviewblog__filters-pill';
                pill.innerHTML = `
            <span>${cb.parentElement.textContent.trim()}</span>
            <span class="tmp-overviewblog__filters-pill-remove" data-type="${type}" data-value="${cb.value}">&times;</span>
          `;
                container.appendChild(pill);
            });
        });
        container.querySelectorAll('.tmp-overviewblog__filters-pill-remove').forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                const type = btn.dataset.type;
                const value = btn.dataset.value;
                const checkbox = document.querySelector(`input[name="${type}"][value="${value}"]`);
                if (checkbox) {
                    checkbox.checked = false;
                    updateFilterCounts();
                    loadPostsCallback(getSelectedFilters());
                }
            });
        });
    }
    updateFilterCounts();
    loadPostsCallback(getSelectedFilters());
}


let $c76cefd1e9dcfa92$var$currentPage = 1;
let $c76cefd1e9dcfa92$var$currentFilters = {};
let $c76cefd1e9dcfa92$var$postsLoaded = 0;
let $c76cefd1e9dcfa92$var$totalItems = 0;
function $c76cefd1e9dcfa92$export$e872fa6ab5911296(filters = {}) {
    $c76cefd1e9dcfa92$var$currentPage = 1;
    $c76cefd1e9dcfa92$var$currentFilters = filters;
    $c76cefd1e9dcfa92$var$postsLoaded = 0;
    $c76cefd1e9dcfa92$var$totalItems = 0;
    $c76cefd1e9dcfa92$var$loadBlogPosts($c76cefd1e9dcfa92$var$currentFilters, $c76cefd1e9dcfa92$var$currentPage, false);
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    loadMoreBtn?.addEventListener('click', ()=>{
        $c76cefd1e9dcfa92$var$currentPage++;
        $c76cefd1e9dcfa92$var$loadBlogPosts($c76cefd1e9dcfa92$var$currentFilters, $c76cefd1e9dcfa92$var$currentPage, true);
    });
}
function $c76cefd1e9dcfa92$var$loadBlogPosts(filters, page = 1, append = false) {
    const container = document.getElementById('recentPostsContainer');
    const pageId = container?.dataset.pageId;
    const loadMoreBtn = document.getElementById('loadMoreBtn');
    const progressText = document.getElementById('postProgressText');
    const progressBar = document.getElementById('postProgressBar');
    if (!container || !pageId) return;
    const queryParams = new URLSearchParams({
        page: page
    });
    if (filters.topic?.length) filters.topic.forEach((val)=>queryParams.append('tags', val));
    if (filters.segment?.length) filters.segment.forEach((val)=>queryParams.append('segments', val));
    const apiUrl = `/api/Blogs/${pageId}/RecentPosts?${queryParams.toString()}`;
    fetch(apiUrl).then((response)=>{
        if (!response.ok) throw new Error(`Failed to fetch: ${response.status}`);
        return response.json();
    }).then((data)=>{
        if (!data.items?.length) {
            if (!append) container.innerHTML = '<p>No recent posts found.</p>';
            loadMoreBtn.style.display = 'none';
            return;
        }
        if (!append) {
            container.innerHTML = '';
            $c76cefd1e9dcfa92$var$postsLoaded = 0;
        }
        data.items.forEach((post)=>{
            const postCard = document.createElement('div');
            postCard.className = 'tmp-overviewblog__card';
            postCard.innerHTML = `
                    <a class="tmp-overviewblog__card-link" href="${post.url}">
                        <img src="${post.cardImage}" alt="${post.postTitle}" class="tmp-overviewblog__card-image" />
                        <div class="tmp-overviewblog__card-tags">
                            ${post.tags.map((tag)=>`<a href="${tag.url}" class="tag">${tag.name}</a>`).join(' ')}
                        </div>
                        <h3 class="tmp-overviewblog__card-title">${post.postTitle}</h3>
                    </a>
                    <p class="blog-post-card__card-description">${post.shortDescription}</p>
                    <a href="${post.url}" class="tmp-overviewblog__card-readmore">Read More</a>
                `;
            container.appendChild(postCard);
        });
        $c76cefd1e9dcfa92$var$postsLoaded += data.items.length;
        $c76cefd1e9dcfa92$var$totalItems = data.totalItems ?? $c76cefd1e9dcfa92$var$totalItems;
        if (progressText && progressBar && $c76cefd1e9dcfa92$var$totalItems > 0) {
            progressText.textContent = `Showing ${$c76cefd1e9dcfa92$var$postsLoaded} of ${$c76cefd1e9dcfa92$var$totalItems}`;
            const percent = $c76cefd1e9dcfa92$var$postsLoaded / $c76cefd1e9dcfa92$var$totalItems * 100;
            progressBar.style.width = `${Math.min(percent, 100)}%`;
        }
        if ($c76cefd1e9dcfa92$var$postsLoaded >= $c76cefd1e9dcfa92$var$totalItems || data.items.length < 12) loadMoreBtn.style.display = 'none';
        else loadMoreBtn.style.display = 'inline-block';
    }).catch((error)=>{
        console.error('Error loading blog posts:', error);
        if (!append) container.innerHTML = '<p>Error loading blog posts.</p>';
    });
}


function $f581c978926dc309$export$e58147ec6a5cf5ac() {
    const wrapper = document.querySelector('.collections-overview__filters.collection-filter');
    const collectionItems = Array.from(document.querySelectorAll('.tmp-collections-overview__grid-collection'));
    const checkboxes = wrapper?.querySelectorAll('input[type="checkbox"]') || [];
    const clearButton = wrapper?.querySelector('.collection-filter-clear');
    const countEl = wrapper?.querySelector('.collection-filter-toggle .collection-filter-count');
    const dropdown = wrapper?.querySelector('.collection-filter-dropdown');
    const toggleBtn = wrapper?.querySelector('.collection-filter-toggle');
    const loadMoreBtn = document.getElementById('collectionsOverviewLoadMoreBtn');
    const progressText = document.getElementById('postCollectionOverviewProgressText');
    const progressBar = document.getElementById('postCollectionOverviewProgressBar');
    const activeFiltersContainer = document.getElementById('collectionOverviewActiveFilters');
    const ITEMS_PER_PAGE = 12;
    let currentVisibleCount = 0;
    function updateCountDisplay(count) {
        if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';
    }
    function getFilteredItems() {
        const selectedCodes = Array.from(checkboxes).filter((cb)=>cb.checked).map((cb)=>cb.dataset.code);
        return collectionItems.filter((item)=>{
            const codesString = item.dataset.codes || '';
            const codes = codesString.split(',').map((s)=>s.trim()).filter(Boolean);
            return selectedCodes.length === 0 || codes.some((code)=>selectedCodes.includes(code));
        });
    }
    function updateProgress(visibleCount, totalCount) {
        if (progressText) progressText.textContent = `Showing ${visibleCount} of ${totalCount}`;
        if (progressBar) {
            const percent = totalCount === 0 ? 0 : visibleCount / totalCount * 100;
            progressBar.style.width = `${percent}%`;
        }
    }
    function showItems(itemsToShow) {
        collectionItems.forEach((item)=>item.style.display = 'none');
        itemsToShow.forEach((item)=>item.style.display = '');
    }
    function renderActiveFilters() {
        if (!activeFiltersContainer) return;
        activeFiltersContainer.innerHTML = '';
        const checked = Array.from(checkboxes).filter((cb)=>cb.checked);
        checked.forEach((cb)=>{
            const pill = document.createElement('div');
            pill.className = 'tmp-collections-overview__filters-active-pill';
            const label = document.createElement('span');
            label.textContent = cb.value;
            const removeBtn = document.createElement('button');
            removeBtn.className = 'tmp-collections-overview__filters-active-pill-remove';
            removeBtn.innerHTML = '&times;';
            removeBtn.setAttribute('aria-label', 'Remove filter');
            removeBtn.addEventListener('click', ()=>{
                cb.checked = false;
                filterAndRender(true);
            });
            pill.appendChild(label);
            pill.appendChild(removeBtn);
            activeFiltersContainer.appendChild(pill);
        });
    }
    function filterAndRender(reset = true) {
        const filteredItems = getFilteredItems();
        updateCountDisplay(Array.from(checkboxes).filter((cb)=>cb.checked).length);
        if (reset) currentVisibleCount = 0;
        const toShow = filteredItems.slice(0, currentVisibleCount + ITEMS_PER_PAGE);
        currentVisibleCount = toShow.length;
        showItems(toShow);
        updateProgress(currentVisibleCount, filteredItems.length);
        if (loadMoreBtn) loadMoreBtn.classList.toggle('hidden', currentVisibleCount >= filteredItems.length);
        renderActiveFilters();
    }
    checkboxes.forEach((cb)=>{
        cb.addEventListener('change', ()=>filterAndRender(true));
    });
    clearButton?.addEventListener('click', (e)=>{
        e.preventDefault();
        checkboxes.forEach((cb)=>cb.checked = false);
        filterAndRender(true);
        activeFiltersContainer.innerHTML = '';
    });
    loadMoreBtn?.addEventListener('click', ()=>{
        const filteredItems = getFilteredItems();
        const nextBatch = filteredItems.slice(0, currentVisibleCount + ITEMS_PER_PAGE);
        currentVisibleCount = nextBatch.length;
        showItems(nextBatch);
        updateProgress(currentVisibleCount, filteredItems.length);
        if (loadMoreBtn) loadMoreBtn.style.display = currentVisibleCount < filteredItems.length ? 'flex' : 'none';
    });
    toggleBtn?.addEventListener('click', ()=>{
        const isOpen = dropdown.classList.toggle('open');
        toggleBtn.classList.toggle('open', isOpen);
    });
    filterAndRender(true);
}




function $06df0d63fec966a5$export$52b52688fd876a7d(root = document) {
    const compareBoxes = root.querySelectorAll("input[name='compare']");
    compareBoxes.forEach((cb)=>{
        if (cb.dataset.compareBound) return;
        cb.dataset.compareBound = true;
        cb.addEventListener("change", ()=>{
            const { checked: checked, dataset: dataset } = cb;
            window.dispatchEvent(new CustomEvent("compare-toggle", {
                detail: {
                    ...dataset,
                    checked: checked
                }
            }));
        });
    });
    window.addEventListener("compare-toggle", (e)=>{
        const { code: code, checked: checked } = e.detail;
        const checkbox = root.querySelector(`input[name='compare'][data-code="${code}"]`);
        if (checkbox && checkbox.checked !== checked) checkbox.checked = checked;
    });
}
function $06df0d63fec966a5$export$4567274423a54926(root = document) {
    root.querySelectorAll('.tmp-collections-details__variant-carousel').forEach(function(carousel) {
        if (carousel.classList.contains('is-initialized')) return;
        const swiperEl = carousel.querySelector('.swiper');
        const prevBtn = carousel.querySelector('.swiper-button-prev');
        const nextBtn = carousel.querySelector('.swiper-button-next');
        if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            }
        });
        carousel.querySelectorAll('.tmp-collections-details__variant-image').forEach((img)=>{
            img.addEventListener('click', ()=>{
                const newUrl = img.dataset.contentUrl;
                const newSrc = img.dataset.mainSrc || img.currentSrc || img.src;
                const newSrcset = Object.prototype.hasOwnProperty.call(img.dataset, 'mainSrcset') ? img.dataset.mainSrcset : undefined;
                const newSizes = Object.prototype.hasOwnProperty.call(img.dataset, 'mainSizes') ? img.dataset.mainSizes : undefined;
                const newStyle = Object.prototype.hasOwnProperty.call(img.dataset, 'mainStyle') ? img.dataset.mainStyle : undefined;
                const newXpressFlag = img.dataset.mainXpress ?? 'False'; // note: this is using .net's bool string representation
                const itemRoot = carousel.closest('.tmp-collections-details__item');
                const itemBadges = itemRoot.querySelector('.tmp-collections-details__badges');
                const mainImage = itemRoot.querySelector('#tmpCollectionsDisplayedImage');
                if (itemBadges) itemBadges.setAttribute('data-xpress-visible', newXpressFlag);
                const mainImageLink = itemRoot.querySelector('.tmp-collections-details__main-link');
                if (mainImageLink && newUrl) mainImageLink.href = newUrl;
                if (mainImage && newSrc) {
                    if (newSrcset !== undefined) {
                        if (newSrcset) mainImage.setAttribute('srcset', newSrcset);
                        else mainImage.removeAttribute('srcset');
                    }
                    if (newSizes !== undefined) {
                        if (newSizes) mainImage.setAttribute('sizes', newSizes);
                        else mainImage.removeAttribute('sizes');
                    }
                    if (newStyle !== undefined) {
                        if (newStyle) mainImage.setAttribute('style', newStyle);
                        else mainImage.removeAttribute('style');
                    }
                    mainImage.src = newSrc;
                    if (img.dataset.mcAssetType) mainImage.dataset.mcAssetType = img.dataset.mcAssetType;
                    if (img.dataset.mcProjectBoardAssetInfo) mainImage.dataset.mcProjectBoardAssetInfo = img.dataset.mcProjectBoardAssetInfo;
                }
                const variantName = img.alt;
                const variantNameEl = itemRoot.querySelector('.selected-variant-name');
                if (variantNameEl) variantNameEl.textContent = variantName;
                if (mainImage && variantName) mainImage.alt = variantName;
                const allWrappers = carousel.querySelectorAll('.tmp-collections-details__variant-image-wrapper');
                allWrappers.forEach((wrapper)=>wrapper.classList.remove('selected'));
                const clickedWrapper = img.closest('.tmp-collections-details__variant-image-wrapper');
                if (clickedWrapper) clickedWrapper.classList.add('selected');
                const compareCb = itemRoot.querySelector("input[name='compare']");
                if (compareCb && newSrc) {
                    compareCb.dataset.img = newSrc;
                    if (compareCb.checked) window.dispatchEvent(new CustomEvent("compare-toggle", {
                        detail: {
                            img: newSrc,
                            productCode: compareCb.dataset.code,
                            checked: true
                        }
                    }));
                }
            });
        });
        carousel.classList.add('is-initialized');
    });
    $06df0d63fec966a5$export$52b52688fd876a7d(root);
}
document.addEventListener('DOMContentLoaded', ()=>{
    $06df0d63fec966a5$export$4567274423a54926();
});
document.body.addEventListener('htmx:afterOnLoad', (e)=>{
    $06df0d63fec966a5$export$4567274423a54926(e.target);
});


function $f626d2dd2b500820$export$f449253774381a1b() {
    const videos = document.querySelectorAll('.cmp-videoplayer');
    videos.forEach((wrapper)=>{
        const video = wrapper.querySelector('video');
        const playBtn = wrapper.querySelector('.cmp-videoplayer__play-button');
        if (!video || !playBtn) return;
        playBtn.addEventListener('click', ()=>{
            video.play();
            playBtn.style.display = 'none';
        });
        video.addEventListener('play', ()=>{
            playBtn.style.display = 'none';
        });
    });
}


// editorblog.js
/**
 * Swiper 11.2.8
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2025 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: May 23, 2025
 */ 





var $fWVzk = parcelRequire("fWVzk");
function $a74e0f3fd4d22cf2$export$14c80272ffa77045() {
    const containers = document.querySelectorAll('.tmp-editorblog__mobile.swiper');
    if (!containers.length) return;
    containers.forEach((container)=>{
        if (container.dataset.swiperInitialized === 'true') return;
        const nextEl = container.querySelector('.swiper-button-next');
        const prevEl = container.querySelector('.swiper-button-prev');
        const paginationEl = container.querySelector('.swiper-pagination');
        const options = {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: false,
            breakpoints: {
                [(0, $fWVzk.BREAKPOINTS).MEDIUM]: {
                    enabled: false
                }
            }
        };
        if (paginationEl) options.pagination = {
            el: paginationEl,
            clickable: true
        };
        if (nextEl && prevEl) options.navigation = {
            nextEl: nextEl,
            prevEl: prevEl
        };
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(container, options);
        container.dataset.swiperInitialized = 'true';
    });
}



var $iouPm = parcelRequire("iouPm");

var $bWUN0 = parcelRequire("bWUN0");

var $8cF6f = parcelRequire("8cF6f");
function $6b07b67fb3f99fcb$export$94fbfcae3bd4ae7b() {
    // connects email signup form(s) to newsletter api
    window.addEventListener('DOMContentLoaded', ()=>{
        const components = document.querySelectorAll('.cmp-emailsignup');
        components.forEach((component)=>{
            const form = component.querySelector('form');
            form.addEventListener('submit', (e)=>{
                e.preventDefault();
                const email = form.querySelector('input[type="email"]').value;
                (0, $iouPm.newsletterSubscribe)(email).then(()=>{
                    component.classList.add('cmp-emailsignup--success');
                    // GTM: Track successful newsletter subscription
                    (0, $bWUN0.pushEvent)({
                        'event': 'formSubmission',
                        'formID': 'newsletter'
                    });
                }).catch((e)=>{
                    console.error('error signing up for newsletter', e);
                    (0, $8cF6f.showToast)('Sorry, there was a problem adding your email address', 'error');
                });
            });
        });
    });
}


function $e59937a8264a8ca7$export$64fc608557bc1fbb() {
    function setup() {
        const pageRoot = document.querySelector('.far-page');
        if (!pageRoot) return; // only run on Find A Rep page
        const form = document.querySelector('.far-page__search-row');
        const input = form ? form.querySelector('input[name="searchTerm"]') : null;
        const resultsContainer = document.getElementById('repResultsContainer');
        const list = resultsContainer || document.getElementById('repResults');
        const empty = document.getElementById('resultsEmpty');
        const count = document.getElementById('resultsCount');
        const mapNotice = document.getElementById('mapNotice');
        const mapToggleBtn = document.querySelector('.far-page__map-toggle');
        const mapSection = document.getElementById('mapSection');
        if (mapToggleBtn && mapSection) mapToggleBtn.addEventListener('click', ()=>{
            const isExpanded = mapToggleBtn.getAttribute('aria-expanded') === 'true';
            if (isExpanded) {
                mapSection.classList.add('is-collapsed');
                mapToggleBtn.setAttribute('aria-expanded', 'false');
                mapToggleBtn.textContent = 'Show Map';
            } else {
                mapSection.classList.remove('is-collapsed');
                mapToggleBtn.setAttribute('aria-expanded', 'true');
                mapToggleBtn.textContent = 'Hide Map';
                ensureMap();
            }
        });
        let map, markers = [];
        let infoWindow;
        let repIndexToMarker = {};
        function getLatLngFromMarker(m) {
            if (!m || !m.position) return null;
            const p = m.position;
            const lat = typeof p.lat === 'function' ? p.lat() : p.lat;
            const lng = typeof p.lng === 'function' ? p.lng() : p.lng;
            if (typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)) return {
                lat: lat,
                lng: lng
            };
            return null;
        }
        function recenterToAllMarkers() {
            if (!map) return;
            const currentMarkers = (markers || []).filter((m)=>!!getLatLngFromMarker(m));
            if (currentMarkers.length === 1) {
                const pos = getLatLngFromMarker(currentMarkers[0]);
                if (pos) {
                    map.setCenter(pos);
                    map.setZoom(11);
                }
            } else if (currentMarkers.length > 1) {
                const bounds = new google.maps.LatLngBounds();
                currentMarkers.forEach((m)=>{
                    const pos = getLatLngFromMarker(m);
                    if (pos) bounds.extend(pos);
                });
                map.fitBounds(bounds);
            }
        }
        function clearMarkers() {
            markers.forEach((m)=>{
                try {
                    m.map = null;
                } catch (e) {
                    console.error('Error clearing markers:', e);
                }
            });
            markers = [];
            repIndexToMarker = {};
        }
        function ensureMap(center) {
            if (window.google && !map) {
                const mapEl = document.getElementById('map');
                if (!mapEl) return;
                // Use provided center or default to continental US centroid when none is provided
                const defaultCenter = center && typeof center.lat === 'number' && typeof center.lng === 'number' ? center : {
                    lat: 39.8283,
                    lng: -98.5795
                };
                const options = {
                    center: defaultCenter,
                    zoom: center ? 11 : 4,
                    disableDefaultUI: false,
                    zoomControl: true
                };
                if (mapId) options.mapId = mapId;
                map = new google.maps.Map(mapEl, options);
                infoWindow = new google.maps.InfoWindow();
                if (infoWindow && typeof infoWindow.addListener === 'function') infoWindow.addListener('closeclick', function() {
                    recenterToAllMarkers();
                });
            } else if (!window.google) {
                const el = document.getElementById('map');
                if (el) el.style.display = 'none';
                if (mapNotice) mapNotice.style.display = 'block';
            }
        }
        // Opens a popup info window on the map for the given marker, optionally with the given content
        function openInfo(marker, content) {
            if (!marker || !infoWindow) return;
            infoWindow.setContent(content || '');
            // Anchor to advanced marker element
            infoWindow.open({
                map: map,
                anchor: marker
            });
        }
        // Adds a marker to the map with the given lat/lng coordinates and title, used for both search center and reps
        function addMarker(lat, lng, title, options) {
            if (!window.google || !map) return null;
            const opts = options || {};
            // Build a custom pin with Mannington color #595653 for reps by default
            let pinContent = undefined;
            try {
                if (!opts.useDefault && google?.maps?.marker?.PinElement) pinContent = new google.maps.marker.PinElement({
                    background: '#595653',
                    borderColor: '#3f3d3b',
                    glyphColor: '#ffffff'
                });
            } catch (e) {
                console.error('Error creating custom marker:', e);
            }
            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: map,
                position: {
                    lat: lat,
                    lng: lng
                },
                title: title || '',
                content: pinContent && pinContent.element ? pinContent.element : undefined
            });
            if (!infoWindow) {
                infoWindow = new google.maps.InfoWindow();
                if (infoWindow && typeof infoWindow.addListener === 'function') infoWindow.addListener('closeclick', function() {
                    recenterToAllMarkers();
                });
            }
            marker.addListener('click', ()=>openInfo(marker, title || ''));
            markers.push(marker);
            return marker;
        }
        if (!input) return;
        // Ensure URL reflects current search term on every search execution
        function updateUrlWithSearchTerm(term) {
            try {
                const url = new URL(window.location.href);
                if (term) url.searchParams.set('searchTerm', term);
                else url.searchParams.delete('searchTerm');
                // push new state to allow back/forward across searches
                window.history.pushState({}, '', url.toString());
            } catch (e) {
                console.error('Error updating URL with search term:', e);
            }
        }
        // Apply search term from URL on page load (if present)
        function applyTermFromUrl() {
            try {
                const url = new URL(window.location.href);
                const q = url.searchParams.get('searchTerm');
                if (q) {
                    input.value = q;
                    // with htmx, submit the form to load results HTML; fallback to JSON search otherwise
                    setTimeout(()=>{
                        if (window.htmx && form) try {
                            window.htmx.trigger(form, 'submit');
                        } catch (e) {
                            console.error('Error triggering htmx submit:', e);
                            form.dispatchEvent(new Event('submit', {
                                bubbles: true,
                                cancelable: true
                            }));
                        }
                    }, 100);
                }
            } catch (e) {
                console.error('Error applying term from URL:', e);
            }
        }
        // Update URL on form submit (HTMX path) so address bar always reflects latest search
        if (form) form.addEventListener('submit', function(e) {
            try {
                const term = (input && input.value || '').trim();
                updateUrlWithSearchTerm(term);
            } catch (e) {
                console.error('Error updating URL on form submit:', e);
            }
        }, true); // capture to run before HTMX request
        window.addEventListener('popstate', function() {
            try {
                const url = new URL(window.location.href);
                const q = url.searchParams.get('searchTerm') || '';
                if (input) input.value = q;
                if (q) {
                    if (window.htmx && form) try {
                        window.htmx.trigger(form, 'submit');
                    } catch (e) {
                        console.error('Error triggering htmx submit on popstate:', e);
                        form.dispatchEvent(new Event('submit', {
                            bubbles: true,
                            cancelable: true
                        }));
                    }
                } else {
                    // Clear results when no query
                    if (list) list.innerHTML = '';
                    if (empty) empty.style.display = 'none';
                    if (count) count.textContent = '';
                    clearMarkers();
                    ensureMap();
                }
            } catch (e) {
                console.error('Error handling popstate event:', e);
            }
        });
        // Google Maps loader: read key and map id from the page root data attributes
        const apiKey = pageRoot && pageRoot.dataset && pageRoot.dataset.googleApiKey || '';
        const mapId = pageRoot && pageRoot.dataset && pageRoot.dataset.googleMapId || 'DEMO_MAP_ID';
        function loadMaps() {
            return new Promise((resolve, reject)=>{
                if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=marker`;
                script.async = true;
                script.defer = true;
                script.onload = async function() {
                    try {
                        if (window.google && window.google.maps && typeof window.google.maps.importLibrary === 'function') {
                            await window.google.maps.importLibrary('maps');
                            await window.google.maps.importLibrary('marker');
                        }
                    } catch (e) {
                        console.error('Error importing Google Maps libraries:', e);
                    } finally{
                        ensureMap();
                        resolve();
                    }
                };
                script.onerror = function() {
                    const el = document.getElementById('map');
                    if (el) el.style.display = 'none';
                    if (mapNotice) mapNotice.style.display = 'block';
                    console.error('Google Maps failed to load');
                    reject(new Error('Google Maps failed to load'));
                };
                document.head.appendChild(script);
            });
        }
        async function afterDomReady() {
            await loadMaps().catch((e)=>{
                console.error('Error loading Google Maps:', e);
            });
            // When htmx swaps in results, parse embedded JSON to update map and count (no extra API call)
            document.body.addEventListener('htmx:afterSwap', function(evt) {
                try {
                    const targetEl = evt && evt.detail && evt.detail.target ? evt.detail.target : evt ? evt.target : null;
                    if (targetEl && targetEl.id === 'repResultsContainer') {
                        const term = (input && input.value || '').trim();
                        const container = document.getElementById('repResultsContainer');
                        if (!container) return;
                        const dataEl = container.querySelector('#repResultsData');
                        if (!dataEl) return;
                        let data = null;
                        try {
                            data = JSON.parse(dataEl.textContent || '{}');
                        } catch (e) {
                            console.error('Error parsing JSON:', e);
                            data = null;
                        }
                        const repsArray = Array.isArray(data?.reps) ? data.reps : [];
                        const reps = repsArray.map((r)=>{
                            const name = r?.name || '';
                            const lat = typeof r?.lat === 'number' ? r.lat : undefined;
                            const lng = typeof r?.lng === 'number' ? r.lng : undefined;
                            return {
                                name: name,
                                latLng: typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng) ? {
                                    lat: lat,
                                    lng: lng
                                } : null
                            };
                        });
                        // update results count UI
                        if (count) {
                            count.textContent = '';
                            const txt = `${reps.length} result${reps.length === 1 ? '' : 's'} for `;
                            const prefix = document.createTextNode(txt + '"');
                            const link = document.createElement('span');
                            // enabling this code will cause the search term to be hyperlinked to recenter the map to the search results
                            //const link = document.createElement('a');
                            //link.href = '#';
                            //link.id = 'recenterLink';
                            link.className = 'recenter-link';
                            link.textContent = term;
                            const suffix = document.createTextNode('"');
                            count.appendChild(prefix);
                            count.appendChild(link);
                            count.appendChild(suffix);
                        }
                        // update map markers
                        let lat = typeof data?.searchCenter?.lat === 'number' ? data.searchCenter.lat : undefined;
                        let lng = typeof data?.searchCenter?.lng === 'number' ? data.searchCenter.lng : undefined;
                        if (!map && window.google) ensureMap(lat && lng ? {
                            lat: lat,
                            lng: lng
                        } : undefined);
                        if (map) {
                            clearMarkers();
                            const currentMarkers = [];
                            if (typeof lat === 'number' && typeof lng === 'number' && !isNaN(lat) && !isNaN(lng)) {
                                const locMarker = addMarker(lat, lng, `Location: ${term}`, {
                                    useDefault: true
                                });
                                if (locMarker) currentMarkers.push(locMarker);
                            }
                            reps.forEach((r)=>{
                                if (r.latLng) {
                                    const m = addMarker(r.latLng.lat, r.latLng.lng, r.name || 'Representative');
                                    if (m) currentMarkers.push(m);
                                }
                            });
                            if (currentMarkers.length === 1) {
                                const p = getLatLngFromMarker(currentMarkers[0]);
                                if (p) {
                                    map.setCenter(p);
                                    map.setZoom(11);
                                }
                            } else if (currentMarkers.length > 1) {
                                const bounds = new google.maps.LatLngBounds();
                                currentMarkers.forEach((m)=>{
                                    const p = getLatLngFromMarker(m);
                                    if (p) bounds.extend(p);
                                });
                                map.fitBounds(bounds);
                            }
                            const recenter = document.getElementById('recenterLink');
                            if (recenter) recenter.addEventListener('click', function(e) {
                                e.preventDefault();
                                if (infoWindow && typeof infoWindow.close === 'function') infoWindow.close();
                                recenterToAllMarkers();
                            });
                        }
                    }
                } catch (e) {
                    console.error('Error parsing embedded JSON:', e);
                }
            });
            // Apply query term from URL after DOM is ready
            applyTermFromUrl();
        }
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', afterDomReady);
        else afterDomReady();
    }
    // Kick off setup after evaluating readiness
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
    else setup();
}



var $9zaOw = parcelRequire("9zaOw");

var $iouPm = parcelRequire("iouPm");

var $bWUN0 = parcelRequire("bWUN0");

var $8cF6f = parcelRequire("8cF6f");
function $4cf7bb8ecff54ff6$export$4134ea2413952409() {
    window.addEventListener('DOMContentLoaded', ()=>{
        const component = document.querySelector('.cmp-footer__newsletter');
        const form = component.querySelector('form');
        form.addEventListener('submit', (e)=>{
            e.preventDefault();
            const email = form.querySelector('input[type="email"]').value;
            (0, $iouPm.newsletterSubscribe)(email).then(()=>{
                component.classList.add('cmp-footer__newsletter--success');
                // GTM: Track successful newsletter subscription
                (0, $bWUN0.pushEvent)({
                    'event': 'formSubmission',
                    'formID': 'newsletter'
                });
            }).catch((e)=>{
                console.error('error signing up for newsletter', e);
                (0, $8cF6f.showToast)('Sorry, there was a problem adding your email address', 'error');
            });
        });
    });
}



var $iouPm = parcelRequire("iouPm");

var $9zaOw = parcelRequire("9zaOw");
function $ef5cb8ba9fd1d43d$export$a808e142f7ca3d76() {
    // try to find flyout
    const flyout = document.querySelector('[data-flyout="forgotPasswordForm"]');
    if (!flyout) return;
    // find elements
    const form = flyout.querySelector('form');
    const description = flyout.querySelector('.forgot-password-flyout__description');
    const emailInput = flyout.querySelector('input[type="email"]');
    const errorContainer = flyout.querySelector('[data-error-for="forgot-email"]');
    const successMessage = flyout.querySelector('.forgot-password-flyout__success');
    // save original display state
    const originalFormDisplay = form.style.display;
    const originalDescriptionDisplay = description.style.display;
    // reset form on close, but keep the email address
    (0, $9zaOw.FlyoutManager).subscribeToClosedEvent((e)=>{
        if (e.detail.id === 'forgotPasswordForm') {
            form.style.display = originalFormDisplay;
            description.style.display = originalDescriptionDisplay;
            errorContainer.innerHTML = '';
            successMessage.classList.add('forgot-password-flyout__success--hidden');
        }
    });
    // hook submit
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        // submit to api, display any errors
        try {
            await (0, $iouPm.forgotPassword)(emailInput.value);
            successMessage.classList.remove('forgot-password-flyout__success--hidden');
            description.style.display = 'none';
            form.style.display = 'none';
            errorContainer.style.display = 'none';
        } catch (e) {
            errorContainer.style.display = 'block';
            if (e instanceof (0, $iouPm.ValidationError)) {
                const ul = document.createElement('ul');
                e.errors.forEach((error)=>{
                    const li = document.createElement('li');
                    li.textContent = error;
                    ul.appendChild(li);
                });
                errorContainer.replaceChildren(ul);
            } else {
                console.error(e);
                const div = document.createElement('div');
                div.textContent = 'Sorry, there was a problem sending the password reset email.';
                errorContainer.replaceChildren(div);
            }
        }
    });
}




var $iouPm = parcelRequire("iouPm");
function $5533160b4bfbd429$export$9a5b1b30f367c021() {
    const id = document.documentElement.dataset?.currentPageId;
    return Number.parseInt(id);
}


/**
 * Throttle a function so it only executes once within a specified time period
 * @param {Function} func - The function to throttle
 * @param {number} delay - The delay in milliseconds
 * @returns {Function} - The throttled function
 */ function $c100eda9fdfffeb5$export$de363e709c412c8a(func, delay) {
    let lastCall = 0;
    return function(...args) {
        const now = Date.now();
        if (now - lastCall >= delay) {
            lastCall = now;
            return func.apply(this, args);
        }
    };
}



var $fWVzk = parcelRequire("fWVzk");

var $8cF6f = parcelRequire("8cF6f");
function $cff4b6e1957f2d0d$export$fa662d34acfc85fc() {
    // the header can be reloaded with ajax, we'll have to reinitialize these variables
    let headerNav = null;
    let hamburger = null;
    let menuLinks = null;
    let throttledHandleResize = null;
    const SEARCH_SUGGESTIONS_ENDPOINT = '/api/search/suggestions';
    const SEARCH_SUGGESTIONS_DEBOUNCE_MS = 250;
    const suggestionsCleanupDelay = 120;
    const RESIZE_THROTTLE_MS = 150;
    function initSearchSuggestions(root = document) {
        const forms = root.querySelectorAll('.header-nav__search');
        forms.forEach((form)=>{
            if (!form || form.dataset.suggestionsInitialized === 'true') return;
            const input = form.querySelector('.header-nav__search-bar');
            const panel = form.querySelector('[data-suggestions-panel]');
            const productsGroup = panel?.querySelector('[data-suggestions-group="products"]');
            const productsList = panel?.querySelector('[data-suggestions-list="products"]');
            const pagesGroup = panel?.querySelector('[data-suggestions-group="pages"]');
            const pagesList = panel?.querySelector('[data-suggestions-list="pages"]');
            if (!input || !panel || !productsGroup || !productsList || !pagesGroup || !pagesList) return;
            form.dataset.suggestionsInitialized = 'true';
            let debounceTimer = null;
            let activeRequest = null;
            const applyHighlightedText = (element, highlighted, fallback, defaultValue = '')=>{
                if (!element) return;
                const trimmedHighlight = typeof highlighted === 'string' ? highlighted.trim() : '';
                const trimmedFallback = typeof fallback === 'string' ? fallback.trim() : '';
                const normalizedDefault = typeof defaultValue === 'string' ? defaultValue : '';
                if (trimmedHighlight) {
                    element.innerHTML = trimmedHighlight;
                    return;
                }
                if (trimmedFallback) {
                    element.textContent = trimmedFallback;
                    return;
                }
                element.textContent = normalizedDefault;
            };
            const buildCategoryMetaFragment = (primaryText, secondaryText, primaryHighlight, secondaryHighlight)=>{
                const segments = [];
                const normalizedPrimaryHighlight = typeof primaryHighlight === 'string' ? primaryHighlight.trim() : '';
                const normalizedSecondaryHighlight = typeof secondaryHighlight === 'string' ? secondaryHighlight.trim() : '';
                const normalizedPrimaryText = typeof primaryText === 'string' ? primaryText.trim() : '';
                const normalizedSecondaryText = typeof secondaryText === 'string' ? secondaryText.trim() : '';
                if (normalizedPrimaryHighlight) segments.push({
                    type: 'html',
                    value: normalizedPrimaryHighlight
                });
                else if (normalizedPrimaryText) segments.push({
                    type: 'text',
                    value: normalizedPrimaryText
                });
                if (normalizedSecondaryHighlight) segments.push({
                    type: 'html',
                    value: normalizedSecondaryHighlight
                });
                else if (normalizedSecondaryText) segments.push({
                    type: 'text',
                    value: normalizedSecondaryText
                });
                if (segments.length === 0) return null;
                const fragment = document.createDocumentFragment();
                segments.forEach((segment, index)=>{
                    if (index > 0) fragment.appendChild(document.createTextNode(': '));
                    if (segment.type === 'html') {
                        const wrapper = document.createElement('span');
                        wrapper.innerHTML = segment.value;
                        fragment.appendChild(wrapper);
                    } else fragment.appendChild(document.createTextNode(segment.value));
                });
                return fragment;
            };
            const clearGroup = (listEl)=>{
                if (listEl) listEl.innerHTML = '';
            };
            const renderEmptyState = (groupEl, listEl, message)=>{
                if (!groupEl || !listEl) return;
                const emptyItem = document.createElement('li');
                emptyItem.className = 'header-nav__search-suggestions-empty';
                emptyItem.textContent = message;
                listEl.appendChild(emptyItem);
                groupEl.hidden = false;
            };
            const clearResults = ()=>{
                clearGroup(productsList);
                clearGroup(pagesList);
                productsGroup.hidden = true;
                pagesGroup.hidden = true;
                panel.dataset.hasResults = 'false';
            };
            const hidePanel = ()=>{
                panel.hidden = true;
                panel.setAttribute('aria-hidden', 'true');
            };
            const showPanel = ()=>{
                panel.hidden = false;
                panel.setAttribute('aria-hidden', 'false');
                panel.dataset.hasResults = 'true';
            };
            const renderProductItems = (items)=>{
                clearGroup(productsList);
                if (!Array.isArray(items) || items.length === 0) {
                    renderEmptyState(productsGroup, productsList, 'No product results');
                    return;
                }
                items.forEach((item)=>{
                    const li = document.createElement('li');
                    li.className = 'header-nav__search-suggestions-item';
                    const link = document.createElement('a');
                    link.className = 'header-nav__search-suggestions-link header-nav__search-suggestions-link--product';
                    if (item?.url) link.href = item.url;
                    else {
                        link.href = '#';
                        link.setAttribute('aria-disabled', 'true');
                        link.addEventListener('click', (ev)=>ev.preventDefault());
                    }
                    const copy = document.createElement('span');
                    copy.className = 'header-nav__search-suggestions-copy';
                    const title = document.createElement('span');
                    title.className = 'header-nav__search-suggestions-title';
                    applyHighlightedText(title, item?.highlightedTitle, item?.title, 'Untitled');
                    copy.appendChild(title);
                    if (item?.imageUrl && item.imageUrl.trim()) {
                        const img = document.createElement('img');
                        img.className = 'header-nav__search-suggestions-thumb';
                        img.src = item.imageUrl.trim();
                        img.alt = item?.title?.trim() ? `Product image for ${item.title.trim()}` : 'Product image';
                        link.appendChild(img);
                    }
                    const primaryCategoryName = item?.primaryCategoryName?.trim();
                    const secondaryCategoryName = item?.secondaryCategoryName?.trim();
                    const metaFragment = buildCategoryMetaFragment(primaryCategoryName, secondaryCategoryName, item?.highlightedPrimaryCategoryName, item?.highlightedSecondaryCategoryName);
                    if (metaFragment) {
                        const meta = document.createElement('span');
                        meta.className = 'header-nav__search-suggestions-meta';
                        meta.appendChild(metaFragment);
                        copy.appendChild(meta);
                    }
                    link.appendChild(copy);
                    li.appendChild(link);
                    productsList.appendChild(li);
                });
                productsGroup.hidden = false;
            };
            const renderPageItems = (items)=>{
                clearGroup(pagesList);
                if (!Array.isArray(items) || items.length === 0) {
                    renderEmptyState(pagesGroup, pagesList, 'No page results');
                    return;
                }
                items.forEach((item)=>{
                    const li = document.createElement('li');
                    li.className = 'header-nav__search-suggestions-item';
                    const link = document.createElement('a');
                    link.className = 'header-nav__search-suggestions-link header-nav__search-suggestions-link--page';
                    if (item?.url) {
                        link.href = item.url;
                        if (item?.contentType === 'Resource' && item?.isPdf) {
                            link.target = '_blank';
                            link.rel = 'noopener noreferrer';
                        }
                    } else {
                        link.href = '#';
                        link.setAttribute('aria-disabled', 'true');
                        link.addEventListener('click', (ev)=>ev.preventDefault());
                    }
                    const copy = document.createElement('span');
                    copy.className = 'header-nav__search-suggestions-copy';
                    const title = document.createElement('span');
                    title.className = 'header-nav__search-suggestions-title';
                    applyHighlightedText(title, item?.highlightedTitle, item?.title, 'Untitled');
                    copy.appendChild(title);
                    link.appendChild(copy);
                    if (item?.contentType === 'Resource' && item?.isPdf) {
                        const indicator = document.createElement('span');
                        indicator.className = 'header-nav__search-suggestions-indicator';
                        indicator.textContent = 'PDF';
                        link.appendChild(indicator);
                    }
                    li.appendChild(link);
                    pagesList.appendChild(li);
                });
                pagesGroup.hidden = false;
            };
            const handleResults = (data)=>{
                const products = Array.isArray(data?.products) ? data.products : [];
                const pages = Array.isArray(data?.pages) ? data.pages : [];
                renderProductItems(products);
                renderPageItems(pages);
                if (products.length === 0 && pages.length === 0) {
                    hidePanel();
                    panel.dataset.hasResults = 'false';
                    return;
                }
                showPanel();
            };
            const fetchSuggestions = async (term)=>{
                if (activeRequest) activeRequest.abort();
                const controller = new AbortController();
                activeRequest = controller;
                try {
                    const params = new URLSearchParams({
                        term: term
                    });
                    const response = await fetch(`${SEARCH_SUGGESTIONS_ENDPOINT}?${params.toString()}`, {
                        signal: controller.signal,
                        headers: {
                            Accept: 'application/json'
                        }
                    });
                    if (!response.ok) throw new Error(`Suggestions request failed with status ${response.status}`);
                    const payload = await response.json();
                    handleResults(payload);
                    activeRequest = null;
                } catch (err) {
                    if (err?.name === 'AbortError') {
                        activeRequest = null;
                        return;
                    }
                    console.error('Failed to load search suggestions', err);
                    clearResults();
                    hidePanel();
                    activeRequest = null;
                }
            };
            const debouncedFetch = (term)=>{
                if (debounceTimer) clearTimeout(debounceTimer);
                debounceTimer = setTimeout(()=>{
                    fetchSuggestions(term);
                }, SEARCH_SUGGESTIONS_DEBOUNCE_MS);
            };
            const abortActiveRequest = ()=>{
                if (debounceTimer) {
                    clearTimeout(debounceTimer);
                    debounceTimer = null;
                }
                if (activeRequest) {
                    activeRequest.abort();
                    activeRequest = null;
                }
            };
            const handleInput = ()=>{
                const term = input.value.trim();
                if (!term) {
                    abortActiveRequest();
                    clearResults();
                    hidePanel();
                    return;
                }
                debouncedFetch(term);
            };
            input.addEventListener('input', handleInput);
            input.addEventListener('focus', ()=>{
                const term = input.value.trim();
                if (term && panel.dataset.hasResults === 'true') showPanel();
            });
            input.addEventListener('keydown', (event)=>{
                if (event.key === 'Escape') {
                    hidePanel();
                    abortActiveRequest();
                    clearResults();
                    input.blur();
                }
            });
            form.addEventListener('submit', ()=>{
                abortActiveRequest();
                hidePanel();
            });
            form.addEventListener('focusout', ()=>{
                window.setTimeout(()=>{
                    if (!form.contains(document.activeElement)) hidePanel();
                }, suggestionsCleanupDelay);
            });
            clearResults();
            hidePanel();
        });
    }
    function toggleMobileMenu() {
        const searchWrapper = document.querySelector('.header-nav__search-wrapper--mobile');
        const loginMobile = document.querySelector('.header-nav__login--mobile');
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        // Check if menu is currently open (will be closed after toggle)
        const isCurrentlyOpen = headerNav?.classList.contains('header-nav--open');
        headerNav?.classList.toggle('header-nav--open');
        hamburger?.classList.toggle('is-active');
        searchWrapper?.classList.toggle('visible');
        loginMobile?.classList.toggle('visible');
        // Reset menu state when closing
        if (isCurrentlyOpen) {
            // Remove active state from all menu items
            menuWrapper?.querySelectorAll('.header-nav__menu--active').forEach((item)=>{
                item.classList.remove('header-nav__menu--active');
            });
            // Close all open submenus
            menuWrapper?.querySelectorAll('.header-nav__menu-standard.open, .header-nav__menu-mega.open').forEach((submenu)=>{
                submenu.classList.remove('open');
            });
            // Close all mega menu accordion items
            document.querySelectorAll('.header-nav__menu-title.open').forEach((title)=>{
                title.classList.remove('open');
            });
            // Restore original menu order
            restoreOriginalOrder();
            syncMenuOpenState();
        }
    }
    function initOriginalOrder() {
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        if (!menuWrapper) return;
        const items = Array.from(menuWrapper.querySelectorAll('.header-nav__menu'));
        items.forEach((el, idx)=>{
            el.dataset.originalIndex = idx;
        });
    }
    function restoreOriginalOrder() {
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        if (!menuWrapper) return;
        const items = Array.from(menuWrapper.querySelectorAll('.header-nav__menu'));
        items.sort((a, b)=>{
            return Number(a.dataset.originalIndex) - Number(b.dataset.originalIndex);
        });
        items.forEach((item)=>menuWrapper.appendChild(item));
    }
    function syncMenuOpenState() {
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        if (!menuWrapper) return;
        const hasOpenSubmenu = Boolean(menuWrapper.querySelector('.header-nav__menu-standard.open, .header-nav__menu-mega.open'));
        menuWrapper.classList.toggle('menu-open', hasOpenSubmenu);
    }
    function handleSubmenuToggle(e) {
        const parentMenuItem = e.target.closest('.header-nav__menu');
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        const submenu = parentMenuItem?.querySelector('.header-nav__menu-standard, .header-nav__menu-mega');
        if (submenu && window.innerWidth < (0, $fWVzk.BREAKPOINTS).LARGE) {
            e.preventDefault();
            const isOpen = submenu.classList.contains('open');
            if (!isOpen) {
                menuWrapper?.querySelectorAll('.header-nav__menu--active').forEach((item)=>{
                    item.classList.remove('header-nav__menu--active');
                });
                if (menuWrapper && parentMenuItem) {
                    menuWrapper.prepend(parentMenuItem);
                    parentMenuItem.classList.add('header-nav__menu--active');
                }
                menuWrapper?.querySelectorAll('.header-nav__menu-standard.open, .header-nav__menu-mega.open').forEach((openSubmenu)=>{
                    if (openSubmenu !== submenu) openSubmenu.classList.remove('open');
                });
                submenu.classList.add('open');
            } else {
                submenu.classList.remove('open');
                parentMenuItem?.classList.remove('header-nav__menu--active');
                restoreOriginalOrder();
            }
            syncMenuOpenState();
        }
    }
    function handleResize() {
        const searchWrapper = document.querySelector('.header-nav__search-wrapper--mobile');
        const menuWrapper = document.querySelector('.header-nav__menu-wrapper');
        if (window.innerWidth >= (0, $fWVzk.BREAKPOINTS).LARGE) {
            headerNav?.classList.remove('header-nav--open');
            hamburger?.classList.remove('is-active');
            searchWrapper?.classList.remove('visible');
            document.querySelector('.header-nav__login--mobile')?.classList.remove('visible');
            // Reset menu state when switching to desktop
            menuWrapper?.querySelectorAll('.header-nav__menu--active').forEach((item)=>{
                item.classList.remove('header-nav__menu--active');
            });
            menuWrapper?.querySelectorAll('.header-nav__menu-standard.open, .header-nav__menu-mega.open').forEach((submenu)=>{
                submenu.classList.remove('open');
            });
            document.querySelectorAll('.header-nav__menu-title.open').forEach((title)=>{
                title.classList.remove('open');
            });
            restoreOriginalOrder();
            syncMenuOpenState();
        }
    }
    function initMegaMenuAccordions() {
        const megaMenuTitles = document.querySelectorAll('.header-nav__menu-title');
        megaMenuTitles.forEach((title)=>{
            title.addEventListener('click', (e)=>{
                if (window.innerWidth < (0, $fWVzk.BREAKPOINTS).LARGE) {
                    const submenu = title.nextElementSibling;
                    if (submenu && submenu.tagName === 'UL') {
                        const isOpen = submenu.classList.contains('open');
                        submenu.classList.toggle('open');
                        title.classList.toggle('open');
                        megaMenuTitles.forEach((otherTitle)=>{
                            const otherSubmenu = otherTitle.nextElementSibling;
                            if (otherTitle !== title && otherSubmenu?.classList.contains('open')) {
                                otherSubmenu.classList.remove('open');
                                otherTitle.classList.remove('open');
                            }
                        });
                        e.preventDefault();
                    }
                }
            });
        });
    }
    function init() {
        headerNav = document.querySelector('.header-nav');
        hamburger = document.querySelector('.header-nav__hamburger');
        menuLinks = document.querySelectorAll('.header-nav__menu > a');
        initOriginalOrder();
        if (hamburger) hamburger.addEventListener('click', toggleMobileMenu);
        menuLinks.forEach((link)=>{
            link.addEventListener('click', (e)=>{
                handleSubmenuToggle(e);
            });
        });
        throttledHandleResize = (0, $c100eda9fdfffeb5$export$de363e709c412c8a)(handleResize, RESIZE_THROTTLE_MS);
        window.addEventListener('resize', throttledHandleResize);
        initMegaMenuAccordions();
        initSearchSuggestions(headerNav ?? document);
        initMobileProfileClick();
    }
    function initMobileProfileClick() {
        const mobileProfileSummary = document.querySelector('.header-nav__login--mobile .profile-summary');
        if (mobileProfileSummary) mobileProfileSummary.addEventListener('click', (e)=>{
            const accountUrl = mobileProfileSummary.dataset.mobileAccountUrl;
            if (accountUrl) window.location.href = accountUrl;
        });
    }
    function reloadHeader() {
        (0, $iouPm.navigationGetHeader)((0, $5533160b4bfbd429$export$9a5b1b30f367c021)()).then((header)=>{
            // clean up resize handler and replace the original DOM elements,
            // the event handler, and element references will be reinitialized by init()
            if (throttledHandleResize) window.removeEventListener('resize', throttledHandleResize);
            headerNav.outerHTML = header;
            init();
            // Dispatch event to signal header reload is complete
            document.dispatchEvent(new Event('mm.headerReloaded'));
        }).catch((err)=>{
            console.error('Failed to reload header', err);
            (0, $8cF6f.showToast)('Sorry, there was a problem reloading the menu. Please refresh the page or try again later.', 'error');
        });
    }
    document.addEventListener('DOMContentLoaded', init);
    document.addEventListener('mm.signedIn', reloadHeader);
}




function $e9e6b93f409cb85b$export$9c309e2e513159f1() {
    document.addEventListener('DOMContentLoaded', function() {
        const swiper = new (0, $74e74a0b53d40157$export$25ce5a424b770e84)('.cmp-hero__swatch-wrapper--mobile.swiper', {
            slidesPerView: 4.2,
            spaceBetween: 10,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    });
}




function $60da81f10253636a$export$eaa867ef12dc7fae() {
    const carouselContainers = document.querySelectorAll('.cmp-horizontalscrollcards');
    carouselContainers.forEach((carouselContainer)=>{
        const swiperEl = carouselContainer.querySelector('.swiper');
        const paginationEl = carouselContainer.querySelector('.swiper-pagination');
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 10,
            slidesPerGroup: 1,
            watchOverflow: false,
            pagination: {
                el: paginationEl,
                clickable: true
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        });
    });
}


var $ac9878a88e4cc6ac$exports = {};
!function(t, e) {
    $ac9878a88e4cc6ac$exports = e();
}(window, function() {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var o = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var o in t)n.d(r, o, (function(e) {
                return t[e];
            }).bind(null, o));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 47);
    }([
        function(t, e) {
            t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
        },
        function(t, e, n) {
            var r = n(11)("wks"), o = n(33), i = n(0).Symbol, c = n(54);
            t.exports = function(t) {
                return r[t] || (r[t] = c && i[t] || (c ? i : o)("Symbol." + t));
            };
        },
        function(t, e, n) {
            var r = n(5);
            t.exports = function(t) {
                if (!r(t)) throw TypeError(String(t) + " is not an object!");
                return t;
            };
        },
        function(t, e, n) {
            var r = n(8), o = n(21);
            t.exports = n(6) ? function(t, e, n) {
                return r.f(t, e, o(1, n));
            } : function(t, e, n) {
                return t[e] = n, t;
            };
        },
        function(t, e) {
            var n = {}.hasOwnProperty;
            t.exports = function(t, e) {
                return n.call(t, e);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                return "object" == typeof t ? null !== t : "function" == typeof t;
            };
        },
        function(t, e, n) {
            t.exports = !n(12)(function() {
                return 7 != Object.defineProperty({}, "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e) {
            var n = {}.toString;
            t.exports = function(t) {
                return n.call(t).slice(8, -1);
            };
        },
        function(t, e, n) {
            var r = n(6), o = n(31), i = n(2), c = n(32), u = Object.defineProperty;
            e.f = r ? u : function(t, e, n) {
                if (i(t), e = c(e, !0), i(n), o) try {
                    return u(t, e, n);
                } catch (t) {}
                if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
                return "value" in n && (t[e] = n.value), t;
            };
        },
        function(t, e, n) {
            var r = n(0), o = n(3), i = n(14), c = n(19), u = n(57);
            t.exports = function(t, e) {
                var n, a, s, f, l = t.target;
                if (n = t.global ? r : t.stat ? r[l] || c(l, {}) : (r[l] || {}).prototype) for(a in e){
                    if (s = n[a], f = e[a], !t.forced && void 0 !== s) {
                        if (typeof f == typeof s) continue;
                        u(f, s);
                    }
                    (t.sham || s && s.sham) && o(f, "sham", !0), i(n, a, f, t.unsafe);
                }
            };
        },
        function(t, e) {
            t.exports = {};
        },
        function(t, e, n) {
            var r = n(0), o = n(19), i = r["__core-js_shared__"] || o("__core-js_shared__", {});
            (t.exports = function(t, e) {
                return i[t] || (i[t] = void 0 !== e ? e : {});
            })("versions", []).push({
                version: "3.0.0-beta.3",
                mode: n(13) ? "pure" : "global",
                copyright: "\xa9 2018 Denis Pushkarev (zloirock.ru)"
            });
        },
        function(t, e) {
            t.exports = function(t) {
                try {
                    return !!t();
                } catch (t) {
                    return !0;
                }
            };
        },
        function(t, e) {
            t.exports = !1;
        },
        function(t, e, n) {
            var r = n(0), o = n(3), i = n(4), c = n(19), u = n(34), a = n(15), s = a.get, f = a.enforce, l = String(u).split("toString");
            n(11)("inspectSource", function(t) {
                return u.call(t);
            }), (t.exports = function(t, e, n, u) {
                "function" == typeof n && ("string" != typeof e || i(n, "name") || o(n, "name", e), f(n).source = l.join("string" == typeof e ? e : "")), t === r ? c(e, n) : u ? t[e] ? t[e] = n : o(t, e, n) : (delete t[e], o(t, e, n));
            })(Function.prototype, "toString", function() {
                return "function" == typeof this && s(this).source || u.call(this);
            });
        },
        function(t, e, n) {
            var r, o, i, c = n(0), u = n(34), a = n(5), s = n(3), f = n(4), l = n(22), p = n(23), v = c.WeakMap;
            if ("function" == typeof v && /native code/.test(u.call(v))) {
                var d = new v, h = d.get, y = d.has, g = d.set;
                r = function(t, e) {
                    return g.call(d, t, e), e;
                }, o = function(t) {
                    return h.call(d, t) || {};
                }, i = function(t) {
                    return y.call(d, t);
                };
            } else {
                var m = l("state");
                p[m] = !0, r = function(t, e) {
                    return s(t, m, e), e;
                }, o = function(t) {
                    return f(t, m) ? t[m] : {};
                }, i = function(t) {
                    return f(t, m);
                };
            }
            t.exports = {
                set: r,
                get: o,
                has: i,
                enforce: function(t) {
                    return i(t) ? o(t) : r(t, {});
                },
                getterFor: function(t) {
                    return function(e) {
                        var n;
                        if (!a(e) || (n = o(e)).type !== t) throw TypeError("Incompatible receiver, " + t + " required!");
                        return n;
                    };
                }
            };
        },
        function(t, e, n) {
            var r = n(60), o = n(25);
            t.exports = function(t) {
                return r(o(t));
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if ("function" != typeof t) throw TypeError(String(t) + " is not a function!");
                return t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(17);
            t.exports.f = function(t) {
                return new function(t) {
                    var e, n;
                    this.promise = new t(function(t, r) {
                        if (void 0 !== e || void 0 !== n) throw TypeError("Bad Promise constructor");
                        e = t, n = r;
                    }), this.resolve = r(e), this.reject = r(n);
                }(t);
            };
        },
        function(t, e, n) {
            var r = n(0), o = n(3);
            t.exports = function(t, e) {
                try {
                    o(r, t, e);
                } catch (n) {
                    r[t] = e;
                }
                return e;
            };
        },
        function(t, e, n) {
            var r = n(5), o = n(0).document, i = r(o) && r(o.createElement);
            t.exports = function(t) {
                return i ? o.createElement(t) : {};
            };
        },
        function(t, e) {
            t.exports = function(t, e) {
                return {
                    enumerable: !(1 & t),
                    configurable: !(2 & t),
                    writable: !(4 & t),
                    value: e
                };
            };
        },
        function(t, e, n) {
            var r = n(11)("keys"), o = n(33);
            t.exports = function(t) {
                return r[t] || (r[t] = o(t));
            };
        },
        function(t, e) {
            t.exports = {};
        },
        function(t, e) {
            var n = Math.ceil, r = Math.floor;
            t.exports = function(t) {
                return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
            };
        },
        function(t, e) {
            t.exports = function(t) {
                if (void 0 == t) throw TypeError("Can't call method on  " + t);
                return t;
            };
        },
        function(t, e) {
            t.exports = [
                "constructor",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "toLocaleString",
                "toString",
                "valueOf"
            ];
        },
        function(t, e, n) {
            var r = n(8).f, o = n(4), i = n(1)("toStringTag");
            t.exports = function(t, e, n) {
                t && !o(t = n ? t : t.prototype, i) && r(t, i, {
                    configurable: !0,
                    value: e
                });
            };
        },
        function(t, e) {
            t.exports = function(t) {
                try {
                    return {
                        e: !1,
                        v: t()
                    };
                } catch (t) {
                    return {
                        e: !0,
                        v: t
                    };
                }
            };
        },
        function(t, e, n) {
            t.exports = n(0);
        },
        function(t, e, n) {
            var r = n(7), o = n(1)("toStringTag"), i = "Arguments" == r(function() {
                return arguments;
            }());
            t.exports = function(t) {
                var e, n, c;
                return void 0 === t ? "Undefined" : null === t ? "Null" : "string" == typeof (n = function(t, e) {
                    try {
                        return t[e];
                    } catch (t) {}
                }(e = Object(t), o)) ? n : i ? r(e) : "Object" == (c = r(e)) && "function" == typeof e.callee ? "Arguments" : c;
            };
        },
        function(t, e, n) {
            t.exports = !n(6) && !n(12)(function() {
                return 7 != Object.defineProperty(n(20)("div"), "a", {
                    get: function() {
                        return 7;
                    }
                }).a;
            });
        },
        function(t, e, n) {
            var r = n(5);
            t.exports = function(t, e) {
                if (!r(t)) return t;
                var n, o;
                if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
                if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
                if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
                throw TypeError("Can't convert object to primitive value");
            };
        },
        function(t, e) {
            var n = 0, r = Math.random();
            t.exports = function(t) {
                return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
            };
        },
        function(t, e, n) {
            t.exports = n(11)("native-function-to-string", Function.toString);
        },
        function(t, e, n) {
            "use strict";
            var r = n(9), o = n(66), i = n(39), c = n(71), u = n(27), a = n(3), s = n(14), f = n(13), l = n(1)("iterator"), p = n(10), v = n(38), d = v.IteratorPrototype, h = v.BUGGY_SAFARI_ITERATORS, y = function() {
                return this;
            };
            t.exports = function(t, e, n, v, g, m, x) {
                o(n, e, v);
                var b, j, S, w = function(t) {
                    if (t === g && _) return _;
                    if (!h && t in E) return E[t];
                    switch(t){
                        case "keys":
                        case "values":
                        case "entries":
                            return function() {
                                return new n(this, t);
                            };
                    }
                    return function() {
                        return new n(this);
                    };
                }, O = e + " Iterator", P = !1, E = t.prototype, T = E[l] || E["@@iterator"] || g && E[g], _ = !h && T || w(g), L = "Array" == e && E.entries || T;
                if (L && (b = i(L.call(new t)), d !== Object.prototype && b.next && (f || i(b) === d || (c ? c(b, d) : "function" != typeof b[l] && a(b, l, y)), u(b, O, !0, !0), f && (p[O] = y))), "values" == g && T && "values" !== T.name && (P = !0, _ = function() {
                    return T.call(this);
                }), f && !x || E[l] === _ || a(E, l, _), p[e] = _, g) {
                    if (j = {
                        values: w("values"),
                        keys: m ? _ : w("keys"),
                        entries: w("entries")
                    }, x) for(S in j)!h && !P && S in E || s(E, S, j[S]);
                    else r({
                        target: e,
                        proto: !0,
                        forced: h || P
                    }, j);
                }
                return j;
            };
        },
        function(t, e, n) {
            var r = n(4), o = n(16), i = n(61)(!1), c = n(23);
            t.exports = function(t, e) {
                var n, u = o(t), a = 0, s = [];
                for(n in u)!r(c, n) && r(u, n) && s.push(n);
                for(; e.length > a;)r(u, n = e[a++]) && (~i(s, n) || s.push(n));
                return s;
            };
        },
        function(t, e, n) {
            var r = n(24), o = Math.min;
            t.exports = function(t) {
                return t > 0 ? o(r(t), 9007199254740991) : 0;
            };
        },
        function(t, e, n) {
            "use strict";
            var r, o, i, c = n(39), u = n(3), a = n(4), s = n(13), f = n(1)("iterator"), l = !1;
            [].keys && ("next" in (i = [].keys()) ? (o = c(c(i))) !== Object.prototype && (r = o) : l = !0), void 0 == r && (r = {}), s || a(r, f) || u(r, f, function() {
                return this;
            }), t.exports = {
                IteratorPrototype: r,
                BUGGY_SAFARI_ITERATORS: l
            };
        },
        function(t, e, n) {
            var r = n(4), o = n(67), i = n(22)("IE_PROTO"), c = n(68), u = Object.prototype;
            t.exports = c ? Object.getPrototypeOf : function(t) {
                return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? u : null;
            };
        },
        function(t, e, n) {
            var r = n(2), o = n(69), i = n(26), c = n(41), u = n(20), a = n(22)("IE_PROTO"), s = function() {}, f = function() {
                var t, e = u("iframe"), n = i.length;
                for(e.style.display = "none", c.appendChild(e), e.src = "javascript:", (t = e.contentWindow.document).open(), t.write("<script>document.F=Object<\/script>"), t.close(), f = t.F; n--;)delete f.prototype[i[n]];
                return f();
            };
            t.exports = Object.create || function(t, e) {
                var n;
                return null !== t ? (s.prototype = r(t), n = new s, s.prototype = null, n[a] = t) : n = f(), void 0 === e ? n : o(n, e);
            }, n(23)[a] = !0;
        },
        function(t, e, n) {
            var r = n(0).document;
            t.exports = r && r.documentElement;
        },
        function(t, e, n) {
            var r = n(2), o = n(79), i = n(37), c = n(43), u = n(80), a = n(81), s = {};
            (t.exports = function(t, e, n, f, l) {
                var p, v, d, h, y, g = c(e, n, f ? 2 : 1);
                if (l) p = t;
                else {
                    if ("function" != typeof (v = u(t))) throw TypeError("Target is not iterable!");
                    if (o(v)) {
                        for(d = 0, h = i(t.length); h > d; d++)if ((f ? g(r(y = t[d])[0], y[1]) : g(t[d])) === s) return;
                        return;
                    }
                    p = v.call(t);
                }
                for(; !(y = p.next()).done;)if (a(p, g, y.value, f) === s) return;
            }).BREAK = s;
        },
        function(t, e, n) {
            var r = n(17);
            t.exports = function(t, e, n) {
                if (r(t), void 0 === e) return t;
                switch(n){
                    case 0:
                        return function() {
                            return t.call(e);
                        };
                    case 1:
                        return function(n) {
                            return t.call(e, n);
                        };
                    case 2:
                        return function(n, r) {
                            return t.call(e, n, r);
                        };
                    case 3:
                        return function(n, r, o) {
                            return t.call(e, n, r, o);
                        };
                }
                return function() {
                    return t.apply(e, arguments);
                };
            };
        },
        function(t, e, n) {
            var r = n(2), o = n(17), i = n(1)("species");
            t.exports = function(t, e) {
                var n, c = r(t).constructor;
                return void 0 === c || void 0 == (n = r(c)[i]) ? e : o(n);
            };
        },
        function(t, e, n) {
            var r, o, i, c = n(0), u = n(7), a = n(43), s = n(41), f = n(20), l = c.setImmediate, p = c.clearImmediate, v = c.process, d = c.MessageChannel, h = c.Dispatch, y = 0, g = {}, m = function() {
                var t = +this;
                if (g.hasOwnProperty(t)) {
                    var e = g[t];
                    delete g[t], e();
                }
            }, x = function(t) {
                m.call(t.data);
            };
            l && p || (l = function(t) {
                for(var e = [], n = 1; arguments.length > n;)e.push(arguments[n++]);
                return g[++y] = function() {
                    ("function" == typeof t ? t : Function(t)).apply(void 0, e);
                }, r(y), y;
            }, p = function(t) {
                delete g[t];
            }, "process" == u(v) ? r = function(t) {
                v.nextTick(a(m, t, 1));
            } : h && h.now ? r = function(t) {
                h.now(a(m, t, 1));
            } : d ? (i = (o = new d).port2, o.port1.onmessage = x, r = a(i.postMessage, i, 1)) : c.addEventListener && "function" == typeof postMessage && !c.importScripts ? (r = function(t) {
                c.postMessage(t + "", "*");
            }, c.addEventListener("message", x, !1)) : r = "onreadystatechange" in f("script") ? function(t) {
                s.appendChild(f("script")).onreadystatechange = function() {
                    s.removeChild(this), m.call(t);
                };
            } : function(t) {
                setTimeout(a(m, t, 1), 0);
            }), t.exports = {
                set: l,
                clear: p
            };
        },
        function(t, e, n) {
            var r = n(2), o = n(5), i = n(18);
            t.exports = function(t, e) {
                if (r(t), o(e) && e.constructor === t) return e;
                var n = i.f(t);
                return (0, n.resolve)(e), n.promise;
            };
        },
        function(t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), n(48);
            !function(t) {
                t && t.__esModule;
            }(n(50));
            var r = n(91);
            e.default = r.BeerSlider;
        },
        function(t, e, n) {},
        ,
        function(t, e, n) {
            t.exports = n(51), n(89), n(90);
        },
        function(t, e, n) {
            n(52), n(55), n(73), n(77), n(88), t.exports = n(29).Promise;
        },
        function(t, e, n) {
            var r = n(53);
            r !== ({}).toString && n(14)(Object.prototype, "toString", r, !0);
        },
        function(t, e, n) {
            "use strict";
            var r = n(30), o = {};
            o[n(1)("toStringTag")] = "z", t.exports = "[object z]" !== String(o) ? function() {
                return "[object " + r(this) + "]";
            } : o.toString;
        },
        function(t, e, n) {
            t.exports = !n(12)(function() {
                String(Symbol());
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(56)(!0), o = n(15), i = n(35), c = o.set, u = o.getterFor("String Iterator");
            i(String, "String", function(t) {
                c(this, {
                    type: "String Iterator",
                    string: String(t),
                    index: 0
                });
            }, function() {
                var t, e = u(this), n = e.string, o = e.index;
                return o >= n.length ? {
                    value: void 0,
                    done: !0
                } : (t = r(n, o), e.index += t.length, {
                    value: t,
                    done: !1
                });
            });
        },
        function(t, e, n) {
            var r = n(24), o = n(25);
            t.exports = function(t) {
                return function(e, n) {
                    var i, c, u = String(o(e)), a = r(n), s = u.length;
                    return a < 0 || a >= s ? t ? "" : void 0 : (i = u.charCodeAt(a)) < 55296 || i > 56319 || a + 1 === s || (c = u.charCodeAt(a + 1)) < 56320 || c > 57343 ? t ? u.charAt(a) : i : t ? u.slice(a, a + 2) : c - 56320 + (i - 55296 << 10) + 65536;
                };
            };
        },
        function(t, e, n) {
            var r = n(4), o = n(58), i = n(64), c = n(8);
            t.exports = function(t, e) {
                for(var n = o(e), u = c.f, a = i.f, s = 0; s < n.length; s++){
                    var f = n[s];
                    r(t, f) || u(t, f, a(e, f));
                }
            };
        },
        function(t, e, n) {
            var r = n(59), o = n(63), i = n(2), c = n(0).Reflect;
            t.exports = c && c.ownKeys || function(t) {
                var e = r.f(i(t)), n = o.f;
                return n ? e.concat(n(t)) : e;
            };
        },
        function(t, e, n) {
            var r = n(36), o = n(26).concat("length", "prototype");
            e.f = Object.getOwnPropertyNames || function(t) {
                return r(t, o);
            };
        },
        function(t, e, n) {
            var r = n(7), o = "".split;
            t.exports = Object("z").propertyIsEnumerable(0) ? Object : function(t) {
                return "String" == r(t) ? o.call(t, "") : Object(t);
            };
        },
        function(t, e, n) {
            var r = n(16), o = n(37), i = n(62);
            t.exports = function(t) {
                return function(e, n, c) {
                    var u, a = r(e), s = o(a.length), f = i(c, s);
                    if (t && n != n) {
                        for(; s > f;)if ((u = a[f++]) != u) return !0;
                    } else for(; s > f; f++)if ((t || f in a) && a[f] === n) return t || f || 0;
                    return !t && -1;
                };
            };
        },
        function(t, e, n) {
            var r = n(24), o = Math.max, i = Math.min;
            t.exports = function(t, e) {
                var n = r(t);
                return n < 0 ? o(n + e, 0) : i(n, e);
            };
        },
        function(t, e) {
            e.f = Object.getOwnPropertySymbols;
        },
        function(t, e, n) {
            var r = n(6), o = n(65), i = n(21), c = n(16), u = n(32), a = n(4), s = n(31), f = Object.getOwnPropertyDescriptor;
            e.f = r ? f : function(t, e) {
                if (t = c(t), e = u(e, !0), s) try {
                    return f(t, e);
                } catch (t) {}
                if (a(t, e)) return i(!o.f.call(t, e), t[e]);
            };
        },
        function(t, e, n) {
            "use strict";
            var r = {}.propertyIsEnumerable, o = Object.getOwnPropertyDescriptor, i = o && !r.call({
                1: 2
            }, 1);
            e.f = i ? function(t) {
                var e = o(this, t);
                return !!e && e.enumerable;
            } : r;
        },
        function(t, e, n) {
            "use strict";
            var r = n(38).IteratorPrototype, o = n(40), i = n(21), c = n(27), u = n(10), a = function() {
                return this;
            };
            t.exports = function(t, e, n) {
                var s = e + " Iterator";
                return t.prototype = o(r, {
                    next: i(1, n)
                }), c(t, s, !1, !0), u[s] = a, t;
            };
        },
        function(t, e, n) {
            var r = n(25);
            t.exports = function(t) {
                return Object(r(t));
            };
        },
        function(t, e, n) {
            t.exports = !n(12)(function() {
                function t() {}
                return t.prototype.constructor = null, Object.getPrototypeOf(new t) !== t.prototype;
            });
        },
        function(t, e, n) {
            var r = n(6), o = n(8), i = n(2), c = n(70);
            t.exports = r ? Object.defineProperties : function(t, e) {
                i(t);
                for(var n, r = c(e), u = r.length, a = 0; u > a;)o.f(t, n = r[a++], e[n]);
                return t;
            };
        },
        function(t, e, n) {
            var r = n(36), o = n(26);
            t.exports = Object.keys || function(t) {
                return r(t, o);
            };
        },
        function(t, e, n) {
            var r = n(72);
            t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
                var t, e = {}, n = !0;
                try {
                    (t = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set).call(e, []), n = e instanceof Array;
                } catch (t) {
                    n = !1;
                }
                return function(e, o) {
                    return r(e, o), n ? t.call(e, o) : e.__proto__ = o, e;
                };
            }() : void 0);
        },
        function(t, e, n) {
            var r = n(5), o = n(2);
            t.exports = function(t, e) {
                if (o(t), !r(e) && null !== e) throw TypeError(String(e) + ": can't set as a prototype!");
            };
        },
        function(t, e, n) {
            var r = n(74), o = n(75), i = n(0), c = n(3), u = n(1), a = u("iterator"), s = u("toStringTag"), f = o.values;
            for(var l in r){
                var p = i[l], v = p && p.prototype;
                if (v) {
                    if (v[a] !== f) try {
                        c(v, a, f);
                    } catch (t) {
                        v[a] = f;
                    }
                    if (v[s] || c(v, s, l), r[l]) {
                        for(var d in o)if (v[d] !== o[d]) try {
                            c(v, d, o[d]);
                        } catch (t) {
                            v[d] = o[d];
                        }
                    }
                }
            }
        },
        function(t, e) {
            t.exports = {
                CSSRuleList: 0,
                CSSStyleDeclaration: 0,
                CSSValueList: 0,
                ClientRectList: 0,
                DOMRectList: 0,
                DOMStringList: 0,
                DOMTokenList: 1,
                DataTransferItemList: 0,
                FileList: 0,
                HTMLAllCollection: 0,
                HTMLCollection: 0,
                HTMLFormElement: 0,
                HTMLSelectElement: 0,
                MediaList: 0,
                MimeTypeArray: 0,
                NamedNodeMap: 0,
                NodeList: 1,
                PaintRequestList: 0,
                Plugin: 0,
                PluginArray: 0,
                SVGLengthList: 0,
                SVGNumberList: 0,
                SVGPathSegList: 0,
                SVGPointList: 0,
                SVGStringList: 0,
                SVGTransformList: 0,
                SourceBufferList: 0,
                StyleSheetList: 0,
                TextTrackCueList: 0,
                TextTrackList: 0,
                TouchList: 0
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(16), o = n(76), i = n(10), c = n(15), u = n(35), a = c.set, s = c.getterFor("Array Iterator");
            t.exports = u(Array, "Array", function(t, e) {
                a(this, {
                    type: "Array Iterator",
                    target: r(t),
                    index: 0,
                    kind: e
                });
            }, function() {
                var t = s(this), e = t.target, n = t.kind, r = t.index++;
                return !e || r >= e.length ? (t.target = void 0, {
                    value: void 0,
                    done: !0
                }) : "keys" == n ? {
                    value: r,
                    done: !1
                } : "values" == n ? {
                    value: e[r],
                    done: !1
                } : {
                    value: [
                        r,
                        e[r]
                    ],
                    done: !1
                };
            }, "values"), i.Arguments = i.Array, o("keys"), o("values"), o("entries");
        },
        function(t, e, n) {
            var r = n(1)("unscopables"), o = n(40), i = n(3), c = Array.prototype;
            void 0 == c[r] && i(c, r, o(null)), t.exports = function(t) {
                c[r][t] = !0;
            };
        },
        function(t, e, n) {
            "use strict";
            var r, o, i, c = "Promise", u = n(13), a = n(0), s = n(9), f = n(5), l = n(17), p = n(78), v = n(7), d = n(42), h = n(82), y = n(44), g = n(45).set, m = n(83)(), x = n(46), b = n(84), j = n(18), S = n(28), w = n(85), O = n(1)("species"), P = n(15), E = P.get, T = P.set, _ = P.getterFor(c), L = a.Promise, M = a.TypeError, I = a.document, A = a.process, k = A && A.versions, C = k && k.v8 || "", R = j.f, F = R, B = "process" == v(A), D = !!(I && I.createEvent && a.dispatchEvent), G = !!function() {
                try {
                    var t = L.resolve(1), e = function() {}, n = (t.constructor = {})[O] = function(t) {
                        t(e, e);
                    };
                    return (B || "function" == typeof PromiseRejectionEvent) && (!u || t.finally) && t.then(e) instanceof n && 0 !== C.indexOf("6.6") && -1 === w.indexOf("Chrome/66");
                } catch (t) {}
            }(), N = function(t) {
                var e;
                return !(!f(t) || "function" != typeof (e = t.then)) && e;
            }, V = function(t, e, n) {
                if (!e.notified) {
                    e.notified = !0;
                    var r = e.reactions;
                    m(function() {
                        for(var o = e.value, i = 1 == e.state, c = 0, u = function(n) {
                            var r, c, u, a = i ? n.ok : n.fail, s = n.resolve, f = n.reject, l = n.domain;
                            try {
                                a ? (i || (2 === e.rejection && U(t, e), e.rejection = 1), !0 === a ? r = o : (l && l.enter(), r = a(o), l && (l.exit(), u = !0)), r === n.promise ? f(M("Promise-chain cycle")) : (c = N(r)) ? c.call(r, s, f) : s(r)) : f(o);
                            } catch (t) {
                                l && !u && l.exit(), f(t);
                            }
                        }; r.length > c;)u(r[c++]);
                        e.reactions = [], e.notified = !1, n && !e.rejection && z(t, e);
                    });
                }
            }, W = function(t, e, n) {
                var r, o;
                D ? ((r = I.createEvent("Event")).promise = e, r.reason = n, r.initEvent(t, !1, !0), a.dispatchEvent(r)) : r = {
                    promise: e,
                    reason: n
                }, (o = a["on" + t]) ? o(r) : "unhandledrejection" === t && b("Unhandled promise rejection", n);
            }, z = function(t, e) {
                g.call(a, function() {
                    var n, r = e.value, o = H(e);
                    if (o && (n = S(function() {
                        B ? A.emit("unhandledRejection", r, t) : W("unhandledrejection", t, r);
                    }), e.rejection = B || H(e) ? 2 : 1), o && n.e) throw n.v;
                });
            }, H = function(t) {
                return 1 !== t.rejection && !t.parent;
            }, U = function(t, e) {
                g.call(a, function() {
                    B ? A.emit("rejectionHandled", t) : W("rejectionhandled", t, e.value);
                });
            }, K = function(t, e, n, r) {
                return function(o) {
                    t(e, n, o, r);
                };
            }, q = function(t, e, n, r) {
                e.done || (e.done = !0, r && (e = r), e.value = n, e.state = 2, V(t, e, !0));
            }, Y = function(t, e, n, r) {
                if (!e.done) {
                    e.done = !0, r && (e = r);
                    try {
                        if (t === n) throw M("Promise can't be resolved itself!");
                        var o = N(n);
                        o ? m(function() {
                            var r = {
                                done: !1
                            };
                            try {
                                o.call(n, K(Y, t, r, e), K(q, t, r, e));
                            } catch (n) {
                                q(t, r, n, e);
                            }
                        }) : (e.value = n, e.state = 1, V(t, e, !1));
                    } catch (n) {
                        q(t, {
                            done: !1
                        }, n, e);
                    }
                }
            };
            G || (L = function(t) {
                p(this, L, c), l(t), r.call(this);
                var e = E(this);
                try {
                    t(K(Y, this, e), K(q, this, e));
                } catch (t) {
                    q(this, e, t);
                }
            }, (r = function(t) {
                T(this, {
                    type: c,
                    done: !1,
                    notified: !1,
                    parent: !1,
                    reactions: [],
                    rejection: !1,
                    state: 0,
                    value: void 0
                });
            }).prototype = n(86)(L.prototype, {
                then: function(t, e) {
                    var n = _(this), r = R(y(this, L));
                    return r.ok = "function" != typeof t || t, r.fail = "function" == typeof e && e, r.domain = B ? A.domain : void 0, n.parent = !0, n.reactions.push(r), 0 != n.state && V(this, n, !1), r.promise;
                },
                catch: function(t) {
                    return this.then(void 0, t);
                }
            }), o = function() {
                var t = new r, e = E(t);
                this.promise = t, this.resolve = K(Y, t, e), this.reject = K(q, t, e);
            }, j.f = R = function(t) {
                return t === L || t === i ? new o(t) : F(t);
            }), s({
                global: !0,
                wrap: !0,
                forced: !G
            }, {
                Promise: L
            }), n(27)(L, c, !1, !0), n(87)(c), i = n(29).Promise, s({
                target: c,
                stat: !0,
                forced: !G
            }, {
                reject: function(t) {
                    var e = R(this);
                    return e.reject.call(void 0, t), e.promise;
                }
            }), s({
                target: c,
                stat: !0,
                forced: u || !G
            }, {
                resolve: function(t) {
                    return x(u && this === i ? L : this, t);
                }
            }), s({
                target: c,
                stat: !0,
                forced: !(G && h(function(t) {
                    L.all(t).catch(function() {});
                }))
            }, {
                all: function(t) {
                    var e = this, n = R(e), r = n.resolve, o = n.reject, i = S(function() {
                        var n = [], i = 0, c = 1;
                        d(t, function(t) {
                            var u = i++, a = !1;
                            n.push(void 0), c++, e.resolve(t).then(function(t) {
                                a || (a = !0, n[u] = t, --c || r(n));
                            }, o);
                        }), --c || r(n);
                    });
                    return i.e && o(i.v), n.promise;
                },
                race: function(t) {
                    var e = this, n = R(e), r = n.reject, o = S(function() {
                        d(t, function(t) {
                            e.resolve(t).then(n.resolve, r);
                        });
                    });
                    return o.e && r(o.v), n.promise;
                }
            });
        },
        function(t, e) {
            t.exports = function(t, e, n) {
                if (!(t instanceof e)) throw TypeError((n ? n + ": i" : "I") + "ncorrect invocation!");
                return t;
            };
        },
        function(t, e, n) {
            var r = n(10), o = n(1)("iterator"), i = Array.prototype;
            t.exports = function(t) {
                return void 0 !== t && (r.Array === t || i[o] === t);
            };
        },
        function(t, e, n) {
            var r = n(30), o = n(1)("iterator"), i = n(10);
            t.exports = function(t) {
                if (void 0 != t) return t[o] || t["@@iterator"] || i[r(t)];
            };
        },
        function(t, e, n) {
            var r = n(2);
            t.exports = function(t, e, n, o) {
                try {
                    return o ? e(r(n)[0], n[1]) : e(n);
                } catch (e) {
                    var i = t.return;
                    throw void 0 !== i && r(i.call(t)), e;
                }
            };
        },
        function(t, e, n) {
            var r = n(1)("iterator"), o = !1;
            try {
                var i = 0, c = {
                    next: function() {
                        return {
                            done: !!i++
                        };
                    },
                    return: function() {
                        o = !0;
                    }
                };
                c[r] = function() {
                    return this;
                }, Array.from(c, function() {
                    throw 2;
                });
            } catch (t) {}
            t.exports = function(t, e) {
                if (!e && !o) return !1;
                var n = !1;
                try {
                    var i = {};
                    i[r] = function() {
                        return {
                            next: function() {
                                return {
                                    done: n = !0
                                };
                            }
                        };
                    }, t(i);
                } catch (t) {}
                return n;
            };
        },
        function(t, e, n) {
            var r = n(0), o = n(7), i = n(45).set, c = r.MutationObserver || r.WebKitMutationObserver, u = r.process, a = r.Promise, s = "process" == o(u);
            t.exports = function() {
                var t, e, n, o = function() {
                    var r, o;
                    for(s && (r = u.domain) && r.exit(); t;){
                        o = t.fn, t = t.next;
                        try {
                            o();
                        } catch (r) {
                            throw t ? n() : e = void 0, r;
                        }
                    }
                    e = void 0, r && r.enter();
                };
                if (s) n = function() {
                    u.nextTick(o);
                };
                else if (!c || r.navigator && r.navigator.standalone) {
                    if (a && a.resolve) {
                        var f = a.resolve(void 0);
                        n = function() {
                            f.then(o);
                        };
                    } else n = function() {
                        i.call(r, o);
                    };
                } else {
                    var l = !0, p = document.createTextNode("");
                    new c(o).observe(p, {
                        characterData: !0
                    }), n = function() {
                        p.data = l = !l;
                    };
                }
                return function(r) {
                    var o = {
                        fn: r,
                        next: void 0
                    };
                    e && (e.next = o), t || (t = o, n()), e = o;
                };
            };
        },
        function(t, e, n) {
            var r = n(0);
            t.exports = function(t, e) {
                var n = r.console;
                n && n.error && (1 === arguments.length ? n.error(t) : n.error(t, e));
            };
        },
        function(t, e, n) {
            var r = n(0).navigator;
            t.exports = r && r.userAgent || "";
        },
        function(t, e, n) {
            var r = n(14);
            t.exports = function(t, e, n) {
                for(var o in e)r(t, o, e[o], n);
                return t;
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(0), o = n(8), i = n(6), c = n(1)("species");
            t.exports = function(t) {
                var e = r[t];
                i && e && !e[c] && o.f(e, c, {
                    configurable: !0,
                    get: function() {
                        return this;
                    }
                });
            };
        },
        function(t, e, n) {
            "use strict";
            var r = n(29), o = n(0), i = n(44), c = n(46);
            n(9)({
                target: "Promise",
                proto: !0,
                real: !0
            }, {
                finally: function(t) {
                    var e = i(this, "function" == typeof r.Promise ? r.Promise : o.Promise), n = "function" == typeof t;
                    return this.then(n ? function(n) {
                        return c(e, t()).then(function() {
                            return n;
                        });
                    } : t, n ? function(n) {
                        return c(e, t()).then(function() {
                            throw n;
                        });
                    } : t);
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(18), o = n(28), i = n(42);
            n(9)({
                target: "Promise",
                stat: !0
            }, {
                allSettled: function(t) {
                    var e = this, n = r.f(e), c = n.resolve, u = n.reject, a = o(function() {
                        var n = [], r = 0, o = 1;
                        i(t, function(t) {
                            var i = r++, u = !1;
                            n.push(void 0), o++, e.resolve(t).then(function(t) {
                                u || (u = !0, n[i] = {
                                    value: t,
                                    status: "fulfilled"
                                }, --o || c(n));
                            }, function(t) {
                                u || (u = !0, n[i] = {
                                    reason: t,
                                    status: "rejected"
                                }, --o || c(n));
                            });
                        }), --o || c(n);
                    });
                    return a.e && u(a.v), n.promise;
                }
            });
        },
        function(t, e, n) {
            "use strict";
            var r = n(18), o = n(28);
            n(9)({
                target: "Promise",
                stat: !0
            }, {
                try: function(t) {
                    var e = r.f(this), n = o(t);
                    return (n.e ? e.reject : e.resolve)(n.v), e.promise;
                }
            });
        },
        function(t, e, n) {
            "use strict";
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = function() {
                function t(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                return function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                };
            }();
            e.BeerSlider = function() {
                function t(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = n.start, o = void 0 === r ? "50" : r, i = n.prefix, c = void 0 === i ? "beer" : i;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), this.start = parseInt(o) ? Math.min(100, Math.max(0, parseInt(o))) : 50, this.prefix = c, e && 2 === e.children.length && (this.element = e, this.revealContainer = this.element.children[1], this.revealContainer.children.length < 1 || (this.revealElement = this.revealContainer.children[0], this.range = this.addElement("input", {
                        type: "range",
                        class: this.prefix + "-range",
                        "aria-label": "Percent of revealed content",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        "aria-valuenow": this.start,
                        value: this.start,
                        min: "0",
                        max: "100"
                    }), this.handle = this.addElement("span", {
                        class: this.prefix + "-handle"
                    }), this.onImagesLoad()));
                }
                return r(t, [
                    {
                        key: "init",
                        value: function() {
                            this.element.classList.add(this.prefix + "-ready"), this.setImgWidth(), this.move(), this.addListeners();
                        }
                    },
                    {
                        key: "loadingImg",
                        value: function(t) {
                            return new Promise(function(e, n) {
                                t || e();
                                var r = new Image;
                                r.onload = function() {
                                    return e();
                                }, r.onerror = function() {
                                    return n();
                                }, r.src = t;
                            });
                        }
                    },
                    {
                        key: "loadedBoth",
                        value: function() {
                            var t = this.element.children[0].src || this.element.children[0].getAttribute("data-" + this.prefix + "-src"), e = this.revealElement.src || this.revealElement.getAttribute("data-" + this.prefix + "-src");
                            return Promise.all([
                                this.loadingImg(t),
                                this.loadingImg(e)
                            ]);
                        }
                    },
                    {
                        key: "onImagesLoad",
                        value: function() {
                            var t = this;
                            this.revealElement && this.loadedBoth().then(function() {
                                t.init();
                            }, function() {
                                console.error("Some errors occurred and images are not loaded.");
                            });
                        }
                    },
                    {
                        key: "addElement",
                        value: function(t, e) {
                            var n = document.createElement(t);
                            return Object.keys(e).forEach(function(t) {
                                n.setAttribute(t, e[t]);
                            }), this.element.appendChild(n), n;
                        }
                    },
                    {
                        key: "setImgWidth",
                        value: function() {
                            this.revealElement.style.width = getComputedStyle(this.element).width;
                        }
                    },
                    {
                        key: "addListeners",
                        value: function() {
                            var t = this;
                            [
                                "input",
                                "change"
                            ].forEach(function(e) {
                                t.range.addEventListener(e, function() {
                                    t.move();
                                });
                            }), window.addEventListener("resize", function() {
                                t.setImgWidth();
                            });
                        }
                    },
                    {
                        key: "move",
                        value: function() {
                            this.revealContainer.style.width = this.range.value + "%", this.handle.style.left = this.range.value + "%", this.range.setAttribute("aria-valuenow", this.range.value);
                        }
                    }
                ]), t;
            }();
        }
    ]).default;
});


function $7eee2698ee4a8e94$export$62624d0d40a71436() {
    const sliders = document.querySelectorAll('.beerslider');
    sliders.forEach((slider)=>{
        const beerSlider = new (0, (/*@__PURE__*/$parcel$interopDefault($ac9878a88e4cc6ac$exports)))(slider);
        // Fix for iOS touch events on range input
        // iOS has a known issue where range inputs don't properly fire input/change events
        // during touch drag operations. This polyfill manually calculates position and
        // updates the slider when touch events occur.
        const rangeInput = slider.querySelector('.beer-range');
        if (rangeInput && 'ontouchstart' in window) {
            let isTouching = false;
            const updateSliderFromTouch = (touch)=>{
                const rect = rangeInput.getBoundingClientRect();
                const percentage = (touch.clientX - rect.left) / rect.width * 100;
                const clampedValue = Math.min(100, Math.max(0, percentage));
                rangeInput.value = clampedValue;
                rangeInput.setAttribute('aria-valuenow', clampedValue);
                // Trigger the change manually for BeerSlider to update visuals
                const inputEvent = new Event('input', {
                    bubbles: true
                });
                rangeInput.dispatchEvent(inputEvent);
            };
            rangeInput.addEventListener('touchstart', (e)=>{
                isTouching = true;
                updateSliderFromTouch(e.touches[0]);
            }, {
                passive: true
            });
            rangeInput.addEventListener('touchmove', (e)=>{
                if (isTouching) {
                    updateSliderFromTouch(e.touches[0]);
                    // Only prevent default during move to avoid blocking click/tap
                    e.preventDefault();
                }
            }, {
                passive: false
            });
            rangeInput.addEventListener('touchend', ()=>{
                isTouching = false;
            }, {
                passive: true
            });
            rangeInput.addEventListener('touchcancel', ()=>{
                isTouching = false;
            }, {
                passive: true
            });
        }
    });
}






function $e336711da62fd953$export$ea8d253c7a42b838() {
    const grid = document.getElementById('images-grid');
    if (!grid) return;
    const filterButtons = document.querySelectorAll('.segments-container .segments-filter .segment-filter-btn');
    const loadMoreBtn = document.getElementById('load-more-images');
    const progressText = document.getElementById('postProgressText');
    const progressBar = document.getElementById('postProgressBar');
    const ITEMS_PER_PAGE = 18;
    let itemsToShow = ITEMS_PER_PAGE;
    let currentSegment = 'all';
    const allItems = Array.from(grid.querySelectorAll('.image-item'));
    function markFilteredItems() {
        let eligible;
        if (currentSegment === 'all') eligible = allItems;
        else eligible = allItems.filter((item)=>{
            const segmentsAttr = item.getAttribute('data-segments') || '';
            const segments = segmentsAttr.split(',').map((s)=>s.trim()).filter(Boolean);
            return segments.includes(currentSegment);
        });
        grid.innerHTML = '';
        eligible.forEach((item)=>{
            item.classList.remove('filtered-out', 'hidden-by-pagination');
            item.style.display = '';
            grid.appendChild(item);
        });
        return eligible;
    }
    function applyPagination(eligibleItems) {
        const eligible = eligibleItems || Array.from(grid.querySelectorAll('.image-item'));
        let visibleCount = 0;
        eligible.forEach((item, index)=>{
            if (index < itemsToShow) {
                item.style.display = '';
                item.classList.remove('hidden-by-pagination');
                visibleCount++;
            } else {
                item.style.display = 'none';
                item.classList.add('hidden-by-pagination');
            }
        });
        if (loadMoreBtn) loadMoreBtn.style.display = visibleCount < eligible.length ? '' : 'none';
        if (progressText && progressBar) {
            progressText.textContent = `Showing ${visibleCount} of ${eligible.length}`;
            const percent = eligible.length > 0 ? visibleCount / eligible.length * 100 : 0;
            progressBar.style.width = `${percent}%`;
        }
    }
    function resetAndApply() {
        itemsToShow = ITEMS_PER_PAGE;
        const eligible = markFilteredItems();
        applyPagination(eligible);
    }
    filterButtons.forEach((btn)=>{
        btn.addEventListener('click', function() {
            filterButtons.forEach((b)=>b.classList.remove('active'));
            this.classList.add('active');
            currentSegment = this.getAttribute('data-segment') || 'all';
            resetAndApply();
        });
    });
    if (loadMoreBtn) loadMoreBtn.addEventListener('click', ()=>{
        itemsToShow += ITEMS_PER_PAGE;
        const eligible = Array.from(grid.querySelectorAll('.image-item'));
        applyPagination(eligible);
    });
    window.addEventListener('resize', (0, $c100eda9fdfffeb5$export$de363e709c412c8a)(()=>{
        const eligible = Array.from(grid.querySelectorAll('.image-item'));
        applyPagination(eligible);
    }, 150));
    resetAndApply();
    const modal = document.getElementById('image-modal');
    if (!modal) return;
    const modalClose = document.getElementById('image-modal-close');
    const modalCloseMobile = document.getElementById('image-modal-close--mobile');
    const modalSwiperWrapper = document.getElementById('modal-swiper-wrapper');
    const modalNextBtns = modal.querySelectorAll('.swiper-button-next');
    const modalPrevBtns = modal.querySelectorAll('.swiper-button-prev');
    const modalSwiper = new (0, $74e74a0b53d40157$export$25ce5a424b770e84)('.modal-swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: Array.from(modalNextBtns),
            prevEl: Array.from(modalPrevBtns)
        },
        on: {
            slideChange: function() {
                updateModalMetadata(this.activeIndex);
                updateModalButtons(this.activeIndex);
            }
        }
    });
    const updateModalMetadata = (index)=>{
        const slide = modalSwiperWrapper.children[index];
        const metaScript = slide.querySelector('.cmp-imagegallery__modal-meta');
        if (metaScript) try {
            const meta = JSON.parse(metaScript.textContent);
            // Update product info using shared utility
            (0, $def8ecdd50291906$export$148e7f13f2b991b1)(meta, modal);
        } catch (e) {
            console.error('Error parsing modal metadata:', e);
        }
    };
    // Update modal Add-to-Board buttons for active slide
    const updateModalButtons = (index)=>{
        const slide = modalSwiperWrapper.children[index];
        if (!slide) return;
        const img = slide.querySelector('img.add-to-board[data-mc-project-board-asset-info]');
        if (!img) return;
        const assetInfo = img.getAttribute('data-mc-project-board-asset-info');
        const buttons = modal.querySelectorAll('[data-flyout-trigger="addToBoard"]');
        buttons.forEach((button)=>button.setAttribute('data-asset-info', assetInfo));
    };
    grid.querySelectorAll('.cmp-imagescrollgallery__card-image').forEach((img, index)=>{
        img.addEventListener('click', ()=>{
            modal.removeAttribute('hidden');
            modalSwiper.slideTo(index);
            updateModalMetadata(index);
            updateModalButtons(index);
        });
    });
    modalClose?.addEventListener('click', ()=>{
        modal.setAttribute('hidden', 'true');
    });
    modalCloseMobile?.addEventListener('click', ()=>{
        modal.setAttribute('hidden', 'true');
    });
}






var $fWVzk = parcelRequire("fWVzk");
function $c63b6f00e4153771$export$7754fa6ee24dcde0() {
    const galleryContainers = document.querySelectorAll('.cmp-imagegallery');
    galleryContainers.forEach((galleryContainer)=>{
        const swiperEl = galleryContainer.querySelector('.swiper');
        const nextBtn = galleryContainer.querySelector('.swiper-button-next');
        const prevBtn = galleryContainer.querySelector('.swiper-button-prev');
        const mainSwiper = new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 10,
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            },
            breakpoints: {
                350: {
                    slidesPerView: 1.2
                },
                [(0, $fWVzk.BREAKPOINTS).LARGE]: {
                    slidesPerView: 1.5
                }
            }
        });
        const modal = document.getElementById('image-modal');
        const modalClose = document.getElementById('image-modal-close');
        const modalSwiperWrapper = document.getElementById('modal-swiper-wrapper');
        const modalNextBtns = modal.querySelectorAll('.swiper-button-next');
        const modalPrevBtns = modal.querySelectorAll('.swiper-button-prev');
        const modalSwiper = new (0, $74e74a0b53d40157$export$25ce5a424b770e84)('.modal-swiper', {
            slidesPerView: 1,
            navigation: {
                nextEl: Array.from(modalNextBtns),
                prevEl: Array.from(modalPrevBtns)
            },
            on: {
                slideChange: function() {
                    updateModalMetadata(modalSwiper.activeIndex);
                }
            }
        });
        const updateModalMetadata = (index)=>{
            const slide = modalSwiperWrapper.children[index];
            const metaScript = slide.querySelector('.cmp-imagegallery__modal-meta');
            if (metaScript) try {
                const meta = JSON.parse(metaScript.textContent);
                // Update product info using shared utility
                (0, $def8ecdd50291906$export$148e7f13f2b991b1)(meta, modal);
            } catch (e) {
                console.error('Error parsing modal metadata:', e);
            }
        };
        // Open modal and go to correct slide
        galleryContainer.querySelectorAll('.cmp-imagegallery__modal-button').forEach((btn, index)=>{
            btn.addEventListener('click', ()=>{
                modal.removeAttribute('hidden');
                modalSwiper.slideToLoop(index);
                updateModalMetadata(index);
            });
        });
        const modalCloseMobile = document.getElementById('image-modal-close--mobile');
        modalClose.addEventListener('click', ()=>{
            modal.setAttribute('hidden', 'true');
        });
        if (modalCloseMobile) modalCloseMobile.addEventListener('click', ()=>{
            modal.setAttribute('hidden', 'true');
        });
    });
}



function $3da1742ac8b8dc2f$export$b83f411861f35e23() {
    document.addEventListener('DOMContentLoaded', async function() {
        const container = document.getElementById('project-board-list-container');
        if (container) {
            const defaultBoardImage = container?.dataset.defaultBoardImage;
            const listModule = await (parcelRequire("41yrs"));
            listModule.initProjectBoardList(container, defaultBoardImage);
        }
    });
}



function $e9db92a032b783a9$export$74a56e8957377fa6() {
    document.addEventListener('DOMContentLoaded', async function() {
        const container = document.getElementById('project-board-details-container');
        if (container) {
            const boardId = container.dataset.projectBoardId;
            const sharedInfo = container.dataset.sharedInfo;
            const productCategoryLinks = container.dataset.productCategoryLinks ? JSON.parse(container.dataset.productCategoryLinks) : {};
            const detailsModule = await (parcelRequire("1nFdx"));
            const checkoutEnabled = JSON.parse(container.dataset.checkoutEnabled ?? "true");
            detailsModule.initProjectBoardDetails(container, boardId, container.dataset.sharing === '1', sharedInfo, productCategoryLinks, checkoutEnabled);
        }
    });
}



var $iouPm = parcelRequire("iouPm");

var $bWUN0 = parcelRequire("bWUN0");

var $8cF6f = parcelRequire("8cF6f");

var $9zaOw = parcelRequire("9zaOw");
function $5cc5e06d1bee6043$export$4cee5bd251fa27b() {
    const flyout = document.querySelector('[data-flyout="registerForm"]');
    const passwordInput = flyout?.querySelector('#register-password');
    const confirmPasswordInput = flyout?.querySelector('#confirmPassword');
    const eyeIcons = flyout?.querySelectorAll(".register-flyout__eye-icon") || [];
    const submitButton = flyout?.querySelector('button[type="submit"]');
    const emailInput = flyout.querySelector("#email");
    const zipInput = flyout.querySelector("#zip");
    const emailError = flyout.querySelector('[data-error-for="email"]');
    const generalErrorDiv = flyout.querySelector('.alert.alert-error');
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    eyeIcons.forEach((icon)=>{
        const input = icon.previousElementSibling;
        if (!input) return;
        icon.addEventListener("click", ()=>{
            const isPassword = input.type === "password";
            input.type = isPassword ? "text" : "password";
            icon.alt = isPassword ? "Hide password" : "Show password";
            icon.src = isPassword ? "/images/eye-icon-hide.svg" : "/images/eye-icon.svg";
        });
    });
    const requiredFields = [
        "#fname",
        "#lname",
        "#email",
        "#zip",
        "#register-password",
        "#confirmPassword",
        "#occupation"
    ].map((selector)=>flyout?.querySelector(selector)).filter(Boolean);
    const segmentsMultipleField = flyout?.querySelector(".segment-select-multiple");
    async function populateDropdowns() {
        try {
            const [occupations, segments] = await Promise.all([
                (0, $iouPm.occupationTypesList)(),
                (0, $iouPm.segmentTypesList)()
            ]);
            const occupationSelect = flyout.querySelector("#occupation");
            if (occupationSelect) occupations.forEach((item)=>{
                const option = document.createElement('option');
                option.text = item.name;
                option.value = item.name;
                occupationSelect.appendChild(option);
            });
            const segmentSelect = flyout.querySelector(".segment-select");
            const segmentsMultiple = flyout.querySelector(".segment-select-multiple");
            if (segmentSelect && segmentsMultiple) segments.forEach((item)=>{
                // Populate visible dropdown
                const visibleOption = document.createElement('option');
                visibleOption.text = item.name;
                visibleOption.value = item.id;
                segmentSelect.appendChild(visibleOption);
                // Populate hidden multi-select
                const hiddenOption = document.createElement('option');
                hiddenOption.text = item.name;
                hiddenOption.value = item.id;
                segmentsMultiple.appendChild(hiddenOption);
            });
        } catch (err) {
            console.error("Failed to load registration form data:", err);
        }
    }
    populateDropdowns().catch((err)=>console.error("Failed to load registration form data:", err));
    function showError(field, message) {
        field.classList.add("error");
        const errorEl = flyout.querySelector(`.error-message[data-error-for="${field.id}"]`);
        if (errorEl) {
            errorEl.textContent = message;
            errorEl.classList.add("visible");
        }
    }
    function clearError(field) {
        field.classList.remove("error");
        const errorEl = flyout.querySelector(`.error-message[data-error-for="${field.id}"]`);
        if (errorEl) {
            errorEl.textContent = "";
            errorEl.classList.remove("visible");
        }
    }
    const toggleSubmitState = ()=>{
        const allFilled = requiredFields.every((field)=>{
            if (field.tagName === "SELECT") return field.value && field.selectedIndex !== 0;
            return field.value.trim().length > 0;
        });
        // Also check if at least one segment is selected
        const hasSegment = segmentsMultipleField && segmentsMultipleField.selectedOptions.length > 0;
        // Validate email format
        const emailValid = emailInput && emailPattern.test(emailInput.value.trim());
        submitButton.disabled = !(allFilled && hasSegment && emailValid);
    };
    requiredFields.forEach((field)=>{
        const eventType = field.tagName === "SELECT" ? "change" : "input";
        field.addEventListener(eventType, ()=>{
            clearError(field);
            toggleSubmitState();
        });
    });
    // Add blur validation for email field
    if (emailInput) emailInput.addEventListener("blur", ()=>{
        const email = emailInput.value.trim();
        if (email && !emailPattern.test(email)) showError(emailInput, "Please enter a valid email address.");
        else if (email) clearError(emailInput);
        toggleSubmitState();
    });
    // Listen to changes on the segment multi-select
    if (segmentsMultipleField) segmentsMultipleField.addEventListener("change", ()=>{
        toggleSubmitState();
    });
    flyout?.querySelector("form")?.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const firstName = flyout.querySelector("#fname")?.value.trim();
        const lastName = flyout.querySelector("#lname")?.value.trim();
        const email = emailInput?.value.trim();
        const password = passwordInput?.value.trim();
        const confirmPassword = confirmPasswordInput?.value.trim();
        const zip = zipInput?.value.trim();
        const occupationSelect = flyout.querySelector("#occupation");
        const segmentsMultiple = flyout.querySelector(".segment-select-multiple");
        const allowMarketing = flyout.querySelector("#optin")?.checked ?? false;
        const occupation = occupationSelect && occupationSelect.selectedIndex !== 0 ? occupationSelect.value : null;
        const segments = segmentsMultiple && segmentsMultiple.selectedOptions.length > 0 ? Array.from(segmentsMultiple.selectedOptions).map((opt)=>opt.value) : [];
        let valid = true;
        requiredFields.forEach((field)=>{
            clearError(field);
        });
        requiredFields.forEach((field)=>{
            const value = field.value.trim();
            if (!value) {
                showError(field, "This field is required.");
                valid = false;
            }
        });
        if (!emailPattern.test(email)) {
            showError(emailInput, "Please enter a valid email address.");
            valid = false;
        }
        if (password !== confirmPassword) {
            showError(confirmPasswordInput, "Passwords do not match.");
            valid = false;
        }
        const zipPattern = /^((\d{5}(-\d{4})?)|[a-z0-9]{3}\s[a-z0-9]{3})$/i;
        if (!zipPattern.test(zip)) {
            showError(zipInput, "Please enter a valid ZIP code.");
            valid = false;
        }
        if (!valid) return;
        submitButton.disabled = true;
        submitButton.textContent = "Creating Account...";
        try {
            const payload = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                password: password,
                confirmPassword: confirmPassword,
                occupation: occupation,
                segments: segments,
                allowMarketing: allowMarketing,
                zip: zip
            };
            const response = await fetch("/api/Accounts/Register", {
                method: "POST",
                credentials: "include",
                headers: await (0, $iouPm.getHeadersWithToken)({
                    "Content-Type": "application/json"
                }),
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                // GTM: Track successful account creation
                (0, $bWUN0.pushEvent)({
                    'event': 'formSubmission',
                    'formID': 'createAccount'
                });
                (0, $8cF6f.showToast)("Account created, check your email for a verification link.", "success");
                (0, $9zaOw.FlyoutManager).close("registerForm");
            } else {
                let errorMessage = "Registration failed.";
                try {
                    const result = await response.json();
                    if (result?.message) errorMessage = result.message;
                    if (result?.errors) {
                        requiredFields.forEach((field)=>clearError(field));
                        if (generalErrorDiv) generalErrorDiv.textContent = "";
                        for (const [key, messages] of Object.entries(result.errors)){
                            if (key === "*") // General errors - show in alert div
                            {
                                if (generalErrorDiv) generalErrorDiv.textContent = messages.join(" ");
                            } else if (key.toLowerCase() === "password") showError(passwordInput, messages.join(" "));
                            else if (key.toLowerCase() === "email") showError(emailInput, messages.join(" "));
                            else if (key.toLowerCase() === "zip") showError(zipInput, messages.join(" "));
                            else {
                                const field = flyout.querySelector(`#${key.toLowerCase()}`);
                                if (field) showError(field, messages.join(" "));
                                else console.warn(`Unhandled validation error for "${key}":`, messages);
                            }
                        }
                        return;
                    }
                } catch (jsonErr) {
                    const text = await response.text();
                    console.warn("Unexpected error response (non-JSON):", text);
                }
                (0, $8cF6f.showToast)(errorMessage, "error");
            }
        } catch (err) {
            console.error("Registration error:", err);
            (0, $8cF6f.showToast)("An unexpected error occurred. Please try again.", "error");
        } finally{
            submitButton.disabled = false;
            submitButton.textContent = "Create Account";
        }
    });
}


var $2829b823e93e4c92$exports = {};
'use strict';
$2829b823e93e4c92$exports.__esModule = true;
// istanbul ignore next
function $2829b823e93e4c92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $e98455ab6f4a98ef$exports = {};
'use strict';
$e98455ab6f4a98ef$exports.__esModule = true;
// istanbul ignore next
function $e98455ab6f4a98ef$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
// istanbul ignore next
function $e98455ab6f4a98ef$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}
var $89c07e0277708a16$exports = {};

$parcel$export($89c07e0277708a16$exports, "__esModule", () => $89c07e0277708a16$export$1e511d4a378977f5, (v) => $89c07e0277708a16$export$1e511d4a378977f5 = v);
$parcel$export($89c07e0277708a16$exports, "HandlebarsEnvironment", () => $89c07e0277708a16$export$5d1b9d3ad24c13f9, (v) => $89c07e0277708a16$export$5d1b9d3ad24c13f9 = v);
$parcel$export($89c07e0277708a16$exports, "VERSION", () => $89c07e0277708a16$export$a4ad2735b021c132, (v) => $89c07e0277708a16$export$a4ad2735b021c132 = v);
$parcel$export($89c07e0277708a16$exports, "COMPILER_REVISION", () => $89c07e0277708a16$export$682db5a6f2fa1046, (v) => $89c07e0277708a16$export$682db5a6f2fa1046 = v);
$parcel$export($89c07e0277708a16$exports, "LAST_COMPATIBLE_COMPILER_REVISION", () => $89c07e0277708a16$export$b416520f9fd5c520, (v) => $89c07e0277708a16$export$b416520f9fd5c520 = v);
$parcel$export($89c07e0277708a16$exports, "REVISION_CHANGES", () => $89c07e0277708a16$export$534648964353ca81, (v) => $89c07e0277708a16$export$534648964353ca81 = v);
$parcel$export($89c07e0277708a16$exports, "log", () => $89c07e0277708a16$export$bef1f36f5486a6a3, (v) => $89c07e0277708a16$export$bef1f36f5486a6a3 = v);
$parcel$export($89c07e0277708a16$exports, "createFrame", () => $89c07e0277708a16$export$52b3fe9f41f5650c, (v) => $89c07e0277708a16$export$52b3fe9f41f5650c = v);
$parcel$export($89c07e0277708a16$exports, "logger", () => $89c07e0277708a16$export$af88d00dbe7f521, (v) => $89c07e0277708a16$export$af88d00dbe7f521 = v);
var $89c07e0277708a16$export$1e511d4a378977f5;
var $89c07e0277708a16$export$5d1b9d3ad24c13f9;
var $89c07e0277708a16$export$a4ad2735b021c132;
var $89c07e0277708a16$export$682db5a6f2fa1046;
var $89c07e0277708a16$export$b416520f9fd5c520;
var $89c07e0277708a16$export$534648964353ca81;
var $89c07e0277708a16$export$bef1f36f5486a6a3;
var $89c07e0277708a16$export$52b3fe9f41f5650c;
var $89c07e0277708a16$export$af88d00dbe7f521;
'use strict';
$89c07e0277708a16$export$1e511d4a378977f5 = true;
$89c07e0277708a16$export$5d1b9d3ad24c13f9 = $89c07e0277708a16$var$HandlebarsEnvironment;
// istanbul ignore next
function $89c07e0277708a16$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $9acd23bffb9df834$exports = {};

$parcel$export($9acd23bffb9df834$exports, "__esModule", () => $9acd23bffb9df834$export$1e511d4a378977f5, (v) => $9acd23bffb9df834$export$1e511d4a378977f5 = v);
$parcel$export($9acd23bffb9df834$exports, "extend", () => $9acd23bffb9df834$export$8b58be045bf06082, (v) => $9acd23bffb9df834$export$8b58be045bf06082 = v);
$parcel$export($9acd23bffb9df834$exports, "indexOf", () => $9acd23bffb9df834$export$305f7d4e9d4624f2, (v) => $9acd23bffb9df834$export$305f7d4e9d4624f2 = v);
$parcel$export($9acd23bffb9df834$exports, "escapeExpression", () => $9acd23bffb9df834$export$e6d4483b22f6b058, (v) => $9acd23bffb9df834$export$e6d4483b22f6b058 = v);
$parcel$export($9acd23bffb9df834$exports, "isEmpty", () => $9acd23bffb9df834$export$dd1bc94b04021eeb, (v) => $9acd23bffb9df834$export$dd1bc94b04021eeb = v);
$parcel$export($9acd23bffb9df834$exports, "createFrame", () => $9acd23bffb9df834$export$52b3fe9f41f5650c, (v) => $9acd23bffb9df834$export$52b3fe9f41f5650c = v);
$parcel$export($9acd23bffb9df834$exports, "blockParams", () => $9acd23bffb9df834$export$b0cad7e592dd4356, (v) => $9acd23bffb9df834$export$b0cad7e592dd4356 = v);
$parcel$export($9acd23bffb9df834$exports, "appendContextPath", () => $9acd23bffb9df834$export$e0253507f826725a, (v) => $9acd23bffb9df834$export$e0253507f826725a = v);
$parcel$export($9acd23bffb9df834$exports, "toString", () => $9acd23bffb9df834$export$f84e8e69fd4488a5, (v) => $9acd23bffb9df834$export$f84e8e69fd4488a5 = v);
$parcel$export($9acd23bffb9df834$exports, "isFunction", () => $9acd23bffb9df834$export$f6e2535fb5126e54, (v) => $9acd23bffb9df834$export$f6e2535fb5126e54 = v);
$parcel$export($9acd23bffb9df834$exports, "isArray", () => $9acd23bffb9df834$export$43bee75e5e14138e, (v) => $9acd23bffb9df834$export$43bee75e5e14138e = v);
var $9acd23bffb9df834$export$1e511d4a378977f5;
var $9acd23bffb9df834$export$8b58be045bf06082;
var $9acd23bffb9df834$export$305f7d4e9d4624f2;
var $9acd23bffb9df834$export$e6d4483b22f6b058;
var $9acd23bffb9df834$export$dd1bc94b04021eeb;
var $9acd23bffb9df834$export$52b3fe9f41f5650c;
var $9acd23bffb9df834$export$b0cad7e592dd4356;
var $9acd23bffb9df834$export$e0253507f826725a;
var $9acd23bffb9df834$export$f84e8e69fd4488a5;
var $9acd23bffb9df834$export$f6e2535fb5126e54;
var $9acd23bffb9df834$export$43bee75e5e14138e;
'use strict';
$9acd23bffb9df834$export$1e511d4a378977f5 = true;
$9acd23bffb9df834$export$8b58be045bf06082 = $9acd23bffb9df834$var$extend;
$9acd23bffb9df834$export$305f7d4e9d4624f2 = $9acd23bffb9df834$var$indexOf;
$9acd23bffb9df834$export$e6d4483b22f6b058 = $9acd23bffb9df834$var$escapeExpression;
$9acd23bffb9df834$export$dd1bc94b04021eeb = $9acd23bffb9df834$var$isEmpty;
$9acd23bffb9df834$export$52b3fe9f41f5650c = $9acd23bffb9df834$var$createFrame;
$9acd23bffb9df834$export$b0cad7e592dd4356 = $9acd23bffb9df834$var$blockParams;
$9acd23bffb9df834$export$e0253507f826725a = $9acd23bffb9df834$var$appendContextPath;
var $9acd23bffb9df834$var$escape = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;',
    '=': '&#x3D;'
};
var $9acd23bffb9df834$var$badChars = /[&<>"'`=]/g, $9acd23bffb9df834$var$possible = /[&<>"'`=]/;
function $9acd23bffb9df834$var$escapeChar(chr) {
    return $9acd23bffb9df834$var$escape[chr];
}
function $9acd23bffb9df834$var$extend(obj /* , ...source */ ) {
    for(var i = 1; i < arguments.length; i++){
        for(var key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) obj[key] = arguments[i][key];
    }
    return obj;
}
var $9acd23bffb9df834$var$toString = Object.prototype.toString;
$9acd23bffb9df834$export$f84e8e69fd4488a5 = $9acd23bffb9df834$var$toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */ var $9acd23bffb9df834$var$isFunction = function isFunction(value) {
    return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */ if ($9acd23bffb9df834$var$isFunction(/x/)) $9acd23bffb9df834$export$f6e2535fb5126e54 = $9acd23bffb9df834$var$isFunction = function(value) {
    return typeof value === 'function' && $9acd23bffb9df834$var$toString.call(value) === '[object Function]';
};
$9acd23bffb9df834$export$f6e2535fb5126e54 = $9acd23bffb9df834$var$isFunction;
/* eslint-enable func-style */ /* istanbul ignore next */ var $9acd23bffb9df834$var$isArray = Array.isArray || function(value) {
    return value && typeof value === 'object' ? $9acd23bffb9df834$var$toString.call(value) === '[object Array]' : false;
};
$9acd23bffb9df834$export$43bee75e5e14138e = $9acd23bffb9df834$var$isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.
function $9acd23bffb9df834$var$indexOf(array, value) {
    for(var i = 0, len = array.length; i < len; i++){
        if (array[i] === value) return i;
    }
    return -1;
}
function $9acd23bffb9df834$var$escapeExpression(string) {
    if (typeof string !== 'string') {
        // don't escape SafeStrings, since they're already safe
        if (string && string.toHTML) return string.toHTML();
        else if (string == null) return '';
        else if (!string) return string + '';
        // Force a string conversion as this will be done by the append regardless and
        // the regex test will do this transparently behind the scenes, causing issues if
        // an object's to string has escaped characters in it.
        string = '' + string;
    }
    if (!$9acd23bffb9df834$var$possible.test(string)) return string;
    return string.replace($9acd23bffb9df834$var$badChars, $9acd23bffb9df834$var$escapeChar);
}
function $9acd23bffb9df834$var$isEmpty(value) {
    if (!value && value !== 0) return true;
    else if ($9acd23bffb9df834$var$isArray(value) && value.length === 0) return true;
    else return false;
}
function $9acd23bffb9df834$var$createFrame(object) {
    var frame = $9acd23bffb9df834$var$extend({}, object);
    frame._parent = object;
    return frame;
}
function $9acd23bffb9df834$var$blockParams(params, ids) {
    params.path = ids;
    return params;
}
function $9acd23bffb9df834$var$appendContextPath(contextPath, id) {
    return (contextPath ? contextPath + '.' : '') + id;
}


var $f9e5592ce830a697$exports = {};
'use strict';
$f9e5592ce830a697$exports.__esModule = true;
var $f9e5592ce830a697$var$errorProps = [
    'description',
    'fileName',
    'lineNumber',
    'endLineNumber',
    'message',
    'name',
    'number',
    'stack'
];
function $f9e5592ce830a697$var$Exception(message, node) {
    var loc = node && node.loc, line = undefined, endLineNumber = undefined, column = undefined, endColumn = undefined;
    if (loc) {
        line = loc.start.line;
        endLineNumber = loc.end.line;
        column = loc.start.column;
        endColumn = loc.end.column;
        message += ' - ' + line + ':' + column;
    }
    var tmp = Error.prototype.constructor.call(this, message);
    // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
    for(var idx = 0; idx < $f9e5592ce830a697$var$errorProps.length; idx++)this[$f9e5592ce830a697$var$errorProps[idx]] = tmp[$f9e5592ce830a697$var$errorProps[idx]];
    /* istanbul ignore else */ if (Error.captureStackTrace) Error.captureStackTrace(this, $f9e5592ce830a697$var$Exception);
    try {
        if (loc) {
            this.lineNumber = line;
            this.endLineNumber = endLineNumber;
            // Work around issue under safari where we can't directly set the column value
            /* istanbul ignore next */ if (Object.defineProperty) {
                Object.defineProperty(this, 'column', {
                    value: column,
                    enumerable: true
                });
                Object.defineProperty(this, 'endColumn', {
                    value: endColumn,
                    enumerable: true
                });
            } else {
                this.column = column;
                this.endColumn = endColumn;
            }
        }
    } catch (nop) {
    /* Ignore if the browser is very particular */ }
}
$f9e5592ce830a697$var$Exception.prototype = new Error();
$f9e5592ce830a697$exports['default'] = $f9e5592ce830a697$var$Exception;
$f9e5592ce830a697$exports = $f9e5592ce830a697$exports['default'];


var $89c07e0277708a16$var$_exception2 = $89c07e0277708a16$var$_interopRequireDefault($f9e5592ce830a697$exports);
var $187b390bf25e9532$export$1e511d4a378977f5;
var $187b390bf25e9532$export$bdf7582f74746f6b;
var $187b390bf25e9532$export$a8e22c3e8a03ea7e;
'use strict';
$187b390bf25e9532$export$1e511d4a378977f5 = true;
$187b390bf25e9532$export$bdf7582f74746f6b = $187b390bf25e9532$var$registerDefaultHelpers;
$187b390bf25e9532$export$a8e22c3e8a03ea7e = $187b390bf25e9532$var$moveHelperToHooks;
// istanbul ignore next
function $187b390bf25e9532$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $2623d11d20b59fa5$exports = {};
'use strict';
$2623d11d20b59fa5$exports.__esModule = true;

$2623d11d20b59fa5$exports['default'] = function(instance) {
    instance.registerHelper('blockHelperMissing', function(context, options) {
        var inverse = options.inverse, fn = options.fn;
        if (context === true) return fn(this);
        else if (context === false || context == null) return inverse(this);
        else if ($9acd23bffb9df834$export$43bee75e5e14138e(context)) {
            if (context.length > 0) {
                if (options.ids) options.ids = [
                    options.name
                ];
                return instance.helpers.each(context, options);
            } else return inverse(this);
        } else {
            if (options.data && options.ids) {
                var data = $9acd23bffb9df834$export$52b3fe9f41f5650c(options.data);
                data.contextPath = $9acd23bffb9df834$export$e0253507f826725a(options.data.contextPath, options.name);
                options = {
                    data: data
                };
            }
            return fn(context, options);
        }
    });
};
$2623d11d20b59fa5$exports = $2623d11d20b59fa5$exports['default'];


var $187b390bf25e9532$var$_helpersBlockHelperMissing2 = $187b390bf25e9532$var$_interopRequireDefault($2623d11d20b59fa5$exports);
var $d571cc4e77af8c66$exports = {};
'use strict';
$d571cc4e77af8c66$exports.__esModule = true;
// istanbul ignore next
function $d571cc4e77af8c66$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}


var $d571cc4e77af8c66$var$_exception2 = $d571cc4e77af8c66$var$_interopRequireDefault($f9e5592ce830a697$exports);
$d571cc4e77af8c66$exports['default'] = function(instance) {
    instance.registerHelper('each', function(context, options) {
        if (!options) throw new $d571cc4e77af8c66$var$_exception2['default']('Must pass iterator to #each');
        var fn = options.fn, inverse = options.inverse, i = 0, ret = '', data = undefined, contextPath = undefined;
        if (options.data && options.ids) contextPath = $9acd23bffb9df834$export$e0253507f826725a(options.data.contextPath, options.ids[0]) + '.';
        if ($9acd23bffb9df834$export$f6e2535fb5126e54(context)) context = context.call(this);
        if (options.data) data = $9acd23bffb9df834$export$52b3fe9f41f5650c(options.data);
        function execIteration(field, index, last) {
            if (data) {
                data.key = field;
                data.index = index;
                data.first = index === 0;
                data.last = !!last;
                if (contextPath) data.contextPath = contextPath + field;
            }
            ret = ret + fn(context[field], {
                data: data,
                blockParams: $9acd23bffb9df834$export$b0cad7e592dd4356([
                    context[field],
                    field
                ], [
                    contextPath + field,
                    null
                ])
            });
        }
        if (context && typeof context === 'object') {
            if ($9acd23bffb9df834$export$43bee75e5e14138e(context)) {
                for(var j = context.length; i < j; i++)if (i in context) execIteration(i, i, i === context.length - 1);
            } else if (typeof Symbol === 'function' && context[Symbol.iterator]) {
                var newContext = [];
                var iterator = context[Symbol.iterator]();
                for(var it = iterator.next(); !it.done; it = iterator.next())newContext.push(it.value);
                context = newContext;
                for(var j = context.length; i < j; i++)execIteration(i, i, i === context.length - 1);
            } else (function() {
                var priorKey = undefined;
                Object.keys(context).forEach(function(key) {
                    // We're running the iterations one step out of sync so we can detect
                    // the last iteration without have to scan the object twice and create
                    // an itermediate keys array.
                    if (priorKey !== undefined) execIteration(priorKey, i - 1);
                    priorKey = key;
                    i++;
                });
                if (priorKey !== undefined) execIteration(priorKey, i - 1, true);
            })();
        }
        if (i === 0) ret = inverse(this);
        return ret;
    });
};
$d571cc4e77af8c66$exports = $d571cc4e77af8c66$exports['default'];


var $187b390bf25e9532$var$_helpersEach2 = $187b390bf25e9532$var$_interopRequireDefault($d571cc4e77af8c66$exports);
var $af61dd291f4eeef0$exports = {};
'use strict';
$af61dd291f4eeef0$exports.__esModule = true;
// istanbul ignore next
function $af61dd291f4eeef0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $af61dd291f4eeef0$var$_exception2 = $af61dd291f4eeef0$var$_interopRequireDefault($f9e5592ce830a697$exports);
$af61dd291f4eeef0$exports['default'] = function(instance) {
    instance.registerHelper('helperMissing', function() /* [args, ]options */ {
        if (arguments.length === 1) // A missing field in a {{foo}} construct.
        return undefined;
        else // Someone is actually trying to call something, blow up.
        throw new $af61dd291f4eeef0$var$_exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    });
};
$af61dd291f4eeef0$exports = $af61dd291f4eeef0$exports['default'];


var $187b390bf25e9532$var$_helpersHelperMissing2 = $187b390bf25e9532$var$_interopRequireDefault($af61dd291f4eeef0$exports);
var $f6af73a8259fe1bf$exports = {};
'use strict';
$f6af73a8259fe1bf$exports.__esModule = true;
// istanbul ignore next
function $f6af73a8259fe1bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}


var $f6af73a8259fe1bf$var$_exception2 = $f6af73a8259fe1bf$var$_interopRequireDefault($f9e5592ce830a697$exports);
$f6af73a8259fe1bf$exports['default'] = function(instance) {
    instance.registerHelper('if', function(conditional, options) {
        if (arguments.length != 2) throw new $f6af73a8259fe1bf$var$_exception2['default']('#if requires exactly one argument');
        if ($9acd23bffb9df834$export$f6e2535fb5126e54(conditional)) conditional = conditional.call(this);
        // Default behavior is to render the positive path if the value is truthy and not empty.
        // The `includeZero` option may be set to treat the condtional as purely not empty based on the
        // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
        if (!options.hash.includeZero && !conditional || $9acd23bffb9df834$export$dd1bc94b04021eeb(conditional)) return options.inverse(this);
        else return options.fn(this);
    });
    instance.registerHelper('unless', function(conditional, options) {
        if (arguments.length != 2) throw new $f6af73a8259fe1bf$var$_exception2['default']('#unless requires exactly one argument');
        return instance.helpers['if'].call(this, conditional, {
            fn: options.inverse,
            inverse: options.fn,
            hash: options.hash
        });
    });
};
$f6af73a8259fe1bf$exports = $f6af73a8259fe1bf$exports['default'];


var $187b390bf25e9532$var$_helpersIf2 = $187b390bf25e9532$var$_interopRequireDefault($f6af73a8259fe1bf$exports);
var $92663e4f22e03a6a$exports = {};
'use strict';
$92663e4f22e03a6a$exports.__esModule = true;
$92663e4f22e03a6a$exports['default'] = function(instance) {
    instance.registerHelper('log', function() /* message, options */ {
        var args = [
            undefined
        ], options = arguments[arguments.length - 1];
        for(var i = 0; i < arguments.length - 1; i++)args.push(arguments[i]);
        var level = 1;
        if (options.hash.level != null) level = options.hash.level;
        else if (options.data && options.data.level != null) level = options.data.level;
        args[0] = level;
        instance.log.apply(instance, args);
    });
};
$92663e4f22e03a6a$exports = $92663e4f22e03a6a$exports['default'];


var $187b390bf25e9532$var$_helpersLog2 = $187b390bf25e9532$var$_interopRequireDefault($92663e4f22e03a6a$exports);
var $3f16ee799a8700df$exports = {};
'use strict';
$3f16ee799a8700df$exports.__esModule = true;
$3f16ee799a8700df$exports['default'] = function(instance) {
    instance.registerHelper('lookup', function(obj, field, options) {
        if (!obj) // Note for 5.0: Change to "obj == null" in 5.0
        return obj;
        return options.lookupProperty(obj, field);
    });
};
$3f16ee799a8700df$exports = $3f16ee799a8700df$exports['default'];


var $187b390bf25e9532$var$_helpersLookup2 = $187b390bf25e9532$var$_interopRequireDefault($3f16ee799a8700df$exports);
var $c225762525286651$exports = {};
'use strict';
$c225762525286651$exports.__esModule = true;
// istanbul ignore next
function $c225762525286651$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}


var $c225762525286651$var$_exception2 = $c225762525286651$var$_interopRequireDefault($f9e5592ce830a697$exports);
$c225762525286651$exports['default'] = function(instance) {
    instance.registerHelper('with', function(context, options) {
        if (arguments.length != 2) throw new $c225762525286651$var$_exception2['default']('#with requires exactly one argument');
        if ($9acd23bffb9df834$export$f6e2535fb5126e54(context)) context = context.call(this);
        var fn = options.fn;
        if (!$9acd23bffb9df834$export$dd1bc94b04021eeb(context)) {
            var data = options.data;
            if (options.data && options.ids) {
                data = $9acd23bffb9df834$export$52b3fe9f41f5650c(options.data);
                data.contextPath = $9acd23bffb9df834$export$e0253507f826725a(options.data.contextPath, options.ids[0]);
            }
            return fn(context, {
                data: data,
                blockParams: $9acd23bffb9df834$export$b0cad7e592dd4356([
                    context
                ], [
                    data && data.contextPath
                ])
            });
        } else return options.inverse(this);
    });
};
$c225762525286651$exports = $c225762525286651$exports['default'];


var $187b390bf25e9532$var$_helpersWith2 = $187b390bf25e9532$var$_interopRequireDefault($c225762525286651$exports);
function $187b390bf25e9532$var$registerDefaultHelpers(instance) {
    $187b390bf25e9532$var$_helpersBlockHelperMissing2['default'](instance);
    $187b390bf25e9532$var$_helpersEach2['default'](instance);
    $187b390bf25e9532$var$_helpersHelperMissing2['default'](instance);
    $187b390bf25e9532$var$_helpersIf2['default'](instance);
    $187b390bf25e9532$var$_helpersLog2['default'](instance);
    $187b390bf25e9532$var$_helpersLookup2['default'](instance);
    $187b390bf25e9532$var$_helpersWith2['default'](instance);
}
function $187b390bf25e9532$var$moveHelperToHooks(instance, helperName, keepHelper) {
    if (instance.helpers[helperName]) {
        instance.hooks[helperName] = instance.helpers[helperName];
        if (!keepHelper) delete instance.helpers[helperName];
    }
}


var $de5f4f3a8eeb59a8$export$1e511d4a378977f5;
var $de5f4f3a8eeb59a8$export$7eaca4a3d56dbe6d;
'use strict';
$de5f4f3a8eeb59a8$export$1e511d4a378977f5 = true;
$de5f4f3a8eeb59a8$export$7eaca4a3d56dbe6d = $de5f4f3a8eeb59a8$var$registerDefaultDecorators;
// istanbul ignore next
function $de5f4f3a8eeb59a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $5daf201a2a09c67a$exports = {};
'use strict';
$5daf201a2a09c67a$exports.__esModule = true;

$5daf201a2a09c67a$exports['default'] = function(instance) {
    instance.registerDecorator('inline', function(fn, props, container, options) {
        var ret = fn;
        if (!props.partials) {
            props.partials = {};
            ret = function(context, options) {
                // Create a new partials stack frame prior to exec.
                var original = container.partials;
                container.partials = $9acd23bffb9df834$export$8b58be045bf06082({}, original, props.partials);
                var ret = fn(context, options);
                container.partials = original;
                return ret;
            };
        }
        props.partials[options.args[0]] = options.fn;
        return ret;
    });
};
$5daf201a2a09c67a$exports = $5daf201a2a09c67a$exports['default'];


var $de5f4f3a8eeb59a8$var$_decoratorsInline2 = $de5f4f3a8eeb59a8$var$_interopRequireDefault($5daf201a2a09c67a$exports);
function $de5f4f3a8eeb59a8$var$registerDefaultDecorators(instance) {
    $de5f4f3a8eeb59a8$var$_decoratorsInline2['default'](instance);
}


var $0c4dbfdbda3846d3$exports = {};
'use strict';
$0c4dbfdbda3846d3$exports.__esModule = true;

var $0c4dbfdbda3846d3$var$logger = {
    methodMap: [
        'debug',
        'info',
        'warn',
        'error'
    ],
    level: 'info',
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function lookupLevel(level) {
        if (typeof level === 'string') {
            var levelMap = $9acd23bffb9df834$export$305f7d4e9d4624f2($0c4dbfdbda3846d3$var$logger.methodMap, level.toLowerCase());
            if (levelMap >= 0) level = levelMap;
            else level = parseInt(level, 10);
        }
        return level;
    },
    // Can be overridden in the host environment
    log: function log(level) {
        level = $0c4dbfdbda3846d3$var$logger.lookupLevel(level);
        if (typeof console !== 'undefined' && $0c4dbfdbda3846d3$var$logger.lookupLevel($0c4dbfdbda3846d3$var$logger.level) <= level) {
            var method = $0c4dbfdbda3846d3$var$logger.methodMap[level];
            // eslint-disable-next-line no-console
            if (!console[method]) method = 'log';
            for(var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)message[_key - 1] = arguments[_key];
            console[method].apply(console, message); // eslint-disable-line no-console
        }
    }
};
$0c4dbfdbda3846d3$exports['default'] = $0c4dbfdbda3846d3$var$logger;
$0c4dbfdbda3846d3$exports = $0c4dbfdbda3846d3$exports['default'];


var $89c07e0277708a16$var$_logger2 = $89c07e0277708a16$var$_interopRequireDefault($0c4dbfdbda3846d3$exports);
var $9f100c5c1c6309ca$export$1e511d4a378977f5;
var $9f100c5c1c6309ca$export$9fc505f5102b04a5;
var $9f100c5c1c6309ca$export$8b633651c7cf59b9;
var $9f100c5c1c6309ca$export$419dc2c4b2f2238b;
'use strict';
$9f100c5c1c6309ca$export$1e511d4a378977f5 = true;
$9f100c5c1c6309ca$export$9fc505f5102b04a5 = $9f100c5c1c6309ca$var$createProtoAccessControl;
$9f100c5c1c6309ca$export$8b633651c7cf59b9 = $9f100c5c1c6309ca$var$resultIsAllowed;
$9f100c5c1c6309ca$export$419dc2c4b2f2238b = $9f100c5c1c6309ca$var$resetLoggedProperties;
// istanbul ignore next
function $9f100c5c1c6309ca$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $b93b244ee886c302$export$1e511d4a378977f5;
var $b93b244ee886c302$export$ec2932ee0c0e8dcc;
'use strict';
$b93b244ee886c302$export$1e511d4a378977f5 = true;
$b93b244ee886c302$export$ec2932ee0c0e8dcc = $b93b244ee886c302$var$createNewLookupObject;

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */ function $b93b244ee886c302$var$createNewLookupObject() {
    for(var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    return $9acd23bffb9df834$export$8b58be045bf06082.apply(undefined, [
        Object.create(null)
    ].concat(sources));
}



var $9f100c5c1c6309ca$var$_logger2 = $9f100c5c1c6309ca$var$_interopRequireDefault($0c4dbfdbda3846d3$exports);
var $9f100c5c1c6309ca$var$loggedProperties = Object.create(null);
function $9f100c5c1c6309ca$var$createProtoAccessControl(runtimeOptions) {
    var defaultMethodWhiteList = Object.create(null);
    defaultMethodWhiteList['constructor'] = false;
    defaultMethodWhiteList['__defineGetter__'] = false;
    defaultMethodWhiteList['__defineSetter__'] = false;
    defaultMethodWhiteList['__lookupGetter__'] = false;
    var defaultPropertyWhiteList = Object.create(null);
    // eslint-disable-next-line no-proto
    defaultPropertyWhiteList['__proto__'] = false;
    return {
        properties: {
            whitelist: $b93b244ee886c302$export$ec2932ee0c0e8dcc(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
            defaultValue: runtimeOptions.allowProtoPropertiesByDefault
        },
        methods: {
            whitelist: $b93b244ee886c302$export$ec2932ee0c0e8dcc(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
            defaultValue: runtimeOptions.allowProtoMethodsByDefault
        }
    };
}
function $9f100c5c1c6309ca$var$resultIsAllowed(result, protoAccessControl, propertyName) {
    if (typeof result === 'function') return $9f100c5c1c6309ca$var$checkWhiteList(protoAccessControl.methods, propertyName);
    else return $9f100c5c1c6309ca$var$checkWhiteList(protoAccessControl.properties, propertyName);
}
function $9f100c5c1c6309ca$var$checkWhiteList(protoAccessControlForType, propertyName) {
    if (protoAccessControlForType.whitelist[propertyName] !== undefined) return protoAccessControlForType.whitelist[propertyName] === true;
    if (protoAccessControlForType.defaultValue !== undefined) return protoAccessControlForType.defaultValue;
    $9f100c5c1c6309ca$var$logUnexpecedPropertyAccessOnce(propertyName);
    return false;
}
function $9f100c5c1c6309ca$var$logUnexpecedPropertyAccessOnce(propertyName) {
    if ($9f100c5c1c6309ca$var$loggedProperties[propertyName] !== true) {
        $9f100c5c1c6309ca$var$loggedProperties[propertyName] = true;
        $9f100c5c1c6309ca$var$_logger2['default'].log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
    }
}
function $9f100c5c1c6309ca$var$resetLoggedProperties() {
    Object.keys($9f100c5c1c6309ca$var$loggedProperties).forEach(function(propertyName) {
        delete $9f100c5c1c6309ca$var$loggedProperties[propertyName];
    });
}


var $89c07e0277708a16$var$VERSION = '4.7.8';
$89c07e0277708a16$export$a4ad2735b021c132 = $89c07e0277708a16$var$VERSION;
var $89c07e0277708a16$var$COMPILER_REVISION = 8;
$89c07e0277708a16$export$682db5a6f2fa1046 = $89c07e0277708a16$var$COMPILER_REVISION;
var $89c07e0277708a16$var$LAST_COMPATIBLE_COMPILER_REVISION = 7;
$89c07e0277708a16$export$b416520f9fd5c520 = $89c07e0277708a16$var$LAST_COMPATIBLE_COMPILER_REVISION;
var $89c07e0277708a16$var$REVISION_CHANGES = {
    1: '<= 1.0.rc.2',
    2: '== 1.0.0-rc.3',
    3: '== 1.0.0-rc.4',
    4: '== 1.x.x',
    5: '== 2.0.0-alpha.x',
    6: '>= 2.0.0-beta.1',
    7: '>= 4.0.0 <4.3.0',
    8: '>= 4.3.0'
};
$89c07e0277708a16$export$534648964353ca81 = $89c07e0277708a16$var$REVISION_CHANGES;
var $89c07e0277708a16$var$objectType = '[object Object]';
function $89c07e0277708a16$var$HandlebarsEnvironment(helpers, partials, decorators) {
    this.helpers = helpers || {};
    this.partials = partials || {};
    this.decorators = decorators || {};
    $187b390bf25e9532$export$bdf7582f74746f6b(this);
    $de5f4f3a8eeb59a8$export$7eaca4a3d56dbe6d(this);
}
$89c07e0277708a16$var$HandlebarsEnvironment.prototype = {
    constructor: $89c07e0277708a16$var$HandlebarsEnvironment,
    logger: $89c07e0277708a16$var$_logger2['default'],
    log: $89c07e0277708a16$var$_logger2['default'].log,
    registerHelper: function registerHelper(name, fn) {
        if ($9acd23bffb9df834$export$f84e8e69fd4488a5.call(name) === $89c07e0277708a16$var$objectType) {
            if (fn) throw new $89c07e0277708a16$var$_exception2['default']('Arg not supported with multiple helpers');
            $9acd23bffb9df834$export$8b58be045bf06082(this.helpers, name);
        } else this.helpers[name] = fn;
    },
    unregisterHelper: function unregisterHelper(name) {
        delete this.helpers[name];
    },
    registerPartial: function registerPartial(name, partial) {
        if ($9acd23bffb9df834$export$f84e8e69fd4488a5.call(name) === $89c07e0277708a16$var$objectType) $9acd23bffb9df834$export$8b58be045bf06082(this.partials, name);
        else {
            if (typeof partial === 'undefined') throw new $89c07e0277708a16$var$_exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
            this.partials[name] = partial;
        }
    },
    unregisterPartial: function unregisterPartial(name) {
        delete this.partials[name];
    },
    registerDecorator: function registerDecorator(name, fn) {
        if ($9acd23bffb9df834$export$f84e8e69fd4488a5.call(name) === $89c07e0277708a16$var$objectType) {
            if (fn) throw new $89c07e0277708a16$var$_exception2['default']('Arg not supported with multiple decorators');
            $9acd23bffb9df834$export$8b58be045bf06082(this.decorators, name);
        } else this.decorators[name] = fn;
    },
    unregisterDecorator: function unregisterDecorator(name) {
        delete this.decorators[name];
    },
    /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */ resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
        $9f100c5c1c6309ca$export$419dc2c4b2f2238b();
    }
};
var $89c07e0277708a16$var$log = $89c07e0277708a16$var$_logger2['default'].log;
$89c07e0277708a16$export$bef1f36f5486a6a3 = $89c07e0277708a16$var$log;
$89c07e0277708a16$export$52b3fe9f41f5650c = $9acd23bffb9df834$export$52b3fe9f41f5650c;
$89c07e0277708a16$export$af88d00dbe7f521 = $89c07e0277708a16$var$_logger2['default'];


var $e98455ab6f4a98ef$var$base = $e98455ab6f4a98ef$var$_interopRequireWildcard($89c07e0277708a16$exports);
var $dde468e5e7708f10$exports = {};
// Build out our basic SafeString type
'use strict';
$dde468e5e7708f10$exports.__esModule = true;
function $dde468e5e7708f10$var$SafeString(string) {
    this.string = string;
}
$dde468e5e7708f10$var$SafeString.prototype.toString = $dde468e5e7708f10$var$SafeString.prototype.toHTML = function() {
    return '' + this.string;
};
$dde468e5e7708f10$exports['default'] = $dde468e5e7708f10$var$SafeString;
$dde468e5e7708f10$exports = $dde468e5e7708f10$exports['default'];


var $e98455ab6f4a98ef$var$_handlebarsSafeString2 = $e98455ab6f4a98ef$var$_interopRequireDefault($dde468e5e7708f10$exports);

var $e98455ab6f4a98ef$var$_handlebarsException2 = $e98455ab6f4a98ef$var$_interopRequireDefault($f9e5592ce830a697$exports);

var $e98455ab6f4a98ef$var$Utils = $e98455ab6f4a98ef$var$_interopRequireWildcard($9acd23bffb9df834$exports);
var $4d447dd33143c337$exports = {};

$parcel$export($4d447dd33143c337$exports, "__esModule", () => $4d447dd33143c337$export$1e511d4a378977f5, (v) => $4d447dd33143c337$export$1e511d4a378977f5 = v);
$parcel$export($4d447dd33143c337$exports, "checkRevision", () => $4d447dd33143c337$export$1a97de37fc44aecb, (v) => $4d447dd33143c337$export$1a97de37fc44aecb = v);
$parcel$export($4d447dd33143c337$exports, "template", () => $4d447dd33143c337$export$ce69bd05624d0c48, (v) => $4d447dd33143c337$export$ce69bd05624d0c48 = v);
$parcel$export($4d447dd33143c337$exports, "wrapProgram", () => $4d447dd33143c337$export$3976c39aa34be3b, (v) => $4d447dd33143c337$export$3976c39aa34be3b = v);
$parcel$export($4d447dd33143c337$exports, "resolvePartial", () => $4d447dd33143c337$export$ee54384c867bf98e, (v) => $4d447dd33143c337$export$ee54384c867bf98e = v);
$parcel$export($4d447dd33143c337$exports, "invokePartial", () => $4d447dd33143c337$export$6c4303200e44071a, (v) => $4d447dd33143c337$export$6c4303200e44071a = v);
$parcel$export($4d447dd33143c337$exports, "noop", () => $4d447dd33143c337$export$8793edee2d425525, (v) => $4d447dd33143c337$export$8793edee2d425525 = v);
var $4d447dd33143c337$export$1e511d4a378977f5;
var $4d447dd33143c337$export$1a97de37fc44aecb;
var $4d447dd33143c337$export$ce69bd05624d0c48;
var $4d447dd33143c337$export$3976c39aa34be3b;
var $4d447dd33143c337$export$ee54384c867bf98e;
var $4d447dd33143c337$export$6c4303200e44071a;
var $4d447dd33143c337$export$8793edee2d425525;
'use strict';
$4d447dd33143c337$export$1e511d4a378977f5 = true;
$4d447dd33143c337$export$1a97de37fc44aecb = $4d447dd33143c337$var$checkRevision;
$4d447dd33143c337$export$ce69bd05624d0c48 = $4d447dd33143c337$var$template;
$4d447dd33143c337$export$3976c39aa34be3b = $4d447dd33143c337$var$wrapProgram;
$4d447dd33143c337$export$ee54384c867bf98e = $4d447dd33143c337$var$resolvePartial;
$4d447dd33143c337$export$6c4303200e44071a = $4d447dd33143c337$var$invokePartial;
$4d447dd33143c337$export$8793edee2d425525 = $4d447dd33143c337$var$noop;
// istanbul ignore next
function $4d447dd33143c337$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
// istanbul ignore next
function $4d447dd33143c337$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}

var $4d447dd33143c337$var$Utils = $4d447dd33143c337$var$_interopRequireWildcard($9acd23bffb9df834$exports);

var $4d447dd33143c337$var$_exception2 = $4d447dd33143c337$var$_interopRequireDefault($f9e5592ce830a697$exports);


var $dd08cbba23d8c93b$export$1e511d4a378977f5;
var $dd08cbba23d8c93b$export$34b84bc8884ca465;
'use strict';
$dd08cbba23d8c93b$export$1e511d4a378977f5 = true;
$dd08cbba23d8c93b$export$34b84bc8884ca465 = $dd08cbba23d8c93b$var$wrapHelper;
function $dd08cbba23d8c93b$var$wrapHelper(helper, transformOptionsFn) {
    if (typeof helper !== 'function') // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
    var wrapper = function wrapper() /* dynamic arguments */ {
        var options = arguments[arguments.length - 1];
        arguments[arguments.length - 1] = transformOptionsFn(options);
        return helper.apply(this, arguments);
    };
    return wrapper;
}



function $4d447dd33143c337$var$checkRevision(compilerInfo) {
    var compilerRevision = compilerInfo && compilerInfo[0] || 1, currentRevision = $89c07e0277708a16$export$682db5a6f2fa1046;
    if (compilerRevision >= $89c07e0277708a16$export$b416520f9fd5c520 && compilerRevision <= $89c07e0277708a16$export$682db5a6f2fa1046) return;
    if (compilerRevision < $89c07e0277708a16$export$b416520f9fd5c520) {
        var runtimeVersions = $89c07e0277708a16$export$534648964353ca81[currentRevision], compilerVersions = $89c07e0277708a16$export$534648964353ca81[compilerRevision];
        throw new $4d447dd33143c337$var$_exception2['default']("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new $4d447dd33143c337$var$_exception2['default']("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + compilerInfo[1] + ').');
}
function $4d447dd33143c337$var$template(templateSpec, env) {
    /* istanbul ignore next */ if (!env) throw new $4d447dd33143c337$var$_exception2['default']('No environment passed to template');
    if (!templateSpec || !templateSpec.main) throw new $4d447dd33143c337$var$_exception2['default']('Unknown template object: ' + typeof templateSpec);
    templateSpec.main.decorator = templateSpec.main_d;
    // Note: Using env.VM references rather than local var references throughout this section to allow
    // for external users to override these as pseudo-supported APIs.
    env.VM.checkRevision(templateSpec.compiler);
    // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
    var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;
    function invokePartialWrapper(partial, context, options) {
        if (options.hash) {
            context = $4d447dd33143c337$var$Utils.extend({}, context, options.hash);
            if (options.ids) options.ids[0] = true;
        }
        partial = env.VM.resolvePartial.call(this, partial, context, options);
        var extendedOptions = $4d447dd33143c337$var$Utils.extend({}, options, {
            hooks: this.hooks,
            protoAccessControl: this.protoAccessControl
        });
        var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);
        if (result == null && env.compile) {
            options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
            result = options.partials[options.name](context, extendedOptions);
        }
        if (result != null) {
            if (options.indent) {
                var lines = result.split('\n');
                for(var i = 0, l = lines.length; i < l; i++){
                    if (!lines[i] && i + 1 === l) break;
                    lines[i] = options.indent + lines[i];
                }
                result = lines.join('\n');
            }
            return result;
        } else throw new $4d447dd33143c337$var$_exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
    // Just add water
    var container = {
        strict: function strict(obj, name, loc) {
            if (!obj || !(name in obj)) throw new $4d447dd33143c337$var$_exception2['default']('"' + name + '" not defined in ' + obj, {
                loc: loc
            });
            return container.lookupProperty(obj, name);
        },
        lookupProperty: function lookupProperty(parent, propertyName) {
            var result = parent[propertyName];
            if (result == null) return result;
            if (Object.prototype.hasOwnProperty.call(parent, propertyName)) return result;
            if ($9f100c5c1c6309ca$export$8b633651c7cf59b9(result, container.protoAccessControl, propertyName)) return result;
            return undefined;
        },
        lookup: function lookup(depths, name) {
            var len = depths.length;
            for(var i = 0; i < len; i++){
                var result = depths[i] && container.lookupProperty(depths[i], name);
                if (result != null) return depths[i][name];
            }
        },
        lambda: function lambda(current, context) {
            return typeof current === 'function' ? current.call(context) : current;
        },
        escapeExpression: $4d447dd33143c337$var$Utils.escapeExpression,
        invokePartial: invokePartialWrapper,
        fn: function fn(i) {
            var ret = templateSpec[i];
            ret.decorator = templateSpec[i + '_d'];
            return ret;
        },
        programs: [],
        program: function program(i, data, declaredBlockParams, blockParams, depths) {
            var programWrapper = this.programs[i], fn = this.fn(i);
            if (data || depths || blockParams || declaredBlockParams) programWrapper = $4d447dd33143c337$var$wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
            else if (!programWrapper) programWrapper = this.programs[i] = $4d447dd33143c337$var$wrapProgram(this, i, fn);
            return programWrapper;
        },
        data: function data(value, depth) {
            while(value && depth--)value = value._parent;
            return value;
        },
        mergeIfNeeded: function mergeIfNeeded(param, common) {
            var obj = param || common;
            if (param && common && param !== common) obj = $4d447dd33143c337$var$Utils.extend({}, common, param);
            return obj;
        },
        // An empty object to use as replacement for null-contexts
        nullContext: Object.seal({}),
        noop: env.VM.noop,
        compilerInfo: templateSpec.compiler
    };
    function ret(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var data = options.data;
        ret._setup(options);
        if (!options.partial && templateSpec.useData) data = $4d447dd33143c337$var$initData(context, data);
        var depths = undefined, blockParams = templateSpec.useBlockParams ? [] : undefined;
        if (templateSpec.useDepths) {
            if (options.depths) depths = context != options.depths[0] ? [
                context
            ].concat(options.depths) : options.depths;
            else depths = [
                context
            ];
        }
        function main(context /*, options*/ ) {
            return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
        }
        main = $4d447dd33143c337$var$executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
        return main(context, options);
    }
    ret.isTop = true;
    ret._setup = function(options) {
        if (!options.partial) {
            var mergedHelpers = $4d447dd33143c337$var$Utils.extend({}, env.helpers, options.helpers);
            $4d447dd33143c337$var$wrapHelpersToPassLookupProperty(mergedHelpers, container);
            container.helpers = mergedHelpers;
            if (templateSpec.usePartial) // Use mergeIfNeeded here to prevent compiling global partials multiple times
            container.partials = container.mergeIfNeeded(options.partials, env.partials);
            if (templateSpec.usePartial || templateSpec.useDecorators) container.decorators = $4d447dd33143c337$var$Utils.extend({}, env.decorators, options.decorators);
            container.hooks = {};
            container.protoAccessControl = $9f100c5c1c6309ca$export$9fc505f5102b04a5(options);
            var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
            $187b390bf25e9532$export$a8e22c3e8a03ea7e(container, 'helperMissing', keepHelperInHelpers);
            $187b390bf25e9532$export$a8e22c3e8a03ea7e(container, 'blockHelperMissing', keepHelperInHelpers);
        } else {
            container.protoAccessControl = options.protoAccessControl; // internal option
            container.helpers = options.helpers;
            container.partials = options.partials;
            container.decorators = options.decorators;
            container.hooks = options.hooks;
        }
    };
    ret._child = function(i, data, blockParams, depths) {
        if (templateSpec.useBlockParams && !blockParams) throw new $4d447dd33143c337$var$_exception2['default']('must pass block params');
        if (templateSpec.useDepths && !depths) throw new $4d447dd33143c337$var$_exception2['default']('must pass parent depths');
        return $4d447dd33143c337$var$wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
    };
    return ret;
}
function $4d447dd33143c337$var$wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
    function prog(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        var currentDepths = depths;
        if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) currentDepths = [
            context
        ].concat(depths);
        return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [
            options.blockParams
        ].concat(blockParams), currentDepths);
    }
    prog = $4d447dd33143c337$var$executeDecorators(fn, prog, container, depths, data, blockParams);
    prog.program = i;
    prog.depth = depths ? depths.length : 0;
    prog.blockParams = declaredBlockParams || 0;
    return prog;
}
/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */ function $4d447dd33143c337$var$resolvePartial(partial, context, options) {
    if (!partial) {
        if (options.name === '@partial-block') partial = options.data['partial-block'];
        else partial = options.partials[options.name];
    } else if (!partial.call && !options.name) {
        // This is a dynamic partial that returned a string
        options.name = partial;
        partial = options.partials[partial];
    }
    return partial;
}
function $4d447dd33143c337$var$invokePartial(partial, context, options) {
    // Use the current closure context to save the partial-block if this partial
    var currentPartialBlock = options.data && options.data['partial-block'];
    options.partial = true;
    if (options.ids) options.data.contextPath = options.ids[0] || options.data.contextPath;
    var partialBlock = undefined;
    if (options.fn && options.fn !== $4d447dd33143c337$var$noop) (function() {
        options.data = $89c07e0277708a16$export$52b3fe9f41f5650c(options.data);
        // Wrapper function to get access to currentPartialBlock from the closure
        var fn = options.fn;
        partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
            var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
            // Restore the partial-block from the closure for the execution of the block
            // i.e. the part inside the block of the partial call.
            options.data = $89c07e0277708a16$export$52b3fe9f41f5650c(options.data);
            options.data['partial-block'] = currentPartialBlock;
            return fn(context, options);
        };
        if (fn.partials) options.partials = $4d447dd33143c337$var$Utils.extend({}, options.partials, fn.partials);
    })();
    if (partial === undefined && partialBlock) partial = partialBlock;
    if (partial === undefined) throw new $4d447dd33143c337$var$_exception2['default']('The partial ' + options.name + ' could not be found');
    else if (partial instanceof Function) return partial(context, options);
}
function $4d447dd33143c337$var$noop() {
    return '';
}
function $4d447dd33143c337$var$initData(context, data) {
    if (!data || !('root' in data)) {
        data = data ? $89c07e0277708a16$export$52b3fe9f41f5650c(data) : {};
        data.root = context;
    }
    return data;
}
function $4d447dd33143c337$var$executeDecorators(fn, prog, container, depths, data, blockParams) {
    if (fn.decorator) {
        var props = {};
        prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
        $4d447dd33143c337$var$Utils.extend(prog, props);
    }
    return prog;
}
function $4d447dd33143c337$var$wrapHelpersToPassLookupProperty(mergedHelpers, container) {
    Object.keys(mergedHelpers).forEach(function(helperName) {
        var helper = mergedHelpers[helperName];
        mergedHelpers[helperName] = $4d447dd33143c337$var$passLookupPropertyOption(helper, container);
    });
}
function $4d447dd33143c337$var$passLookupPropertyOption(helper, container) {
    var lookupProperty = container.lookupProperty;
    return $dd08cbba23d8c93b$export$34b84bc8884ca465(helper, function(options) {
        return $4d447dd33143c337$var$Utils.extend({
            lookupProperty: lookupProperty
        }, options);
    });
}


var $e98455ab6f4a98ef$var$runtime = $e98455ab6f4a98ef$var$_interopRequireWildcard($4d447dd33143c337$exports);
var $787e52a2b9acbb7c$exports = {};
/* global globalThis */ 'use strict';
$787e52a2b9acbb7c$exports.__esModule = true;
$787e52a2b9acbb7c$exports['default'] = function(Handlebars) {
    /* istanbul ignore next */ // https://mathiasbynens.be/notes/globalthis
    (function() {
        if (typeof globalThis === 'object') return;
        Object.prototype.__defineGetter__('__magic__', function() {
            return this;
        });
        __magic__.globalThis = __magic__; // eslint-disable-line no-undef
        delete Object.prototype.__magic__;
    })();
    var $Handlebars = globalThis.Handlebars;
    /* istanbul ignore next */ Handlebars.noConflict = function() {
        if (globalThis.Handlebars === Handlebars) globalThis.Handlebars = $Handlebars;
        return Handlebars;
    };
};
$787e52a2b9acbb7c$exports = $787e52a2b9acbb7c$exports['default'];


var $e98455ab6f4a98ef$var$_handlebarsNoConflict2 = $e98455ab6f4a98ef$var$_interopRequireDefault($787e52a2b9acbb7c$exports);
// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function $e98455ab6f4a98ef$var$create() {
    var hb = new $e98455ab6f4a98ef$var$base.HandlebarsEnvironment();
    $e98455ab6f4a98ef$var$Utils.extend(hb, $e98455ab6f4a98ef$var$base);
    hb.SafeString = $e98455ab6f4a98ef$var$_handlebarsSafeString2['default'];
    hb.Exception = $e98455ab6f4a98ef$var$_handlebarsException2['default'];
    hb.Utils = $e98455ab6f4a98ef$var$Utils;
    hb.escapeExpression = $e98455ab6f4a98ef$var$Utils.escapeExpression;
    hb.VM = $e98455ab6f4a98ef$var$runtime;
    hb.template = function(spec) {
        return $e98455ab6f4a98ef$var$runtime.template(spec, hb);
    };
    return hb;
}
var $e98455ab6f4a98ef$var$inst = $e98455ab6f4a98ef$var$create();
$e98455ab6f4a98ef$var$inst.create = $e98455ab6f4a98ef$var$create;
$e98455ab6f4a98ef$var$_handlebarsNoConflict2['default']($e98455ab6f4a98ef$var$inst);
$e98455ab6f4a98ef$var$inst['default'] = $e98455ab6f4a98ef$var$inst;
$e98455ab6f4a98ef$exports['default'] = $e98455ab6f4a98ef$var$inst;
$e98455ab6f4a98ef$exports = $e98455ab6f4a98ef$exports['default'];


var $2829b823e93e4c92$var$_handlebarsRuntime2 = $2829b823e93e4c92$var$_interopRequireDefault($e98455ab6f4a98ef$exports);
var $1b8bcd285ab58e50$exports = {};
'use strict';
$1b8bcd285ab58e50$exports.__esModule = true;
var $1b8bcd285ab58e50$var$AST = {
    // Public API used to evaluate derived attributes regarding AST nodes
    helpers: {
        // a mustache is definitely a helper if:
        // * it is an eligible helper, and
        // * it has at least one parameter or hash segment
        helperExpression: function helperExpression(node) {
            return node.type === 'SubExpression' || (node.type === 'MustacheStatement' || node.type === 'BlockStatement') && !!(node.params && node.params.length || node.hash);
        },
        scopedId: function scopedId(path) {
            return /^\.|this\b/.test(path.original);
        },
        // an ID is simple if it only has one part, and that part is not
        // `..` or `this`.
        simpleId: function simpleId(path) {
            return path.parts.length === 1 && !$1b8bcd285ab58e50$var$AST.helpers.scopedId(path) && !path.depth;
        }
    }
};
// Must be exported as an object rather than the root of the module as the jison lexer
// must modify the object to operate properly.
$1b8bcd285ab58e50$exports['default'] = $1b8bcd285ab58e50$var$AST;
$1b8bcd285ab58e50$exports = $1b8bcd285ab58e50$exports['default'];


var $2829b823e93e4c92$var$_handlebarsCompilerAst2 = $2829b823e93e4c92$var$_interopRequireDefault($1b8bcd285ab58e50$exports);
var $dc49e6b2606b0f90$export$1e511d4a378977f5;
var $dc49e6b2606b0f90$export$fc85b2c4462e0bc6;
var $dc49e6b2606b0f90$export$98e6a39c04603d36;
var $dc49e6b2606b0f90$export$8f49e4af10703ce3;
'use strict';
$dc49e6b2606b0f90$export$1e511d4a378977f5 = true;
$dc49e6b2606b0f90$export$fc85b2c4462e0bc6 = $dc49e6b2606b0f90$var$parseWithoutProcessing;
$dc49e6b2606b0f90$export$98e6a39c04603d36 = $dc49e6b2606b0f90$var$parse;
// istanbul ignore next
function $dc49e6b2606b0f90$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj['default'] = obj;
        return newObj;
    }
}
// istanbul ignore next
function $dc49e6b2606b0f90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $0ccdac69ab9c529e$exports = {};
// File ignored in coverage tests via setting in .istanbul.yml
/* Jison generated parser */ "use strict";
$0ccdac69ab9c529e$exports.__esModule = true;
var $0ccdac69ab9c529e$var$handlebars = function() {
    var parser = {
        trace: function trace() {},
        yy: {},
        symbols_: {
            "error": 2,
            "root": 3,
            "program": 4,
            "EOF": 5,
            "program_repetition0": 6,
            "statement": 7,
            "mustache": 8,
            "block": 9,
            "rawBlock": 10,
            "partial": 11,
            "partialBlock": 12,
            "content": 13,
            "COMMENT": 14,
            "CONTENT": 15,
            "openRawBlock": 16,
            "rawBlock_repetition0": 17,
            "END_RAW_BLOCK": 18,
            "OPEN_RAW_BLOCK": 19,
            "helperName": 20,
            "openRawBlock_repetition0": 21,
            "openRawBlock_option0": 22,
            "CLOSE_RAW_BLOCK": 23,
            "openBlock": 24,
            "block_option0": 25,
            "closeBlock": 26,
            "openInverse": 27,
            "block_option1": 28,
            "OPEN_BLOCK": 29,
            "openBlock_repetition0": 30,
            "openBlock_option0": 31,
            "openBlock_option1": 32,
            "CLOSE": 33,
            "OPEN_INVERSE": 34,
            "openInverse_repetition0": 35,
            "openInverse_option0": 36,
            "openInverse_option1": 37,
            "openInverseChain": 38,
            "OPEN_INVERSE_CHAIN": 39,
            "openInverseChain_repetition0": 40,
            "openInverseChain_option0": 41,
            "openInverseChain_option1": 42,
            "inverseAndProgram": 43,
            "INVERSE": 44,
            "inverseChain": 45,
            "inverseChain_option0": 46,
            "OPEN_ENDBLOCK": 47,
            "OPEN": 48,
            "mustache_repetition0": 49,
            "mustache_option0": 50,
            "OPEN_UNESCAPED": 51,
            "mustache_repetition1": 52,
            "mustache_option1": 53,
            "CLOSE_UNESCAPED": 54,
            "OPEN_PARTIAL": 55,
            "partialName": 56,
            "partial_repetition0": 57,
            "partial_option0": 58,
            "openPartialBlock": 59,
            "OPEN_PARTIAL_BLOCK": 60,
            "openPartialBlock_repetition0": 61,
            "openPartialBlock_option0": 62,
            "param": 63,
            "sexpr": 64,
            "OPEN_SEXPR": 65,
            "sexpr_repetition0": 66,
            "sexpr_option0": 67,
            "CLOSE_SEXPR": 68,
            "hash": 69,
            "hash_repetition_plus0": 70,
            "hashSegment": 71,
            "ID": 72,
            "EQUALS": 73,
            "blockParams": 74,
            "OPEN_BLOCK_PARAMS": 75,
            "blockParams_repetition_plus0": 76,
            "CLOSE_BLOCK_PARAMS": 77,
            "path": 78,
            "dataName": 79,
            "STRING": 80,
            "NUMBER": 81,
            "BOOLEAN": 82,
            "UNDEFINED": 83,
            "NULL": 84,
            "DATA": 85,
            "pathSegments": 86,
            "SEP": 87,
            "$accept": 0,
            "$end": 1
        },
        terminals_: {
            2: "error",
            5: "EOF",
            14: "COMMENT",
            15: "CONTENT",
            18: "END_RAW_BLOCK",
            19: "OPEN_RAW_BLOCK",
            23: "CLOSE_RAW_BLOCK",
            29: "OPEN_BLOCK",
            33: "CLOSE",
            34: "OPEN_INVERSE",
            39: "OPEN_INVERSE_CHAIN",
            44: "INVERSE",
            47: "OPEN_ENDBLOCK",
            48: "OPEN",
            51: "OPEN_UNESCAPED",
            54: "CLOSE_UNESCAPED",
            55: "OPEN_PARTIAL",
            60: "OPEN_PARTIAL_BLOCK",
            65: "OPEN_SEXPR",
            68: "CLOSE_SEXPR",
            72: "ID",
            73: "EQUALS",
            75: "OPEN_BLOCK_PARAMS",
            77: "CLOSE_BLOCK_PARAMS",
            80: "STRING",
            81: "NUMBER",
            82: "BOOLEAN",
            83: "UNDEFINED",
            84: "NULL",
            85: "DATA",
            87: "SEP"
        },
        productions_: [
            0,
            [
                3,
                2
            ],
            [
                4,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                7,
                1
            ],
            [
                13,
                1
            ],
            [
                10,
                3
            ],
            [
                16,
                5
            ],
            [
                9,
                4
            ],
            [
                9,
                4
            ],
            [
                24,
                6
            ],
            [
                27,
                6
            ],
            [
                38,
                6
            ],
            [
                43,
                2
            ],
            [
                45,
                3
            ],
            [
                45,
                1
            ],
            [
                26,
                3
            ],
            [
                8,
                5
            ],
            [
                8,
                5
            ],
            [
                11,
                5
            ],
            [
                12,
                3
            ],
            [
                59,
                5
            ],
            [
                63,
                1
            ],
            [
                63,
                1
            ],
            [
                64,
                5
            ],
            [
                69,
                1
            ],
            [
                71,
                3
            ],
            [
                74,
                3
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                20,
                1
            ],
            [
                56,
                1
            ],
            [
                56,
                1
            ],
            [
                79,
                2
            ],
            [
                78,
                1
            ],
            [
                86,
                3
            ],
            [
                86,
                1
            ],
            [
                6,
                0
            ],
            [
                6,
                2
            ],
            [
                17,
                0
            ],
            [
                17,
                2
            ],
            [
                21,
                0
            ],
            [
                21,
                2
            ],
            [
                22,
                0
            ],
            [
                22,
                1
            ],
            [
                25,
                0
            ],
            [
                25,
                1
            ],
            [
                28,
                0
            ],
            [
                28,
                1
            ],
            [
                30,
                0
            ],
            [
                30,
                2
            ],
            [
                31,
                0
            ],
            [
                31,
                1
            ],
            [
                32,
                0
            ],
            [
                32,
                1
            ],
            [
                35,
                0
            ],
            [
                35,
                2
            ],
            [
                36,
                0
            ],
            [
                36,
                1
            ],
            [
                37,
                0
            ],
            [
                37,
                1
            ],
            [
                40,
                0
            ],
            [
                40,
                2
            ],
            [
                41,
                0
            ],
            [
                41,
                1
            ],
            [
                42,
                0
            ],
            [
                42,
                1
            ],
            [
                46,
                0
            ],
            [
                46,
                1
            ],
            [
                49,
                0
            ],
            [
                49,
                2
            ],
            [
                50,
                0
            ],
            [
                50,
                1
            ],
            [
                52,
                0
            ],
            [
                52,
                2
            ],
            [
                53,
                0
            ],
            [
                53,
                1
            ],
            [
                57,
                0
            ],
            [
                57,
                2
            ],
            [
                58,
                0
            ],
            [
                58,
                1
            ],
            [
                61,
                0
            ],
            [
                61,
                2
            ],
            [
                62,
                0
            ],
            [
                62,
                1
            ],
            [
                66,
                0
            ],
            [
                66,
                2
            ],
            [
                67,
                0
            ],
            [
                67,
                1
            ],
            [
                70,
                1
            ],
            [
                70,
                2
            ],
            [
                76,
                1
            ],
            [
                76,
                2
            ]
        ],
        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
            var $0 = $$.length - 1;
            switch(yystate){
                case 1:
                    return $$[$0 - 1];
                case 2:
                    this.$ = yy.prepareProgram($$[$0]);
                    break;
                case 3:
                    this.$ = $$[$0];
                    break;
                case 4:
                    this.$ = $$[$0];
                    break;
                case 5:
                    this.$ = $$[$0];
                    break;
                case 6:
                    this.$ = $$[$0];
                    break;
                case 7:
                    this.$ = $$[$0];
                    break;
                case 8:
                    this.$ = $$[$0];
                    break;
                case 9:
                    this.$ = {
                        type: 'CommentStatement',
                        value: yy.stripComment($$[$0]),
                        strip: yy.stripFlags($$[$0], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 10:
                    this.$ = {
                        type: 'ContentStatement',
                        original: $$[$0],
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 11:
                    this.$ = yy.prepareRawBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 12:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1]
                    };
                    break;
                case 13:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], false, this._$);
                    break;
                case 14:
                    this.$ = yy.prepareBlock($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0], true, this._$);
                    break;
                case 15:
                    this.$ = {
                        open: $$[$0 - 5],
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 16:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 17:
                    this.$ = {
                        path: $$[$0 - 4],
                        params: $$[$0 - 3],
                        hash: $$[$0 - 2],
                        blockParams: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 5], $$[$0])
                    };
                    break;
                case 18:
                    this.$ = {
                        strip: yy.stripFlags($$[$0 - 1], $$[$0 - 1]),
                        program: $$[$0]
                    };
                    break;
                case 19:
                    var inverse = yy.prepareBlock($$[$0 - 2], $$[$0 - 1], $$[$0], $$[$0], false, this._$), program = yy.prepareProgram([
                        inverse
                    ], $$[$0 - 1].loc);
                    program.chained = true;
                    this.$ = {
                        strip: $$[$0 - 2].strip,
                        program: program,
                        chain: true
                    };
                    break;
                case 20:
                    this.$ = $$[$0];
                    break;
                case 21:
                    this.$ = {
                        path: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 2], $$[$0])
                    };
                    break;
                case 22:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 23:
                    this.$ = yy.prepareMustache($$[$0 - 3], $$[$0 - 2], $$[$0 - 1], $$[$0 - 4], yy.stripFlags($$[$0 - 4], $$[$0]), this._$);
                    break;
                case 24:
                    this.$ = {
                        type: 'PartialStatement',
                        name: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        indent: '',
                        strip: yy.stripFlags($$[$0 - 4], $$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 25:
                    this.$ = yy.preparePartialBlock($$[$0 - 2], $$[$0 - 1], $$[$0], this._$);
                    break;
                case 26:
                    this.$ = {
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        strip: yy.stripFlags($$[$0 - 4], $$[$0])
                    };
                    break;
                case 27:
                    this.$ = $$[$0];
                    break;
                case 28:
                    this.$ = $$[$0];
                    break;
                case 29:
                    this.$ = {
                        type: 'SubExpression',
                        path: $$[$0 - 3],
                        params: $$[$0 - 2],
                        hash: $$[$0 - 1],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 30:
                    this.$ = {
                        type: 'Hash',
                        pairs: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 31:
                    this.$ = {
                        type: 'HashPair',
                        key: yy.id($$[$0 - 2]),
                        value: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 32:
                    this.$ = yy.id($$[$0 - 1]);
                    break;
                case 33:
                    this.$ = $$[$0];
                    break;
                case 34:
                    this.$ = $$[$0];
                    break;
                case 35:
                    this.$ = {
                        type: 'StringLiteral',
                        value: $$[$0],
                        original: $$[$0],
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 36:
                    this.$ = {
                        type: 'NumberLiteral',
                        value: Number($$[$0]),
                        original: Number($$[$0]),
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 37:
                    this.$ = {
                        type: 'BooleanLiteral',
                        value: $$[$0] === 'true',
                        original: $$[$0] === 'true',
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 38:
                    this.$ = {
                        type: 'UndefinedLiteral',
                        original: undefined,
                        value: undefined,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 39:
                    this.$ = {
                        type: 'NullLiteral',
                        original: null,
                        value: null,
                        loc: yy.locInfo(this._$)
                    };
                    break;
                case 40:
                    this.$ = $$[$0];
                    break;
                case 41:
                    this.$ = $$[$0];
                    break;
                case 42:
                    this.$ = yy.preparePath(true, $$[$0], this._$);
                    break;
                case 43:
                    this.$ = yy.preparePath(false, $$[$0], this._$);
                    break;
                case 44:
                    $$[$0 - 2].push({
                        part: yy.id($$[$0]),
                        original: $$[$0],
                        separator: $$[$0 - 1]
                    });
                    this.$ = $$[$0 - 2];
                    break;
                case 45:
                    this.$ = [
                        {
                            part: yy.id($$[$0]),
                            original: $$[$0]
                        }
                    ];
                    break;
                case 46:
                    this.$ = [];
                    break;
                case 47:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 48:
                    this.$ = [];
                    break;
                case 49:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 50:
                    this.$ = [];
                    break;
                case 51:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 58:
                    this.$ = [];
                    break;
                case 59:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 64:
                    this.$ = [];
                    break;
                case 65:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 70:
                    this.$ = [];
                    break;
                case 71:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 78:
                    this.$ = [];
                    break;
                case 79:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 82:
                    this.$ = [];
                    break;
                case 83:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 86:
                    this.$ = [];
                    break;
                case 87:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 90:
                    this.$ = [];
                    break;
                case 91:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 94:
                    this.$ = [];
                    break;
                case 95:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 98:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 99:
                    $$[$0 - 1].push($$[$0]);
                    break;
                case 100:
                    this.$ = [
                        $$[$0]
                    ];
                    break;
                case 101:
                    $$[$0 - 1].push($$[$0]);
                    break;
            }
        },
        table: [
            {
                3: 1,
                4: 2,
                5: [
                    2,
                    46
                ],
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                1: [
                    3
                ]
            },
            {
                5: [
                    1,
                    4
                ]
            },
            {
                5: [
                    2,
                    2
                ],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [
                    1,
                    12
                ],
                15: [
                    1,
                    20
                ],
                16: 17,
                19: [
                    1,
                    23
                ],
                24: 15,
                27: 16,
                29: [
                    1,
                    21
                ],
                34: [
                    1,
                    22
                ],
                39: [
                    2,
                    2
                ],
                44: [
                    2,
                    2
                ],
                47: [
                    2,
                    2
                ],
                48: [
                    1,
                    13
                ],
                51: [
                    1,
                    14
                ],
                55: [
                    1,
                    18
                ],
                59: 19,
                60: [
                    1,
                    24
                ]
            },
            {
                1: [
                    2,
                    1
                ]
            },
            {
                5: [
                    2,
                    47
                ],
                14: [
                    2,
                    47
                ],
                15: [
                    2,
                    47
                ],
                19: [
                    2,
                    47
                ],
                29: [
                    2,
                    47
                ],
                34: [
                    2,
                    47
                ],
                39: [
                    2,
                    47
                ],
                44: [
                    2,
                    47
                ],
                47: [
                    2,
                    47
                ],
                48: [
                    2,
                    47
                ],
                51: [
                    2,
                    47
                ],
                55: [
                    2,
                    47
                ],
                60: [
                    2,
                    47
                ]
            },
            {
                5: [
                    2,
                    3
                ],
                14: [
                    2,
                    3
                ],
                15: [
                    2,
                    3
                ],
                19: [
                    2,
                    3
                ],
                29: [
                    2,
                    3
                ],
                34: [
                    2,
                    3
                ],
                39: [
                    2,
                    3
                ],
                44: [
                    2,
                    3
                ],
                47: [
                    2,
                    3
                ],
                48: [
                    2,
                    3
                ],
                51: [
                    2,
                    3
                ],
                55: [
                    2,
                    3
                ],
                60: [
                    2,
                    3
                ]
            },
            {
                5: [
                    2,
                    4
                ],
                14: [
                    2,
                    4
                ],
                15: [
                    2,
                    4
                ],
                19: [
                    2,
                    4
                ],
                29: [
                    2,
                    4
                ],
                34: [
                    2,
                    4
                ],
                39: [
                    2,
                    4
                ],
                44: [
                    2,
                    4
                ],
                47: [
                    2,
                    4
                ],
                48: [
                    2,
                    4
                ],
                51: [
                    2,
                    4
                ],
                55: [
                    2,
                    4
                ],
                60: [
                    2,
                    4
                ]
            },
            {
                5: [
                    2,
                    5
                ],
                14: [
                    2,
                    5
                ],
                15: [
                    2,
                    5
                ],
                19: [
                    2,
                    5
                ],
                29: [
                    2,
                    5
                ],
                34: [
                    2,
                    5
                ],
                39: [
                    2,
                    5
                ],
                44: [
                    2,
                    5
                ],
                47: [
                    2,
                    5
                ],
                48: [
                    2,
                    5
                ],
                51: [
                    2,
                    5
                ],
                55: [
                    2,
                    5
                ],
                60: [
                    2,
                    5
                ]
            },
            {
                5: [
                    2,
                    6
                ],
                14: [
                    2,
                    6
                ],
                15: [
                    2,
                    6
                ],
                19: [
                    2,
                    6
                ],
                29: [
                    2,
                    6
                ],
                34: [
                    2,
                    6
                ],
                39: [
                    2,
                    6
                ],
                44: [
                    2,
                    6
                ],
                47: [
                    2,
                    6
                ],
                48: [
                    2,
                    6
                ],
                51: [
                    2,
                    6
                ],
                55: [
                    2,
                    6
                ],
                60: [
                    2,
                    6
                ]
            },
            {
                5: [
                    2,
                    7
                ],
                14: [
                    2,
                    7
                ],
                15: [
                    2,
                    7
                ],
                19: [
                    2,
                    7
                ],
                29: [
                    2,
                    7
                ],
                34: [
                    2,
                    7
                ],
                39: [
                    2,
                    7
                ],
                44: [
                    2,
                    7
                ],
                47: [
                    2,
                    7
                ],
                48: [
                    2,
                    7
                ],
                51: [
                    2,
                    7
                ],
                55: [
                    2,
                    7
                ],
                60: [
                    2,
                    7
                ]
            },
            {
                5: [
                    2,
                    8
                ],
                14: [
                    2,
                    8
                ],
                15: [
                    2,
                    8
                ],
                19: [
                    2,
                    8
                ],
                29: [
                    2,
                    8
                ],
                34: [
                    2,
                    8
                ],
                39: [
                    2,
                    8
                ],
                44: [
                    2,
                    8
                ],
                47: [
                    2,
                    8
                ],
                48: [
                    2,
                    8
                ],
                51: [
                    2,
                    8
                ],
                55: [
                    2,
                    8
                ],
                60: [
                    2,
                    8
                ]
            },
            {
                5: [
                    2,
                    9
                ],
                14: [
                    2,
                    9
                ],
                15: [
                    2,
                    9
                ],
                19: [
                    2,
                    9
                ],
                29: [
                    2,
                    9
                ],
                34: [
                    2,
                    9
                ],
                39: [
                    2,
                    9
                ],
                44: [
                    2,
                    9
                ],
                47: [
                    2,
                    9
                ],
                48: [
                    2,
                    9
                ],
                51: [
                    2,
                    9
                ],
                55: [
                    2,
                    9
                ],
                60: [
                    2,
                    9
                ]
            },
            {
                20: 25,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 36,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 37,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                4: 38,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                15: [
                    2,
                    48
                ],
                17: 39,
                18: [
                    2,
                    48
                ]
            },
            {
                20: 41,
                56: 40,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 44,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                5: [
                    2,
                    10
                ],
                14: [
                    2,
                    10
                ],
                15: [
                    2,
                    10
                ],
                18: [
                    2,
                    10
                ],
                19: [
                    2,
                    10
                ],
                29: [
                    2,
                    10
                ],
                34: [
                    2,
                    10
                ],
                39: [
                    2,
                    10
                ],
                44: [
                    2,
                    10
                ],
                47: [
                    2,
                    10
                ],
                48: [
                    2,
                    10
                ],
                51: [
                    2,
                    10
                ],
                55: [
                    2,
                    10
                ],
                60: [
                    2,
                    10
                ]
            },
            {
                20: 45,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 46,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 47,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 41,
                56: 48,
                64: 42,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    2,
                    78
                ],
                49: 49,
                65: [
                    2,
                    78
                ],
                72: [
                    2,
                    78
                ],
                80: [
                    2,
                    78
                ],
                81: [
                    2,
                    78
                ],
                82: [
                    2,
                    78
                ],
                83: [
                    2,
                    78
                ],
                84: [
                    2,
                    78
                ],
                85: [
                    2,
                    78
                ]
            },
            {
                23: [
                    2,
                    33
                ],
                33: [
                    2,
                    33
                ],
                54: [
                    2,
                    33
                ],
                65: [
                    2,
                    33
                ],
                68: [
                    2,
                    33
                ],
                72: [
                    2,
                    33
                ],
                75: [
                    2,
                    33
                ],
                80: [
                    2,
                    33
                ],
                81: [
                    2,
                    33
                ],
                82: [
                    2,
                    33
                ],
                83: [
                    2,
                    33
                ],
                84: [
                    2,
                    33
                ],
                85: [
                    2,
                    33
                ]
            },
            {
                23: [
                    2,
                    34
                ],
                33: [
                    2,
                    34
                ],
                54: [
                    2,
                    34
                ],
                65: [
                    2,
                    34
                ],
                68: [
                    2,
                    34
                ],
                72: [
                    2,
                    34
                ],
                75: [
                    2,
                    34
                ],
                80: [
                    2,
                    34
                ],
                81: [
                    2,
                    34
                ],
                82: [
                    2,
                    34
                ],
                83: [
                    2,
                    34
                ],
                84: [
                    2,
                    34
                ],
                85: [
                    2,
                    34
                ]
            },
            {
                23: [
                    2,
                    35
                ],
                33: [
                    2,
                    35
                ],
                54: [
                    2,
                    35
                ],
                65: [
                    2,
                    35
                ],
                68: [
                    2,
                    35
                ],
                72: [
                    2,
                    35
                ],
                75: [
                    2,
                    35
                ],
                80: [
                    2,
                    35
                ],
                81: [
                    2,
                    35
                ],
                82: [
                    2,
                    35
                ],
                83: [
                    2,
                    35
                ],
                84: [
                    2,
                    35
                ],
                85: [
                    2,
                    35
                ]
            },
            {
                23: [
                    2,
                    36
                ],
                33: [
                    2,
                    36
                ],
                54: [
                    2,
                    36
                ],
                65: [
                    2,
                    36
                ],
                68: [
                    2,
                    36
                ],
                72: [
                    2,
                    36
                ],
                75: [
                    2,
                    36
                ],
                80: [
                    2,
                    36
                ],
                81: [
                    2,
                    36
                ],
                82: [
                    2,
                    36
                ],
                83: [
                    2,
                    36
                ],
                84: [
                    2,
                    36
                ],
                85: [
                    2,
                    36
                ]
            },
            {
                23: [
                    2,
                    37
                ],
                33: [
                    2,
                    37
                ],
                54: [
                    2,
                    37
                ],
                65: [
                    2,
                    37
                ],
                68: [
                    2,
                    37
                ],
                72: [
                    2,
                    37
                ],
                75: [
                    2,
                    37
                ],
                80: [
                    2,
                    37
                ],
                81: [
                    2,
                    37
                ],
                82: [
                    2,
                    37
                ],
                83: [
                    2,
                    37
                ],
                84: [
                    2,
                    37
                ],
                85: [
                    2,
                    37
                ]
            },
            {
                23: [
                    2,
                    38
                ],
                33: [
                    2,
                    38
                ],
                54: [
                    2,
                    38
                ],
                65: [
                    2,
                    38
                ],
                68: [
                    2,
                    38
                ],
                72: [
                    2,
                    38
                ],
                75: [
                    2,
                    38
                ],
                80: [
                    2,
                    38
                ],
                81: [
                    2,
                    38
                ],
                82: [
                    2,
                    38
                ],
                83: [
                    2,
                    38
                ],
                84: [
                    2,
                    38
                ],
                85: [
                    2,
                    38
                ]
            },
            {
                23: [
                    2,
                    39
                ],
                33: [
                    2,
                    39
                ],
                54: [
                    2,
                    39
                ],
                65: [
                    2,
                    39
                ],
                68: [
                    2,
                    39
                ],
                72: [
                    2,
                    39
                ],
                75: [
                    2,
                    39
                ],
                80: [
                    2,
                    39
                ],
                81: [
                    2,
                    39
                ],
                82: [
                    2,
                    39
                ],
                83: [
                    2,
                    39
                ],
                84: [
                    2,
                    39
                ],
                85: [
                    2,
                    39
                ]
            },
            {
                23: [
                    2,
                    43
                ],
                33: [
                    2,
                    43
                ],
                54: [
                    2,
                    43
                ],
                65: [
                    2,
                    43
                ],
                68: [
                    2,
                    43
                ],
                72: [
                    2,
                    43
                ],
                75: [
                    2,
                    43
                ],
                80: [
                    2,
                    43
                ],
                81: [
                    2,
                    43
                ],
                82: [
                    2,
                    43
                ],
                83: [
                    2,
                    43
                ],
                84: [
                    2,
                    43
                ],
                85: [
                    2,
                    43
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                72: [
                    1,
                    35
                ],
                86: 51
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                52: 52,
                54: [
                    2,
                    82
                ],
                65: [
                    2,
                    82
                ],
                72: [
                    2,
                    82
                ],
                80: [
                    2,
                    82
                ],
                81: [
                    2,
                    82
                ],
                82: [
                    2,
                    82
                ],
                83: [
                    2,
                    82
                ],
                84: [
                    2,
                    82
                ],
                85: [
                    2,
                    82
                ]
            },
            {
                25: 53,
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 54,
                47: [
                    2,
                    54
                ]
            },
            {
                28: 59,
                43: 60,
                44: [
                    1,
                    58
                ],
                47: [
                    2,
                    56
                ]
            },
            {
                13: 62,
                15: [
                    1,
                    20
                ],
                18: [
                    1,
                    61
                ]
            },
            {
                33: [
                    2,
                    86
                ],
                57: 63,
                65: [
                    2,
                    86
                ],
                72: [
                    2,
                    86
                ],
                80: [
                    2,
                    86
                ],
                81: [
                    2,
                    86
                ],
                82: [
                    2,
                    86
                ],
                83: [
                    2,
                    86
                ],
                84: [
                    2,
                    86
                ],
                85: [
                    2,
                    86
                ]
            },
            {
                33: [
                    2,
                    40
                ],
                65: [
                    2,
                    40
                ],
                72: [
                    2,
                    40
                ],
                80: [
                    2,
                    40
                ],
                81: [
                    2,
                    40
                ],
                82: [
                    2,
                    40
                ],
                83: [
                    2,
                    40
                ],
                84: [
                    2,
                    40
                ],
                85: [
                    2,
                    40
                ]
            },
            {
                33: [
                    2,
                    41
                ],
                65: [
                    2,
                    41
                ],
                72: [
                    2,
                    41
                ],
                80: [
                    2,
                    41
                ],
                81: [
                    2,
                    41
                ],
                82: [
                    2,
                    41
                ],
                83: [
                    2,
                    41
                ],
                84: [
                    2,
                    41
                ],
                85: [
                    2,
                    41
                ]
            },
            {
                20: 64,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 65,
                47: [
                    1,
                    66
                ]
            },
            {
                30: 67,
                33: [
                    2,
                    58
                ],
                65: [
                    2,
                    58
                ],
                72: [
                    2,
                    58
                ],
                75: [
                    2,
                    58
                ],
                80: [
                    2,
                    58
                ],
                81: [
                    2,
                    58
                ],
                82: [
                    2,
                    58
                ],
                83: [
                    2,
                    58
                ],
                84: [
                    2,
                    58
                ],
                85: [
                    2,
                    58
                ]
            },
            {
                33: [
                    2,
                    64
                ],
                35: 68,
                65: [
                    2,
                    64
                ],
                72: [
                    2,
                    64
                ],
                75: [
                    2,
                    64
                ],
                80: [
                    2,
                    64
                ],
                81: [
                    2,
                    64
                ],
                82: [
                    2,
                    64
                ],
                83: [
                    2,
                    64
                ],
                84: [
                    2,
                    64
                ],
                85: [
                    2,
                    64
                ]
            },
            {
                21: 69,
                23: [
                    2,
                    50
                ],
                65: [
                    2,
                    50
                ],
                72: [
                    2,
                    50
                ],
                80: [
                    2,
                    50
                ],
                81: [
                    2,
                    50
                ],
                82: [
                    2,
                    50
                ],
                83: [
                    2,
                    50
                ],
                84: [
                    2,
                    50
                ],
                85: [
                    2,
                    50
                ]
            },
            {
                33: [
                    2,
                    90
                ],
                61: 70,
                65: [
                    2,
                    90
                ],
                72: [
                    2,
                    90
                ],
                80: [
                    2,
                    90
                ],
                81: [
                    2,
                    90
                ],
                82: [
                    2,
                    90
                ],
                83: [
                    2,
                    90
                ],
                84: [
                    2,
                    90
                ],
                85: [
                    2,
                    90
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    80
                ],
                50: 71,
                63: 72,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 73,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                72: [
                    1,
                    79
                ]
            },
            {
                23: [
                    2,
                    42
                ],
                33: [
                    2,
                    42
                ],
                54: [
                    2,
                    42
                ],
                65: [
                    2,
                    42
                ],
                68: [
                    2,
                    42
                ],
                72: [
                    2,
                    42
                ],
                75: [
                    2,
                    42
                ],
                80: [
                    2,
                    42
                ],
                81: [
                    2,
                    42
                ],
                82: [
                    2,
                    42
                ],
                83: [
                    2,
                    42
                ],
                84: [
                    2,
                    42
                ],
                85: [
                    2,
                    42
                ],
                87: [
                    1,
                    50
                ]
            },
            {
                20: 74,
                53: 80,
                54: [
                    2,
                    84
                ],
                63: 81,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 82,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                26: 83,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    55
                ]
            },
            {
                4: 84,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                39: [
                    2,
                    46
                ],
                44: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                47: [
                    2,
                    20
                ]
            },
            {
                20: 85,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                4: 86,
                6: 3,
                14: [
                    2,
                    46
                ],
                15: [
                    2,
                    46
                ],
                19: [
                    2,
                    46
                ],
                29: [
                    2,
                    46
                ],
                34: [
                    2,
                    46
                ],
                47: [
                    2,
                    46
                ],
                48: [
                    2,
                    46
                ],
                51: [
                    2,
                    46
                ],
                55: [
                    2,
                    46
                ],
                60: [
                    2,
                    46
                ]
            },
            {
                26: 87,
                47: [
                    1,
                    66
                ]
            },
            {
                47: [
                    2,
                    57
                ]
            },
            {
                5: [
                    2,
                    11
                ],
                14: [
                    2,
                    11
                ],
                15: [
                    2,
                    11
                ],
                19: [
                    2,
                    11
                ],
                29: [
                    2,
                    11
                ],
                34: [
                    2,
                    11
                ],
                39: [
                    2,
                    11
                ],
                44: [
                    2,
                    11
                ],
                47: [
                    2,
                    11
                ],
                48: [
                    2,
                    11
                ],
                51: [
                    2,
                    11
                ],
                55: [
                    2,
                    11
                ],
                60: [
                    2,
                    11
                ]
            },
            {
                15: [
                    2,
                    49
                ],
                18: [
                    2,
                    49
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    88
                ],
                58: 88,
                63: 89,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 90,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                65: [
                    2,
                    94
                ],
                66: 91,
                68: [
                    2,
                    94
                ],
                72: [
                    2,
                    94
                ],
                80: [
                    2,
                    94
                ],
                81: [
                    2,
                    94
                ],
                82: [
                    2,
                    94
                ],
                83: [
                    2,
                    94
                ],
                84: [
                    2,
                    94
                ],
                85: [
                    2,
                    94
                ]
            },
            {
                5: [
                    2,
                    25
                ],
                14: [
                    2,
                    25
                ],
                15: [
                    2,
                    25
                ],
                19: [
                    2,
                    25
                ],
                29: [
                    2,
                    25
                ],
                34: [
                    2,
                    25
                ],
                39: [
                    2,
                    25
                ],
                44: [
                    2,
                    25
                ],
                47: [
                    2,
                    25
                ],
                48: [
                    2,
                    25
                ],
                51: [
                    2,
                    25
                ],
                55: [
                    2,
                    25
                ],
                60: [
                    2,
                    25
                ]
            },
            {
                20: 92,
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                31: 93,
                33: [
                    2,
                    60
                ],
                63: 94,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 95,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    60
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    66
                ],
                36: 96,
                63: 97,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 98,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    66
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                22: 99,
                23: [
                    2,
                    52
                ],
                63: 100,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 101,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                20: 74,
                33: [
                    2,
                    92
                ],
                62: 102,
                63: 103,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 104,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    105
                ]
            },
            {
                33: [
                    2,
                    79
                ],
                65: [
                    2,
                    79
                ],
                72: [
                    2,
                    79
                ],
                80: [
                    2,
                    79
                ],
                81: [
                    2,
                    79
                ],
                82: [
                    2,
                    79
                ],
                83: [
                    2,
                    79
                ],
                84: [
                    2,
                    79
                ],
                85: [
                    2,
                    79
                ]
            },
            {
                33: [
                    2,
                    81
                ]
            },
            {
                23: [
                    2,
                    27
                ],
                33: [
                    2,
                    27
                ],
                54: [
                    2,
                    27
                ],
                65: [
                    2,
                    27
                ],
                68: [
                    2,
                    27
                ],
                72: [
                    2,
                    27
                ],
                75: [
                    2,
                    27
                ],
                80: [
                    2,
                    27
                ],
                81: [
                    2,
                    27
                ],
                82: [
                    2,
                    27
                ],
                83: [
                    2,
                    27
                ],
                84: [
                    2,
                    27
                ],
                85: [
                    2,
                    27
                ]
            },
            {
                23: [
                    2,
                    28
                ],
                33: [
                    2,
                    28
                ],
                54: [
                    2,
                    28
                ],
                65: [
                    2,
                    28
                ],
                68: [
                    2,
                    28
                ],
                72: [
                    2,
                    28
                ],
                75: [
                    2,
                    28
                ],
                80: [
                    2,
                    28
                ],
                81: [
                    2,
                    28
                ],
                82: [
                    2,
                    28
                ],
                83: [
                    2,
                    28
                ],
                84: [
                    2,
                    28
                ],
                85: [
                    2,
                    28
                ]
            },
            {
                23: [
                    2,
                    30
                ],
                33: [
                    2,
                    30
                ],
                54: [
                    2,
                    30
                ],
                68: [
                    2,
                    30
                ],
                71: 106,
                72: [
                    1,
                    107
                ],
                75: [
                    2,
                    30
                ]
            },
            {
                23: [
                    2,
                    98
                ],
                33: [
                    2,
                    98
                ],
                54: [
                    2,
                    98
                ],
                68: [
                    2,
                    98
                ],
                72: [
                    2,
                    98
                ],
                75: [
                    2,
                    98
                ]
            },
            {
                23: [
                    2,
                    45
                ],
                33: [
                    2,
                    45
                ],
                54: [
                    2,
                    45
                ],
                65: [
                    2,
                    45
                ],
                68: [
                    2,
                    45
                ],
                72: [
                    2,
                    45
                ],
                73: [
                    1,
                    108
                ],
                75: [
                    2,
                    45
                ],
                80: [
                    2,
                    45
                ],
                81: [
                    2,
                    45
                ],
                82: [
                    2,
                    45
                ],
                83: [
                    2,
                    45
                ],
                84: [
                    2,
                    45
                ],
                85: [
                    2,
                    45
                ],
                87: [
                    2,
                    45
                ]
            },
            {
                23: [
                    2,
                    44
                ],
                33: [
                    2,
                    44
                ],
                54: [
                    2,
                    44
                ],
                65: [
                    2,
                    44
                ],
                68: [
                    2,
                    44
                ],
                72: [
                    2,
                    44
                ],
                75: [
                    2,
                    44
                ],
                80: [
                    2,
                    44
                ],
                81: [
                    2,
                    44
                ],
                82: [
                    2,
                    44
                ],
                83: [
                    2,
                    44
                ],
                84: [
                    2,
                    44
                ],
                85: [
                    2,
                    44
                ],
                87: [
                    2,
                    44
                ]
            },
            {
                54: [
                    1,
                    109
                ]
            },
            {
                54: [
                    2,
                    83
                ],
                65: [
                    2,
                    83
                ],
                72: [
                    2,
                    83
                ],
                80: [
                    2,
                    83
                ],
                81: [
                    2,
                    83
                ],
                82: [
                    2,
                    83
                ],
                83: [
                    2,
                    83
                ],
                84: [
                    2,
                    83
                ],
                85: [
                    2,
                    83
                ]
            },
            {
                54: [
                    2,
                    85
                ]
            },
            {
                5: [
                    2,
                    13
                ],
                14: [
                    2,
                    13
                ],
                15: [
                    2,
                    13
                ],
                19: [
                    2,
                    13
                ],
                29: [
                    2,
                    13
                ],
                34: [
                    2,
                    13
                ],
                39: [
                    2,
                    13
                ],
                44: [
                    2,
                    13
                ],
                47: [
                    2,
                    13
                ],
                48: [
                    2,
                    13
                ],
                51: [
                    2,
                    13
                ],
                55: [
                    2,
                    13
                ],
                60: [
                    2,
                    13
                ]
            },
            {
                38: 55,
                39: [
                    1,
                    57
                ],
                43: 56,
                44: [
                    1,
                    58
                ],
                45: 111,
                46: 110,
                47: [
                    2,
                    76
                ]
            },
            {
                33: [
                    2,
                    70
                ],
                40: 112,
                65: [
                    2,
                    70
                ],
                72: [
                    2,
                    70
                ],
                75: [
                    2,
                    70
                ],
                80: [
                    2,
                    70
                ],
                81: [
                    2,
                    70
                ],
                82: [
                    2,
                    70
                ],
                83: [
                    2,
                    70
                ],
                84: [
                    2,
                    70
                ],
                85: [
                    2,
                    70
                ]
            },
            {
                47: [
                    2,
                    18
                ]
            },
            {
                5: [
                    2,
                    14
                ],
                14: [
                    2,
                    14
                ],
                15: [
                    2,
                    14
                ],
                19: [
                    2,
                    14
                ],
                29: [
                    2,
                    14
                ],
                34: [
                    2,
                    14
                ],
                39: [
                    2,
                    14
                ],
                44: [
                    2,
                    14
                ],
                47: [
                    2,
                    14
                ],
                48: [
                    2,
                    14
                ],
                51: [
                    2,
                    14
                ],
                55: [
                    2,
                    14
                ],
                60: [
                    2,
                    14
                ]
            },
            {
                33: [
                    1,
                    113
                ]
            },
            {
                33: [
                    2,
                    87
                ],
                65: [
                    2,
                    87
                ],
                72: [
                    2,
                    87
                ],
                80: [
                    2,
                    87
                ],
                81: [
                    2,
                    87
                ],
                82: [
                    2,
                    87
                ],
                83: [
                    2,
                    87
                ],
                84: [
                    2,
                    87
                ],
                85: [
                    2,
                    87
                ]
            },
            {
                33: [
                    2,
                    89
                ]
            },
            {
                20: 74,
                63: 115,
                64: 75,
                65: [
                    1,
                    43
                ],
                67: 114,
                68: [
                    2,
                    96
                ],
                69: 116,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                33: [
                    1,
                    117
                ]
            },
            {
                32: 118,
                33: [
                    2,
                    62
                ],
                74: 119,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    59
                ],
                65: [
                    2,
                    59
                ],
                72: [
                    2,
                    59
                ],
                75: [
                    2,
                    59
                ],
                80: [
                    2,
                    59
                ],
                81: [
                    2,
                    59
                ],
                82: [
                    2,
                    59
                ],
                83: [
                    2,
                    59
                ],
                84: [
                    2,
                    59
                ],
                85: [
                    2,
                    59
                ]
            },
            {
                33: [
                    2,
                    61
                ],
                75: [
                    2,
                    61
                ]
            },
            {
                33: [
                    2,
                    68
                ],
                37: 121,
                74: 122,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    65
                ],
                65: [
                    2,
                    65
                ],
                72: [
                    2,
                    65
                ],
                75: [
                    2,
                    65
                ],
                80: [
                    2,
                    65
                ],
                81: [
                    2,
                    65
                ],
                82: [
                    2,
                    65
                ],
                83: [
                    2,
                    65
                ],
                84: [
                    2,
                    65
                ],
                85: [
                    2,
                    65
                ]
            },
            {
                33: [
                    2,
                    67
                ],
                75: [
                    2,
                    67
                ]
            },
            {
                23: [
                    1,
                    123
                ]
            },
            {
                23: [
                    2,
                    51
                ],
                65: [
                    2,
                    51
                ],
                72: [
                    2,
                    51
                ],
                80: [
                    2,
                    51
                ],
                81: [
                    2,
                    51
                ],
                82: [
                    2,
                    51
                ],
                83: [
                    2,
                    51
                ],
                84: [
                    2,
                    51
                ],
                85: [
                    2,
                    51
                ]
            },
            {
                23: [
                    2,
                    53
                ]
            },
            {
                33: [
                    1,
                    124
                ]
            },
            {
                33: [
                    2,
                    91
                ],
                65: [
                    2,
                    91
                ],
                72: [
                    2,
                    91
                ],
                80: [
                    2,
                    91
                ],
                81: [
                    2,
                    91
                ],
                82: [
                    2,
                    91
                ],
                83: [
                    2,
                    91
                ],
                84: [
                    2,
                    91
                ],
                85: [
                    2,
                    91
                ]
            },
            {
                33: [
                    2,
                    93
                ]
            },
            {
                5: [
                    2,
                    22
                ],
                14: [
                    2,
                    22
                ],
                15: [
                    2,
                    22
                ],
                19: [
                    2,
                    22
                ],
                29: [
                    2,
                    22
                ],
                34: [
                    2,
                    22
                ],
                39: [
                    2,
                    22
                ],
                44: [
                    2,
                    22
                ],
                47: [
                    2,
                    22
                ],
                48: [
                    2,
                    22
                ],
                51: [
                    2,
                    22
                ],
                55: [
                    2,
                    22
                ],
                60: [
                    2,
                    22
                ]
            },
            {
                23: [
                    2,
                    99
                ],
                33: [
                    2,
                    99
                ],
                54: [
                    2,
                    99
                ],
                68: [
                    2,
                    99
                ],
                72: [
                    2,
                    99
                ],
                75: [
                    2,
                    99
                ]
            },
            {
                73: [
                    1,
                    108
                ]
            },
            {
                20: 74,
                63: 125,
                64: 75,
                65: [
                    1,
                    43
                ],
                72: [
                    1,
                    35
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    23
                ],
                14: [
                    2,
                    23
                ],
                15: [
                    2,
                    23
                ],
                19: [
                    2,
                    23
                ],
                29: [
                    2,
                    23
                ],
                34: [
                    2,
                    23
                ],
                39: [
                    2,
                    23
                ],
                44: [
                    2,
                    23
                ],
                47: [
                    2,
                    23
                ],
                48: [
                    2,
                    23
                ],
                51: [
                    2,
                    23
                ],
                55: [
                    2,
                    23
                ],
                60: [
                    2,
                    23
                ]
            },
            {
                47: [
                    2,
                    19
                ]
            },
            {
                47: [
                    2,
                    77
                ]
            },
            {
                20: 74,
                33: [
                    2,
                    72
                ],
                41: 126,
                63: 127,
                64: 75,
                65: [
                    1,
                    43
                ],
                69: 128,
                70: 76,
                71: 77,
                72: [
                    1,
                    78
                ],
                75: [
                    2,
                    72
                ],
                78: 26,
                79: 27,
                80: [
                    1,
                    28
                ],
                81: [
                    1,
                    29
                ],
                82: [
                    1,
                    30
                ],
                83: [
                    1,
                    31
                ],
                84: [
                    1,
                    32
                ],
                85: [
                    1,
                    34
                ],
                86: 33
            },
            {
                5: [
                    2,
                    24
                ],
                14: [
                    2,
                    24
                ],
                15: [
                    2,
                    24
                ],
                19: [
                    2,
                    24
                ],
                29: [
                    2,
                    24
                ],
                34: [
                    2,
                    24
                ],
                39: [
                    2,
                    24
                ],
                44: [
                    2,
                    24
                ],
                47: [
                    2,
                    24
                ],
                48: [
                    2,
                    24
                ],
                51: [
                    2,
                    24
                ],
                55: [
                    2,
                    24
                ],
                60: [
                    2,
                    24
                ]
            },
            {
                68: [
                    1,
                    129
                ]
            },
            {
                65: [
                    2,
                    95
                ],
                68: [
                    2,
                    95
                ],
                72: [
                    2,
                    95
                ],
                80: [
                    2,
                    95
                ],
                81: [
                    2,
                    95
                ],
                82: [
                    2,
                    95
                ],
                83: [
                    2,
                    95
                ],
                84: [
                    2,
                    95
                ],
                85: [
                    2,
                    95
                ]
            },
            {
                68: [
                    2,
                    97
                ]
            },
            {
                5: [
                    2,
                    21
                ],
                14: [
                    2,
                    21
                ],
                15: [
                    2,
                    21
                ],
                19: [
                    2,
                    21
                ],
                29: [
                    2,
                    21
                ],
                34: [
                    2,
                    21
                ],
                39: [
                    2,
                    21
                ],
                44: [
                    2,
                    21
                ],
                47: [
                    2,
                    21
                ],
                48: [
                    2,
                    21
                ],
                51: [
                    2,
                    21
                ],
                55: [
                    2,
                    21
                ],
                60: [
                    2,
                    21
                ]
            },
            {
                33: [
                    1,
                    130
                ]
            },
            {
                33: [
                    2,
                    63
                ]
            },
            {
                72: [
                    1,
                    132
                ],
                76: 131
            },
            {
                33: [
                    1,
                    133
                ]
            },
            {
                33: [
                    2,
                    69
                ]
            },
            {
                15: [
                    2,
                    12
                ],
                18: [
                    2,
                    12
                ]
            },
            {
                14: [
                    2,
                    26
                ],
                15: [
                    2,
                    26
                ],
                19: [
                    2,
                    26
                ],
                29: [
                    2,
                    26
                ],
                34: [
                    2,
                    26
                ],
                47: [
                    2,
                    26
                ],
                48: [
                    2,
                    26
                ],
                51: [
                    2,
                    26
                ],
                55: [
                    2,
                    26
                ],
                60: [
                    2,
                    26
                ]
            },
            {
                23: [
                    2,
                    31
                ],
                33: [
                    2,
                    31
                ],
                54: [
                    2,
                    31
                ],
                68: [
                    2,
                    31
                ],
                72: [
                    2,
                    31
                ],
                75: [
                    2,
                    31
                ]
            },
            {
                33: [
                    2,
                    74
                ],
                42: 134,
                74: 135,
                75: [
                    1,
                    120
                ]
            },
            {
                33: [
                    2,
                    71
                ],
                65: [
                    2,
                    71
                ],
                72: [
                    2,
                    71
                ],
                75: [
                    2,
                    71
                ],
                80: [
                    2,
                    71
                ],
                81: [
                    2,
                    71
                ],
                82: [
                    2,
                    71
                ],
                83: [
                    2,
                    71
                ],
                84: [
                    2,
                    71
                ],
                85: [
                    2,
                    71
                ]
            },
            {
                33: [
                    2,
                    73
                ],
                75: [
                    2,
                    73
                ]
            },
            {
                23: [
                    2,
                    29
                ],
                33: [
                    2,
                    29
                ],
                54: [
                    2,
                    29
                ],
                65: [
                    2,
                    29
                ],
                68: [
                    2,
                    29
                ],
                72: [
                    2,
                    29
                ],
                75: [
                    2,
                    29
                ],
                80: [
                    2,
                    29
                ],
                81: [
                    2,
                    29
                ],
                82: [
                    2,
                    29
                ],
                83: [
                    2,
                    29
                ],
                84: [
                    2,
                    29
                ],
                85: [
                    2,
                    29
                ]
            },
            {
                14: [
                    2,
                    15
                ],
                15: [
                    2,
                    15
                ],
                19: [
                    2,
                    15
                ],
                29: [
                    2,
                    15
                ],
                34: [
                    2,
                    15
                ],
                39: [
                    2,
                    15
                ],
                44: [
                    2,
                    15
                ],
                47: [
                    2,
                    15
                ],
                48: [
                    2,
                    15
                ],
                51: [
                    2,
                    15
                ],
                55: [
                    2,
                    15
                ],
                60: [
                    2,
                    15
                ]
            },
            {
                72: [
                    1,
                    137
                ],
                77: [
                    1,
                    136
                ]
            },
            {
                72: [
                    2,
                    100
                ],
                77: [
                    2,
                    100
                ]
            },
            {
                14: [
                    2,
                    16
                ],
                15: [
                    2,
                    16
                ],
                19: [
                    2,
                    16
                ],
                29: [
                    2,
                    16
                ],
                34: [
                    2,
                    16
                ],
                44: [
                    2,
                    16
                ],
                47: [
                    2,
                    16
                ],
                48: [
                    2,
                    16
                ],
                51: [
                    2,
                    16
                ],
                55: [
                    2,
                    16
                ],
                60: [
                    2,
                    16
                ]
            },
            {
                33: [
                    1,
                    138
                ]
            },
            {
                33: [
                    2,
                    75
                ]
            },
            {
                33: [
                    2,
                    32
                ]
            },
            {
                72: [
                    2,
                    101
                ],
                77: [
                    2,
                    101
                ]
            },
            {
                14: [
                    2,
                    17
                ],
                15: [
                    2,
                    17
                ],
                19: [
                    2,
                    17
                ],
                29: [
                    2,
                    17
                ],
                34: [
                    2,
                    17
                ],
                39: [
                    2,
                    17
                ],
                44: [
                    2,
                    17
                ],
                47: [
                    2,
                    17
                ],
                48: [
                    2,
                    17
                ],
                51: [
                    2,
                    17
                ],
                55: [
                    2,
                    17
                ],
                60: [
                    2,
                    17
                ]
            }
        ],
        defaultActions: {
            4: [
                2,
                1
            ],
            54: [
                2,
                55
            ],
            56: [
                2,
                20
            ],
            60: [
                2,
                57
            ],
            73: [
                2,
                81
            ],
            82: [
                2,
                85
            ],
            86: [
                2,
                18
            ],
            90: [
                2,
                89
            ],
            101: [
                2,
                53
            ],
            104: [
                2,
                93
            ],
            110: [
                2,
                19
            ],
            111: [
                2,
                77
            ],
            116: [
                2,
                97
            ],
            119: [
                2,
                63
            ],
            122: [
                2,
                69
            ],
            135: [
                2,
                75
            ],
            136: [
                2,
                32
            ]
        },
        parseError: function parseError(str, hash) {
            throw new Error(str);
        },
        parse: function parse(input) {
            var self = this, stack = [
                0
            ], vstack = [
                null
            ], lstack = [], table = this.table, yytext = "", yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
            this.lexer.setInput(input);
            this.lexer.yy = this.yy;
            this.yy.lexer = this.lexer;
            this.yy.parser = this;
            if (typeof this.lexer.yylloc == "undefined") this.lexer.yylloc = {};
            var yyloc = this.lexer.yylloc;
            lstack.push(yyloc);
            var ranges = this.lexer.options && this.lexer.options.ranges;
            if (typeof this.yy.parseError === "function") this.parseError = this.yy.parseError;
            function popStack(n) {
                stack.length = stack.length - 2 * n;
                vstack.length = vstack.length - n;
                lstack.length = lstack.length - n;
            }
            function lex() {
                var token;
                token = self.lexer.lex() || 1;
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token;
            }
            var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
            while(true){
                state = stack[stack.length - 1];
                if (this.defaultActions[state]) action = this.defaultActions[state];
                else {
                    if (symbol === null || typeof symbol == "undefined") symbol = lex();
                    action = table[state] && table[state][symbol];
                }
                if (typeof action === "undefined" || !action.length || !action[0]) {
                    var errStr = "";
                    if (!recovering) {
                        expected = [];
                        for(p in table[state])if (this.terminals_[p] && p > 2) expected.push("'" + this.terminals_[p] + "'");
                        if (this.lexer.showPosition) errStr = "Parse error on line " + (yylineno + 1) + ":\n" + this.lexer.showPosition() + "\nExpecting " + expected.join(", ") + ", got '" + (this.terminals_[symbol] || symbol) + "'";
                        else errStr = "Parse error on line " + (yylineno + 1) + ": Unexpected " + (symbol == 1 ? "end of input" : "'" + (this.terminals_[symbol] || symbol) + "'");
                        this.parseError(errStr, {
                            text: this.lexer.match,
                            token: this.terminals_[symbol] || symbol,
                            line: this.lexer.yylineno,
                            loc: yyloc,
                            expected: expected
                        });
                    }
                }
                if (action[0] instanceof Array && action.length > 1) throw new Error("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol);
                switch(action[0]){
                    case 1:
                        stack.push(symbol);
                        vstack.push(this.lexer.yytext);
                        lstack.push(this.lexer.yylloc);
                        stack.push(action[1]);
                        symbol = null;
                        if (!preErrorSymbol) {
                            yyleng = this.lexer.yyleng;
                            yytext = this.lexer.yytext;
                            yylineno = this.lexer.yylineno;
                            yyloc = this.lexer.yylloc;
                            if (recovering > 0) recovering--;
                        } else {
                            symbol = preErrorSymbol;
                            preErrorSymbol = null;
                        }
                        break;
                    case 2:
                        len = this.productions_[action[1]][1];
                        yyval.$ = vstack[vstack.length - len];
                        yyval._$ = {
                            first_line: lstack[lstack.length - (len || 1)].first_line,
                            last_line: lstack[lstack.length - 1].last_line,
                            first_column: lstack[lstack.length - (len || 1)].first_column,
                            last_column: lstack[lstack.length - 1].last_column
                        };
                        if (ranges) yyval._$.range = [
                            lstack[lstack.length - (len || 1)].range[0],
                            lstack[lstack.length - 1].range[1]
                        ];
                        r = this.performAction.call(yyval, yytext, yyleng, yylineno, this.yy, action[1], vstack, lstack);
                        if (typeof r !== "undefined") return r;
                        if (len) {
                            stack = stack.slice(0, -1 * len * 2);
                            vstack = vstack.slice(0, -1 * len);
                            lstack = lstack.slice(0, -1 * len);
                        }
                        stack.push(this.productions_[action[1]][0]);
                        vstack.push(yyval.$);
                        lstack.push(yyval._$);
                        newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
                        stack.push(newState);
                        break;
                    case 3:
                        return true;
                }
            }
            return true;
        }
    };
    /* Jison generated lexer */ var lexer = function() {
        var lexer = {
            EOF: 1,
            parseError: function parseError(str, hash) {
                if (this.yy.parser) this.yy.parser.parseError(str, hash);
                else throw new Error(str);
            },
            setInput: function setInput(input) {
                this._input = input;
                this._more = this._less = this.done = false;
                this.yylineno = this.yyleng = 0;
                this.yytext = this.matched = this.match = '';
                this.conditionStack = [
                    'INITIAL'
                ];
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0
                };
                if (this.options.ranges) this.yylloc.range = [
                    0,
                    0
                ];
                this.offset = 0;
                return this;
            },
            input: function input() {
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                var lines = ch.match(/(?:\r\n?|\n).*/g);
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                } else this.yylloc.last_column++;
                if (this.options.ranges) this.yylloc.range[1]++;
                this._input = this._input.slice(1);
                return ch;
            },
            unput: function unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len - 1);
                //this.yyleng -= len;
                this.offset -= len;
                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
                this.match = this.match.substr(0, this.match.length - 1);
                this.matched = this.matched.substr(0, this.matched.length - 1);
                if (lines.length - 1) this.yylineno -= lines.length - 1;
                var r = this.yylloc.range;
                this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
                };
                if (this.options.ranges) this.yylloc.range = [
                    r[0],
                    r[0] + this.yyleng - len
                ];
                return this;
            },
            more: function more() {
                this._more = true;
                return this;
            },
            less: function less(n) {
                this.unput(this.match.slice(n));
            },
            pastInput: function pastInput() {
                var past = this.matched.substr(0, this.matched.length - this.match.length);
                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, "");
            },
            upcomingInput: function upcomingInput() {
                var next = this.match;
                if (next.length < 20) next += this._input.substr(0, 20 - next.length);
                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
            },
            showPosition: function showPosition() {
                var pre = this.pastInput();
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput() + "\n" + c + "^";
            },
            next: function next() {
                if (this.done) return this.EOF;
                if (!this._input) this.done = true;
                var token, match, tempMatch, index, col, lines;
                if (!this._more) {
                    this.yytext = '';
                    this.match = '';
                }
                var rules = this._currentRules();
                for(var i = 0; i < rules.length; i++){
                    tempMatch = this._input.match(this.rules[rules[i]]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (!this.options.flex) break;
                    }
                }
                if (match) {
                    lines = match[0].match(/(?:\r\n?|\n).*/g);
                    if (lines) this.yylineno += lines.length;
                    this.yylloc = {
                        first_line: this.yylloc.last_line,
                        last_line: this.yylineno + 1,
                        first_column: this.yylloc.last_column,
                        last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
                    };
                    this.yytext += match[0];
                    this.match += match[0];
                    this.matches = match;
                    this.yyleng = this.yytext.length;
                    if (this.options.ranges) this.yylloc.range = [
                        this.offset,
                        this.offset += this.yyleng
                    ];
                    this._more = false;
                    this._input = this._input.slice(match[0].length);
                    this.matched += match[0];
                    token = this.performAction.call(this, this.yy, this, rules[index], this.conditionStack[this.conditionStack.length - 1]);
                    if (this.done && this._input) this.done = false;
                    if (token) return token;
                    else return;
                }
                if (this._input === "") return this.EOF;
                else return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                    text: "",
                    token: null,
                    line: this.yylineno
                });
            },
            lex: function lex() {
                var r = this.next();
                if (typeof r !== 'undefined') return r;
                else return this.lex();
            },
            begin: function begin(condition) {
                this.conditionStack.push(condition);
            },
            popState: function popState() {
                return this.conditionStack.pop();
            },
            _currentRules: function _currentRules() {
                return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
            },
            topState: function topState() {
                return this.conditionStack[this.conditionStack.length - 2];
            },
            pushState: function begin(condition) {
                this.begin(condition);
            }
        };
        lexer.options = {};
        lexer.performAction = function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
            function strip(start, end) {
                return yy_.yytext = yy_.yytext.substring(start, yy_.yyleng - end + start);
            }
            var YYSTATE = YY_START;
            switch($avoiding_name_collisions){
                case 0:
                    if (yy_.yytext.slice(-2) === "\\\\") {
                        strip(0, 1);
                        this.begin("mu");
                    } else if (yy_.yytext.slice(-1) === "\\") {
                        strip(0, 1);
                        this.begin("emu");
                    } else this.begin("mu");
                    if (yy_.yytext) return 15;
                    break;
                case 1:
                    return 15;
                case 2:
                    this.popState();
                    return 15;
                case 3:
                    this.begin('raw');
                    return 15;
                case 4:
                    this.popState();
                    // Should be using `this.topState()` below, but it currently
                    // returns the second top instead of the first top. Opened an
                    // issue about it at https://github.com/zaach/jison/issues/291
                    if (this.conditionStack[this.conditionStack.length - 1] === 'raw') return 15;
                    else {
                        strip(5, 9);
                        return 'END_RAW_BLOCK';
                    }
                    break;
                case 5:
                    return 15;
                case 6:
                    this.popState();
                    return 14;
                case 7:
                    return 65;
                case 8:
                    return 68;
                case 9:
                    return 19;
                case 10:
                    this.popState();
                    this.begin('raw');
                    return 23;
                case 11:
                    return 55;
                case 12:
                    return 60;
                case 13:
                    return 29;
                case 14:
                    return 47;
                case 15:
                    this.popState();
                    return 44;
                case 16:
                    this.popState();
                    return 44;
                case 17:
                    return 34;
                case 18:
                    return 39;
                case 19:
                    return 51;
                case 20:
                    return 48;
                case 21:
                    this.unput(yy_.yytext);
                    this.popState();
                    this.begin('com');
                    break;
                case 22:
                    this.popState();
                    return 14;
                case 23:
                    return 48;
                case 24:
                    return 73;
                case 25:
                    return 72;
                case 26:
                    return 72;
                case 27:
                    return 87;
                case 28:
                    break;
                case 29:
                    this.popState();
                    return 54;
                case 30:
                    this.popState();
                    return 33;
                case 31:
                    yy_.yytext = strip(1, 2).replace(/\\"/g, '"');
                    return 80;
                case 32:
                    yy_.yytext = strip(1, 2).replace(/\\'/g, "'");
                    return 80;
                case 33:
                    return 85;
                case 34:
                    return 82;
                case 35:
                    return 82;
                case 36:
                    return 83;
                case 37:
                    return 84;
                case 38:
                    return 81;
                case 39:
                    return 75;
                case 40:
                    return 77;
                case 41:
                    return 72;
                case 42:
                    yy_.yytext = yy_.yytext.replace(/\\([\\\]])/g, '$1');
                    return 72;
                case 43:
                    return 'INVALID';
                case 44:
                    return 5;
            }
        };
        lexer.rules = [
            /^(?:[^\x00]*?(?=(\{\{)))/,
            /^(?:[^\x00]+)/,
            /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
            /^(?:\{\{\{\{(?=[^/]))/,
            /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
            /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
            /^(?:[\s\S]*?--(~)?\}\})/,
            /^(?:\()/,
            /^(?:\))/,
            /^(?:\{\{\{\{)/,
            /^(?:\}\}\}\})/,
            /^(?:\{\{(~)?>)/,
            /^(?:\{\{(~)?#>)/,
            /^(?:\{\{(~)?#\*?)/,
            /^(?:\{\{(~)?\/)/,
            /^(?:\{\{(~)?\^\s*(~)?\}\})/,
            /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
            /^(?:\{\{(~)?\^)/,
            /^(?:\{\{(~)?\s*else\b)/,
            /^(?:\{\{(~)?\{)/,
            /^(?:\{\{(~)?&)/,
            /^(?:\{\{(~)?!--)/,
            /^(?:\{\{(~)?![\s\S]*?\}\})/,
            /^(?:\{\{(~)?\*?)/,
            /^(?:=)/,
            /^(?:\.\.)/,
            /^(?:\.(?=([=~}\s\/.)|])))/,
            /^(?:[\/.])/,
            /^(?:\s+)/,
            /^(?:\}(~)?\}\})/,
            /^(?:(~)?\}\})/,
            /^(?:"(\\["]|[^"])*")/,
            /^(?:'(\\[']|[^'])*')/,
            /^(?:@)/,
            /^(?:true(?=([~}\s)])))/,
            /^(?:false(?=([~}\s)])))/,
            /^(?:undefined(?=([~}\s)])))/,
            /^(?:null(?=([~}\s)])))/,
            /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
            /^(?:as\s+\|)/,
            /^(?:\|)/,
            /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
            /^(?:\[(\\\]|[^\]])*\])/,
            /^(?:.)/,
            /^(?:$)/
        ];
        lexer.conditions = {
            "mu": {
                "rules": [
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44
                ],
                "inclusive": false
            },
            "emu": {
                "rules": [
                    2
                ],
                "inclusive": false
            },
            "com": {
                "rules": [
                    6
                ],
                "inclusive": false
            },
            "raw": {
                "rules": [
                    3,
                    4,
                    5
                ],
                "inclusive": false
            },
            "INITIAL": {
                "rules": [
                    0,
                    1,
                    44
                ],
                "inclusive": true
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$0ccdac69ab9c529e$exports["default"] = $0ccdac69ab9c529e$var$handlebars;
$0ccdac69ab9c529e$exports = $0ccdac69ab9c529e$exports["default"];


var $dc49e6b2606b0f90$var$_parser2 = $dc49e6b2606b0f90$var$_interopRequireDefault($0ccdac69ab9c529e$exports);
var $dcf6a5cddbac5f37$exports = {};
'use strict';
$dcf6a5cddbac5f37$exports.__esModule = true;
// istanbul ignore next
function $dcf6a5cddbac5f37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
var $24772e40320d4317$exports = {};
'use strict';
$24772e40320d4317$exports.__esModule = true;
// istanbul ignore next
function $24772e40320d4317$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $24772e40320d4317$var$_exception2 = $24772e40320d4317$var$_interopRequireDefault($f9e5592ce830a697$exports);
function $24772e40320d4317$var$Visitor() {
    this.parents = [];
}
$24772e40320d4317$var$Visitor.prototype = {
    constructor: $24772e40320d4317$var$Visitor,
    mutating: false,
    // Visits a given value. If mutating, will replace the value if necessary.
    acceptKey: function acceptKey(node, name) {
        var value = this.accept(node[name]);
        if (this.mutating) {
            // Hacky sanity check: This may have a few false positives for type for the helper
            // methods but will generally do the right thing without a lot of overhead.
            if (value && !$24772e40320d4317$var$Visitor.prototype[value.type]) throw new $24772e40320d4317$var$_exception2['default']('Unexpected node type "' + value.type + '" found when accepting ' + name + ' on ' + node.type);
            node[name] = value;
        }
    },
    // Performs an accept operation with added sanity check to ensure
    // required keys are not removed.
    acceptRequired: function acceptRequired(node, name) {
        this.acceptKey(node, name);
        if (!node[name]) throw new $24772e40320d4317$var$_exception2['default'](node.type + ' requires ' + name);
    },
    // Traverses a given array. If mutating, empty respnses will be removed
    // for child elements.
    acceptArray: function acceptArray(array) {
        for(var i = 0, l = array.length; i < l; i++){
            this.acceptKey(array, i);
            if (!array[i]) {
                array.splice(i, 1);
                i--;
                l--;
            }
        }
    },
    accept: function accept(object) {
        if (!object) return;
        /* istanbul ignore next: Sanity code */ if (!this[object.type]) throw new $24772e40320d4317$var$_exception2['default']('Unknown type: ' + object.type, object);
        if (this.current) this.parents.unshift(this.current);
        this.current = object;
        var ret = this[object.type](object);
        this.current = this.parents.shift();
        if (!this.mutating || ret) return ret;
        else if (ret !== false) return object;
    },
    Program: function Program(program) {
        this.acceptArray(program.body);
    },
    MustacheStatement: $24772e40320d4317$var$visitSubExpression,
    Decorator: $24772e40320d4317$var$visitSubExpression,
    BlockStatement: $24772e40320d4317$var$visitBlock,
    DecoratorBlock: $24772e40320d4317$var$visitBlock,
    PartialStatement: $24772e40320d4317$var$visitPartial,
    PartialBlockStatement: function PartialBlockStatement(partial) {
        $24772e40320d4317$var$visitPartial.call(this, partial);
        this.acceptKey(partial, 'program');
    },
    ContentStatement: function ContentStatement() /* content */ {},
    CommentStatement: function CommentStatement() /* comment */ {},
    SubExpression: $24772e40320d4317$var$visitSubExpression,
    PathExpression: function PathExpression() /* path */ {},
    StringLiteral: function StringLiteral() /* string */ {},
    NumberLiteral: function NumberLiteral() /* number */ {},
    BooleanLiteral: function BooleanLiteral() /* bool */ {},
    UndefinedLiteral: function UndefinedLiteral() /* literal */ {},
    NullLiteral: function NullLiteral() /* literal */ {},
    Hash: function Hash(hash) {
        this.acceptArray(hash.pairs);
    },
    HashPair: function HashPair(pair) {
        this.acceptRequired(pair, 'value');
    }
};
function $24772e40320d4317$var$visitSubExpression(mustache) {
    this.acceptRequired(mustache, 'path');
    this.acceptArray(mustache.params);
    this.acceptKey(mustache, 'hash');
}
function $24772e40320d4317$var$visitBlock(block) {
    $24772e40320d4317$var$visitSubExpression.call(this, block);
    this.acceptKey(block, 'program');
    this.acceptKey(block, 'inverse');
}
function $24772e40320d4317$var$visitPartial(partial) {
    this.acceptRequired(partial, 'name');
    this.acceptArray(partial.params);
    this.acceptKey(partial, 'hash');
}
$24772e40320d4317$exports['default'] = $24772e40320d4317$var$Visitor;
$24772e40320d4317$exports = $24772e40320d4317$exports['default'];


var $dcf6a5cddbac5f37$var$_visitor2 = $dcf6a5cddbac5f37$var$_interopRequireDefault($24772e40320d4317$exports);
function $dcf6a5cddbac5f37$var$WhitespaceControl() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
    this.options = options;
}
$dcf6a5cddbac5f37$var$WhitespaceControl.prototype = new $dcf6a5cddbac5f37$var$_visitor2['default']();
$dcf6a5cddbac5f37$var$WhitespaceControl.prototype.Program = function(program) {
    var doStandalone = !this.options.ignoreStandalone;
    var isRoot = !this.isRootSeen;
    this.isRootSeen = true;
    var body = program.body;
    for(var i = 0, l = body.length; i < l; i++){
        var current = body[i], strip = this.accept(current);
        if (!strip) continue;
        var _isPrevWhitespace = $dcf6a5cddbac5f37$var$isPrevWhitespace(body, i, isRoot), _isNextWhitespace = $dcf6a5cddbac5f37$var$isNextWhitespace(body, i, isRoot), openStandalone = strip.openStandalone && _isPrevWhitespace, closeStandalone = strip.closeStandalone && _isNextWhitespace, inlineStandalone = strip.inlineStandalone && _isPrevWhitespace && _isNextWhitespace;
        if (strip.close) $dcf6a5cddbac5f37$var$omitRight(body, i, true);
        if (strip.open) $dcf6a5cddbac5f37$var$omitLeft(body, i, true);
        if (doStandalone && inlineStandalone) {
            $dcf6a5cddbac5f37$var$omitRight(body, i);
            if ($dcf6a5cddbac5f37$var$omitLeft(body, i)) // If we are on a standalone node, save the indent info for partials
            {
                if (current.type === 'PartialStatement') // Pull out the whitespace from the final line
                current.indent = /([ \t]+$)/.exec(body[i - 1].original)[1];
            }
        }
        if (doStandalone && openStandalone) {
            $dcf6a5cddbac5f37$var$omitRight((current.program || current.inverse).body);
            // Strip out the previous content node if it's whitespace only
            $dcf6a5cddbac5f37$var$omitLeft(body, i);
        }
        if (doStandalone && closeStandalone) {
            // Always strip the next node
            $dcf6a5cddbac5f37$var$omitRight(body, i);
            $dcf6a5cddbac5f37$var$omitLeft((current.inverse || current.program).body);
        }
    }
    return program;
};
$dcf6a5cddbac5f37$var$WhitespaceControl.prototype.BlockStatement = $dcf6a5cddbac5f37$var$WhitespaceControl.prototype.DecoratorBlock = $dcf6a5cddbac5f37$var$WhitespaceControl.prototype.PartialBlockStatement = function(block) {
    this.accept(block.program);
    this.accept(block.inverse);
    // Find the inverse program that is involed with whitespace stripping.
    var program = block.program || block.inverse, inverse = block.program && block.inverse, firstInverse = inverse, lastInverse = inverse;
    if (inverse && inverse.chained) {
        firstInverse = inverse.body[0].program;
        // Walk the inverse chain to find the last inverse that is actually in the chain.
        while(lastInverse.chained)lastInverse = lastInverse.body[lastInverse.body.length - 1].program;
    }
    var strip = {
        open: block.openStrip.open,
        close: block.closeStrip.close,
        // Determine the standalone candiacy. Basically flag our content as being possibly standalone
        // so our parent can determine if we actually are standalone
        openStandalone: $dcf6a5cddbac5f37$var$isNextWhitespace(program.body),
        closeStandalone: $dcf6a5cddbac5f37$var$isPrevWhitespace((firstInverse || program).body)
    };
    if (block.openStrip.close) $dcf6a5cddbac5f37$var$omitRight(program.body, null, true);
    if (inverse) {
        var inverseStrip = block.inverseStrip;
        if (inverseStrip.open) $dcf6a5cddbac5f37$var$omitLeft(program.body, null, true);
        if (inverseStrip.close) $dcf6a5cddbac5f37$var$omitRight(firstInverse.body, null, true);
        if (block.closeStrip.open) $dcf6a5cddbac5f37$var$omitLeft(lastInverse.body, null, true);
        // Find standalone else statments
        if (!this.options.ignoreStandalone && $dcf6a5cddbac5f37$var$isPrevWhitespace(program.body) && $dcf6a5cddbac5f37$var$isNextWhitespace(firstInverse.body)) {
            $dcf6a5cddbac5f37$var$omitLeft(program.body);
            $dcf6a5cddbac5f37$var$omitRight(firstInverse.body);
        }
    } else if (block.closeStrip.open) $dcf6a5cddbac5f37$var$omitLeft(program.body, null, true);
    return strip;
};
$dcf6a5cddbac5f37$var$WhitespaceControl.prototype.Decorator = $dcf6a5cddbac5f37$var$WhitespaceControl.prototype.MustacheStatement = function(mustache) {
    return mustache.strip;
};
$dcf6a5cddbac5f37$var$WhitespaceControl.prototype.PartialStatement = $dcf6a5cddbac5f37$var$WhitespaceControl.prototype.CommentStatement = function(node) {
    /* istanbul ignore next */ var strip = node.strip || {};
    return {
        inlineStandalone: true,
        open: strip.open,
        close: strip.close
    };
};
function $dcf6a5cddbac5f37$var$isPrevWhitespace(body, i, isRoot) {
    if (i === undefined) i = body.length;
    // Nodes that end with newlines are considered whitespace (but are special
    // cased for strip operations)
    var prev = body[i - 1], sibling = body[i - 2];
    if (!prev) return isRoot;
    if (prev.type === 'ContentStatement') return (sibling || !isRoot ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(prev.original);
}
function $dcf6a5cddbac5f37$var$isNextWhitespace(body, i, isRoot) {
    if (i === undefined) i = -1;
    var next = body[i + 1], sibling = body[i + 2];
    if (!next) return isRoot;
    if (next.type === 'ContentStatement') return (sibling || !isRoot ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(next.original);
}
// Marks the node to the right of the position as omitted.
// I.e. {{foo}}' ' will mark the ' ' node as omitted.
//
// If i is undefined, then the first child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $dcf6a5cddbac5f37$var$omitRight(body, i, multiple) {
    var current = body[i == null ? 0 : i + 1];
    if (!current || current.type !== 'ContentStatement' || !multiple && current.rightStripped) return;
    var original = current.value;
    current.value = current.value.replace(multiple ? /^\s+/ : /^[ \t]*\r?\n?/, '');
    current.rightStripped = current.value !== original;
}
// Marks the node to the left of the position as omitted.
// I.e. ' '{{foo}} will mark the ' ' node as omitted.
//
// If i is undefined then the last child will be marked as such.
//
// If mulitple is truthy then all whitespace will be stripped out until non-whitespace
// content is met.
function $dcf6a5cddbac5f37$var$omitLeft(body, i, multiple) {
    var current = body[i == null ? body.length - 1 : i - 1];
    if (!current || current.type !== 'ContentStatement' || !multiple && current.leftStripped) return;
    // We omit the last node if it's whitespace only and not preceded by a non-content node.
    var original = current.value;
    current.value = current.value.replace(multiple ? /\s+$/ : /[ \t]+$/, '');
    current.leftStripped = current.value !== original;
    return current.leftStripped;
}
$dcf6a5cddbac5f37$exports['default'] = $dcf6a5cddbac5f37$var$WhitespaceControl;
$dcf6a5cddbac5f37$exports = $dcf6a5cddbac5f37$exports['default'];


var $dc49e6b2606b0f90$var$_whitespaceControl2 = $dc49e6b2606b0f90$var$_interopRequireDefault($dcf6a5cddbac5f37$exports);
var $09761553d5a1f646$exports = {};

$parcel$export($09761553d5a1f646$exports, "__esModule", () => $09761553d5a1f646$export$1e511d4a378977f5, (v) => $09761553d5a1f646$export$1e511d4a378977f5 = v);
$parcel$export($09761553d5a1f646$exports, "SourceLocation", () => $09761553d5a1f646$export$7387db7caf96fcdb, (v) => $09761553d5a1f646$export$7387db7caf96fcdb = v);
$parcel$export($09761553d5a1f646$exports, "id", () => $09761553d5a1f646$export$d560c7e4a29451c2, (v) => $09761553d5a1f646$export$d560c7e4a29451c2 = v);
$parcel$export($09761553d5a1f646$exports, "stripFlags", () => $09761553d5a1f646$export$a56883f706fd4153, (v) => $09761553d5a1f646$export$a56883f706fd4153 = v);
$parcel$export($09761553d5a1f646$exports, "stripComment", () => $09761553d5a1f646$export$b0ad15fcf54729ff, (v) => $09761553d5a1f646$export$b0ad15fcf54729ff = v);
$parcel$export($09761553d5a1f646$exports, "preparePath", () => $09761553d5a1f646$export$ea68d0dfa0ba072f, (v) => $09761553d5a1f646$export$ea68d0dfa0ba072f = v);
$parcel$export($09761553d5a1f646$exports, "prepareMustache", () => $09761553d5a1f646$export$6b8089a1dfd22498, (v) => $09761553d5a1f646$export$6b8089a1dfd22498 = v);
$parcel$export($09761553d5a1f646$exports, "prepareRawBlock", () => $09761553d5a1f646$export$c642052fcb02035b, (v) => $09761553d5a1f646$export$c642052fcb02035b = v);
$parcel$export($09761553d5a1f646$exports, "prepareBlock", () => $09761553d5a1f646$export$9814855d713f4497, (v) => $09761553d5a1f646$export$9814855d713f4497 = v);
$parcel$export($09761553d5a1f646$exports, "prepareProgram", () => $09761553d5a1f646$export$6e1c63ef90231a66, (v) => $09761553d5a1f646$export$6e1c63ef90231a66 = v);
$parcel$export($09761553d5a1f646$exports, "preparePartialBlock", () => $09761553d5a1f646$export$8b47bc71272f067a, (v) => $09761553d5a1f646$export$8b47bc71272f067a = v);
var $09761553d5a1f646$export$1e511d4a378977f5;
var $09761553d5a1f646$export$7387db7caf96fcdb;
var $09761553d5a1f646$export$d560c7e4a29451c2;
var $09761553d5a1f646$export$a56883f706fd4153;
var $09761553d5a1f646$export$b0ad15fcf54729ff;
var $09761553d5a1f646$export$ea68d0dfa0ba072f;
var $09761553d5a1f646$export$6b8089a1dfd22498;
var $09761553d5a1f646$export$c642052fcb02035b;
var $09761553d5a1f646$export$9814855d713f4497;
var $09761553d5a1f646$export$6e1c63ef90231a66;
var $09761553d5a1f646$export$8b47bc71272f067a;
'use strict';
$09761553d5a1f646$export$1e511d4a378977f5 = true;
$09761553d5a1f646$export$7387db7caf96fcdb = $09761553d5a1f646$var$SourceLocation;
$09761553d5a1f646$export$d560c7e4a29451c2 = $09761553d5a1f646$var$id;
$09761553d5a1f646$export$a56883f706fd4153 = $09761553d5a1f646$var$stripFlags;
$09761553d5a1f646$export$b0ad15fcf54729ff = $09761553d5a1f646$var$stripComment;
$09761553d5a1f646$export$ea68d0dfa0ba072f = $09761553d5a1f646$var$preparePath;
$09761553d5a1f646$export$6b8089a1dfd22498 = $09761553d5a1f646$var$prepareMustache;
$09761553d5a1f646$export$c642052fcb02035b = $09761553d5a1f646$var$prepareRawBlock;
$09761553d5a1f646$export$9814855d713f4497 = $09761553d5a1f646$var$prepareBlock;
$09761553d5a1f646$export$6e1c63ef90231a66 = $09761553d5a1f646$var$prepareProgram;
$09761553d5a1f646$export$8b47bc71272f067a = $09761553d5a1f646$var$preparePartialBlock;
// istanbul ignore next
function $09761553d5a1f646$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $09761553d5a1f646$var$_exception2 = $09761553d5a1f646$var$_interopRequireDefault($f9e5592ce830a697$exports);
function $09761553d5a1f646$var$validateClose(open, close) {
    close = close.path ? close.path.original : close;
    if (open.path.original !== close) {
        var errorNode = {
            loc: open.path.loc
        };
        throw new $09761553d5a1f646$var$_exception2['default'](open.path.original + " doesn't match " + close, errorNode);
    }
}
function $09761553d5a1f646$var$SourceLocation(source, locInfo) {
    this.source = source;
    this.start = {
        line: locInfo.first_line,
        column: locInfo.first_column
    };
    this.end = {
        line: locInfo.last_line,
        column: locInfo.last_column
    };
}
function $09761553d5a1f646$var$id(token) {
    if (/^\[.*\]$/.test(token)) return token.substring(1, token.length - 1);
    else return token;
}
function $09761553d5a1f646$var$stripFlags(open, close) {
    return {
        open: open.charAt(2) === '~',
        close: close.charAt(close.length - 3) === '~'
    };
}
function $09761553d5a1f646$var$stripComment(comment) {
    return comment.replace(/^\{\{~?!-?-?/, '').replace(/-?-?~?\}\}$/, '');
}
function $09761553d5a1f646$var$preparePath(data, parts, loc) {
    loc = this.locInfo(loc);
    var original = data ? '@' : '', dig = [], depth = 0;
    for(var i = 0, l = parts.length; i < l; i++){
        var part = parts[i].part, // If we have [] syntax then we do not treat path references as operators,
        // i.e. foo.[this] resolves to approximately context.foo['this']
        isLiteral = parts[i].original !== part;
        original += (parts[i].separator || '') + part;
        if (!isLiteral && (part === '..' || part === '.' || part === 'this')) {
            if (dig.length > 0) throw new $09761553d5a1f646$var$_exception2['default']('Invalid path: ' + original, {
                loc: loc
            });
            else if (part === '..') depth++;
        } else dig.push(part);
    }
    return {
        type: 'PathExpression',
        data: data,
        depth: depth,
        parts: dig,
        original: original,
        loc: loc
    };
}
function $09761553d5a1f646$var$prepareMustache(path, params, hash, open, strip, locInfo) {
    // Must use charAt to support IE pre-10
    var escapeFlag = open.charAt(3) || open.charAt(2), escaped = escapeFlag !== '{' && escapeFlag !== '&';
    var decorator = /\*/.test(open);
    return {
        type: decorator ? 'Decorator' : 'MustacheStatement',
        path: path,
        params: params,
        hash: hash,
        escaped: escaped,
        strip: strip,
        loc: this.locInfo(locInfo)
    };
}
function $09761553d5a1f646$var$prepareRawBlock(openRawBlock, contents, close, locInfo) {
    $09761553d5a1f646$var$validateClose(openRawBlock, close);
    locInfo = this.locInfo(locInfo);
    var program = {
        type: 'Program',
        body: contents,
        strip: {},
        loc: locInfo
    };
    return {
        type: 'BlockStatement',
        path: openRawBlock.path,
        params: openRawBlock.params,
        hash: openRawBlock.hash,
        program: program,
        openStrip: {},
        inverseStrip: {},
        closeStrip: {},
        loc: locInfo
    };
}
function $09761553d5a1f646$var$prepareBlock(openBlock, program, inverseAndProgram, close, inverted, locInfo) {
    if (close && close.path) $09761553d5a1f646$var$validateClose(openBlock, close);
    var decorator = /\*/.test(openBlock.open);
    program.blockParams = openBlock.blockParams;
    var inverse = undefined, inverseStrip = undefined;
    if (inverseAndProgram) {
        if (decorator) throw new $09761553d5a1f646$var$_exception2['default']('Unexpected inverse block on decorator', inverseAndProgram);
        if (inverseAndProgram.chain) inverseAndProgram.program.body[0].closeStrip = close.strip;
        inverseStrip = inverseAndProgram.strip;
        inverse = inverseAndProgram.program;
    }
    if (inverted) {
        inverted = inverse;
        inverse = program;
        program = inverted;
    }
    return {
        type: decorator ? 'DecoratorBlock' : 'BlockStatement',
        path: openBlock.path,
        params: openBlock.params,
        hash: openBlock.hash,
        program: program,
        inverse: inverse,
        openStrip: openBlock.strip,
        inverseStrip: inverseStrip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}
function $09761553d5a1f646$var$prepareProgram(statements, loc) {
    if (!loc && statements.length) {
        var firstLoc = statements[0].loc, lastLoc = statements[statements.length - 1].loc;
        /* istanbul ignore else */ if (firstLoc && lastLoc) loc = {
            source: firstLoc.source,
            start: {
                line: firstLoc.start.line,
                column: firstLoc.start.column
            },
            end: {
                line: lastLoc.end.line,
                column: lastLoc.end.column
            }
        };
    }
    return {
        type: 'Program',
        body: statements,
        strip: {},
        loc: loc
    };
}
function $09761553d5a1f646$var$preparePartialBlock(open, program, close, locInfo) {
    $09761553d5a1f646$var$validateClose(open, close);
    return {
        type: 'PartialBlockStatement',
        name: open.path,
        params: open.params,
        hash: open.hash,
        program: program,
        openStrip: open.strip,
        closeStrip: close && close.strip,
        loc: this.locInfo(locInfo)
    };
}


var $dc49e6b2606b0f90$var$Helpers = $dc49e6b2606b0f90$var$_interopRequireWildcard($09761553d5a1f646$exports);

$dc49e6b2606b0f90$export$8f49e4af10703ce3 = $dc49e6b2606b0f90$var$_parser2['default'];
var $dc49e6b2606b0f90$var$yy = {};
$9acd23bffb9df834$export$8b58be045bf06082($dc49e6b2606b0f90$var$yy, $dc49e6b2606b0f90$var$Helpers);
function $dc49e6b2606b0f90$var$parseWithoutProcessing(input, options) {
    // Just return if an already-compiled AST was passed in.
    if (input.type === 'Program') return input;
    $dc49e6b2606b0f90$var$_parser2['default'].yy = $dc49e6b2606b0f90$var$yy;
    // Altering the shared object here, but this is ok as parser is a sync operation
    $dc49e6b2606b0f90$var$yy.locInfo = function(locInfo) {
        return new $dc49e6b2606b0f90$var$yy.SourceLocation(options && options.srcName, locInfo);
    };
    var ast = $dc49e6b2606b0f90$var$_parser2['default'].parse(input);
    return ast;
}
function $dc49e6b2606b0f90$var$parse(input, options) {
    var ast = $dc49e6b2606b0f90$var$parseWithoutProcessing(input, options);
    var strip = new $dc49e6b2606b0f90$var$_whitespaceControl2['default'](options);
    return strip.accept(ast);
}


/* eslint-disable new-cap */ var $7080109da79cd625$export$1e511d4a378977f5;
var $7080109da79cd625$export$3a6335acfcf707c9;
var $7080109da79cd625$export$cfb9e0f1330f9bbd;
var $7080109da79cd625$export$ef7acd7185315e22;
'use strict';
$7080109da79cd625$export$1e511d4a378977f5 = true;
$7080109da79cd625$export$3a6335acfcf707c9 = $7080109da79cd625$var$Compiler;
$7080109da79cd625$export$cfb9e0f1330f9bbd = $7080109da79cd625$var$precompile;
$7080109da79cd625$export$ef7acd7185315e22 = $7080109da79cd625$var$compile;
// istanbul ignore next
function $7080109da79cd625$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $7080109da79cd625$var$_exception2 = $7080109da79cd625$var$_interopRequireDefault($f9e5592ce830a697$exports);


var $7080109da79cd625$var$_ast2 = $7080109da79cd625$var$_interopRequireDefault($1b8bcd285ab58e50$exports);
var $7080109da79cd625$var$slice = [].slice;
function $7080109da79cd625$var$Compiler() {}
// the foundHelper register will disambiguate helper lookup from finding a
// function in a context. This is necessary for mustache compatibility, which
// requires that context functions in blocks are evaluated by blockHelperMissing,
// and then proceed as if the resulting value was provided to blockHelperMissing.
$7080109da79cd625$var$Compiler.prototype = {
    compiler: $7080109da79cd625$var$Compiler,
    equals: function equals(other) {
        var len = this.opcodes.length;
        if (other.opcodes.length !== len) return false;
        for(var i = 0; i < len; i++){
            var opcode = this.opcodes[i], otherOpcode = other.opcodes[i];
            if (opcode.opcode !== otherOpcode.opcode || !$7080109da79cd625$var$argEquals(opcode.args, otherOpcode.args)) return false;
        }
        // We know that length is the same between the two arrays because they are directly tied
        // to the opcode behavior above.
        len = this.children.length;
        for(var i = 0; i < len; i++){
            if (!this.children[i].equals(other.children[i])) return false;
        }
        return true;
    },
    guid: 0,
    compile: function compile(program, options) {
        this.sourceNode = [];
        this.opcodes = [];
        this.children = [];
        this.options = options;
        this.stringParams = options.stringParams;
        this.trackIds = options.trackIds;
        options.blockParams = options.blockParams || [];
        options.knownHelpers = $9acd23bffb9df834$export$8b58be045bf06082(Object.create(null), {
            helperMissing: true,
            blockHelperMissing: true,
            each: true,
            'if': true,
            unless: true,
            'with': true,
            log: true,
            lookup: true
        }, options.knownHelpers);
        return this.accept(program);
    },
    compileProgram: function compileProgram(program) {
        var childCompiler = new this.compiler(), // eslint-disable-line new-cap
        result = childCompiler.compile(program, this.options), guid = this.guid++;
        this.usePartial = this.usePartial || result.usePartial;
        this.children[guid] = result;
        this.useDepths = this.useDepths || result.useDepths;
        return guid;
    },
    accept: function accept(node) {
        /* istanbul ignore next: Sanity code */ if (!this[node.type]) throw new $7080109da79cd625$var$_exception2['default']('Unknown type: ' + node.type, node);
        this.sourceNode.unshift(node);
        var ret = this[node.type](node);
        this.sourceNode.shift();
        return ret;
    },
    Program: function Program(program) {
        this.options.blockParams.unshift(program.blockParams);
        var body = program.body, bodyLength = body.length;
        for(var i = 0; i < bodyLength; i++)this.accept(body[i]);
        this.options.blockParams.shift();
        this.isSimple = bodyLength === 1;
        this.blockParams = program.blockParams ? program.blockParams.length : 0;
        return this;
    },
    BlockStatement: function BlockStatement(block) {
        $7080109da79cd625$var$transformLiteralToPath(block);
        var program = block.program, inverse = block.inverse;
        program = program && this.compileProgram(program);
        inverse = inverse && this.compileProgram(inverse);
        var type = this.classifySexpr(block);
        if (type === 'helper') this.helperSexpr(block, program, inverse);
        else if (type === 'simple') {
            this.simpleSexpr(block);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode('pushProgram', program);
            this.opcode('pushProgram', inverse);
            this.opcode('emptyHash');
            this.opcode('blockValue', block.path.original);
        } else {
            this.ambiguousSexpr(block, program, inverse);
            // now that the simple mustache is resolved, we need to
            // evaluate it by executing `blockHelperMissing`
            this.opcode('pushProgram', program);
            this.opcode('pushProgram', inverse);
            this.opcode('emptyHash');
            this.opcode('ambiguousBlockValue');
        }
        this.opcode('append');
    },
    DecoratorBlock: function DecoratorBlock(decorator) {
        var program = decorator.program && this.compileProgram(decorator.program);
        var params = this.setupFullMustacheParams(decorator, program, undefined), path = decorator.path;
        this.useDecorators = true;
        this.opcode('registerDecorator', params.length, path.original);
    },
    PartialStatement: function PartialStatement(partial) {
        this.usePartial = true;
        var program = partial.program;
        if (program) program = this.compileProgram(partial.program);
        var params = partial.params;
        if (params.length > 1) throw new $7080109da79cd625$var$_exception2['default']('Unsupported number of partial arguments: ' + params.length, partial);
        else if (!params.length) {
            if (this.options.explicitPartialContext) this.opcode('pushLiteral', 'undefined');
            else params.push({
                type: 'PathExpression',
                parts: [],
                depth: 0
            });
        }
        var partialName = partial.name.original, isDynamic = partial.name.type === 'SubExpression';
        if (isDynamic) this.accept(partial.name);
        this.setupFullMustacheParams(partial, program, undefined, true);
        var indent = partial.indent || '';
        if (this.options.preventIndent && indent) {
            this.opcode('appendContent', indent);
            indent = '';
        }
        this.opcode('invokePartial', isDynamic, partialName, indent);
        this.opcode('append');
    },
    PartialBlockStatement: function PartialBlockStatement(partialBlock) {
        this.PartialStatement(partialBlock);
    },
    MustacheStatement: function MustacheStatement(mustache) {
        this.SubExpression(mustache);
        if (mustache.escaped && !this.options.noEscape) this.opcode('appendEscaped');
        else this.opcode('append');
    },
    Decorator: function Decorator(decorator) {
        this.DecoratorBlock(decorator);
    },
    ContentStatement: function ContentStatement(content) {
        if (content.value) this.opcode('appendContent', content.value);
    },
    CommentStatement: function CommentStatement() {},
    SubExpression: function SubExpression(sexpr) {
        $7080109da79cd625$var$transformLiteralToPath(sexpr);
        var type = this.classifySexpr(sexpr);
        if (type === 'simple') this.simpleSexpr(sexpr);
        else if (type === 'helper') this.helperSexpr(sexpr);
        else this.ambiguousSexpr(sexpr);
    },
    ambiguousSexpr: function ambiguousSexpr(sexpr, program, inverse) {
        var path = sexpr.path, name = path.parts[0], isBlock = program != null || inverse != null;
        this.opcode('getContext', path.depth);
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        path.strict = true;
        this.accept(path);
        this.opcode('invokeAmbiguous', name, isBlock);
    },
    simpleSexpr: function simpleSexpr(sexpr) {
        var path = sexpr.path;
        path.strict = true;
        this.accept(path);
        this.opcode('resolvePossibleLambda');
    },
    helperSexpr: function helperSexpr(sexpr, program, inverse) {
        var params = this.setupFullMustacheParams(sexpr, program, inverse), path = sexpr.path, name = path.parts[0];
        if (this.options.knownHelpers[name]) this.opcode('invokeKnownHelper', params.length, name);
        else if (this.options.knownHelpersOnly) throw new $7080109da79cd625$var$_exception2['default']('You specified knownHelpersOnly, but used the unknown helper ' + name, sexpr);
        else {
            path.strict = true;
            path.falsy = true;
            this.accept(path);
            this.opcode('invokeHelper', params.length, path.original, $7080109da79cd625$var$_ast2['default'].helpers.simpleId(path));
        }
    },
    PathExpression: function PathExpression(path) {
        this.addDepth(path.depth);
        this.opcode('getContext', path.depth);
        var name = path.parts[0], scoped = $7080109da79cd625$var$_ast2['default'].helpers.scopedId(path), blockParamId = !path.depth && !scoped && this.blockParamIndex(name);
        if (blockParamId) this.opcode('lookupBlockParam', blockParamId, path.parts);
        else if (!name) // Context reference, i.e. `{{foo .}}` or `{{foo ..}}`
        this.opcode('pushContext');
        else if (path.data) {
            this.options.data = true;
            this.opcode('lookupData', path.depth, path.parts, path.strict);
        } else this.opcode('lookupOnContext', path.parts, path.falsy, path.strict, scoped);
    },
    StringLiteral: function StringLiteral(string) {
        this.opcode('pushString', string.value);
    },
    NumberLiteral: function NumberLiteral(number) {
        this.opcode('pushLiteral', number.value);
    },
    BooleanLiteral: function BooleanLiteral(bool) {
        this.opcode('pushLiteral', bool.value);
    },
    UndefinedLiteral: function UndefinedLiteral() {
        this.opcode('pushLiteral', 'undefined');
    },
    NullLiteral: function NullLiteral() {
        this.opcode('pushLiteral', 'null');
    },
    Hash: function Hash(hash) {
        var pairs = hash.pairs, i = 0, l = pairs.length;
        this.opcode('pushHash');
        for(; i < l; i++)this.pushParam(pairs[i].value);
        while(i--)this.opcode('assignToHash', pairs[i].key);
        this.opcode('popHash');
    },
    // HELPERS
    opcode: function opcode(name) {
        this.opcodes.push({
            opcode: name,
            args: $7080109da79cd625$var$slice.call(arguments, 1),
            loc: this.sourceNode[0].loc
        });
    },
    addDepth: function addDepth(depth) {
        if (!depth) return;
        this.useDepths = true;
    },
    classifySexpr: function classifySexpr(sexpr) {
        var isSimple = $7080109da79cd625$var$_ast2['default'].helpers.simpleId(sexpr.path);
        var isBlockParam = isSimple && !!this.blockParamIndex(sexpr.path.parts[0]);
        // a mustache is an eligible helper if:
        // * its id is simple (a single part, not `this` or `..`)
        var isHelper = !isBlockParam && $7080109da79cd625$var$_ast2['default'].helpers.helperExpression(sexpr);
        // if a mustache is an eligible helper but not a definite
        // helper, it is ambiguous, and will be resolved in a later
        // pass or at runtime.
        var isEligible = !isBlockParam && (isHelper || isSimple);
        // if ambiguous, we can possibly resolve the ambiguity now
        // An eligible helper is one that does not have a complex path, i.e. `this.foo`, `../foo` etc.
        if (isEligible && !isHelper) {
            var _name = sexpr.path.parts[0], options = this.options;
            if (options.knownHelpers[_name]) isHelper = true;
            else if (options.knownHelpersOnly) isEligible = false;
        }
        if (isHelper) return 'helper';
        else if (isEligible) return 'ambiguous';
        else return 'simple';
    },
    pushParams: function pushParams(params) {
        for(var i = 0, l = params.length; i < l; i++)this.pushParam(params[i]);
    },
    pushParam: function pushParam(val) {
        var value = val.value != null ? val.value : val.original || '';
        if (this.stringParams) {
            if (value.replace) value = value.replace(/^(\.?\.\/)*/g, '').replace(/\//g, '.');
            if (val.depth) this.addDepth(val.depth);
            this.opcode('getContext', val.depth || 0);
            this.opcode('pushStringParam', value, val.type);
            if (val.type === 'SubExpression') // SubExpressions get evaluated and passed in
            // in string params mode.
            this.accept(val);
        } else {
            if (this.trackIds) {
                var blockParamIndex = undefined;
                if (val.parts && !$7080109da79cd625$var$_ast2['default'].helpers.scopedId(val) && !val.depth) blockParamIndex = this.blockParamIndex(val.parts[0]);
                if (blockParamIndex) {
                    var blockParamChild = val.parts.slice(1).join('.');
                    this.opcode('pushId', 'BlockParam', blockParamIndex, blockParamChild);
                } else {
                    value = val.original || value;
                    if (value.replace) value = value.replace(/^this(?:\.|$)/, '').replace(/^\.\//, '').replace(/^\.$/, '');
                    this.opcode('pushId', val.type, value);
                }
            }
            this.accept(val);
        }
    },
    setupFullMustacheParams: function setupFullMustacheParams(sexpr, program, inverse, omitEmpty) {
        var params = sexpr.params;
        this.pushParams(params);
        this.opcode('pushProgram', program);
        this.opcode('pushProgram', inverse);
        if (sexpr.hash) this.accept(sexpr.hash);
        else this.opcode('emptyHash', omitEmpty);
        return params;
    },
    blockParamIndex: function blockParamIndex(name) {
        for(var depth = 0, len = this.options.blockParams.length; depth < len; depth++){
            var blockParams = this.options.blockParams[depth], param = blockParams && $9acd23bffb9df834$export$305f7d4e9d4624f2(blockParams, name);
            if (blockParams && param >= 0) return [
                depth,
                param
            ];
        }
    }
};
function $7080109da79cd625$var$precompile(input, options, env) {
    if (input == null || typeof input !== 'string' && input.type !== 'Program') throw new $7080109da79cd625$var$_exception2['default']('You must pass a string or Handlebars AST to Handlebars.precompile. You passed ' + input);
    options = options || {};
    if (!('data' in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options);
    return new env.JavaScriptCompiler().compile(environment, options);
}
function $7080109da79cd625$var$compile(input, options, env) {
    if (options === undefined) options = {};
    if (input == null || typeof input !== 'string' && input.type !== 'Program') throw new $7080109da79cd625$var$_exception2['default']('You must pass a string or Handlebars AST to Handlebars.compile. You passed ' + input);
    options = $9acd23bffb9df834$export$8b58be045bf06082({}, options);
    if (!('data' in options)) options.data = true;
    if (options.compat) options.useDepths = true;
    var compiled = undefined;
    function compileInput() {
        var ast = env.parse(input, options), environment = new env.Compiler().compile(ast, options), templateSpec = new env.JavaScriptCompiler().compile(environment, options, undefined, true);
        return env.template(templateSpec);
    }
    // Template is only compiled on first use and cached after that point.
    function ret(context, execOptions) {
        if (!compiled) compiled = compileInput();
        return compiled.call(this, context, execOptions);
    }
    ret._setup = function(setupOptions) {
        if (!compiled) compiled = compileInput();
        return compiled._setup(setupOptions);
    };
    ret._child = function(i, data, blockParams, depths) {
        if (!compiled) compiled = compileInput();
        return compiled._child(i, data, blockParams, depths);
    };
    return ret;
}
function $7080109da79cd625$var$argEquals(a, b) {
    if (a === b) return true;
    if ($9acd23bffb9df834$export$43bee75e5e14138e(a) && $9acd23bffb9df834$export$43bee75e5e14138e(b) && a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (!$7080109da79cd625$var$argEquals(a[i], b[i])) return false;
        }
        return true;
    }
}
function $7080109da79cd625$var$transformLiteralToPath(sexpr) {
    if (!sexpr.path.parts) {
        var literal = sexpr.path;
        // Casting to string here to make false and 0 literal values play nicely with the rest
        // of the system.
        sexpr.path = {
            type: 'PathExpression',
            data: false,
            depth: 0,
            parts: [
                literal.original + ''
            ],
            original: literal.original + '',
            loc: literal.loc
        };
    }
}


var $4191254efacb0122$exports = {};
'use strict';
$4191254efacb0122$exports.__esModule = true;
// istanbul ignore next
function $4191254efacb0122$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}


var $4191254efacb0122$var$_exception2 = $4191254efacb0122$var$_interopRequireDefault($f9e5592ce830a697$exports);

var $6f3e6e5bf303bde5$exports = {};
/* global define, require */ 'use strict';
$6f3e6e5bf303bde5$exports.__esModule = true;

var $6f3e6e5bf303bde5$var$SourceNode = undefined;

try {
    /* istanbul ignore next */ if (typeof define !== 'function' || !define.amd) {
        // We don't support this in AMD environments. For these environments, we assume that
        // they are running on the browser and thus have no need for the source-map library.
        var $6f3e6e5bf303bde5$var$SourceMap = (parcelRequire("dF3Ou"));
        $6f3e6e5bf303bde5$var$SourceNode = $6f3e6e5bf303bde5$var$SourceMap.SourceNode;
    }
} catch (err) {}
/* NOP */ /* istanbul ignore if: tested but not covered in istanbul due to dist build  */ if (!$6f3e6e5bf303bde5$var$SourceNode) {
    $6f3e6e5bf303bde5$var$SourceNode = function(line, column, srcFile, chunks) {
        this.src = '';
        if (chunks) this.add(chunks);
    };
    /* istanbul ignore next */ $6f3e6e5bf303bde5$var$SourceNode.prototype = {
        add: function add(chunks) {
            if ($9acd23bffb9df834$export$43bee75e5e14138e(chunks)) chunks = chunks.join('');
            this.src += chunks;
        },
        prepend: function prepend(chunks) {
            if ($9acd23bffb9df834$export$43bee75e5e14138e(chunks)) chunks = chunks.join('');
            this.src = chunks + this.src;
        },
        toStringWithSourceMap: function toStringWithSourceMap() {
            return {
                code: this.toString()
            };
        },
        toString: function toString() {
            return this.src;
        }
    };
}
function $6f3e6e5bf303bde5$var$castChunk(chunk, codeGen, loc) {
    if ($9acd23bffb9df834$export$43bee75e5e14138e(chunk)) {
        var ret = [];
        for(var i = 0, len = chunk.length; i < len; i++)ret.push(codeGen.wrap(chunk[i], loc));
        return ret;
    } else if (typeof chunk === 'boolean' || typeof chunk === 'number') // Handle primitives that the SourceNode will throw up on
    return chunk + '';
    return chunk;
}
function $6f3e6e5bf303bde5$var$CodeGen(srcFile) {
    this.srcFile = srcFile;
    this.source = [];
}
$6f3e6e5bf303bde5$var$CodeGen.prototype = {
    isEmpty: function isEmpty() {
        return !this.source.length;
    },
    prepend: function prepend(source, loc) {
        this.source.unshift(this.wrap(source, loc));
    },
    push: function push(source, loc) {
        this.source.push(this.wrap(source, loc));
    },
    merge: function merge() {
        var source = this.empty();
        this.each(function(line) {
            source.add([
                '  ',
                line,
                '\n'
            ]);
        });
        return source;
    },
    each: function each(iter) {
        for(var i = 0, len = this.source.length; i < len; i++)iter(this.source[i]);
    },
    empty: function empty() {
        var loc = this.currentLocation || {
            start: {}
        };
        return new $6f3e6e5bf303bde5$var$SourceNode(loc.start.line, loc.start.column, this.srcFile);
    },
    wrap: function wrap(chunk) {
        var loc = arguments.length <= 1 || arguments[1] === undefined ? this.currentLocation || {
            start: {}
        } : arguments[1];
        if (chunk instanceof $6f3e6e5bf303bde5$var$SourceNode) return chunk;
        chunk = $6f3e6e5bf303bde5$var$castChunk(chunk, this, loc);
        return new $6f3e6e5bf303bde5$var$SourceNode(loc.start.line, loc.start.column, this.srcFile, chunk);
    },
    functionCall: function functionCall(fn, type, params) {
        params = this.generateList(params);
        return this.wrap([
            fn,
            type ? '.' + type + '(' : '(',
            params,
            ')'
        ]);
    },
    quotedString: function quotedString(str) {
        return '"' + (str + '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\u2028/g, '\\u2028') // Per Ecma-262 7.3 + 7.8.4
        .replace(/\u2029/g, '\\u2029') + '"';
    },
    objectLiteral: function objectLiteral(obj) {
        // istanbul ignore next
        var _this = this;
        var pairs = [];
        Object.keys(obj).forEach(function(key) {
            var value = $6f3e6e5bf303bde5$var$castChunk(obj[key], _this);
            if (value !== 'undefined') pairs.push([
                _this.quotedString(key),
                ':',
                value
            ]);
        });
        var ret = this.generateList(pairs);
        ret.prepend('{');
        ret.add('}');
        return ret;
    },
    generateList: function generateList(entries) {
        var ret = this.empty();
        for(var i = 0, len = entries.length; i < len; i++){
            if (i) ret.add(',');
            ret.add($6f3e6e5bf303bde5$var$castChunk(entries[i], this));
        }
        return ret;
    },
    generateArray: function generateArray(entries) {
        var ret = this.generateList(entries);
        ret.prepend('[');
        ret.add(']');
        return ret;
    }
};
$6f3e6e5bf303bde5$exports['default'] = $6f3e6e5bf303bde5$var$CodeGen;
$6f3e6e5bf303bde5$exports = $6f3e6e5bf303bde5$exports['default'];


var $4191254efacb0122$var$_codeGen2 = $4191254efacb0122$var$_interopRequireDefault($6f3e6e5bf303bde5$exports);
function $4191254efacb0122$var$Literal(value) {
    this.value = value;
}
function $4191254efacb0122$var$JavaScriptCompiler() {}
$4191254efacb0122$var$JavaScriptCompiler.prototype = {
    // PUBLIC API: You can override these methods in a subclass to provide
    // alternative compiled forms for name lookup and buffering semantics
    nameLookup: function nameLookup(parent, name /*,  type */ ) {
        return this.internalNameLookup(parent, name);
    },
    depthedLookup: function depthedLookup(name) {
        return [
            this.aliasable('container.lookup'),
            '(depths, ',
            JSON.stringify(name),
            ')'
        ];
    },
    compilerInfo: function compilerInfo() {
        var revision = $89c07e0277708a16$export$682db5a6f2fa1046, versions = $89c07e0277708a16$export$534648964353ca81[revision];
        return [
            revision,
            versions
        ];
    },
    appendToBuffer: function appendToBuffer(source, location, explicit) {
        // Force a source as this simplifies the merge logic.
        if (!$9acd23bffb9df834$export$43bee75e5e14138e(source)) source = [
            source
        ];
        source = this.source.wrap(source, location);
        if (this.environment.isSimple) return [
            'return ',
            source,
            ';'
        ];
        else if (explicit) // This is a case where the buffer operation occurs as a child of another
        // construct, generally braces. We have to explicitly output these buffer
        // operations to ensure that the emitted code goes in the correct location.
        return [
            'buffer += ',
            source,
            ';'
        ];
        else {
            source.appendToBuffer = true;
            return source;
        }
    },
    initializeBuffer: function initializeBuffer() {
        return this.quotedString('');
    },
    // END PUBLIC API
    internalNameLookup: function internalNameLookup(parent, name) {
        this.lookupPropertyFunctionIsUsed = true;
        return [
            'lookupProperty(',
            parent,
            ',',
            JSON.stringify(name),
            ')'
        ];
    },
    lookupPropertyFunctionIsUsed: false,
    compile: function compile(environment, options, context, asObject) {
        this.environment = environment;
        this.options = options;
        this.stringParams = this.options.stringParams;
        this.trackIds = this.options.trackIds;
        this.precompile = !asObject;
        this.name = this.environment.name;
        this.isChild = !!context;
        this.context = context || {
            decorators: [],
            programs: [],
            environments: []
        };
        this.preamble();
        this.stackSlot = 0;
        this.stackVars = [];
        this.aliases = {};
        this.registers = {
            list: []
        };
        this.hashes = [];
        this.compileStack = [];
        this.inlineStack = [];
        this.blockParams = [];
        this.compileChildren(environment, options);
        this.useDepths = this.useDepths || environment.useDepths || environment.useDecorators || this.options.compat;
        this.useBlockParams = this.useBlockParams || environment.useBlockParams;
        var opcodes = environment.opcodes, opcode = undefined, firstLoc = undefined, i = undefined, l = undefined;
        for(i = 0, l = opcodes.length; i < l; i++){
            opcode = opcodes[i];
            this.source.currentLocation = opcode.loc;
            firstLoc = firstLoc || opcode.loc;
            this[opcode.opcode].apply(this, opcode.args);
        }
        // Flush any trailing content that might be pending.
        this.source.currentLocation = firstLoc;
        this.pushSource('');
        /* istanbul ignore next */ if (this.stackSlot || this.inlineStack.length || this.compileStack.length) throw new $4191254efacb0122$var$_exception2['default']('Compile completed with content left on stack');
        if (!this.decorators.isEmpty()) {
            this.useDecorators = true;
            this.decorators.prepend([
                'var decorators = container.decorators, ',
                this.lookupPropertyFunctionVarDeclaration(),
                ';\n'
            ]);
            this.decorators.push('return fn;');
            if (asObject) this.decorators = Function.apply(this, [
                'fn',
                'props',
                'container',
                'depth0',
                'data',
                'blockParams',
                'depths',
                this.decorators.merge()
            ]);
            else {
                this.decorators.prepend('function(fn, props, container, depth0, data, blockParams, depths) {\n');
                this.decorators.push('}\n');
                this.decorators = this.decorators.merge();
            }
        } else this.decorators = undefined;
        var fn = this.createFunctionContext(asObject);
        if (!this.isChild) {
            var ret = {
                compiler: this.compilerInfo(),
                main: fn
            };
            if (this.decorators) {
                ret.main_d = this.decorators; // eslint-disable-line camelcase
                ret.useDecorators = true;
            }
            var _context = this.context;
            var programs = _context.programs;
            var decorators = _context.decorators;
            for(i = 0, l = programs.length; i < l; i++)if (programs[i]) {
                ret[i] = programs[i];
                if (decorators[i]) {
                    ret[i + '_d'] = decorators[i];
                    ret.useDecorators = true;
                }
            }
            if (this.environment.usePartial) ret.usePartial = true;
            if (this.options.data) ret.useData = true;
            if (this.useDepths) ret.useDepths = true;
            if (this.useBlockParams) ret.useBlockParams = true;
            if (this.options.compat) ret.compat = true;
            if (!asObject) {
                ret.compiler = JSON.stringify(ret.compiler);
                this.source.currentLocation = {
                    start: {
                        line: 1,
                        column: 0
                    }
                };
                ret = this.objectLiteral(ret);
                if (options.srcName) {
                    ret = ret.toStringWithSourceMap({
                        file: options.destName
                    });
                    ret.map = ret.map && ret.map.toString();
                } else ret = ret.toString();
            } else ret.compilerOptions = this.options;
            return ret;
        } else return fn;
    },
    preamble: function preamble() {
        // track the last context pushed into place to allow skipping the
        // getContext opcode when it would be a noop
        this.lastContext = 0;
        this.source = new $4191254efacb0122$var$_codeGen2['default'](this.options.srcName);
        this.decorators = new $4191254efacb0122$var$_codeGen2['default'](this.options.srcName);
    },
    createFunctionContext: function createFunctionContext(asObject) {
        // istanbul ignore next
        var _this = this;
        var varDeclarations = '';
        var locals = this.stackVars.concat(this.registers.list);
        if (locals.length > 0) varDeclarations += ', ' + locals.join(', ');
        // Generate minimizer alias mappings
        //
        // When using true SourceNodes, this will update all references to the given alias
        // as the source nodes are reused in situ. For the non-source node compilation mode,
        // aliases will not be used, but this case is already being run on the client and
        // we aren't concern about minimizing the template size.
        var aliasCount = 0;
        Object.keys(this.aliases).forEach(function(alias) {
            var node = _this.aliases[alias];
            if (node.children && node.referenceCount > 1) {
                varDeclarations += ', alias' + ++aliasCount + '=' + alias;
                node.children[0] = 'alias' + aliasCount;
            }
        });
        if (this.lookupPropertyFunctionIsUsed) varDeclarations += ', ' + this.lookupPropertyFunctionVarDeclaration();
        var params = [
            'container',
            'depth0',
            'helpers',
            'partials',
            'data'
        ];
        if (this.useBlockParams || this.useDepths) params.push('blockParams');
        if (this.useDepths) params.push('depths');
        // Perform a second pass over the output to merge content when possible
        var source = this.mergeSource(varDeclarations);
        if (asObject) {
            params.push(source);
            return Function.apply(this, params);
        } else return this.source.wrap([
            'function(',
            params.join(','),
            ') {\n  ',
            source,
            '}'
        ]);
    },
    mergeSource: function mergeSource(varDeclarations) {
        var isSimple = this.environment.isSimple, appendOnly = !this.forceBuffer, appendFirst = undefined, sourceSeen = undefined, bufferStart = undefined, bufferEnd = undefined;
        this.source.each(function(line) {
            if (line.appendToBuffer) {
                if (bufferStart) line.prepend('  + ');
                else bufferStart = line;
                bufferEnd = line;
            } else {
                if (bufferStart) {
                    if (!sourceSeen) appendFirst = true;
                    else bufferStart.prepend('buffer += ');
                    bufferEnd.add(';');
                    bufferStart = bufferEnd = undefined;
                }
                sourceSeen = true;
                if (!isSimple) appendOnly = false;
            }
        });
        if (appendOnly) {
            if (bufferStart) {
                bufferStart.prepend('return ');
                bufferEnd.add(';');
            } else if (!sourceSeen) this.source.push('return "";');
        } else {
            varDeclarations += ', buffer = ' + (appendFirst ? '' : this.initializeBuffer());
            if (bufferStart) {
                bufferStart.prepend('return buffer + ');
                bufferEnd.add(';');
            } else this.source.push('return buffer;');
        }
        if (varDeclarations) this.source.prepend('var ' + varDeclarations.substring(2) + (appendFirst ? '' : ';\n'));
        return this.source.merge();
    },
    lookupPropertyFunctionVarDeclaration: function lookupPropertyFunctionVarDeclaration() {
        return '\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    '.trim();
    },
    // [blockValue]
    //
    // On stack, before: hash, inverse, program, value
    // On stack, after: return value of blockHelperMissing
    //
    // The purpose of this opcode is to take a block of the form
    // `{{#this.foo}}...{{/this.foo}}`, resolve the value of `foo`, and
    // replace it on the stack with the result of properly
    // invoking blockHelperMissing.
    blockValue: function blockValue(name) {
        var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs(name, 0, params);
        var blockName = this.popStack();
        params.splice(1, 0, blockName);
        this.push(this.source.functionCall(blockHelperMissing, 'call', params));
    },
    // [ambiguousBlockValue]
    //
    // On stack, before: hash, inverse, program, value
    // Compiler value, before: lastHelper=value of last found helper, if any
    // On stack, after, if no lastHelper: same as [blockValue]
    // On stack, after, if lastHelper: value
    ambiguousBlockValue: function ambiguousBlockValue() {
        // We're being a bit cheeky and reusing the options value from the prior exec
        var blockHelperMissing = this.aliasable('container.hooks.blockHelperMissing'), params = [
            this.contextName(0)
        ];
        this.setupHelperArgs('', 0, params, true);
        this.flushInline();
        var current = this.topStack();
        params.splice(1, 0, current);
        this.pushSource([
            'if (!',
            this.lastHelper,
            ') { ',
            current,
            ' = ',
            this.source.functionCall(blockHelperMissing, 'call', params),
            '}'
        ]);
    },
    // [appendContent]
    //
    // On stack, before: ...
    // On stack, after: ...
    //
    // Appends the string value of `content` to the current buffer
    appendContent: function appendContent(content) {
        if (this.pendingContent) content = this.pendingContent + content;
        else this.pendingLocation = this.source.currentLocation;
        this.pendingContent = content;
    },
    // [append]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Coerces `value` to a String and appends it to the current buffer.
    //
    // If `value` is truthy, or 0, it is coerced into a string and appended
    // Otherwise, the empty string is appended
    append: function append() {
        if (this.isInline()) {
            this.replaceStack(function(current) {
                return [
                    ' != null ? ',
                    current,
                    ' : ""'
                ];
            });
            this.pushSource(this.appendToBuffer(this.popStack()));
        } else {
            var local = this.popStack();
            this.pushSource([
                'if (',
                local,
                ' != null) { ',
                this.appendToBuffer(local, undefined, true),
                ' }'
            ]);
            if (this.environment.isSimple) this.pushSource([
                'else { ',
                this.appendToBuffer("''", undefined, true),
                ' }'
            ]);
        }
    },
    // [appendEscaped]
    //
    // On stack, before: value, ...
    // On stack, after: ...
    //
    // Escape `value` and append it to the buffer
    appendEscaped: function appendEscaped() {
        this.pushSource(this.appendToBuffer([
            this.aliasable('container.escapeExpression'),
            '(',
            this.popStack(),
            ')'
        ]));
    },
    // [getContext]
    //
    // On stack, before: ...
    // On stack, after: ...
    // Compiler value, after: lastContext=depth
    //
    // Set the value of the `lastContext` compiler value to the depth
    getContext: function getContext(depth) {
        this.lastContext = depth;
    },
    // [pushContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext, ...
    //
    // Pushes the value of the current context onto the stack.
    pushContext: function pushContext() {
        this.pushStackLiteral(this.contextName(this.lastContext));
    },
    // [lookupOnContext]
    //
    // On stack, before: ...
    // On stack, after: currentContext[name], ...
    //
    // Looks up the value of `name` on the current context and pushes
    // it onto the stack.
    lookupOnContext: function lookupOnContext(parts, falsy, strict, scoped) {
        var i = 0;
        if (!scoped && this.options.compat && !this.lastContext) // The depthed query is expected to handle the undefined logic for the root level that
        // is implemented below, so we evaluate that directly in compat mode
        this.push(this.depthedLookup(parts[i++]));
        else this.pushContext();
        this.resolvePath('context', parts, i, falsy, strict);
    },
    // [lookupBlockParam]
    //
    // On stack, before: ...
    // On stack, after: blockParam[name], ...
    //
    // Looks up the value of `parts` on the given block param and pushes
    // it onto the stack.
    lookupBlockParam: function lookupBlockParam(blockParamId, parts) {
        this.useBlockParams = true;
        this.push([
            'blockParams[',
            blockParamId[0],
            '][',
            blockParamId[1],
            ']'
        ]);
        this.resolvePath('context', parts, 1);
    },
    // [lookupData]
    //
    // On stack, before: ...
    // On stack, after: data, ...
    //
    // Push the data lookup operator
    lookupData: function lookupData(depth, parts, strict) {
        if (!depth) this.pushStackLiteral('data');
        else this.pushStackLiteral('container.data(data, ' + depth + ')');
        this.resolvePath('data', parts, 0, true, strict);
    },
    resolvePath: function resolvePath(type, parts, i, falsy, strict) {
        // istanbul ignore next
        var _this2 = this;
        if (this.options.strict || this.options.assumeObjects) {
            this.push($4191254efacb0122$var$strictLookup(this.options.strict && strict, this, parts, i, type));
            return;
        }
        var len = parts.length;
        for(; i < len; i++)/* eslint-disable no-loop-func */ this.replaceStack(function(current) {
            var lookup = _this2.nameLookup(current, parts[i], type);
            // We want to ensure that zero and false are handled properly if the context (falsy flag)
            // needs to have the special handling for these values.
            if (!falsy) return [
                ' != null ? ',
                lookup,
                ' : ',
                current
            ];
            else // Otherwise we can use generic falsy handling
            return [
                ' && ',
                lookup
            ];
        });
    },
    // [resolvePossibleLambda]
    //
    // On stack, before: value, ...
    // On stack, after: resolved value, ...
    //
    // If the `value` is a lambda, replace it on the stack by
    // the return value of the lambda
    resolvePossibleLambda: function resolvePossibleLambda() {
        this.push([
            this.aliasable('container.lambda'),
            '(',
            this.popStack(),
            ', ',
            this.contextName(0),
            ')'
        ]);
    },
    // [pushStringParam]
    //
    // On stack, before: ...
    // On stack, after: string, currentContext, ...
    //
    // This opcode is designed for use in string mode, which
    // provides the string value of a parameter along with its
    // depth rather than resolving it immediately.
    pushStringParam: function pushStringParam(string, type) {
        this.pushContext();
        this.pushString(type);
        // If it's a subexpression, the string result
        // will be pushed after this opcode.
        if (type !== 'SubExpression') {
            if (typeof string === 'string') this.pushString(string);
            else this.pushStackLiteral(string);
        }
    },
    emptyHash: function emptyHash(omitEmpty) {
        if (this.trackIds) this.push('{}'); // hashIds
        if (this.stringParams) {
            this.push('{}'); // hashContexts
            this.push('{}'); // hashTypes
        }
        this.pushStackLiteral(omitEmpty ? 'undefined' : '{}');
    },
    pushHash: function pushHash() {
        if (this.hash) this.hashes.push(this.hash);
        this.hash = {
            values: {},
            types: [],
            contexts: [],
            ids: []
        };
    },
    popHash: function popHash() {
        var hash = this.hash;
        this.hash = this.hashes.pop();
        if (this.trackIds) this.push(this.objectLiteral(hash.ids));
        if (this.stringParams) {
            this.push(this.objectLiteral(hash.contexts));
            this.push(this.objectLiteral(hash.types));
        }
        this.push(this.objectLiteral(hash.values));
    },
    // [pushString]
    //
    // On stack, before: ...
    // On stack, after: quotedString(string), ...
    //
    // Push a quoted version of `string` onto the stack
    pushString: function pushString(string) {
        this.pushStackLiteral(this.quotedString(string));
    },
    // [pushLiteral]
    //
    // On stack, before: ...
    // On stack, after: value, ...
    //
    // Pushes a value onto the stack. This operation prevents
    // the compiler from creating a temporary variable to hold
    // it.
    pushLiteral: function pushLiteral(value) {
        this.pushStackLiteral(value);
    },
    // [pushProgram]
    //
    // On stack, before: ...
    // On stack, after: program(guid), ...
    //
    // Push a program expression onto the stack. This takes
    // a compile-time guid and converts it into a runtime-accessible
    // expression.
    pushProgram: function pushProgram(guid) {
        if (guid != null) this.pushStackLiteral(this.programExpression(guid));
        else this.pushStackLiteral(null);
    },
    // [registerDecorator]
    //
    // On stack, before: hash, program, params..., ...
    // On stack, after: ...
    //
    // Pops off the decorator's parameters, invokes the decorator,
    // and inserts the decorator into the decorators list.
    registerDecorator: function registerDecorator(paramSize, name) {
        var foundDecorator = this.nameLookup('decorators', name, 'decorator'), options = this.setupHelperArgs(name, paramSize);
        this.decorators.push([
            'fn = ',
            this.decorators.functionCall(foundDecorator, '', [
                'fn',
                'props',
                'container',
                options
            ]),
            ' || fn;'
        ]);
    },
    // [invokeHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // Pops off the helper's parameters, invokes the helper,
    // and pushes the helper's return value onto the stack.
    //
    // If the helper is not found, `helperMissing` is called.
    invokeHelper: function invokeHelper(paramSize, name, isSimple) {
        var nonHelper = this.popStack(), helper = this.setupHelper(paramSize, name);
        var possibleFunctionCalls = [];
        if (isSimple) // direct call to helper
        possibleFunctionCalls.push(helper.name);
        // call a function from the input object
        possibleFunctionCalls.push(nonHelper);
        if (!this.options.strict) possibleFunctionCalls.push(this.aliasable('container.hooks.helperMissing'));
        var functionLookupCode = [
            '(',
            this.itemsSeparatedBy(possibleFunctionCalls, '||'),
            ')'
        ];
        var functionCall = this.source.functionCall(functionLookupCode, 'call', helper.callParams);
        this.push(functionCall);
    },
    itemsSeparatedBy: function itemsSeparatedBy(items, separator) {
        var result = [];
        result.push(items[0]);
        for(var i = 1; i < items.length; i++)result.push(separator, items[i]);
        return result;
    },
    // [invokeKnownHelper]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of helper invocation
    //
    // This operation is used when the helper is known to exist,
    // so a `helperMissing` fallback is not required.
    invokeKnownHelper: function invokeKnownHelper(paramSize, name) {
        var helper = this.setupHelper(paramSize, name);
        this.push(this.source.functionCall(helper.name, 'call', helper.callParams));
    },
    // [invokeAmbiguous]
    //
    // On stack, before: hash, inverse, program, params..., ...
    // On stack, after: result of disambiguation
    //
    // This operation is used when an expression like `{{foo}}`
    // is provided, but we don't know at compile-time whether it
    // is a helper or a path.
    //
    // This operation emits more code than the other options,
    // and can be avoided by passing the `knownHelpers` and
    // `knownHelpersOnly` flags at compile-time.
    invokeAmbiguous: function invokeAmbiguous(name, helperCall) {
        this.useRegister('helper');
        var nonHelper = this.popStack();
        this.emptyHash();
        var helper = this.setupHelper(0, name, helperCall);
        var helperName = this.lastHelper = this.nameLookup('helpers', name, 'helper');
        var lookup = [
            '(',
            '(helper = ',
            helperName,
            ' || ',
            nonHelper,
            ')'
        ];
        if (!this.options.strict) {
            lookup[0] = '(helper = ';
            lookup.push(' != null ? helper : ', this.aliasable('container.hooks.helperMissing'));
        }
        this.push([
            '(',
            lookup,
            helper.paramsInit ? [
                '),(',
                helper.paramsInit
            ] : [],
            '),',
            '(typeof helper === ',
            this.aliasable('"function"'),
            ' ? ',
            this.source.functionCall('helper', 'call', helper.callParams),
            ' : helper))'
        ]);
    },
    // [invokePartial]
    //
    // On stack, before: context, ...
    // On stack after: result of partial invocation
    //
    // This operation pops off a context, invokes a partial with that context,
    // and pushes the result of the invocation back.
    invokePartial: function invokePartial(isDynamic, name, indent) {
        var params = [], options = this.setupParams(name, 1, params);
        if (isDynamic) {
            name = this.popStack();
            delete options.name;
        }
        if (indent) options.indent = JSON.stringify(indent);
        options.helpers = 'helpers';
        options.partials = 'partials';
        options.decorators = 'container.decorators';
        if (!isDynamic) params.unshift(this.nameLookup('partials', name, 'partial'));
        else params.unshift(name);
        if (this.options.compat) options.depths = 'depths';
        options = this.objectLiteral(options);
        params.push(options);
        this.push(this.source.functionCall('container.invokePartial', '', params));
    },
    // [assignToHash]
    //
    // On stack, before: value, ..., hash, ...
    // On stack, after: ..., hash, ...
    //
    // Pops a value off the stack and assigns it to the current hash
    assignToHash: function assignToHash(key) {
        var value = this.popStack(), context = undefined, type = undefined, id = undefined;
        if (this.trackIds) id = this.popStack();
        if (this.stringParams) {
            type = this.popStack();
            context = this.popStack();
        }
        var hash = this.hash;
        if (context) hash.contexts[key] = context;
        if (type) hash.types[key] = type;
        if (id) hash.ids[key] = id;
        hash.values[key] = value;
    },
    pushId: function pushId(type, name, child) {
        if (type === 'BlockParam') this.pushStackLiteral('blockParams[' + name[0] + '].path[' + name[1] + ']' + (child ? ' + ' + JSON.stringify('.' + child) : ''));
        else if (type === 'PathExpression') this.pushString(name);
        else if (type === 'SubExpression') this.pushStackLiteral('true');
        else this.pushStackLiteral('null');
    },
    // HELPERS
    compiler: $4191254efacb0122$var$JavaScriptCompiler,
    compileChildren: function compileChildren(environment, options) {
        var children = environment.children, child = undefined, compiler = undefined;
        for(var i = 0, l = children.length; i < l; i++){
            child = children[i];
            compiler = new this.compiler(); // eslint-disable-line new-cap
            var existing = this.matchExistingProgram(child);
            if (existing == null) {
                this.context.programs.push(''); // Placeholder to prevent name conflicts for nested children
                var index = this.context.programs.length;
                child.index = index;
                child.name = 'program' + index;
                this.context.programs[index] = compiler.compile(child, options, this.context, !this.precompile);
                this.context.decorators[index] = compiler.decorators;
                this.context.environments[index] = child;
                this.useDepths = this.useDepths || compiler.useDepths;
                this.useBlockParams = this.useBlockParams || compiler.useBlockParams;
                child.useDepths = this.useDepths;
                child.useBlockParams = this.useBlockParams;
            } else {
                child.index = existing.index;
                child.name = 'program' + existing.index;
                this.useDepths = this.useDepths || existing.useDepths;
                this.useBlockParams = this.useBlockParams || existing.useBlockParams;
            }
        }
    },
    matchExistingProgram: function matchExistingProgram(child) {
        for(var i = 0, len = this.context.environments.length; i < len; i++){
            var environment = this.context.environments[i];
            if (environment && environment.equals(child)) return environment;
        }
    },
    programExpression: function programExpression(guid) {
        var child = this.environment.children[guid], programParams = [
            child.index,
            'data',
            child.blockParams
        ];
        if (this.useBlockParams || this.useDepths) programParams.push('blockParams');
        if (this.useDepths) programParams.push('depths');
        return 'container.program(' + programParams.join(', ') + ')';
    },
    useRegister: function useRegister(name) {
        if (!this.registers[name]) {
            this.registers[name] = true;
            this.registers.list.push(name);
        }
    },
    push: function push(expr) {
        if (!(expr instanceof $4191254efacb0122$var$Literal)) expr = this.source.wrap(expr);
        this.inlineStack.push(expr);
        return expr;
    },
    pushStackLiteral: function pushStackLiteral(item) {
        this.push(new $4191254efacb0122$var$Literal(item));
    },
    pushSource: function pushSource(source) {
        if (this.pendingContent) {
            this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent), this.pendingLocation));
            this.pendingContent = undefined;
        }
        if (source) this.source.push(source);
    },
    replaceStack: function replaceStack(callback) {
        var prefix = [
            '('
        ], stack = undefined, createdStack = undefined, usedLiteral = undefined;
        /* istanbul ignore next */ if (!this.isInline()) throw new $4191254efacb0122$var$_exception2['default']('replaceStack on non-inline');
        // We want to merge the inline statement into the replacement statement via ','
        var top = this.popStack(true);
        if (top instanceof $4191254efacb0122$var$Literal) {
            // Literals do not need to be inlined
            stack = [
                top.value
            ];
            prefix = [
                '(',
                stack
            ];
            usedLiteral = true;
        } else {
            // Get or create the current stack name for use by the inline
            createdStack = true;
            var _name = this.incrStack();
            prefix = [
                '((',
                this.push(_name),
                ' = ',
                top,
                ')'
            ];
            stack = this.topStack();
        }
        var item = callback.call(this, stack);
        if (!usedLiteral) this.popStack();
        if (createdStack) this.stackSlot--;
        this.push(prefix.concat(item, ')'));
    },
    incrStack: function incrStack() {
        this.stackSlot++;
        if (this.stackSlot > this.stackVars.length) this.stackVars.push('stack' + this.stackSlot);
        return this.topStackName();
    },
    topStackName: function topStackName() {
        return 'stack' + this.stackSlot;
    },
    flushInline: function flushInline() {
        var inlineStack = this.inlineStack;
        this.inlineStack = [];
        for(var i = 0, len = inlineStack.length; i < len; i++){
            var entry = inlineStack[i];
            /* istanbul ignore if */ if (entry instanceof $4191254efacb0122$var$Literal) this.compileStack.push(entry);
            else {
                var stack = this.incrStack();
                this.pushSource([
                    stack,
                    ' = ',
                    entry,
                    ';'
                ]);
                this.compileStack.push(stack);
            }
        }
    },
    isInline: function isInline() {
        return this.inlineStack.length;
    },
    popStack: function popStack(wrapped) {
        var inline = this.isInline(), item = (inline ? this.inlineStack : this.compileStack).pop();
        if (!wrapped && item instanceof $4191254efacb0122$var$Literal) return item.value;
        else {
            if (!inline) {
                /* istanbul ignore next */ if (!this.stackSlot) throw new $4191254efacb0122$var$_exception2['default']('Invalid stack pop');
                this.stackSlot--;
            }
            return item;
        }
    },
    topStack: function topStack() {
        var stack = this.isInline() ? this.inlineStack : this.compileStack, item = stack[stack.length - 1];
        /* istanbul ignore if */ if (item instanceof $4191254efacb0122$var$Literal) return item.value;
        else return item;
    },
    contextName: function contextName(context) {
        if (this.useDepths && context) return 'depths[' + context + ']';
        else return 'depth' + context;
    },
    quotedString: function quotedString(str) {
        return this.source.quotedString(str);
    },
    objectLiteral: function objectLiteral(obj) {
        return this.source.objectLiteral(obj);
    },
    aliasable: function aliasable(name) {
        var ret = this.aliases[name];
        if (ret) {
            ret.referenceCount++;
            return ret;
        }
        ret = this.aliases[name] = this.source.wrap(name);
        ret.aliasable = true;
        ret.referenceCount = 1;
        return ret;
    },
    setupHelper: function setupHelper(paramSize, name, blockHelper) {
        var params = [], paramsInit = this.setupHelperArgs(name, paramSize, params, blockHelper);
        var foundHelper = this.nameLookup('helpers', name, 'helper'), callContext = this.aliasable(this.contextName(0) + ' != null ? ' + this.contextName(0) + ' : (container.nullContext || {})');
        return {
            params: params,
            paramsInit: paramsInit,
            name: foundHelper,
            callParams: [
                callContext
            ].concat(params)
        };
    },
    setupParams: function setupParams(helper, paramSize, params) {
        var options = {}, contexts = [], types = [], ids = [], objectArgs = !params, param = undefined;
        if (objectArgs) params = [];
        options.name = this.quotedString(helper);
        options.hash = this.popStack();
        if (this.trackIds) options.hashIds = this.popStack();
        if (this.stringParams) {
            options.hashTypes = this.popStack();
            options.hashContexts = this.popStack();
        }
        var inverse = this.popStack(), program = this.popStack();
        // Avoid setting fn and inverse if neither are set. This allows
        // helpers to do a check for `if (options.fn)`
        if (program || inverse) {
            options.fn = program || 'container.noop';
            options.inverse = inverse || 'container.noop';
        }
        // The parameters go on to the stack in order (making sure that they are evaluated in order)
        // so we need to pop them off the stack in reverse order
        var i = paramSize;
        while(i--){
            param = this.popStack();
            params[i] = param;
            if (this.trackIds) ids[i] = this.popStack();
            if (this.stringParams) {
                types[i] = this.popStack();
                contexts[i] = this.popStack();
            }
        }
        if (objectArgs) options.args = this.source.generateArray(params);
        if (this.trackIds) options.ids = this.source.generateArray(ids);
        if (this.stringParams) {
            options.types = this.source.generateArray(types);
            options.contexts = this.source.generateArray(contexts);
        }
        if (this.options.data) options.data = 'data';
        if (this.useBlockParams) options.blockParams = 'blockParams';
        return options;
    },
    setupHelperArgs: function setupHelperArgs(helper, paramSize, params, useRegister) {
        var options = this.setupParams(helper, paramSize, params);
        options.loc = JSON.stringify(this.source.currentLocation);
        options = this.objectLiteral(options);
        if (useRegister) {
            this.useRegister('options');
            params.push('options');
            return [
                'options=',
                options
            ];
        } else if (params) {
            params.push(options);
            return '';
        } else return options;
    }
};
(function() {
    var reservedWords = "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(' ');
    var compilerWords = $4191254efacb0122$var$JavaScriptCompiler.RESERVED_WORDS = {};
    for(var i = 0, l = reservedWords.length; i < l; i++)compilerWords[reservedWords[i]] = true;
})();
/**
 * @deprecated May be removed in the next major version
 */ $4191254efacb0122$var$JavaScriptCompiler.isValidJavaScriptVariableName = function(name) {
    return !$4191254efacb0122$var$JavaScriptCompiler.RESERVED_WORDS[name] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(name);
};
function $4191254efacb0122$var$strictLookup(requireTerminal, compiler, parts, i, type) {
    var stack = compiler.popStack(), len = parts.length;
    if (requireTerminal) len--;
    for(; i < len; i++)stack = compiler.nameLookup(stack, parts[i], type);
    if (requireTerminal) return [
        compiler.aliasable('container.strict'),
        '(',
        stack,
        ', ',
        compiler.quotedString(parts[i]),
        ', ',
        JSON.stringify(compiler.source.currentLocation),
        ' )'
    ];
    else return stack;
}
$4191254efacb0122$exports['default'] = $4191254efacb0122$var$JavaScriptCompiler;
$4191254efacb0122$exports = $4191254efacb0122$exports['default'];


var $2829b823e93e4c92$var$_handlebarsCompilerJavascriptCompiler2 = $2829b823e93e4c92$var$_interopRequireDefault($4191254efacb0122$exports);

var $2829b823e93e4c92$var$_handlebarsCompilerVisitor2 = $2829b823e93e4c92$var$_interopRequireDefault($24772e40320d4317$exports);

var $2829b823e93e4c92$var$_handlebarsNoConflict2 = $2829b823e93e4c92$var$_interopRequireDefault($787e52a2b9acbb7c$exports);
var $2829b823e93e4c92$var$_create = $2829b823e93e4c92$var$_handlebarsRuntime2['default'].create;
function $2829b823e93e4c92$var$create() {
    var hb = $2829b823e93e4c92$var$_create();
    hb.compile = function(input, options) {
        return $7080109da79cd625$export$ef7acd7185315e22(input, options, hb);
    };
    hb.precompile = function(input, options) {
        return $7080109da79cd625$export$cfb9e0f1330f9bbd(input, options, hb);
    };
    hb.AST = $2829b823e93e4c92$var$_handlebarsCompilerAst2['default'];
    hb.Compiler = $7080109da79cd625$export$3a6335acfcf707c9;
    hb.JavaScriptCompiler = $2829b823e93e4c92$var$_handlebarsCompilerJavascriptCompiler2['default'];
    hb.Parser = $dc49e6b2606b0f90$export$8f49e4af10703ce3;
    hb.parse = $dc49e6b2606b0f90$export$98e6a39c04603d36;
    hb.parseWithoutProcessing = $dc49e6b2606b0f90$export$fc85b2c4462e0bc6;
    return hb;
}
var $2829b823e93e4c92$var$inst = $2829b823e93e4c92$var$create();
$2829b823e93e4c92$var$inst.create = $2829b823e93e4c92$var$create;
$2829b823e93e4c92$var$_handlebarsNoConflict2['default']($2829b823e93e4c92$var$inst);
$2829b823e93e4c92$var$inst.Visitor = $2829b823e93e4c92$var$_handlebarsCompilerVisitor2['default'];
$2829b823e93e4c92$var$inst['default'] = $2829b823e93e4c92$var$inst;
$2829b823e93e4c92$exports['default'] = $2829b823e93e4c92$var$inst;
$2829b823e93e4c92$exports = $2829b823e93e4c92$exports['default'];


// Expose equality helper so templates can branch without bundler support
(0, (/*@__PURE__*/$parcel$interopDefault($2829b823e93e4c92$exports))).registerHelper('eq', (left, right)=>left === right);
const $b140a5789469c122$var$ICON_LOOKUP = {
    product: 'product',
    products: 'product',
    collection: 'collection',
    collections: 'collection',
    content: 'content',
    resource: 'resource',
    resources: 'resource'
};
const $b140a5789469c122$var$TEMPLATE_FALLBACK = ()=>'';
function $b140a5789469c122$var$resolveIconKey(raw) {
    if (!raw) return '';
    const key = String(raw).trim().toLowerCase();
    return $b140a5789469c122$var$ICON_LOOKUP[key] || '';
}
function $b140a5789469c122$var$createSearchPageView(container) {
    const refs = {
        headerInputs: Array.from(document.querySelectorAll('.header-nav__search-bar')),
        results: container.querySelector('#search-results'),
        summary: container.querySelector('#search-summary'),
        progressWrap: container.querySelector('#search-progress'),
        progressText: container.querySelector('#searchProgressText'),
        progressBar: container.querySelector('#searchProgressBar'),
        loadMore: container.querySelector('#load-more-results'),
        loading: container.querySelector('#search-loading'),
        error: container.querySelector('#search-error'),
        filters: container.querySelector('.search-page__filters'),
        sortSelect: container.querySelector('#search-sort')
    };
    function setLoading(isLoading) {
        if (refs.loading) refs.loading.hidden = !isLoading;
        if (refs.loadMore && !refs.loadMore.hidden) refs.loadMore.disabled = Boolean(isLoading);
    }
    function setError(message) {
        if (!refs.error) return;
        if (message) {
            refs.error.textContent = message;
            refs.error.hidden = false;
        } else {
            refs.error.textContent = '';
            refs.error.hidden = true;
        }
    }
    function renderResults(items, template, append = false) {
        if (!refs.results) return;
        const list = Array.isArray(items) ? items : [];
        const templateFn = typeof template === 'function' ? template : $b140a5789469c122$var$TEMPLATE_FALLBACK;
        if (!append) refs.results.innerHTML = '';
        if (list.length === 0) return;
        const html = list.map((item)=>{
            const title = item?.title || 'Untitled';
            const url = item?.url || '#';
            const excerpt = item?.excerpt || '';
            const typeLabel = typeof item?.contentType === 'string' ? item.contentType : '';
            const normalizedType = typeLabel || '';
            const icon = $b140a5789469c122$var$resolveIconKey(typeLabel) || $b140a5789469c122$var$resolveIconKey(item?.icon);
            const lowerType = normalizedType.trim().toLowerCase();
            const target = lowerType === 'resource' || lowerType === 'resources' ? '_blank' : '_self';
            const hasPrimaryCategory = Boolean(item?.primaryCategoryName);
            const hasSecondaryCategory = Boolean(item?.secondaryCategoryName);
            const categoryCount = hasPrimaryCategory && hasSecondaryCategory ? 2 : hasPrimaryCategory ? 1 : 0;
            return templateFn({
                title: title,
                imageUrl: item?.imageUrl,
                url: url,
                excerpt: excerpt,
                type: normalizedType,
                icon: icon,
                target: target,
                categoryCount: categoryCount,
                primaryCategoryName: item?.primaryCategoryName,
                secondaryCategoryName: item?.secondaryCategoryName
            });
        }).join('');
        if (append) refs.results.insertAdjacentHTML('beforeend', html);
        else refs.results.innerHTML = html;
    }
    function renderSummary(total, term) {
        if (!refs.summary) return;
        refs.summary.textContent = '';
        if (!term) return;
        const summaryText = `${total.toLocaleString()} result${total === 1 ? '' : 's'} for `;
        const emphasisedTerm = document.createElement('strong');
        emphasisedTerm.textContent = `"${term}"`;
        refs.summary.append(summaryText, emphasisedTerm);
    }
    function updateProgress(displayed, total, moreAvailable = false) {
        if (!refs.progressWrap) return;
        const shownCount = Math.max(0, Number(displayed) || 0);
        const totalRaw = Number(total);
        const totalCount = Number.isFinite(totalRaw) && totalRaw > 0 ? totalRaw : shownCount;
        if (!totalCount) {
            refs.progressWrap.hidden = true;
            if (refs.progressText) refs.progressText.textContent = 'Showing 0 of 0';
            if (refs.progressBar) refs.progressBar.style.width = '0%';
            if (refs.loadMore) {
                refs.loadMore.hidden = true;
                refs.loadMore.disabled = false;
            }
            return;
        }
        refs.progressWrap.hidden = false;
        if (refs.progressText) refs.progressText.textContent = `Showing ${shownCount} of ${totalCount}`;
        if (refs.progressBar) {
            const percent = totalCount > 0 ? Math.min(100, shownCount / totalCount * 100) : 0;
            refs.progressBar.style.width = `${percent}%`;
        }
        if (refs.loadMore) {
            const showLoadMore = Boolean(moreAvailable);
            refs.loadMore.hidden = !showLoadMore;
            refs.loadMore.disabled = !showLoadMore;
        }
    }
    function syncActiveFilter(activeType) {
        if (!refs.filters) return;
        const targetType = (activeType || 'All').toString().toLowerCase();
        refs.filters.querySelectorAll('.search-page__filter-btn').forEach((btn)=>{
            const type = (btn.getAttribute('data-content-type') || 'All').toLowerCase();
            const isActive = type === targetType;
            btn.classList.toggle('is-active', isActive);
            btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
    }
    function updateSort(value) {
        if (!refs.sortSelect) return;
        refs.sortSelect.value = value || 'Default';
    }
    function updateHeaderInputs(term) {
        refs.headerInputs.forEach((el)=>{
            if (el instanceof HTMLInputElement) el.value = term || '';
        });
    }
    return {
        refs: refs,
        setLoading: setLoading,
        setError: setError,
        renderResults: renderResults,
        renderSummary: renderSummary,
        updateProgress: updateProgress,
        syncActiveFilter: syncActiveFilter,
        updateSort: updateSort,
        updateHeaderInputs: updateHeaderInputs
    };
}
function $b140a5789469c122$var$updateUrlParameters(term, page, type, sort) {
    try {
        const url = new URL(window.location.href);
        if (term) url.searchParams.set('query', term);
        else url.searchParams.delete('query');
        if (page && page > 1) url.searchParams.set('page', String(page));
        else url.searchParams.delete('page');
        if (type && type !== 'All') url.searchParams.set('type', type);
        else url.searchParams.delete('type');
        if (sort && sort !== 'Default') url.searchParams.set('sort', sort);
        else url.searchParams.delete('sort');
        window.history.replaceState({}, '', url);
    } catch (error) {
        console.error('error updating url', error);
    }
}
function $b140a5789469c122$export$2f53dd46c8386eb6() {
    const container = document.querySelector('.search-page');
    if (!container) return;
    const view = $b140a5789469c122$var$createSearchPageView(container);
    const { refs: refs } = view;
    const { loadMore: loadMoreBtn, filters: filtersWrap, sortSelect: sortSelect } = refs;
    const pageSizeAttr = parseInt(container.getAttribute('data-page-size') || '16', 10);
    const pageSize = Number.isFinite(pageSizeAttr) && pageSizeAttr > 0 ? pageSizeAttr : 16;
    const state = {
        term: '',
        page: 1,
        type: 'All',
        sort: 'Default',
        total: 0,
        displayed: 0
    };
    view.syncActiveFilter(state.type);
    const templateScript = document.getElementById('search-page-result-template');
    const itemTemplate = templateScript ? (0, (/*@__PURE__*/$parcel$interopDefault($2829b823e93e4c92$exports))).compile(templateScript.innerHTML) : $b140a5789469c122$var$TEMPLATE_FALLBACK;
    async function performSearch(term, page = 1, options = {}) {
        const { append: append = false } = options;
        const normalizedTerm = append ? state.term : String(term || '').trim();
        if (!append) {
            state.term = normalizedTerm;
            state.page = 1;
            state.total = 0;
            state.displayed = 0;
            view.renderResults([], itemTemplate, false);
            view.renderSummary(0, '');
            view.updateProgress(0, 0, false);
        }
        view.setError('');
        if (!normalizedTerm) {
            $b140a5789469c122$var$updateUrlParameters('', 1, state.type, state.sort);
            return null;
        }
        const targetPage = page < 1 ? 1 : page;
        view.setLoading(true);
        try {
            const params = new URLSearchParams({
                term: normalizedTerm,
                pageSize: String(pageSize),
                page: String(targetPage),
                contentType: state.type,
                sort: state.sort
            });
            const response = await fetch(`/api/search?${params.toString()}`, {
                headers: {
                    Accept: 'application/json'
                }
            });
            if (!response.ok) throw new Error(`Search failed (${response.status})`);
            const payload = await response.json();
            const itemsSource = payload.items || payload.Items || [];
            const items = Array.isArray(itemsSource) ? itemsSource : [];
            const totalFromResponse = payload.totalItems ?? payload.TotalItems ?? payload.total ?? payload.Total ?? payload.count ?? payload.Count ?? 0;
            const numericTotal = Number(totalFromResponse);
            const hasExplicitTotal = Number.isFinite(numericTotal) && numericTotal > 0;
            view.renderResults(items, itemTemplate, append);
            const addedCount = items.length;
            state.displayed = append ? state.displayed + addedCount : addedCount;
            if (hasExplicitTotal) state.total = numericTotal;
            else if (!append) state.total = state.displayed;
            else state.total = Math.max(state.total, state.displayed);
            if (state.total > 0) state.displayed = Math.min(state.displayed, state.total);
            state.page = targetPage;
            const hasMoreFlag = payload.hasMore ?? payload.HasMore ?? null;
            let moreAvailable;
            if (typeof hasMoreFlag === 'boolean') moreAvailable = hasMoreFlag;
            else if (state.total > 0) moreAvailable = state.displayed < state.total;
            else moreAvailable = addedCount === pageSize;
            const totalForSummary = state.total > 0 ? state.total : state.displayed;
            view.renderSummary(totalForSummary, normalizedTerm);
            view.updateProgress(state.displayed, totalForSummary, moreAvailable);
            view.syncActiveFilter(state.type);
            state.term = normalizedTerm;
            $b140a5789469c122$var$updateUrlParameters(state.term, state.page, state.type, state.sort);
            if (!moreAvailable && loadMoreBtn) {
                loadMoreBtn.hidden = true;
                loadMoreBtn.disabled = true;
            }
            return {
                items: items,
                totalItems: totalForSummary,
                displayedItems: state.displayed,
                page: state.page,
                hasMore: Boolean(moreAvailable)
            };
        } catch (error) {
            const message = error && error.message ? error.message : 'An error occurred while searching.';
            view.setError(message);
            return null;
        } finally{
            view.setLoading(false);
        }
    }
    if (loadMoreBtn) loadMoreBtn.addEventListener('click', ()=>{
        if (loadMoreBtn.disabled) return;
        if (!state.term) return;
        performSearch(state.term, state.page + 1, {
            append: true
        });
    });
    // Initialize from URL
    try {
        const url = new URL(window.location.href);
        const initialTerm = url.searchParams.get('query') || '';
        const initialPage = parseInt(url.searchParams.get('page') || '1', 10) || 1;
        const initialType = url.searchParams.get('type') || 'All';
        const initialSort = url.searchParams.get('sort') || 'Default';
        state.type = initialType;
        state.sort = initialSort;
        view.updateSort(state.sort);
        view.updateHeaderInputs(initialTerm);
        view.syncActiveFilter(state.type);
        if (initialTerm) {
            const targetPage = initialPage > 1 ? initialPage : 1;
            performSearch(initialTerm, 1).then(async (result)=>{
                if (!result) return;
                if (targetPage <= 1) return;
                for(let pageNumber = 2; pageNumber <= targetPage; pageNumber += 1){
                    const nextResult = await performSearch(initialTerm, pageNumber, {
                        append: true
                    });
                    if (!nextResult || nextResult.items.length === 0 || !nextResult.hasMore) break;
                }
            });
        } else $b140a5789469c122$var$updateUrlParameters('', 1, state.type, state.sort);
    } catch (error) {
        console.error('error initializing search page', error);
    }
    // Wire up filter buttons
    if (filtersWrap) filtersWrap.addEventListener('click', (ev)=>{
        const trigger = ev.target instanceof HTMLElement ? ev.target : null;
        if (!trigger) return;
        const btn = trigger.closest('.search-page__filter-btn');
        if (!btn) return;
        const nextType = btn.getAttribute('data-content-type') || 'All';
        if (state.type === nextType) return;
        state.type = nextType;
        view.syncActiveFilter(state.type);
        if (state.term) performSearch(state.term, 1);
        else $b140a5789469c122$var$updateUrlParameters('', 1, state.type, state.sort);
    });
    // Wire up sort dropdown
    if (sortSelect) sortSelect.addEventListener('change', ()=>{
        const nextSort = String(sortSelect.value || 'Default');
        if (state.sort === nextSort) return;
        state.sort = nextSort;
        if (state.term) performSearch(state.term, 1);
        else $b140a5789469c122$var$updateUrlParameters('', 1, state.type, state.sort);
    });
}


function $8a2968deefd15088$export$55fba04d7ae06ee3() {
    window.mergeAdjacentCollections = (e)=>{
        const collectionContainers = document.querySelectorAll('.collection--container');
        if (collectionContainers.length < 2) return;
        for(let i = 0; i < collectionContainers.length - 1; i++){
            const container = collectionContainers[i];
            const nextContainer = collectionContainers[i + 1];
            if (container.dataset.collectionName !== nextContainer.dataset.collectionName) continue;
            const nextItems = nextContainer.querySelectorAll('.collection--items');
            nextItems.forEach((x)=>container.appendChild(x));
            nextContainer.remove();
        }
    };
    const mainForm = document.getElementById("tmp-product-category-facets-form");
    const mobileForm = document.getElementById("tmp-product-category-facets-form-mobile");
    const modal = document.getElementById("facetsModal");
    if (!mainForm || !mobileForm || !modal) return;
    const openBtn = document.querySelector(".tmp-productcategory__facets-filter");
    const closeBtn = modal.querySelector(".tmp-productcategory__facets-modal__close");
    const overlay = modal.querySelector(".tmp-productcategory__facets-modal__overlay");
    // start accordiong & helpers
    function toggleAccordion(button, values) {
        const expandIcon = button.querySelector(".accordion-icon__expand");
        const collapseIcon = button.querySelector(".accordion-icon__collapse");
        const isHidden = values.hasAttribute("hidden");
        if (isHidden) {
            values.removeAttribute("hidden");
            button.classList.add("open");
            expandIcon.setAttribute("hidden", "");
            collapseIcon.removeAttribute("hidden");
        } else {
            values.setAttribute("hidden", "");
            button.classList.remove("open");
            collapseIcon.setAttribute("hidden", "");
            expandIcon.removeAttribute("hidden");
        }
    }
    function openModal() {
        modal.classList.add("is-open");
        document.body.style.overflow = "hidden";
    }
    function closeModal() {
        modal.classList.remove("is-open");
        document.body.style.overflow = "";
    }
    openBtn?.addEventListener("click", openModal);
    closeBtn?.addEventListener("click", closeModal);
    overlay?.addEventListener("click", closeModal);
    document.querySelectorAll("[data-accordion-toggle]").forEach((button)=>{
        button.addEventListener("click", ()=>{
            const values = button.nextElementSibling;
            toggleAccordion(button, values);
        });
    });
    // end accordion & helpers
    // helper function to update the facet count badge
    function updateFacetCountFor(groupEl) {
        const count = groupEl.querySelectorAll('.facet-checkbox:checked').length;
        const badge = groupEl.querySelector('[data-facet-count]');
        const btn = groupEl.querySelector('.tmp-productcategory__facets__group-accordion p');
        if (!badge) return;
        if (count > 0) {
            badge.textContent = String(count);
            badge.setAttribute('data-facet-count', String(count));
            badge.removeAttribute('hidden');
            btn.classList.add("bold");
        } else {
            badge.textContent = '';
            badge.setAttribute('data-facet-count', '0');
            badge.setAttribute('hidden', '');
            btn.classList.remove("bold");
        }
    }
    // update facet count when user clicks a facet
    mainForm.addEventListener("change", (e)=>{
        const cb = e.target;
        if (!(cb instanceof HTMLInputElement)) return;
        if (!cb.classList.contains("facet-checkbox")) return;
        updateFacetCountFor(cb.closest(".tmp-productcategory__facets__group"));
        mainForm.requestSubmit();
    });
    // update facet count when user clicks a facet
    mobileForm.addEventListener("change", (e)=>{
        const cb = e.target;
        if (!(cb instanceof HTMLInputElement)) return;
        if (!cb.classList.contains("facet-checkbox")) return;
        updateFacetCountFor(cb.closest(".tmp-productcategory__facets__group"));
        const id = cb.closest(".tmp-productcategory__facets__group")?.getAttribute("data-accordion-id");
        if (id) {
            const desktopGroup = document.querySelector(`.tmp-productcategory__facets__groups-desktop .tmp-productcategory__facets__group[data-accordion-id="${id}"]`);
            if (desktopGroup) updateFacetCountFor(desktopGroup);
        }
        syncCheckboxes(mobileForm, mainForm);
        mainForm.requestSubmit();
        closeModal();
    });
    const resetDesktopBtn = document.getElementById("reset-facets");
    resetDesktopBtn?.addEventListener("click", ()=>{
        mainForm.querySelectorAll(".facet-checkbox").forEach((cb)=>cb.checked = false);
        document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);
        mainForm.requestSubmit();
    });
    const resetMobileBtn = document.getElementById("reset-facets-mobile");
    resetMobileBtn?.addEventListener("click", ()=>{
        mobileForm.querySelectorAll(".facet-checkbox").forEach((cb)=>cb.checked = false);
        syncCheckboxes(mobileForm, mainForm);
        document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);
        mainForm.requestSubmit();
        closeModal();
    });
    function syncCheckboxes(sourceForm, targetForm) {
        targetForm.querySelectorAll(".facet-checkbox").forEach((desktopCb)=>{
            const sourceCb = sourceForm.querySelector(`.facet-checkbox[name="${desktopCb.name}"][value="${desktopCb.value}"]`);
            if (sourceCb) desktopCb.checked = sourceCb.checked;
        });
    }
    mobileForm.querySelectorAll(".sort-radio").forEach((rb)=>{
        rb.addEventListener("change", ()=>{
            const select = mainForm?.querySelector("select[name='SortOrder']");
            if (select) {
                select.value = rb.value;
                select.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            }
            const sortLabel = document.getElementById("sortLabel");
            if (sortLabel) sortLabel.textContent = rb.value;
            closeModal();
        });
    });
    // update facet count on initial paint
    document.querySelectorAll(".tmp-productcategory__facets__group").forEach(updateFacetCountFor);
    // render error msg on htmx failure
    const plpRoot = document.querySelector('.tmp-productcategory');
    if (plpRoot) {
        plpRoot.addEventListener('htmx:responseError', function() {
            var err = document.getElementById('plp-error');
            if (err) err.classList.remove('hidden');
        });
        plpRoot.addEventListener('htmx:afterSwap', function() {
            var err = document.getElementById('plp-error');
            if (err) err.classList.add('hidden');
        });
    }
    // after user interacts with applied facet chips, set checkbox val to false and dispatch change event
    function onAppliedFacetClick(e) {
        const btn = e.target.closest('.tmp-productcategory__facets__applied-chips');
        if (!btn) return;
        const key = btn.dataset.facetKey;
        const val = btn.dataset.facetValue;
        if (!key || !val) return;
        const cb = mainForm.querySelector(`input.facet-checkbox[name="filters[${key}]"][value="${CSS.escape(val)}"]`);
        if (!cb || !cb.checked) return;
        cb.checked = false;
        cb.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    }
    function bindAppliedFacetClicks() {
        const applied = document.getElementById('applied-facets');
        if (!applied) return;
        // Guard against accidental double-bind
        applied.removeEventListener('click', onAppliedFacetClick);
        applied.addEventListener('click', onAppliedFacetClick);
    }
    // Initial bind
    bindAppliedFacetClicks();
    // Re-bind after HTMX swaps
    document.body.addEventListener('htmx:oobAfterSwap', (e)=>{
        const target = e.detail?.target;
        if (target && target.id === 'applied-facets') bindAppliedFacetClicks();
    });
}


function $f00eefbc9fdbbeab$export$86460d36a13550a2() {
    // handle the weird segment selector
    document.querySelectorAll('select.segment-select').forEach(function(select) {
        select.addEventListener('change', function() {
            $f00eefbc9fdbbeab$var$onSegmentChange(select);
        });
        $f00eefbc9fdbbeab$var$updateSegmentSelection(select);
    });
}
function $f00eefbc9fdbbeab$var$onSegmentChange(selectElement) {
    const selected = selectElement.value;
    const segmentMultiple = selectElement.closest('div').querySelector('.segment-select-multiple');
    // Select or deselect the option in segmentMultiple
    if (segmentMultiple) {
        for(let i = 0; i < segmentMultiple.options.length; i++)if (segmentMultiple.options[i].value === selected) {
            segmentMultiple.options[i].selected = !segmentMultiple.options[i].selected;
            break;
        }
        // Trigger change event so listeners can react
        segmentMultiple.dispatchEvent(new Event('change', {
            bubbles: true
        }));
        // Update the select's text to show the count of selected segments
        $f00eefbc9fdbbeab$var$updateSegmentSelection(selectElement);
    }
}
function $f00eefbc9fdbbeab$var$updateSegmentSelection(selectElement) {
    const segmentMultiple = selectElement.closest('div').querySelector('.segment-select-multiple');
    const segmentList = selectElement.closest('div').querySelector('.segment-list');
    if (!segmentMultiple || !segmentList) return;
    const count = Array.from(segmentMultiple.selectedOptions).length;
    // Reset the select to the first option
    selectElement.selectedIndex = 0;
    // Update the select text
    if (selectElement && selectElement.options.length > 0) selectElement.options[0].text = count > 0 ? `${count} Selected` : "-- Select --";
    // Create the pills
    segmentList.innerHTML = '';
    Array.from(segmentMultiple.selectedOptions).forEach((option)=>{
        const div = document.createElement('div');
        div.classList.add('segment-pill');
        div.dataset.segment = option.value;
        const span = document.createElement('span');
        span.textContent = option.text;
        div.appendChild(span);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.classList.add('segment-pill__remove');
        btn.textContent = "\xd7";
        btn.addEventListener('click', ()=>{
            option.selected = false;
            // Trigger change event so listeners can react
            segmentMultiple.dispatchEvent(new Event('change', {
                bubbles: true
            }));
            $f00eefbc9fdbbeab$var$updateSegmentSelection(selectElement);
        });
        div.appendChild(btn);
        segmentList.appendChild(div);
    });
}



var $iouPm = parcelRequire("iouPm");


var $9zaOw = parcelRequire("9zaOw");

var $bWUN0 = parcelRequire("bWUN0");

var $8cF6f = parcelRequire("8cF6f");
function $3ccabf6a7e25ddf1$export$98d1f400bca69d1b() {
    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    function getFormIdField(form) {
        return form.querySelector('[name="Id"]');
    }
    document.addEventListener('DOMContentLoaded', function() {
        // Initialize address form handlers on both Shipping Detail page and Shopping Cart page
        const hasShippingDetail = document.querySelector('.shipping-detail');
        const hasShoppingCart = document.querySelector('.tmp-account-cart');
        if (hasShippingDetail || hasShoppingCart) {
            // Initialize "Add Address" button click handler
            const addAddressBtn = document.getElementById('addAddress');
            if (addAddressBtn) addAddressBtn.addEventListener('click', function(e) {
                const addressFormContainer = document.getElementById('addressFormContainer');
                if (!addressFormContainer) return;
                addressFormContainer.style.display = 'block';
                const form = document.getElementById('addressForm');
                if (form) {
                    form.reset();
                    (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
                    // the id field is being set when editing an address, but it was never unset.
                    // so if a user edited an address, then added a new address, the new address
                    // would overwrite the existing address.
                    const idField = getFormIdField(form);
                    if (idField) {
                        idField.value = emptyGuid;
                        console.debug('reset shipping address form id field');
                    } else console.error('could not find shipping address form id field to reset');
                }
                $3ccabf6a7e25ddf1$var$resetFieldBorders();
                addressFormContainer.querySelectorAll('h2').forEach(function(el) {
                    el.textContent = "Add Shipping Address";
                });
                addressFormContainer.querySelectorAll('.btn-primary').forEach(function(el) {
                    el.textContent = "Add Shipping Address";
                });
                // Check if the user has any default address
                const hasDefaultAddress = document.querySelector('input[name="shippingAddressId"][type="radio"]:checked, .set-default-address:checked');
                const isDefaultCheckbox = document.getElementById('IsDefault');
                if (isDefaultCheckbox) // Check the checkbox by default if no default address exists (but allow user to uncheck)
                isDefaultCheckbox.checked = !hasDefaultAddress;
                e.preventDefault();
            });
            $3ccabf6a7e25ddf1$var$initAddressListHandlers();
            // Clear validation errors when a shipping address is selected (cart page only)
            $3ccabf6a7e25ddf1$var$attachRadioValidationListeners();
            // Clear validation errors when a segment is selected
            const segmentSelect = document.getElementById('segmentIds');
            if (segmentSelect) segmentSelect.addEventListener('change', function() {
                if (this.selectedOptions.length > 0) $3ccabf6a7e25ddf1$var$clearValidationError('segment');
            });
            // dynamically post the shipping address form
            const form = document.getElementById('addressForm');
            const requiredFields = [
                'FirstName',
                'LastName',
                'CompanyName',
                'AddressLine1',
                'State',
                'City',
                'ZipCode'
            ];
            if (form) form.addEventListener('submit', async function(e) {
                e.preventDefault();
                // Get the id field value
                const idField = getFormIdField(form);
                const id = idField ? idField.value : '';
                // assume we're adding
                let url = '/api/ShippingAddresses';
                // if there's not an empty id, we're updating
                if (id && id !== emptyGuid) url = `/api/ShippingAddresses/${id}`;
                requiredFields.forEach((id)=>{
                    const input = document.getElementById(id);
                    if (input) {
                        if (!input.value.trim()) input.classList.add('input-error');
                        else input.classList.remove('input-error');
                    }
                });
                await (0, $acf010821545adc4$export$c1f4f1b4e9de260b).postForm(form, url, "Shipping Address", async function(result) {
                    if (result.success) {
                        // GTM: Track successful new address addition (only for new addresses, not updates)
                        (0, $bWUN0.pushEvent)({
                            'event': 'formSubmission',
                            'formID': 'addNewAddress'
                        });
                        (0, $9zaOw.FlyoutManager).close("address");
                        // Check if we're on the shopping cart page
                        const cartAddressList = document.querySelector('.tmp-account-cart__addresses');
                        if (cartAddressList) // On cart page: fetch and replace the address list dynamically
                        $3ccabf6a7e25ddf1$var$refreshCartAddressList().then(()=>{
                            // Select the newly created address if we have its ID
                            if (result.data && result.data.id) {
                                const newAddressRadio = document.querySelector(`input[name="shippingAddressId"][value="${result.data.id}"]`);
                                if (newAddressRadio) newAddressRadio.checked = true;
                            }
                            // Clear address validation error since address is now selected
                            $3ccabf6a7e25ddf1$var$clearValidationError('address');
                        });
                        else {
                            // On shipping detail page: refresh the address list dynamically
                            const addressListContainer = document.getElementById('addressListContainer');
                            if (addressListContainer) await $3ccabf6a7e25ddf1$var$refreshAddressList();
                        }
                    } else // Handle error
                    console.error(result.error);
                });
            });
        }
    });
}
function $3ccabf6a7e25ddf1$var$initAddressListHandlers() {
    document.querySelectorAll('.edit-address').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            const flyout = document.getElementById('flyout-address');
            const addressFormContainer = document.getElementById('addressFormContainer');
            if (!addressFormContainer || !flyout) return;
            const form = document.getElementById('addressForm');
            if (form) (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
            $3ccabf6a7e25ddf1$var$resetFieldBorders();
            addressFormContainer.style.display = 'block';
            document.getElementById('Id').value = btn.dataset.id || '';
            document.getElementById('DisplayName').value = btn.dataset.displayname || '';
            document.getElementById('FirstName').value = btn.dataset.firstname || '';
            document.getElementById('LastName').value = btn.dataset.lastname || '';
            document.getElementById('CompanyName').value = btn.dataset.companyname || '';
            document.getElementById('AddressLine1').value = btn.dataset.addressline1 || '';
            document.getElementById('AddressLine2').value = btn.dataset.addressline2 || '';
            document.getElementById('City').value = btn.dataset.city || '';
            document.getElementById('State').value = btn.dataset.state || '';
            document.getElementById('ZipCode').value = btn.dataset.zipcode || '';
            document.getElementById('Country').value = btn.dataset.country || '';
            document.getElementById('DeliveryNotes').value = btn.dataset.deliverynotes || '';
            document.getElementById('PhoneNumber').value = btn.dataset.phonenumber || '';
            document.getElementById('IsDefault').checked = btn.dataset.isdefault === 'true';
            document.getElementById('addressFormTitle').textContent = "Edit Shipping Address";
            document.getElementById('addressFormSubmit').textContent = "Update Shipping Address";
            (0, $9zaOw.FlyoutManager).open("address");
        });
    });
    document.querySelectorAll('.delete-address').forEach(function(btn) {
        btn.addEventListener('click', async function() {
            // Show confirmation dialog before deleting
            if (!window.confirm('Are you sure you want to delete this address?')) return;
            const addressFormContainer = document.getElementById('addressFormContainer');
            if (!addressFormContainer) return;
            const id = btn.dataset.id;
            const response = await fetch(`/api/ShippingAddresses/${id}`, {
                method: 'DELETE',
                headers: await (0, $iouPm.getHeadersWithToken)({
                    'Accept': 'application/json'
                })
            });
            if (response.ok) // Success: you can update the UI or notify the user
            (0, $8cF6f.showToast)('Address deleted successfully.', 'success');
            else if (response.status === 404) (0, $8cF6f.showToast)('Address not found.', 'error');
            else (0, $8cF6f.showToast)('Failed to delete address.', 'error');
            await $3ccabf6a7e25ddf1$var$refreshAddressList();
        });
    });
    document.querySelectorAll('.set-default-address').forEach(function(input) {
        input.addEventListener('change', async function() {
            const id = this.value;
            const card = this.closest('.address-card');
            const payload = {
                id: id,
                displayName: card.querySelector('[data-displayname]')?.dataset.displayname || "",
                firstName: card.querySelector('[data-firstname]')?.dataset.firstname || "",
                lastName: card.querySelector('[data-lastname]')?.dataset.lastname || "",
                companyName: card.querySelector('[data-companyname]')?.dataset.companyname || "",
                addressLine1: card.querySelector('[data-addressline1]')?.dataset.addressline1 || "",
                addressLine2: card.querySelector('[data-addressline2]')?.dataset.addressline2 || "",
                city: card.querySelector('[data-city]')?.dataset.city || "",
                state: card.querySelector('[data-state]')?.dataset.state || "",
                zipCode: card.querySelector('[data-zipcode]')?.dataset.zipcode || "",
                country: card.querySelector('[data-country]')?.dataset.country || "",
                deliveryNotes: card.querySelector('[data-deliverynotes]')?.dataset.deliverynotes || "",
                phoneNumber: card.querySelector('[data-phonenumber]')?.dataset.phonenumber || "",
                isDefault: true
            };
            const response = await fetch(`/api/ShippingAddresses/${id}`, {
                method: 'PUT',
                headers: await (0, $iouPm.getHeadersWithToken)({
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }),
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                await $3ccabf6a7e25ddf1$var$refreshAddressList();
                window.location.reload();
            } else (0, $8cF6f.showToast)('Failed to update default address.', 'error');
        });
    });
}
async function $3ccabf6a7e25ddf1$var$refreshAddressList() {
    const container = document.getElementById('addressListContainer');
    if (!container) return Promise.resolve();
    const url = container.dataset.addressesUrl || 'getaddresses';
    return await fetch(url).then((response)=>response.text()).then((html)=>{
        container.innerHTML = html;
        $3ccabf6a7e25ddf1$var$initAddressListHandlers();
    });
}
function $3ccabf6a7e25ddf1$var$refreshCartAddressList() {
    const addressListContainer = document.querySelector('.tmp-account-cart__addresses');
    if (!addressListContainer) return Promise.resolve();
    // Get the refresh URL from data attribute
    const refreshUrl = addressListContainer.dataset.refreshUrl || 'GetAddressList';
    // Fetch the updated address list from the server
    return fetch(refreshUrl).then((response)=>response.text()).then((html)=>{
        // Replace the content of the address list
        addressListContainer.innerHTML = html;
        // Wire up change event listeners to the new radio buttons
        $3ccabf6a7e25ddf1$var$attachRadioValidationListeners();
    }).catch((error)=>{
        console.error('Error refreshing address list:', error);
    });
}
function $3ccabf6a7e25ddf1$var$attachRadioValidationListeners() {
    // Only applies to cart page - attaches listeners to clear validation errors
    const radioButtons = document.querySelectorAll('input[name="shippingAddressId"]');
    radioButtons.forEach(function(radio) {
        radio.addEventListener('change', function() {
            if (this.checked) $3ccabf6a7e25ddf1$var$clearValidationError('address');
        });
    });
}
const $3ccabf6a7e25ddf1$var$cancelBtn = document.querySelector('.address-form__buttons-cancel');
if ($3ccabf6a7e25ddf1$var$cancelBtn) $3ccabf6a7e25ddf1$var$cancelBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const form = document.getElementById('addressForm');
    if (form) {
        form.reset();
        (0, $acf010821545adc4$export$c1f4f1b4e9de260b).clearFormState(form);
    }
    (0, $9zaOw.FlyoutManager).close("address");
});
function $3ccabf6a7e25ddf1$var$resetFieldBorders() {
    const requiredFields = [
        'FirstName',
        'LastName',
        'CompanyName',
        'AddressLine1',
        'State',
        'City',
        'ZipCode'
    ];
    requiredFields.forEach((id)=>{
        const input = document.getElementById(id);
        if (input) input.classList.remove('input-error');
    });
}
function $3ccabf6a7e25ddf1$var$clearValidationError(keyword) {
    const validationSummary = document.querySelector('.validation-summary-errors ul');
    if (validationSummary) {
        const errors = validationSummary.querySelectorAll('li');
        errors.forEach((error)=>{
            if (error.textContent.toLowerCase().includes(keyword)) error.remove();
        });
        // Hide the summary if no errors remain
        if (validationSummary.querySelectorAll('li').length === 0) {
            const summaryContainer = document.querySelector('.validation-summary-errors');
            if (summaryContainer) summaryContainer.style.display = 'none';
        }
    }
}



var $5Q3m3 = parcelRequire("5Q3m3");


function $081ba289f1c9a9d9$export$48cb63b51e451653() {
    const carousels = document.querySelectorAll('.cmp-testimonial');
    carousels.forEach((container)=>{
        const swiperEl = container.querySelector('.swiper') || container;
        const paginationEl = container.querySelector('.swiper-pagination');
        const nextBtn = container.querySelector('.swiper-button-next');
        const prevBtn = container.querySelector('.swiper-button-prev');
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(swiperEl, {
            slidesPerView: 1,
            loop: true,
            spaceBetween: 10,
            pagination: {
                el: paginationEl,
                clickable: true
            },
            navigation: {
                nextEl: nextBtn,
                prevEl: prevBtn
            }
        });
    });
}



var $1srIE = parcelRequire("1srIE");

var $6PIFj = parcelRequire("6PIFj");

var $2kmti = parcelRequire("2kmti");

var $8GGcu = parcelRequire("8GGcu");

var $iouPm = parcelRequire("iouPm");

var $9zaOw = parcelRequire("9zaOw");

var $9CCCV = parcelRequire("9CCCV");
let $01ba5e37e51cd6c2$var$root = null;
function $01ba5e37e51cd6c2$export$771dc24fef65f395({ itemId: itemId }) {
    const [boards, setBoards] = (0, $6PIFj.useState)([]);
    const [selectedBoards, setSelectedBoards] = (0, $6PIFj.useState)([]);
    const [successBoards, setSuccessBoards] = (0, $6PIFj.useState)([]);
    const [showForm, setShowForm] = (0, $6PIFj.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $6PIFj.useState)(null);
    (0, $6PIFj.useEffect)(()=>{
        fetchBoards();
    }, []);
    (0, $6PIFj.useEffect)(()=>{
        const handleFlyoutClosed = (event)=>{
            if (event?.detail?.id !== "addToBoard") return;
            setSuccessBoards([]);
            setErrorMessage(null);
        };
        document.addEventListener("flyout:closed", handleFlyoutClosed);
        return ()=>{
            document.removeEventListener("flyout:closed", handleFlyoutClosed);
        };
    }, []);
    async function fetchBoards() {
        try {
            const data = await (0, $iouPm.projectBoardsList)();
            setBoards(data.items);
        } catch (err) {
            console.error("Failed to load boards", err);
            setBoards([]);
        }
    }
    function handleToggle(boardId) {
        setSelectedBoards((prev)=>prev.includes(boardId) ? prev.filter((id)=>id !== boardId) : [
                ...prev,
                boardId
            ]);
    }
    async function handleAddToBoards() {
        const results = await (0, $iouPm.projectBoardItemsAdd)(selectedBoards, itemId);
        const failed = results.filter((r)=>!r.success).map((r)=>r.boardId);
        if (failed.length > 0) setErrorMessage(`Failed to add item to ${failed.length} board(s). Please try again.`);
        else {
            setErrorMessage(null);
            setSuccessBoards(selectedBoards);
            setSelectedBoards([]);
        }
    }
    function handleBoardSaved(newBoardId) {
        fetchBoards().then(()=>{
            setShowForm(false);
            setSelectedBoards([
                newBoardId
            ]);
        });
    }
    return /*#__PURE__*/ (0, $1srIE.jsx)("div", {
        className: "cmp-add-to-board",
        children: showForm ? /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $1srIE.jsxs)("a", {
                    href: "#",
                    className: "cmp-add-to-board__back",
                    onClick: (e)=>{
                        e.preventDefault();
                        setShowForm(false);
                    },
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                            src: "/images/arrow-left.svg",
                            alt: "Back",
                            className: "cmp-add-to-board__back-icon"
                        }),
                        "Back to Add to Project Board"
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)((0, $9CCCV.ProjectBoardForm), {
                    onBoardSaved: handleBoardSaved
                })
            ]
        }) : /*#__PURE__*/ (0, $1srIE.jsxs)((0, $1srIE.Fragment), {
            children: [
                /*#__PURE__*/ (0, $1srIE.jsx)("h4", {
                    className: "cmp-add-to-board__title",
                    children: "Add to Project Board"
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                    className: "cmp-add-to-board__subtitle",
                    children: "Select the board(s) to add this style:"
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                    className: "cmp-add-to-board__select-all",
                    children: /*#__PURE__*/ (0, $1srIE.jsxs)("label", {
                        className: "cmp-add-to-board__select-all-label",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("input", {
                                type: "checkbox",
                                checked: selectedBoards.length === boards.length && boards.length > 0,
                                onChange: ()=>{
                                    if (selectedBoards.length === boards.length) setSelectedBoards([]);
                                    else setSelectedBoards(boards.map((b)=>b.id));
                                }
                            }),
                            "Select all"
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("ul", {
                    className: "cmp-add-to-board__list",
                    children: boards.map((board)=>/*#__PURE__*/ (0, $1srIE.jsx)("li", {
                            className: "cmp-add-to-board__item",
                            children: /*#__PURE__*/ (0, $1srIE.jsxs)("label", {
                                className: "cmp-add-to-board__label",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsx)("input", {
                                        type: "checkbox",
                                        checked: selectedBoards.includes(board.id),
                                        onChange: ()=>handleToggle(board.id)
                                    }),
                                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                        className: "cmp-add-to-board__board",
                                        children: [
                                            board.coverImageUrl && /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                src: board.coverImageUrl,
                                                alt: board.name,
                                                className: "cmp-add-to-board__thumbnail"
                                            }),
                                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                                className: "cmp-add-to-board__info",
                                                children: [
                                                    board.publicUrl ? /*#__PURE__*/ (0, $1srIE.jsx)("a", {
                                                        href: board.publicUrl,
                                                        target: "_blank",
                                                        children: /*#__PURE__*/ (0, $1srIE.jsx)("span", {
                                                            className: "cmp-add-to-board__name",
                                                            children: board.name
                                                        })
                                                    }) : /*#__PURE__*/ (0, $1srIE.jsx)("span", {
                                                        className: "cmp-add-to-board__name",
                                                        children: board.name
                                                    }),
                                                    /*#__PURE__*/ (0, $1srIE.jsx)("span", {
                                                        className: "cmp-add-to-board__segments",
                                                        children: board.segmentTypes?.length ? board.segmentTypes.map((st)=>st.name).join(", ") : ""
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, board.id))
                }),
                successBoards.length > 0 && /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "cmp-add-to-board__success",
                    children: [
                        "Added to ",
                        successBoards.length > 1 ? "boards" : "board",
                        " successfully!"
                    ]
                }),
                errorMessage && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                    className: "cmp-add-to-board__error",
                    children: errorMessage
                }),
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "cmp-add-to-board__actions",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                            className: "btn",
                            onClick: handleAddToBoards,
                            disabled: selectedBoards.length === 0,
                            children: "Add To Board"
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                            className: "btn-secondary",
                            onClick: ()=>(0, $9zaOw.FlyoutManager).close("addToBoard"),
                            children: "Cancel"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("hr", {
                    className: "cmp-add-to-board__divider"
                }),
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "cmp-add-to-board__create",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                            className: "cmp-add-to-board__create-missing",
                            children: "Missing a board?"
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                            className: "btn-secondary",
                            onClick: ()=>setShowForm(true),
                            children: "Create a New Project Board"
                        })
                    ]
                })
            ]
        })
    });
}
function $01ba5e37e51cd6c2$export$dc623ba6c13219d6(assetInfo, trigger = null) {
    if (!$01ba5e37e51cd6c2$var$root) {
        console.error("AddToBoard root not found");
        return;
    }
    const isAuthenticated = window.mannington.isAuthenticated === true;
    if (isAuthenticated) {
        (0, $8GGcu.flushSync)(()=>{
            $01ba5e37e51cd6c2$var$root.render(/*#__PURE__*/ (0, $1srIE.jsx)($01ba5e37e51cd6c2$export$771dc24fef65f395, {
                itemId: assetInfo
            }));
        });
        (0, $9zaOw.FlyoutManager).open("addToBoard", trigger);
    } else (0, $9zaOw.FlyoutManager).open("SignInForm", trigger);
}
function $01ba5e37e51cd6c2$export$26de3d8b25ea080c() {
    const container = document.getElementById("add-to-board-root");
    if (!container) return;
    $01ba5e37e51cd6c2$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($2kmti))).createRoot(container);
    const buttons = document.querySelectorAll('[data-flyout-trigger="addToBoard"]');
    buttons.forEach((button)=>{
        button.addEventListener("click", (e)=>{
            e.preventDefault();
            e.stopPropagation();
            // Try to read data-asset-info directly from the button
            let assetInfo = button.getAttribute("data-asset-info");
            // Fallback: look inside the wrapper for the add-to-board image
            if (!assetInfo) {
                const wrapper = button.closest(".add-to-board-wrapper");
                if (!wrapper) return;
                const imgEl = wrapper.querySelector("img.add-to-board[data-mc-project-board-asset-info]");
                if (!imgEl) return;
                assetInfo = imgEl.getAttribute("data-mc-project-board-asset-info");
            }
            if (!assetInfo) return;
            $01ba5e37e51cd6c2$export$dc623ba6c13219d6(assetInfo, button);
        }, true);
    });
}







var $fWVzk = parcelRequire("fWVzk");
function $80acd778e4ef8923$export$55b4e627ff05ebe0() {
    const carousels = document.querySelectorAll('.cmp-featuredproductlisting.swiper');
    carousels.forEach((carousel)=>{
        const nextEls = Array.from(carousel.querySelectorAll('.swiper-button-next-desktop, .swiper-button-next-mobile'));
        const prevEls = Array.from(carousel.querySelectorAll('.swiper-button-prev-desktop, .swiper-button-prev-mobile'));
        const paginationEl = carousel.querySelector('.swiper-pagination');
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(carousel, {
            slidesPerView: 1,
            spaceBetween: 16,
            loop: true,
            navigation: {
                nextEl: nextEls,
                prevEl: prevEls
            },
            pagination: {
                el: paginationEl,
                clickable: true
            },
            breakpoints: {
                [(0, $fWVzk.BREAKPOINTS).MEDIUM]: {
                    slidesPerView: 3,
                    spaceBetween: 10
                },
                [(0, $fWVzk.BREAKPOINTS).LARGE]: {
                    slidesPerView: 4.5,
                    spaceBetween: 10
                }
            }
        });
    });
}



var $1srIE = parcelRequire("1srIE");

var $6PIFj = parcelRequire("6PIFj");

var $2kmti = parcelRequire("2kmti");
function $0e4623e8f9bbec40$export$2e2bcd8739ae039() {
    const [items, setItems] = (0, $6PIFj.useState)([]);
    const [message, setMessage] = (0, $6PIFj.useState)("");
    (0, $6PIFj.useEffect)(()=>{
        function handleCompareToggle(e) {
            const { img: img, code: code, checked: checked } = e.detail;
            const normalizedImg = typeof img === "string" && img.trim().length > 0 ? img : null;
            setItems((prev)=>{
                if (checked) {
                    if (prev.some((p)=>p.code === code)) return prev;
                    if (prev.length >= 6) {
                        setMessage("You can compare up to 6 items");
                        return prev;
                    }
                    return [
                        ...prev,
                        {
                            img: normalizedImg,
                            code: code
                        }
                    ];
                } else return prev.filter((p)=>p.code !== code);
            });
        }
        window.addEventListener("compare-toggle", handleCompareToggle);
        return ()=>window.removeEventListener("compare-toggle", handleCompareToggle);
    }, []);
    function removeItem(code) {
        window.dispatchEvent(new CustomEvent("compare-toggle", {
            detail: {
                code: code,
                img: null,
                checked: false
            }
        }));
    }
    function removeAll() {
        items.forEach((item)=>{
            window.dispatchEvent(new CustomEvent("compare-toggle", {
                detail: {
                    code: item.code,
                    img: null,
                    checked: false
                }
            }));
        });
    }
    const isVisible = items.length > 0;
    const slots = [
        ...items
    ];
    while(slots.length < 6)slots.push(null);
    return /*#__PURE__*/ (0, $1srIE.jsx)((0, $1srIE.Fragment), {
        children: /*#__PURE__*/ (0, $1srIE.jsx)("div", {
            className: `compare-drawer ${isVisible ? "" : "hidden"}`,
            children: /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                className: "compare-drawer__wrapper",
                children: [
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-drawer__wrapper-content",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                className: "compare-drawer__header",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsx)("h4", {
                                        className: "compare-drawer__header-title",
                                        children: "Compare Products"
                                    }),
                                    /*#__PURE__*/ (0, $1srIE.jsxs)("p", {
                                        className: "compare-drawer__header-total",
                                        children: [
                                            items.length,
                                            " of 6 Selected"
                                        ]
                                    }),
                                    message && /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                        className: "compare-drawer__error",
                                        children: message
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                className: "compare-drawer__content",
                                children: /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                    className: "compare-drawer__items",
                                    children: slots.map((item, i)=>item ? /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                            className: "compare-drawer__item",
                                            children: [
                                                item.img ? /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                    src: item.img,
                                                    alt: item.code,
                                                    className: "compare-drawer__item-img"
                                                }) : null,
                                                /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                                    className: "compare-drawer__remove",
                                                    onClick: ()=>removeItem(item.code),
                                                    children: /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                        src: "/images/close-icon.svg",
                                                        alt: "Remove"
                                                    })
                                                })
                                            ]
                                        }, item.code) : /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                            className: "compare-drawer__item empty"
                                        }, `empty-${i}`))
                                })
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                className: "compare-drawer__buttons",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                        type: "button",
                                        className: "btn",
                                        onClick: ()=>window.compareModal?.open(),
                                        children: "Compare Styles"
                                    }),
                                    /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                        type: "button",
                                        className: "btn-secondary",
                                        onClick: removeAll,
                                        children: "Remove All"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-drawer__buttons-mobile",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                type: "button",
                                className: "compare-drawer__cta",
                                onClick: ()=>window.compareModal?.open(),
                                children: /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                    src: "/images/arrow-right-white.svg",
                                    alt: "Compare Styles"
                                })
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                type: "button",
                                className: "compare-drawer__removeall",
                                onClick: removeAll,
                                children: "Remove All"
                            })
                        ]
                    })
                ]
            })
        })
    });
}
function $0e4623e8f9bbec40$export$49d9a96ac5239fc() {
    const container = document.getElementById("compareDrawerRoot");
    if (!container) return;
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($2kmti))).createRoot(container);
    root.render(/*#__PURE__*/ (0, $1srIE.jsx)($0e4623e8f9bbec40$export$2e2bcd8739ae039, {}));
}



var $1srIE = parcelRequire("1srIE");

var $6PIFj = parcelRequire("6PIFj");

var $8GGcu = parcelRequire("8GGcu");

var $2kmti = parcelRequire("2kmti");

var $1srIE = parcelRequire("1srIE");

var $6PIFj = parcelRequire("6PIFj");



var $7H02q = parcelRequire("7H02q");

var $8cF6f = parcelRequire("8cF6f");
function $2178642afe9b3e63$export$2e2bcd8739ae039({ product: product, setProductCodes: setProductCodes, checkoutEnabled: checkoutEnabled = true }) {
    const nonBreakingSpace = "\u00a0";
    const swiperRef = (0, $6PIFj.useRef)(null);
    const swiperContainerRef = (0, $6PIFj.useRef)(null);
    const bodyRef = (0, $6PIFj.useRef)(null);
    const swiperId = product.styleCatalogCode;
    const variantTypeSingular = product.isStylesFirst ? "Style" : "Colorway";
    const variantTypePlural = product.isStylesFirst ? "Styles" : "Colorways";
    // a lot of the code talks about colorways, but later on styles became a variant-type.
    // if a pattern is style first then the variant type will be style, otherwise it will be colorways.
    // this isn't always 
    const mergedColorways = (()=>{
        // this used to add the room scenes into the list of colorways.
        // i am lazy and leaving this.
        return (product.isStylesFirst ? product.styles : product.colorways) || [];
    })();
    const [selectedColorwayIndex, setSelectedColorwayIndex] = (0, $6PIFj.useState)(null);
    const selectedColorway = selectedColorwayIndex != null ? mergedColorways[selectedColorwayIndex] || null : null;
    const [isSpecOpen, setIsSpecOpen] = (0, $6PIFj.useState)(false);
    const [isSustOpen, setIsSustOpen] = (0, $6PIFj.useState)(false);
    const specGroups = (0, $6PIFj.useMemo)(()=>Array.isArray(product?.specGroups) ? product.specGroups : [], [
        product
    ]);
    const findGroupByName = (0, $6PIFj.useCallback)((groupName)=>specGroups.find((group)=>typeof group?.name === "string" && group.name.trim().toLowerCase() === groupName), [
        specGroups
    ]);
    const overviewGroup = (0, $6PIFj.useMemo)(()=>findGroupByName("overview"), [
        findGroupByName
    ]);
    const sustainabilityGroup = (0, $6PIFj.useMemo)(()=>findGroupByName("sustainability"), [
        findGroupByName
    ]);
    const extractSpecText = (value)=>{
        if (!value || value.hasValue === false) return "";
        const typeName = typeof value["$type"] === "string" ? value["$type"] : "";
        if (typeName === "SpecString" || typeName === "string") return typeof value.value === "string" ? value.value.trim() : "";
        if (typeName === "SpecLink" || typeName === "link") {
            const linkText = typeof value.linkText === "string" ? value.linkText.trim() : "";
            const url = typeof value.url === "string" ? value.url.trim() : "";
            return linkText || url;
        }
        return "";
    };
    const renderSpecGroup = (group, emptyMessage)=>{
        const specs = Array.isArray(group?.specs) ? group.specs : [];
        const rows = specs.map((spec, specIndex)=>{
            const specName = spec?.name?.trim();
            if (!specName) return null;
            const displayValues = (Array.isArray(spec.values) ? spec.values : []).map(extractSpecText).filter(Boolean);
            if (displayValues.length === 0) return null;
            return /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                className: "compare-card__accordion-row",
                children: [
                    /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                        className: "compare-card__label",
                        children: specName
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                        className: "compare-card__accordion-values",
                        children: displayValues.map((text, valueIndex)=>/*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__value compare-card__value-accordion",
                                children: text || nonBreakingSpace
                            }, `${specName}-${valueIndex}`))
                    })
                ]
            }, `${specName}-${specIndex}`);
        }).filter(Boolean);
        if (rows.length === 0) return /*#__PURE__*/ (0, $1srIE.jsx)("p", {
            className: "compare-card__accordion-empty",
            children: emptyMessage
        });
        return rows;
    };
    const handleBodyWheel = (0, $6PIFj.useCallback)((event)=>{
        const body = event.currentTarget;
        const itemsContainer = body.closest(".compare-modal__items");
        if (!itemsContainer) return;
        const horizontalIntent = event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontalIntent) {
            const delta = event.deltaX !== 0 ? event.deltaX : event.deltaY;
            itemsContainer.scrollLeft += delta;
            event.preventDefault();
            return;
        }
        const bodyIsScrollable = body.scrollHeight > body.clientHeight;
        if (!bodyIsScrollable) {
            itemsContainer.scrollLeft += event.deltaY;
            event.preventDefault();
        }
    }, []);
    const handleOrderSample = async ()=>{
        try {
            const response = await (0, $7H02q.default).addBestSampleToCart(selectedColorway.catalogCode, 1);
            if (response.success) {
                const name = `${response.patternFamilyName}: ${response.variantName}`;
                (0, $8cF6f.showToast)(`${name} sample added to cart.`, "success");
            } else {
                console.error("Error adding sample to cart:", response);
                (0, $8cF6f.showToast)("Sorry, there was an error adding the sample to your cart.", "error");
            }
        } catch (e) {
            console.error("Error adding sample to cart:", e);
            (0, $8cF6f.showToast)("Sorry, there was an error adding the sample to your cart.", "error");
        }
    };
    (0, $6PIFj.useEffect)(()=>{
        const bodyElement = bodyRef.current;
        if (!bodyElement) return;
        bodyElement.addEventListener("wheel", handleBodyWheel, {
            passive: false
        });
        return ()=>{
            bodyElement.removeEventListener("wheel", handleBodyWheel);
        };
    }, [
        handleBodyWheel
    ]);
    (0, $6PIFj.useEffect)(()=>{
        if (!swiperContainerRef.current || mergedColorways.length <= 1) return;
        if (swiperRef.current) swiperRef.current.destroy(true, true);
        swiperRef.current = new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(`#color-swiper-${swiperId}`, {
            slidesPerView: 5,
            spaceBetween: 8,
            navigation: {
                nextEl: `.swiper-button-next-${swiperId}`,
                prevEl: `.swiper-button-prev-${swiperId}`
            }
        });
        return ()=>{
            if (swiperRef.current) swiperRef.current.destroy(true, true);
        };
    }, [
        mergedColorways,
        swiperId
    ]);
    return /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
        className: "compare-card",
        children: [
            /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                src: selectedColorway?.mainImage?.url || product.styleMainImage?.url,
                alt: product.styleName,
                className: "compare-card__image"
            }),
            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                className: "compare-card__body",
                ref: bodyRef,
                children: [
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__section",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__label",
                                children: "Style"
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__value",
                                children: product.styleName || nonBreakingSpace
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__section",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__label",
                                children: "Collection"
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__value",
                                children: product.collectionName || nonBreakingSpace
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__section",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__label",
                                children: "Style Number"
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__value",
                                children: product.styleNumber || nonBreakingSpace
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__section",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__label",
                                children: variantTypeSingular
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                className: "compare-card__value",
                                children: selectedColorway?.name || 'Select Below'
                            })
                        ]
                    }),
                    mergedColorways.length > 0 && /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__colors",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsxs)("p", {
                                className: "compare-card__label",
                                children: [
                                    mergedColorways.length,
                                    " ",
                                    variantTypePlural
                                ]
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                className: "compare-card__colors-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                        className: `swiper-button-prev swiper-button-prev-${swiperId}`
                                    }),
                                    /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                        id: `color-swiper-${swiperId}`,
                                        ref: swiperContainerRef,
                                        className: "compare-card__color-swatches swiper",
                                        children: /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                            className: "swiper-wrapper",
                                            children: mergedColorways.map((cw, i)=>/*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                                    className: `compare-card__color-swatch swiper-slide ${i === selectedColorwayIndex ? "active" : ""}`,
                                                    onClick: ()=>setSelectedColorwayIndex(i),
                                                    children: /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                                        className: `compare-card__color-swatch-image-wrapper ${i === selectedColorwayIndex ? "selected" : ""}`,
                                                        children: /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                            src: cw.mainImage?.url,
                                                            alt: cw.name,
                                                            className: "compare-card__color-swatch-image"
                                                        })
                                                    })
                                                }, `${product.styleCatalogCode}-color-${i}`))
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                        className: `swiper-button-next swiper-button-next-${swiperId}`
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                        className: "compare-card__accordion-wrapper",
                        children: [
                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                className: "compare-card__accordion",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                        className: "compare-card__accordion-header",
                                        onClick: ()=>setIsSpecOpen(!isSpecOpen),
                                        children: [
                                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                                children: "Specifications"
                                            }),
                                            /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                src: isSpecOpen ? "/images/minus-sign.svg" : "/images/plus-sign.svg",
                                                alt: isSpecOpen ? "Collapse" : "Expand"
                                            })
                                        ]
                                    }),
                                    isSpecOpen && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                        className: "compare-card__accordion-body",
                                        children: renderSpecGroup(overviewGroup, "Specifications not available.")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                className: "compare-card__accordion",
                                children: [
                                    /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                                        className: "compare-card__accordion-header",
                                        onClick: ()=>setIsSustOpen(!isSustOpen),
                                        children: [
                                            /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                                                children: "Sustainability"
                                            }),
                                            /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                                src: isSustOpen ? "/images/minus-sign.svg" : "/images/plus-sign.svg",
                                                alt: isSustOpen ? "Collapse" : "Expand"
                                            })
                                        ]
                                    }),
                                    isSustOpen && /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                                        className: "compare-card__accordion-body",
                                        children: renderSpecGroup(sustainabilityGroup, "Sustainability information not available.")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                className: "compare-card__footer",
                children: [
                    checkoutEnabled && /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                        className: "btn",
                        disabled: selectedColorway === null,
                        onClick: (_)=>handleOrderSample(),
                        children: "Order Sample"
                    }),
                    /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                        className: "btn-secondary",
                        onClick: ()=>{
                            setProductCodes((prev)=>prev.filter((c)=>c !== product.styleCatalogCode));
                            window.dispatchEvent(new CustomEvent("compare-toggle", {
                                detail: {
                                    code: product.styleCatalogCode,
                                    img: "",
                                    checked: false
                                }
                            }));
                        },
                        children: "Remove Style"
                    })
                ]
            })
        ]
    });
}


function $db7fac7cfe2ac236$export$2e2bcd8739ae039({ checkoutEnabled: checkoutEnabled = true }) {
    const [productCodes, setProductCodes] = (0, $6PIFj.useState)([]);
    const [products, setProducts] = (0, $6PIFj.useState)([]);
    const [isOpen, setIsOpen] = (0, $6PIFj.useState)(false);
    const [loading, setLoading] = (0, $6PIFj.useState)(false);
    (0, $6PIFj.useEffect)(()=>{
        function handleCompareToggle(e) {
            const { code: code, checked: checked } = e.detail;
            setProductCodes((prev)=>{
                if (checked) {
                    if (prev.includes(code)) return prev;
                    if (prev.length >= 6) return prev;
                    return [
                        ...prev,
                        code
                    ];
                } else return prev.filter((c)=>c !== code);
            });
        }
        window.addEventListener("compare-toggle", handleCompareToggle);
        return ()=>window.removeEventListener("compare-toggle", handleCompareToggle);
    }, []);
    (0, $6PIFj.useEffect)(()=>{
        if (productCodes.length === 0) {
            setProducts([]);
            setLoading(false);
        }
        if (!isOpen || productCodes.length === 0) return;
        const controller = new AbortController();
        const fetchProducts = async ()=>{
            try {
                setLoading(true);
                const query = productCodes.map((c)=>`codes=${encodeURIComponent(c)}`).join("&");
                const res = await fetch(`/api/Catalog/products/compare?${query}`, {
                    signal: controller.signal
                });
                if (!res.ok) throw new Error("Failed to fetch compare data");
                const data = await res.json();
                setProducts(data.products || []);
            } catch (err) {
                if (err.name !== "AbortError") console.error("Compare fetch error:", err);
            } finally{
                setLoading(false);
            }
        };
        fetchProducts();
        return ()=>controller.abort();
    }, [
        isOpen,
        productCodes
    ]);
    const open = ()=>setIsOpen(true);
    const close = ()=>setIsOpen(false);
    const removeAll = ()=>{
        productCodes.forEach((code)=>{
            window.dispatchEvent(new CustomEvent("compare-toggle", {
                detail: {
                    code: code,
                    img: "",
                    checked: false
                }
            }));
        });
        setProductCodes([]);
    };
    (0, $6PIFj.useEffect)(()=>{
        window.compareModal = {
            open: open,
            close: close
        };
    }, []);
    (0, $6PIFj.useEffect)(()=>{
        document.body.style.overflow = isOpen ? "hidden" : "";
    }, [
        isOpen
    ]);
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8GGcu))).createPortal(/*#__PURE__*/ (0, $1srIE.jsx)("div", {
        className: "compare-modal-overlay",
        onClick: close,
        children: /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
            className: "compare-modal",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                    className: "compare-modal__header",
                    children: [
                        /*#__PURE__*/ (0, $1srIE.jsxs)("div", {
                            className: "compare-modal__header-title",
                            children: [
                                /*#__PURE__*/ (0, $1srIE.jsx)("h2", {
                                    children: "Compare Styles"
                                }),
                                /*#__PURE__*/ (0, $1srIE.jsxs)("p", {
                                    children: [
                                        products.length,
                                        " Selected"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                            className: "compare-modal__header-actions compare-modal__header-actions-desktop",
                            children: /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                                className: "btn-secondary",
                                onClick: ()=>removeAll(),
                                children: "Remove All"
                            })
                        }),
                        /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                            type: "button",
                            className: "compare-modal__close",
                            onClick: close,
                            children: /*#__PURE__*/ (0, $1srIE.jsx)("img", {
                                src: "/images/close-icon.svg",
                                alt: "Close modal"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                    className: "compare-modal__content",
                    children: loading ? /*#__PURE__*/ (0, $1srIE.jsx)("p", {
                        className: "compare-modal__loading",
                        children: "Loading..."
                    }) : /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                        className: "compare-modal__items",
                        children: products.map((p)=>/*#__PURE__*/ (0, $1srIE.jsx)((0, $2178642afe9b3e63$export$2e2bcd8739ae039), {
                                product: p,
                                setProductCodes: setProductCodes,
                                checkoutEnabled: checkoutEnabled
                            }, p.styleCatalogCode))
                    })
                }),
                /*#__PURE__*/ (0, $1srIE.jsx)("div", {
                    className: "compare-modal__header-actions compare-modal__header-actions-mobile",
                    children: /*#__PURE__*/ (0, $1srIE.jsx)("button", {
                        className: "btn-secondary",
                        onClick: ()=>removeAll(),
                        children: "Remove All"
                    })
                })
            ]
        })
    }), document.body);
}
function $db7fac7cfe2ac236$export$4c39ae523cffaaac() {
    const container = document.getElementById("compareModalRoot");
    if (!container) return;
    // pass the checkout-enabled flag down to the modal so the cards can use it.
    // defaults to true to keep existing functionality.
    const checkoutEnabledAttr = container.getAttribute("data-checkout-enabled");
    const checkoutEnabled = JSON.parse(checkoutEnabledAttr ?? "true");
    const root = (0, (/*@__PURE__*/$parcel$interopDefault($2kmti))).createRoot(container);
    root.render(/*#__PURE__*/ (0, $1srIE.jsx)($db7fac7cfe2ac236$export$2e2bcd8739ae039, {
        checkoutEnabled: checkoutEnabled
    }));
}





var $fWVzk = parcelRequire("fWVzk");
function $5ed318ea0afa6dda$export$1a37a0ba361730bc() {
    const carousels = document.querySelectorAll('.cmp-upcomingevents');
    carousels.forEach((carousel)=>{
        const swiperEl = carousel.querySelector('.swiper');
        const nextBtn = carousel.querySelector('.swiper-button-next');
        const prevBtn = carousel.querySelector('.swiper-button-prev');
        const mobileNextBtn = carousel.querySelector('.swiper-button-next-mobile');
        const mobilePrevBtn = carousel.querySelector('.swiper-button-prev-mobile');
        if (!swiperEl) return;
        new (0, $74e74a0b53d40157$export$25ce5a424b770e84)(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: [
                    nextBtn,
                    mobileNextBtn
                ],
                prevEl: [
                    prevBtn,
                    mobilePrevBtn
                ]
            },
            loop: true,
            speed: 500,
            allowTouchMove: window.innerWidth > (0, $fWVzk.BREAKPOINTS).LARGE
        });
    });
}



var $iouPm = parcelRequire("iouPm");


var $8cF6f = parcelRequire("8cF6f");

function $d89054caf267f12e$export$3d535f4908aec6fc() {
    if (document.querySelector('html.page-visualizerpage') === null) {
        console.debug('visualizer page not found, skipping visualizer init');
        return;
    }
    function getVisualizerType() {
        const container = document.querySelector('div.visualizer-container');
        return container?.dataset.visualizerType ?? null;
    }
    // table of visualizer configurations, keyed by VisualizerType
    //  the "buildModel" method should take the data from the visualizer and return a json object that can be sent to the 
    //  verification api. the "$type" property must match a type specified on "VisualizerModelBase".
    const visualizerConfigs = {
        "ActiveLines": {
            buildModel: (data)=>{
                return {
                    "$type": "ActiveLinesVisualizerModel",
                    style: data?.style,
                    size: data?.size,
                    profile: data?.profile,
                    products: data?.products
                };
            }
        },
        "CustomCarpet": {
            buildModel: (data)=>{
                return {
                    "$type": "CustomCarpetVisualizerModel",
                    projectUrl: data?.projectUrl,
                    renderUrl: data?.rugImageUrl
                };
            }
        },
        "CustomRug": {
            buildModel: (data)=>{
                return {
                    "$type": "CustomRugVisualizerModel",
                    projectUrl: data?.projectUrl,
                    renderUrl: data?.rugImageUrl
                };
            }
        },
        "RoomScenes": {
            buildModel: (data)=>{
                let submenu = null;
                if (data?.projectUrl) try {
                    const url = new URL(data.projectUrl);
                    submenu = url.searchParams.get('submenu');
                } catch (e) {
                    console.warn('Failed to parse projectUrl:', e);
                }
                return {
                    "$type": "RoomSceneVisualizerModel",
                    selString: data?.selstring,
                    specifier: data?.specifier,
                    seriesIds: data?.seriesUsed,
                    submenu: submenu
                };
            }
        },
        "LayingPatterns": {
            buildModel: (data)=>{
                return {
                    "$type": "LayingPatternsVisualizerModel",
                    activePatternId: data?.activePatternId,
                    productSelection: data?.productSelection
                };
            }
        }
    };
    function getConfig() {
        const type = getVisualizerType();
        if (!type) throw new Error('no visualizer type found');
        const config = visualizerConfigs[type];
        if (!config) throw new Error(`no config found for visualizer type: ${type}`);
        return config;
    }
    async function handleSaveRequest(data) {
        const config = getConfig();
        const visualizerInfo = config.buildModel(data);
        const visualizerInfoString = JSON.stringify(visualizerInfo);
        // Encrypt the visualizer info
        const response = await fetch('/api/visualizer/encrypt', {
            method: 'POST',
            headers: await (0, $iouPm.getHeadersWithToken)({
                'Content-Type': 'application/json'
            }),
            body: visualizerInfoString
        });
        if (!response.ok) throw new Error('Failed to encrypt visualizer info');
        // API returns a raw encrypted string, not a JSON object
        const encryptedString = await response.text();
        (0, $01ba5e37e51cd6c2$export$dc623ba6c13219d6)(encryptedString);
        return {
            status: 'UI_OPENED'
        };
    }
    async function handleFetchProjects() {
        try {
            const api = await Promise.resolve((parcelRequire("iouPm")));
            const list = await api.projectBoardsList();
            return list?.items ?? [];
        } catch (err) {
            console.error('Error fetching project boards:', err);
            return [];
        }
    }
    window.addEventListener('message', (e)=>{
        if (!e.data || !e.data.type) return;
        // todo: check origin
        switch(e.data.type){
            case 'SAVE_REQUEST':
                handleSaveRequest(e.data.payload).then((result)=>e.source?.postMessage({
                        type: 'SAVE_ACK',
                        receivedAt: Date.now(),
                        result: result
                    }, e.origin || '*')).catch((err)=>{
                    console.error('error handling save request', err);
                    (0, $8cF6f.showToast)('Sorry, there was an error saving your visualizer data. Please try again later.', 'error');
                });
                break;
            case 'FETCH_PROJECTS':
                handleFetchProjects().then((projects)=>e.source?.postMessage({
                        type: 'PROJECTS_DATA',
                        projects: projects,
                        queryParams: e.data.queryParams,
                        receivedAt: Date.now()
                    }, e.origin || '*')).catch((err)=>console.error('error fetching project data', err));
                break;
            default:
                console.warn(`unhandled message type: ${e.data.type}`, e.data);
                break;
        }
    });
}


function $cb7c0b3381c9608e$export$a658e50cde83fe78() {
    document.addEventListener("DOMContentLoaded", ()=>{
        const accordions = document.querySelectorAll(".tmp-orderhistory [data-accordion]");
        if (!accordions.length) return;
        accordions.forEach((acc)=>{
            const toggle = acc.querySelector("[data-accordion-toggle]");
            const content = acc.querySelector("[data-accordion-content]");
            const icon = toggle?.querySelector(".order-accordion__icon");
            if (!toggle || !content) return;
            const plusSrc = icon?.dataset.iconPlus || icon?.getAttribute("src");
            const minusSrc = icon?.dataset.iconMinus || plusSrc;
            const setState = (open)=>{
                acc.classList.toggle("open", open);
                toggle.setAttribute("aria-expanded", open.toString());
                content.hidden = !open;
                if (icon && plusSrc && minusSrc) {
                    icon.setAttribute("src", open ? minusSrc : plusSrc);
                    icon.setAttribute("alt", open ? "Collapse order" : "Expand order");
                }
            };
            setState(acc.classList.contains("open"));
            toggle.addEventListener("click", ()=>{
                setState(!acc.classList.contains("open"));
            });
        });
    });
}



var $eUy0V = parcelRequire("eUy0V");
parcelRequire("bWUN0");

var $7H02q = parcelRequire("7H02q");
window.mannington = window.mannington || {};
window.htmx = (0, $eUy0V.default);
// Update cart count badges when cart is updated via HTMX
document.body.addEventListener('htmx:afterSwap', (event)=>{
    if (event.detail.target.classList.contains('tmp-account-cart')) (0, $7H02q.default).refreshCartCount();
});

// expose function to lazy load product details
window.mannington.initializeProductDetails = async (args)=>{
    const module = await (parcelRequire("23OgD"));
    return module.initializeProductDetails(args);
};
(0, $7d4b08104d2dc6af$export$6e9847a60c738c4d)();
(0, $3bb2332a5ac38c00$export$963762d7be283e09)();
(0, $2101ee1b4e112d93$export$f09be6266877bf97)();
(0, $2b90fe259d1f6d7e$export$dba48aad7ea58a0)();
(0, $f96d6717bc10e65b$export$4c75c8c3488dfe0)();
(0, $3ff5e247f05a2348$export$d2ccd73696d1a549)((0, $c76cefd1e9dcfa92$export$e872fa6ab5911296));
(0, $c76cefd1e9dcfa92$export$e872fa6ab5911296)();
(0, $f581c978926dc309$export$e58147ec6a5cf5ac)();
(0, $06df0d63fec966a5$export$4567274423a54926)();
(0, $f626d2dd2b500820$export$f449253774381a1b)();
(0, $a74e0f3fd4d22cf2$export$14c80272ffa77045)();
(0, $6b07b67fb3f99fcb$export$94fbfcae3bd4ae7b)();
(0, $e59937a8264a8ca7$export$64fc608557bc1fbb)();
(0, $9zaOw.initFlyoutManager)();
(0, $4cf7bb8ecff54ff6$export$4134ea2413952409)();
(0, $ef5cb8ba9fd1d43d$export$a808e142f7ca3d76)();
(0, $acf010821545adc4$export$6b5a000cfb5fda7b)();
(0, $cff4b6e1957f2d0d$export$fa662d34acfc85fc)();
(0, $e9e6b93f409cb85b$export$9c309e2e513159f1)();
(0, $60da81f10253636a$export$eaa867ef12dc7fae)();
(0, $7eee2698ee4a8e94$export$62624d0d40a71436)();
(0, $e336711da62fd953$export$ea8d253c7a42b838)();
(0, $c63b6f00e4153771$export$7754fa6ee24dcde0)();
(0, $3da1742ac8b8dc2f$export$b83f411861f35e23)();
(0, $e9db92a032b783a9$export$74a56e8957377fa6)();
(0, $b140a5789469c122$export$2f53dd46c8386eb6)();
(0, $8a2968deefd15088$export$55fba04d7ae06ee3)();
(0, $5cc5e06d1bee6043$export$4cee5bd251fa27b)();
(0, $f00eefbc9fdbbeab$export$86460d36a13550a2)();
(0, $3ccabf6a7e25ddf1$export$98d1f400bca69d1b)();
(0, $5Q3m3.initSignin)();
(0, $081ba289f1c9a9d9$export$48cb63b51e451653)();
(0, $01ba5e37e51cd6c2$export$26de3d8b25ea080c)();
(0, $80acd778e4ef8923$export$55b4e627ff05ebe0)();
(0, $0e4623e8f9bbec40$export$49d9a96ac5239fc)();
(0, $db7fac7cfe2ac236$export$4c39ae523cffaaac)();
(0, $5ed318ea0afa6dda$export$1a37a0ba361730bc)();
(0, $d89054caf267f12e$export$3d535f4908aec6fc)();
(0, $cb7c0b3381c9608e$export$a658e50cde83fe78)();

})();
//# sourceMappingURL=main.js.map
